import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: { input: string; output: string; }
  /** A datetime string in ISO 8601 Zulu format, e.g. `2025-11-11T17:47:06Z`. */
  DateTime: { input: string; output: string; }
  /** Произвольное JSON-значение (объект, массив или скаляр). */
  JSON: { input: any; output: any; }
  /** Денежная сумма в минимальных единицах валюты. */
  Money: { input: number; output: number; }
  /** Represents a file upload. */
  Upload: { input: any; output: any; }
};

export enum AnalyticsBreakdownRowKind {
  Aggregated = 'Aggregated',
  Regular = 'Regular',
  Unattributed = 'Unattributed'
}

export type AnalyticsCancellations = {
  __typename?: 'AnalyticsCancellations';
  cancellation_percent: Scalars['Float']['output'];
  cancelled_count: Scalars['Int']['output'];
  no_show_count: Scalars['Int']['output'];
};

export enum AnalyticsComparisonMode {
  PreviousMonthToDate = 'PreviousMonthToDate',
  PreviousPeriod = 'PreviousPeriod',
  SamePeriodLastYear = 'SamePeriodLastYear'
}

export type AnalyticsComparisonWindow = {
  __typename?: 'AnalyticsComparisonWindow';
  current_date_from?: Maybe<Scalars['Date']['output']>;
  current_date_to?: Maybe<Scalars['Date']['output']>;
  equal_length: Scalars['Boolean']['output'];
  excluded_incomplete_day?: Maybe<Scalars['Date']['output']>;
  mode: AnalyticsComparisonMode;
  previous_date_from?: Maybe<Scalars['Date']['output']>;
  previous_date_to?: Maybe<Scalars['Date']['output']>;
};

export type AnalyticsKpis = {
  __typename?: 'AnalyticsKpis';
  available_unit_hours?: Maybe<Scalars['Float']['output']>;
  avg_check: Scalars['Money']['output'];
  new_clients_count: Scalars['Int']['output'];
  orders_count: Scalars['Int']['output'];
  revenue_total: Scalars['Money']['output'];
  utilization_percent?: Maybe<Scalars['Float']['output']>;
  visits_count: Scalars['Int']['output'];
};

export type AnalyticsNewClientSource = {
  __typename?: 'AnalyticsNewClientSource';
  clients_count: Scalars['Int']['output'];
  row_kind: AnalyticsBreakdownRowKind;
  source_id?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type AnalyticsOverview = {
  __typename?: 'AnalyticsOverview';
  cancellations: AnalyticsCancellations;
  comparison: AnalyticsComparisonWindow;
  kpis: AnalyticsKpis;
  kpis_comparable: AnalyticsKpis;
  kpis_previous: AnalyticsKpis;
  locations: Array<LocationAnalyticsRow>;
  new_client_sources: Array<AnalyticsNewClientSource>;
  revenue_series: Array<AnalyticsSeriesPoint>;
  revenue_series_previous: Array<AnalyticsSeriesPoint>;
  top_services: Array<AnalyticsTopService>;
  trend_granularity: AnalyticsTrendGranularity;
  utilization_series: Array<AnalyticsUtilizationPoint>;
  utilization_series_previous: Array<AnalyticsUtilizationPoint>;
};

export type AnalyticsPeriodInput = {
  comparison?: InputMaybe<AnalyticsComparisonMode>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};

export type AnalyticsSeriesPoint = {
  __typename?: 'AnalyticsSeriesPoint';
  date: Scalars['Date']['output'];
  is_partial: Scalars['Boolean']['output'];
  value: Scalars['Money']['output'];
};

export type AnalyticsTopService = {
  __typename?: 'AnalyticsTopService';
  /** Позиция каталога; null у импортированной истории и строки «Остальное». */
  catalog_item_id?: Maybe<Scalars['ID']['output']>;
  revenue_total: Scalars['Money']['output'];
  row_kind: AnalyticsBreakdownRowKind;
  title: Scalars['String']['output'];
};

export enum AnalyticsTrendGranularity {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week'
}

export enum AnalyticsUtilizationNormState {
  Above = 'Above',
  Below = 'Below',
  Normal = 'Normal',
  Unavailable = 'Unavailable'
}

export enum AnalyticsUtilizationNormUnavailableReason {
  ConfigurationChanged = 'ConfigurationChanged',
  InsufficientHistory = 'InsufficientHistory',
  InsufficientWeekdayData = 'InsufficientWeekdayData'
}

export type AnalyticsUtilizationPoint = {
  __typename?: 'AnalyticsUtilizationPoint';
  available_unit_hours: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  occupied_unit_hours: Scalars['Float']['output'];
  utilization_percent?: Maybe<Scalars['Float']['output']>;
};

export type AnnulInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
};

export type AnswerOrderFiscalReceiptPrintedInput = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  idCommand: Scalars['String']['input'];
  kktDeviceId: Scalars['String']['input'];
  operationId: Scalars['ID']['input'];
  payloadHash: Scalars['String']['input'];
  /** Ответ администратора на вопрос «Чек вышел?». */
  printed: Scalars['Boolean']['input'];
};

/**
 * Единый payload подтверждённого подключения кассы. `enabled` и `shiftsEnabled` здесь
 * не принимаются: подтверждённое подключение по определению вводит кассу в работу, а
 * инвариант «касса ⟹ смены» не должен зависеть от формы запроса.
 */
export type ApplyOrderFiscalizationConnectionInput = {
  browserWorkstationId: Scalars['ID']['input'];
  cashierLastName?: InputMaybe<Scalars['String']['input']>;
  cashierPosition: Scalars['String']['input'];
  confirmRebind?: Scalars['Boolean']['input'];
  expectedConfigVersion?: InputMaybe<Scalars['Int']['input']>;
  /** null сохраняет ожидаемый ИНН локации; без сохранённого ИНН подключение отклоняется. */
  expectedKktInn?: InputMaybe<Scalars['String']['input']>;
  kkmserverVersion: Scalars['String']['input'];
  kkt: OrderFiscalKktVerificationInput;
  locationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  paymentMethod?: OrderFiscalPaymentMethod;
  paymentSubject?: OrderFiscalPaymentSubject;
  provider?: OrderFiscalizationProvider;
  taxationSystem?: OrderFiscalTaxationSystem;
  terminal: OrderFiscalTerminalVerificationInput;
  vatRate?: OrderFiscalVatRate;
};

export type AuthContext = {
  __typename?: 'AuthContext';
  available_organizations: Array<Organization>;
  employee?: Maybe<Employee>;
  location?: Maybe<Location>;
  organization?: Maybe<Organization>;
  permissions: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
  web_push: WebPushCapability;
};

export type BankSuggestion = {
  __typename?: 'BankSuggestion';
  bik: Scalars['String']['output'];
  correspondent_account?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Сотрудник, указанный автором изменения группы броней. */
export type BookingActor = {
  __typename?: 'BookingActor';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** Действие, сохранённое в истории изменений группы броней. */
export enum BookingAuditAction {
  Cancelled = 'CANCELLED',
  ClientReplaced = 'CLIENT_REPLACED',
  Created = 'CREATED',
  StatusChanged = 'STATUS_CHANGED',
  Updated = 'UPDATED'
}

/** Причина отмены брони. Значения — App\Modules\Booking\Enums\CancellationReason. */
export enum BookingCancellationReason {
  ClientCancelled = 'CLIENT_CANCELLED',
  Erroneous = 'ERRONEOUS',
  NoShow = 'NO_SHOW',
  Technical = 'TECHNICAL'
}

/** Результат атомарного сохранения каталога; при конфликтах обе коллекции равны null. */
export type BookingCatalogMutationPayload = {
  __typename?: 'BookingCatalogMutationPayload';
  conflicts: Array<UnitUnavailabilityBookingConflict>;
  services?: Maybe<Array<BookingSettingsService>>;
  units?: Maybe<Array<BookingSettingsUnit>>;
};

/** Услуга каталога в локации; услуги, которых нет в списке, не меняются. */
export type BookingCatalogServiceInput = {
  catalogItemId: Scalars['ID']['input'];
  /** Доступна ли услуга в локации. */
  enabled: Scalars['Boolean']['input'];
  /** Цена локации у фиксированной цены; null — общая цена. */
  price?: InputMaybe<Scalars['Int']['input']>;
  tariffs: Array<BookingCatalogTariffInput>;
  /** Ресурсы, на которые ограничена услуга; пусто — все ресурсы локации. */
  unitKeys: Array<Scalars['String']['input']>;
};

/** Тариф услуги в локации: включён ли и по какой цене. */
export type BookingCatalogTariffInput = {
  enabled: Scalars['Boolean']['input'];
  /** Цена локации; null — общая цена тарифа. */
  price?: InputMaybe<Scalars['Int']['input']>;
  tariffId: Scalars['ID']['input'];
};

export type BookingCatalogUnitInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Контекст клиента для работы с записью. Метрики и история относятся ко всей организации. */
export type BookingClientProfile = {
  __typename?: 'BookingClientProfile';
  client: BookingClientProfileClient;
  hours_total: Scalars['Float']['output'];
  recent_bookings: Array<BookingClientRecentBooking>;
  visits_count: Scalars['Int']['output'];
};

/** Безопасная booking-проекция клиента. */
export type BookingClientProfileClient = {
  __typename?: 'BookingClientProfileClient';
  birthday?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importance?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_visit_at?: Maybe<Scalars['DateTime']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  marketing_source_id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patronymic_name?: Maybe<Scalars['String']['output']>;
  phone_masked?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<ClientSex>;
  type: ClientType;
};

/** Группа записи в истории клиента одной из локаций организации. */
export type BookingClientRecentBooking = {
  __typename?: 'BookingClientRecentBooking';
  discount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  location_id: Scalars['ID']['output'];
  location_title: Scalars['String']['output'];
  max_end?: Maybe<Scalars['DateTime']['output']>;
  min_start: Scalars['DateTime']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  slots: Array<BookingClientRecentSlot>;
  status: BookingStatus;
  subtotal_price?: Maybe<Scalars['Int']['output']>;
};

/** Один слот в истории записей клиента. */
export type BookingClientRecentSlot = {
  __typename?: 'BookingClientRecentSlot';
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  service_title?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  unit_title?: Maybe<Scalars['String']['output']>;
};

/** Тип актора, изменившего группу броней. */
export enum BookingCreatorType {
  Client = 'CLIENT',
  Employee = 'EMPLOYEE'
}

/** Одна запись истории изменений группы броней. */
export type BookingGroupAuditLog = {
  __typename?: 'BookingGroupAuditLog';
  action: BookingAuditAction;
  changed_by_employee?: Maybe<BookingActor>;
  changed_by_type: BookingCreatorType;
  changed_fields: Scalars['JSON']['output'];
  changed_via: BookingPlatform;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  new_data: Scalars['JSON']['output'];
  old_data?: Maybe<Scalars['JSON']['output']>;
};

/** A paginated list of BookingGroupAuditLog edges. */
export type BookingGroupAuditLogConnection = {
  __typename?: 'BookingGroupAuditLogConnection';
  /** A list of BookingGroupAuditLog edges. */
  edges: Array<BookingGroupAuditLogEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type BookingGroupAuditLog and a cursor. */
export type BookingGroupAuditLogEdge = {
  __typename?: 'BookingGroupAuditLogEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The BookingGroupAuditLog node. */
  node: BookingGroupAuditLog;
};

/** Финансовое состояние последней ревизии заказа, связанного с группой броней. */
export enum BookingPaymentStatus {
  Free = 'FREE',
  Paid = 'PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

/** Интерфейс, через который изменили группу броней. */
export enum BookingPlatform {
  AdminPanel = 'ADMIN_PANEL',
  BookingPortal = 'BOOKING_PORTAL'
}

/** Слот расписания ресурса. Визуальные start/end клипованы к рабочему интервалу; unavailability хранит исходный период. */
export type BookingScheduleSlot = {
  __typename?: 'BookingScheduleSlot';
  booking_details?: Maybe<BookingSlotDetails>;
  end: Scalars['DateTime']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  type: BookingScheduleSlotType;
  unavailability?: Maybe<UnitUnavailability>;
};

/** Тип слота расписания ресурса. */
export enum BookingScheduleSlotType {
  /** Свободный интервал. */
  AvailabilityBlock = 'AVAILABILITY_BLOCK',
  /** Занят бронью. */
  Booked = 'BOOKED',
  /** Недоступен (перерыв/закрытие). */
  Unavailability = 'UNAVAILABILITY'
}

/** Записываемая услуга каталога в текущей локации. */
export type BookingSettingsService = {
  __typename?: 'BookingSettingsService';
  /** Позиция каталога. */
  id: Scalars['ID']['output'];
  max_duration_minutes: Scalars['Int']['output'];
  min_duration_minutes: Scalars['Int']['output'];
  /** Цена брони в локации у фиксированной цены; null у других правил. */
  price?: Maybe<Scalars['Int']['output']>;
  price_rule: CatalogPriceRule;
  slot_step_minutes: Scalars['Int']['output'];
  tariffs: Array<BookingSettingsTariff>;
  title: Scalars['String']['output'];
  /** Ресурсы локации, на которые ограничена услуга; пустой список — все ресурсы локации. */
  unit_ids: Array<Scalars['ID']['output']>;
};

/** Тариф услуги, включённый в локации, с её ценой; в том числе выключенный для онлайн-записи. */
export type BookingSettingsTariff = {
  __typename?: 'BookingSettingsTariff';
  available_online: Scalars['Boolean']['output'];
  duration_minutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Цена в локации. */
  price: Scalars['Int']['output'];
};

/** Ресурс текущей точки с текущей либо ближайшей будущей недоступностью. */
export type BookingSettingsUnit = {
  __typename?: 'BookingSettingsUnit';
  active_unavailability?: Maybe<UnitUnavailability>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

/** Короткая идентификация клиента для часто обновляемого расписания. */
export type BookingSlotClientSummary = {
  __typename?: 'BookingSlotClientSummary';
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importance?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  patronymic_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Детали занятого слота (type = BOOKED). Паритет booking_details в UnitScheduleResource. */
export type BookingSlotDetails = {
  __typename?: 'BookingSlotDetails';
  booking_id: Scalars['ID']['output'];
  catalog_item_id?: Maybe<Scalars['ID']['output']>;
  catalog_tariff_id?: Maybe<Scalars['ID']['output']>;
  client_summary?: Maybe<BookingSlotClientSummary>;
  discount: Scalars['Int']['output'];
  group_id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  /** Почему запись нельзя оплатить её собственным заказом; null — оплачивается напрямую. */
  payment_delegation?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<BookingPaymentStatus>;
  price?: Maybe<Scalars['Int']['output']>;
  service_title?: Maybe<Scalars['String']['output']>;
  status: BookingStatus;
  subtotal_price?: Maybe<Scalars['Int']['output']>;
  tariff_duration?: Maybe<Scalars['Int']['output']>;
  /** Цена брони (quoted_price). */
  tariff_price?: Maybe<Scalars['Int']['output']>;
  unit_id: Scalars['ID']['output'];
};

/** Слот новой/обновляемой брони. Паритет SlotDTO + slots.* в BookingStoreRequest. */
export type BookingSlotInput = {
  /** Услуга каталога; без неё бронь получает цену 0. */
  catalogItemId?: InputMaybe<Scalars['ID']['input']>;
  /** Тариф услуги; без него цену даёт правило услуги. */
  catalogTariffId?: InputMaybe<Scalars['ID']['input']>;
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
  unitId: Scalars['ID']['input'];
};

/** Статус группы броней. Значения — App\Modules\Booking\Enums\BookingGroupStatus. */
export enum BookingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

/** Результат изменения ресурса; при конфликте unit = null и запись не меняется. */
export type BookingUnitMutationPayload = {
  __typename?: 'BookingUnitMutationPayload';
  conflicts: Array<UnitUnavailabilityBookingConflict>;
  unit?: Maybe<BookingSettingsUnit>;
};

export type BroadcastAudienceChannelCount = {
  __typename?: 'BroadcastAudienceChannelCount';
  channel_label: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type BroadcastAudienceDefinition = {
  __typename?: 'BroadcastAudienceDefinition';
  additions: Array<BroadcastAudienceRule>;
  exclusions: Array<BroadcastAudienceRule>;
};

export type BroadcastAudienceDefinitionInput = {
  additions: Array<BroadcastAudienceRuleInput>;
  exclusions: Array<BroadcastAudienceRuleInput>;
};

export enum BroadcastAudienceEntryDecision {
  Excluded = 'EXCLUDED',
  NoChannel = 'NO_CHANNEL',
  Ready = 'READY'
}

export type BroadcastAudienceReason = {
  __typename?: 'BroadcastAudienceReason';
  broadcast_id?: Maybe<Scalars['ID']['output']>;
  broadcast_name?: Maybe<Scalars['String']['output']>;
  from_at?: Maybe<Scalars['DateTime']['output']>;
  kind: BroadcastAudienceRuleKind;
  last_booking_at?: Maybe<Scalars['DateTime']['output']>;
  months?: Maybe<Scalars['Int']['output']>;
  rule_id: Scalars['ID']['output'];
  to_at?: Maybe<Scalars['DateTime']['output']>;
};

export type BroadcastAudienceRule = {
  __typename?: 'BroadcastAudienceRule';
  broadcast_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  kind: BroadcastAudienceRuleKind;
  months?: Maybe<Scalars['Int']['output']>;
};

export type BroadcastAudienceRuleInput = {
  broadcast_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  kind: BroadcastAudienceRuleKind;
  months?: InputMaybe<Scalars['Int']['input']>;
};

export enum BroadcastAudienceRuleKind {
  AllClients = 'ALL_CLIENTS',
  NoBookings = 'NO_BOOKINGS',
  PreviousBroadcast = 'PREVIOUS_BROADCAST',
  UnlinkedConversations = 'UNLINKED_CONVERSATIONS'
}

export enum BroadcastAudienceSnapshotStatus {
  Building = 'BUILDING',
  Failed = 'FAILED',
  Ready = 'READY'
}

export enum BroadcastAudienceUnavailableReason {
  AddressMissing = 'ADDRESS_MISSING',
  ChannelUnavailable = 'CHANNEL_UNAVAILABLE',
  ConversationInactive = 'CONVERSATION_INACTIVE',
  NoConversation = 'NO_CONVERSATION'
}

export type BroadcastAudienceWindow = {
  __typename?: 'BroadcastAudienceWindow';
  from_at: Scalars['DateTime']['output'];
  months: Scalars['Int']['output'];
  rule_id: Scalars['ID']['output'];
  to_at: Scalars['DateTime']['output'];
};

export type BusinessCountryOption = {
  __typename?: 'BusinessCountryOption';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Каркас содержит только публичные сведения; приватные поля защищены отдельно. */
export type BusinessLocation = {
  __typename?: 'BusinessLocation';
  address?: Maybe<Scalars['String']['output']>;
  alias: Scalars['String']['output'];
  business_status: BusinessLocationStatus;
  city?: Maybe<Scalars['String']['output']>;
  closed_from?: Maybe<Scalars['Date']['output']>;
  color: LocationColor;
  details?: Maybe<BusinessLocationDetails>;
  full_address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location_address?: Maybe<BusinessLocationAddress>;
  opened_from?: Maybe<Scalars['Date']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  short_name: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BusinessLocationAddress = {
  __typename?: 'BusinessLocationAddress';
  address?: Maybe<Scalars['String']['output']>;
  address_line?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  full_address?: Maybe<Scalars['String']['output']>;
  house?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of BusinessLocation edges. */
export type BusinessLocationConnection = {
  __typename?: 'BusinessLocationConnection';
  /** A list of BusinessLocation edges. */
  edges: Array<BusinessLocationEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

export type BusinessLocationDetails = {
  __typename?: 'BusinessLocationDetails';
  alias: Scalars['String']['output'];
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_bik?: Maybe<Scalars['String']['output']>;
  bank_correspondent_account?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  color: LocationColor;
  email?: Maybe<Scalars['String']['output']>;
  legal_address?: Maybe<Scalars['String']['output']>;
  legal_director_name?: Maybe<Scalars['String']['output']>;
  legal_form?: Maybe<LegalForm>;
  legal_kpp?: Maybe<Scalars['String']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  legal_ogrn?: Maybe<Scalars['String']['output']>;
  legal_tin?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  short_name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** An edge that contains a node of type BusinessLocation and a cursor. */
export type BusinessLocationEdge = {
  __typename?: 'BusinessLocationEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The BusinessLocation node. */
  node: BusinessLocation;
};

export enum BusinessLocationStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Hidden = 'HIDDEN',
  Planned = 'PLANNED'
}

export type BusinessSettings = {
  __typename?: 'BusinessSettings';
  country_code?: Maybe<Scalars['String']['output']>;
  currency: OrganizationCurrency;
  facebook_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instagram_url?: Maybe<Scalars['String']['output']>;
  /** Как называть ресурсы записи на экране. */
  resource_term: ResourceTerm;
  sphere_id?: Maybe<OrganizationSphere>;
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  vk_url?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

export type BusinessSettingsCatalog = {
  __typename?: 'BusinessSettingsCatalog';
  countries: Array<BusinessCountryOption>;
  timezones: Array<BusinessTimezoneOption>;
};

export type BusinessTimezoneOption = {
  __typename?: 'BusinessTimezoneOption';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CancelOrderFiscalPaymentInput = {
  /** Реквизиты отмены на терминале, если он их вернул. */
  bank?: InputMaybe<OrderFiscalBankResultInput>;
  /** PAYMENT_REVERSED, CANCELLED_NOT_CHARGED или CANCELLED_UNVERIFIED. */
  failureKind: OrderFiscalFailureKind;
  operationId: Scalars['ID']['input'];
};

export type CatalogBookingInput = {
  availableOnline: Scalars['Boolean']['input'];
  maxDurationMinutes: Scalars['Int']['input'];
  minDurationMinutes: Scalars['Int']['input'];
  slotStepMinutes: Scalars['Int']['input'];
};

/** Категория каталога одного уровня. */
export type CatalogCategory = {
  __typename?: 'CatalogCategory';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** Позиция каталога организации: услуга или товар. Цены — в копейках. */
export type CatalogItem = {
  __typename?: 'CatalogItem';
  /** Правила цены, которые можно выбрать услуге; системная услуга модуля ограничивает список. */
  allowed_price_rules: Array<CatalogPriceRule>;
  /** Можно ли убрать услугу в архив. */
  archive_allowed: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  /** Можно ли включить запись на услугу. */
  booking_allowed: Scalars['Boolean']['output'];
  booking_available_online: Scalars['Boolean']['output'];
  booking_max_duration_minutes?: Maybe<Scalars['Int']['output']>;
  /** Настройки записи; null — услуга не записываемая. */
  booking_min_duration_minutes?: Maybe<Scalars['Int']['output']>;
  booking_slot_step_minutes?: Maybe<Scalars['Int']['output']>;
  category_id?: Maybe<Scalars['ID']['output']>;
  fixed_price?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kind: CatalogItemKind;
  locations: Array<CatalogItemLocation>;
  position: Scalars['Int']['output'];
  /** Минимальная цена для подписи «от N ₽»: в локации запроса или общая; null — цену вводит кассир. */
  price_from?: Maybe<Scalars['Int']['output']>;
  price_rule: CatalogPriceRule;
  range_max?: Maybe<Scalars['Int']['output']>;
  range_min?: Maybe<Scalars['Int']['output']>;
  tariffs: Array<CatalogTariff>;
  /** Вид услуги шиномонтажа: STORAGE_INTAKE — системная услуга хранения, остальные — REGULAR. */
  tire_kind: TireServiceItemKind;
  /** Матрица цены по классу машины, диаметру колёс и RunFlat и свои цены локаций, включая скрытые параметрами клетки. */
  tire_prices: Array<TireServicePrice>;
  title: Scalars['String']['output'];
};


/** Позиция каталога организации: услуга или товар. Цены — в копейках. */
export type CatalogItemTire_PricesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CatalogItemKind {
  Product = 'PRODUCT',
  Service = 'SERVICE'
}

/** Локация, где доступна позиция; price переопределяет фиксированную цену. */
export type CatalogItemLocation = {
  __typename?: 'CatalogItemLocation';
  location_id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Int']['output']>;
};

/** Результат изменения позиции; при конфликте с будущими бронями item = null. */
export type CatalogItemMutationPayload = {
  __typename?: 'CatalogItemMutationPayload';
  conflicts: Array<UnitUnavailabilityBookingConflict>;
  item?: Maybe<CatalogItem>;
};

/** Своя цена в локации; локации без строки получают общую цену. */
export type CatalogLocationPriceInput = {
  locationId: Scalars['ID']['input'];
  price: Scalars['Int']['input'];
};

/** Правило цены: фиксированная, свободная, из диапазона, по тарифам или по параметрам дополнения. */
export enum CatalogPriceRule {
  Fixed = 'FIXED',
  Free = 'FREE',
  Parameters = 'PARAMETERS',
  Range = 'RANGE',
  Tariffs = 'TARIFFS'
}

/** Группа раздела «Услуги»: категория и её услуги по порядку. */
export type CatalogServiceGroupInput = {
  /** Категория группы; null — услуги без категории. */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  itemIds: Array<Scalars['ID']['input']>;
};

export type CatalogServiceInput = {
  /** Настройки записи; null — услуга не записываемая. */
  booking?: InputMaybe<CatalogBookingInput>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  fixedPrice?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Локации, где доступна услуга. */
  locationIds: Array<Scalars['ID']['input']>;
  /** Свои фиксированные цены в локациях услуги; у других правил — пусто, null — не менять. */
  locationPrices?: InputMaybe<Array<CatalogLocationPriceInput>>;
  priceRule: CatalogPriceRule;
  rangeMax?: InputMaybe<Scalars['Int']['input']>;
  rangeMin?: InputMaybe<Scalars['Int']['input']>;
  tariffs?: InputMaybe<Array<CatalogTariffInput>>;
  /** Матрица цены шиномонтажа; только с подключённым дополнением. Для цены «По машине» обязательна. */
  tireService?: InputMaybe<TireServiceSettingsInput>;
  title: Scalars['String']['input'];
};

/** Тариф: длительность записи с ценой. Цены — в копейках. */
export type CatalogTariff = {
  __typename?: 'CatalogTariff';
  available_online: Scalars['Boolean']['output'];
  duration_minutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  locations: Array<CatalogTariffLocation>;
  price: Scalars['Int']['output'];
};

export type CatalogTariffInput = {
  availableOnline: Scalars['Boolean']['input'];
  durationMinutes: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Локации, где длительность продаётся. null — новая во всех локациях услуги, сохранённая как была. */
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Свои цены тарифа в локациях, где он включён; null — не менять. */
  locationPrices?: InputMaybe<Array<CatalogLocationPriceInput>>;
  price: Scalars['Int']['input'];
};

/** Локация, где включён тариф; price переопределяет цену тарифа. */
export type CatalogTariffLocation = {
  __typename?: 'CatalogTariffLocation';
  location_id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Int']['output']>;
};

export type ChangeBusinessLocationTimezonePayload = {
  __typename?: 'ChangeBusinessLocationTimezonePayload';
  conflicts: Array<UnitUnavailabilityBookingConflict>;
  saved: Scalars['Boolean']['output'];
  timezone: Scalars['String']['output'];
};

/** Маскированные credentials канала (провайдер-специфичные ключи, секреты скрыты). */
export type ChannelCredentials = {
  __typename?: 'ChannelCredentials';
  access_token?: Maybe<Scalars['String']['output']>;
  confirmation?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['String']['output']>;
  screen_name?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ChannelHealthCheck = {
  __typename?: 'ChannelHealthCheck';
  checked_at?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ChannelHealthStatus = {
  __typename?: 'ChannelHealthStatus';
  api: ChannelHealthCheck;
  status?: Maybe<Scalars['String']['output']>;
  webhook: ChannelHealthCheck;
};

export type ChatMetadata = {
  __typename?: 'ChatMetadata';
  avatar_url?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type City = {
  __typename?: 'City';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Client = {
  __typename?: 'Client';
  active_scenario_runs: Array<ScenarioRun>;
  avg_check?: Maybe<Scalars['Int']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  contact_person?: Maybe<Scalars['String']['output']>;
  /** Цифры канонического номера контакта компании, например 79215551234. */
  contact_phone?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  first_visit_location?: Maybe<Location>;
  hours_total?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  importance?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_visit_at?: Maybe<Scalars['DateTime']['output']>;
  last_visit_location?: Maybe<Location>;
  legal_address?: Maybe<Scalars['String']['output']>;
  legal_form?: Maybe<LegalForm>;
  legal_kpp?: Maybe<Scalars['String']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  legal_tin?: Maybe<Scalars['String']['output']>;
  ltv?: Maybe<Scalars['Int']['output']>;
  marketing_source?: Maybe<MarketingSource>;
  note?: Maybe<Scalars['String']['output']>;
  patronymic_name?: Maybe<Scalars['String']['output']>;
  phone_masked?: Maybe<Scalars['String']['output']>;
  /** Сегменты клиента с включённым бейджем: стандартные выше настраиваемых. */
  segment_badges: Array<ClientSegment>;
  sex?: Maybe<ClientSex>;
  statistics_by_location: Array<ClientLocationStatistic>;
  /** Человек или компания. У компании наименование вместо ФИО и нет личного телефона. */
  type: ClientType;
  visits_count?: Maybe<Scalars['Int']['output']>;
};

export enum ClientActivityType {
  Order = 'ORDER',
  Visit = 'VISIT'
}

export type ClientAutomation = {
  __typename?: 'ClientAutomation';
  active_providers: Array<MessengerProvider>;
  /** Через сколько дней сгорают баллы маркетинговой карточки; null — не задано или у вида нет срока. */
  bonus_expiry_days?: Maybe<Scalars['Int']['output']>;
  /** Сумма бонуса: у бонуса за регистрацию — сумма по умолчанию, у маркетинговых видов — баллы за повод (0 — бонус выключен); null — у вида нет бонуса. */
  bonus_points?: Maybe<Scalars['Int']['output']>;
  /** Подпись inline-кнопки, которую отправитель добавляет к сообщению; null — кнопки нет. */
  button_label?: Maybe<Scalars['String']['output']>;
  channel_policy: ClientAutomationChannelPolicy;
  default_template: Scalars['String']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Неизменяемая строка после текста; null — нет. */
  footer?: Maybe<Scalars['String']['output']>;
  /** id созданной карточки; null — встроенная карточка вида. */
  id?: Maybe<Scalars['ID']['output']>;
  is_modified: Scalars['Boolean']['output'];
  kind: ClientAutomationKind;
  /** Название вида без срока. */
  kind_title: Scalars['String']['output'];
  last_30_days: ClientAutomationCounters;
  /** Код публичной ссылки запуска: лендинг `/s/<code>`; null — у вида нет ссылки. */
  link_code?: Maybe<Scalars['String']['output']>;
  quiet_hours_mode: ClientAutomationQuietHoursMode;
  /** Карточку нельзя выключить. */
  required: Scalars['Boolean']['output'];
  section: ClientAutomationSection;
  template: Scalars['String']['output'];
  /** Заголовок карточки: у напоминаний с триггером — фраза триггера, у маркетинговых — вид · срок. */
  title: Scalars['String']['output'];
  /** Доступные значения триггера; значения других карточек группы исключены. Пустой список — триггер не настраивается. */
  trigger_options: Array<ClientAutomationTriggerOption>;
  /** Значение параметра триггера; null — триггер вида не настраивается. */
  trigger_value?: Maybe<Scalars['Int']['output']>;
  variables: Array<Scalars['String']['output']>;
};

/** Куда отправлять сообщение, если у клиента несколько подключённых каналов. */
export enum ClientAutomationChannelPolicy {
  All = 'ALL',
  FirstAvailable = 'FIRST_AVAILABLE',
  LastActive = 'LAST_ACTIVE'
}

export type ClientAutomationChannelStatistics = {
  __typename?: 'ClientAutomationChannelStatistics';
  delivered: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  provider: MessengerProvider;
  sent: Scalars['Int']['output'];
};

export type ClientAutomationCounters = {
  __typename?: 'ClientAutomationCounters';
  delivered: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type ClientAutomationInput = {
  /** Через сколько дней сгорают баллы маркетинговой карточки; null — оставить текущее значение. */
  bonusExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Сумма бонуса: за регистрацию или баллы маркетинговой карточки (0 — бонус выключен); null — оставить текущее значение. */
  bonusPoints?: InputMaybe<Scalars['Int']['input']>;
  channelPolicy: ClientAutomationChannelPolicy;
  enabled: Scalars['Boolean']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
  /** Значение из trigger_options; null — оставить текущее. */
  triggerValue?: InputMaybe<Scalars['Int']['input']>;
};

/** Вид клиентской автоматизации. */
export enum ClientAutomationKind {
  Birthday = 'BIRTHDAY',
  BonusBalance = 'BONUS_BALANCE',
  BookingCancelled = 'BOOKING_CANCELLED',
  BookingChanged = 'BOOKING_CHANGED',
  BookingCreated = 'BOOKING_CREATED',
  BookingNoShow = 'BOOKING_NO_SHOW',
  BotGreeting = 'BOT_GREETING',
  LoyaltyAccrual = 'LOYALTY_ACCRUAL',
  LoyaltyExpiryReminder = 'LOYALTY_EXPIRY_REMINDER',
  LoyaltyRedemption = 'LOYALTY_REDEMPTION',
  LoyaltyTierUpgrade = 'LOYALTY_TIER_UPGRADE',
  LoyaltyWelcomeBonus = 'LOYALTY_WELCOME_BONUS',
  RebookReminder = 'REBOOK_REMINDER',
  RegistrationCompleted = 'REGISTRATION_COMPLETED',
  RegistrationExisting = 'REGISTRATION_EXISTING',
  RegistrationPhoneRequest = 'REGISTRATION_PHONE_REQUEST',
  RegistrationProfile = 'REGISTRATION_PROFILE',
  Reminder_1H = 'REMINDER_1H',
  Reminder_24H = 'REMINDER_24H',
  ReminderDayOf = 'REMINDER_DAY_OF',
  VisitCompleted = 'VISIT_COMPLETED',
  Welcome = 'WELCOME',
  WinBack = 'WIN_BACK'
}

/** Как вид автоматизации относится к тихим часам организации. */
export enum ClientAutomationQuietHoursMode {
  /** Момент в тихий период откладывается до ближайшего конца тихих часов. */
  Deferred = 'DEFERRED',
  /** Отправляется в свой момент в любое время. */
  Ignored = 'IGNORED',
  /** Отправляется в конец тихих часов в дату визита или повода. */
  QuietHoursEnd = 'QUIET_HOURS_END',
  /** Момент в тихий период переносится к границе того же дня: вечер — к началу тихих часов, раннее утро — к концу. */
  SameDay = 'SAME_DAY'
}

/** Значения переменных записи для предпросмотра — те же, что у тестовой отправки. */
export type ClientAutomationSample = {
  __typename?: 'ClientAutomationSample';
  address: Scalars['String']['output'];
  booking_link: Scalars['String']['output'];
  date: Scalars['String']['output'];
  location: Scalars['String']['output'];
  services: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

/** Секция страницы «Автоматизация». */
export enum ClientAutomationSection {
  Bookings = 'BOOKINGS',
  Bot = 'BOT',
  Loyalty = 'LOYALTY',
  Marketing = 'MARKETING',
  Reminders = 'REMINDERS'
}

export type ClientAutomationSeries = {
  __typename?: 'ClientAutomationSeries';
  provider: MessengerProvider;
  values: Array<Scalars['Int']['output']>;
};

export type ClientAutomationStatistics = {
  __typename?: 'ClientAutomationStatistics';
  by_channel: Array<ClientAutomationChannelStatistics>;
  dates: Array<Scalars['Date']['output']>;
  series: Array<ClientAutomationSeries>;
  totals: ClientAutomationCounters;
};

/** Вариант параметра триггера вида автоматизации. */
export type ClientAutomationTriggerOption = {
  __typename?: 'ClientAutomationTriggerOption';
  /** Фраза триггера с этим значением. */
  description: Scalars['String']['output'];
  /** Режим тихих часов вида при этом значении. */
  quiet_hours_mode: ClientAutomationQuietHoursMode;
  /** Значение: минуты до начала визита у напоминаний, дни у маркетинговых видов. */
  value: Scalars['Int']['output'];
};

/** A paginated list of Client edges. */
export type ClientConnection = {
  __typename?: 'ClientConnection';
  /** A list of Client edges. */
  edges: Array<ClientEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type Client and a cursor. */
export type ClientEdge = {
  __typename?: 'ClientEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Client node. */
  node: Client;
};

/** Разбивка статистики клиента по одной локации (паритет REST by_location). */
export type ClientLocationStatistic = {
  __typename?: 'ClientLocationStatistic';
  first_visit_at?: Maybe<Scalars['DateTime']['output']>;
  hours_total: Scalars['Float']['output'];
  last_visit_at?: Maybe<Scalars['DateTime']['output']>;
  location_id: Scalars['ID']['output'];
  location_name: Scalars['String']['output'];
  visits_count: Scalars['Int']['output'];
};

export enum ClientOrderByField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  LastVisitAt = 'LAST_VISIT_AT',
  Phone = 'PHONE',
  VisitsCount = 'VISITS_COUNT'
}

/** Тихие часы клиентских сообщений организации: местное время HH:MM, сообщение может прийти ровно на границе. */
export type ClientQuietHours = {
  __typename?: 'ClientQuietHours';
  /** false — окно ничего не откладывает; «в день визита» и маркетинговые виды по-прежнему приходят в `end`. */
  enabled: Scalars['Boolean']['output'];
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type ClientQuietHoursInput = {
  enabled: Scalars['Boolean']['input'];
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

/** Сегмент клиентов: правила соединяются по AND, активность — уникальные локальные дни с визитом или покупкой. */
export type ClientSegment = {
  __typename?: 'ClientSegment';
  badge_color?: Maybe<Scalars['String']['output']>;
  badge_enabled: Scalars['Boolean']['output'];
  /** Клиентов в сегменте по последнему пересчёту членства. */
  clients_count: Scalars['Int']['output'];
  code?: Maybe<ClientSegmentStandardCode>;
  created_at: Scalars['DateTime']['output'];
  /** Описание правил по-русски. */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Стандартный сегмент отличается от значений по умолчанию. */
  is_modified: Scalars['Boolean']['output'];
  kind: ClientSegmentKind;
  members_computed_at?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  rules: Array<ClientSegmentRule>;
  updated_at: Scalars['DateTime']['output'];
};

export enum ClientSegmentConditionField {
  ActivityType = 'ACTIVITY_TYPE',
  BookingChannel = 'BOOKING_CHANNEL',
  Location = 'LOCATION'
}

export enum ClientSegmentConditionOperator {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export type ClientSegmentInput = {
  badgeColor?: InputMaybe<Scalars['String']['input']>;
  badgeEnabled: Scalars['Boolean']['input'];
  /** Игнорируется у стандартного сегмента. */
  name?: InputMaybe<Scalars['String']['input']>;
  rules: Array<ClientSegmentRuleInput>;
};

export enum ClientSegmentKind {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

export type ClientSegmentPreview = {
  __typename?: 'ClientSegmentPreview';
  clients_count: Scalars['Int']['output'];
};

export type ClientSegmentRule = {
  __typename?: 'ClientSegmentRule';
  conditions: Array<ClientSegmentRuleCondition>;
  predicate: ClientSegmentRulePredicate;
  subject: ClientSegmentRuleSubject;
  /** Число дней активности, сумма в минорных единицах валюты или число дней. */
  value?: Maybe<Scalars['Int']['output']>;
  /** Id источников клиента для условия «один из». */
  values: Array<Scalars['ID']['output']>;
  window?: Maybe<ClientSegmentRuleWindow>;
};

/** Условие правила: значения лежат в списке поля `field`, остальные списки пусты. */
export type ClientSegmentRuleCondition = {
  __typename?: 'ClientSegmentRuleCondition';
  activity_types: Array<ClientActivityType>;
  booking_channels: Array<BookingPlatform>;
  field: ClientSegmentConditionField;
  location_ids: Array<Scalars['ID']['output']>;
  operator: ClientSegmentConditionOperator;
};

/** Задаётся список поля `field`, остальные списки пусты или не передаются. */
export type ClientSegmentRuleConditionInput = {
  activity_types?: InputMaybe<Array<ClientActivityType>>;
  booking_channels?: InputMaybe<Array<BookingPlatform>>;
  field: ClientSegmentConditionField;
  location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  operator: ClientSegmentConditionOperator;
};

export type ClientSegmentRuleInput = {
  conditions?: InputMaybe<Array<ClientSegmentRuleConditionInput>>;
  predicate: ClientSegmentRulePredicate;
  subject: ClientSegmentRuleSubject;
  value?: InputMaybe<Scalars['Int']['input']>;
  values?: InputMaybe<Array<Scalars['ID']['input']>>;
  window?: InputMaybe<ClientSegmentRuleWindowInput>;
};

export enum ClientSegmentRulePredicate {
  AmountMoreThan = 'AMOUNT_MORE_THAN',
  Any = 'ANY',
  CountAtLeast = 'COUNT_AT_LEAST',
  In = 'IN',
  None = 'NONE',
  WithinLastDays = 'WITHIN_LAST_DAYS',
  WithinNextDays = 'WITHIN_NEXT_DAYS'
}

export enum ClientSegmentRuleSubject {
  Activity = 'ACTIVITY',
  Birthday = 'BIRTHDAY',
  ClientAdded = 'CLIENT_ADDED',
  MarketingSource = 'MARKETING_SOURCE',
  OrdersAmount = 'ORDERS_AMOUNT',
  UpcomingBookings = 'UPCOMING_BOOKINGS'
}

/** Окно правила «за последние N дней/месяцев», включая сегодняшний день. */
export type ClientSegmentRuleWindow = {
  __typename?: 'ClientSegmentRuleWindow';
  amount: Scalars['Int']['output'];
  unit: ClientSegmentWindowUnit;
};

export type ClientSegmentRuleWindowInput = {
  amount: Scalars['Int']['input'];
  unit: ClientSegmentWindowUnit;
};

export enum ClientSegmentStandardCode {
  FirstVisit = 'FIRST_VISIT',
  HighSpenders = 'HIGH_SPENDERS',
  InactiveClients = 'INACTIVE_CLIENTS',
  LostClients = 'LOST_CLIENTS',
  LoyalClients = 'LOYAL_CLIENTS',
  NewClients = 'NEW_CLIENTS',
  RecentClients = 'RECENT_CLIENTS',
  UpcomingBirthday = 'UPCOMING_BIRTHDAY'
}

export enum ClientSegmentWindowUnit {
  Days = 'DAYS',
  Months = 'MONTHS'
}

export enum ClientSex {
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum ClientType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

export type CloseLocationInput = {
  /** Локальная дата локации в формате ГГГГ-ММ-ДД, не раньше opened_from. */
  closedFrom: Scalars['Date']['input'];
};

export type CloseShiftInput = {
  closingCash: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  /**
   * ККТ сообщила `SessionState=1`: Z-отчёт уже напечатан, повторная device-команда
   * не нужна. Закрытие получает отличимое audit evidence.
   */
  kktAlreadyClosed?: Scalars['Boolean']['input'];
  revenueKkt?: InputMaybe<Scalars['Float']['input']>;
  shiftId: Scalars['ID']['input'];
};

export type CompleteOrderFiscalPaymentReturnInput = {
  /** Реквизиты возврата на терминале, если он их вернул. */
  bank?: InputMaybe<OrderFiscalBankResultInput>;
  operationId: Scalars['ID']['input'];
  outcome: OrderFiscalPaymentReturnOutcome;
  /** false — терминал не дал понятного ответа: возврат считается выполненным. */
  verified?: Scalars['Boolean']['input'];
};

export type CompleteOrderFiscalRefundInput = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  idCommand: Scalars['String']['input'];
  kktDeviceId?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  payloadHash: Scalars['String']['input'];
  result: OrderFiscalRefundResultInput;
};

export type CompleteOrderFiscalSettlementInput = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  idCommand: Scalars['String']['input'];
  kktDeviceId?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  payloadHash: Scalars['String']['input'];
  result: OrderFiscalSettlementResultInput;
};

export type CompleteOrderRefundTransferInput = {
  approvalId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  /** Номер платёжного поручения. */
  reference: Scalars['String']['input'];
};

export type ConfirmInvoiceReceiptInput = {
  amount: Scalars['Money']['input'];
  idempotencyKey: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
  paymentOrderNumber: Scalars['String']['input'];
  receivedOn: Scalars['Date']['input'];
};

export type ConfirmShiftKktInput = {
  fnSerial: Scalars['String']['input'];
  kktShiftNumber?: InputMaybe<Scalars['Int']['input']>;
  shiftId: Scalars['ID']['input'];
};

/** Создание группы броней. Паритет BookingStoreRequest + BookingStoreController. */
export type CreateBookingInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  slots: Array<BookingSlotInput>;
  status: BookingStatus;
};

export type CreateBookingUnitInput = {
  title: Scalars['String']['input'];
};

export type CreateBusinessLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  alias: Scalars['String']['input'];
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_bik?: InputMaybe<Scalars['String']['input']>;
  bank_correspondent_account?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** Пусто — первый свободный цвет палитры. */
  color?: InputMaybe<LocationColor>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  days: Array<LocationScheduleDayInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  full_address?: InputMaybe<Scalars['String']['input']>;
  house?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  legal_address?: InputMaybe<Scalars['String']['input']>;
  legal_director_name?: InputMaybe<Scalars['String']['input']>;
  legal_form?: InputMaybe<LegalForm>;
  legal_kpp?: InputMaybe<Scalars['String']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  legal_ogrn?: InputMaybe<Scalars['String']['input']>;
  legal_tin?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Scalars['String']['input']>;
  /** Пусто — код подберётся по названию. */
  short_name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateClientFromConversationInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type CreateClientFromConversationPayload = {
  __typename?: 'CreateClientFromConversationPayload';
  conversation: MessengerConversation;
  existing: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/**
 * Паритет ClientStoreRequest. Обязательность и уникальность телефона человека, реквизиты
 * компании и остальные правила проверяются в резолвере (см. D7 плана).
 */
export type CreateClientInput = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalForm?: InputMaybe<LegalForm>;
  legalKpp?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalTin?: InputMaybe<Scalars['String']['input']>;
  marketingSourceId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patronymicName?: InputMaybe<Scalars['String']['input']>;
  /** Обязателен для человека, у компании отсутствует. */
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<ClientSex>;
  type?: InputMaybe<ClientType>;
};

export type CreateEmployeeInput = {
  first_name: Scalars['String']['input'];
  has_all_locations_access: Scalars['Boolean']['input'];
  last_name: Scalars['String']['input'];
  location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  phone: Scalars['String']['input'];
  role_ids: Array<Scalars['ID']['input']>;
};

export type CreateMarketingSourceInput = {
  isManualSelectable?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateMessengerChannelInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  confirmation?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['Int']['input']>;
  provider: Scalars['String']['input'];
  screen_name?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQrLinkInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  styleConfig?: InputMaybe<Scalars['String']['input']>;
  targetUrl: Scalars['String']['input'];
};

export type CreateRadioPlaylistInput = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateScenarioInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  availableProviders?: InputMaybe<Array<Scalars['String']['input']>>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  flowDefinition: Array<ScenarioStepInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  marketingSourceId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** Бонус за регистрацию по ссылке: null — сумма из автоматизации, 0 — без бонуса. */
  registrationBonusPoints?: InputMaybe<Scalars['Int']['input']>;
  restartOnReactivation?: InputMaybe<Scalars['Boolean']['input']>;
  stopIfBooked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSopInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  sectionId: Scalars['ID']['input'];
  status?: InputMaybe<SopStatus>;
  title: Scalars['String']['input'];
};

export type CreateSopSectionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Новый полуоткрытый UTC-интервал временной недоступности. */
export type CreateUnitUnavailabilityInput = {
  end: Scalars['DateTime']['input'];
  reason: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  unitId: Scalars['ID']['input'];
};

export type Employee = {
  __typename?: 'Employee';
  created_at: Scalars['DateTime']['output'];
  employee_id: Scalars['ID']['output'];
  fired_at?: Maybe<Scalars['DateTime']['output']>;
  fired_reason?: Maybe<Scalars['String']['output']>;
  firing_reason?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  has_all_locations_access: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_owner: Scalars['Boolean']['output'];
  last_activity_at?: Maybe<Scalars['DateTime']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location_ids: Array<Scalars['ID']['output']>;
  locations: Array<Location>;
  patronymic_name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
  status: EmployeeStatus;
  title?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** A paginated list of Employee edges. */
export type EmployeeConnection = {
  __typename?: 'EmployeeConnection';
  /** A list of Employee edges. */
  edges: Array<EmployeeEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type Employee and a cursor. */
export type EmployeeEdge = {
  __typename?: 'EmployeeEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Employee node. */
  node: Employee;
};

export enum EmployeeStatus {
  Fired = 'FIRED',
  Working = 'WORKING'
}

export type FailOrderFiscalRefundInput = {
  bankPaymentStatus?: InputMaybe<OrderFiscalBankPaymentStatus>;
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  commandStatus: OrderFiscalKkmCommandStatus;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  failureKind: OrderFiscalFailureKind;
  idCommand: Scalars['String']['input'];
  kktDeviceId?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  payloadHash: Scalars['String']['input'];
  warningCode?: InputMaybe<Scalars['String']['input']>;
};

export type FailOrderFiscalSettlementInput = {
  bankPaymentStatus?: InputMaybe<OrderFiscalBankPaymentStatus>;
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  commandStatus: OrderFiscalKkmCommandStatus;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  failureKind: OrderFiscalFailureKind;
  idCommand: Scalars['String']['input'];
  kktDeviceId?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  payloadHash: Scalars['String']['input'];
  warningCode?: InputMaybe<Scalars['String']['input']>;
};

export type FireEmployeeInput = {
  firing_reason: Scalars['String']['input'];
};

export type ForceCloseOrderFiscalOperationInput = {
  operationId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ForceCloseShiftInput = {
  closingCash: Scalars['Float']['input'];
  comment: Scalars['String']['input'];
  shiftId: Scalars['ID']['input'];
};

export enum ImpersonationEndReason {
  Forced = 'FORCED',
  Logout = 'LOGOUT',
  Manual = 'MANUAL',
  SessionExpired = 'SESSION_EXPIRED',
  Superseded = 'SUPERSEDED'
}

export type ImpersonationState = {
  __typename?: 'ImpersonationState';
  active: Scalars['Boolean']['output'];
  impersonator?: Maybe<User>;
  organization?: Maybe<Organization>;
  session_id?: Maybe<Scalars['ID']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  target_user?: Maybe<User>;
};

export type Invoice = {
  __typename?: 'Invoice';
  annulled_at?: Maybe<Scalars['DateTime']['output']>;
  client_id: Scalars['ID']['output'];
  client_title: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  due_on: Scalars['Date']['output'];
  history: Array<InvoiceHistoryEntry>;
  id: Scalars['ID']['output'];
  is_overdue: Scalars['Boolean']['output'];
  issued_on: Scalars['Date']['output'];
  lines: Array<InvoiceLine>;
  location: InvoiceLocation;
  number: Scalars['Int']['output'];
  order_id: Scalars['ID']['output'];
  /** Основание: «Заказ-наряд № 482», «Запись 22.10, 14:00», «Витрина». */
  order_title: Scalars['String']['output'];
  paid_amount: Scalars['Money']['output'];
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  payer: InvoiceParty;
  /** Поля одного счёта: в списке не выбирать. */
  receipts: Array<InvoiceReceipt>;
  remaining_amount: Scalars['Money']['output'];
  seller: InvoiceParty;
  status: InvoiceStatus;
  total_amount: Scalars['Money']['output'];
};

export type InvoiceFilterCounts = {
  __typename?: 'InvoiceFilterCounts';
  all: Scalars['Int']['output'];
  awaiting_payment: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  paid: Scalars['Int']['output'];
};

export type InvoiceHistoryEntry = {
  __typename?: 'InvoiceHistoryEntry';
  /** Пусто — системная операция. */
  actor_title?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Money']['output']>;
  at: Scalars['DateTime']['output'];
  kind: InvoiceHistoryKind;
  reason?: Maybe<Scalars['String']['output']>;
  /** Номер платёжного поручения. */
  reference?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceHistoryKind {
  Annulled = 'ANNULLED',
  Issued = 'ISSUED',
  Paid = 'PAID',
  ReceiptConfirmed = 'RECEIPT_CONFIRMED',
  ReceiptReturned = 'RECEIPT_RETURNED',
  ReceiptVoided = 'RECEIPT_VOIDED'
}

export type InvoiceIssueAvailability = {
  __typename?: 'InvoiceIssueAvailability';
  available: Scalars['Boolean']['output'];
  missing_payer: Array<InvoiceRequisite>;
  missing_seller: Array<InvoiceRequisite>;
  /** На кого выставится счёт, если у клиента есть реквизиты. */
  payer_preview?: Maybe<InvoiceParty>;
  reason?: Maybe<InvoiceIssueBlock>;
  /** Текст причины для оператора. */
  reason_message?: Maybe<Scalars['String']['output']>;
  /** Юрлицо продавца из реквизитов локации заказа. */
  seller_name?: Maybe<Scalars['String']['output']>;
};

/** Почему по заказу нельзя выставить счёт. */
export enum InvoiceIssueBlock {
  ActiveInvoice = 'ACTIVE_INVOICE',
  AddOnDisabled = 'ADD_ON_DISABLED',
  HasAdvance = 'HAS_ADVANCE',
  MarkedGoods = 'MARKED_GOODS',
  NoClient = 'NO_CLIENT',
  OrderNotDraft = 'ORDER_NOT_DRAFT',
  OrderStale = 'ORDER_STALE',
  PayerRequisitesMissing = 'PAYER_REQUISITES_MISSING',
  PaymentInProgress = 'PAYMENT_IN_PROGRESS',
  SellerRequisitesMissing = 'SELLER_REQUISITES_MISSING',
  ZeroTotal = 'ZERO_TOTAL'
}

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  amount: Scalars['Money']['output'];
  position: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  unit: InvoiceLineUnit;
  unit_price: Scalars['Money']['output'];
};

export enum InvoiceLineUnit {
  Piece = 'PIECE',
  Service = 'SERVICE'
}

export enum InvoiceListFilter {
  All = 'ALL',
  /** Не оплачен полностью: ждёт оплаты или оплачен частично. */
  AwaitingPayment = 'AWAITING_PAYMENT',
  Overdue = 'OVERDUE',
  Paid = 'PAID'
}

export type InvoiceLocation = {
  __typename?: 'InvoiceLocation';
  color: LocationColor;
  id: Scalars['ID']['output'];
  short_name: Scalars['String']['output'];
  /** IANA-зона локации: даты поступлений и сроки — по её календарю. */
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InvoicePage = {
  __typename?: 'InvoicePage';
  /** Считаются, только когда выбраны: дочитка страниц их не спрашивает. */
  counts: InvoiceFilterCounts;
  items: Array<Invoice>;
  /** Сколько разных продавцов (ИНН) у счетов организации: колонка «Продавец» нужна при двух и больше. */
  seller_count: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Сторона счёта на момент выставления: продавец с банком или плательщик. */
export type InvoiceParty = {
  __typename?: 'InvoiceParty';
  account?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  bank_name?: Maybe<Scalars['String']['output']>;
  bik?: Maybe<Scalars['String']['output']>;
  correspondent_account?: Maybe<Scalars['String']['output']>;
  director_name?: Maybe<Scalars['String']['output']>;
  kpp?: Maybe<Scalars['String']['output']>;
  legal_form: LegalForm;
  name: Scalars['String']['output'];
  ogrn?: Maybe<Scalars['String']['output']>;
  tin: Scalars['String']['output'];
};

export type InvoiceReceipt = {
  __typename?: 'InvoiceReceipt';
  amount: Scalars['Money']['output'];
  confirmed_at: Scalars['DateTime']['output'];
  confirmed_by_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  payment_id: Scalars['ID']['output'];
  payment_order_number: Scalars['String']['output'];
  received_on: Scalars['Date']['output'];
  return_payment_order_number?: Maybe<Scalars['String']['output']>;
  returned_at?: Maybe<Scalars['DateTime']['output']>;
  returned_by_title?: Maybe<Scalars['String']['output']>;
  returned_on?: Maybe<Scalars['Date']['output']>;
  status: InvoiceReceiptStatus;
  void_reason?: Maybe<Scalars['String']['output']>;
  voided_at?: Maybe<Scalars['DateTime']['output']>;
  voided_by_title?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceReceiptStatus {
  Confirmed = 'CONFIRMED',
  Returned = 'RETURNED',
  Voided = 'VOIDED'
}

/** Реквизит стороны счёта, которого не хватает для выставления. */
export enum InvoiceRequisite {
  Account = 'ACCOUNT',
  Address = 'ADDRESS',
  BankName = 'BANK_NAME',
  Bik = 'BIK',
  CorrespondentAccount = 'CORRESPONDENT_ACCOUNT',
  DirectorName = 'DIRECTOR_NAME',
  Kpp = 'KPP',
  LegalForm = 'LEGAL_FORM',
  LegalName = 'LEGAL_NAME',
  Tin = 'TIN'
}

export type InvoiceSellerReadiness = {
  __typename?: 'InvoiceSellerReadiness';
  location: InvoiceLocation;
  missing: Array<InvoiceRequisite>;
  seller_name?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceStatus {
  Annulled = 'ANNULLED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export type IssueInvoiceInput = {
  dueOn: Scalars['Date']['input'];
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};

/** Статус организации по данным DaData. */
export enum LegalEntityStatus {
  Active = 'ACTIVE',
  Bankrupt = 'BANKRUPT',
  Liquidated = 'LIQUIDATED',
  Liquidating = 'LIQUIDATING',
  Reorganizing = 'REORGANIZING'
}

export type LegalEntitySuggestion = {
  __typename?: 'LegalEntitySuggestion';
  address?: Maybe<Scalars['String']['output']>;
  kpp?: Maybe<Scalars['String']['output']>;
  legal_form: LegalForm;
  liquidated_on?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  ogrn?: Maybe<Scalars['String']['output']>;
  status: LegalEntityStatus;
  tin: Scalars['String']['output'];
};

export enum LegalForm {
  IndividualEntrepreneur = 'INDIVIDUAL_ENTREPRENEUR',
  Organization = 'ORGANIZATION'
}

export type LinkConversationPayload = {
  __typename?: 'LinkConversationPayload';
  conversation: MessengerConversation;
  warnings: Array<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** Дата закрытия локации (локальная дата). NULL — локация работает; дата в будущем — запланированное закрытие. */
  closed_from?: Maybe<Scalars['Date']['output']>;
  color: LocationColor;
  coordinate?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  enabled: Scalars['Boolean']['output'];
  full_address?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  location_id: Scalars['ID']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Дата начала работы локации (локальная дата). NULL — локация работала всегда. */
  opened_from?: Maybe<Scalars['Date']['output']>;
  organization_id: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  /** Короткое имя: до пяти заглавных букв или цифр, уникально в организации. */
  short_name: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LocationAddressGeocodeResult = {
  __typename?: 'LocationAddressGeocodeResult';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coordinates_exact: Scalars['Boolean']['output'];
  country_code?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postal_code?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  requires_review: Scalars['Boolean']['output'];
};

export type LocationAddressSuggestion = {
  __typename?: 'LocationAddressSuggestion';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coordinates_exact: Scalars['Boolean']['output'];
  country_code?: Maybe<Scalars['String']['output']>;
  house?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  query: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type LocationAnalyticsRow = {
  __typename?: 'LocationAnalyticsRow';
  /** Дата закрытия локации; NULL — локация работает. */
  closed_from?: Maybe<Scalars['Date']['output']>;
  /** Закрыта ли локация на текущий момент с учётом её локальной полуночи. */
  is_closed: Scalars['Boolean']['output'];
  location_id: Scalars['ID']['output'];
  new_clients_count: Scalars['Int']['output'];
  revenue_comparable: Scalars['Money']['output'];
  revenue_per_unit_hour?: Maybe<Scalars['Money']['output']>;
  revenue_previous: Scalars['Money']['output'];
  revenue_series: Array<AnalyticsSeriesPoint>;
  revenue_total: Scalars['Money']['output'];
  revenue_trend: Array<AnalyticsSeriesPoint>;
  title: Scalars['String']['output'];
  utilization_days_below_norm?: Maybe<Scalars['Int']['output']>;
  utilization_days_compared?: Maybe<Scalars['Int']['output']>;
  utilization_deviation_percent?: Maybe<Scalars['Float']['output']>;
  utilization_norm_percent?: Maybe<Scalars['Float']['output']>;
  utilization_norm_state: AnalyticsUtilizationNormState;
  utilization_norm_unavailable_reason?: Maybe<AnalyticsUtilizationNormUnavailableReason>;
  utilization_norm_window_end?: Maybe<Scalars['Date']['output']>;
  utilization_norm_window_start?: Maybe<Scalars['Date']['output']>;
  utilization_percent?: Maybe<Scalars['Float']['output']>;
};

/** Сводка плашки по одной доступной локации: смена и вопросы «Нужно решить». */
export type LocationAttention = {
  __typename?: 'LocationAttention';
  /** Закрытие локации по графику для идущей смены; null без смены или графика. */
  location_closes_at?: Maybe<Scalars['DateTime']['output']>;
  location_id: Scalars['ID']['output'];
  payment_attention_count: Scalars['Int']['output'];
  refund_approval_count: Scalars['Int']['output'];
  shift_expires_at?: Maybe<Scalars['DateTime']['output']>;
  /** Состояние смены; null, если сотруднику не видны смены или модуль заказов выключен. */
  shift_state?: Maybe<ShiftSettlementState>;
};

/** Результат закрытия либо переоткрытия локации; при отказе location = null и дата не меняется. */
export type LocationClosureMutationPayload = {
  __typename?: 'LocationClosureMutationPayload';
  conflicts: Array<UnitUnavailabilityBookingConflict>;
  /** Ближайшая локальная дата, с которой закрытие разрешено; возвращается только при отказе. */
  earliest_allowed_closed_from?: Maybe<Scalars['Date']['output']>;
  location?: Maybe<Location>;
};

/** Цвет локации из палитры графиков, порядок — порядок назначения. */
export enum LocationColor {
  Blue = 'BLUE',
  Cyan = 'CYAN',
  Green = 'GREEN',
  Lime = 'LIME',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Violet = 'VIOLET',
  Yellow = 'YELLOW'
}

export type LocationSchedule = {
  __typename?: 'LocationSchedule';
  current: Array<LocationScheduleDay>;
  upcoming: Array<LocationScheduleDay>;
};

export type LocationScheduleDay = {
  __typename?: 'LocationScheduleDay';
  closes_next_day: Scalars['Boolean']['output'];
  day_of_week: ScheduleWeekday;
  effective_from: Scalars['DateTime']['output'];
  end?: Maybe<Scalars['String']['output']>;
  is_day_off: Scalars['Boolean']['output'];
  start?: Maybe<Scalars['String']['output']>;
};

export type LocationScheduleDayInput = {
  closesNextDay: Scalars['Boolean']['input'];
  dayOfWeek: ScheduleWeekday;
  end?: InputMaybe<Scalars['String']['input']>;
  isDayOff: Scalars['Boolean']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
};

/** Результат сохранения расписания: при конфликтах schedule = null и записи не создаются. */
export type LocationScheduleMutationPayload = {
  __typename?: 'LocationScheduleMutationPayload';
  conflicts: Array<UnitUnavailabilityBookingConflict>;
  schedule?: Maybe<LocationSchedule>;
};

export type LoyaltyAccount = {
  __typename?: 'LoyaltyAccount';
  available_balance: Scalars['Int']['output'];
  client_id: Scalars['ID']['output'];
  current_tier?: Maybe<LoyaltyTier>;
  debt: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lifetime_spent_amount: Scalars['Int']['output'];
  nearest_expiry?: Maybe<LoyaltyNearestExpiry>;
};

export type LoyaltyActor = {
  __typename?: 'LoyaltyActor';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyNearestExpiry = {
  __typename?: 'LoyaltyNearestExpiry';
  amount: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
};

export type LoyaltyProgram = {
  __typename?: 'LoyaltyProgram';
  expiry_months: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  max_redemption_percent: Scalars['Int']['output'];
  organization_id: Scalars['ID']['output'];
  tiers: Array<LoyaltyTier>;
  /** @deprecated Сумма бонуса за регистрацию задаётся в автоматизации «Бонус за регистрацию». */
  welcome_points: Scalars['Int']['output'];
};

export type LoyaltyTier = {
  __typename?: 'LoyaltyTier';
  base_rate_percent: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Ставки на позиции каталога; без ставки позиция получает базовую. */
  item_rates: Array<LoyaltyTierItemRate>;
  min_spent_amount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LoyaltyTierInput = {
  baseRatePercent: Scalars['Int']['input'];
  itemRates?: Array<LoyaltyTierItemRateInput>;
  minSpentAmount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type LoyaltyTierItemRate = {
  __typename?: 'LoyaltyTierItemRate';
  catalog_item_id: Scalars['ID']['output'];
  rate_percent: Scalars['Int']['output'];
};

export type LoyaltyTierItemRateInput = {
  catalogItemId: Scalars['ID']['input'];
  ratePercent: Scalars['Int']['input'];
};

export type LoyaltyTransaction = {
  __typename?: 'LoyaltyTransaction';
  amount: Scalars['Int']['output'];
  client_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by_employee?: Maybe<LoyaltyActor>;
  created_by_employee_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['ID']['output']>;
  order_refund_id?: Maybe<Scalars['ID']['output']>;
  type: LoyaltyTransactionType;
};

/** A paginated list of LoyaltyTransaction edges. */
export type LoyaltyTransactionConnection = {
  __typename?: 'LoyaltyTransactionConnection';
  /** A list of LoyaltyTransaction edges. */
  edges: Array<LoyaltyTransactionEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type LoyaltyTransaction and a cursor. */
export type LoyaltyTransactionEdge = {
  __typename?: 'LoyaltyTransactionEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The LoyaltyTransaction node. */
  node: LoyaltyTransaction;
};

export enum LoyaltyTransactionType {
  Accrual = 'ACCRUAL',
  AccrualRevoke = 'ACCRUAL_REVOKE',
  AutomationAccrual = 'AUTOMATION_ACCRUAL',
  ManualAccrual = 'MANUAL_ACCRUAL',
  ManualDeduct = 'MANUAL_DEDUCT',
  OrderDeduct = 'ORDER_DEDUCT',
  OrderDeductRevert = 'ORDER_DEDUCT_REVERT',
  WelcomeAccrual = 'WELCOME_ACCRUAL'
}

export type MarketingBroadcast = {
  __typename?: 'MarketingBroadcast';
  audience_definition?: Maybe<BroadcastAudienceDefinition>;
  audience_definition_version: Scalars['Int']['output'];
  audience_snapshot?: Maybe<MarketingBroadcastAudienceSnapshot>;
  audience_snapshot_id?: Maybe<Scalars['ID']['output']>;
  body: Scalars['String']['output'];
  bonus_amount?: Maybe<Scalars['Int']['output']>;
  bonus_enabled: Scalars['Boolean']['output'];
  bonus_expires_at?: Maybe<Scalars['DateTime']['output']>;
  bonus_expires_on?: Maybe<Scalars['Date']['output']>;
  bonus_timezone?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  excluded_unlinked_dialogs_count: Scalars['Int']['output'];
  failed_count: Scalars['Int']['output'];
  failed_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<MarketingBroadcastImage>;
  linked_clients_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sent_count: Scalars['Int']['output'];
  snapshot_at?: Maybe<Scalars['DateTime']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: MarketingBroadcastStatus;
  total_count: Scalars['Int']['output'];
  unknown_count: Scalars['Int']['output'];
  unlinked_dialogs_count: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type MarketingBroadcastAudienceEntry = {
  __typename?: 'MarketingBroadcastAudienceEntry';
  channel_id?: Maybe<Scalars['ID']['output']>;
  channel_label?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  client_id?: Maybe<Scalars['ID']['output']>;
  conversation_id?: Maybe<Scalars['ID']['output']>;
  decision: BroadcastAudienceEntryDecision;
  delivery?: Maybe<MarketingBroadcastRecipient>;
  exclusion_reasons: Array<BroadcastAudienceReason>;
  external_chat_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inclusion_reasons: Array<BroadcastAudienceReason>;
  recipient_name: Scalars['String']['output'];
  recipient_username?: Maybe<Scalars['String']['output']>;
  unavailable_reason?: Maybe<BroadcastAudienceUnavailableReason>;
};

/** A paginated list of MarketingBroadcastAudienceEntry edges. */
export type MarketingBroadcastAudienceEntryConnection = {
  __typename?: 'MarketingBroadcastAudienceEntryConnection';
  /** A list of MarketingBroadcastAudienceEntry edges. */
  edges: Array<MarketingBroadcastAudienceEntryEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type MarketingBroadcastAudienceEntry and a cursor. */
export type MarketingBroadcastAudienceEntryEdge = {
  __typename?: 'MarketingBroadcastAudienceEntryEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The MarketingBroadcastAudienceEntry node. */
  node: MarketingBroadcastAudienceEntry;
};

export type MarketingBroadcastAudienceSnapshot = {
  __typename?: 'MarketingBroadcastAudienceSnapshot';
  as_of: Scalars['DateTime']['output'];
  channel_counts: Array<BroadcastAudienceChannelCount>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  definition: BroadcastAudienceDefinition;
  definition_version: Scalars['Int']['output'];
  excluded_count: Scalars['Int']['output'];
  failed_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linked_ready_count: Scalars['Int']['output'];
  no_channel_count: Scalars['Int']['output'];
  ready_count: Scalars['Int']['output'];
  status: BroadcastAudienceSnapshotStatus;
  total_count: Scalars['Int']['output'];
  unlinked_ready_count: Scalars['Int']['output'];
  windows: Array<BroadcastAudienceWindow>;
};

/** A paginated list of MarketingBroadcast edges. */
export type MarketingBroadcastConnection = {
  __typename?: 'MarketingBroadcastConnection';
  /** A list of MarketingBroadcast edges. */
  edges: Array<MarketingBroadcastEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type MarketingBroadcast and a cursor. */
export type MarketingBroadcastEdge = {
  __typename?: 'MarketingBroadcastEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The MarketingBroadcast node. */
  node: MarketingBroadcast;
};

export type MarketingBroadcastImage = {
  __typename?: 'MarketingBroadcastImage';
  file_name: Scalars['String']['output'];
  file_size: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  mime_type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type MarketingBroadcastInput = {
  audienceDefinition?: InputMaybe<BroadcastAudienceDefinitionInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  bonusAmount?: InputMaybe<Scalars['Int']['input']>;
  bonusEnabled?: Scalars['Boolean']['input'];
  bonusExpiresOn?: InputMaybe<Scalars['String']['input']>;
  bonusTimezone?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeImage?: Scalars['Boolean']['input'];
};

export type MarketingBroadcastRecipient = {
  __typename?: 'MarketingBroadcastRecipient';
  audience_entry_id?: Maybe<Scalars['ID']['output']>;
  channel_id: Scalars['ID']['output'];
  client?: Maybe<Client>;
  client_id?: Maybe<Scalars['ID']['output']>;
  conversation_id: Scalars['ID']['output'];
  external_chat_id?: Maybe<Scalars['String']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loyalty_transaction_id?: Maybe<Scalars['ID']['output']>;
  message_id?: Maybe<Scalars['ID']['output']>;
  status: MarketingBroadcastRecipientStatus;
};

export enum MarketingBroadcastRecipientStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Queued = 'QUEUED',
  Sent = 'SENT',
  Unknown = 'UNKNOWN'
}

export enum MarketingBroadcastStatus {
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Preparing = 'PREPARING',
  Sending = 'SENDING'
}

export type MarketingBroadcastTestDelivery = {
  __typename?: 'MarketingBroadcastTestDelivery';
  failed_reason?: Maybe<Scalars['String']['output']>;
  message_id?: Maybe<Scalars['ID']['output']>;
  status: MarketingBroadcastRecipientStatus;
};

export type MarketingBroadcastTestRecipient = {
  __typename?: 'MarketingBroadcastTestRecipient';
  channel_id: Scalars['ID']['output'];
  channel_title: Scalars['String']['output'];
  client?: Maybe<Client>;
  client_id: Scalars['ID']['output'];
  conversation_id: Scalars['ID']['output'];
};

export type MarketingBroadcastTestTargetInput = {
  channelId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
};

export type MarketingSource = {
  __typename?: 'MarketingSource';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_manual_selectable: Scalars['Boolean']['output'];
  is_system: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

/** Фильтр выборки сообщений диалога. */
export enum MessageFilter {
  All = 'ALL',
  NonScheduled = 'NON_SCHEDULED',
  Scheduled = 'SCHEDULED'
}

export type MessengerChannel = {
  __typename?: 'MessengerChannel';
  conversation_count: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  /** Маскированные credentials — сырые токены наружу не отдаём (маскирующий резолвер). */
  credentials?: Maybe<ChannelCredentials>;
  health_status: ChannelHealthStatus;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_fallback: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  provider: MessengerProvider;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** Клиент в контексте мессенджера (подмножество полей клиента для UI). */
export type MessengerClient = {
  __typename?: 'MessengerClient';
  active_bookings_count?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<City>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  marketing_source?: Maybe<MarketingSource>;
  /** Маскированный номер (+7 *** *** 12 34). Полный номер — только через revealClientPhone (rate-limit + аудит). */
  phone_masked?: Maybe<Scalars['String']['output']>;
  type: ClientType;
};

/** Ближайшая предстоящая запись клиента (карточка мессенджера). */
export type MessengerClientNextBooking = {
  __typename?: 'MessengerClientNextBooking';
  end: Scalars['DateTime']['output'];
  location_title?: Maybe<Scalars['String']['output']>;
  service_variant_title?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  /** Статус группы брони (pending/confirmed — отменённые и завершённые группы не попадают в выборку). */
  status: BookingStatus;
};

export type MessengerConversation = {
  __typename?: 'MessengerConversation';
  channel?: Maybe<MessengerChannel>;
  channel_id?: Maybe<Scalars['ID']['output']>;
  chat_metadata?: Maybe<ChatMetadata>;
  client?: Maybe<MessengerClient>;
  connected_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  disconnected_at?: Maybe<Scalars['DateTime']['output']>;
  external_chat_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  last_message?: Maybe<MessengerMessage>;
  last_message_at?: Maybe<Scalars['DateTime']['output']>;
  messages_count?: Maybe<Scalars['Int']['output']>;
  unread_count?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type MessengerConversationGroup = {
  __typename?: 'MessengerConversationGroup';
  client?: Maybe<MessengerClient>;
  client_id?: Maybe<Scalars['ID']['output']>;
  conversations: Array<MessengerConversation>;
  dialog?: Maybe<MessengerDialog>;
  last_message?: Maybe<MessengerMessage>;
  last_message_at?: Maybe<Scalars['DateTime']['output']>;
  unread_count: Scalars['Int']['output'];
};

/** Страница групп диалогов (page-based пагинация, паритет REST). */
export type MessengerConversationGroupPage = {
  __typename?: 'MessengerConversationGroupPage';
  groups: Array<MessengerConversationGroup>;
  meta: PageMeta;
};

/** Рабочий диалог оператора поверх канальных conversation (статус раздела + владелец). */
export type MessengerDialog = {
  __typename?: 'MessengerDialog';
  assignee?: Maybe<MessengerDialogAssignee>;
  id: Scalars['ID']['output'];
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  status: MessengerDialogStatus;
  /** Когда клиент начал ждать ответа; NULL = отвечено (reply-state разделов). */
  waiting_since?: Maybe<Scalars['DateTime']['output']>;
};

/** Оператор-владелец диалога (Employee → User, подмножество для UI). */
export type MessengerDialogAssignee = {
  __typename?: 'MessengerDialogAssignee';
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
};

/** Счётчики диалогов по разделам (для бейджей переключателя). */
export type MessengerDialogCounts = {
  __typename?: 'MessengerDialogCounts';
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
  unanswered: Scalars['Int']['output'];
};

/** Раздел списка диалогов (reply-state, не по назначению). null/ALL = без фильтра. */
export enum MessengerDialogSection {
  All = 'ALL',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
  Unanswered = 'UNANSWERED'
}

/** Статус рабочего диалога: открыт или решён. */
export enum MessengerDialogStatus {
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type MessengerMessage = {
  __typename?: 'MessengerMessage';
  attempts?: Maybe<Scalars['Int']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  body_preview?: Maybe<Scalars['String']['output']>;
  channel_id?: Maybe<Scalars['ID']['output']>;
  conversation_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deliver_deadline?: Maybe<Scalars['DateTime']['output']>;
  delivered_at?: Maybe<Scalars['DateTime']['output']>;
  direction: MessengerMessageDirection;
  /** Автор исходящего — «Имя Фамилия» оператора; NULL у входящих и сценарных. */
  employee_name?: Maybe<Scalars['String']['output']>;
  external_message_id?: Maybe<Scalars['String']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message_type: MessengerMessageType;
  messenger_type?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  read_at?: Maybe<Scalars['DateTime']['output']>;
  scheduled_at?: Maybe<Scalars['DateTime']['output']>;
  sender_type?: Maybe<MessengerMessageSenderType>;
  sent_at?: Maybe<Scalars['DateTime']['output']>;
  status: MessengerMessageStatus;
  updated_at: Scalars['DateTime']['output'];
};

export enum MessengerMessageDirection {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

/** Страница сообщений диалога (keyset-курсор по (sent_at, id)). */
export type MessengerMessagePage = {
  __typename?: 'MessengerMessagePage';
  has_more: Scalars['Boolean']['output'];
  messages: Array<MessengerMessage>;
  scheduled_count: Scalars['Int']['output'];
};

export enum MessengerMessageSenderType {
  Client = 'CLIENT',
  Operator = 'OPERATOR',
  Scenario = 'SCENARIO',
  System = 'SYSTEM'
}

export enum MessengerMessageStatus {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Retry = 'RETRY',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  WaitingForConnection = 'WAITING_FOR_CONNECTION'
}

export enum MessengerMessageType {
  Audio = 'AUDIO',
  Contact = 'CONTACT',
  Document = 'DOCUMENT',
  Event = 'EVENT',
  Image = 'IMAGE',
  Location = 'LOCATION',
  Sticker = 'STICKER',
  Text = 'TEXT',
  Video = 'VIDEO'
}

/** Мессенджер-провайдер. */
export enum MessengerProvider {
  Max = 'MAX',
  Telegram = 'TELEGRAM',
  Vk = 'VK'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Placeholder for future mutations */
  _empty?: Maybe<Scalars['String']['output']>;
  abortShiftOpening: Shift;
  activateScenario: Scenario;
  /** Услуги выбранных групп образца прайса; занятые названия пропускаются. Возвращает число созданных услуг. */
  addTireServiceTemplate: Scalars['Int']['output'];
  /** Продление: остаток единиц × цена услуги приёма. */
  addTireStorageExtension: TireWorkOrder;
  addTireStorageIntake: TireWorkOrder;
  addTireWorkOrderLine: TireWorkOrder;
  addTracksToRadioPlaylist: RadioPlaylist;
  /** Аннулирование работает и при отключённом дополнении. */
  annulInvoice: Invoice;
  /**
   * Ответ администратора «Чек вышел?», когда касса печатает, а ФН прочитать не удалось.
   * «Не вышел» разрешает печать заново, «вышел» закрывает операцию с отметкой сотрудника;
   * реквизиты чека Mors дописывает из ФН позже.
   */
  answerOrderFiscalReceiptPrinted: OrderFiscalSettlementMutationResult;
  /**
   * Подтверждённое подключение кассы: настройки локации, привязка рабочего места и
   * его активация применяются одной транзакцией. Промежуточные шаги мастера боевую
   * строку не изменяют, поэтому отменённая перенастройка не выключает действующую кассу.
   */
  applyOrderFiscalizationConnection: OrderFiscalWorkstation;
  archiveProduct: Product;
  archiveSop: Sop;
  assignTireStoragePlace: TireStorage;
  attachRecoveredRefundRequest: PaymentRefund;
  cancelOrder: Order;
  /**
   * Отмена платежа, расчёт по которому не завершён: исход оплаты картой неизвестен
   * либо деньги получены, а чек пробить не удалось. Чек возврата не оформляется.
   */
  cancelOrderFiscalPayment: OrderFiscalOperation;
  cancelShiftClosing: Shift;
  changeBusinessLocationTimezone: ChangeBusinessLocationTimezonePayload;
  changeBusinessTimezone: BusinessSettings;
  changeTireWorkOrderLineQuantity: TireWorkOrder;
  checkPaymentStatus: PaymentDetails;
  /** Закрыть текущую локацию с указанной даты; активные брони и оплаченные заказы после неё блокируют закрытие. */
  closeLocation: LocationClosureMutationPayload;
  closeShift: Shift;
  /** Исход возврата на карту. Без вызова отметка остаётся и блокирует повтор. */
  completeOrderFiscalPaymentReturn: OrderFiscalOperation;
  completeOrderFiscalRefund: OrderFiscalRefundMutationResult;
  completeOrderFiscalSettlement: OrderFiscalSettlementMutationResult;
  /**
   * «Перевели»: одобряет запрос на возврат переводом и записывает возврат по номеру
   * платёжного поручения. Чек возврата допечатывается на кассе локации.
   */
  completeOrderRefundTransfer: OrderFiscalRefundMutationResult;
  confirmInvoiceReceipt: Invoice;
  confirmShiftKkt: Shift;
  confirmTrackUpload: RadioTrack;
  connectOrganizationAddOn: OrganizationAddOn;
  connectRobokassa: RobokassaConnection;
  /** Создать группу броней. Паритет POST /api/v2/booking (BookingStoreController). */
  createBooking: Scalars['Boolean']['output'];
  createBusinessLocation: BusinessLocation;
  createClient: Client;
  /** Создаёт карточку маркетингового вида со сроком, свободным среди карточек вида. */
  createClientAutomation: ClientAutomation;
  createClientFromConversation: CreateClientFromConversationPayload;
  createClientSegment: ClientSegment;
  createEmployee: Employee;
  createMarketingBroadcast: MarketingBroadcast;
  createMarketingSource: MarketingSource;
  createMessengerChannel: MessengerChannel;
  createOrderFromBookingGroup: Order;
  createProduct: Product;
  createQrLink: QrLink;
  createRadioPlaylist: RadioPlaylist;
  createScenario: Scenario;
  createShopOrderDraft: Order;
  createSop: Sop;
  createSopSection: SopSection;
  createTireCar: TireCar;
  createTireWorkOrder: TireWorkOrder;
  /** Создать ресурс текущей точки. */
  createUnit: BookingUnitMutationPayload;
  /** Создать период временной недоступности unit. */
  createUnitUnavailability: UnitUnavailabilityMutationPayload;
  deactivateOrderFiscalWorkstation: OrderFiscalWorkstation;
  deactivateScenario: Scenario;
  /** Удаляет пустую категорию; с позициями — ошибка category_not_empty. */
  deleteCatalogCategory: Scalars['Boolean']['output'];
  deleteClient: Scalars['Boolean']['output'];
  /** Удаляет созданную карточку и возвращает её. */
  deleteClientAutomation: ClientAutomation;
  /** Удаляет настраиваемый сегмент и возвращает его. */
  deleteClientSegment: ClientSegment;
  deleteMarketingSource: Scalars['Boolean']['output'];
  deleteMessengerChannel: Scalars['Boolean']['output'];
  deleteMessengerMessage: Scalars['Boolean']['output'];
  deleteOrderFiscalWorkstation: Scalars['Boolean']['output'];
  deleteQrLink: Scalars['Boolean']['output'];
  deleteRadioPlaylist: RadioPlaylist;
  deleteRadioTrack: RadioTrack;
  deleteScenario: Scalars['Boolean']['output'];
  deleteSop: Scalars['Boolean']['output'];
  deleteSopSection: Scalars['Boolean']['output'];
  deleteTireCar: Scalars['Boolean']['output'];
  deleteTireStorageWarehouse: Scalars['Boolean']['output'];
  deleteTireWorkOrder: Scalars['Boolean']['output'];
  /** Удалить ресурс, если у него нет текущих или будущих броней. */
  deleteUnit: BookingUnitMutationPayload;
  /** Отменить будущий период недоступности. */
  deleteUnitUnavailability: Scalars['Boolean']['output'];
  deleteWebPushSubscription: User;
  disableRobokassaConnection: RobokassaConnection;
  disconnectOrganizationAddOn: OrganizationAddOn;
  /** Вход суперюзера в чужую организацию под её владельцем. */
  enterOrganizationAsOwner: ImpersonationState;
  failOrderFiscalRefund: OrderFiscalRefundMutationResult;
  failOrderFiscalSettlement: OrderFiscalSettlementMutationResult;
  /** Завершить активный период недоступности сейчас. */
  finishUnitUnavailability: UnitUnavailability;
  fireEmployee: Employee;
  forceCloseOrderFiscalOperation: OrderFiscalOperation;
  forceCloseShift: Shift;
  issueInvoice: Invoice;
  linkConversationClient: LinkConversationPayload;
  manualLoyaltyAccrual: LoyaltyTransaction;
  manualLoyaltyDeduction: LoyaltyTransaction;
  markConversationAsRead: Scalars['Boolean']['output'];
  markMessengerDialogAnswered: MessengerDialog;
  openShift: Shift;
  /** Открывает оплату наряда: строит черновик заказа без записи или возвращает действующий. */
  openTireWorkOrderCheckout: Order;
  platformCreateEmployee: Employee;
  platformCreateOrganization: Organization;
  platformForceStopImpersonationSession: PlatformImpersonationSession;
  platformSetOrganizationModules: Organization;
  platformStartImpersonation: ImpersonationState;
  platformStopImpersonation: ImpersonationState;
  prepareMarketingBroadcastAudience: MarketingBroadcastAudienceSnapshot;
  prepareOrderFiscalRefund: OrderFiscalRefundExecution;
  prepareOrderFiscalSettlement: OrderFiscalSettlementExecution;
  publishSop: Sop;
  reassignMessengerDialog: MessengerDialog;
  receiveProduct: ProductMovement;
  recordOrderFiscalCommandLogs: Scalars['Boolean']['output'];
  /**
   * Возврат СБП, проведённый в меню терминала: записывается по номеру операции со слипа,
   * чек возврата печатается повтором на кассе.
   */
  recordOrderOutsideTerminalRefund: OrderFiscalRefundMutationResult;
  refreshOrderDraft: Order;
  refundAdvance: RefundAdvancePayload;
  refundOrder: Order;
  registerShiftKktReopen: Shift;
  /** Выдача строк хранения; при нулевом остатке хранение выдано и ячейка свободна. */
  releaseTireStorage: TireStorageRelease;
  removeBusinessLocationPhoto: BusinessLocation;
  removeSopPermission: Scalars['Boolean']['output'];
  removeTireWorkOrderLine: TireWorkOrder;
  removeTrackFromRadioPlaylist: RadioPlaylist;
  /** Снять закрытие текущей локации. */
  reopenLocation: LocationClosureMutationPayload;
  /** Порядок раздела «Услуги»: категории в порядке групп, услуги сквозь группы; услуга переезжает в категорию своей группы. */
  reorderCatalogServices: Array<CatalogCategory>;
  reorderRadioPlaylist: RadioPlaylist;
  /** Атомарно заменить клиента записи и пересчитать скидку и итоговую цену. */
  replaceBookingClient: Scalars['Boolean']['output'];
  /** Администратор просит руководителя разрешить возврат платежа чужой смены. */
  requestOrderRefundApproval: OrderRefundApproval;
  requestTrackUpload: TrackUploadUrl;
  /** Возвращает встроенной карточке вида настройки по умолчанию. */
  resetClientAutomation: ClientAutomation;
  /** Возвращает стандартному сегменту правила и название по умолчанию. */
  resetClientSegment: ClientSegment;
  resolveMessengerDialog: MessengerDialog;
  /**
   * Неясный исход печати решает фискальный накопитель: браузер читает документы ФН,
   * сервер решает, есть ли среди них чек операции. Чек операции сохраняется, доказанное
   * отсутствие чека разрешает повтор печати или возврат к оплате.
   */
  resolveOrderFiscalReceipt: OrderFiscalSettlementMutationResult;
  /** Решение руководителя: разрешить, отклонить или отозвать одобрение возврата. */
  resolveOrderRefundApproval: OrderRefundApproval;
  restoreQrLink: QrLink;
  /**
   * Повтор печати непробитого чека оплаты или возврата: деньги учтены, операция
   * получает новый IdCommand и продолжается обычным complete. После закрытия смены
   * расчёта печатается чек коррекции. Для возврата план чека читается через
   * `orderFiscalRefundOperation`.
   */
  retryOrderFiscalReceipt: OrderFiscalSettlementExecution;
  returnInvoiceReceipt: Invoice;
  reverseProductReceipt: ProductMovement;
  saveCatalogCategory: CatalogCategory;
  /** Создаёт или меняет услугу; при конфликте с будущими бронями item = null и услуга не меняется. */
  saveCatalogService: CatalogItemMutationPayload;
  /** Классы машины, диапазон диаметров и RunFlat одним сохранением; сужение, архив и выключение скрывают цены, не удаляя их. */
  saveTireServiceSettings: TireServiceSettings;
  saveTireStorageWarehouse: TireStorageWarehouse;
  /** Отправляет сохранённый текст карточки сотруднику с примерными значениями переменных; повтор с тем же requestId не дублирует сообщение. */
  sendClientAutomationTest: MessengerMessage;
  sendMarketingBroadcastTest: MarketingBroadcastTestDelivery;
  sendMessengerMessage: MessengerMessage;
  /** Отправляет клиенту постоянную ссылку на оплату системным сообщением с кнопкой «Оплатить». */
  sendPaymentLink: PaymentLinkSendTarget;
  /** Архивирует или возвращает услугу; архивация при будущих бронях возвращает конфликты. */
  setCatalogItemArchived: CatalogItemMutationPayload;
  setConversationDefault: MessengerConversation;
  /** Заменяет список услуг отчёта о регистрациях. */
  setShiftLoyaltyReportItems: Array<Scalars['ID']['output']>;
  setSopPermission: SopPermissionType;
  /** Хранение шин организации; зависит от подключённого шиномонтажа. */
  setTireStorageEnabled: OrganizationAddOn;
  setTireWorkOrderCar: TireWorkOrder;
  settleOrder: Order;
  startMarketingBroadcast: MarketingBroadcast;
  /**
   * Клиент вернулся со списанием по платежу, отменённому без проверки: сервер
   * ставит отметку начала возврата и отдаёт команду терминалу. В ту же смену это
   * отмена по карте, позже — возврат на карту по одобренному запросу.
   */
  startOrderFiscalPaymentReturn: OrderFiscalPaymentReturnExecution;
  startOrderFiscalRefund: OrderFiscalRefundExecution;
  startOrderFiscalSettlement: OrderFiscalSettlementExecution;
  startShiftClosing: ShiftClosingContext;
  takeMessengerDialog: MessengerDialog;
  testWebPushSubscription: User;
  transferProduct: ProductMovement;
  unassignMessengerDialog: MessengerDialog;
  unfireEmployee: Employee;
  unlinkConversationClient: MessengerConversation;
  /** Обновить слоты, комментарий и скидку группы; стоимость рассчитывает сервер. */
  updateBooking: Scalars['Boolean']['output'];
  /** Сменить статус группы броней. */
  updateBookingStatus: Scalars['Boolean']['output'];
  updateBusinessLocationAddress: BusinessLocation;
  updateBusinessLocationDetails: BusinessLocation;
  updateBusinessSettings: BusinessSettings;
  updateClient: Client;
  updateClientAutomation: ClientAutomation;
  /** Меняет или выключает тихие часы; запланированные напоминания о визитах пересчитываются в фоне. */
  updateClientQuietHours: ClientQuietHours;
  updateClientSegment: ClientSegment;
  updateEmployee: Employee;
  updateMarketingBroadcast: MarketingBroadcast;
  updateMarketingSource: MarketingSource;
  updateMessengerChannel: MessengerChannel;
  updateMyProfile: User;
  updateOrderFiscalizationSettings: OrderFiscalizationSetting;
  updateProduct: Product;
  updateQrLink: QrLink;
  updateRadioPlaylist: RadioPlaylist;
  updateRadioTrack: RadioTrack;
  updateRobokassaConnection: RobokassaConnection;
  updateScenario: Scenario;
  updateSop: Sop;
  updateSopSection: SopSection;
  updateTireCar: TireCar;
  updateTireStorageIntake: TireWorkOrder;
  /** Класс запоминается у машины и пересчитывает строки по их размеру. Диаметр и RunFlat — размер колёс для новых строк, добавленные не меняются. */
  updateTireWorkOrderParams: TireWorkOrder;
  /** Изменить название и/или активность ресурса; деактивация блокируется будущими бронями. */
  updateUnit: BookingUnitMutationPayload;
  /** Изменить будущий или активный период недоступности. */
  updateUnitUnavailability: UnitUnavailabilityMutationPayload;
  updateWebPushNotificationPreference: User;
  uploadBusinessLocationPhoto: BusinessLocation;
  uploadProductPhoto: ProductPhotoUploadPayload;
  uploadSopImage: SopImageUploadPayload;
  /** Атомарно сохранить ресурсы локации и настройки услуг каталога в ней. */
  upsertBookingCatalog: BookingCatalogMutationPayload;
  /** Создать версии изменённых дней расписания; при конфликтах с будущими бронями ничего не сохраняется. */
  upsertLocationSchedule: LocationScheduleMutationPayload;
  upsertLoyaltyProgram: LoyaltyProgram;
  upsertWebPushSubscription: User;
  voidInvoiceReceipt: Invoice;
  writeOffProduct: ProductMovement;
};


export type MutationAbortShiftOpeningArgs = {
  shiftId: Scalars['ID']['input'];
};


export type MutationActivateScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddTireServiceTemplateArgs = {
  groups: Array<TireServiceTemplateGroup>;
};


export type MutationAddTireStorageExtensionArgs = {
  enteredPrice?: InputMaybe<Scalars['Int']['input']>;
  storageId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};


export type MutationAddTireStorageIntakeArgs = {
  catalogItemId: Scalars['ID']['input'];
  input: TireStorageInput;
  workOrderId: Scalars['ID']['input'];
};


export type MutationAddTireWorkOrderLineArgs = {
  catalogItemId: Scalars['ID']['input'];
  enteredPrice?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationAddTracksToRadioPlaylistArgs = {
  playlistId: Scalars['ID']['input'];
  trackIds: Array<Scalars['ID']['input']>;
};


export type MutationAnnulInvoiceArgs = {
  input: AnnulInvoiceInput;
};


export type MutationAnswerOrderFiscalReceiptPrintedArgs = {
  input: AnswerOrderFiscalReceiptPrintedInput;
};


export type MutationApplyOrderFiscalizationConnectionArgs = {
  input: ApplyOrderFiscalizationConnectionInput;
};


export type MutationArchiveProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveSopArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignTireStoragePlaceArgs = {
  cellNo?: InputMaybe<Scalars['Int']['input']>;
  rackNo?: InputMaybe<Scalars['Int']['input']>;
  storageId: Scalars['ID']['input'];
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAttachRecoveredRefundRequestArgs = {
  refundId: Scalars['ID']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  expectedVersion: Scalars['Int']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationCancelOrderFiscalPaymentArgs = {
  input: CancelOrderFiscalPaymentInput;
};


export type MutationCancelShiftClosingArgs = {
  shiftId: Scalars['ID']['input'];
};


export type MutationChangeBusinessLocationTimezoneArgs = {
  locationId: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationChangeBusinessTimezoneArgs = {
  timezone: Scalars['String']['input'];
};


export type MutationChangeTireWorkOrderLineQuantityArgs = {
  lineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationCheckPaymentStatusArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationCloseLocationArgs = {
  input: CloseLocationInput;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCloseShiftArgs = {
  input: CloseShiftInput;
};


export type MutationCompleteOrderFiscalPaymentReturnArgs = {
  input: CompleteOrderFiscalPaymentReturnInput;
};


export type MutationCompleteOrderFiscalRefundArgs = {
  input: CompleteOrderFiscalRefundInput;
};


export type MutationCompleteOrderFiscalSettlementArgs = {
  input: CompleteOrderFiscalSettlementInput;
};


export type MutationCompleteOrderRefundTransferArgs = {
  input: CompleteOrderRefundTransferInput;
};


export type MutationConfirmInvoiceReceiptArgs = {
  input: ConfirmInvoiceReceiptInput;
};


export type MutationConfirmShiftKktArgs = {
  input: ConfirmShiftKktInput;
};


export type MutationConfirmTrackUploadArgs = {
  duration: Scalars['Int']['input'];
  trackId: Scalars['ID']['input'];
};


export type MutationConnectOrganizationAddOnArgs = {
  module: OrganizationModule;
};


export type MutationConnectRobokassaArgs = {
  input: RobokassaConnectionInput;
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateBusinessLocationArgs = {
  input: CreateBusinessLocationInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateClientAutomationArgs = {
  input: ClientAutomationInput;
  kind: ClientAutomationKind;
};


export type MutationCreateClientFromConversationArgs = {
  conversationId: Scalars['ID']['input'];
  input: CreateClientFromConversationInput;
};


export type MutationCreateClientSegmentArgs = {
  input: ClientSegmentInput;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateMarketingBroadcastArgs = {
  input: MarketingBroadcastInput;
};


export type MutationCreateMarketingSourceArgs = {
  input: CreateMarketingSourceInput;
};


export type MutationCreateMessengerChannelArgs = {
  input: CreateMessengerChannelInput;
};


export type MutationCreateOrderFromBookingGroupArgs = {
  bookingGroupId: Scalars['ID']['input'];
};


export type MutationCreateProductArgs = {
  input: ProductInput;
};


export type MutationCreateQrLinkArgs = {
  input: CreateQrLinkInput;
};


export type MutationCreateRadioPlaylistArgs = {
  input: CreateRadioPlaylistInput;
};


export type MutationCreateScenarioArgs = {
  input: CreateScenarioInput;
};


export type MutationCreateShopOrderDraftArgs = {
  input: ShopOrderDraftInput;
};


export type MutationCreateSopArgs = {
  input: CreateSopInput;
};


export type MutationCreateSopSectionArgs = {
  input: CreateSopSectionInput;
};


export type MutationCreateTireCarArgs = {
  input: TireCarInput;
};


export type MutationCreateTireWorkOrderArgs = {
  bookingGroupId?: InputMaybe<Scalars['ID']['input']>;
  carId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateUnitArgs = {
  input: CreateBookingUnitInput;
};


export type MutationCreateUnitUnavailabilityArgs = {
  input: CreateUnitUnavailabilityInput;
};


export type MutationDeactivateOrderFiscalWorkstationArgs = {
  locationId: Scalars['ID']['input'];
  workstationId: Scalars['ID']['input'];
};


export type MutationDeactivateScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCatalogCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientAutomationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientSegmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMarketingSourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMessengerChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMessengerMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrderFiscalWorkstationArgs = {
  locationId: Scalars['ID']['input'];
  workstationId: Scalars['ID']['input'];
};


export type MutationDeleteQrLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRadioPlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRadioTrackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSopArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSopSectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTireCarArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTireStorageWarehouseArgs = {
  id: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type MutationDeleteTireWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUnitArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUnitUnavailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWebPushSubscriptionArgs = {
  input: WebPushEndpointInput;
};


export type MutationDisconnectOrganizationAddOnArgs = {
  module: OrganizationModule;
};


export type MutationEnterOrganizationAsOwnerArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationFailOrderFiscalRefundArgs = {
  input: FailOrderFiscalRefundInput;
};


export type MutationFailOrderFiscalSettlementArgs = {
  input: FailOrderFiscalSettlementInput;
};


export type MutationFinishUnitUnavailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFireEmployeeArgs = {
  id: Scalars['ID']['input'];
  input: FireEmployeeInput;
};


export type MutationForceCloseOrderFiscalOperationArgs = {
  input: ForceCloseOrderFiscalOperationInput;
};


export type MutationForceCloseShiftArgs = {
  input: ForceCloseShiftInput;
};


export type MutationIssueInvoiceArgs = {
  input: IssueInvoiceInput;
};


export type MutationLinkConversationClientArgs = {
  clientId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationManualLoyaltyAccrualArgs = {
  amount: Scalars['Int']['input'];
  clientId: Scalars['ID']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  note: Scalars['String']['input'];
};


export type MutationManualLoyaltyDeductionArgs = {
  amount: Scalars['Int']['input'];
  clientId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationMarkConversationAsReadArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationMarkMessengerDialogAnsweredArgs = {
  dialogId: Scalars['ID']['input'];
};


export type MutationOpenShiftArgs = {
  input: OpenShiftInput;
};


export type MutationOpenTireWorkOrderCheckoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformCreateEmployeeArgs = {
  input: PlatformCreateEmployeeInput;
};


export type MutationPlatformCreateOrganizationArgs = {
  input: PlatformCreateOrganizationInput;
};


export type MutationPlatformForceStopImpersonationSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformSetOrganizationModulesArgs = {
  input: PlatformSetOrganizationModulesInput;
};


export type MutationPlatformStartImpersonationArgs = {
  input: PlatformStartImpersonationInput;
};


export type MutationPrepareMarketingBroadcastAudienceArgs = {
  id: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPrepareOrderFiscalRefundArgs = {
  input: PrepareOrderFiscalRefundInput;
};


export type MutationPrepareOrderFiscalSettlementArgs = {
  input: PrepareOrderFiscalSettlementInput;
};


export type MutationPublishSopArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReassignMessengerDialogArgs = {
  dialogId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
};


export type MutationReceiveProductArgs = {
  input: ProductMovementInput;
};


export type MutationRecordOrderFiscalCommandLogsArgs = {
  input: RecordOrderFiscalCommandLogsInput;
};


export type MutationRecordOrderOutsideTerminalRefundArgs = {
  input: RecordOrderOutsideTerminalRefundInput;
};


export type MutationRefreshOrderDraftArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationRefundAdvanceArgs = {
  input: RefundAdvanceInput;
};


export type MutationRefundOrderArgs = {
  input: RefundOrderInput;
};


export type MutationRegisterShiftKktReopenArgs = {
  input: RegisterShiftKktReopenInput;
};


export type MutationReleaseTireStorageArgs = {
  items: Array<TireStorageReleaseItemInput>;
  storageId: Scalars['ID']['input'];
};


export type MutationRemoveBusinessLocationPhotoArgs = {
  locationId: Scalars['ID']['input'];
};


export type MutationRemoveSopPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTireWorkOrderLineArgs = {
  lineId: Scalars['ID']['input'];
};


export type MutationRemoveTrackFromRadioPlaylistArgs = {
  playlistId: Scalars['ID']['input'];
  trackId: Scalars['ID']['input'];
};


export type MutationReopenLocationArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationReorderCatalogServicesArgs = {
  groups: Array<CatalogServiceGroupInput>;
};


export type MutationReorderRadioPlaylistArgs = {
  playlistId: Scalars['ID']['input'];
  trackIds: Array<Scalars['ID']['input']>;
};


export type MutationReplaceBookingClientArgs = {
  id: Scalars['ID']['input'];
  input: ReplaceBookingClientInput;
};


export type MutationRequestOrderRefundApprovalArgs = {
  input: RequestOrderRefundApprovalInput;
};


export type MutationRequestTrackUploadArgs = {
  input: RequestTrackUploadInput;
};


export type MutationResetClientAutomationArgs = {
  kind: ClientAutomationKind;
};


export type MutationResetClientSegmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResolveMessengerDialogArgs = {
  dialogId: Scalars['ID']['input'];
};


export type MutationResolveOrderFiscalReceiptArgs = {
  input: ResolveOrderFiscalReceiptInput;
};


export type MutationResolveOrderRefundApprovalArgs = {
  input: ResolveOrderRefundApprovalInput;
};


export type MutationRestoreQrLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryOrderFiscalReceiptArgs = {
  input: RetryOrderFiscalReceiptInput;
};


export type MutationReturnInvoiceReceiptArgs = {
  input: ReturnInvoiceReceiptInput;
};


export type MutationReverseProductReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveCatalogCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  position?: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};


export type MutationSaveCatalogServiceArgs = {
  input: CatalogServiceInput;
};


export type MutationSaveTireServiceSettingsArgs = {
  input: SaveTireServiceSettingsInput;
};


export type MutationSaveTireStorageWarehouseArgs = {
  cellCount: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  rackCount: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};


export type MutationSendClientAutomationTestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: ClientAutomationKind;
  target: MarketingBroadcastTestTargetInput;
};


export type MutationSendMarketingBroadcastTestArgs = {
  id: Scalars['ID']['input'];
  target: MarketingBroadcastTestTargetInput;
  version: Scalars['Int']['input'];
};


export type MutationSendMessengerMessageArgs = {
  input: SendMessengerMessageInput;
};


export type MutationSendPaymentLinkArgs = {
  input: SendPaymentLinkInput;
};


export type MutationSetCatalogItemArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetConversationDefaultArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationSetShiftLoyaltyReportItemsArgs = {
  catalogItemIds: Array<Scalars['ID']['input']>;
};


export type MutationSetSopPermissionArgs = {
  input: SetSopPermissionInput;
};


export type MutationSetTireStorageEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetTireWorkOrderCarArgs = {
  carId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSettleOrderArgs = {
  input: SettleOrderInput;
};


export type MutationStartMarketingBroadcastArgs = {
  id: Scalars['ID']['input'];
  snapshotId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationStartOrderFiscalPaymentReturnArgs = {
  operationId: Scalars['ID']['input'];
};


export type MutationStartOrderFiscalRefundArgs = {
  input: OrderFiscalOperationIdentityInput;
};


export type MutationStartOrderFiscalSettlementArgs = {
  input: OrderFiscalOperationIdentityInput;
};


export type MutationStartShiftClosingArgs = {
  shiftId: Scalars['ID']['input'];
};


export type MutationTakeMessengerDialogArgs = {
  dialogId: Scalars['ID']['input'];
};


export type MutationTestWebPushSubscriptionArgs = {
  input: WebPushEndpointInput;
};


export type MutationTransferProductArgs = {
  input: ProductTransferInput;
};


export type MutationUnassignMessengerDialogArgs = {
  dialogId: Scalars['ID']['input'];
};


export type MutationUnfireEmployeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlinkConversationClientArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationUpdateBookingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBookingInput;
};


export type MutationUpdateBookingStatusArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBookingStatusInput;
};


export type MutationUpdateBusinessLocationAddressArgs = {
  input: UpdateBusinessLocationAddressInput;
  locationId: Scalars['ID']['input'];
};


export type MutationUpdateBusinessLocationDetailsArgs = {
  input: UpdateBusinessLocationDetailsInput;
  locationId: Scalars['ID']['input'];
};


export type MutationUpdateBusinessSettingsArgs = {
  input: UpdateBusinessSettingsInput;
};


export type MutationUpdateClientArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientInput;
};


export type MutationUpdateClientAutomationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ClientAutomationInput;
  kind: ClientAutomationKind;
};


export type MutationUpdateClientQuietHoursArgs = {
  input: ClientQuietHoursInput;
};


export type MutationUpdateClientSegmentArgs = {
  id: Scalars['ID']['input'];
  input: ClientSegmentInput;
};


export type MutationUpdateEmployeeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeInput;
};


export type MutationUpdateMarketingBroadcastArgs = {
  id: Scalars['ID']['input'];
  input: MarketingBroadcastInput;
  version: Scalars['Int']['input'];
};


export type MutationUpdateMarketingSourceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMarketingSourceInput;
};


export type MutationUpdateMessengerChannelArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMessengerChannelInput;
};


export type MutationUpdateMyProfileArgs = {
  input: UpdateMyProfileInput;
};


export type MutationUpdateOrderFiscalizationSettingsArgs = {
  input: UpdateOrderFiscalizationSettingsInput;
};


export type MutationUpdateProductArgs = {
  id: Scalars['ID']['input'];
  input: ProductInput;
};


export type MutationUpdateQrLinkArgs = {
  id: Scalars['ID']['input'];
  input: UpdateQrLinkInput;
};


export type MutationUpdateRadioPlaylistArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRadioPlaylistInput;
};


export type MutationUpdateRadioTrackArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRadioTrackInput;
};


export type MutationUpdateRobokassaConnectionArgs = {
  input: RobokassaConnectionInput;
};


export type MutationUpdateScenarioArgs = {
  id: Scalars['ID']['input'];
  input: UpdateScenarioInput;
};


export type MutationUpdateSopArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSopInput;
};


export type MutationUpdateSopSectionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSopSectionInput;
};


export type MutationUpdateTireCarArgs = {
  id: Scalars['ID']['input'];
  input: TireCarInput;
};


export type MutationUpdateTireStorageIntakeArgs = {
  input: TireStorageInput;
  storageId: Scalars['ID']['input'];
};


export type MutationUpdateTireWorkOrderParamsArgs = {
  carClassId?: InputMaybe<Scalars['ID']['input']>;
  discountPercent?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  runFlat?: InputMaybe<Scalars['Boolean']['input']>;
  wheelDiameter?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateUnitArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBookingUnitInput;
};


export type MutationUpdateUnitUnavailabilityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUnitUnavailabilityInput;
};


export type MutationUpdateWebPushNotificationPreferenceArgs = {
  input: UpdateWebPushNotificationPreferenceInput;
};


export type MutationUploadBusinessLocationPhotoArgs = {
  locationId: Scalars['ID']['input'];
  photo: Scalars['Upload']['input'];
};


export type MutationUploadProductPhotoArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadSopImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpsertBookingCatalogArgs = {
  input: UpsertBookingCatalogInput;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertLocationScheduleArgs = {
  input: UpsertLocationScheduleInput;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertLoyaltyProgramArgs = {
  input: UpsertLoyaltyProgramInput;
};


export type MutationUpsertWebPushSubscriptionArgs = {
  input: UpsertWebPushSubscriptionInput;
};


export type MutationVoidInvoiceReceiptArgs = {
  input: VoidInvoiceReceiptInput;
};


export type MutationWriteOffProductArgs = {
  input: ProductMovementInput;
};

/** Когорта новичков одного месяца: сколько пришло впервые и сколько вернулось. */
export type NewClientRetentionCohort = {
  __typename?: 'NewClientRetentionCohort';
  /** Самая ранняя локальная дата первого визита клиентов этой строки в выбранном периоде; null в пустом месяце. */
  first_visit_date?: Maybe<Scalars['Date']['output']>;
  /**
   * Созревшие клиенты окна 30 дней: с их первого визита прошло больше 30 дней,
   * поэтому окно наблюдения полностью в прошлом.
   */
  matured_30: Scalars['Int']['output'];
  /** Созревшие клиенты окна 90 дней. */
  matured_90: Scalars['Int']['output'];
  /** Первый день календарного месяца когорты. */
  month: Scalars['Date']['output'];
  /** Клиенты, чей первый визит попал в этот месяц. */
  new_clients: Scalars['Int']['output'];
  /** Вернувшиеся за 30 дней; числитель ограничен созревшими клиентами. */
  returned_30: Scalars['Int']['output'];
  /** Вернувшиеся за 90 дней; числитель ограничен созревшими клиентами. */
  returned_90: Scalars['Int']['output'];
  /** Вернувшиеся когда-либо, без ограничения окна и созревания. */
  returned_any: Scalars['Int']['output'];
};

/** Разрез отчёта «Возвращаемость новичков» по признаку первого визита. */
export enum NewClientRetentionDimension {
  Location = 'Location',
  LoyaltyRegistration = 'LoyaltyRegistration',
  ShiftEmployee = 'ShiftEmployee'
}

/** Строка временного ручного отчёта «Возвращаемость новичков». */
export type NewClientRetentionRow = {
  __typename?: 'NewClientRetentionRow';
  /** Плотный список месяцев периода: месяцы без новичков присутствуют с нулями. */
  cohorts: Array<NewClientRetentionCohort>;
  /** Идентификатор разреза; null у агрегата «Вся сеть» и строки «Без смены». */
  key?: Maybe<Scalars['ID']['output']>;
  row_kind: AnalyticsBreakdownRowKind;
  title: Scalars['String']['output'];
};

export type OpenShiftInput = {
  locationId: Scalars['ID']['input'];
  openingCash: Scalars['Float']['input'];
};

export type Order = {
  __typename?: 'Order';
  /**
   * Способ безналичной оплаты, восстановленный из маски банковского
   * идентификатора. `null` у оплаченных наличными заказов и у заказов до подключения ККТ.
   */
  acquiring_instrument?: Maybe<OrderAcquiringInstrument>;
  adjustments: Array<OrderAdjustment>;
  /** Подтверждённый, но ещё не зачтённый онлайн-аванс черновика; у остальных статусов 0. */
  advance_amount: Scalars['Int']['output'];
  audit_logs: Array<OrderAuditLog>;
  booking_group_id?: Maybe<Scalars['ID']['output']>;
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  cancelled_by_employee?: Maybe<OrderActor>;
  client_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by_employee?: Maybe<OrderActor>;
  currency: OrderCurrency;
  customer_snapshot?: Maybe<OrderCustomerSnapshot>;
  discount_amount: Scalars['Int']['output'];
  final_receipt_outside_mors: Scalars['Boolean']['output'];
  fiscal_operations: Array<OrderFiscalOperation>;
  fiscal_receipt_state: OrderFiscalReceiptState;
  gross_amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lines: Array<OrderLine>;
  location: Location;
  location_id: Scalars['ID']['output'];
  money_parts: Array<OrderMoneyPart>;
  organization_id: Scalars['ID']['output'];
  paid_amount: Scalars['Int']['output'];
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  paid_by_employee?: Maybe<OrderActor>;
  refunded_amount: Scalars['Int']['output'];
  refunds: Array<OrderRefund>;
  remaining_amount: Scalars['Int']['output'];
  revision: Scalars['Int']['output'];
  source: OrderSource;
  status: OrderStatus;
  total_amount: Scalars['Int']['output'];
  /**
   * Коды маркировки чека, которые ГИС МТ не считает нашими: партия без
   * подписанного УПД. Оплату заказа не блокирует, но чек уходит в ГИС МТ с ошибкой.
   */
  unowned_marking_codes: Array<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export enum OrderAcquiringInstrument {
  Card = 'CARD',
  Sbp = 'SBP'
}

export type OrderActor = {
  __typename?: 'OrderActor';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type OrderAdjustment = {
  __typename?: 'OrderAdjustment';
  adjustment_type: OrderAdjustmentType;
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  line_points: Array<OrderAdjustmentLinePoints>;
  order_line_id?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
};

/**
 * Распределение списанных баллов лояльности по строкам заказа
 * (из metadata loyalty-adjustment).
 */
export type OrderAdjustmentLinePoints = {
  __typename?: 'OrderAdjustmentLinePoints';
  order_line_id: Scalars['ID']['output'];
  points: Scalars['Int']['output'];
};

export enum OrderAdjustmentType {
  BookingDiscount = 'BOOKING_DISCOUNT',
  LoyaltyDiscount = 'LOYALTY_DISCOUNT',
  ManualDiscount = 'MANUAL_DISCOUNT'
}

export enum OrderAuditAction {
  Cancelled = 'CANCELLED',
  ClientLinked = 'CLIENT_LINKED',
  Created = 'CREATED',
  FiscalForceClosed = 'FISCAL_FORCE_CLOSED',
  FiscalPaymentCancelled = 'FISCAL_PAYMENT_CANCELLED',
  FiscalPaymentReturned = 'FISCAL_PAYMENT_RETURNED',
  FiscalReconciled = 'FISCAL_RECONCILED',
  LegacyImported = 'LEGACY_IMPORTED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Refreshed = 'REFRESHED',
  Refunded = 'REFUNDED',
  Settled = 'SETTLED'
}

export type OrderAuditLog = {
  __typename?: 'OrderAuditLog';
  action: OrderAuditAction;
  actor_employee?: Maybe<OrderActor>;
  actor_employee_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  new_values?: Maybe<Scalars['JSON']['output']>;
  old_values?: Maybe<Scalars['JSON']['output']>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type OrderCheckoutContext = {
  __typename?: 'OrderCheckoutContext';
  active_fiscal_operation?: Maybe<OrderFiscalOperation>;
  advance_total: Scalars['Int']['output'];
  advances: Array<PaymentAdvanceState>;
  allowed_payment_methods: Array<OrderPaymentMethod>;
  final_receipt_required: Scalars['Boolean']['output'];
  fiscalization_readiness?: Maybe<OrderFiscalizationReadiness>;
  fiscalization_required: Scalars['Boolean']['output'];
  /** Действующий или оплаченный счёт заказа: под действующим заказ оплачивается только по счёту. */
  invoice?: Maybe<Invoice>;
  loyalty?: Maybe<OrderLoyaltyContext>;
  loyalty_program_active: Scalars['Boolean']['output'];
  open_payment_links: Array<PaymentLinkState>;
  order: Order;
  overpayment_to_refund: Scalars['Int']['output'];
  /** Постоянная ссылка на оплату; null — ссылка недоступна или нет права принимать оплату. */
  pay_url?: Maybe<Scalars['String']['output']>;
  payment_link_availability: PaymentLinkAvailability;
  remaining_to_pay: Scalars['Int']['output'];
  send_targets: Array<PaymentLinkSendTarget>;
  shift_blocker_reason?: Maybe<ShiftSettlementBlockerReason>;
  shift_expires_at?: Maybe<Scalars['DateTime']['output']>;
  shift_required?: Maybe<Scalars['Boolean']['output']>;
  shift_state?: Maybe<ShiftSettlementState>;
  source_state: OrderCheckoutSourceState;
};

export enum OrderCheckoutSourceState {
  Fresh = 'FRESH',
  Locked = 'LOCKED',
  Stale = 'STALE',
  Terminal = 'TERMINAL'
}

/** A paginated list of Order edges. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of Order edges. */
  edges: Array<OrderEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

export enum OrderCurrency {
  Rub = 'RUB'
}

export type OrderCustomerSnapshot = {
  __typename?: 'OrderCustomerSnapshot';
  email_masked?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  /** Наименование компании, если клиент — компания. */
  legal_name?: Maybe<Scalars['String']['output']>;
  patronymic_name?: Maybe<Scalars['String']['output']>;
  phone_masked?: Maybe<Scalars['String']['output']>;
  /** У старых снимков пусто. */
  type?: Maybe<ClientType>;
};

/** An edge that contains a node of type Order and a cursor. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Order node. */
  node: Order;
};

export enum OrderFiscalAcquiringMode {
  TwoStep = 'TWO_STEP'
}

export enum OrderFiscalBankPaymentStatus {
  Cancelled = 'CANCELLED',
  Captured = 'CAPTURED',
  Declined = 'DECLINED',
  Refunded = 'REFUNDED',
  /** Терминал не дал понятного ответа на возврат: возврат считается выполненным. */
  RefundedUnverified = 'REFUNDED_UNVERIFIED',
  Reversed = 'REVERSED'
}

export type OrderFiscalBankResultInput = {
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  maskedPan?: InputMaybe<Scalars['String']['input']>;
  rrn?: InputMaybe<Scalars['String']['input']>;
  terminalTransactionId?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderFiscalCommandDeviceKind {
  Acquiring = 'ACQUIRING',
  Kkt = 'KKT',
  Server = 'SERVER'
}

export type OrderFiscalCommandLogEntryInput = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  clientAt: Scalars['DateTime']['input'];
  clientEventId: Scalars['ID']['input'];
  command: Scalars['String']['input'];
  deviceKind: OrderFiscalCommandDeviceKind;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  fiscalOperationId?: InputMaybe<Scalars['ID']['input']>;
  idCommand: Scalars['String']['input'];
  idDevice?: InputMaybe<Scalars['String']['input']>;
  kkmserverVersion?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
  pageSessionId: Scalars['ID']['input'];
  payload: Scalars['JSON']['input'];
  phase: OrderFiscalCommandPhase;
  refundId?: InputMaybe<Scalars['ID']['input']>;
  shiftId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<OrderFiscalKkmCommandStatus>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  vendorMessage?: InputMaybe<Scalars['String']['input']>;
  workstationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum OrderFiscalCommandPhase {
  Request = 'REQUEST',
  Response = 'RESPONSE',
  Threw = 'THREW',
  Timeout = 'TIMEOUT'
}

export type OrderFiscalDocumentResultInput = {
  fiscalDocumentNumber?: InputMaybe<Scalars['Int']['input']>;
  fiscalDocumentSign?: InputMaybe<Scalars['String']['input']>;
  fiscalDriveNumber?: InputMaybe<Scalars['String']['input']>;
  fiscalizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  receiptNumber?: InputMaybe<Scalars['Int']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  shiftNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Чек фискального накопителя, прочитанный с кассы. */
export type OrderFiscalDriveDocumentInput = {
  fiscal: OrderFiscalDocumentResultInput;
  /** Приход или возврат прихода. */
  operationType: OrderFiscalOperationType;
  /** Итог чека в копейках. */
  totalAmount: Scalars['Int']['input'];
};

export type OrderFiscalExecutionTarget = {
  __typename?: 'OrderFiscalExecutionTarget';
  browser_workstation_id: Scalars['ID']['output'];
  kkt_device_id: Scalars['String']['output'];
  kkt_identity_hash?: Maybe<Scalars['String']['output']>;
  provider: OrderFiscalizationProvider;
  settings_version: Scalars['Int']['output'];
  terminal_device_id?: Maybe<Scalars['String']['output']>;
  terminal_identity_hash?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
};

export enum OrderFiscalFailureKind {
  CancelledNotCharged = 'CANCELLED_NOT_CHARGED',
  CancelledUnverified = 'CANCELLED_UNVERIFIED',
  KnownPrePrint = 'KNOWN_PRE_PRINT',
  MalformedResponse = 'MALFORMED_RESPONSE',
  ManagerConfirmedNotRun = 'MANAGER_CONFIRMED_NOT_RUN',
  MappingUnsupported = 'MAPPING_UNSUPPORTED',
  OwnerForceClosed = 'OWNER_FORCE_CLOSED',
  PaymentCancelled = 'PAYMENT_CANCELLED',
  PaymentDeclined = 'PAYMENT_DECLINED',
  PaymentReversed = 'PAYMENT_REVERSED',
  ShiftClosedUnconfirmed = 'SHIFT_CLOSED_UNCONFIRMED',
  TransportUnknown = 'TRANSPORT_UNKNOWN'
}

export enum OrderFiscalKkmCommandStatus {
  /** Команда с этим `IdCommand` уже выполнена: подтверждение, а не ошибка. */
  AlreadyDone = 'ALREADY_DONE',
  Error = 'ERROR',
  NotFound = 'NOT_FOUND',
  NotRun = 'NOT_RUN',
  Ok = 'OK',
  Run = 'RUN'
}

export type OrderFiscalKkmResponseInput = {
  /** IdTypeDevice драйвера ККТ из списка устройств KKMServer. */
  driver?: InputMaybe<Scalars['String']['input']>;
  /** Распакованный ответ RegisterCheck без банковских данных. */
  response: Scalars['JSON']['input'];
  serverVersion?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderFiscalKktStatus {
  Blocked = 'BLOCKED',
  Ready = 'READY',
  Unknown = 'UNKNOWN'
}

export type OrderFiscalKktVerificationInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** Версия ФФД из GetDataKKT.Info.FFDVersion; чек с кодами маркировки требует 1.2. */
  ffdVersion?: InputMaybe<Scalars['String']['input']>;
  fnNumber?: InputMaybe<Scalars['String']['input']>;
  inn?: InputMaybe<Scalars['String']['input']>;
  kktNumber?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  /** Признак регистрации «торговля подакцизными товарами». */
  saleExcisableGoods?: InputMaybe<Scalars['Boolean']['input']>;
  /** Признак регистрации «торговля маркированными товарами». */
  saleMarking?: InputMaybe<Scalars['Boolean']['input']>;
  status: OrderFiscalKktStatus;
};

export type OrderFiscalManualBankReferenceInput = {
  rrn: Scalars['String']['input'];
  terminalTransactionId: Scalars['String']['input'];
};

export type OrderFiscalOperation = {
  __typename?: 'OrderFiscalOperation';
  acquiring_mode: OrderFiscalAcquiringMode;
  bank_payment_status?: Maybe<OrderFiscalBankPaymentStatus>;
  /** Наличная часть расчёта в копейках: при отмене её отдаёт клиенту администратор. */
  cash_amount: Scalars['Int']['output'];
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  failed_at?: Maybe<Scalars['DateTime']['output']>;
  failure_kind?: Maybe<OrderFiscalFailureKind>;
  fiscal_document_number?: Maybe<Scalars['String']['output']>;
  fiscal_document_sign?: Maybe<Scalars['String']['output']>;
  fiscal_drive_number_masked?: Maybe<Scalars['String']['output']>;
  fiscalized_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  kkm_command_status?: Maybe<OrderFiscalKkmCommandStatus>;
  location_id: Scalars['ID']['output'];
  operation_type: OrderFiscalOperationType;
  order_id: Scalars['ID']['output'];
  organization_id: Scalars['ID']['output'];
  payment_captured_at?: Maybe<Scalars['DateTime']['output']>;
  prepared_at: Scalars['DateTime']['output'];
  /** Чек вышел, но ФН не прочитан: операцию закрыл сотрудник, реквизиты подтянутся из ФН. */
  receipt_confirmed_at?: Maybe<Scalars['DateTime']['output']>;
  receipt_kind?: Maybe<OrderFiscalReceiptKind>;
  receipt_number?: Maybe<Scalars['Int']['output']>;
  receipt_url?: Maybe<Scalars['String']['output']>;
  reconciliation_required_at?: Maybe<Scalars['DateTime']['output']>;
  refund_id?: Maybe<Scalars['ID']['output']>;
  /** IdCommand начатого возврата на карту по отменённому платежу. */
  return_command_id?: Maybe<Scalars['String']['output']>;
  return_started_at?: Maybe<Scalars['DateTime']['output']>;
  shift_number?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: OrderFiscalOperationStatus;
  timezone: Scalars['String']['output'];
  warning_code?: Maybe<Scalars['String']['output']>;
  workstation: OrderFiscalWorkstation;
};

export type OrderFiscalOperationIdentityInput = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  idCommand: Scalars['String']['input'];
  kktDeviceId?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  payloadHash: Scalars['String']['input'];
};

export enum OrderFiscalOperationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PaymentCaptured = 'PAYMENT_CAPTURED',
  PaymentCapturedUnfiscalized = 'PAYMENT_CAPTURED_UNFISCALIZED',
  Prepared = 'PREPARED',
  ReconciliationRequired = 'RECONCILIATION_REQUIRED',
  Started = 'STARTED'
}

export enum OrderFiscalOperationType {
  Refund = 'REFUND',
  Settlement = 'SETTLEMENT'
}

export type OrderFiscalOperationalStatus = {
  __typename?: 'OrderFiscalOperationalStatus';
  browser_workstation_id?: Maybe<Scalars['ID']['output']>;
  cashier_display_name?: Maybe<Scalars['String']['output']>;
  expected_kkt_device_id?: Maybe<Scalars['String']['output']>;
  fiscalization_enabled: Scalars['Boolean']['output'];
  location_closes_at?: Maybe<Scalars['DateTime']['output']>;
  pause_reason?: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  paused_at?: Maybe<Scalars['DateTime']['output']>;
  shifts_enabled: Scalars['Boolean']['output'];
  workstation_binding: OrderFiscalWorkstationBinding;
};

export enum OrderFiscalPaymentMethod {
  FullPayment = 'FULL_PAYMENT'
}

/** Чем терминал возвращает деньги по отменённому платежу. */
export enum OrderFiscalPaymentReturnCommand {
  /** Та же смена: отмена по карте. */
  Cancel = 'CANCEL',
  /** После смены: возврат на карту. */
  Return = 'RETURN'
}

export type OrderFiscalPaymentReturnExecution = {
  __typename?: 'OrderFiscalPaymentReturnExecution';
  /** Карточная часть отменённого платежа в копейках. */
  amount: Scalars['Int']['output'];
  command: OrderFiscalPaymentReturnCommand;
  id_command: Scalars['String']['output'];
  kkt_device_id: Scalars['String']['output'];
  operation: OrderFiscalOperation;
  terminal_device_id: Scalars['String']['output'];
};

export enum OrderFiscalPaymentReturnOutcome {
  NotCharged = 'NOT_CHARGED',
  /** Команда доказанно не выполнялась: возврат можно начать заново. */
  NotRun = 'NOT_RUN',
  Returned = 'RETURNED'
}

export enum OrderFiscalPaymentSubject {
  Commodity = 'COMMODITY',
  ExcisableCommodity = 'EXCISABLE_COMMODITY',
  MarkedCommodity = 'MARKED_COMMODITY',
  MarkedExcisableCommodity = 'MARKED_EXCISABLE_COMMODITY',
  Service = 'SERVICE'
}

export type OrderFiscalReceiptContact = {
  __typename?: 'OrderFiscalReceiptContact';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type OrderFiscalReceiptContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OrderFiscalReceiptItem = {
  __typename?: 'OrderFiscalReceiptItem';
  amount: Scalars['Int']['output'];
  marking_code?: Maybe<Scalars['String']['output']>;
  /** Строка заказа; в замороженном плане чека ключ называется `sale_line_id`. */
  order_line_id: Scalars['ID']['output'];
  payment_method: OrderFiscalPaymentMethod;
  payment_subject: OrderFiscalPaymentSubject;
  position: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  unit_price: Scalars['Int']['output'];
  vat_rate: OrderFiscalVatRate;
};

/** Каким документом допечатывается непробитый чек. */
export enum OrderFiscalReceiptKind {
  Correction = 'CORRECTION',
  Regular = 'REGULAR'
}

export type OrderFiscalReceiptPayment = {
  __typename?: 'OrderFiscalReceiptPayment';
  amount: Scalars['Int']['output'];
  change_amount: Scalars['Int']['output'];
  execution_order: Scalars['Int']['output'];
  method: OrderPaymentMethod;
  tendered_amount?: Maybe<Scalars['Int']['output']>;
  use_acquiring: Scalars['Boolean']['output'];
};

export type OrderFiscalReceiptPlan = {
  __typename?: 'OrderFiscalReceiptPlan';
  advance_amount: Scalars['Int']['output'];
  cashier_name: Scalars['String']['output'];
  contact: OrderFiscalReceiptContact;
  currency: OrderCurrency;
  items: Array<OrderFiscalReceiptItem>;
  loyalty_points: Scalars['Int']['output'];
  operation_type: OrderFiscalOperationType;
  payments: Array<OrderFiscalReceiptPayment>;
  schema_version: Scalars['Int']['output'];
  taxation_system: OrderFiscalTaxationSystem;
  total_amount: Scalars['Int']['output'];
};

export enum OrderFiscalReceiptState {
  Failed = 'FAILED',
  Issued = 'ISSUED',
  None = 'NONE',
  Pending = 'PENDING'
}

export enum OrderFiscalRecoveryAction {
  /** Неясный исход оплаты картой: отменить платёж на терминале. */
  CancelPayment = 'CANCEL_PAYMENT',
  None = 'NONE',
  PollResult = 'POLL_RESULT',
  PrintReceipt = 'PRINT_RECEIPT',
  /** Неясный исход чека: прочитать документы ФН и, если чека нет, напечатать. */
  ResolveReceipt = 'RESOLVE_RECEIPT',
  StartPayment = 'START_PAYMENT'
}

export type OrderFiscalRefundExecution = {
  __typename?: 'OrderFiscalRefundExecution';
  execution_target: OrderFiscalExecutionTarget;
  /** С какого номера ФД читать документы накопителя: только пока чек операции ищется. */
  fiscal_scan_from?: Maybe<Scalars['Int']['output']>;
  id_command: Scalars['String']['output'];
  next_action: OrderFiscalRecoveryAction;
  operation: OrderFiscalOperation;
  payload_hash: Scalars['String']['output'];
  /** Каким документом печатать чек: обычным или, после закрытия смены расчёта, чеком коррекции. */
  receipt_kind: OrderFiscalReceiptKind;
  receipt_plan: OrderFiscalRefundReceiptPlan;
  /** Накопитель операции доступен на кассе локации; false — ФН заменён, чек печатается заново. */
  same_fiscal_drive?: Maybe<Scalars['Boolean']['output']>;
  /** Момент расчёта: дата основания чека коррекции. */
  settled_at: Scalars['DateTime']['output'];
};

export type OrderFiscalRefundMutationResult = {
  __typename?: 'OrderFiscalRefundMutationResult';
  execution: OrderFiscalRefundExecution;
  order: Order;
};

export type OrderFiscalRefundPayment = {
  __typename?: 'OrderFiscalRefundPayment';
  amount: Scalars['Int']['output'];
  execution_order: Scalars['Int']['output'];
  method: OrderPaymentMethod;
  original_rrn?: Maybe<Scalars['String']['output']>;
  original_terminal_transaction_id?: Maybe<Scalars['String']['output']>;
  payment_id: Scalars['ID']['output'];
  use_acquiring: Scalars['Boolean']['output'];
};

export type OrderFiscalRefundReceiptPlan = {
  __typename?: 'OrderFiscalRefundReceiptPlan';
  advance_amount: Scalars['Int']['output'];
  cashier_name: Scalars['String']['output'];
  currency: OrderCurrency;
  items: Array<OrderFiscalReceiptItem>;
  operation_type: OrderFiscalOperationType;
  payments: Array<OrderFiscalRefundPayment>;
  schema_version: Scalars['Int']['output'];
  taxation_system: OrderFiscalTaxationSystem;
  total_amount: Scalars['Int']['output'];
};

export type OrderFiscalRefundResultInput = {
  bank?: InputMaybe<OrderFiscalBankResultInput>;
  commandStatus: OrderFiscalKkmCommandStatus;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fiscal?: InputMaybe<OrderFiscalDocumentResultInput>;
  /** Ответ ККТ на RegisterCheck: по нему сервер доказывает, что документ не создан. */
  kkm?: InputMaybe<OrderFiscalKkmResponseInput>;
  outcome: OrderFiscalRefundResultOutcome;
  warningCode?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderFiscalRefundResultOutcome {
  Ambiguous = 'AMBIGUOUS',
  Fiscalized = 'FISCALIZED',
  RefundCompleted = 'REFUND_COMPLETED',
  RefundCompletedUnfiscalized = 'REFUND_COMPLETED_UNFISCALIZED'
}

export type OrderFiscalSettlementExecution = {
  __typename?: 'OrderFiscalSettlementExecution';
  execution_target: OrderFiscalExecutionTarget;
  /** С какого номера ФД читать документы накопителя: только пока чек операции ищется. */
  fiscal_scan_from?: Maybe<Scalars['Int']['output']>;
  id_command: Scalars['String']['output'];
  next_action: OrderFiscalRecoveryAction;
  operation: OrderFiscalOperation;
  payload_hash: Scalars['String']['output'];
  /** Каким документом печатать чек: обычным или, после закрытия смены расчёта, чеком коррекции. */
  receipt_kind: OrderFiscalReceiptKind;
  receipt_plan: OrderFiscalReceiptPlan;
  /** Накопитель операции доступен на кассе локации; false — ФН заменён, чек печатается заново. */
  same_fiscal_drive?: Maybe<Scalars['Boolean']['output']>;
  /** Момент расчёта: дата основания чека коррекции. */
  settled_at: Scalars['DateTime']['output'];
  /** UniversalID принятой оплаты картой: нужен терминалу для отмены платежа. */
  terminal_transaction_id?: Maybe<Scalars['String']['output']>;
};

export type OrderFiscalSettlementMutationResult = {
  __typename?: 'OrderFiscalSettlementMutationResult';
  execution: OrderFiscalSettlementExecution;
  order: Order;
};

export type OrderFiscalSettlementResultInput = {
  bank?: InputMaybe<OrderFiscalBankResultInput>;
  commandStatus: OrderFiscalKkmCommandStatus;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fiscal?: InputMaybe<OrderFiscalDocumentResultInput>;
  /** Ответ ККТ на RegisterCheck: по нему сервер доказывает, что документ не создан. */
  kkm?: InputMaybe<OrderFiscalKkmResponseInput>;
  outcome: OrderFiscalSettlementResultOutcome;
  /** Коды чека, которые ГИС МТ не считает нашими; старый SPA поля не шлёт. */
  unownedMarkingCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  warningCode?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderFiscalSettlementResultOutcome {
  Ambiguous = 'AMBIGUOUS',
  Fiscalized = 'FISCALIZED',
  PaymentCaptured = 'PAYMENT_CAPTURED',
  PaymentCapturedUnfiscalized = 'PAYMENT_CAPTURED_UNFISCALIZED'
}

export enum OrderFiscalTaxationSystem {
  UsnIncome = 'USN_INCOME'
}

export enum OrderFiscalTerminalStatus {
  Ready = 'READY',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN'
}

export type OrderFiscalTerminalVerificationInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  paymentKind?: InputMaybe<Scalars['String']['input']>;
  status: OrderFiscalTerminalStatus;
};

export enum OrderFiscalVatRate {
  None = 'NONE'
}

export type OrderFiscalWorkstation = {
  __typename?: 'OrderFiscalWorkstation';
  activated_at?: Maybe<Scalars['DateTime']['output']>;
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  deletable: Scalars['Boolean']['output'];
  fn_number_masked?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kkmserver_version?: Maybe<Scalars['String']['output']>;
  kkt_model_masked?: Maybe<Scalars['String']['output']>;
  kkt_number_masked?: Maybe<Scalars['String']['output']>;
  kkt_status: OrderFiscalKktStatus;
  kkt_verified_at?: Maybe<Scalars['DateTime']['output']>;
  location_id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['ID']['output'];
  setting: OrderFiscalizationSetting;
  terminal_name_masked?: Maybe<Scalars['String']['output']>;
  terminal_number_masked?: Maybe<Scalars['String']['output']>;
  terminal_status: OrderFiscalTerminalStatus;
  terminal_verified_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
  workstation_id: Scalars['ID']['output'];
};

export enum OrderFiscalWorkstationBinding {
  Bound = 'BOUND',
  NotBound = 'NOT_BOUND'
}

export enum OrderFiscalizationProvider {
  KkmServer = 'KKM_SERVER'
}

export type OrderFiscalizationReadiness = {
  __typename?: 'OrderFiscalizationReadiness';
  active_workstation?: Maybe<OrderFiscalWorkstation>;
  effective_enabled: Scalars['Boolean']['output'];
  /** @deprecated Всегда true; используйте setting_enabled и effective_enabled. */
  global_enabled: Scalars['Boolean']['output'];
  kkt_status: OrderFiscalKktStatus;
  last_workstation?: Maybe<OrderFiscalWorkstation>;
  setting?: Maybe<OrderFiscalizationSetting>;
  setting_enabled: Scalars['Boolean']['output'];
  terminal_status: OrderFiscalTerminalStatus;
};

export type OrderFiscalizationSetting = {
  __typename?: 'OrderFiscalizationSetting';
  cashier_display_name?: Maybe<Scalars['String']['output']>;
  cashier_last_name?: Maybe<Scalars['String']['output']>;
  cashier_position?: Maybe<Scalars['String']['output']>;
  config_version: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  expected_kkt_inn_masked?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location_id: Scalars['ID']['output'];
  organization_id: Scalars['ID']['output'];
  payment_method: OrderFiscalPaymentMethod;
  payment_subject: OrderFiscalPaymentSubject;
  provider: OrderFiscalizationProvider;
  shifts_enabled: Scalars['Boolean']['output'];
  taxation_system: OrderFiscalTaxationSystem;
  updated_at: Scalars['DateTime']['output'];
  vat_rate: OrderFiscalVatRate;
};

export type OrderInvoiceState = {
  __typename?: 'OrderInvoiceState';
  /** Действующий или оплаченный счёт заказа. */
  invoice?: Maybe<Invoice>;
  /** Проверки выставления: спрашивает только форма выставления счёта. */
  issue_availability: InvoiceIssueAvailability;
};

export type OrderLine = {
  __typename?: 'OrderLine';
  booking_id?: Maybe<Scalars['ID']['output']>;
  /** Позиция каталога: услуга или товар. */
  catalog_item_id?: Maybe<Scalars['ID']['output']>;
  catalog_tariff_id?: Maybe<Scalars['ID']['output']>;
  discount_amount: Scalars['Int']['output'];
  duration_minutes_snapshot?: Maybe<Scalars['Int']['output']>;
  gross_amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  line_type: OrderLineType;
  net_amount: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  refunded_amount: Scalars['Int']['output'];
  title_snapshot: Scalars['String']['output'];
  unit_price: Scalars['Int']['output'];
};

export enum OrderLineType {
  GiftCertificate = 'GIFT_CERTIFICATE',
  Product = 'PRODUCT',
  Service = 'SERVICE'
}

export type OrderLoyaltyContext = {
  __typename?: 'OrderLoyaltyContext';
  available_balance: Scalars['Int']['output'];
  max_redeemable_points: Scalars['Int']['output'];
};

export type OrderMoneyPart = {
  __typename?: 'OrderMoneyPart';
  /** Зачтено в заказ этой частью. */
  amount: Scalars['Int']['output'];
  captured_at?: Maybe<Scalars['DateTime']['output']>;
  captured_by_employee?: Maybe<OrderActor>;
  /** Идентификатор денежной части платежа; он же идёт в RefundPaymentAllocationInput.moneyPartId. */
  id: Scalars['ID']['output'];
  method: PaymentMoneyPartMethod;
  payment_id: Scalars['ID']['output'];
  /** Остаток для возврата заказа. */
  refundable_amount: Scalars['Int']['output'];
};

export enum OrderPaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  LegacyUnknown = 'LEGACY_UNKNOWN',
  Online = 'ONLINE'
}

export type OrderRefund = {
  __typename?: 'OrderRefund';
  amount: Scalars['Int']['output'];
  completed_at: Scalars['DateTime']['output'];
  created_by_employee?: Maybe<OrderActor>;
  from_previous_shift: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lines: Array<OrderRefundLine>;
  money_parts: Array<OrderRefundMoneyPart>;
  order: Order;
  reason: Scalars['String']['output'];
  reason_code?: Maybe<Scalars['String']['output']>;
  status: OrderRefundStatus;
};

export type OrderRefundApproval = {
  __typename?: 'OrderRefundApproval';
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind: OrderRefundApprovalKind;
  location: Location;
  location_id: Scalars['ID']['output'];
  order: Order;
  order_id: Scalars['ID']['output'];
  request_comment?: Maybe<Scalars['String']['output']>;
  requested_at: Scalars['DateTime']['output'];
  requested_by_employee: OrderActor;
  resolve_comment?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  resolved_by_employee?: Maybe<OrderActor>;
  status: OrderRefundApprovalStatus;
  /** Сумма возврата переводом в копейках. */
  transfer_amount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of OrderRefundApproval edges. */
export type OrderRefundApprovalConnection = {
  __typename?: 'OrderRefundApprovalConnection';
  /** A list of OrderRefundApproval edges. */
  edges: Array<OrderRefundApprovalEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type OrderRefundApproval and a cursor. */
export type OrderRefundApprovalEdge = {
  __typename?: 'OrderRefundApprovalEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The OrderRefundApproval node. */
  node: OrderRefundApproval;
};

/** Как вернуть деньги по запросу на возврат. */
export enum OrderRefundApprovalKind {
  /** Возврат проводит касса, управляющий только разрешает его. */
  Terminal = 'TERMINAL',
  /** Терминал вернуть не может: деньги переводят по заявлению клиента. */
  Transfer = 'TRANSFER'
}

export enum OrderRefundApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export type OrderRefundContext = {
  __typename?: 'OrderRefundContext';
  allowed_payment_methods: Array<OrderPaymentMethod>;
  approval_expires_at?: Maybe<Scalars['DateTime']['output']>;
  approval_required: Scalars['Boolean']['output'];
  approval_status?: Maybe<OrderRefundApprovalStatus>;
  cashier_display_name?: Maybe<Scalars['String']['output']>;
  /** Привязанная ККТ локации: handshake без неё не выберет кассу, когда их несколько. */
  expected_kkt_device_id?: Maybe<Scalars['String']['output']>;
  fiscalization_required: Scalars['Boolean']['output'];
  /** Заказ проведён до фискализации: реквизиты карточной оплаты придётся ввести вручную. */
  manual_bank_reference_required: Scalars['Boolean']['output'];
  online_payments: Array<OrderRefundOnlinePayment>;
  online_refunds: Array<PaymentRefund>;
  shift_blocker_reason?: Maybe<ShiftSettlementBlockerReason>;
  shift_expires_at?: Maybe<Scalars['DateTime']['output']>;
  shift_required?: Maybe<Scalars['Boolean']['output']>;
  shift_state?: Maybe<ShiftSettlementState>;
};

export type OrderRefundLine = {
  __typename?: 'OrderRefundLine';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  order_line: OrderLine;
  order_line_id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type OrderRefundMoneyPart = {
  __typename?: 'OrderRefundMoneyPart';
  amount: Scalars['Int']['output'];
  method: PaymentMoneyPartMethod;
  money_part_id: Scalars['ID']['output'];
};

export type OrderRefundOnlinePayment = {
  __typename?: 'OrderRefundOnlinePayment';
  fiscal_scheme: PaymentFiscalScheme;
  money_part_id: Scalars['ID']['output'];
};

export enum OrderRefundStatus {
  Completed = 'COMPLETED'
}

export type OrderRefundTransferInput = {
  orderLineIds: Array<Scalars['ID']['input']>;
  paymentAllocations: Array<RefundPaymentAllocationInput>;
  reason: Scalars['String']['input'];
};

export enum OrderSource {
  BookingCheckout = 'BOOKING_CHECKOUT',
  LegacyImported = 'LEGACY_IMPORTED',
  Shop = 'SHOP',
  WorkOrder = 'WORK_ORDER'
}

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Paid = 'PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Refunded = 'REFUNDED'
}

export type Organization = {
  __typename?: 'Organization';
  alias?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency: OrganizationCurrency;
  domain?: Maybe<Scalars['String']['output']>;
  enabled_modules: Array<OrganizationModule>;
  has_locations: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Дополнения, которые организация хоть раз подключала, включая отключённые. */
  known_add_ons: Array<OrganizationModule>;
  locations?: Maybe<Array<Location>>;
  /** Как называть ресурсы записи на экране. */
  resource_term: ResourceTerm;
  sphere_id?: Maybe<OrganizationSphere>;
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** Дополнение, которое организация подключает сама на странице «Дополнения». */
export type OrganizationAddOn = {
  __typename?: 'OrganizationAddOn';
  connected_at?: Maybe<Scalars['DateTime']['output']>;
  module: OrganizationModule;
  status: OrganizationAddOnStatus;
};

export enum OrganizationAddOnStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED'
}

export enum OrganizationCurrency {
  Rub = 'RUB'
}

export enum OrganizationModule {
  Analytics = 'ANALYTICS',
  Booking = 'BOOKING',
  Clients = 'CLIENTS',
  Invoices = 'INVOICES',
  Loyalty = 'LOYALTY',
  Marketing = 'MARKETING',
  Messenger = 'MESSENGER',
  Orders = 'ORDERS',
  Radio = 'RADIO',
  Shop = 'SHOP',
  Sop = 'SOP',
  TireService = 'TIRE_SERVICE',
  TireStorage = 'TIRE_STORAGE'
}

export enum OrganizationSphere {
  SimraceClub = 'SIMRACE_CLUB',
  TireFitting = 'TIRE_FITTING'
}

/** Как пользователь попадёт в организацию из переключателя. */
export enum OrganizationSwitchAccess {
  /** Работает в организации: обычное переключение. */
  Member = 'MEMBER',
  /** Работающего владельца нет, входить не под кем. */
  NoOwner = 'NO_OWNER',
  /** Суперюзер входит под самым ранним работающим владельцем. */
  OwnerImpersonation = 'OWNER_IMPERSONATION'
}

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int']['output'];
};

export type PageMeta = {
  __typename?: 'PageMeta';
  current_page: Scalars['Int']['output'];
  has_more: Scalars['Boolean']['output'];
  last_page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaymentAdvanceState = {
  __typename?: 'PaymentAdvanceState';
  amount: Scalars['Money']['output'];
  available_amount: Scalars['Money']['output'];
  created_at: Scalars['DateTime']['output'];
  fiscal_scheme: PaymentFiscalScheme;
  id: Scalars['ID']['output'];
  receipt_status: PaymentReceiptStatus;
};

export enum PaymentApplicationStatus {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type PaymentAttempt = {
  __typename?: 'PaymentAttempt';
  created_at: Scalars['DateTime']['output'];
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  legacy_fiscal_operation_id?: Maybe<Scalars['ID']['output']>;
  sent_at?: Maybe<Scalars['DateTime']['output']>;
  status: PaymentAttemptStatus;
};

export enum PaymentAttemptStatus {
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Prepared = 'PREPARED',
  Sent = 'SENT',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export enum PaymentAttentionReason {
  AdvanceOverdue = 'ADVANCE_OVERDUE',
  AdvanceRejected = 'ADVANCE_REJECTED',
  AdvanceRemainder = 'ADVANCE_REMAINDER',
  ApplicationFailed = 'APPLICATION_FAILED',
  CallbackUnprocessed = 'CALLBACK_UNPROCESSED',
  LinkDeactivationOverdue = 'LINK_DEACTIVATION_OVERDUE',
  LinkIssueMismatch = 'LINK_ISSUE_MISMATCH',
  LinkIssueUnknown = 'LINK_ISSUE_UNKNOWN',
  MoneyUnknown = 'MONEY_UNKNOWN',
  ProviderReversed = 'PROVIDER_REVERSED',
  ProviderSuspended = 'PROVIDER_SUSPENDED',
  ReceiptFailed = 'RECEIPT_FAILED',
  ReceiptOverdue = 'RECEIPT_OVERDUE',
  ReceiptUnknown = 'RECEIPT_UNKNOWN',
  RefundFailed = 'REFUND_FAILED',
  RefundUnknown = 'REFUND_UNKNOWN'
}

export enum PaymentAvailableAction {
  AttachRefundRequest = 'ATTACH_REFUND_REQUEST',
  CheckStatus = 'CHECK_STATUS',
  CopyLink = 'COPY_LINK',
  KkmCancel = 'KKM_CANCEL',
  KkmForceClose = 'KKM_FORCE_CLOSE',
  /** Вернуть деньги по платежу, отменённому без проверки на терминале. */
  KkmReturn = 'KKM_RETURN',
  RefundAdvance = 'REFUND_ADVANCE'
}

export enum PaymentBlockScope {
  None = 'NONE',
  Order = 'ORDER'
}

export enum PaymentConfirmationSource {
  BankStatement = 'BANK_STATEMENT',
  LegacyImport = 'LEGACY_IMPORT',
  OrdersFinalizer = 'ORDERS_FINALIZER',
  ProviderCallback = 'PROVIDER_CALLBACK',
  ProviderLookup = 'PROVIDER_LOOKUP',
  Terminal = 'TERMINAL'
}

export enum PaymentConnectionMode {
  Live = 'LIVE',
  Test = 'TEST'
}

export enum PaymentConnectionStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED'
}

export enum PaymentCurrency {
  Rub = 'RUB'
}

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  /** Сотрудник, принявший платёж. */
  actor_title?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Money']['output'];
  application_status?: Maybe<PaymentApplicationStatus>;
  attempts: Array<PaymentAttempt>;
  attention_reasons: Array<PaymentAttentionReason>;
  available_actions: Array<PaymentAvailableAction>;
  block_scope: PaymentBlockScope;
  /** Когда получены деньги. */
  captured_at?: Maybe<Scalars['DateTime']['output']>;
  confirmed_amount: Scalars['Money']['output'];
  created_at: Scalars['DateTime']['output'];
  currency: PaymentCurrency;
  events: Array<PaymentEvent>;
  fiscal_operation_id?: Maybe<Scalars['ID']['output']>;
  fiscal_scheme?: Maybe<PaymentFiscalScheme>;
  id: Scalars['ID']['output'];
  kind: PaymentJournalKind;
  links: Array<PaymentLinkState>;
  location_id: Scalars['ID']['output'];
  location_title: Scalars['String']['output'];
  mode?: Maybe<PaymentConnectionMode>;
  money_parts: Array<PaymentMoneyPart>;
  order_id?: Maybe<Scalars['ID']['output']>;
  provider: PaymentProvider;
  receipts: Array<PaymentReceipt>;
  refundable_amount: Scalars['Money']['output'];
  refunds: Array<PaymentRefund>;
  shift_id?: Maybe<Scalars['ID']['output']>;
  source_id: Scalars['ID']['output'];
  source_summary?: Maybe<PaymentSourceSummary>;
  source_type: PaymentSourceType;
  status?: Maybe<PaymentStatus>;
  timezone: Scalars['String']['output'];
  transfer_details?: Maybe<PaymentTransferDetails>;
};

export type PaymentEvent = {
  __typename?: 'PaymentEvent';
  amount?: Maybe<Scalars['Money']['output']>;
  created_at: Scalars['DateTime']['output'];
  from_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Текст кассы об отказе операции события. */
  message?: Maybe<Scalars['String']['output']>;
  origin: PaymentEventOrigin;
  reason?: Maybe<Scalars['String']['output']>;
  reason_code?: Maybe<Scalars['String']['output']>;
  to_status?: Maybe<Scalars['String']['output']>;
  type: PaymentEventType;
};

export enum PaymentEventOrigin {
  LegacyImport = 'LEGACY_IMPORT',
  Operator = 'OPERATOR',
  ProviderCallback = 'PROVIDER_CALLBACK',
  ProviderLookup = 'PROVIDER_LOOKUP',
  System = 'SYSTEM'
}

export enum PaymentEventType {
  Created = 'CREATED',
  OperatorAction = 'OPERATOR_ACTION',
  ProviderEvidence = 'PROVIDER_EVIDENCE',
  StatusChanged = 'STATUS_CHANGED'
}

export enum PaymentFiscalScheme {
  AgentPrepayment = 'AGENT_PREPAYMENT',
  OwnSingleReceipt = 'OWN_SINGLE_RECEIPT',
  OwnTwoReceipts = 'OWN_TWO_RECEIPTS'
}

export enum PaymentHashAlgorithm {
  Md5 = 'MD5',
  Ripemd160 = 'RIPEMD160',
  Sha1 = 'SHA1',
  Sha256 = 'SHA256',
  Sha384 = 'SHA384',
  Sha512 = 'SHA512'
}

export type PaymentJournalEntry = {
  __typename?: 'PaymentJournalEntry';
  /** Сотрудник, принявший платёж или оформивший возврат. */
  actor_title?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Money']['output'];
  application_status?: Maybe<PaymentApplicationStatus>;
  attention_reasons: Array<PaymentAttentionReason>;
  block_scope: PaymentBlockScope;
  confirmed_amount: Scalars['Money']['output'];
  /** Время строки: получение денег или создание возврата. */
  created_at: Scalars['DateTime']['output'];
  currency: PaymentCurrency;
  /** Стадия отказа кассы, пока деньги или чек строки не прошли. */
  failure_kind?: Maybe<OrderFiscalFailureKind>;
  /** Текст кассы об отказе. */
  failure_message?: Maybe<Scalars['String']['output']>;
  /** Код причины отказа без операции кассы, например у Robokassa. */
  failure_reason_code?: Maybe<Scalars['String']['output']>;
  /** Схема чеков онлайн-оплаты: кто пробил чек Robokassa — агент или своя касса бизнеса. */
  fiscal_scheme?: Maybe<PaymentFiscalScheme>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: PaymentJournalKind;
  link_status?: Maybe<PaymentLinkStatus>;
  location_id: Scalars['ID']['output'];
  location_title: Scalars['String']['output'];
  methods: Array<PaymentMoneyPartMethod>;
  money_status?: Maybe<PaymentJournalMoneyStatus>;
  /** Когда получены деньги платежа; строка возврата по нему называет исходный платёж. */
  payment_captured_at?: Maybe<Scalars['DateTime']['output']>;
  payment_id: Scalars['ID']['output'];
  provider: PaymentProvider;
  /** Причина возврата. */
  reason?: Maybe<Scalars['String']['output']>;
  receipt_fd_number?: Maybe<Scalars['String']['output']>;
  /** Кем пробит чек строки. */
  receipt_issuer?: Maybe<PaymentReceiptIssuer>;
  receipt_operation: PaymentReceiptOperation;
  receipt_settlement_method: ReceiptSettlementMethod;
  /** Чек строки. `receipt_status = null` — чека в Mors нет: оплата прошла без кассы. */
  receipt_status?: Maybe<PaymentReceiptStatus>;
  /** Сколько чеков относится к строке: у аванса после зачёта их два. */
  receipts_count: Scalars['Int']['output'];
  source_id: Scalars['ID']['output'];
  source_summary?: Maybe<PaymentSourceSummary>;
  source_type: PaymentSourceType;
  timezone: Scalars['String']['output'];
  /** Банковский перевод: номер п/п, дата и счёт исходного поступления. */
  transfer_details?: Maybe<PaymentTransferDetails>;
};

/** A paginated list of PaymentJournalEntry edges. */
export type PaymentJournalEntryConnection = {
  __typename?: 'PaymentJournalEntryConnection';
  /** A list of PaymentJournalEntry edges. */
  edges: Array<PaymentJournalEntryEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type PaymentJournalEntry and a cursor. */
export type PaymentJournalEntryEdge = {
  __typename?: 'PaymentJournalEntryEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The PaymentJournalEntry node. */
  node: PaymentJournalEntry;
};

export type PaymentJournalFilter = {
  attention?: InputMaybe<Scalars['Boolean']['input']>;
  /** Платежи и возвраты по заказам и записям клиента во всей организации. */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  kind?: InputMaybe<PaymentJournalKind>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  moneyStatus?: InputMaybe<PaymentJournalMoneyStatus>;
  provider?: InputMaybe<PaymentProvider>;
  receiptStatus?: InputMaybe<PaymentReceiptStatus>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Платежи и возвраты конкретных оснований: заказа и его записи. */
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceType?: InputMaybe<PaymentSourceType>;
};

export enum PaymentJournalKind {
  Payment = 'PAYMENT',
  Refund = 'REFUND'
}

export enum PaymentJournalMoneyStatus {
  Accepted = 'ACCEPTED',
  Captured = 'CAPTURED',
  Failed = 'FAILED',
  PartiallyCaptured = 'PARTIALLY_CAPTURED',
  Pending = 'PENDING',
  Reserved = 'RESERVED',
  Sent = 'SENT',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type PaymentLinkAvailability = {
  __typename?: 'PaymentLinkAvailability';
  available: Scalars['Boolean']['output'];
  reason_code?: Maybe<Scalars['String']['output']>;
};

/** Доступный диалог клиента для отправки ссылки на оплату. */
export type PaymentLinkSendTarget = {
  __typename?: 'PaymentLinkSendTarget';
  conversation_id: Scalars['ID']['output'];
  provider: MessengerProvider;
};

export type PaymentLinkState = {
  __typename?: 'PaymentLinkState';
  amount: Scalars['Money']['output'];
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inv_id: Scalars['String']['output'];
  payment_id: Scalars['ID']['output'];
  status: PaymentLinkStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export enum PaymentLinkStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Deactivated = 'DEACTIVATED',
  Deactivating = 'DEACTIVATING',
  Expired = 'EXPIRED',
  IssueFailed = 'ISSUE_FAILED',
  IssueUnknown = 'ISSUE_UNKNOWN',
  Issuing = 'ISSUING',
  Paid = 'PAID'
}

export type PaymentMoneyPart = {
  __typename?: 'PaymentMoneyPart';
  confirmation_source?: Maybe<PaymentConfirmationSource>;
  confirmed_amount: Scalars['Money']['output'];
  id: Scalars['ID']['output'];
  method: PaymentMoneyPartMethod;
  planned_amount: Scalars['Money']['output'];
  status: PaymentMoneyPartStatus;
};

export enum PaymentMoneyPartMethod {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  Online = 'ONLINE',
  Unknown = 'UNKNOWN'
}

export enum PaymentMoneyPartStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Planned = 'PLANNED',
  Unknown = 'UNKNOWN'
}

export enum PaymentProvider {
  BankTransfer = 'BANK_TRANSFER',
  Kkmserver = 'KKMSERVER',
  Manual = 'MANUAL',
  Robokassa = 'ROBOKASSA'
}

export enum PaymentReadinessReason {
  ConnectionDisabled = 'CONNECTION_DISABLED',
  FinalReceiptLocations = 'FINAL_RECEIPT_LOCATIONS',
  FiscalSchemeUnconfirmed = 'FISCAL_SCHEME_UNCONFIRMED',
  IncomeReceiptsUnavailable = 'INCOME_RECEIPTS_UNAVAILABLE',
  PaymentCredentialsMissing = 'PAYMENT_CREDENTIALS_MISSING',
  PaymentSettingsIncomplete = 'PAYMENT_SETTINGS_INCOMPLETE',
  RefundCredentialsMissing = 'REFUND_CREDENTIALS_MISSING',
  RefundTestMode = 'REFUND_TEST_MODE',
  VatRatesUnsupported = 'VAT_RATES_UNSUPPORTED'
}

export type PaymentReceipt = {
  __typename?: 'PaymentReceipt';
  created_at: Scalars['DateTime']['output'];
  fd_number?: Maybe<Scalars['String']['output']>;
  fiscal_at?: Maybe<Scalars['DateTime']['output']>;
  fiscal_sign?: Maybe<Scalars['String']['output']>;
  fn_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuer: PaymentReceiptIssuer;
  kkm_operation_id?: Maybe<Scalars['ID']['output']>;
  operation: PaymentReceiptOperation;
  provider: PaymentProvider;
  refund_id?: Maybe<Scalars['ID']['output']>;
  settlement_method: ReceiptSettlementMethod;
  status: PaymentReceiptStatus;
};

/** Кем пробит чек. */
export enum PaymentReceiptIssuer {
  LocationKkt = 'LOCATION_KKT',
  RobokassaAgent = 'ROBOKASSA_AGENT',
  RobokassaOwn = 'ROBOKASSA_OWN'
}

export type PaymentReceiptLocation = {
  __typename?: 'PaymentReceiptLocation';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum PaymentReceiptOperation {
  Income = 'INCOME',
  Refund = 'REFUND'
}

export enum PaymentReceiptStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN',
  Untracked = 'UNTRACKED'
}

export type PaymentRefund = {
  __typename?: 'PaymentRefund';
  /** Кто оформил возврат. */
  actor_title?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Money']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  legacy_fiscal_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Возврат заказа, к которому относятся эти деньги. */
  order_refund_id?: Maybe<Scalars['ID']['output']>;
  parts: Array<PaymentRefundPartView>;
  payment_id: Scalars['ID']['output'];
  provider: PaymentProvider;
  provider_request_id?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  shift_id?: Maybe<Scalars['ID']['output']>;
  status: PaymentRefundStatus;
  /** Возврат переводом: номер платёжного поручения и дата. */
  transfer_reference?: Maybe<Scalars['String']['output']>;
  transferred_on?: Maybe<Scalars['Date']['output']>;
};

/** Часть возврата по способу исходной части платежа. */
export type PaymentRefundPartView = {
  __typename?: 'PaymentRefundPartView';
  amount: Scalars['Money']['output'];
  method: PaymentMoneyPartMethod;
};

export enum PaymentRefundStatus {
  Accepted = 'ACCEPTED',
  Failed = 'FAILED',
  Reserved = 'RESERVED',
  Sent = 'SENT',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type PaymentSourceSummary = {
  __typename?: 'PaymentSourceSummary';
  customer_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export enum PaymentSourceType {
  Booking = 'BOOKING',
  Order = 'ORDER'
}

export enum PaymentStatus {
  Captured = 'CAPTURED',
  Failed = 'FAILED',
  PartiallyCaptured = 'PARTIALLY_CAPTURED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export enum PaymentTaxSystem {
  UsnIncome = 'USN_INCOME'
}

/** Поступление банковским переводом: платёжное поручение и счёт. */
export type PaymentTransferDetails = {
  __typename?: 'PaymentTransferDetails';
  invoice_number?: Maybe<Scalars['Int']['output']>;
  payment_order_number: Scalars['String']['output'];
  received_on: Scalars['Date']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Часть ФИО в справочнике имён. */
export enum PersonNameKind {
  First = 'FIRST',
  Last = 'LAST',
  Patronymic = 'PATRONYMIC'
}

/** Строка, разобранная на имя, отчество и фамилию. */
export type PersonNameSplit = {
  __typename?: 'PersonNameSplit';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  patronymic_name?: Maybe<Scalars['String']['output']>;
};

export type PersonNameSuggestion = {
  __typename?: 'PersonNameSuggestion';
  gender?: Maybe<ClientSex>;
  text: Scalars['String']['output'];
};

export type PersonNameSuggestions = {
  __typename?: 'PersonNameSuggestions';
  /** Частое имя или отчество, на которое похоже незнакомое слово. */
  correction?: Maybe<Scalars['String']['output']>;
  /** Частые записи с этим началом, от частых к редким. */
  items: Array<PersonNameSuggestion>;
  /** Только для FIRST: имя из 2–3 слов, разобранное по полям. */
  split?: Maybe<PersonNameSplit>;
};

/** Событие ленты штаба без данных клиента. */
export type PlatformActivityEvent = {
  __typename?: 'PlatformActivityEvent';
  amount?: Maybe<Scalars['Money']['output']>;
  booking_source?: Maybe<BookingPlatform>;
  /** Позиция для `before`; строки сортируются как лента: больше — новее. */
  cursor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: PlatformActivityKind;
  location?: Maybe<Location>;
  occurred_at: Scalars['DateTime']['output'];
  order_source?: Maybe<OrderSource>;
  organization: Organization;
  payment_provider?: Maybe<PaymentProvider>;
  /** Начало записи для BOOKING_CREATED. */
  scheduled_for?: Maybe<Scalars['DateTime']['output']>;
};

/** Вид события ленты штаба. */
export enum PlatformActivityKind {
  BookingCreated = 'BOOKING_CREATED',
  OrderCreated = 'ORDER_CREATED',
  OrderPaid = 'ORDER_PAID',
  PaymentCaptured = 'PAYMENT_CAPTURED',
  RefundCompleted = 'REFUND_COMPLETED'
}

export type PlatformBookingSourceSeries = {
  __typename?: 'PlatformBookingSourceSeries';
  source: BookingPlatform;
  total: Scalars['Int']['output'];
  values: Array<Scalars['Int']['output']>;
};

/** Записи (группы броней) по дате создания. */
export type PlatformBookingsMetric = {
  __typename?: 'PlatformBookingsMetric';
  by_source: Array<PlatformBookingSourceSeries>;
  /** Сумма прошлого периода по бакетам, выровнена с buckets. */
  previous: Array<Scalars['Int']['output']>;
  previous_total: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PlatformCountMetric = {
  __typename?: 'PlatformCountMetric';
  previous_total: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  values: Array<Scalars['Int']['output']>;
};

export type PlatformCreateEmployeeInput = {
  firstName: Scalars['String']['input'];
  hasAllLocationsAccess: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type PlatformCreateOrganizationInput = {
  domain: Scalars['String']['input'];
  modules?: InputMaybe<Array<OrganizationModule>>;
  title: Scalars['String']['input'];
};

export type PlatformImpersonationAction = {
  __typename?: 'PlatformImpersonationAction';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  operation_name: Scalars['String']['output'];
  operation_type: Scalars['String']['output'];
  root_fields: Array<Scalars['String']['output']>;
};

/** A paginated list of PlatformImpersonationAction edges. */
export type PlatformImpersonationActionConnection = {
  __typename?: 'PlatformImpersonationActionConnection';
  /** A list of PlatformImpersonationAction edges. */
  edges: Array<PlatformImpersonationActionEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type PlatformImpersonationAction and a cursor. */
export type PlatformImpersonationActionEdge = {
  __typename?: 'PlatformImpersonationActionEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The PlatformImpersonationAction node. */
  node: PlatformImpersonationAction;
};

export type PlatformImpersonationSession = {
  __typename?: 'PlatformImpersonationSession';
  actions: Array<PlatformImpersonationAction>;
  actions_count: Scalars['Int']['output'];
  end_reason?: Maybe<ImpersonationEndReason>;
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  impersonator: User;
  ip?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  reason?: Maybe<Scalars['String']['output']>;
  started_at: Scalars['DateTime']['output'];
  target_user: User;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of PlatformImpersonationSession edges. */
export type PlatformImpersonationSessionConnection = {
  __typename?: 'PlatformImpersonationSessionConnection';
  /** A list of PlatformImpersonationSession edges. */
  edges: Array<PlatformImpersonationSessionEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type PlatformImpersonationSession and a cursor. */
export type PlatformImpersonationSessionEdge = {
  __typename?: 'PlatformImpersonationSessionEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The PlatformImpersonationSession node. */
  node: PlatformImpersonationSession;
};

/** Сообщения мессенджеров: входящие и исходящие, без служебных. */
export type PlatformMessagesMetric = {
  __typename?: 'PlatformMessagesMetric';
  by_provider: Array<PlatformMessengerProviderSeries>;
  incoming_total: Scalars['Int']['output'];
  outgoing_total: Scalars['Int']['output'];
  previous: Array<Scalars['Int']['output']>;
  previous_total: Scalars['Int']['output'];
};

export type PlatformMessengerProviderSeries = {
  __typename?: 'PlatformMessengerProviderSeries';
  incoming: Scalars['Int']['output'];
  outgoing: Scalars['Int']['output'];
  provider: MessengerProvider;
  /** Входящие и исходящие вместе по бакетам. */
  values: Array<Scalars['Int']['output']>;
};

export type PlatformOrganizationRow = {
  __typename?: 'PlatformOrganizationRow';
  employee_count: Scalars['Int']['output'];
  locations: Array<Location>;
  organization: Organization;
  uses_default_modules: Scalars['Boolean']['output'];
};

/** A paginated list of PlatformOrganizationRow edges. */
export type PlatformOrganizationRowConnection = {
  __typename?: 'PlatformOrganizationRowConnection';
  /** A list of PlatformOrganizationRow edges. */
  edges: Array<PlatformOrganizationRowEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type PlatformOrganizationRow and a cursor. */
export type PlatformOrganizationRowEdge = {
  __typename?: 'PlatformOrganizationRowEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The PlatformOrganizationRow node. */
  node: PlatformOrganizationRow;
};

/** Записи одной организации по бакетам. */
export type PlatformOrganizationTrend = {
  __typename?: 'PlatformOrganizationTrend';
  organization: Organization;
  previous_total: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  values: Array<Scalars['Int']['output']>;
};

/** Главная штаба. Последний бакет незавершённый. */
export type PlatformOverview = {
  __typename?: 'PlatformOverview';
  bookings: PlatformBookingsMetric;
  buckets: Array<Scalars['String']['output']>;
  granularity: PlatformOverviewBucket;
  messages: PlatformMessagesMetric;
  new_clients: PlatformCountMetric;
  organizations: Array<PlatformOrganizationTrend>;
  turnover: PlatformTurnoverMetric;
};

/** Размер бакета графиков штаба: часы, дни или недели по московскому времени. */
export enum PlatformOverviewBucket {
  Day = 'DAY',
  Hour = 'HOUR',
  Week = 'WEEK'
}

/** Период главной штаба. */
export enum PlatformOverviewPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type PlatformPaymentProviderSeries = {
  __typename?: 'PlatformPaymentProviderSeries';
  provider: PaymentProvider;
  total: Scalars['Money']['output'];
  values: Array<Scalars['Money']['output']>;
};

/** Очередь воркеров: имя берётся из конфигурации воркеров. */
export type PlatformQueueStat = {
  __typename?: 'PlatformQueueStat';
  failed_last_day: Scalars['Int']['output'];
  oldest_pending_seconds?: Maybe<Scalars['Int']['output']>;
  pending: Scalars['Int']['output'];
  queue: Scalars['String']['output'];
};

export type PlatformSetOrganizationModulesInput = {
  modules: Array<OrganizationModule>;
  organizationId: Scalars['ID']['input'];
  useDefaultModules?: Scalars['Boolean']['input'];
};

export type PlatformStartImpersonationInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  targetUserId: Scalars['ID']['input'];
};

/** Оборот: проведённые платежи по дате проведения, возвраты не вычитаются. */
export type PlatformTurnoverMetric = {
  __typename?: 'PlatformTurnoverMetric';
  by_provider: Array<PlatformPaymentProviderSeries>;
  previous: Array<Scalars['Money']['output']>;
  previous_total: Scalars['Money']['output'];
  total: Scalars['Money']['output'];
};

export type PlatformUserMembership = {
  __typename?: 'PlatformUserMembership';
  employee: Employee;
  locations: Array<Location>;
  organization: Organization;
};

export type PlatformUserRow = {
  __typename?: 'PlatformUserRow';
  memberships: Array<PlatformUserMembership>;
  user: User;
};

/** A paginated list of PlatformUserRow edges. */
export type PlatformUserRowConnection = {
  __typename?: 'PlatformUserRowConnection';
  /** A list of PlatformUserRow edges. */
  edges: Array<PlatformUserRowEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type PlatformUserRow and a cursor. */
export type PlatformUserRowEdge = {
  __typename?: 'PlatformUserRowEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The PlatformUserRow node. */
  node: PlatformUserRow;
};

export enum PlatformUserSortField {
  CreatedAt = 'CREATED_AT',
  LastActivityAt = 'LAST_ACTIVITY_AT',
  Name = 'NAME'
}

export type PrepareOrderFiscalRefundInput = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  kkt?: InputMaybe<OrderFiscalKktVerificationInput>;
  kktDeviceId?: InputMaybe<Scalars['String']['input']>;
  /** Реквизиты исходной оплаты, введённые вручную: только для заказов до включения фискализации. */
  manualBankReference?: InputMaybe<OrderFiscalManualBankReferenceInput>;
  orderId: Scalars['ID']['input'];
  orderLineIds: Array<Scalars['ID']['input']>;
  paymentAllocations: Array<RefundPaymentAllocationInput>;
  reason: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<OrderFiscalTerminalVerificationInput>;
};

export type PrepareOrderFiscalSettlementInput = {
  advancePaymentIds?: Array<Scalars['ID']['input']>;
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  kkt?: InputMaybe<OrderFiscalKktVerificationInput>;
  kktDeviceId?: InputMaybe<Scalars['String']['input']>;
  loyaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['ID']['input'];
  payments: Array<SettleOrderPaymentInput>;
  receiptContact?: InputMaybe<OrderFiscalReceiptContactInput>;
  terminal?: InputMaybe<OrderFiscalTerminalVerificationInput>;
};

export type Product = {
  __typename?: 'Product';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  category_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** GTIN-14 товара; у маркированного без штрихкода привязывается при первой приёмке. */
  gtins: Array<Scalars['String']['output']>;
  /** Совпадает с id позиции каталога. */
  id: Scalars['ID']['output'];
  /** Подакцизный товар (признак предмета расчёта 2 или 33). */
  is_excisable: Scalars['Boolean']['output'];
  /** Товар подлежит маркировке «Честный знак» и продаётся только сканом кода. */
  is_marked: Scalars['Boolean']['output'];
  photo_url?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Money']['output'];
  sale_price: Scalars['Money']['output'];
  stocks: Array<ProductStock>;
  title: Scalars['String']['output'];
  total_stock_quantity: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of Product edges. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** A list of Product edges. */
  edges: Array<ProductEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type Product and a cursor. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Product node. */
  node: Product;
};

export type ProductInput = {
  /** Категория каталога; null — без категории. */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** GTIN по 8–14 цифр; нормализуются в GTIN-14. Маркированному товару штрихкод можно привязать позже, при первой приёмке. */
  gtins?: InputMaybe<Array<Scalars['String']['input']>>;
  isExcisable?: InputMaybe<Scalars['Boolean']['input']>;
  isMarked?: InputMaybe<Scalars['Boolean']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  purchasePrice: Scalars['Money']['input'];
  salePrice: Scalars['Money']['input'];
  title: Scalars['String']['input'];
};

export type ProductMovement = {
  __typename?: 'ProductMovement';
  comment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  delta: Scalars['Int']['output'];
  /** Сотрудник, выполнивший операцию. Переиспользует проекцию OrderActor (id + title). */
  employee?: Maybe<OrderActor>;
  id: Scalars['ID']['output'];
  location: Location;
  /** Коды маркировки, прошедшие движением; пусто у немаркированного товара. */
  marking_codes: Array<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['ID']['output']>;
  product: Product;
  reason: ProductMovementReason;
  /** Отменяющее движение; заполнено только у отменённого оприходования. */
  reversal?: Maybe<ProductMovement>;
  /** Исходящее движение перемещения; заполнено только у `transfer_in`. */
  transfer_source?: Maybe<ProductMovement>;
  /** Входящее движение перемещения; заполнено только у отправленного `transfer_out`. */
  transfer_target?: Maybe<ProductMovement>;
  unit_purchase_price: Scalars['Money']['output'];
};

/** A paginated list of ProductMovement edges. */
export type ProductMovementConnection = {
  __typename?: 'ProductMovementConnection';
  /** A list of ProductMovement edges. */
  edges: Array<ProductMovementEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type ProductMovement and a cursor. */
export type ProductMovementEdge = {
  __typename?: 'ProductMovementEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The ProductMovement node. */
  node: ProductMovement;
};

export type ProductMovementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  /** Коды маркировки списываемых единиц; количество берётся по их числу. */
  markingCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export enum ProductMovementReason {
  Order = 'ORDER',
  Receipt = 'RECEIPT',
  ReceiptReversal = 'RECEIPT_REVERSAL',
  Refund = 'REFUND',
  TransferIn = 'TRANSFER_IN',
  TransferOut = 'TRANSFER_OUT',
  Writeoff = 'WRITEOFF'
}

export type ProductPhotoUploadPayload = {
  __typename?: 'ProductPhotoUploadPayload';
  url: Scalars['String']['output'];
};

export type ProductStock = {
  __typename?: 'ProductStock';
  id: Scalars['ID']['output'];
  location: Location;
  quantity: Scalars['Int']['output'];
};

export type ProductTransferInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  fromLocationId: Scalars['ID']['input'];
  /** Коды маркировки перемещаемых единиц; количество берётся по их числу. */
  markingCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  toLocationId: Scalars['ID']['input'];
};

/** Маркированная единица товара: где она сейчас и в каком состоянии; читается по коду со сканера. */
export type ProductUnit = {
  __typename?: 'ProductUnit';
  /** Нормализованный код маркировки единицы. */
  code: Scalars['String']['output'];
  /** Точка, в которой единица числится сейчас. */
  location: Location;
  /** Товар единицы; у архивного товара тоже возвращается. */
  product: Product;
  status: ProductUnitStatus;
};

export enum ProductUnitStatus {
  InStock = 'IN_STOCK',
  Sold = 'SOLD',
  WrittenOff = 'WRITTEN_OFF'
}

export type QrLink = {
  __typename?: 'QrLink';
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  public_url: Scalars['String']['output'];
  style_config: Scalars['String']['output'];
  target_url: Scalars['String']['output'];
  total_clicks: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type Query = {
  __typename?: 'Query';
  analyticsOverview: AnalyticsOverview;
  authContext: AuthContext;
  bankByBik?: Maybe<BankSuggestion>;
  /** Контекст клиента для корзины записи без доступа к полной карточке клиента. */
  bookingClientProfile?: Maybe<BookingClientProfile>;
  /** История изменений одной группы броней от новых записей к старым. */
  bookingGroupAuditLogs: BookingGroupAuditLogConnection;
  /** Расписание шахматки за диапазон дат [start, end]. Паритет GET /api/v2/booking/schedule (ScheduleIndexController). */
  bookingSchedule: Array<UnitSchedule>;
  /** Записываемые услуги текущей локации с её тарифами и ценами для шахматки; обновляется отдельно от динамического расписания. */
  bookingServiceCatalog: Array<BookingSettingsService>;
  /** Записываемые услуги текущей локации с её тарифами, ценами и ограничением ресурсов. */
  bookingSettingsServices: Array<BookingSettingsService>;
  /** Все ресурсы текущей локации с ближайшей недоступностью. */
  bookingSettingsUnits: Array<BookingSettingsUnit>;
  businessLocation: BusinessLocation;
  businessLocations: BusinessLocationConnection;
  businessSettings: BusinessSettings;
  businessSettingsCatalog: BusinessSettingsCatalog;
  /** Категории каталога организации. */
  catalogCategories: Array<CatalogCategory>;
  /** Позиция каталога, в том числе архивная. */
  catalogItem?: Maybe<CatalogItem>;
  /** Позиции каталога для настроек и пикеров; с locationId — только доступные в локации, с её ценой. */
  catalogItems: Array<CatalogItem>;
  cities: Array<City>;
  client?: Maybe<Client>;
  /** Значения переменных записи для предпросмотра: текущая локация, её первая услуга, визит завтра в 12:00. */
  clientAutomationSample: ClientAutomationSample;
  /** Статистика карточки автоматизации за период в зоне организации. */
  clientAutomationStatistics: ClientAutomationStatistics;
  /** Адресаты тестовой отправки вида: диалоги клиентов с телефоном работающего сотрудника. */
  clientAutomationTestRecipients: Array<MarketingBroadcastTestRecipient>;
  /** Карточки автоматизаций организации со счётчиками за 30 дней. */
  clientAutomations: Array<ClientAutomation>;
  clientLoyalty?: Maybe<LoyaltyAccount>;
  clientMessengerConversations: Array<MessengerConversation>;
  /** Тихие часы клиентских сообщений организации. Без отдельного права: значение показывают редакторы сценариев и рассылок. */
  clientQuietHours: ClientQuietHours;
  /** Живой счётчик клиентов по правилам на текущий момент. */
  clientSegmentPreview: ClientSegmentPreview;
  /** Сегменты организации: стандартные выше настраиваемых. */
  clientSegments: Array<ClientSegment>;
  clients: ClientConnection;
  conversationMessages: MessengerMessagePage;
  currentShift?: Maybe<Shift>;
  employees: EmployeeConnection;
  impersonationState: ImpersonationState;
  invoice?: Maybe<Invoice>;
  /** Готовность реквизитов продавца по незакрытым локациям. */
  invoiceSellerReadiness: Array<InvoiceSellerReadiness>;
  /** Счета организации: фильтр по состоянию, поиск по номеру, ИНН или названию плательщика. */
  invoices: InvoicePage;
  legalEntitySuggestions: Array<LegalEntitySuggestion>;
  locationAddressGeocode?: Maybe<LocationAddressGeocodeResult>;
  locationAddressSuggestions: Array<LocationAddressSuggestion>;
  /** Сводка плашки локации по всем доступным сотруднику локациям. */
  locationAttention: Array<LocationAttention>;
  locationSchedule: LocationSchedule;
  locations: Array<Location>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  loyaltyTransactions: LoyaltyTransactionConnection;
  marketingBroadcast?: Maybe<MarketingBroadcast>;
  marketingBroadcastAudienceEnabled: Scalars['Boolean']['output'];
  marketingBroadcastAudienceEntries: MarketingBroadcastAudienceEntryConnection;
  marketingBroadcastTestDelivery: MarketingBroadcastTestDelivery;
  marketingBroadcastTestRecipients: Array<MarketingBroadcastTestRecipient>;
  marketingBroadcasts: MarketingBroadcastConnection;
  marketingSource?: Maybe<MarketingSource>;
  marketingSources: Array<MarketingSource>;
  messengerChannels: Array<MessengerChannel>;
  /** Ближайшая предстоящая запись клиента для карточки мессенджера. */
  messengerClientNextBooking?: Maybe<MessengerClientNextBooking>;
  /** Точечный добор одной группы диалога по conversationId — вне пагинации и секции (deeplink / удержание открытого окна). */
  messengerConversationGroup?: Maybe<MessengerConversationGroup>;
  messengerConversationGroups: MessengerConversationGroupPage;
  /** Счётчики диалогов по разделам для бейджей переключателя. */
  messengerDialogCounts: MessengerDialogCounts;
  /** Точечный добор сообщения по id (при промахе кэша по тонкому WS-событию). */
  messengerMessage?: Maybe<MessengerMessage>;
  /** Операторы организации для переназначения диалога (гейт messenger.view). */
  messengerOperators: Array<MessengerDialogAssignee>;
  /**
   * Временный ручной отчёт, переедет в конструктор отчётов.
   * Строится по всем локациям организации.
   */
  newClientRetentionReport: Array<NewClientRetentionRow>;
  order?: Maybe<Order>;
  /** Checkout-flow шахматки: доступен операторам оплат без права на раздел платежей. */
  orderByBookingGroup?: Maybe<Order>;
  /** Checkout-flow шахматки: доступен операторам оплат без права на раздел платежей. */
  orderCheckoutContext?: Maybe<OrderCheckoutContext>;
  orderFiscalActiveWorkstation?: Maybe<OrderFiscalWorkstation>;
  /** Операция кассы платежа: для карточки платежа и принудительного закрытия. */
  orderFiscalOperation: OrderFiscalOperation;
  /** Операционное состояние кассы для сотрудников, принимающих оплату. */
  orderFiscalOperationalStatus: OrderFiscalOperationalStatus;
  orderFiscalRefundOperation?: Maybe<OrderFiscalRefundExecution>;
  orderFiscalSettlementOperation?: Maybe<OrderFiscalSettlementExecution>;
  orderFiscalizationReadiness: OrderFiscalizationReadiness;
  orderFiscalizationSettings?: Maybe<OrderFiscalizationSetting>;
  /** Счёт заказа и можно ли его выставить: каждое поле считается, только когда выбрано. */
  orderInvoiceState: OrderInvoiceState;
  /** Лента запросов на подтверждение возврата для руководителя. */
  orderRefundApprovals: OrderRefundApprovalConnection;
  /** Refund-flow: операционная readiness без управленческого права настройки ККТ. */
  orderRefundContext?: Maybe<OrderRefundContext>;
  payment?: Maybe<PaymentDetails>;
  paymentJournal: PaymentJournalEntryConnection;
  permissions: Array<Permission>;
  /** Подсказки для поля ФИО. Для отчества и фамилии firstName оставляет записи пола этого имени. */
  personNameSuggestions: PersonNameSuggestions;
  /** 20 новейших событий, с `before` — следующие за этим курсором. */
  platformActivityFeed: Array<PlatformActivityEvent>;
  platformImpersonationActions: PlatformImpersonationActionConnection;
  platformImpersonationSessions: PlatformImpersonationSessionConnection;
  platformOrganizationRoles: Array<Role>;
  platformOrganizations: PlatformOrganizationRowConnection;
  platformOverview: PlatformOverview;
  platformQueueStats: Array<PlatformQueueStat>;
  platformUser?: Maybe<PlatformUserRow>;
  platformUsers: PlatformUserRowConnection;
  /** Товар каталога. Открыт и держателю `shop.manage`: правка (в том числе привязка GTIN со склада) начинается с чтения текущего товара. */
  product?: Maybe<Product>;
  productMovements: ProductMovementConnection;
  /** Единица по коду маркировки: где числится и в каком состоянии. `null` — код не приходовался. */
  productUnit?: Maybe<ProductUnit>;
  products: ProductConnection;
  qrLink?: Maybe<QrLink>;
  qrLinks: Array<QrLink>;
  qrLinksTrashed: Array<QrLink>;
  radioPlaylist?: Maybe<RadioPlaylist>;
  radioPlaylists: Array<RadioPlaylist>;
  radioTrackLoudness: Array<RadioTrack>;
  radioTracks: RadioTrackConnection;
  /** Витрина магазина: последние чеки локации для оператора оплат без права на раздел платежей. */
  recentLocationOrders: OrderConnection;
  /**
   * Временный ручной отчёт, переедет в конструктор отчётов.
   * Строится по всем локациям организации.
   */
  regularClientsReport: Array<RegularClientsMonth>;
  revealClientPhone: Scalars['String']['output'];
  robokassaConnection?: Maybe<RobokassaConnection>;
  roles: Array<Role>;
  scenario?: Maybe<Scenario>;
  scenarios: ScenarioConnection;
  /** Карточка смены. Смена недоступной сотруднику локации возвращается как `null`. */
  shift?: Maybe<Shift>;
  /**
   * Контекст закрытия смены без перевода её в `closing`: на нём открывается диалог,
   * статус меняет только сабмит закрытия.
   */
  shiftClosingContext: ShiftClosingContext;
  /**
   * Временный ручной отчёт, переедет в конструктор отчётов.
   * Строится по всем локациям организации независимо от привязки сотрудника.
   */
  shiftLoyaltyRegistrationsReport: Array<ShiftLoyaltyRegistrationsReportRow>;
  /** Услуги отчёта о регистрациях: позиции каталога. */
  shiftLoyaltyReportItems: Array<Scalars['ID']['output']>;
  /** Журнал смен по доступным сотруднику локациям; период по `opened_at` в зоне локации. */
  shifts: ShiftConnection;
  showcaseProducts: ShowcaseProductConnection;
  sop?: Maybe<Sop>;
  sopSections: Array<SopSection>;
  sopVersions: Array<SopVersion>;
  sops: SopConnection;
  /** Остатки склада: товары, у которых есть остаток в выбранной области. Без locationId — по всем доступным точкам (нужен shop.manage). */
  stockBalances: StockBalanceConnection;
  /** Лента склада: последние движения точки, кроме заказов и возвратов (они в ленте витрины). */
  stockMovements: ProductMovementConnection;
  /** Каталог для склада: весь ассортимент организации с остатком запрошенной точки. */
  stockProducts: ShowcaseProductConnection;
  /** Организации переключателя: суперюзер видит все, остальные — свои; права по импервонатору. */
  switchableOrganizations: SwitchableOrganizationConnection;
  tireBrands: Array<Scalars['String']['output']>;
  /** Поиск машины по госномеру или по цифрам телефона владельца. */
  tireCarLookup: Array<TireCar>;
  tireCarMarks: TireCarSuggestions;
  tireCarModels: TireCarSuggestions;
  /** Машины клиента. */
  tireCars: Array<TireCar>;
  /** Хранения клиента во всех локациях организации. */
  tireClientStorages: Array<TireStorage>;
  /** Модели шин бренда из справочника; бренд не из справочника — пустой список. */
  tireModels: Array<Scalars['String']['output']>;
  /** Параметры цены шиномонтажа; без сохранённых настроек — значения по умолчанию. */
  tireServiceSettings: TireServiceSettings;
  /** Склады хранения всех доступных сотруднику локаций для раздела настроек. */
  tireSettingsWarehouses: Array<TireStorageWarehouse>;
  /** Хранение любой локации организации: карточка клиента и QR договора. */
  tireStorage?: Maybe<TireStorage>;
  /** Полный телефон поклажедателя для печати договора, акта и наклеек; каждый запрос пишется в журнал действий. */
  tireStorageClientPhone?: Maybe<Scalars['String']['output']>;
  /** Первая свободная ячейка склада. */
  tireStorageFreeCell?: Maybe<TireStorageCell>;
  /** Хранений на складе во всей организации. */
  tireStorageInStockCount: Scalars['Int']['output'];
  /** Склады хранения текущей локации. */
  tireStorageWarehouses: Array<TireStorageWarehouse>;
  /** Хранения выбранных локаций (по умолчанию — текущей) по вкладкам; черновики не показываются. */
  tireStorages: TireStorageConnection;
  /** Наряд любой доступной сотруднику локации организации. */
  tireWorkOrder?: Maybe<TireWorkOrder>;
  /** Наряд, открытый из записи. */
  tireWorkOrderForBooking?: Maybe<TireWorkOrder>;
  /** Сводка журнала нарядов: открытые выбранных локаций и смена, если выбрана одна локация. */
  tireWorkOrderJournal: TireWorkOrderJournal;
  /** Наряды выбранных локаций (по умолчанию — текущей): открытые от старых к новым, затем закрытые от новых к старым. */
  tireWorkOrders: TireWorkOrderConnection;
  /** Текущие и будущие периоды недоступности unit текущей локации. */
  unitUnavailabilities: UnitUnavailabilityPage;
  webPushContext: WebPushContext;
};


export type QueryAnalyticsOverviewArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  period: AnalyticsPeriodInput;
};


export type QueryBankByBikArgs = {
  bik: Scalars['String']['input'];
};


export type QueryBookingClientProfileArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryBookingGroupAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  bookingGroupId: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
};


export type QueryBookingScheduleArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};


export type QueryBookingSettingsServicesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBookingSettingsUnitsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBusinessLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryBusinessLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BusinessLocationStatus>;
};


export type QueryCatalogItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCatalogItemsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<CatalogItemKind>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientAutomationStatisticsArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: ClientAutomationKind;
};


export type QueryClientLoyaltyArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryClientMessengerConversationsArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryClientSegmentPreviewArgs = {
  rules: Array<ClientSegmentRuleInput>;
};


export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  firstVisitLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastVisitLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  marketingSourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<ClientOrderByField>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sortOrder?: InputMaybe<SortOrder>;
  type?: InputMaybe<ClientType>;
};


export type QueryConversationMessagesArgs = {
  beforeMessageId?: InputMaybe<Scalars['ID']['input']>;
  conversationId: Scalars['ID']['input'];
  filter?: MessageFilter;
  perPage?: Scalars['Int']['input'];
};


export type QueryCurrentShiftArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryEmployeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  location_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EmployeeStatus>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  filter?: InputMaybe<InvoiceListFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryLegalEntitySuggestionsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  query: Scalars['String']['input'];
};


export type QueryLocationAddressGeocodeArgs = {
  countryCode?: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QueryLocationAddressSuggestionsArgs = {
  count?: Scalars['Int']['input'];
  countryCode?: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QueryLocationScheduleArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLoyaltyTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
};


export type QueryMarketingBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMarketingBroadcastAudienceEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  broadcastId: Scalars['ID']['input'];
  decision?: InputMaybe<BroadcastAudienceEntryDecision>;
  first?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  snapshotId: Scalars['ID']['input'];
  status?: InputMaybe<MarketingBroadcastRecipientStatus>;
};


export type QueryMarketingBroadcastTestDeliveryArgs = {
  broadcastId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};


export type QueryMarketingBroadcastsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  startedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketingSourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessengerClientNextBookingArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryMessengerConversationGroupArgs = {
  conversationId: Scalars['ID']['input'];
};


export type QueryMessengerConversationGroupsArgs = {
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<MessengerDialogSection>;
};


export type QueryMessengerMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewClientRetentionReportArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  dimension: NewClientRetentionDimension;
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderByBookingGroupArgs = {
  bookingGroupId: Scalars['ID']['input'];
};


export type QueryOrderCheckoutContextArgs = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryOrderFiscalActiveWorkstationArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryOrderFiscalOperationArgs = {
  operationId: Scalars['ID']['input'];
};


export type QueryOrderFiscalOperationalStatusArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryOrderFiscalRefundOperationArgs = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryOrderFiscalSettlementOperationArgs = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryOrderFiscalizationReadinessArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryOrderFiscalizationSettingsArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryOrderInvoiceStateArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryOrderRefundApprovalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  live?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<OrderRefundApprovalStatus>;
};


export type QueryOrderRefundContextArgs = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentJournalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PaymentJournalFilter>;
  first?: Scalars['Int']['input'];
};


export type QueryPersonNameSuggestionsArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  kind: PersonNameKind;
  query: Scalars['String']['input'];
};


export type QueryPlatformActivityFeedArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  kinds?: InputMaybe<Array<PlatformActivityKind>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlatformImpersonationActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
};


export type QueryPlatformImpersonationSessionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  targetUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlatformOrganizationRolesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryPlatformOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlatformOverviewArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  period: PlatformOverviewPeriod;
};


export type QueryPlatformUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PlatformUserSortField>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductMovementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};


export type QueryProductUnitArgs = {
  code: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQrLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRadioPlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRadioTrackLoudnessArgs = {
  trackIds: Array<Scalars['ID']['input']>;
};


export type QueryRadioTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecentLocationOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};


export type QueryRegularClientsReportArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryRevealClientPhoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScenariosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShiftArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShiftClosingContextArgs = {
  shiftId: Scalars['ID']['input'];
};


export type QueryShiftLoyaltyRegistrationsReportArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


export type QueryShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryShowcaseProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  locationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySopArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySopVersionsArgs = {
  sopId: Scalars['ID']['input'];
};


export type QuerySopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SopStatus>;
};


export type QueryStockBalancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStockMovementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  locationId: Scalars['ID']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStockProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  locationId: Scalars['ID']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySwitchableOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTireBrandsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTireCarLookupArgs = {
  query: Scalars['String']['input'];
};


export type QueryTireCarMarksArgs = {
  limit?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTireCarModelsArgs = {
  limit?: Scalars['Int']['input'];
  mark: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTireCarsArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryTireClientStoragesArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryTireModelsArgs = {
  brand: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTireStorageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTireStorageClientPhoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTireStorageFreeCellArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type QueryTireStoragesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tab: TireStorageTab;
};


export type QueryTireWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTireWorkOrderForBookingArgs = {
  bookingGroupId: Scalars['ID']['input'];
};


export type QueryTireWorkOrderJournalArgs = {
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryTireWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  shift?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TireWorkOrderStatus>;
};


export type QueryUnitUnavailabilitiesArgs = {
  activeOrFuture?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export enum RadioLoudnessAnalysisStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export type RadioPlaylist = {
  __typename?: 'RadioPlaylist';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  tracks: Array<RadioTrack>;
};

export type RadioTrack = {
  __typename?: 'RadioTrack';
  artist?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  duration: Scalars['Int']['output'];
  file_size: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  loudness_analysis_status: RadioLoudnessAnalysisStatus;
  loudness_analysis_version: Scalars['Int']['output'];
  normalization_gain_db?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A paginated list of RadioTrack edges. */
export type RadioTrackConnection = {
  __typename?: 'RadioTrackConnection';
  /** A list of RadioTrack edges. */
  edges: Array<RadioTrackEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type RadioTrack and a cursor. */
export type RadioTrackEdge = {
  __typename?: 'RadioTrackEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The RadioTrack node. */
  node: RadioTrack;
};

export enum ReceiptSettlementMethod {
  FullPayment = 'FULL_PAYMENT',
  FullPrepayment = 'FULL_PREPAYMENT'
}

export type RecordOrderFiscalCommandLogsInput = {
  entries: Array<OrderFiscalCommandLogEntryInput>;
};

export type RecordOrderOutsideTerminalRefundInput = {
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  orderLineIds: Array<Scalars['ID']['input']>;
  paymentAllocations: Array<RefundPaymentAllocationInput>;
  reason: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  /** Номер операции СБП со слипа терминала. */
  reference: Scalars['String']['input'];
};

export type RefundAdvanceInput = {
  amount: Scalars['Money']['input'];
  idempotencyKey: Scalars['String']['input'];
  paymentId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RefundAdvancePayload = {
  __typename?: 'RefundAdvancePayload';
  refund: PaymentRefund;
};

export type RefundOrderInput = {
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  orderLineIds: Array<Scalars['ID']['input']>;
  paymentAllocations: Array<RefundPaymentAllocationInput>;
  reason: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  /** Обязателен, если возвращаются деньги банковского перевода. */
  transfer?: InputMaybe<RefundTransferInput>;
};

export type RefundPaymentAllocationInput = {
  amount: Scalars['Int']['input'];
  moneyPartId: Scalars['ID']['input'];
};

/** Возврат переводом: номер платёжного поручения и дата перевода. */
export type RefundTransferInput = {
  reference: Scalars['String']['input'];
  transferredOn: Scalars['Date']['input'];
};

export type RegisterShiftKktReopenInput = {
  fnSerial: Scalars['String']['input'];
  kktShiftNumber?: InputMaybe<Scalars['Int']['input']>;
  shiftId: Scalars['ID']['input'];
};

/**
 * Месяц временного ручного отчёта «Постоянные клиенты».
 *
 * Постоянный клиент — член стандартного сегмента «Лояльные клиенты» на точке
 * месяца по текущему правилу сегмента: смена значений сегмента или сброс
 * к дефолту меняет и прошлые месяцы. Точка месяца — его последний день,
 * а у текущего месяца — сегодняшний день организации. Показатели активности
 * считаются по клиентам, которые были лояльными на предыдущей точке.
 */
export type RegularClientsMonth = {
  __typename?: 'RegularClientsMonth';
  /** Лояльных на предыдущей точке, у которых есть завершённая запись в этом месяце. */
  active: Scalars['Int']['output'];
  /** Вошли в сегмент за месяц: в сегменте на точке месяца и не были на предыдущей. */
  entered: Scalars['Int']['output'];
  /** Месяц ещё идёт: point_date раньше последнего дня месяца. */
  is_partial: Scalars['Boolean']['output'];
  /** Выпали из сегмента за месяц: были на предыдущей точке и не на этой. */
  left: Scalars['Int']['output'];
  /** Клиентов в сегменте «Лояльные клиенты» по правилу на момент запроса, на точке месяца. */
  loyal: Scalars['Int']['output'];
  /** Первый день календарного месяца. */
  month: Scalars['Date']['output'];
  /** Дата, на которую считается членство: последний день месяца или сегодня. */
  point_date: Scalars['Date']['output'];
  /**
   * Оплаты клиентов, лояльных на предыдущей точке, за месяц: заказы, включая
   * магазин, за вычетом возвратов. Оплата баллами не входит.
   */
  revenue: Scalars['Money']['output'];
  /** Визит-дни этих клиентов в этом месяце. */
  visits: Scalars['Int']['output'];
};

/** Новый клиент для существующей группы броней. */
export type ReplaceBookingClientInput = {
  clientId: Scalars['ID']['input'];
};

export type RequestOrderRefundApprovalInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  kind?: OrderRefundApprovalKind;
  orderId: Scalars['ID']['input'];
  /** Состав возврата переводом: обязателен для TRANSFER. */
  refund?: InputMaybe<OrderRefundTransferInput>;
};

export type RequestTrackUploadInput = {
  artist?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  filesize: Scalars['Int']['input'];
  mimetype: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ResolveOrderFiscalReceiptInput = {
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  /** Чеки ФН с номерами от `fiscal_scan_from` до последнего; отчёты смены не передаются. */
  documents: Array<OrderFiscalDriveDocumentInput>;
  /** Номер ФН кассы, к которой подключён браузер. */
  fiscalDriveNumber?: InputMaybe<Scalars['String']['input']>;
  idCommand: Scalars['String']['input'];
  kktDeviceId: Scalars['String']['input'];
  operationId: Scalars['ID']['input'];
  payloadHash: Scalars['String']['input'];
};

export type ResolveOrderRefundApprovalInput = {
  approvalId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  decision: OrderRefundApprovalStatus;
};

/** Слово для ресурса записи. */
export enum ResourceTerm {
  Cabinet = 'CABINET',
  Chair = 'CHAIR',
  Place = 'PLACE',
  Post = 'POST',
  Simulator = 'SIMULATOR'
}

export type RetryOrderFiscalReceiptInput = {
  /** Повтор привязан к ККТ, а не к браузеру: поле не проверяется. */
  browserWorkstationId?: InputMaybe<Scalars['ID']['input']>;
  idCommand: Scalars['String']['input'];
  kkt: OrderFiscalKktVerificationInput;
  kktDeviceId: Scalars['String']['input'];
  operationId: Scalars['ID']['input'];
  payloadHash: Scalars['String']['input'];
};

export type ReturnInvoiceReceiptInput = {
  paymentOrderNumber: Scalars['String']['input'];
  receiptId: Scalars['ID']['input'];
  transferredOn: Scalars['Date']['input'];
};

export type RobokassaConnection = {
  __typename?: 'RobokassaConnection';
  fiscal_scheme?: Maybe<PaymentFiscalScheme>;
  hash_algorithm?: Maybe<PaymentHashAlgorithm>;
  id: Scalars['ID']['output'];
  merchant_login: Scalars['String']['output'];
  mode: PaymentConnectionMode;
  password1_mask?: Maybe<Scalars['String']['output']>;
  password2_mask?: Maybe<Scalars['String']['output']>;
  password3_mask?: Maybe<Scalars['String']['output']>;
  readiness: RobokassaReadiness;
  result_url: Scalars['String']['output'];
  single_receipt_confirmed_at?: Maybe<Scalars['DateTime']['output']>;
  status: PaymentConnectionStatus;
  tax_system?: Maybe<PaymentTaxSystem>;
  test_password1_mask?: Maybe<Scalars['String']['output']>;
  test_password2_mask?: Maybe<Scalars['String']['output']>;
  vat_payer: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
};

export type RobokassaConnectionInput = {
  confirmSingleReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  fiscalScheme?: InputMaybe<PaymentFiscalScheme>;
  hashAlgorithm?: InputMaybe<PaymentHashAlgorithm>;
  merchantLogin?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<PaymentConnectionMode>;
  password1?: InputMaybe<Scalars['String']['input']>;
  password2?: InputMaybe<Scalars['String']['input']>;
  password3?: InputMaybe<Scalars['String']['input']>;
  taxSystem?: InputMaybe<PaymentTaxSystem>;
  testPassword1?: InputMaybe<Scalars['String']['input']>;
  testPassword2?: InputMaybe<Scalars['String']['input']>;
  vatPayer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RobokassaReadiness = {
  __typename?: 'RobokassaReadiness';
  final_receipt_locations: Array<PaymentReceiptLocation>;
  income_receipts: Scalars['Boolean']['output'];
  payments: Scalars['Boolean']['output'];
  reasons: Array<PaymentReadinessReason>;
  refunds: Scalars['Boolean']['output'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  title: Scalars['String']['output'];
};

export type SaveTireServiceSettingsInput = {
  /** Активные классы машины по порядку: класс не из списка уходит в архив, архивный из списка возвращается. */
  classes: Array<TireCarClassInput>;
  diameterMax: Scalars['Int']['input'];
  diameterMin: Scalars['Int']['input'];
  runFlatEnabled: Scalars['Boolean']['input'];
};

export type Scenario = {
  __typename?: 'Scenario';
  active_from?: Maybe<Scalars['DateTime']['output']>;
  active_to?: Maybe<Scalars['DateTime']['output']>;
  available_providers: Array<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  default_city?: Maybe<City>;
  flow_definition: Array<ScenarioStep>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  marketing_source?: Maybe<MarketingSource>;
  name: Scalars['String']['output'];
  /** Бонус за регистрацию по ссылке сценария: null — сумма из автоматизации «Бонус за регистрацию», 0 — без бонуса. */
  registration_bonus_points?: Maybe<Scalars['Int']['output']>;
  restart_on_reactivation: Scalars['Boolean']['output'];
  runs_count: Scalars['Int']['output'];
  statistics: ScenarioStatistics;
  stop_if_booked: Scalars['Boolean']['output'];
  structural_edit_locked: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of Scenario edges. */
export type ScenarioConnection = {
  __typename?: 'ScenarioConnection';
  /** A list of Scenario edges. */
  edges: Array<ScenarioEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type Scenario and a cursor. */
export type ScenarioEdge = {
  __typename?: 'ScenarioEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Scenario node. */
  node: Scenario;
};

export type ScenarioRun = {
  __typename?: 'ScenarioRun';
  current_step_index: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last_step_at?: Maybe<Scalars['DateTime']['output']>;
  scenario: Scenario;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: ScenarioRunStatus;
};

export enum ScenarioRunStatus {
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  Running = 'RUNNING',
  Waiting = 'WAITING'
}

export type ScenarioStatistics = {
  __typename?: 'ScenarioStatistics';
  funnel: ScenarioStatsFunnel;
  overview: ScenarioStatsOverview;
};

export type ScenarioStatsFunnel = {
  __typename?: 'ScenarioStatsFunnel';
  contacts_collected: Scalars['Int']['output'];
  identified: Scalars['Int']['output'];
  reached_club: Scalars['Int']['output'];
};

export type ScenarioStatsOverview = {
  __typename?: 'ScenarioStatsOverview';
  contacts_collected: Scalars['Int']['output'];
  new_clients: Scalars['Int']['output'];
  new_clients_revenue: Scalars['Int']['output'];
  reactivated_clients: Scalars['Int']['output'];
  reactivated_revenue: Scalars['Int']['output'];
};

export type ScenarioStep = {
  __typename?: 'ScenarioStep';
  body?: Maybe<Scalars['String']['output']>;
  button_text?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<ScenarioStepButton>>;
  delay_unit?: Maybe<Scalars['String']['output']>;
  delay_value?: Maybe<Scalars['Int']['output']>;
  on_timeout?: Maybe<Scalars['String']['output']>;
  timeout_unit?: Maybe<Scalars['String']['output']>;
  timeout_value?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type ScenarioStepButton = {
  __typename?: 'ScenarioStepButton';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ScenarioStepButtonInput = {
  text: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ScenarioStepInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<Array<ScenarioStepButtonInput>>;
  delayUnit?: InputMaybe<Scalars['String']['input']>;
  delayValue?: InputMaybe<Scalars['Int']['input']>;
  onTimeout?: InputMaybe<Scalars['String']['input']>;
  timeoutUnit?: InputMaybe<Scalars['String']['input']>;
  timeoutValue?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};

export enum ScheduleWeekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type SendMessengerMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  targetConversationId: Scalars['ID']['input'];
};

export type SendPaymentLinkInput = {
  conversationId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
  sourceType: PaymentSourceType;
};

export type SetSopPermissionInput = {
  accessLevel: SopAccessLevel;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  sopId: Scalars['ID']['input'];
};

export type SettleOrderInput = {
  advancePaymentIds?: Array<Scalars['ID']['input']>;
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  loyaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['ID']['input'];
  payments: Array<SettleOrderPaymentInput>;
};

export type SettleOrderPaymentInput = {
  amount: Scalars['Int']['input'];
  method: OrderPaymentMethod;
};

export type Shift = {
  __typename?: 'Shift';
  cashier_vatin?: Maybe<Scalars['String']['output']>;
  close_comment?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  closed_by?: Maybe<OrderActor>;
  closing_cash?: Maybe<Scalars['Float']['output']>;
  /**
   * Расхождение по наличным: пересчитанное кассиром минус ожидаемое. Отрицательное —
   * недостача. `null` у смен, закрытых до появления сверки.
   */
  closing_cash_diff?: Maybe<Scalars['Float']['output']>;
  /**
   * Сколько наличных должно быть в ящике на закрытие: остаток на открытие плюс наличная
   * выручка минус наличные возвраты. `null` у смен, закрытых до появления сверки.
   */
  closing_cash_expected?: Maybe<Scalars['Float']['output']>;
  closing_revenue_diff?: Maybe<Scalars['Float']['output']>;
  closing_revenue_kkt?: Maybe<Scalars['Float']['output']>;
  closing_revenue_mors?: Maybe<Scalars['Float']['output']>;
  events: Array<ShiftEvent>;
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kkt_fn_serial_masked?: Maybe<Scalars['String']['output']>;
  kkt_sessions: Array<ShiftKktSession>;
  kkt_sync: ShiftKktSyncState;
  location: Location;
  location_id: Scalars['ID']['output'];
  opened_at: Scalars['DateTime']['output'];
  opened_by?: Maybe<OrderActor>;
  opening_cash: Scalars['Float']['output'];
  organization_id: Scalars['ID']['output'];
  /** Считается запросом к платежам смены: для карточки, не для списка. */
  revenue_mors: ShiftRevenueBreakdown;
  status: ShiftStatus;
};

export type ShiftClosingContext = {
  __typename?: 'ShiftClosingContext';
  /** Незавершённые операции локации: кассир завершает их перед Z-отчётом, закрыть смену они не мешают. */
  pending_operations: Array<OrderFiscalOperation>;
  revenue_mors_card: Scalars['Money']['output'];
  revenue_mors_cash: Scalars['Money']['output'];
  revenue_mors_other: Scalars['Money']['output'];
  revenue_mors_total: Scalars['Money']['output'];
  shift: Shift;
};

/** A paginated list of Shift edges. */
export type ShiftConnection = {
  __typename?: 'ShiftConnection';
  /** A list of Shift edges. */
  edges: Array<ShiftEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type Shift and a cursor. */
export type ShiftEdge = {
  __typename?: 'ShiftEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Shift node. */
  node: Shift;
};

/** Payload события не отдаётся: в нём фискальные реквизиты. */
export type ShiftEvent = {
  __typename?: 'ShiftEvent';
  actor?: Maybe<OrderActor>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  type: ShiftEventType;
};

export enum ShiftEventType {
  Closed = 'CLOSED',
  ClosedWithoutZReport = 'CLOSED_WITHOUT_Z_REPORT',
  ClosingStarted = 'CLOSING_STARTED',
  DesyncDetected = 'DESYNC_DETECTED',
  ForceClosed = 'FORCE_CLOSED',
  KktOpenFailed = 'KKT_OPEN_FAILED',
  KktOpenOk = 'KKT_OPEN_OK',
  KktReopened = 'KKT_REOPENED',
  Opened = 'OPENED',
  OrphanKktClosed = 'ORPHAN_KKT_CLOSED',
  QueueMovedToReview = 'QUEUE_MOVED_TO_REVIEW'
}

export type ShiftKktSession = {
  __typename?: 'ShiftKktSession';
  close_reason?: Maybe<ShiftKktSessionCloseReason>;
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  fn_serial_masked: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kkt_shift_number?: Maybe<Scalars['Int']['output']>;
  opened_at: Scalars['DateTime']['output'];
  shift_id: Scalars['ID']['output'];
};

export enum ShiftKktSessionCloseReason {
  Emergency = 'EMERGENCY',
  External = 'EXTERNAL',
  KktAlreadyClosed = 'KKT_ALREADY_CLOSED',
  Normal = 'NORMAL'
}

export enum ShiftKktSyncState {
  ClosedWithoutKkt = 'CLOSED_WITHOUT_KKT',
  NotRequired = 'NOT_REQUIRED',
  Reopened = 'REOPENED',
  Synced = 'SYNCED'
}

/** Строка временного ручного отчёта «Регистрации в бонусной программе по сменам». */
export type ShiftLoyaltyRegistrationsReportRow = {
  __typename?: 'ShiftLoyaltyRegistrationsReportRow';
  employee_id: Scalars['ID']['output'];
  employee_name: Scalars['String']['output'];
  potential_clients: Scalars['Int']['output'];
  registered_clients: Scalars['Int']['output'];
  shifts_count: Scalars['Int']['output'];
};

/** Выручка Mors смены в копейках: платежи минус возвраты смены, без онлайн-оплат. */
export type ShiftRevenueBreakdown = {
  __typename?: 'ShiftRevenueBreakdown';
  card: Scalars['Money']['output'];
  cash: Scalars['Money']['output'];
  other: Scalars['Money']['output'];
  total: Scalars['Money']['output'];
};

export enum ShiftSettlementBlockerReason {
  Closing = 'CLOSING',
  Expired = 'EXPIRED',
  ForeignKkt = 'FOREIGN_KKT',
  NotOpen = 'NOT_OPEN',
  Opening = 'OPENING'
}

export enum ShiftSettlementState {
  Closing = 'CLOSING',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
  ForeignKkt = 'FOREIGN_KKT',
  NotOpen = 'NOT_OPEN',
  Open = 'OPEN',
  Opening = 'OPENING',
  Warning = 'WARNING'
}

export enum ShiftStatus {
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Open = 'OPEN',
  Opening = 'OPENING'
}

export type ShopOrderDraftInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<ShopOrderDraftLineInput>;
};

export type ShopOrderDraftLineInput = {
  /** Код маркировки единицы; обязателен у маркированного товара, quantity тогда равен 1. */
  markingCode?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ShowcaseProduct = {
  __typename?: 'ShowcaseProduct';
  product: Product;
  stock_quantity: Scalars['Int']['output'];
};

/** A paginated list of ShowcaseProduct edges. */
export type ShowcaseProductConnection = {
  __typename?: 'ShowcaseProductConnection';
  /** A list of ShowcaseProduct edges. */
  edges: Array<ShowcaseProductEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type ShowcaseProduct and a cursor. */
export type ShowcaseProductEdge = {
  __typename?: 'ShowcaseProductEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The ShowcaseProduct node. */
  node: ShowcaseProduct;
};

export type Sop = {
  __typename?: 'Sop';
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  creator?: Maybe<Employee>;
  current_version: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<SopPermissionType>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  search_highlight_content?: Maybe<Scalars['String']['output']>;
  search_highlight_title?: Maybe<Scalars['String']['output']>;
  section?: Maybe<SopSection>;
  status: SopStatus;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updater?: Maybe<Employee>;
  versions: Array<SopVersion>;
};

export enum SopAccessLevel {
  Edit = 'EDIT',
  Manage = 'MANAGE',
  View = 'VIEW'
}

/** A paginated list of Sop edges. */
export type SopConnection = {
  __typename?: 'SopConnection';
  /** A list of Sop edges. */
  edges: Array<SopEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type Sop and a cursor. */
export type SopEdge = {
  __typename?: 'SopEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Sop node. */
  node: Sop;
};

export type SopImageUploadPayload = {
  __typename?: 'SopImageUploadPayload';
  url: Scalars['String']['output'];
};

export type SopPermissionType = {
  __typename?: 'SopPermissionType';
  access_level: SopAccessLevel;
  employee?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  role?: Maybe<Role>;
};

export type SopSection = {
  __typename?: 'SopSection';
  children: Array<SopSection>;
  color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<SopSection>;
  sops_count: Scalars['Int']['output'];
};

export enum SopStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type SopVersion = {
  __typename?: 'SopVersion';
  change_summary?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  creator?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  version_number: Scalars['Int']['output'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

/**
 * Строка остатка склада: товар и его остаток в выбранной области.
 *
 * Не доменный объект и не таблица — проекция каталога на область доступа.
 * Один и тот же товар в разных областях даёт разный результат, поэтому на
 * клиенте строка не нормализуется как Product.
 */
export type StockBalance = {
  __typename?: 'StockBalance';
  gtins: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_excisable: Scalars['Boolean']['output'];
  is_marked: Scalars['Boolean']['output'];
  photo_url?: Maybe<Scalars['String']['output']>;
  /** Остаток по выбранной области: одна точка или все доступные сотруднику. */
  stock_quantity: Scalars['Int']['output'];
  /** Разбивка по точкам той же области; недоступные точки в неё не попадают. */
  stocks: Array<ProductStock>;
  title: Scalars['String']['output'];
};

/** A paginated list of StockBalance edges. */
export type StockBalanceConnection = {
  __typename?: 'StockBalanceConnection';
  /** A list of StockBalance edges. */
  edges: Array<StockBalanceEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type StockBalance and a cursor. */
export type StockBalanceEdge = {
  __typename?: 'StockBalanceEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The StockBalance node. */
  node: StockBalance;
};

export type SwitchableOrganization = {
  __typename?: 'SwitchableOrganization';
  access: OrganizationSwitchAccess;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** A paginated list of SwitchableOrganization edges. */
export type SwitchableOrganizationConnection = {
  __typename?: 'SwitchableOrganizationConnection';
  /** A list of SwitchableOrganization edges. */
  edges: Array<SwitchableOrganizationEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type SwitchableOrganization and a cursor. */
export type SwitchableOrganizationEdge = {
  __typename?: 'SwitchableOrganizationEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The SwitchableOrganization node. */
  node: SwitchableOrganization;
};

/** Машина клиента, по которой оформляются наряды и хранения. */
export type TireCar = {
  __typename?: 'TireCar';
  /** Класс машины, в том числе архивный: тогда в новом наряде класс выбирается заново. */
  car_class?: Maybe<TireCarClass>;
  client: Client;
  id: Scalars['ID']['output'];
  mark: Scalars['String']['output'];
  model: Scalars['String']['output'];
  plate?: Maybe<Scalars['String']['output']>;
};

/** Класс машины для цены по параметрам: свой список у организации. */
export type TireCarClass = {
  __typename?: 'TireCarClass';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type TireCarClassInput = {
  /** Без id — новый класс; id архивного класса возвращает его из архива. */
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

/** Марка, модель и госномер машины в документе. */
export type TireCarDetails = {
  __typename?: 'TireCarDetails';
  mark: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  plate?: Maybe<Scalars['String']['output']>;
};

export type TireCarInput = {
  /** Активный класс организации. */
  carClassId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  mark: Scalars['String']['input'];
  model: Scalars['String']['input'];
  plate?: InputMaybe<Scalars['String']['input']>;
};

/** Подсказки марки или модели из справочника. */
export type TireCarSuggestions = {
  __typename?: 'TireCarSuggestions';
  /** Не больше `limit` подсказок; при пустом запросе первыми идут частые значения организации. */
  items: Array<Scalars['String']['output']>;
  /** Название из справочника, точно совпавшее с запросом с учётом вариантов написания, транслитерации и раскладки. */
  match?: Maybe<Scalars['String']['output']>;
};

/** Реквизиты локации документа для печати. */
export type TirePrintRequisites = {
  __typename?: 'TirePrintRequisites';
  address?: Maybe<Scalars['String']['output']>;
  legal_address?: Maybe<Scalars['String']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  legal_ogrn?: Maybe<Scalars['String']['output']>;
  legal_tin?: Maybe<Scalars['String']['output']>;
  location_title: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export enum TireSeason {
  AllSeason = 'ALL_SEASON',
  Summer = 'SUMMER',
  WinterStudded = 'WINTER_STUDDED',
  WinterStudless = 'WINTER_STUDLESS'
}

/** Вид строки наряда. У услуги каталога бывают только REGULAR и STORAGE_INTAKE. */
export enum TireServiceItemKind {
  Regular = 'REGULAR',
  StorageExtension = 'STORAGE_EXTENSION',
  StorageIntake = 'STORAGE_INTAKE'
}

/** Своя таблица локации: пустая клетка берёт общую цену. */
export type TireServiceLocationPricesInput = {
  locationId: Scalars['ID']['input'];
  prices: Array<TireServicePriceInput>;
};

/** Ячейка матрицы цены «класс машины × диаметр × RunFlat». Цена — в копейках. */
export type TireServicePrice = {
  __typename?: 'TireServicePrice';
  car_class_id: Scalars['ID']['output'];
  /** Локация своей цены; null — общая матрица. */
  location_id?: Maybe<Scalars['ID']['output']>;
  price: Scalars['Int']['output'];
  run_flat: Scalars['Boolean']['output'];
  wheel_diameter: Scalars['Int']['output'];
};

/** Пустая клетка RunFlat значит «цена как у обычных шин» и не передаётся. */
export type TireServicePriceInput = {
  carClassId: Scalars['ID']['input'];
  price: Scalars['Int']['input'];
  runFlat: Scalars['Boolean']['input'];
  wheelDiameter: Scalars['Int']['input'];
};

/** Параметры цены шиномонтажа организации. */
export type TireServiceSettings = {
  __typename?: 'TireServiceSettings';
  archived_car_classes: Array<TireCarClass>;
  /** Активные классы по порядку. */
  car_classes: Array<TireCarClass>;
  diameter_max: Scalars['Int']['output'];
  diameter_min: Scalars['Int']['output'];
  run_flat_enabled: Scalars['Boolean']['output'];
};

/** Матрица цены «По машине»: заменяется видимая параметрами область, скрытые клетки остаются. */
export type TireServiceSettingsInput = {
  /** Свои таблицы локаций услуги поверх общей; локация вне списка теряет свои цены, null — не менять. */
  locationPrices?: InputMaybe<Array<TireServiceLocationPricesInput>>;
  prices: Array<TireServicePriceInput>;
};

/** Группа услуг образца прайса. */
export enum TireServiceTemplateGroup {
  Extras = 'EXTRAS',
  TireFitting = 'TIRE_FITTING',
  TireRepair = 'TIRE_REPAIR',
  WheelPainting = 'WHEEL_PAINTING',
  WheelRepair = 'WHEEL_REPAIR'
}

/** Шины или диски клиента на хранении. */
export type TireStorage = {
  __typename?: 'TireStorage';
  car: TireCar;
  /** Машина в документе: на складе и после выдачи — на момент постановки на склад, у черновика — текущая. */
  car_details: TireCarDetails;
  cell_no?: Maybe<Scalars['Int']['output']>;
  client: Client;
  condition_note?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  /** Оценочная стоимость комплекта со слов поклажедателя, в копейках. */
  declared_value?: Maybe<Scalars['Int']['output']>;
  /** Закрытые наряды, которыми хранение продлевалось. */
  extension_work_orders: Array<TireWorkOrder>;
  id: Scalars['ID']['output'];
  intake_work_order: TireWorkOrder;
  /** Строки состава с остатком после выдач. */
  items: Array<TireStorageItem>;
  location: Location;
  location_id: Scalars['ID']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  /** Дней просрочки на сегодня в поясе локации хранения; 0, если срок не вышел или хранение не на складе. */
  overdue_days: Scalars['Int']['output'];
  print_requisites: TirePrintRequisites;
  /** Принято единиц: колёс, покрышек или дисков. */
  quantity: Scalars['Int']['output'];
  rack_no?: Maybe<Scalars['Int']['output']>;
  released_at?: Maybe<Scalars['DateTime']['output']>;
  /** Выдачи по порядку; последняя при нулевом остатке закрывает хранение. */
  releases: Array<TireStorageRelease>;
  /** Осталось на хранении после выдач. */
  remaining_quantity: Scalars['Int']['output'];
  status: TireStorageStatus;
  stored_until?: Maybe<Scalars['Date']['output']>;
  warehouse?: Maybe<TireStorageWarehouse>;
};

export type TireStorageCell = {
  __typename?: 'TireStorageCell';
  cell_no: Scalars['Int']['output'];
  rack_no: Scalars['Int']['output'];
};

/** A paginated list of TireStorage edges. */
export type TireStorageConnection = {
  __typename?: 'TireStorageConnection';
  /** A list of TireStorage edges. */
  edges: Array<TireStorageEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

export enum TireStorageContent {
  Discs = 'DISCS',
  Tires = 'TIRES',
  TiresWithDiscs = 'TIRES_WITH_DISCS'
}

/** An edge that contains a node of type TireStorage and a cursor. */
export type TireStorageEdge = {
  __typename?: 'TireStorageEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The TireStorage node. */
  node: TireStorage;
};

export type TireStorageInput = {
  cellNo?: InputMaybe<Scalars['Int']['input']>;
  /** Повреждения и комплектность при приёме: грыжи, порезы, колпаки. */
  conditionNote?: InputMaybe<Scalars['String']['input']>;
  /** Оценочная стоимость комплекта со слов поклажедателя, в копейках. */
  declaredValue?: InputMaybe<Scalars['Int']['input']>;
  enteredPrice?: InputMaybe<Scalars['Int']['input']>;
  /** Строки состава; всего от 1 до 12 единиц. */
  items: Array<TireStorageItemInput>;
  rackNo?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Строка состава хранения: одинаковые шины, шины с дисками или диски. */
export type TireStorageItem = {
  __typename?: 'TireStorageItem';
  brand?: Maybe<Scalars['String']['output']>;
  content: TireStorageContent;
  disc_model?: Maybe<Scalars['String']['output']>;
  dot?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  /** Осталось на хранении из этой строки. */
  remaining: Scalars['Int']['output'];
  season?: Maybe<TireSeason>;
  tire_profile?: Maybe<Scalars['Int']['output']>;
  tire_width?: Maybe<Scalars['Int']['output']>;
  tread_depth_mm?: Maybe<Scalars['Int']['output']>;
  wheel_diameter: Scalars['Int']['output'];
};

export type TireStorageItemInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  content: TireStorageContent;
  discModel?: InputMaybe<Scalars['String']['input']>;
  dot?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  season?: InputMaybe<TireSeason>;
  tireProfile?: InputMaybe<Scalars['Int']['input']>;
  tireWidth?: InputMaybe<Scalars['Int']['input']>;
  treadDepthMm?: InputMaybe<Scalars['Int']['input']>;
  wheelDiameter: Scalars['Int']['input'];
};

/** Выдача хранения целиком или частью. */
export type TireStorageRelease = {
  __typename?: 'TireStorageRelease';
  id: Scalars['ID']['output'];
  items: Array<TireStorageReleaseItem>;
  released_at: Scalars['DateTime']['output'];
  /** Осталось на хранении после этой выдачи. */
  remaining_quantity: Scalars['Int']['output'];
  storage: TireStorage;
};

export type TireStorageReleaseItem = {
  __typename?: 'TireStorageReleaseItem';
  item_id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type TireStorageReleaseItemInput = {
  itemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export enum TireStorageStatus {
  Draft = 'DRAFT',
  InStock = 'IN_STOCK',
  Released = 'RELEASED'
}

export enum TireStorageTab {
  InStock = 'IN_STOCK',
  Overdue = 'OVERDUE',
  Released = 'RELEASED'
}

/** Склад хранения локации: стеллажи × ячейки. */
export type TireStorageWarehouse = {
  __typename?: 'TireStorageWarehouse';
  cell_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  location_id: Scalars['ID']['output'];
  /** Ячейки, занятые хранениями на складе и черновиками приёма. */
  occupied_cells: Scalars['Int']['output'];
  rack_count: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** Заказ-наряд: услуги по машине клиента или без машины и их оплата. Суммы — в копейках. */
export type TireWorkOrder = {
  __typename?: 'TireWorkOrder';
  booking_group_id?: Maybe<Scalars['ID']['output']>;
  car?: Maybe<TireCar>;
  car_class_id?: Maybe<Scalars['ID']['output']>;
  /** Название класса: у закрытого наряда — на момент закрытия, у открытого — текущее. */
  car_class_title?: Maybe<Scalars['String']['output']>;
  /** Машина в документе: у закрытого наряда — на момент закрытия, у открытого — текущая. */
  car_details?: Maybe<TireCarDetails>;
  client?: Maybe<Client>;
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Кто закрыл: сотрудник, принявший оплату заказа наряда. Пусто у открытого наряда и при оплате по ссылке. */
  closed_by_employee?: Maybe<OrderActor>;
  created_at: Scalars['DateTime']['output'];
  /** Кто открыл. Переиспользует проекцию OrderActor (id + title). */
  created_by_employee?: Maybe<OrderActor>;
  discount_amount: Scalars['Int']['output'];
  discount_percent: Scalars['Int']['output'];
  gross_amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lines: Array<TireWorkOrderLine>;
  location: Location;
  location_id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  order_id?: Maybe<Scalars['ID']['output']>;
  print_requisites: TirePrintRequisites;
  run_flat: Scalars['Boolean']['output'];
  status: TireWorkOrderStatus;
  total_amount: Scalars['Int']['output'];
  /** Размер колёс для новых строк «По машине»; уже добавленные строки помнят свой. */
  wheel_diameter?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of TireWorkOrder edges. */
export type TireWorkOrderConnection = {
  __typename?: 'TireWorkOrderConnection';
  /** A list of TireWorkOrder edges. */
  edges: Array<TireWorkOrderEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type TireWorkOrder and a cursor. */
export type TireWorkOrderEdge = {
  __typename?: 'TireWorkOrderEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The TireWorkOrder node. */
  node: TireWorkOrder;
};

export type TireWorkOrderJournal = {
  __typename?: 'TireWorkOrderJournal';
  open_count: Scalars['Int']['output'];
  /** Последняя смена единственной выбранной локации; пусто при нескольких локациях и выключенных сменах. */
  shift?: Maybe<TireWorkOrderShift>;
};

export type TireWorkOrderLine = {
  __typename?: 'TireWorkOrderLine';
  amount: Scalars['Int']['output'];
  catalog_item_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  kind: TireServiceItemKind;
  price_rule: CatalogPriceRule;
  quantity: Scalars['Int']['output'];
  run_flat: Scalars['Boolean']['output'];
  storage?: Maybe<TireStorage>;
  storage_id?: Maybe<Scalars['ID']['output']>;
  /** Срок хранения после оплаты строки приёма или продления. */
  storage_until?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  unit_price: Scalars['Int']['output'];
  /** Размер колёс, по которому посчитана строка «По машине»; у остальных строк пусто. */
  wheel_diameter?: Maybe<Scalars['Int']['output']>;
};

export type TireWorkOrderShift = {
  __typename?: 'TireWorkOrderShift';
  closed_amount: Scalars['Int']['output'];
  /** Пусто, пока смена открыта. */
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Наряды, закрытые в пределах смены. */
  closed_count: Scalars['Int']['output'];
  opened_at: Scalars['DateTime']['output'];
};

export enum TireWorkOrderStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type TrackUploadUrl = {
  __typename?: 'TrackUploadUrl';
  expiresAt: Scalars['DateTime']['output'];
  s3Path: Scalars['String']['output'];
  trackId: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

/** Расписание одного ресурса за диапазон дат. Паритет UnitScheduleResource. */
export type UnitSchedule = {
  __typename?: 'UnitSchedule';
  index: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  is_deleted: Scalars['Boolean']['output'];
  schedule: Array<BookingScheduleSlot>;
  unit_id: Scalars['ID']['output'];
  unit_title: Scalars['String']['output'];
};

/** Исходный период временной недоступности unit в полуоткрытом UTC-интервале [start, end). */
export type UnitUnavailability = {
  __typename?: 'UnitUnavailability';
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  unit_id: Scalars['ID']['output'];
};

/** Безопасная проекция брони, конфликтующей с создаваемой недоступностью. */
export type UnitUnavailabilityBookingConflict = {
  __typename?: 'UnitUnavailabilityBookingConflict';
  booking_id: Scalars['ID']['output'];
  client_title?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  group_id: Scalars['ID']['output'];
  service_title?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
};

/** Результат writer-мутации: при конфликте период не сохраняется. */
export type UnitUnavailabilityMutationPayload = {
  __typename?: 'UnitUnavailabilityMutationPayload';
  conflicts: Array<UnitUnavailabilityBookingConflict>;
  unit_unavailability?: Maybe<UnitUnavailability>;
};

/** Текущие и будущие периоды всех unit текущей локации. */
export type UnitUnavailabilityPage = {
  __typename?: 'UnitUnavailabilityPage';
  data: Array<UnitUnavailability>;
  meta: UnitUnavailabilityPageMeta;
};

export type UnitUnavailabilityPageMeta = {
  __typename?: 'UnitUnavailabilityPageMeta';
  current_page: Scalars['Int']['output'];
  from?: Maybe<Scalars['Int']['output']>;
  last_page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

/**
 * Обновление слотов, комментария и скидки группы бронирований.
 * `status` отсутствует намеренно: UpdateBookingGroupAction статус не меняет
 * (смена статуса — отдельная мутация updateBookingStatus), клиент меняется через
 * replaceBookingClient, а subtotal/price рассчитывает сервер.
 */
export type UpdateBookingInput = {
  discount?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  slots: Array<BookingSlotInput>;
};

/** Смена статуса группы броней. Паритет BookingStatusUpdateRequest. */
export type UpdateBookingStatusInput = {
  cancellationReason?: InputMaybe<BookingCancellationReason>;
  status: BookingStatus;
};

export type UpdateBookingUnitInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessLocationAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  full_address?: InputMaybe<Scalars['String']['input']>;
  house?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessLocationDetailsInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_bik?: InputMaybe<Scalars['String']['input']>;
  bank_correspondent_account?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<LocationColor>;
  email?: InputMaybe<Scalars['String']['input']>;
  legal_address?: InputMaybe<Scalars['String']['input']>;
  legal_director_name?: InputMaybe<Scalars['String']['input']>;
  legal_form?: InputMaybe<LegalForm>;
  legal_kpp?: InputMaybe<Scalars['String']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  legal_ogrn?: InputMaybe<Scalars['String']['input']>;
  legal_tin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessSettingsInput = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  resource_term?: InputMaybe<ResourceTerm>;
  sphere_id?: InputMaybe<OrganizationSphere>;
  title?: InputMaybe<Scalars['String']['input']>;
  vk_url?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Паритет ClientUpdateRequest. Все поля nullable — применяются только
 * переданные (частичное обновление, как в REST-контроллере).
 */
export type UpdateClientInput = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalForm?: InputMaybe<LegalForm>;
  legalKpp?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalTin?: InputMaybe<Scalars['String']['input']>;
  marketingSourceId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patronymicName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<ClientSex>;
};

export type UpdateEmployeeInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_all_locations_access?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  role_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateMarketingSourceInput = {
  isManualSelectable?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMessengerChannelInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  confirmation?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  screen_name?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyProfileInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  patronymicName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderFiscalizationSettingsInput = {
  cashierLastName?: InputMaybe<Scalars['String']['input']>;
  cashierPosition?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  expectedConfigVersion?: InputMaybe<Scalars['Int']['input']>;
  expectedKktInn?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  paymentMethod?: OrderFiscalPaymentMethod;
  paymentSubject?: OrderFiscalPaymentSubject;
  provider?: OrderFiscalizationProvider;
  shiftsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxationSystem?: OrderFiscalTaxationSystem;
  vatRate?: OrderFiscalVatRate;
};

export type UpdateQrLinkInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  styleConfig?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRadioPlaylistInput = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRadioTrackInput = {
  artist?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScenarioInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  availableProviders?: InputMaybe<Array<Scalars['String']['input']>>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  flowDefinition?: InputMaybe<Array<ScenarioStepInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  marketingSourceId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Бонус за регистрацию по ссылке: не передано — без изменений, null — сумма из автоматизации, 0 — без бонуса. */
  registrationBonusPoints?: InputMaybe<Scalars['Int']['input']>;
  restartOnReactivation?: InputMaybe<Scalars['Boolean']['input']>;
  stopIfBooked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSopInput = {
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createVersion?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSopSectionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Изменение границ и причины; unit периода неизменяем. */
export type UpdateUnitUnavailabilityInput = {
  end: Scalars['DateTime']['input'];
  reason: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
};

export type UpdateWebPushNotificationPreferenceInput = {
  enabled: Scalars['Boolean']['input'];
  kind: WebPushNotificationKind;
};

export type UpsertBookingCatalogInput = {
  services: Array<BookingCatalogServiceInput>;
  /** Порядок элементов задаёт сохраняемый index ресурсов. */
  units: Array<BookingCatalogUnitInput>;
};

export type UpsertLocationScheduleInput = {
  days: Array<LocationScheduleDayInput>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpsertLoyaltyProgramInput = {
  expiryMonths: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  maxRedemptionPercent?: Scalars['Int']['input'];
  tiers?: Array<LoyaltyTierInput>;
  /** @deprecated Сумма бонуса за регистрацию задаётся в автоматизации «Бонус за регистрацию». */
  welcomePoints?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertWebPushSubscriptionInput = {
  auth: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_super_user?: Maybe<Scalars['Boolean']['output']>;
  last_activity_at?: Maybe<Scalars['DateTime']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  patronymic_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  telegram_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  web_push_notification_preferences: Array<WebPushNotificationPreference>;
};

export type VoidInvoiceReceiptInput = {
  reason: Scalars['String']['input'];
  receiptId: Scalars['ID']['input'];
};

export type WebPushCapability = {
  __typename?: 'WebPushCapability';
  enabled: Scalars['Boolean']['output'];
  public_key?: Maybe<Scalars['String']['output']>;
};

export type WebPushContext = {
  __typename?: 'WebPushContext';
  capability: WebPushCapability;
  preferences: Array<WebPushNotificationPreference>;
};

export type WebPushEndpointInput = {
  endpoint: Scalars['String']['input'];
};

export enum WebPushNotificationKind {
  BookingCreatedOnline = 'BOOKING_CREATED_ONLINE',
  MessengerMessageReceived = 'MESSENGER_MESSAGE_RECEIVED'
}

export type WebPushNotificationPreference = {
  __typename?: 'WebPushNotificationPreference';
  available?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  kind: WebPushNotificationKind;
};

export type GetAnalyticsOverviewQueryVariables = Exact<{
  period: AnalyticsPeriodInput;
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAnalyticsOverviewQuery = { __typename?: 'Query', analyticsOverview: { __typename?: 'AnalyticsOverview', trend_granularity: AnalyticsTrendGranularity, kpis: { __typename?: 'AnalyticsKpis', revenue_total: number, orders_count: number, avg_check: number, visits_count: number, new_clients_count: number, utilization_percent?: number | null, available_unit_hours?: number | null }, kpis_comparable: { __typename?: 'AnalyticsKpis', revenue_total: number, orders_count: number, avg_check: number, visits_count: number, new_clients_count: number, utilization_percent?: number | null, available_unit_hours?: number | null }, kpis_previous: { __typename?: 'AnalyticsKpis', revenue_total: number, orders_count: number, avg_check: number, visits_count: number, new_clients_count: number, utilization_percent?: number | null, available_unit_hours?: number | null }, comparison: { __typename?: 'AnalyticsComparisonWindow', mode: AnalyticsComparisonMode, current_date_from?: string | null, current_date_to?: string | null, previous_date_from?: string | null, previous_date_to?: string | null, excluded_incomplete_day?: string | null, equal_length: boolean }, locations: Array<{ __typename?: 'LocationAnalyticsRow', location_id: string, title: string, closed_from?: string | null, is_closed: boolean, revenue_total: number, revenue_comparable: number, revenue_previous: number, utilization_percent?: number | null, utilization_norm_percent?: number | null, utilization_deviation_percent?: number | null, utilization_days_below_norm?: number | null, utilization_days_compared?: number | null, utilization_norm_state: AnalyticsUtilizationNormState, utilization_norm_unavailable_reason?: AnalyticsUtilizationNormUnavailableReason | null, utilization_norm_window_start?: string | null, utilization_norm_window_end?: string | null, revenue_per_unit_hour?: number | null, new_clients_count: number, revenue_trend: Array<{ __typename?: 'AnalyticsSeriesPoint', date: string, value: number, is_partial: boolean }> }>, revenue_series: Array<{ __typename?: 'AnalyticsSeriesPoint', date: string, value: number, is_partial: boolean }>, revenue_series_previous: Array<{ __typename?: 'AnalyticsSeriesPoint', date: string, value: number, is_partial: boolean }>, utilization_series: Array<{ __typename?: 'AnalyticsUtilizationPoint', date: string, utilization_percent?: number | null, available_unit_hours: number, occupied_unit_hours: number }>, utilization_series_previous: Array<{ __typename?: 'AnalyticsUtilizationPoint', date: string, utilization_percent?: number | null, available_unit_hours: number, occupied_unit_hours: number }>, top_services: Array<{ __typename?: 'AnalyticsTopService', catalog_item_id?: string | null, title: string, revenue_total: number, row_kind: AnalyticsBreakdownRowKind }>, new_client_sources: Array<{ __typename?: 'AnalyticsNewClientSource', source_id?: string | null, title: string, clients_count: number, row_kind: AnalyticsBreakdownRowKind }> } };

export type GetAnalyticsMetricDetailQueryVariables = Exact<{
  period: AnalyticsPeriodInput;
}>;


export type GetAnalyticsMetricDetailQuery = { __typename?: 'Query', analyticsOverview: { __typename?: 'AnalyticsOverview', trend_granularity: AnalyticsTrendGranularity, kpis: { __typename?: 'AnalyticsKpis', revenue_total: number }, kpis_comparable: { __typename?: 'AnalyticsKpis', revenue_total: number }, kpis_previous: { __typename?: 'AnalyticsKpis', revenue_total: number }, comparison: { __typename?: 'AnalyticsComparisonWindow', mode: AnalyticsComparisonMode, current_date_from?: string | null, current_date_to?: string | null, previous_date_from?: string | null, previous_date_to?: string | null, excluded_incomplete_day?: string | null, equal_length: boolean }, revenue_series: Array<{ __typename?: 'AnalyticsSeriesPoint', date: string, value: number, is_partial: boolean }>, locations: Array<{ __typename?: 'LocationAnalyticsRow', location_id: string, title: string, closed_from?: string | null, is_closed: boolean, revenue_total: number, revenue_series: Array<{ __typename?: 'AnalyticsSeriesPoint', date: string, value: number, is_partial: boolean }> }> } };

export type AuthLocationFragmentFragment = { __typename?: 'Location', id: string, location_id: string, organization_id: string, alias?: string | null, title: string, short_name: string, color: LocationColor, enabled: boolean, photo?: string | null, icon?: string | null, city?: string | null, address?: string | null, full_address?: string | null, phone?: string | null, latitude?: number | null, longitude?: number | null, coordinate?: Array<number | null> | null, timezone: string, opened_from?: string | null, closed_from?: string | null };

export type AuthOrganizationFragmentFragment = { __typename?: 'Organization', id: string, alias?: string | null, title: string, sphere_id?: OrganizationSphere | null, resource_term: ResourceTerm, domain?: string | null, enabled_modules: Array<OrganizationModule>, known_add_ons: Array<OrganizationModule>, timezone: string, currency: OrganizationCurrency, country_code?: string | null, has_locations: boolean, created_at?: string | null, updated_at?: string | null, locations?: Array<{ __typename?: 'Location', id: string, location_id: string, organization_id: string, alias?: string | null, title: string, short_name: string, color: LocationColor, enabled: boolean, photo?: string | null, icon?: string | null, city?: string | null, address?: string | null, full_address?: string | null, phone?: string | null, latitude?: number | null, longitude?: number | null, coordinate?: Array<number | null> | null, timezone: string, opened_from?: string | null, closed_from?: string | null }> | null };

export type AuthContextQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthContextQuery = { __typename?: 'Query', authContext: { __typename?: 'AuthContext', permissions: Array<string>, user?: { __typename?: 'User', id: string, phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, telegram_id?: string | null, is_super_user?: boolean | null } | null, employee?: { __typename?: 'Employee', id: string, title?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone?: string | null, employee_id: string, role_id?: string | null, status: EmployeeStatus, fired_at?: string | null, fired_reason?: string | null, created_at: string, last_activity_at?: string | null, has_all_locations_access: boolean, location_ids: Array<string>, is_owner: boolean } | null, organization?: { __typename?: 'Organization', id: string, alias?: string | null, title: string, sphere_id?: OrganizationSphere | null, resource_term: ResourceTerm, domain?: string | null, enabled_modules: Array<OrganizationModule>, known_add_ons: Array<OrganizationModule>, timezone: string, currency: OrganizationCurrency, country_code?: string | null, has_locations: boolean, created_at?: string | null, updated_at?: string | null, locations?: Array<{ __typename?: 'Location', id: string, location_id: string, organization_id: string, alias?: string | null, title: string, short_name: string, color: LocationColor, enabled: boolean, photo?: string | null, icon?: string | null, city?: string | null, address?: string | null, full_address?: string | null, phone?: string | null, latitude?: number | null, longitude?: number | null, coordinate?: Array<number | null> | null, timezone: string, opened_from?: string | null, closed_from?: string | null }> | null } | null, location?: { __typename?: 'Location', id: string, location_id: string, organization_id: string, alias?: string | null, title: string, short_name: string, color: LocationColor, enabled: boolean, photo?: string | null, icon?: string | null, city?: string | null, address?: string | null, full_address?: string | null, phone?: string | null, latitude?: number | null, longitude?: number | null, coordinate?: Array<number | null> | null, timezone: string, opened_from?: string | null, closed_from?: string | null } | null, available_organizations: Array<{ __typename?: 'Organization', id: string, alias?: string | null, title: string, sphere_id?: OrganizationSphere | null, resource_term: ResourceTerm, domain?: string | null, enabled_modules: Array<OrganizationModule>, known_add_ons: Array<OrganizationModule>, timezone: string, currency: OrganizationCurrency, country_code?: string | null, has_locations: boolean, created_at?: string | null, updated_at?: string | null, locations?: Array<{ __typename?: 'Location', id: string, location_id: string, organization_id: string, alias?: string | null, title: string, short_name: string, color: LocationColor, enabled: boolean, photo?: string | null, icon?: string | null, city?: string | null, address?: string | null, full_address?: string | null, phone?: string | null, latitude?: number | null, longitude?: number | null, coordinate?: Array<number | null> | null, timezone: string, opened_from?: string | null, closed_from?: string | null }> | null }> }, impersonationState: { __typename?: 'ImpersonationState', active: boolean, session_id?: string | null, started_at?: string | null, impersonator?: { __typename?: 'User', id: string, phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, is_super_user?: boolean | null } | null, target_user?: { __typename?: 'User', id: string, phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, is_super_user?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string, alias?: string | null, title: string } | null } };

export type BookingGroupAuditLogFragment = { __typename?: 'BookingGroupAuditLog', id: string, action: BookingAuditAction, changed_by_type: BookingCreatorType, changed_via: BookingPlatform, changed_fields: any, old_data?: any | null, new_data: any, created_at: string, changed_by_employee?: { __typename?: 'BookingActor', id: string, title?: string | null } | null };

export type GetBookingGroupAuditLogsQueryVariables = Exact<{
  bookingGroupId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBookingGroupAuditLogsQuery = { __typename?: 'Query', bookingGroupAuditLogs: { __typename?: 'BookingGroupAuditLogConnection', edges: Array<{ __typename?: 'BookingGroupAuditLogEdge', cursor: string, node: { __typename?: 'BookingGroupAuditLog', id: string, action: BookingAuditAction, changed_by_type: BookingCreatorType, changed_via: BookingPlatform, changed_fields: any, old_data?: any | null, new_data: any, created_at: string, changed_by_employee?: { __typename?: 'BookingActor', id: string, title?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type BookingClientProfileClientFragment = { __typename?: 'BookingClientProfileClient', id: string, type: ClientType, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, sex?: ClientSex | null, birthday?: string | null, importance?: string | null, discount?: number | null, note?: string | null, created_at: string, last_visit_at?: string | null, marketing_source_id?: string | null };

export type BookingClientRecentSlotFragment = { __typename?: 'BookingClientRecentSlot', id: string, start: string, end: string, service_title?: string | null, unit_title?: string | null };

export type BookingClientRecentBookingFragment = { __typename?: 'BookingClientRecentBooking', id: string, min_start: string, max_end?: string | null, status: BookingStatus, discount: number, subtotal_price?: number | null, price?: number | null, location_id: string, location_title: string, slots: Array<{ __typename?: 'BookingClientRecentSlot', id: string, start: string, end: string, service_title?: string | null, unit_title?: string | null }> };

export type GetBookingClientProfileQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetBookingClientProfileQuery = { __typename?: 'Query', bookingClientProfile?: { __typename?: 'BookingClientProfile', visits_count: number, hours_total: number, client: { __typename?: 'BookingClientProfileClient', id: string, type: ClientType, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, sex?: ClientSex | null, birthday?: string | null, importance?: string | null, discount?: number | null, note?: string | null, created_at: string, last_visit_at?: string | null, marketing_source_id?: string | null }, recent_bookings: Array<{ __typename?: 'BookingClientRecentBooking', id: string, min_start: string, max_end?: string | null, status: BookingStatus, discount: number, subtotal_price?: number | null, price?: number | null, location_id: string, location_title: string, slots: Array<{ __typename?: 'BookingClientRecentSlot', id: string, start: string, end: string, service_title?: string | null, unit_title?: string | null }> }> } | null };

export type GetBookingSettingsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetBookingSettingsQuery = { __typename?: 'Query', locationSchedule: { __typename?: 'LocationSchedule', current: Array<{ __typename?: 'LocationScheduleDay', day_of_week: ScheduleWeekday, is_day_off: boolean, start?: string | null, end?: string | null, closes_next_day: boolean, effective_from: string }>, upcoming: Array<{ __typename?: 'LocationScheduleDay', day_of_week: ScheduleWeekday, is_day_off: boolean, start?: string | null, end?: string | null, closes_next_day: boolean, effective_from: string }> }, bookingSettingsServices: Array<{ __typename?: 'BookingSettingsService', id: string, unit_ids: Array<string> }>, bookingSettingsUnits: Array<{ __typename?: 'BookingSettingsUnit', id: string, title: string, is_active: boolean, active_unavailability?: { __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string } | null }> };

export type GetBookingScheduleQueryVariables = Exact<{
  start: Scalars['Date']['input'];
  end: Scalars['Date']['input'];
}>;


export type GetBookingScheduleQuery = { __typename?: 'Query', bookingSchedule: Array<{ __typename?: 'UnitSchedule', unit_id: string, unit_title: string, index: string, is_active: boolean, is_deleted: boolean, schedule: Array<{ __typename?: 'BookingScheduleSlot', type: BookingScheduleSlotType, start: string, end: string, reason?: string | null, unavailability?: { __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string } | null, booking_details?: { __typename?: 'BookingSlotDetails', booking_id: string, group_id: string, unit_id: string, status: BookingStatus, payment_status?: BookingPaymentStatus | null, payment_delegation?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, tariff_price?: number | null, tariff_duration?: number | null, service_title?: string | null, note: string, discount: number, subtotal_price?: number | null, price?: number | null, client_summary?: { __typename?: 'BookingSlotClientSummary', id: string, title?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone?: string | null, importance?: string | null } | null } | null }> }> };

export type GetBookingServiceCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookingServiceCatalogQuery = { __typename?: 'Query', bookingServiceCatalog: Array<{ __typename?: 'BookingSettingsService', id: string, title: string, price_rule: CatalogPriceRule, price?: number | null, min_duration_minutes: number, max_duration_minutes: number, slot_step_minutes: number, unit_ids: Array<string>, tariffs: Array<{ __typename?: 'BookingSettingsTariff', id: string, duration_minutes: number, price: number, available_online: boolean }> }> };

export type GetUnitUnavailabilitiesQueryVariables = Exact<{
  unitId?: InputMaybe<Scalars['ID']['input']>;
  activeOrFuture?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUnitUnavailabilitiesQuery = { __typename?: 'Query', unitUnavailabilities: { __typename?: 'UnitUnavailabilityPage', data: Array<{ __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string }> } };

export type BroadcastSnapshotFieldsFragment = { __typename?: 'MarketingBroadcastAudienceSnapshot', id: string, definition_version: number, status: BroadcastAudienceSnapshotStatus, as_of: string, total_count: number, ready_count: number, excluded_count: number, no_channel_count: number, linked_ready_count: number, unlinked_ready_count: number, failed_reason?: string | null, windows: Array<{ __typename?: 'BroadcastAudienceWindow', rule_id: string, months: number, from_at: string, to_at: string }>, channel_counts: Array<{ __typename?: 'BroadcastAudienceChannelCount', channel_label: string, count: number }> };

export type BroadcastFieldsFragment = { __typename?: 'MarketingBroadcast', id: string, name: string, body: string, version: number, audience_definition_version: number, audience_snapshot_id?: string | null, status: MarketingBroadcastStatus, bonus_enabled: boolean, bonus_amount?: number | null, bonus_expires_on?: string | null, bonus_timezone?: string | null, bonus_expires_at?: string | null, total_count: number, sent_count: number, failed_count: number, unknown_count: number, started_at?: string | null, snapshot_at?: string | null, completed_at?: string | null, failed_reason?: string | null, created_at: string, updated_at: string, audience_definition?: { __typename?: 'BroadcastAudienceDefinition', additions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }>, exclusions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }> } | null, audience_snapshot?: { __typename?: 'MarketingBroadcastAudienceSnapshot', id: string, definition_version: number, status: BroadcastAudienceSnapshotStatus, as_of: string, total_count: number, ready_count: number, excluded_count: number, no_channel_count: number, linked_ready_count: number, unlinked_ready_count: number, failed_reason?: string | null, windows: Array<{ __typename?: 'BroadcastAudienceWindow', rule_id: string, months: number, from_at: string, to_at: string }>, channel_counts: Array<{ __typename?: 'BroadcastAudienceChannelCount', channel_label: string, count: number }> } | null, image?: { __typename?: 'MarketingBroadcastImage', url: string, file_name: string, mime_type: string, file_size: number, width: number, height: number } | null };

export type GetMarketingBroadcastsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMarketingBroadcastsQuery = { __typename?: 'Query', marketingBroadcasts: { __typename?: 'MarketingBroadcastConnection', edges: Array<{ __typename?: 'MarketingBroadcastEdge', cursor: string, node: { __typename?: 'MarketingBroadcast', id: string, name: string, body: string, version: number, audience_definition_version: number, audience_snapshot_id?: string | null, status: MarketingBroadcastStatus, bonus_enabled: boolean, bonus_amount?: number | null, bonus_expires_on?: string | null, bonus_timezone?: string | null, bonus_expires_at?: string | null, total_count: number, sent_count: number, failed_count: number, unknown_count: number, started_at?: string | null, snapshot_at?: string | null, completed_at?: string | null, failed_reason?: string | null, created_at: string, updated_at: string, audience_definition?: { __typename?: 'BroadcastAudienceDefinition', additions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }>, exclusions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }> } | null, audience_snapshot?: { __typename?: 'MarketingBroadcastAudienceSnapshot', id: string, definition_version: number, status: BroadcastAudienceSnapshotStatus, as_of: string, total_count: number, ready_count: number, excluded_count: number, no_channel_count: number, linked_ready_count: number, unlinked_ready_count: number, failed_reason?: string | null, windows: Array<{ __typename?: 'BroadcastAudienceWindow', rule_id: string, months: number, from_at: string, to_at: string }>, channel_counts: Array<{ __typename?: 'BroadcastAudienceChannelCount', channel_label: string, count: number }> } | null, image?: { __typename?: 'MarketingBroadcastImage', url: string, file_name: string, mime_type: string, file_size: number, width: number, height: number } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetMarketingBroadcastQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMarketingBroadcastQuery = { __typename?: 'Query', marketingBroadcast?: { __typename?: 'MarketingBroadcast', id: string, name: string, body: string, version: number, audience_definition_version: number, audience_snapshot_id?: string | null, status: MarketingBroadcastStatus, bonus_enabled: boolean, bonus_amount?: number | null, bonus_expires_on?: string | null, bonus_timezone?: string | null, bonus_expires_at?: string | null, total_count: number, sent_count: number, failed_count: number, unknown_count: number, started_at?: string | null, snapshot_at?: string | null, completed_at?: string | null, failed_reason?: string | null, created_at: string, updated_at: string, audience_definition?: { __typename?: 'BroadcastAudienceDefinition', additions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }>, exclusions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }> } | null, audience_snapshot?: { __typename?: 'MarketingBroadcastAudienceSnapshot', id: string, definition_version: number, status: BroadcastAudienceSnapshotStatus, as_of: string, total_count: number, ready_count: number, excluded_count: number, no_channel_count: number, linked_ready_count: number, unlinked_ready_count: number, failed_reason?: string | null, windows: Array<{ __typename?: 'BroadcastAudienceWindow', rule_id: string, months: number, from_at: string, to_at: string }>, channel_counts: Array<{ __typename?: 'BroadcastAudienceChannelCount', channel_label: string, count: number }> } | null, image?: { __typename?: 'MarketingBroadcastImage', url: string, file_name: string, mime_type: string, file_size: number, width: number, height: number } | null } | null };

export type GetMarketingBroadcastAudienceEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketingBroadcastAudienceEnabledQuery = { __typename?: 'Query', marketingBroadcastAudienceEnabled: boolean };

export type GetBroadcastExclusionsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetBroadcastExclusionsQuery = { __typename?: 'Query', marketingBroadcasts: { __typename?: 'MarketingBroadcastConnection', edges: Array<{ __typename?: 'MarketingBroadcastEdge', node: { __typename?: 'MarketingBroadcast', id: string, name: string, started_at?: string | null, status: MarketingBroadcastStatus } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type BroadcastDeliveryFieldsFragment = { __typename?: 'MarketingBroadcastRecipient', id: string, client_id?: string | null, conversation_id: string, channel_id: string, external_chat_id?: string | null, audience_entry_id?: string | null, message_id?: string | null, status: MarketingBroadcastRecipientStatus, failed_reason?: string | null, loyalty_transaction_id?: string | null };

export type GetMarketingBroadcastAudienceEntriesQueryVariables = Exact<{
  broadcastId: Scalars['ID']['input'];
  snapshotId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  decision?: InputMaybe<BroadcastAudienceEntryDecision>;
  status?: InputMaybe<MarketingBroadcastRecipientStatus>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMarketingBroadcastAudienceEntriesQuery = { __typename?: 'Query', marketingBroadcastAudienceEntries: { __typename?: 'MarketingBroadcastAudienceEntryConnection', edges: Array<{ __typename?: 'MarketingBroadcastAudienceEntryEdge', node: { __typename?: 'MarketingBroadcastAudienceEntry', id: string, client_id?: string | null, conversation_id?: string | null, channel_id?: string | null, external_chat_id?: string | null, recipient_name: string, recipient_username?: string | null, channel_label?: string | null, decision: BroadcastAudienceEntryDecision, unavailable_reason?: BroadcastAudienceUnavailableReason | null, client?: { __typename?: 'Client', id: string, phone_masked?: string | null } | null, inclusion_reasons: Array<{ __typename?: 'BroadcastAudienceReason', rule_id: string, kind: BroadcastAudienceRuleKind, months?: number | null, from_at?: string | null, to_at?: string | null, last_booking_at?: string | null, broadcast_id?: string | null, broadcast_name?: string | null }>, exclusion_reasons: Array<{ __typename?: 'BroadcastAudienceReason', rule_id: string, kind: BroadcastAudienceRuleKind, months?: number | null, from_at?: string | null, to_at?: string | null, last_booking_at?: string | null, broadcast_id?: string | null, broadcast_name?: string | null }>, delivery?: { __typename?: 'MarketingBroadcastRecipient', id: string, client_id?: string | null, conversation_id: string, channel_id: string, external_chat_id?: string | null, audience_entry_id?: string | null, message_id?: string | null, status: MarketingBroadcastRecipientStatus, failed_reason?: string | null, loyalty_transaction_id?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetMarketingBroadcastTestRecipientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketingBroadcastTestRecipientsQuery = { __typename?: 'Query', marketingBroadcastTestRecipients: Array<{ __typename?: 'MarketingBroadcastTestRecipient', client_id: string, conversation_id: string, channel_id: string, channel_title: string, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } | null }> };

export type GetMarketingBroadcastTestDeliveryQueryVariables = Exact<{
  broadcastId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}>;


export type GetMarketingBroadcastTestDeliveryQuery = { __typename?: 'Query', marketingBroadcastTestDelivery: { __typename?: 'MarketingBroadcastTestDelivery', message_id?: string | null, status: MarketingBroadcastRecipientStatus, failed_reason?: string | null } };

export type CatalogItemFieldsFragment = { __typename?: 'CatalogItem', id: string, kind: CatalogItemKind, category_id?: string | null, title: string, position: number, price_rule: CatalogPriceRule, fixed_price?: number | null, range_min?: number | null, range_max?: number | null, booking_min_duration_minutes?: number | null, booking_max_duration_minutes?: number | null, booking_slot_step_minutes?: number | null, booking_available_online: boolean, archived: boolean, price_from?: number | null, allowed_price_rules: Array<CatalogPriceRule>, booking_allowed: boolean, archive_allowed: boolean, tariffs: Array<{ __typename?: 'CatalogTariff', id: string, duration_minutes: number, price: number, available_online: boolean, locations: Array<{ __typename?: 'CatalogTariffLocation', location_id: string, price?: number | null }> }>, locations: Array<{ __typename?: 'CatalogItemLocation', location_id: string, price?: number | null }> };

export type GetCatalogCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCatalogCategoriesQuery = { __typename?: 'Query', catalogCategories: Array<{ __typename?: 'CatalogCategory', id: string, title: string, position: number }> };

export type GetCatalogItemsQueryVariables = Exact<{
  kind?: InputMaybe<CatalogItemKind>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCatalogItemsQuery = { __typename?: 'Query', catalogItems: Array<{ __typename?: 'CatalogItem', id: string, kind: CatalogItemKind, category_id?: string | null, title: string, position: number, price_rule: CatalogPriceRule, fixed_price?: number | null, range_min?: number | null, range_max?: number | null, booking_min_duration_minutes?: number | null, booking_max_duration_minutes?: number | null, booking_slot_step_minutes?: number | null, booking_available_online: boolean, archived: boolean, price_from?: number | null, allowed_price_rules: Array<CatalogPriceRule>, booking_allowed: boolean, archive_allowed: boolean, tariffs: Array<{ __typename?: 'CatalogTariff', id: string, duration_minutes: number, price: number, available_online: boolean, locations: Array<{ __typename?: 'CatalogTariffLocation', location_id: string, price?: number | null }> }>, locations: Array<{ __typename?: 'CatalogItemLocation', location_id: string, price?: number | null }> }> };

export type ClientAutomationFieldsFragment = { __typename?: 'ClientAutomation', id?: string | null, kind: ClientAutomationKind, section: ClientAutomationSection, title: string, kind_title: string, description: string, enabled: boolean, channel_policy: ClientAutomationChannelPolicy, quiet_hours_mode: ClientAutomationQuietHoursMode, trigger_value?: number | null, bonus_points?: number | null, bonus_expiry_days?: number | null, template: string, default_template: string, variables: Array<string>, button_label?: string | null, required: boolean, footer?: string | null, link_code?: string | null, is_modified: boolean, active_providers: Array<MessengerProvider>, trigger_options: Array<{ __typename?: 'ClientAutomationTriggerOption', value: number, description: string, quiet_hours_mode: ClientAutomationQuietHoursMode }>, last_30_days: { __typename?: 'ClientAutomationCounters', sent: number, delivered: number, failed: number } };

export type GetClientAutomationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientAutomationsQuery = { __typename?: 'Query', clientAutomations: Array<{ __typename?: 'ClientAutomation', id?: string | null, kind: ClientAutomationKind, section: ClientAutomationSection, title: string, kind_title: string, description: string, enabled: boolean, channel_policy: ClientAutomationChannelPolicy, quiet_hours_mode: ClientAutomationQuietHoursMode, trigger_value?: number | null, bonus_points?: number | null, bonus_expiry_days?: number | null, template: string, default_template: string, variables: Array<string>, button_label?: string | null, required: boolean, footer?: string | null, link_code?: string | null, is_modified: boolean, active_providers: Array<MessengerProvider>, trigger_options: Array<{ __typename?: 'ClientAutomationTriggerOption', value: number, description: string, quiet_hours_mode: ClientAutomationQuietHoursMode }>, last_30_days: { __typename?: 'ClientAutomationCounters', sent: number, delivered: number, failed: number } }> };

export type GetClientQuietHoursQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientQuietHoursQuery = { __typename?: 'Query', clientQuietHours: { __typename?: 'ClientQuietHours', enabled: boolean, start: string, end: string } };

export type GetClientAutomationStatisticsQueryVariables = Exact<{
  kind: ClientAutomationKind;
  id?: InputMaybe<Scalars['ID']['input']>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
}>;


export type GetClientAutomationStatisticsQuery = { __typename?: 'Query', clientAutomationStatistics: { __typename?: 'ClientAutomationStatistics', dates: Array<string>, totals: { __typename?: 'ClientAutomationCounters', sent: number, delivered: number, failed: number }, by_channel: Array<{ __typename?: 'ClientAutomationChannelStatistics', provider: MessengerProvider, sent: number, delivered: number, failed: number }>, series: Array<{ __typename?: 'ClientAutomationSeries', provider: MessengerProvider, values: Array<number> }> } };

export type GetClientAutomationSampleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientAutomationSampleQuery = { __typename?: 'Query', clientAutomationSample: { __typename?: 'ClientAutomationSample', date: string, time: string, services: string, location: string, address: string, booking_link: string } };

export type GetClientAutomationTestRecipientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientAutomationTestRecipientsQuery = { __typename?: 'Query', clientAutomationTestRecipients: Array<{ __typename?: 'MarketingBroadcastTestRecipient', client_id: string, conversation_id: string, channel_id: string, channel_title: string, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null } | null }> };

export type ClientSegmentFieldsFragment = { __typename?: 'ClientSegment', id: string, kind: ClientSegmentKind, code?: ClientSegmentStandardCode | null, name: string, description: string, badge_enabled: boolean, badge_color?: string | null, is_modified: boolean, position: number, clients_count: number, members_computed_at?: string | null, rules: Array<{ __typename?: 'ClientSegmentRule', subject: ClientSegmentRuleSubject, predicate: ClientSegmentRulePredicate, value?: number | null, values: Array<string>, window?: { __typename?: 'ClientSegmentRuleWindow', unit: ClientSegmentWindowUnit, amount: number } | null, conditions: Array<{ __typename?: 'ClientSegmentRuleCondition', field: ClientSegmentConditionField, operator: ClientSegmentConditionOperator, activity_types: Array<ClientActivityType>, location_ids: Array<string>, booking_channels: Array<BookingPlatform> }> }> };

export type GetClientSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientSegmentsQuery = { __typename?: 'Query', clientSegments: Array<{ __typename?: 'ClientSegment', id: string, kind: ClientSegmentKind, code?: ClientSegmentStandardCode | null, name: string, description: string, badge_enabled: boolean, badge_color?: string | null, is_modified: boolean, position: number, clients_count: number, members_computed_at?: string | null, rules: Array<{ __typename?: 'ClientSegmentRule', subject: ClientSegmentRuleSubject, predicate: ClientSegmentRulePredicate, value?: number | null, values: Array<string>, window?: { __typename?: 'ClientSegmentRuleWindow', unit: ClientSegmentWindowUnit, amount: number } | null, conditions: Array<{ __typename?: 'ClientSegmentRuleCondition', field: ClientSegmentConditionField, operator: ClientSegmentConditionOperator, activity_types: Array<ClientActivityType>, location_ids: Array<string>, booking_channels: Array<BookingPlatform> }> }> }> };

export type GetClientSegmentPreviewQueryVariables = Exact<{
  rules: Array<ClientSegmentRuleInput> | ClientSegmentRuleInput;
}>;


export type GetClientSegmentPreviewQuery = { __typename?: 'Query', clientSegmentPreview: { __typename?: 'ClientSegmentPreview', clients_count: number } };

export type ClientWithLocationsFragment = { __typename?: 'Client', id: string, type: ClientType, legal_form?: LegalForm | null, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, sex?: ClientSex | null, birthday?: string | null, importance?: string | null, discount?: number | null, visits_count?: number | null, hours_total?: number | null, ltv?: number | null, avg_check?: number | null, note?: string | null, created_at: string, last_visit_at?: string | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, first_visit_location?: { __typename?: 'Location', id: string, title: string } | null, last_visit_location?: { __typename?: 'Location', id: string, title: string } | null, active_scenario_runs: Array<{ __typename?: 'ScenarioRun', id: string, current_step_index: number, status: ScenarioRunStatus, started_at?: string | null, last_step_at?: string | null, scenario: { __typename?: 'Scenario', id: string, name: string, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null }> } }> };

export type BookingClientOptionFragment = { __typename?: 'Client', id: string, type: ClientType, legal_form?: LegalForm | null, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, importance?: string | null, discount?: number | null, created_at: string };

export type GetClientsQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ClientOrderByField>;
  sortOrder?: InputMaybe<SortOrder>;
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  marketingSourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  firstVisitLocationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  lastVisitLocationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  type?: InputMaybe<ClientType>;
}>;


export type GetClientsQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', cursor: string, node: { __typename?: 'Client', id: string, type: ClientType, legal_form?: LegalForm | null, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, sex?: ClientSex | null, birthday?: string | null, importance?: string | null, discount?: number | null, visits_count?: number | null, hours_total?: number | null, ltv?: number | null, avg_check?: number | null, note?: string | null, created_at: string, last_visit_at?: string | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, first_visit_location?: { __typename?: 'Location', id: string, title: string } | null, last_visit_location?: { __typename?: 'Location', id: string, title: string } | null, active_scenario_runs: Array<{ __typename?: 'ScenarioRun', id: string, current_step_index: number, status: ScenarioRunStatus, started_at?: string | null, last_step_at?: string | null, scenario: { __typename?: 'Scenario', id: string, name: string, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null }> } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, type: ClientType, legal_form?: LegalForm | null, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, sex?: ClientSex | null, birthday?: string | null, importance?: string | null, discount?: number | null, visits_count?: number | null, hours_total?: number | null, ltv?: number | null, avg_check?: number | null, note?: string | null, created_at: string, last_visit_at?: string | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, first_visit_location?: { __typename?: 'Location', id: string, title: string } | null, last_visit_location?: { __typename?: 'Location', id: string, title: string } | null, active_scenario_runs: Array<{ __typename?: 'ScenarioRun', id: string, current_step_index: number, status: ScenarioRunStatus, started_at?: string | null, last_step_at?: string | null, scenario: { __typename?: 'Scenario', id: string, name: string, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null }> } }> } | null };

export type GetBookingClientsQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ClientType>;
}>;


export type GetBookingClientsQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', edges: Array<{ __typename?: 'ClientEdge', cursor: string, node: { __typename?: 'Client', id: string, type: ClientType, legal_form?: LegalForm | null, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, importance?: string | null, discount?: number | null, created_at: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetClientWithStatisticsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientWithStatisticsQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, type: ClientType, legal_form?: LegalForm | null, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, sex?: ClientSex | null, birthday?: string | null, importance?: string | null, discount?: number | null, visits_count?: number | null, hours_total?: number | null, ltv?: number | null, avg_check?: number | null, note?: string | null, created_at: string, last_visit_at?: string | null, segment_badges: Array<{ __typename?: 'ClientSegment', id: string, name: string, badge_color?: string | null }>, statistics_by_location: Array<{ __typename?: 'ClientLocationStatistic', location_id: string, location_name: string, visits_count: number, hours_total: number, first_visit_at?: string | null, last_visit_at?: string | null }>, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, first_visit_location?: { __typename?: 'Location', id: string, title: string } | null, last_visit_location?: { __typename?: 'Location', id: string, title: string } | null, active_scenario_runs: Array<{ __typename?: 'ScenarioRun', id: string, current_step_index: number, status: ScenarioRunStatus, started_at?: string | null, last_step_at?: string | null, scenario: { __typename?: 'Scenario', id: string, name: string, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null }> } }> } | null };

export type RevealClientPhoneQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevealClientPhoneQuery = { __typename?: 'Query', revealClientPhone: string };

export type OrderFiscalizationSettingFieldsFragment = { __typename?: 'OrderFiscalizationSetting', id: string, organization_id: string, location_id: string, provider: OrderFiscalizationProvider, enabled: boolean, shifts_enabled: boolean, expected_kkt_inn_masked?: string | null, cashier_position?: string | null, cashier_last_name?: string | null, cashier_display_name?: string | null, taxation_system: OrderFiscalTaxationSystem, vat_rate: OrderFiscalVatRate, payment_subject: OrderFiscalPaymentSubject, payment_method: OrderFiscalPaymentMethod, config_version: number, created_at: string, updated_at: string };

export type OrderFiscalWorkstationFieldsFragment = { __typename?: 'OrderFiscalWorkstation', id: string, organization_id: string, location_id: string, workstation_id: string, name: string, active: boolean, deletable: boolean, kkmserver_version?: string | null, kkt_model_masked?: string | null, kkt_number_masked?: string | null, fn_number_masked?: string | null, kkt_status: OrderFiscalKktStatus, terminal_name_masked?: string | null, terminal_number_masked?: string | null, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null, activated_at?: string | null, deactivated_at?: string | null, created_at: string, updated_at: string };

export type OrderFiscalizationReadinessFieldsFragment = { __typename?: 'OrderFiscalizationReadiness', setting_enabled: boolean, effective_enabled: boolean, kkt_status: OrderFiscalKktStatus, terminal_status: OrderFiscalTerminalStatus, setting?: { __typename?: 'OrderFiscalizationSetting', id: string, organization_id: string, location_id: string, provider: OrderFiscalizationProvider, enabled: boolean, shifts_enabled: boolean, expected_kkt_inn_masked?: string | null, cashier_position?: string | null, cashier_last_name?: string | null, cashier_display_name?: string | null, taxation_system: OrderFiscalTaxationSystem, vat_rate: OrderFiscalVatRate, payment_subject: OrderFiscalPaymentSubject, payment_method: OrderFiscalPaymentMethod, config_version: number, created_at: string, updated_at: string } | null, active_workstation?: { __typename?: 'OrderFiscalWorkstation', id: string, organization_id: string, location_id: string, workstation_id: string, name: string, active: boolean, deletable: boolean, kkmserver_version?: string | null, kkt_model_masked?: string | null, kkt_number_masked?: string | null, fn_number_masked?: string | null, kkt_status: OrderFiscalKktStatus, terminal_name_masked?: string | null, terminal_number_masked?: string | null, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null, activated_at?: string | null, deactivated_at?: string | null, created_at: string, updated_at: string } | null, last_workstation?: { __typename?: 'OrderFiscalWorkstation', id: string, organization_id: string, location_id: string, workstation_id: string, name: string, active: boolean, deletable: boolean, kkmserver_version?: string | null, kkt_model_masked?: string | null, kkt_number_masked?: string | null, fn_number_masked?: string | null, kkt_status: OrderFiscalKktStatus, terminal_name_masked?: string | null, terminal_number_masked?: string | null, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null, activated_at?: string | null, deactivated_at?: string | null, created_at: string, updated_at: string } | null };

export type ShiftFieldsFragment = { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> };

export type GetOrderFiscalizationSetupQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetOrderFiscalizationSetupQuery = { __typename?: 'Query', orderFiscalizationReadiness: { __typename?: 'OrderFiscalizationReadiness', setting_enabled: boolean, effective_enabled: boolean, kkt_status: OrderFiscalKktStatus, terminal_status: OrderFiscalTerminalStatus, setting?: { __typename?: 'OrderFiscalizationSetting', id: string, organization_id: string, location_id: string, provider: OrderFiscalizationProvider, enabled: boolean, shifts_enabled: boolean, expected_kkt_inn_masked?: string | null, cashier_position?: string | null, cashier_last_name?: string | null, cashier_display_name?: string | null, taxation_system: OrderFiscalTaxationSystem, vat_rate: OrderFiscalVatRate, payment_subject: OrderFiscalPaymentSubject, payment_method: OrderFiscalPaymentMethod, config_version: number, created_at: string, updated_at: string } | null, active_workstation?: { __typename?: 'OrderFiscalWorkstation', id: string, organization_id: string, location_id: string, workstation_id: string, name: string, active: boolean, deletable: boolean, kkmserver_version?: string | null, kkt_model_masked?: string | null, kkt_number_masked?: string | null, fn_number_masked?: string | null, kkt_status: OrderFiscalKktStatus, terminal_name_masked?: string | null, terminal_number_masked?: string | null, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null, activated_at?: string | null, deactivated_at?: string | null, created_at: string, updated_at: string } | null, last_workstation?: { __typename?: 'OrderFiscalWorkstation', id: string, organization_id: string, location_id: string, workstation_id: string, name: string, active: boolean, deletable: boolean, kkmserver_version?: string | null, kkt_model_masked?: string | null, kkt_number_masked?: string | null, fn_number_masked?: string | null, kkt_status: OrderFiscalKktStatus, terminal_name_masked?: string | null, terminal_number_masked?: string | null, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null, activated_at?: string | null, deactivated_at?: string | null, created_at: string, updated_at: string } | null } };

export type GetOrderRefundContextQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderRefundContextQuery = { __typename?: 'Query', orderRefundContext?: { __typename?: 'OrderRefundContext', fiscalization_required: boolean, cashier_display_name?: string | null, allowed_payment_methods: Array<OrderPaymentMethod>, shift_required?: boolean | null, shift_state?: ShiftSettlementState | null, shift_blocker_reason?: ShiftSettlementBlockerReason | null, shift_expires_at?: string | null, approval_required: boolean, approval_status?: OrderRefundApprovalStatus | null, approval_expires_at?: string | null, manual_bank_reference_required: boolean, expected_kkt_device_id?: string | null, online_payments: Array<{ __typename?: 'OrderRefundOnlinePayment', money_part_id: string, fiscal_scheme: PaymentFiscalScheme }>, online_refunds: Array<{ __typename?: 'PaymentRefund', id: string, payment_id: string, amount: number, status: PaymentRefundStatus }> } | null };

export type GetOrderFiscalOperationalStatusQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetOrderFiscalOperationalStatusQuery = { __typename?: 'Query', orderFiscalOperationalStatus: { __typename?: 'OrderFiscalOperationalStatus', fiscalization_enabled: boolean, shifts_enabled: boolean, paused: boolean, pause_reason?: string | null, paused_at?: string | null, cashier_display_name?: string | null, expected_kkt_device_id?: string | null, workstation_binding: OrderFiscalWorkstationBinding, browser_workstation_id?: string | null, location_closes_at?: string | null } };

export type GetCurrentShiftQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetCurrentShiftQuery = { __typename?: 'Query', currentShift?: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } | null };

export type GetShiftsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetShiftsQuery = { __typename?: 'Query', shifts: { __typename?: 'ShiftConnection', edges: Array<{ __typename?: 'ShiftEdge', cursor: string, node: { __typename?: 'Shift', id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, location: { __typename?: 'Location', id: string, title: string, timezone: string }, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetShiftQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetShiftQuery = { __typename?: 'Query', shift?: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, location: { __typename?: 'Location', id: string, title: string, timezone: string }, revenue_mors: { __typename?: 'ShiftRevenueBreakdown', cash: number, card: number, other: number, total: number }, events: Array<{ __typename?: 'ShiftEvent', id: string, type: ShiftEventType, created_at: string, actor?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } | null };

export type UpdateOrderFiscalizationSettingsMutationVariables = Exact<{
  input: UpdateOrderFiscalizationSettingsInput;
}>;


export type UpdateOrderFiscalizationSettingsMutation = { __typename?: 'Mutation', updateOrderFiscalizationSettings: { __typename?: 'OrderFiscalizationSetting', id: string, organization_id: string, location_id: string, provider: OrderFiscalizationProvider, enabled: boolean, shifts_enabled: boolean, expected_kkt_inn_masked?: string | null, cashier_position?: string | null, cashier_last_name?: string | null, cashier_display_name?: string | null, taxation_system: OrderFiscalTaxationSystem, vat_rate: OrderFiscalVatRate, payment_subject: OrderFiscalPaymentSubject, payment_method: OrderFiscalPaymentMethod, config_version: number, created_at: string, updated_at: string } };

export type ApplyOrderFiscalizationConnectionMutationVariables = Exact<{
  input: ApplyOrderFiscalizationConnectionInput;
}>;


export type ApplyOrderFiscalizationConnectionMutation = { __typename?: 'Mutation', applyOrderFiscalizationConnection: { __typename?: 'OrderFiscalWorkstation', id: string, organization_id: string, location_id: string, workstation_id: string, name: string, active: boolean, deletable: boolean, kkmserver_version?: string | null, kkt_model_masked?: string | null, kkt_number_masked?: string | null, fn_number_masked?: string | null, kkt_status: OrderFiscalKktStatus, terminal_name_masked?: string | null, terminal_number_masked?: string | null, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null, activated_at?: string | null, deactivated_at?: string | null, created_at: string, updated_at: string, setting: { __typename?: 'OrderFiscalizationSetting', id: string, organization_id: string, location_id: string, provider: OrderFiscalizationProvider, enabled: boolean, shifts_enabled: boolean, expected_kkt_inn_masked?: string | null, cashier_position?: string | null, cashier_last_name?: string | null, cashier_display_name?: string | null, taxation_system: OrderFiscalTaxationSystem, vat_rate: OrderFiscalVatRate, payment_subject: OrderFiscalPaymentSubject, payment_method: OrderFiscalPaymentMethod, config_version: number, created_at: string, updated_at: string } } };

export type DeactivateOrderFiscalWorkstationMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  workstationId: Scalars['ID']['input'];
}>;


export type DeactivateOrderFiscalWorkstationMutation = { __typename?: 'Mutation', deactivateOrderFiscalWorkstation: { __typename?: 'OrderFiscalWorkstation', id: string, organization_id: string, location_id: string, workstation_id: string, name: string, active: boolean, deletable: boolean, kkmserver_version?: string | null, kkt_model_masked?: string | null, kkt_number_masked?: string | null, fn_number_masked?: string | null, kkt_status: OrderFiscalKktStatus, terminal_name_masked?: string | null, terminal_number_masked?: string | null, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null, activated_at?: string | null, deactivated_at?: string | null, created_at: string, updated_at: string } };

export type DeleteOrderFiscalWorkstationMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  workstationId: Scalars['ID']['input'];
}>;


export type DeleteOrderFiscalWorkstationMutation = { __typename?: 'Mutation', deleteOrderFiscalWorkstation: boolean };

export type InvoiceLocationFieldsFragment = { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string };

export type InvoicePartyFieldsFragment = { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null };

export type InvoiceFieldsFragment = { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, order_id: string, order_title: string, client_id: string, client_title: string, paid_at?: string | null, annulled_at?: string | null, created_at: string, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, payer: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, lines: Array<{ __typename?: 'InvoiceLine', position: number, title: string, quantity: number, unit: InvoiceLineUnit, unit_price: number, amount: number }>, receipts: Array<{ __typename?: 'InvoiceReceipt', id: string, status: InvoiceReceiptStatus, amount: number, received_on: string, payment_order_number: string, payment_id: string, confirmed_at: string, confirmed_by_title?: string | null, void_reason?: string | null, voided_at?: string | null, voided_by_title?: string | null, returned_on?: string | null, return_payment_order_number?: string | null, returned_at?: string | null, returned_by_title?: string | null }>, history: Array<{ __typename?: 'InvoiceHistoryEntry', kind: InvoiceHistoryKind, at: string, actor_title?: string | null, amount?: number | null, reference?: string | null, reason?: string | null }> };

export type GetInvoicesQueryVariables = Exact<{
  filter?: InputMaybe<InvoiceListFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  withCounts?: Scalars['Boolean']['input'];
}>;


export type GetInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoicePage', total: number, seller_count?: number, items: Array<{ __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, client_title: string, payer: { __typename?: 'InvoiceParty', name: string, tin: string }, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', name: string, legal_form: LegalForm } }>, counts?: { __typename?: 'InvoiceFilterCounts', all: number, awaiting_payment: number, overdue: number, paid: number } } };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', invoice?: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, order_id: string, order_title: string, client_id: string, client_title: string, paid_at?: string | null, annulled_at?: string | null, created_at: string, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, payer: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, lines: Array<{ __typename?: 'InvoiceLine', position: number, title: string, quantity: number, unit: InvoiceLineUnit, unit_price: number, amount: number }>, receipts: Array<{ __typename?: 'InvoiceReceipt', id: string, status: InvoiceReceiptStatus, amount: number, received_on: string, payment_order_number: string, payment_id: string, confirmed_at: string, confirmed_by_title?: string | null, void_reason?: string | null, voided_at?: string | null, voided_by_title?: string | null, returned_on?: string | null, return_payment_order_number?: string | null, returned_at?: string | null, returned_by_title?: string | null }>, history: Array<{ __typename?: 'InvoiceHistoryEntry', kind: InvoiceHistoryKind, at: string, actor_title?: string | null, amount?: number | null, reference?: string | null, reason?: string | null }> } | null };

export type GetOrderInvoiceStateQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderInvoiceStateQuery = { __typename?: 'Query', orderInvoiceState: { __typename?: 'OrderInvoiceState', invoice?: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, order_id: string, order_title: string, client_id: string, client_title: string, paid_at?: string | null, annulled_at?: string | null, created_at: string, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, payer: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, lines: Array<{ __typename?: 'InvoiceLine', position: number, title: string, quantity: number, unit: InvoiceLineUnit, unit_price: number, amount: number }>, receipts: Array<{ __typename?: 'InvoiceReceipt', id: string, status: InvoiceReceiptStatus, amount: number, received_on: string, payment_order_number: string, payment_id: string, confirmed_at: string, confirmed_by_title?: string | null, void_reason?: string | null, voided_at?: string | null, voided_by_title?: string | null, returned_on?: string | null, return_payment_order_number?: string | null, returned_at?: string | null, returned_by_title?: string | null }>, history: Array<{ __typename?: 'InvoiceHistoryEntry', kind: InvoiceHistoryKind, at: string, actor_title?: string | null, amount?: number | null, reference?: string | null, reason?: string | null }> } | null } };

export type GetOrderInvoiceHoldQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderInvoiceHoldQuery = { __typename?: 'Query', orderInvoiceState: { __typename?: 'OrderInvoiceState', invoice?: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus } | null } };

export type GetOrderInvoiceAvailabilityQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderInvoiceAvailabilityQuery = { __typename?: 'Query', orderInvoiceState: { __typename?: 'OrderInvoiceState', issue_availability: { __typename?: 'InvoiceIssueAvailability', available: boolean, reason?: InvoiceIssueBlock | null, reason_message?: string | null, missing_seller: Array<InvoiceRequisite>, missing_payer: Array<InvoiceRequisite>, seller_name?: string | null, payer_preview?: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null } | null } } };

export type GetInvoiceSellerReadinessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceSellerReadinessQuery = { __typename?: 'Query', invoiceSellerReadiness: Array<{ __typename?: 'InvoiceSellerReadiness', seller_name?: string | null, missing: Array<InvoiceRequisite>, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string } }> };

export type LegalEntitySuggestionsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LegalEntitySuggestionsQuery = { __typename?: 'Query', legalEntitySuggestions: Array<{ __typename?: 'LegalEntitySuggestion', name: string, legal_form: LegalForm, tin: string, kpp?: string | null, ogrn?: string | null, address?: string | null, status: LegalEntityStatus, liquidated_on?: string | null }> };

export type BankByBikQueryVariables = Exact<{
  bik: Scalars['String']['input'];
}>;


export type BankByBikQuery = { __typename?: 'Query', bankByBik?: { __typename?: 'BankSuggestion', name: string, bik: string, correspondent_account?: string | null } | null };

export type GetLocationAttentionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationAttentionQuery = { __typename?: 'Query', locationAttention: Array<{ __typename?: 'LocationAttention', location_id: string, shift_state?: ShiftSettlementState | null, shift_expires_at?: string | null, location_closes_at?: string | null, payment_attention_count: number, refund_approval_count: number }> };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, title: string, opened_from?: string | null, closed_from?: string | null }> };

export type LoyaltyTierFieldsFragment = { __typename?: 'LoyaltyTier', id: string, name: string, min_spent_amount: number, base_rate_percent: number, item_rates: Array<{ __typename?: 'LoyaltyTierItemRate', catalog_item_id: string, rate_percent: number }> };

export type LoyaltyProgramFieldsFragment = { __typename?: 'LoyaltyProgram', id: string, organization_id: string, is_active: boolean, expiry_months: number, max_redemption_percent: number, tiers: Array<{ __typename?: 'LoyaltyTier', id: string, name: string, min_spent_amount: number, base_rate_percent: number, item_rates: Array<{ __typename?: 'LoyaltyTierItemRate', catalog_item_id: string, rate_percent: number }> }> };

export type LoyaltyAccountFieldsFragment = { __typename?: 'LoyaltyAccount', id: string, client_id: string, available_balance: number, lifetime_spent_amount: number, debt: number, current_tier?: { __typename?: 'LoyaltyTier', id: string, name: string, min_spent_amount: number, base_rate_percent: number, item_rates: Array<{ __typename?: 'LoyaltyTierItemRate', catalog_item_id: string, rate_percent: number }> } | null, nearest_expiry?: { __typename?: 'LoyaltyNearestExpiry', date: string, amount: number } | null };

export type LoyaltyTransactionFieldsFragment = { __typename?: 'LoyaltyTransaction', id: string, client_id: string, type: LoyaltyTransactionType, amount: number, order_id?: string | null, order_refund_id?: string | null, created_by_employee_id?: string | null, note?: string | null, metadata?: any | null, created_at: string, created_by_employee?: { __typename?: 'LoyaltyActor', id: string, title?: string | null } | null };

export type GetClientLoyaltyQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetClientLoyaltyQuery = { __typename?: 'Query', clientLoyalty?: { __typename?: 'LoyaltyAccount', id: string, client_id: string, available_balance: number, lifetime_spent_amount: number, debt: number, current_tier?: { __typename?: 'LoyaltyTier', id: string, name: string, min_spent_amount: number, base_rate_percent: number, item_rates: Array<{ __typename?: 'LoyaltyTierItemRate', catalog_item_id: string, rate_percent: number }> } | null, nearest_expiry?: { __typename?: 'LoyaltyNearestExpiry', date: string, amount: number } | null } | null };

export type GetLoyaltyTransactionsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLoyaltyTransactionsQuery = { __typename?: 'Query', loyaltyTransactions: { __typename?: 'LoyaltyTransactionConnection', edges: Array<{ __typename?: 'LoyaltyTransactionEdge', cursor: string, node: { __typename?: 'LoyaltyTransaction', id: string, client_id: string, type: LoyaltyTransactionType, amount: number, order_id?: string | null, order_refund_id?: string | null, created_by_employee_id?: string | null, note?: string | null, metadata?: any | null, created_at: string, created_by_employee?: { __typename?: 'LoyaltyActor', id: string, title?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetLoyaltyProgramQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoyaltyProgramQuery = { __typename?: 'Query', loyaltyProgram?: { __typename?: 'LoyaltyProgram', id: string, organization_id: string, is_active: boolean, expiry_months: number, max_redemption_percent: number, tiers: Array<{ __typename?: 'LoyaltyTier', id: string, name: string, min_spent_amount: number, base_rate_percent: number, item_rates: Array<{ __typename?: 'LoyaltyTierItemRate', catalog_item_id: string, rate_percent: number }> }> } | null };

export type UpsertLoyaltyProgramMutationVariables = Exact<{
  input: UpsertLoyaltyProgramInput;
}>;


export type UpsertLoyaltyProgramMutation = { __typename?: 'Mutation', upsertLoyaltyProgram: { __typename?: 'LoyaltyProgram', id: string, organization_id: string, is_active: boolean, expiry_months: number, max_redemption_percent: number, tiers: Array<{ __typename?: 'LoyaltyTier', id: string, name: string, min_spent_amount: number, base_rate_percent: number, item_rates: Array<{ __typename?: 'LoyaltyTierItemRate', catalog_item_id: string, rate_percent: number }> }> } };

export type ManualLoyaltyAccrualMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ManualLoyaltyAccrualMutation = { __typename?: 'Mutation', manualLoyaltyAccrual: { __typename?: 'LoyaltyTransaction', id: string, client_id: string, type: LoyaltyTransactionType, amount: number, order_id?: string | null, order_refund_id?: string | null, created_by_employee_id?: string | null, note?: string | null, metadata?: any | null, created_at: string, created_by_employee?: { __typename?: 'LoyaltyActor', id: string, title?: string | null } | null } };

export type ManualLoyaltyDeductionMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
  note: Scalars['String']['input'];
}>;


export type ManualLoyaltyDeductionMutation = { __typename?: 'Mutation', manualLoyaltyDeduction: { __typename?: 'LoyaltyTransaction', id: string, client_id: string, type: LoyaltyTransactionType, amount: number, order_id?: string | null, order_refund_id?: string | null, created_by_employee_id?: string | null, note?: string | null, metadata?: any | null, created_at: string, created_by_employee?: { __typename?: 'LoyaltyActor', id: string, title?: string | null } | null } };

export type GetMarketingSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketingSourcesQuery = { __typename?: 'Query', marketingSources: Array<{ __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean, is_system: boolean, created_at?: string | null }> };

export type GetMarketingSourceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMarketingSourceQuery = { __typename?: 'Query', marketingSource?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean, is_system: boolean, created_at?: string | null } | null };

export type MessengerChannelFragmentFragment = { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, is_fallback: boolean, priority: number, conversation_count: number, created_at: string, updated_at: string, health_status: { __typename?: 'ChannelHealthStatus', status?: string | null, webhook: { __typename?: 'ChannelHealthCheck', status: string, error?: string | null, checked_at?: string | null }, api: { __typename?: 'ChannelHealthCheck', status: string, error?: string | null, checked_at?: string | null } }, credentials?: { __typename?: 'ChannelCredentials', token?: string | null, username?: string | null, access_token?: string | null, group_id?: string | null, confirmation?: string | null, secret?: string | null, screen_name?: string | null } | null };

export type GetMessengerChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMessengerChannelsQuery = { __typename?: 'Query', messengerChannels: Array<{ __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, is_fallback: boolean, priority: number, conversation_count: number, created_at: string, updated_at: string, health_status: { __typename?: 'ChannelHealthStatus', status?: string | null, webhook: { __typename?: 'ChannelHealthCheck', status: string, error?: string | null, checked_at?: string | null }, api: { __typename?: 'ChannelHealthCheck', status: string, error?: string | null, checked_at?: string | null } }, credentials?: { __typename?: 'ChannelCredentials', token?: string | null, username?: string | null, access_token?: string | null, group_id?: string | null, confirmation?: string | null, secret?: string | null, screen_name?: string | null } | null }> };

export type CreateMessengerChannelMutationVariables = Exact<{
  input: CreateMessengerChannelInput;
}>;


export type CreateMessengerChannelMutation = { __typename?: 'Mutation', createMessengerChannel: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, is_fallback: boolean, priority: number, conversation_count: number, created_at: string, updated_at: string, health_status: { __typename?: 'ChannelHealthStatus', status?: string | null, webhook: { __typename?: 'ChannelHealthCheck', status: string, error?: string | null, checked_at?: string | null }, api: { __typename?: 'ChannelHealthCheck', status: string, error?: string | null, checked_at?: string | null } }, credentials?: { __typename?: 'ChannelCredentials', token?: string | null, username?: string | null, access_token?: string | null, group_id?: string | null, confirmation?: string | null, secret?: string | null, screen_name?: string | null } | null } };

export type UpdateMessengerChannelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateMessengerChannelInput;
}>;


export type UpdateMessengerChannelMutation = { __typename?: 'Mutation', updateMessengerChannel: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, is_fallback: boolean, priority: number, conversation_count: number, created_at: string, updated_at: string, health_status: { __typename?: 'ChannelHealthStatus', status?: string | null, webhook: { __typename?: 'ChannelHealthCheck', status: string, error?: string | null, checked_at?: string | null }, api: { __typename?: 'ChannelHealthCheck', status: string, error?: string | null, checked_at?: string | null } }, credentials?: { __typename?: 'ChannelCredentials', token?: string | null, username?: string | null, access_token?: string | null, group_id?: string | null, confirmation?: string | null, secret?: string | null, screen_name?: string | null } | null } };

export type DeleteMessengerChannelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMessengerChannelMutation = { __typename?: 'Mutation', deleteMessengerChannel: boolean };

export type MessengerClientFragmentFragment = { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null };

export type MessengerConversationFragmentFragment = { __typename?: 'MessengerConversation', id: string, channel_id?: string | null, external_chat_id?: string | null, is_active: boolean, is_default?: boolean | null, connected_at?: string | null, disconnected_at?: string | null, last_message_at?: string | null, messages_count?: number | null, created_at: string, updated_at: string, channel?: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, priority: number } | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, chat_metadata?: { __typename?: 'ChatMetadata', first_name?: string | null, last_name?: string | null, username?: string | null, avatar_url?: string | null, type?: string | null } | null };

export type LinkConversationClientMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LinkConversationClientMutation = { __typename?: 'Mutation', linkConversationClient: { __typename?: 'LinkConversationPayload', warnings: Array<string>, conversation: { __typename?: 'MessengerConversation', id: string, channel_id?: string | null, external_chat_id?: string | null, is_active: boolean, is_default?: boolean | null, connected_at?: string | null, disconnected_at?: string | null, last_message_at?: string | null, messages_count?: number | null, created_at: string, updated_at: string, channel?: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, priority: number } | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, chat_metadata?: { __typename?: 'ChatMetadata', first_name?: string | null, last_name?: string | null, username?: string | null, avatar_url?: string | null, type?: string | null } | null } } };

export type UnlinkConversationClientMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type UnlinkConversationClientMutation = { __typename?: 'Mutation', unlinkConversationClient: { __typename?: 'MessengerConversation', id: string, channel_id?: string | null, external_chat_id?: string | null, is_active: boolean, is_default?: boolean | null, connected_at?: string | null, disconnected_at?: string | null, last_message_at?: string | null, messages_count?: number | null, created_at: string, updated_at: string, channel?: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, priority: number } | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, chat_metadata?: { __typename?: 'ChatMetadata', first_name?: string | null, last_name?: string | null, username?: string | null, avatar_url?: string | null, type?: string | null } | null } };

export type SetConversationDefaultMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type SetConversationDefaultMutation = { __typename?: 'Mutation', setConversationDefault: { __typename?: 'MessengerConversation', id: string, channel_id?: string | null, external_chat_id?: string | null, is_active: boolean, is_default?: boolean | null, connected_at?: string | null, disconnected_at?: string | null, last_message_at?: string | null, messages_count?: number | null, created_at: string, updated_at: string, channel?: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, priority: number } | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, chat_metadata?: { __typename?: 'ChatMetadata', first_name?: string | null, last_name?: string | null, username?: string | null, avatar_url?: string | null, type?: string | null } | null } };

export type CreateClientFromConversationMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  input: CreateClientFromConversationInput;
}>;


export type CreateClientFromConversationMutation = { __typename?: 'Mutation', createClientFromConversation: { __typename?: 'CreateClientFromConversationPayload', existing: boolean, warnings: Array<string>, conversation: { __typename?: 'MessengerConversation', id: string, channel_id?: string | null, external_chat_id?: string | null, is_active: boolean, is_default?: boolean | null, connected_at?: string | null, disconnected_at?: string | null, last_message_at?: string | null, messages_count?: number | null, created_at: string, updated_at: string, channel?: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, priority: number } | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, chat_metadata?: { __typename?: 'ChatMetadata', first_name?: string | null, last_name?: string | null, username?: string | null, avatar_url?: string | null, type?: string | null } | null } } };

export type MessengerMessageFragmentFragment = { __typename?: 'MessengerMessage', id: string, conversation_id?: string | null, channel_id?: string | null, direction: MessengerMessageDirection, sender_type?: MessengerMessageSenderType | null, message_type: MessengerMessageType, messenger_type?: string | null, employee_name?: string | null, body?: string | null, body_preview?: string | null, status: MessengerMessageStatus, external_message_id?: string | null, metadata?: any | null, file_url?: string | null, file_name?: string | null, file_size?: number | null, failed_reason?: string | null, scheduled_at?: string | null, sent_at?: string | null, delivered_at?: string | null, deliver_deadline?: string | null, read_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string };

export type MessengerDialogFragmentFragment = { __typename?: 'MessengerDialog', id: string, status: MessengerDialogStatus, waiting_since?: string | null, assignee?: { __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null } | null };

export type GetMessengerConversationGroupsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  section?: InputMaybe<MessengerDialogSection>;
}>;


export type GetMessengerConversationGroupsQuery = { __typename?: 'Query', messengerConversationGroups: { __typename?: 'MessengerConversationGroupPage', groups: Array<{ __typename?: 'MessengerConversationGroup', client_id?: string | null, unread_count: number, last_message_at?: string | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, conversations: Array<{ __typename?: 'MessengerConversation', id: string, channel_id?: string | null, external_chat_id?: string | null, is_active: boolean, is_default?: boolean | null, connected_at?: string | null, disconnected_at?: string | null, last_message_at?: string | null, messages_count?: number | null, created_at: string, updated_at: string, channel?: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, priority: number } | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, chat_metadata?: { __typename?: 'ChatMetadata', first_name?: string | null, last_name?: string | null, username?: string | null, avatar_url?: string | null, type?: string | null } | null }>, last_message?: { __typename?: 'MessengerMessage', id: string, conversation_id?: string | null, channel_id?: string | null, direction: MessengerMessageDirection, sender_type?: MessengerMessageSenderType | null, message_type: MessengerMessageType, messenger_type?: string | null, employee_name?: string | null, body?: string | null, body_preview?: string | null, status: MessengerMessageStatus, external_message_id?: string | null, metadata?: any | null, file_url?: string | null, file_name?: string | null, file_size?: number | null, failed_reason?: string | null, scheduled_at?: string | null, sent_at?: string | null, delivered_at?: string | null, deliver_deadline?: string | null, read_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string } | null, dialog?: { __typename?: 'MessengerDialog', id: string, status: MessengerDialogStatus, waiting_since?: string | null, assignee?: { __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null } | null } | null }>, meta: { __typename?: 'PageMeta', current_page: number, per_page: number, total: number, last_page: number, has_more: boolean } } };

export type GetMessengerConversationGroupQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type GetMessengerConversationGroupQuery = { __typename?: 'Query', messengerConversationGroup?: { __typename?: 'MessengerConversationGroup', client_id?: string | null, unread_count: number, last_message_at?: string | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, conversations: Array<{ __typename?: 'MessengerConversation', id: string, channel_id?: string | null, external_chat_id?: string | null, is_active: boolean, is_default?: boolean | null, connected_at?: string | null, disconnected_at?: string | null, last_message_at?: string | null, messages_count?: number | null, created_at: string, updated_at: string, channel?: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, priority: number } | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, chat_metadata?: { __typename?: 'ChatMetadata', first_name?: string | null, last_name?: string | null, username?: string | null, avatar_url?: string | null, type?: string | null } | null }>, last_message?: { __typename?: 'MessengerMessage', id: string, conversation_id?: string | null, channel_id?: string | null, direction: MessengerMessageDirection, sender_type?: MessengerMessageSenderType | null, message_type: MessengerMessageType, messenger_type?: string | null, employee_name?: string | null, body?: string | null, body_preview?: string | null, status: MessengerMessageStatus, external_message_id?: string | null, metadata?: any | null, file_url?: string | null, file_name?: string | null, file_size?: number | null, failed_reason?: string | null, scheduled_at?: string | null, sent_at?: string | null, delivered_at?: string | null, deliver_deadline?: string | null, read_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string } | null, dialog?: { __typename?: 'MessengerDialog', id: string, status: MessengerDialogStatus, waiting_since?: string | null, assignee?: { __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null } | null } | null } | null };

export type GetMessengerDialogCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMessengerDialogCountsQuery = { __typename?: 'Query', messengerDialogCounts: { __typename?: 'MessengerDialogCounts', open: number, unanswered: number, resolved: number } };

export type GetMessengerOperatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMessengerOperatorsQuery = { __typename?: 'Query', messengerOperators: Array<{ __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null }> };

export type GetClientMessengerConversationsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetClientMessengerConversationsQuery = { __typename?: 'Query', clientMessengerConversations: Array<{ __typename?: 'MessengerConversation', id: string, channel_id?: string | null, external_chat_id?: string | null, is_active: boolean, is_default?: boolean | null, connected_at?: string | null, disconnected_at?: string | null, last_message_at?: string | null, messages_count?: number | null, created_at: string, updated_at: string, channel?: { __typename?: 'MessengerChannel', id: string, title: string, provider: MessengerProvider, is_active: boolean, priority: number } | null, client?: { __typename?: 'MessengerClient', id: string, first_name?: string | null, last_name?: string | null, phone_masked?: string | null, type: ClientType, active_bookings_count?: number | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, city?: { __typename?: 'City', id: string, name: string } | null } | null, chat_metadata?: { __typename?: 'ChatMetadata', first_name?: string | null, last_name?: string | null, username?: string | null, avatar_url?: string | null, type?: string | null } | null }> };

export type GetMessengerClientNextBookingQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetMessengerClientNextBookingQuery = { __typename?: 'Query', messengerClientNextBooking?: { __typename?: 'MessengerClientNextBooking', start: string, end: string, status: BookingStatus, service_variant_title?: string | null, location_title?: string | null } | null };

export type GetConversationMessagesQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  beforeMessageId?: InputMaybe<Scalars['ID']['input']>;
  perPage: Scalars['Int']['input'];
  filter: MessageFilter;
}>;


export type GetConversationMessagesQuery = { __typename?: 'Query', conversationMessages: { __typename?: 'MessengerMessagePage', has_more: boolean, scheduled_count: number, messages: Array<{ __typename?: 'MessengerMessage', id: string, conversation_id?: string | null, channel_id?: string | null, direction: MessengerMessageDirection, sender_type?: MessengerMessageSenderType | null, message_type: MessengerMessageType, messenger_type?: string | null, employee_name?: string | null, body?: string | null, body_preview?: string | null, status: MessengerMessageStatus, external_message_id?: string | null, metadata?: any | null, file_url?: string | null, file_name?: string | null, file_size?: number | null, failed_reason?: string | null, scheduled_at?: string | null, sent_at?: string | null, delivered_at?: string | null, deliver_deadline?: string | null, read_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string }> } };

export type GetMessengerMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMessengerMessageQuery = { __typename?: 'Query', messengerMessage?: { __typename?: 'MessengerMessage', id: string, conversation_id?: string | null, channel_id?: string | null, direction: MessengerMessageDirection, sender_type?: MessengerMessageSenderType | null, message_type: MessengerMessageType, messenger_type?: string | null, employee_name?: string | null, body?: string | null, body_preview?: string | null, status: MessengerMessageStatus, external_message_id?: string | null, metadata?: any | null, file_url?: string | null, file_name?: string | null, file_size?: number | null, failed_reason?: string | null, scheduled_at?: string | null, sent_at?: string | null, delivered_at?: string | null, deliver_deadline?: string | null, read_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string } | null };

export type SendMessengerMessageMutationVariables = Exact<{
  input: SendMessengerMessageInput;
}>;


export type SendMessengerMessageMutation = { __typename?: 'Mutation', sendMessengerMessage: { __typename?: 'MessengerMessage', id: string, conversation_id?: string | null, channel_id?: string | null, direction: MessengerMessageDirection, sender_type?: MessengerMessageSenderType | null, message_type: MessengerMessageType, messenger_type?: string | null, employee_name?: string | null, body?: string | null, body_preview?: string | null, status: MessengerMessageStatus, external_message_id?: string | null, metadata?: any | null, file_url?: string | null, file_name?: string | null, file_size?: number | null, failed_reason?: string | null, scheduled_at?: string | null, sent_at?: string | null, delivered_at?: string | null, deliver_deadline?: string | null, read_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string } };

export type DeleteMessengerMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMessengerMessageMutation = { __typename?: 'Mutation', deleteMessengerMessage: boolean };

export type MarkConversationAsReadMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type MarkConversationAsReadMutation = { __typename?: 'Mutation', markConversationAsRead: boolean };

export type TakeMessengerDialogMutationVariables = Exact<{
  dialogId: Scalars['ID']['input'];
}>;


export type TakeMessengerDialogMutation = { __typename?: 'Mutation', takeMessengerDialog: { __typename?: 'MessengerDialog', id: string, status: MessengerDialogStatus, waiting_since?: string | null, assignee?: { __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null } | null } };

export type ResolveMessengerDialogMutationVariables = Exact<{
  dialogId: Scalars['ID']['input'];
}>;


export type ResolveMessengerDialogMutation = { __typename?: 'Mutation', resolveMessengerDialog: { __typename?: 'MessengerDialog', id: string, status: MessengerDialogStatus, waiting_since?: string | null, assignee?: { __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null } | null } };

export type ReassignMessengerDialogMutationVariables = Exact<{
  dialogId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type ReassignMessengerDialogMutation = { __typename?: 'Mutation', reassignMessengerDialog: { __typename?: 'MessengerDialog', id: string, status: MessengerDialogStatus, waiting_since?: string | null, assignee?: { __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null } | null } };

export type UnassignMessengerDialogMutationVariables = Exact<{
  dialogId: Scalars['ID']['input'];
}>;


export type UnassignMessengerDialogMutation = { __typename?: 'Mutation', unassignMessengerDialog: { __typename?: 'MessengerDialog', id: string, status: MessengerDialogStatus, waiting_since?: string | null, assignee?: { __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null } | null } };

export type MarkMessengerDialogAnsweredMutationVariables = Exact<{
  dialogId: Scalars['ID']['input'];
}>;


export type MarkMessengerDialogAnsweredMutation = { __typename?: 'Mutation', markMessengerDialogAnswered: { __typename?: 'MessengerDialog', id: string, status: MessengerDialogStatus, waiting_since?: string | null, assignee?: { __typename?: 'MessengerDialogAssignee', id: string, first_name?: string | null, last_name?: string | null } | null } };

export type OrderActorFieldsFragment = { __typename?: 'OrderActor', id: string, title?: string | null };

export type OrderLineFieldsFragment = { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number };

export type OrderMoneyPartFieldsFragment = { __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null };

export type OrderListFieldsFragment = { __typename?: 'Order', id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> };

export type OrderFieldsFragment = { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> };

export type OrderCheckoutContextFieldsFragment = { __typename?: 'OrderCheckoutContext', pay_url?: string | null, advance_total: number, remaining_to_pay: number, overpayment_to_refund: number, final_receipt_required: boolean, source_state: OrderCheckoutSourceState, allowed_payment_methods: Array<OrderPaymentMethod>, fiscalization_required: boolean, shift_required?: boolean | null, shift_state?: ShiftSettlementState | null, shift_blocker_reason?: ShiftSettlementBlockerReason | null, shift_expires_at?: string | null, loyalty_program_active: boolean, advances: Array<{ __typename?: 'PaymentAdvanceState', id: string, amount: number, available_amount: number, fiscal_scheme: PaymentFiscalScheme, created_at: string, receipt_status: PaymentReceiptStatus }>, open_payment_links: Array<{ __typename?: 'PaymentLinkState', id: string, payment_id: string, amount: number, inv_id: string, status: PaymentLinkStatus, expires_at: string, url?: string | null }>, payment_link_availability: { __typename?: 'PaymentLinkAvailability', available: boolean, reason_code?: string | null }, send_targets: Array<{ __typename?: 'PaymentLinkSendTarget', conversation_id: string, provider: MessengerProvider }>, order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> }, fiscalization_readiness?: { __typename?: 'OrderFiscalizationReadiness', setting_enabled: boolean, effective_enabled: boolean, kkt_status: OrderFiscalKktStatus, terminal_status: OrderFiscalTerminalStatus, setting?: { __typename?: 'OrderFiscalizationSetting', id: string, expected_kkt_inn_masked?: string | null, cashier_display_name?: string | null, config_version: number } | null, active_workstation?: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, active: boolean, kkt_status: OrderFiscalKktStatus, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null } | null, last_workstation?: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, active: boolean, kkt_status: OrderFiscalKktStatus, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null } | null } | null, active_fiscal_operation?: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, order_id: string, location_id: string, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, completed_at?: string | null } | null, loyalty?: { __typename?: 'OrderLoyaltyContext', available_balance: number, max_redeemable_points: number } | null, invoice?: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, remaining_amount: number } | null };

export type OrderRefundApprovalFieldsFragment = { __typename?: 'OrderRefundApproval', id: string, order_id: string, location_id: string, status: OrderRefundApprovalStatus, kind: OrderRefundApprovalKind, transfer_amount?: number | null, requested_at: string, request_comment?: string | null, resolved_at?: string | null, resolve_comment?: string | null, expires_at?: string | null, location: { __typename?: 'Location', id: string, title: string }, requested_by_employee: { __typename?: 'OrderActor', id: string, title?: string | null }, resolved_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, order: { __typename?: 'Order', id: string, status: OrderStatus, total_amount: number, refunded_amount: number, created_at: string, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null } };

export type GetOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } | null };

export type GetOrderPaymentSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderPaymentSummaryQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, status: OrderStatus, refunded_amount: number, acquiring_instrument?: OrderAcquiringInstrument | null, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, method: PaymentMoneyPartMethod, amount: number, captured_at?: string | null }>, refunds: Array<{ __typename?: 'OrderRefund', id: string, amount: number, completed_at: string, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod }> }> } | null };

export type GetOrderByBookingGroupQueryVariables = Exact<{
  bookingGroupId: Scalars['ID']['input'];
}>;


export type GetOrderByBookingGroupQuery = { __typename?: 'Query', orderByBookingGroup?: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } | null };

export type GetOrderCheckoutContextQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderCheckoutContextQuery = { __typename?: 'Query', orderCheckoutContext?: { __typename?: 'OrderCheckoutContext', pay_url?: string | null, advance_total: number, remaining_to_pay: number, overpayment_to_refund: number, final_receipt_required: boolean, source_state: OrderCheckoutSourceState, allowed_payment_methods: Array<OrderPaymentMethod>, fiscalization_required: boolean, shift_required?: boolean | null, shift_state?: ShiftSettlementState | null, shift_blocker_reason?: ShiftSettlementBlockerReason | null, shift_expires_at?: string | null, loyalty_program_active: boolean, advances: Array<{ __typename?: 'PaymentAdvanceState', id: string, amount: number, available_amount: number, fiscal_scheme: PaymentFiscalScheme, created_at: string, receipt_status: PaymentReceiptStatus }>, open_payment_links: Array<{ __typename?: 'PaymentLinkState', id: string, payment_id: string, amount: number, inv_id: string, status: PaymentLinkStatus, expires_at: string, url?: string | null }>, payment_link_availability: { __typename?: 'PaymentLinkAvailability', available: boolean, reason_code?: string | null }, send_targets: Array<{ __typename?: 'PaymentLinkSendTarget', conversation_id: string, provider: MessengerProvider }>, order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> }, fiscalization_readiness?: { __typename?: 'OrderFiscalizationReadiness', setting_enabled: boolean, effective_enabled: boolean, kkt_status: OrderFiscalKktStatus, terminal_status: OrderFiscalTerminalStatus, setting?: { __typename?: 'OrderFiscalizationSetting', id: string, expected_kkt_inn_masked?: string | null, cashier_display_name?: string | null, config_version: number } | null, active_workstation?: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, active: boolean, kkt_status: OrderFiscalKktStatus, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null } | null, last_workstation?: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, active: boolean, kkt_status: OrderFiscalKktStatus, terminal_status: OrderFiscalTerminalStatus, kkt_verified_at?: string | null, terminal_verified_at?: string | null } | null } | null, active_fiscal_operation?: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, order_id: string, location_id: string, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, completed_at?: string | null } | null, loyalty?: { __typename?: 'OrderLoyaltyContext', available_balance: number, max_redeemable_points: number } | null, invoice?: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, remaining_amount: number } | null } | null };

export type GetOrderRefundApprovalsQueryVariables = Exact<{
  live?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderRefundApprovalsQuery = { __typename?: 'Query', orderRefundApprovals: { __typename?: 'OrderRefundApprovalConnection', edges: Array<{ __typename?: 'OrderRefundApprovalEdge', cursor: string, node: { __typename?: 'OrderRefundApproval', id: string, order_id: string, location_id: string, status: OrderRefundApprovalStatus, kind: OrderRefundApprovalKind, transfer_amount?: number | null, requested_at: string, request_comment?: string | null, resolved_at?: string | null, resolve_comment?: string | null, expires_at?: string | null, location: { __typename?: 'Location', id: string, title: string }, requested_by_employee: { __typename?: 'OrderActor', id: string, title?: string | null }, resolved_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, order: { __typename?: 'Order', id: string, status: OrderStatus, total_amount: number, refunded_amount: number, created_at: string, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetRecentLocationOrdersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecentLocationOrdersQuery = { __typename?: 'Query', recentLocationOrders: { __typename?: 'OrderConnection', edges: Array<{ __typename?: 'OrderEdge', cursor: string, node: { __typename?: 'Order', id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetSwitchableOrganizationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSwitchableOrganizationsQuery = { __typename?: 'Query', switchableOrganizations: { __typename?: 'SwitchableOrganizationConnection', edges: Array<{ __typename?: 'SwitchableOrganizationEdge', node: { __typename?: 'SwitchableOrganization', id: string, title: string, access: OrganizationSwitchAccess } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type PaymentDetailsFieldsFragment = { __typename?: 'PaymentDetails', id: string, amount: number, confirmed_amount: number, refundable_amount: number, provider: PaymentProvider, mode?: PaymentConnectionMode | null, location_id: string, location_title: string, timezone: string, created_at: string, captured_at?: string | null, actor_title?: string | null, status?: PaymentStatus | null, application_status?: PaymentApplicationStatus | null, order_id?: string | null, fiscal_operation_id?: string | null, block_scope: PaymentBlockScope, attention_reasons: Array<PaymentAttentionReason>, available_actions: Array<PaymentAvailableAction>, source_summary?: { __typename?: 'PaymentSourceSummary', customer_name?: string | null, description?: string | null } | null, transfer_details?: { __typename?: 'PaymentTransferDetails', payment_order_number: string, received_on: string, invoice_number?: number | null } | null, money_parts: Array<{ __typename?: 'PaymentMoneyPart', id: string, method: PaymentMoneyPartMethod, planned_amount: number, confirmed_amount: number }>, attempts: Array<{ __typename?: 'PaymentAttempt', id: string, status: PaymentAttemptStatus, created_at: string }>, links: Array<{ __typename?: 'PaymentLinkState', id: string, status: PaymentLinkStatus, amount: number, inv_id: string, expires_at: string, url?: string | null }>, refunds: Array<{ __typename?: 'PaymentRefund', id: string, amount: number, status: PaymentRefundStatus, reason: string, provider_request_id?: string | null, created_at: string, actor_title?: string | null, transfer_reference?: string | null, transferred_on?: string | null, parts: Array<{ __typename?: 'PaymentRefundPartView', method: PaymentMoneyPartMethod, amount: number }> }>, receipts: Array<{ __typename?: 'PaymentReceipt', id: string, issuer: PaymentReceiptIssuer, operation: PaymentReceiptOperation, settlement_method: ReceiptSettlementMethod, status: PaymentReceiptStatus, fn_number?: string | null, fd_number?: string | null, fiscal_sign?: string | null, fiscal_at?: string | null }>, events: Array<{ __typename?: 'PaymentEvent', id: string, type: PaymentEventType, created_at: string, from_status?: string | null, to_status?: string | null, reason_code?: string | null, message?: string | null, reason?: string | null, amount?: number | null }> };

export type GetPaymentJournalQueryVariables = Exact<{
  filter?: InputMaybe<PaymentJournalFilter>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaymentJournalQuery = { __typename?: 'Query', paymentJournal: { __typename?: 'PaymentJournalEntryConnection', edges: Array<{ __typename?: 'PaymentJournalEntryEdge', cursor: string, node: { __typename?: 'PaymentJournalEntry', key: string, id: string, payment_id: string, kind: PaymentJournalKind, amount: number, provider: PaymentProvider, methods: Array<PaymentMoneyPartMethod>, receipt_operation: PaymentReceiptOperation, receipt_settlement_method: ReceiptSettlementMethod, receipt_fd_number?: string | null, receipt_issuer?: PaymentReceiptIssuer | null, receipts_count: number, location_id: string, location_title: string, timezone: string, created_at: string, actor_title?: string | null, reason?: string | null, payment_captured_at?: string | null, failure_kind?: OrderFiscalFailureKind | null, failure_message?: string | null, failure_reason_code?: string | null, money_status?: PaymentJournalMoneyStatus | null, receipt_status?: PaymentReceiptStatus | null, attention_reasons: Array<PaymentAttentionReason>, transfer_details?: { __typename?: 'PaymentTransferDetails', payment_order_number: string, received_on: string, invoice_number?: number | null } | null, source_summary?: { __typename?: 'PaymentSourceSummary', customer_name?: string | null, description?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', payment?: { __typename?: 'PaymentDetails', id: string, amount: number, confirmed_amount: number, refundable_amount: number, provider: PaymentProvider, mode?: PaymentConnectionMode | null, location_id: string, location_title: string, timezone: string, created_at: string, captured_at?: string | null, actor_title?: string | null, status?: PaymentStatus | null, application_status?: PaymentApplicationStatus | null, order_id?: string | null, fiscal_operation_id?: string | null, block_scope: PaymentBlockScope, attention_reasons: Array<PaymentAttentionReason>, available_actions: Array<PaymentAvailableAction>, source_summary?: { __typename?: 'PaymentSourceSummary', customer_name?: string | null, description?: string | null } | null, transfer_details?: { __typename?: 'PaymentTransferDetails', payment_order_number: string, received_on: string, invoice_number?: number | null } | null, money_parts: Array<{ __typename?: 'PaymentMoneyPart', id: string, method: PaymentMoneyPartMethod, planned_amount: number, confirmed_amount: number }>, attempts: Array<{ __typename?: 'PaymentAttempt', id: string, status: PaymentAttemptStatus, created_at: string }>, links: Array<{ __typename?: 'PaymentLinkState', id: string, status: PaymentLinkStatus, amount: number, inv_id: string, expires_at: string, url?: string | null }>, refunds: Array<{ __typename?: 'PaymentRefund', id: string, amount: number, status: PaymentRefundStatus, reason: string, provider_request_id?: string | null, created_at: string, actor_title?: string | null, transfer_reference?: string | null, transferred_on?: string | null, parts: Array<{ __typename?: 'PaymentRefundPartView', method: PaymentMoneyPartMethod, amount: number }> }>, receipts: Array<{ __typename?: 'PaymentReceipt', id: string, issuer: PaymentReceiptIssuer, operation: PaymentReceiptOperation, settlement_method: ReceiptSettlementMethod, status: PaymentReceiptStatus, fn_number?: string | null, fd_number?: string | null, fiscal_sign?: string | null, fiscal_at?: string | null }>, events: Array<{ __typename?: 'PaymentEvent', id: string, type: PaymentEventType, created_at: string, from_status?: string | null, to_status?: string | null, reason_code?: string | null, message?: string | null, reason?: string | null, amount?: number | null }> } | null };

export type GetPersonNameSuggestionsQueryVariables = Exact<{
  kind: PersonNameKind;
  query: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPersonNameSuggestionsQuery = { __typename?: 'Query', personNameSuggestions: { __typename?: 'PersonNameSuggestions', correction?: string | null, items: Array<{ __typename?: 'PersonNameSuggestion', text: string }>, split?: { __typename?: 'PersonNameSplit', first_name?: string | null, last_name?: string | null, patronymic_name?: string | null } | null } };

export type PlatformOrganizationRowFieldsFragment = { __typename?: 'PlatformOrganizationRow', employee_count: number, uses_default_modules: boolean, organization: { __typename?: 'Organization', id: string, alias?: string | null, title: string, domain?: string | null, enabled_modules: Array<OrganizationModule>, created_at?: string | null, updated_at?: string | null }, locations: Array<{ __typename?: 'Location', id: string, title: string, city?: string | null, address?: string | null, full_address?: string | null, phone?: string | null, opened_from?: string | null, closed_from?: string | null }> };

export type PlatformUserRowFieldsFragment = { __typename?: 'PlatformUserRow', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone?: string | null, last_activity_at?: string | null, created_at?: string | null, is_super_user?: boolean | null }, memberships: Array<{ __typename?: 'PlatformUserMembership', employee: { __typename?: 'Employee', id: string, status: EmployeeStatus, is_owner: boolean, title?: string | null, created_at: string, last_activity_at?: string | null }, organization: { __typename?: 'Organization', id: string, alias?: string | null, title: string }, locations: Array<{ __typename?: 'Location', id: string, title: string }> }> };

export type GetPlatformOrganizationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlatformOrganizationsQuery = { __typename?: 'Query', platformOrganizations: { __typename?: 'PlatformOrganizationRowConnection', edges: Array<{ __typename?: 'PlatformOrganizationRowEdge', cursor: string, node: { __typename?: 'PlatformOrganizationRow', employee_count: number, uses_default_modules: boolean, organization: { __typename?: 'Organization', id: string, alias?: string | null, title: string, domain?: string | null, enabled_modules: Array<OrganizationModule>, created_at?: string | null, updated_at?: string | null }, locations: Array<{ __typename?: 'Location', id: string, title: string, city?: string | null, address?: string | null, full_address?: string | null, phone?: string | null, opened_from?: string | null, closed_from?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetPlatformUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<PlatformUserSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlatformUsersQuery = { __typename?: 'Query', platformUsers: { __typename?: 'PlatformUserRowConnection', edges: Array<{ __typename?: 'PlatformUserRowEdge', cursor: string, node: { __typename?: 'PlatformUserRow', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone?: string | null, last_activity_at?: string | null, created_at?: string | null, is_super_user?: boolean | null }, memberships: Array<{ __typename?: 'PlatformUserMembership', employee: { __typename?: 'Employee', id: string, status: EmployeeStatus, is_owner: boolean, title?: string | null, created_at: string, last_activity_at?: string | null }, organization: { __typename?: 'Organization', id: string, alias?: string | null, title: string }, locations: Array<{ __typename?: 'Location', id: string, title: string }> }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetPlatformOrganizationQueryVariables = Exact<{
  organizationSearch: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetPlatformOrganizationQuery = { __typename?: 'Query', platformOrganizations: { __typename?: 'PlatformOrganizationRowConnection', edges: Array<{ __typename?: 'PlatformOrganizationRowEdge', node: { __typename?: 'PlatformOrganizationRow', employee_count: number, uses_default_modules: boolean, organization: { __typename?: 'Organization', id: string, alias?: string | null, title: string, domain?: string | null, enabled_modules: Array<OrganizationModule>, created_at?: string | null, updated_at?: string | null }, locations: Array<{ __typename?: 'Location', id: string, title: string, city?: string | null, address?: string | null, full_address?: string | null, phone?: string | null, opened_from?: string | null, closed_from?: string | null }> } }> }, platformUsers: { __typename?: 'PlatformUserRowConnection', edges: Array<{ __typename?: 'PlatformUserRowEdge', node: { __typename?: 'PlatformUserRow', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone?: string | null, last_activity_at?: string | null, created_at?: string | null, is_super_user?: boolean | null }, memberships: Array<{ __typename?: 'PlatformUserMembership', employee: { __typename?: 'Employee', id: string, status: EmployeeStatus, is_owner: boolean, title?: string | null, created_at: string, last_activity_at?: string | null }, organization: { __typename?: 'Organization', id: string, alias?: string | null, title: string }, locations: Array<{ __typename?: 'Location', id: string, title: string }> }> } }>, pageInfo: { __typename?: 'PageInfo', total: number } } };

export type StartPlatformImpersonationMutationVariables = Exact<{
  input: PlatformStartImpersonationInput;
}>;


export type StartPlatformImpersonationMutation = { __typename?: 'Mutation', platformStartImpersonation: { __typename?: 'ImpersonationState', active: boolean, session_id?: string | null, started_at?: string | null, target_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone?: string | null } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null } };

export type EnterOrganizationAsOwnerMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type EnterOrganizationAsOwnerMutation = { __typename?: 'Mutation', enterOrganizationAsOwner: { __typename?: 'ImpersonationState', active: boolean, organization?: { __typename?: 'Organization', id: string } | null } };

export type StopPlatformImpersonationMutationVariables = Exact<{ [key: string]: never; }>;


export type StopPlatformImpersonationMutation = { __typename?: 'Mutation', platformStopImpersonation: { __typename?: 'ImpersonationState', active: boolean, impersonator?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, is_super_user?: boolean | null } | null } };

export type SetPlatformOrganizationModulesMutationVariables = Exact<{
  input: PlatformSetOrganizationModulesInput;
}>;


export type SetPlatformOrganizationModulesMutation = { __typename?: 'Mutation', platformSetOrganizationModules: { __typename?: 'Organization', id: string, enabled_modules: Array<OrganizationModule> } };

export type PlatformImpersonationSessionRowFieldsFragment = { __typename?: 'PlatformImpersonationSession', id: string, reason?: string | null, ip?: string | null, user_agent?: string | null, started_at: string, ended_at?: string | null, end_reason?: ImpersonationEndReason | null, actions_count: number, impersonator: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, target_user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, organization?: { __typename?: 'Organization', id: string, title: string } | null };

export type PlatformImpersonationActionRowFieldsFragment = { __typename?: 'PlatformImpersonationAction', id: string, operation_name: string, operation_type: string, root_fields: Array<string>, created_at: string };

export type ForceStopPlatformImpersonationSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ForceStopPlatformImpersonationSessionMutation = { __typename?: 'Mutation', platformForceStopImpersonationSession: { __typename?: 'PlatformImpersonationSession', id: string, reason?: string | null, ip?: string | null, user_agent?: string | null, started_at: string, ended_at?: string | null, end_reason?: ImpersonationEndReason | null, actions_count: number, impersonator: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, target_user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, organization?: { __typename?: 'Organization', id: string, title: string } | null } };

export type GetPlatformImpersonationSessionsQueryVariables = Exact<{
  targetUserId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlatformImpersonationSessionsQuery = { __typename?: 'Query', platformImpersonationSessions: { __typename?: 'PlatformImpersonationSessionConnection', edges: Array<{ __typename?: 'PlatformImpersonationSessionEdge', cursor: string, node: { __typename?: 'PlatformImpersonationSession', id: string, reason?: string | null, ip?: string | null, user_agent?: string | null, started_at: string, ended_at?: string | null, end_reason?: ImpersonationEndReason | null, actions_count: number, impersonator: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, target_user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, organization?: { __typename?: 'Organization', id: string, title: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetPlatformImpersonationActionsQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlatformImpersonationActionsQuery = { __typename?: 'Query', platformImpersonationActions: { __typename?: 'PlatformImpersonationActionConnection', edges: Array<{ __typename?: 'PlatformImpersonationActionEdge', cursor: string, node: { __typename?: 'PlatformImpersonationAction', id: string, operation_name: string, operation_type: string, root_fields: Array<string>, created_at: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetPlatformUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlatformUserQuery = { __typename?: 'Query', platformUser?: { __typename?: 'PlatformUserRow', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone?: string | null, last_activity_at?: string | null, created_at?: string | null, is_super_user?: boolean | null }, memberships: Array<{ __typename?: 'PlatformUserMembership', employee: { __typename?: 'Employee', id: string, status: EmployeeStatus, is_owner: boolean, title?: string | null, created_at: string, last_activity_at?: string | null }, organization: { __typename?: 'Organization', id: string, alias?: string | null, title: string }, locations: Array<{ __typename?: 'Location', id: string, title: string }> }> } | null, platformImpersonationSessions: { __typename?: 'PlatformImpersonationSessionConnection', edges: Array<{ __typename?: 'PlatformImpersonationSessionEdge', cursor: string, node: { __typename?: 'PlatformImpersonationSession', id: string, reason?: string | null, ip?: string | null, user_agent?: string | null, started_at: string, ended_at?: string | null, end_reason?: ImpersonationEndReason | null, actions_count: number, impersonator: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, target_user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, organization?: { __typename?: 'Organization', id: string, title: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetPlatformOverviewQueryVariables = Exact<{
  period: PlatformOverviewPeriod;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPlatformOverviewQuery = { __typename?: 'Query', platformOverview: { __typename?: 'PlatformOverview', granularity: PlatformOverviewBucket, buckets: Array<string>, bookings: { __typename?: 'PlatformBookingsMetric', total: number, previous_total: number, previous: Array<number>, by_source: Array<{ __typename?: 'PlatformBookingSourceSeries', source: BookingPlatform, total: number, values: Array<number> }> }, turnover: { __typename?: 'PlatformTurnoverMetric', total: number, previous_total: number, previous: Array<number>, by_provider: Array<{ __typename?: 'PlatformPaymentProviderSeries', provider: PaymentProvider, total: number, values: Array<number> }> }, new_clients: { __typename?: 'PlatformCountMetric', total: number, previous_total: number, values: Array<number> }, messages: { __typename?: 'PlatformMessagesMetric', incoming_total: number, outgoing_total: number, previous_total: number, previous: Array<number>, by_provider: Array<{ __typename?: 'PlatformMessengerProviderSeries', provider: MessengerProvider, incoming: number, outgoing: number, values: Array<number> }> }, organizations: Array<{ __typename?: 'PlatformOrganizationTrend', total: number, previous_total: number, values: Array<number>, organization: { __typename?: 'Organization', id: string, title: string, domain?: string | null } }> } };

export type GetPlatformActivityFeedQueryVariables = Exact<{
  kinds?: InputMaybe<Array<PlatformActivityKind> | PlatformActivityKind>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlatformActivityFeedQuery = { __typename?: 'Query', platformActivityFeed: Array<{ __typename?: 'PlatformActivityEvent', id: string, cursor: string, kind: PlatformActivityKind, occurred_at: string, booking_source?: BookingPlatform | null, payment_provider?: PaymentProvider | null, order_source?: OrderSource | null, amount?: number | null, scheduled_for?: string | null, organization: { __typename?: 'Organization', id: string, title: string }, location?: { __typename?: 'Location', id: string, title: string, timezone: string } | null }> };

export type GetPlatformQueueStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformQueueStatsQuery = { __typename?: 'Query', platformQueueStats: Array<{ __typename?: 'PlatformQueueStat', queue: string, pending: number, oldest_pending_seconds?: number | null, failed_last_day: number }> };

export type ProductStockFieldsFragment = { __typename?: 'ProductStock', id: string, quantity: number, location: { __typename?: 'Location', id: string, title: string } };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, purchase_price: number, sale_price: number, category_id?: string | null, description?: string | null, total_stock_quantity: number, archived_at?: string | null, created_at: string, updated_at: string, stocks: Array<{ __typename?: 'ProductStock', id: string, quantity: number, location: { __typename?: 'Location', id: string, title: string } }> };

export type ShowcaseProductFieldsFragment = { __typename?: 'Product', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, sale_price: number };

export type StockBalanceFieldsFragment = { __typename?: 'StockBalance', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, stock_quantity: number, stocks: Array<{ __typename?: 'ProductStock', id: string, quantity: number, location: { __typename?: 'Location', id: string, title: string } }> };

export type ProductMovementFieldsFragment = { __typename?: 'ProductMovement', id: string, reason: ProductMovementReason, delta: number, comment?: string | null, unit_purchase_price: number, marking_codes: Array<string>, order_id?: string | null, created_at: string, location: { __typename?: 'Location', id: string, title: string }, employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, reversal?: { __typename?: 'ProductMovement', id: string } | null, transfer_source?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null, transfer_target?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null };

export type GetProductsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', cursor: string, node: { __typename?: 'Product', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, purchase_price: number, sale_price: number, category_id?: string | null, description?: string | null, total_stock_quantity: number, archived_at?: string | null, created_at: string, updated_at: string, stocks: Array<{ __typename?: 'ProductStock', id: string, quantity: number, location: { __typename?: 'Location', id: string, title: string } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, purchase_price: number, sale_price: number, category_id?: string | null, description?: string | null, total_stock_quantity: number, archived_at?: string | null, created_at: string, updated_at: string, stocks: Array<{ __typename?: 'ProductStock', id: string, quantity: number, location: { __typename?: 'Location', id: string, title: string } }> } | null };

export type GetProductMovementsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductMovementsQuery = { __typename?: 'Query', productMovements: { __typename?: 'ProductMovementConnection', edges: Array<{ __typename?: 'ProductMovementEdge', cursor: string, node: { __typename?: 'ProductMovement', id: string, reason: ProductMovementReason, delta: number, comment?: string | null, unit_purchase_price: number, marking_codes: Array<string>, order_id?: string | null, created_at: string, location: { __typename?: 'Location', id: string, title: string }, employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, reversal?: { __typename?: 'ProductMovement', id: string } | null, transfer_source?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null, transfer_target?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetShowcaseProductsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetShowcaseProductsQuery = { __typename?: 'Query', showcaseProducts: { __typename?: 'ShowcaseProductConnection', edges: Array<{ __typename?: 'ShowcaseProductEdge', cursor: string, node: { __typename?: 'ShowcaseProduct', stock_quantity: number, product: { __typename?: 'Product', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, sale_price: number } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetStockProductsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStockProductsQuery = { __typename?: 'Query', stockProducts: { __typename?: 'ShowcaseProductConnection', edges: Array<{ __typename?: 'ShowcaseProductEdge', cursor: string, node: { __typename?: 'ShowcaseProduct', stock_quantity: number, product: { __typename?: 'Product', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, sale_price: number } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetStockBalancesQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStockBalancesQuery = { __typename?: 'Query', stockBalances: { __typename?: 'StockBalanceConnection', edges: Array<{ __typename?: 'StockBalanceEdge', cursor: string, node: { __typename?: 'StockBalance', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, stock_quantity: number, stocks: Array<{ __typename?: 'ProductStock', id: string, quantity: number, location: { __typename?: 'Location', id: string, title: string } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetStockMovementsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStockMovementsQuery = { __typename?: 'Query', stockMovements: { __typename?: 'ProductMovementConnection', edges: Array<{ __typename?: 'ProductMovementEdge', cursor: string, node: { __typename?: 'ProductMovement', id: string, reason: ProductMovementReason, delta: number, comment?: string | null, unit_purchase_price: number, marking_codes: Array<string>, order_id?: string | null, created_at: string, product: { __typename?: 'Product', id: string, title: string }, location: { __typename?: 'Location', id: string, title: string }, employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, reversal?: { __typename?: 'ProductMovement', id: string } | null, transfer_source?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null, transfer_target?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetProductUnitQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetProductUnitQuery = { __typename?: 'Query', productUnit?: { __typename?: 'ProductUnit', code: string, status: ProductUnitStatus, location: { __typename?: 'Location', id: string, title: string }, product: { __typename?: 'Product', id: string, title: string } } | null };

export type QrLinkFragmentFragment = { __typename?: 'QrLink', id: string, name: string, code: string, target_url: string, total_clicks: number, public_url: string, style_config: string, deleted_at?: string | null, created_at: string, updated_at: string };

export type GetQrLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQrLinksQuery = { __typename?: 'Query', qrLinks: Array<{ __typename?: 'QrLink', id: string, name: string, code: string, target_url: string, total_clicks: number, public_url: string, style_config: string, deleted_at?: string | null, created_at: string, updated_at: string }> };

export type GetQrLinkQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetQrLinkQuery = { __typename?: 'Query', qrLink?: { __typename?: 'QrLink', id: string, name: string, code: string, target_url: string, total_clicks: number, public_url: string, style_config: string, deleted_at?: string | null, created_at: string, updated_at: string } | null };

export type GetQrLinksTrashedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQrLinksTrashedQuery = { __typename?: 'Query', qrLinksTrashed: Array<{ __typename?: 'QrLink', id: string, name: string, code: string, target_url: string, total_clicks: number, public_url: string, style_config: string, deleted_at?: string | null, created_at: string, updated_at: string }> };

export type ScenarioStepFragmentFragment = { __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null, on_timeout?: string | null, buttons?: Array<{ __typename?: 'ScenarioStepButton', text: string, url: string }> | null };

export type ScenarioListFragmentFragment = { __typename?: 'Scenario', id: string, name: string, code?: string | null, is_active: boolean, active_from?: string | null, active_to?: string | null, stop_if_booked: boolean, restart_on_reactivation: boolean, runs_count: number, created_at: string, updated_at: string, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean } | null, default_city?: { __typename?: 'City', id: string, name: string } | null };

export type ScenarioDetailFragmentFragment = { __typename?: 'Scenario', id: string, name: string, code?: string | null, is_active: boolean, active_from?: string | null, active_to?: string | null, stop_if_booked: boolean, restart_on_reactivation: boolean, registration_bonus_points?: number | null, available_providers: Array<string>, runs_count: number, structural_edit_locked: boolean, created_at: string, updated_at: string, statistics: { __typename?: 'ScenarioStatistics', overview: { __typename?: 'ScenarioStatsOverview', contacts_collected: number, new_clients: number, new_clients_revenue: number, reactivated_clients: number, reactivated_revenue: number }, funnel: { __typename?: 'ScenarioStatsFunnel', contacts_collected: number, identified: number, reached_club: number } }, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean } | null, default_city?: { __typename?: 'City', id: string, name: string } | null, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null, on_timeout?: string | null, buttons?: Array<{ __typename?: 'ScenarioStepButton', text: string, url: string }> | null }> };

export type GetScenariosQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetScenariosQuery = { __typename?: 'Query', scenarios: { __typename?: 'ScenarioConnection', edges: Array<{ __typename?: 'ScenarioEdge', cursor: string, node: { __typename?: 'Scenario', id: string, name: string, code?: string | null, is_active: boolean, active_from?: string | null, active_to?: string | null, stop_if_booked: boolean, restart_on_reactivation: boolean, runs_count: number, created_at: string, updated_at: string, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean } | null, default_city?: { __typename?: 'City', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetScenarioQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScenarioQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, name: string, code?: string | null, is_active: boolean, active_from?: string | null, active_to?: string | null, stop_if_booked: boolean, restart_on_reactivation: boolean, registration_bonus_points?: number | null, available_providers: Array<string>, runs_count: number, structural_edit_locked: boolean, created_at: string, updated_at: string, statistics: { __typename?: 'ScenarioStatistics', overview: { __typename?: 'ScenarioStatsOverview', contacts_collected: number, new_clients: number, new_clients_revenue: number, reactivated_clients: number, reactivated_revenue: number }, funnel: { __typename?: 'ScenarioStatsFunnel', contacts_collected: number, identified: number, reached_club: number } }, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean } | null, default_city?: { __typename?: 'City', id: string, name: string } | null, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null, on_timeout?: string | null, buttons?: Array<{ __typename?: 'ScenarioStepButton', text: string, url: string }> | null }> } | null };

export type TireCarFieldsFragment = { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } };

export type TireStorageItemFieldsFragment = { __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null };

export type TireStorageSummaryFieldsFragment = { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null };

export type TireStorageFieldsFragment = { __typename?: 'TireStorage', overdue_days: number, released_at?: string | null, created_at: string, location_id: string, id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null }, car: { __typename?: 'TireCar', id: string }, car_details: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null }, intake_work_order: { __typename?: 'TireWorkOrder', id: string, number: number }, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null };

export type TireStorageReleaseFieldsFragment = { __typename?: 'TireStorageRelease', id: string, released_at: string, remaining_quantity: number, items: Array<{ __typename?: 'TireStorageReleaseItem', item_id: string, quantity: number }> };

export type TireWorkOrderFieldsFragment = { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> };

export type GetTireCarsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetTireCarsQuery = { __typename?: 'Query', tireCars: Array<{ __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } }> };

export type GetTireCarLookupQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetTireCarLookupQuery = { __typename?: 'Query', tireCarLookup: Array<{ __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } }> };

export type GetTireCarMarksQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetTireCarMarksQuery = { __typename?: 'Query', tireCarMarks: { __typename?: 'TireCarSuggestions', match?: string | null, items: Array<string> } };

export type GetTireCarModelsQueryVariables = Exact<{
  mark: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetTireCarModelsQuery = { __typename?: 'Query', tireCarModels: { __typename?: 'TireCarSuggestions', match?: string | null, items: Array<string> } };

export type GetTireBrandsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTireBrandsQuery = { __typename?: 'Query', tireBrands: Array<string> };

export type GetTireModelsQueryVariables = Exact<{
  brand: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTireModelsQuery = { __typename?: 'Query', tireModels: Array<string> };

export type TireServiceItemFieldsFragment = { __typename?: 'CatalogItem', id: string, category_id?: string | null, title: string, position: number, price_rule: CatalogPriceRule, fixed_price?: number | null, range_min?: number | null, range_max?: number | null, price_from?: number | null, tire_kind: TireServiceItemKind, tire_prices: Array<{ __typename?: 'TireServicePrice', location_id?: string | null, car_class_id: string, wheel_diameter: number, run_flat: boolean, price: number }> };

export type GetTireServiceCatalogQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetTireServiceCatalogQuery = { __typename?: 'Query', catalogCategories: Array<{ __typename?: 'CatalogCategory', id: string, title: string, position: number }>, catalogItems: Array<{ __typename?: 'CatalogItem', id: string, category_id?: string | null, title: string, position: number, price_rule: CatalogPriceRule, fixed_price?: number | null, range_min?: number | null, range_max?: number | null, price_from?: number | null, tire_kind: TireServiceItemKind, tire_prices: Array<{ __typename?: 'TireServicePrice', location_id?: string | null, car_class_id: string, wheel_diameter: number, run_flat: boolean, price: number }> }> };

export type GetTireServicePricingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTireServicePricingQuery = { __typename?: 'Query', catalogItem?: { __typename?: 'CatalogItem', id: string, tire_prices: Array<{ __typename?: 'TireServicePrice', location_id?: string | null, car_class_id: string, wheel_diameter: number, run_flat: boolean, price: number }> } | null };

export type TireServiceSettingsFieldsFragment = { __typename?: 'TireServiceSettings', diameter_min: number, diameter_max: number, run_flat_enabled: boolean, car_classes: Array<{ __typename?: 'TireCarClass', id: string, title: string }>, archived_car_classes: Array<{ __typename?: 'TireCarClass', id: string, title: string }> };

export type GetTireServiceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTireServiceSettingsQuery = { __typename?: 'Query', tireServiceSettings: { __typename?: 'TireServiceSettings', diameter_min: number, diameter_max: number, run_flat_enabled: boolean, car_classes: Array<{ __typename?: 'TireCarClass', id: string, title: string }>, archived_car_classes: Array<{ __typename?: 'TireCarClass', id: string, title: string }> } };

export type TireStorageWarehouseFieldsFragment = { __typename?: 'TireStorageWarehouse', id: string, title: string, rack_count: number, cell_count: number, occupied_cells: number, location_id: string };

export type GetTireStorageWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTireStorageWarehousesQuery = { __typename?: 'Query', tireStorageWarehouses: Array<{ __typename?: 'TireStorageWarehouse', id: string, title: string, rack_count: number, cell_count: number, occupied_cells: number, location_id: string }> };

export type GetTireSettingsWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTireSettingsWarehousesQuery = { __typename?: 'Query', tireSettingsWarehouses: Array<{ __typename?: 'TireStorageWarehouse', id: string, title: string, rack_count: number, cell_count: number, occupied_cells: number, location_id: string }> };

export type GetTireWorkOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTireWorkOrderQuery = { __typename?: 'Query', tireWorkOrder?: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, print_requisites: { __typename?: 'TirePrintRequisites', location_title: string, address?: string | null, phone?: string | null, legal_name?: string | null, legal_address?: string | null, legal_tin?: string | null, legal_ogrn?: string | null }, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } | null };

export type GetTireWorkOrdersQueryVariables = Exact<{
  status?: InputMaybe<TireWorkOrderStatus>;
  shift?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTireWorkOrdersQuery = { __typename?: 'Query', tireWorkOrders: { __typename?: 'TireWorkOrderConnection', edges: Array<{ __typename?: 'TireWorkOrderEdge', cursor: string, node: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, title: string, quantity: number, kind: TireServiceItemKind }>, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetTireWorkOrderJournalQueryVariables = Exact<{
  locationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetTireWorkOrderJournalQuery = { __typename?: 'Query', tireWorkOrderJournal: { __typename?: 'TireWorkOrderJournal', open_count: number, shift?: { __typename?: 'TireWorkOrderShift', opened_at: string, closed_at?: string | null, closed_count: number, closed_amount: number } | null } };

export type GetTireWorkOrderForBookingQueryVariables = Exact<{
  bookingGroupId: Scalars['ID']['input'];
}>;


export type GetTireWorkOrderForBookingQuery = { __typename?: 'Query', tireWorkOrderForBooking?: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus } | null };

export type GetTireStoragesQueryVariables = Exact<{
  tab: TireStorageTab;
  search?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTireStoragesQuery = { __typename?: 'Query', tireStorages: { __typename?: 'TireStorageConnection', edges: Array<{ __typename?: 'TireStorageEdge', cursor: string, node: { __typename?: 'TireStorage', overdue_days: number, released_at?: string | null, created_at: string, location_id: string, id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null }, car: { __typename?: 'TireCar', id: string }, car_details: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null }, intake_work_order: { __typename?: 'TireWorkOrder', id: string, number: number }, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type TireStoragePaidWorkOrderFieldsFragment = { __typename?: 'TireWorkOrder', id: string, number: number, closed_at?: string | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, kind: TireServiceItemKind, storage_id?: string | null, amount: number, storage_until?: string | null }> };

export type GetTireStorageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTireStorageQuery = { __typename?: 'Query', tireStorage?: { __typename?: 'TireStorage', overdue_days: number, released_at?: string | null, created_at: string, location_id: string, id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, releases: Array<{ __typename?: 'TireStorageRelease', id: string, released_at: string, remaining_quantity: number, items: Array<{ __typename?: 'TireStorageReleaseItem', item_id: string, quantity: number }> }>, extension_work_orders: Array<{ __typename?: 'TireWorkOrder', id: string, number: number, closed_at?: string | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, kind: TireServiceItemKind, storage_id?: string | null, amount: number, storage_until?: string | null }> }>, intake_work_order: { __typename?: 'TireWorkOrder', id: string, number: number, closed_at?: string | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, kind: TireServiceItemKind, storage_id?: string | null, amount: number, storage_until?: string | null }> }, print_requisites: { __typename?: 'TirePrintRequisites', location_title: string, address?: string | null, phone?: string | null, legal_name?: string | null, legal_address?: string | null, legal_tin?: string | null, legal_ogrn?: string | null }, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null }, car: { __typename?: 'TireCar', id: string }, car_details: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null }, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null };

export type GetTireStorageClientPhoneQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTireStorageClientPhoneQuery = { __typename?: 'Query', tireStorageClientPhone?: string | null };

export type GetTireClientStoragesQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetTireClientStoragesQuery = { __typename?: 'Query', tireClientStorages: Array<{ __typename?: 'TireStorage', overdue_days: number, released_at?: string | null, created_at: string, location_id: string, id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null }, car: { __typename?: 'TireCar', id: string }, car_details: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null }, intake_work_order: { __typename?: 'TireWorkOrder', id: string, number: number }, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null }> };

export type GetTireStorageInStockCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTireStorageInStockCountQuery = { __typename?: 'Query', tireStorageInStockCount: number };

export type GetTireStorageFreeCellQueryVariables = Exact<{
  warehouseId: Scalars['ID']['input'];
}>;


export type GetTireStorageFreeCellQuery = { __typename?: 'Query', tireStorageFreeCell?: { __typename?: 'TireStorageCell', rack_no: number, cell_no: number } | null };

export type CreateMarketingBroadcastMutationVariables = Exact<{
  input: MarketingBroadcastInput;
}>;


export type CreateMarketingBroadcastMutation = { __typename?: 'Mutation', createMarketingBroadcast: { __typename?: 'MarketingBroadcast', id: string, name: string, body: string, version: number, audience_definition_version: number, audience_snapshot_id?: string | null, status: MarketingBroadcastStatus, bonus_enabled: boolean, bonus_amount?: number | null, bonus_expires_on?: string | null, bonus_timezone?: string | null, bonus_expires_at?: string | null, total_count: number, sent_count: number, failed_count: number, unknown_count: number, started_at?: string | null, snapshot_at?: string | null, completed_at?: string | null, failed_reason?: string | null, created_at: string, updated_at: string, audience_definition?: { __typename?: 'BroadcastAudienceDefinition', additions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }>, exclusions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }> } | null, audience_snapshot?: { __typename?: 'MarketingBroadcastAudienceSnapshot', id: string, definition_version: number, status: BroadcastAudienceSnapshotStatus, as_of: string, total_count: number, ready_count: number, excluded_count: number, no_channel_count: number, linked_ready_count: number, unlinked_ready_count: number, failed_reason?: string | null, windows: Array<{ __typename?: 'BroadcastAudienceWindow', rule_id: string, months: number, from_at: string, to_at: string }>, channel_counts: Array<{ __typename?: 'BroadcastAudienceChannelCount', channel_label: string, count: number }> } | null, image?: { __typename?: 'MarketingBroadcastImage', url: string, file_name: string, mime_type: string, file_size: number, width: number, height: number } | null } };

export type UpdateMarketingBroadcastMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
  input: MarketingBroadcastInput;
}>;


export type UpdateMarketingBroadcastMutation = { __typename?: 'Mutation', updateMarketingBroadcast: { __typename?: 'MarketingBroadcast', id: string, name: string, body: string, version: number, audience_definition_version: number, audience_snapshot_id?: string | null, status: MarketingBroadcastStatus, bonus_enabled: boolean, bonus_amount?: number | null, bonus_expires_on?: string | null, bonus_timezone?: string | null, bonus_expires_at?: string | null, total_count: number, sent_count: number, failed_count: number, unknown_count: number, started_at?: string | null, snapshot_at?: string | null, completed_at?: string | null, failed_reason?: string | null, created_at: string, updated_at: string, audience_definition?: { __typename?: 'BroadcastAudienceDefinition', additions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }>, exclusions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }> } | null, audience_snapshot?: { __typename?: 'MarketingBroadcastAudienceSnapshot', id: string, definition_version: number, status: BroadcastAudienceSnapshotStatus, as_of: string, total_count: number, ready_count: number, excluded_count: number, no_channel_count: number, linked_ready_count: number, unlinked_ready_count: number, failed_reason?: string | null, windows: Array<{ __typename?: 'BroadcastAudienceWindow', rule_id: string, months: number, from_at: string, to_at: string }>, channel_counts: Array<{ __typename?: 'BroadcastAudienceChannelCount', channel_label: string, count: number }> } | null, image?: { __typename?: 'MarketingBroadcastImage', url: string, file_name: string, mime_type: string, file_size: number, width: number, height: number } | null } };

export type StartMarketingBroadcastMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
  snapshotId: Scalars['ID']['input'];
}>;


export type StartMarketingBroadcastMutation = { __typename?: 'Mutation', startMarketingBroadcast: { __typename?: 'MarketingBroadcast', id: string, name: string, body: string, version: number, audience_definition_version: number, audience_snapshot_id?: string | null, status: MarketingBroadcastStatus, bonus_enabled: boolean, bonus_amount?: number | null, bonus_expires_on?: string | null, bonus_timezone?: string | null, bonus_expires_at?: string | null, total_count: number, sent_count: number, failed_count: number, unknown_count: number, started_at?: string | null, snapshot_at?: string | null, completed_at?: string | null, failed_reason?: string | null, created_at: string, updated_at: string, audience_definition?: { __typename?: 'BroadcastAudienceDefinition', additions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }>, exclusions: Array<{ __typename?: 'BroadcastAudienceRule', id: string, kind: BroadcastAudienceRuleKind, months?: number | null, broadcast_id?: string | null }> } | null, audience_snapshot?: { __typename?: 'MarketingBroadcastAudienceSnapshot', id: string, definition_version: number, status: BroadcastAudienceSnapshotStatus, as_of: string, total_count: number, ready_count: number, excluded_count: number, no_channel_count: number, linked_ready_count: number, unlinked_ready_count: number, failed_reason?: string | null, windows: Array<{ __typename?: 'BroadcastAudienceWindow', rule_id: string, months: number, from_at: string, to_at: string }>, channel_counts: Array<{ __typename?: 'BroadcastAudienceChannelCount', channel_label: string, count: number }> } | null, image?: { __typename?: 'MarketingBroadcastImage', url: string, file_name: string, mime_type: string, file_size: number, width: number, height: number } | null } };

export type PrepareMarketingBroadcastAudienceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
  requestId: Scalars['ID']['input'];
}>;


export type PrepareMarketingBroadcastAudienceMutation = { __typename?: 'Mutation', prepareMarketingBroadcastAudience: { __typename?: 'MarketingBroadcastAudienceSnapshot', id: string, definition_version: number, status: BroadcastAudienceSnapshotStatus, as_of: string, total_count: number, ready_count: number, excluded_count: number, no_channel_count: number, linked_ready_count: number, unlinked_ready_count: number, failed_reason?: string | null, windows: Array<{ __typename?: 'BroadcastAudienceWindow', rule_id: string, months: number, from_at: string, to_at: string }>, channel_counts: Array<{ __typename?: 'BroadcastAudienceChannelCount', channel_label: string, count: number }> } };

export type SendMarketingBroadcastTestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
  target: MarketingBroadcastTestTargetInput;
}>;


export type SendMarketingBroadcastTestMutation = { __typename?: 'Mutation', sendMarketingBroadcastTest: { __typename?: 'MarketingBroadcastTestDelivery', message_id?: string | null, status: MarketingBroadcastRecipientStatus, failed_reason?: string | null } };

export type CreateClientAutomationMutationVariables = Exact<{
  kind: ClientAutomationKind;
  input: ClientAutomationInput;
}>;


export type CreateClientAutomationMutation = { __typename?: 'Mutation', createClientAutomation: { __typename?: 'ClientAutomation', id?: string | null, kind: ClientAutomationKind, section: ClientAutomationSection, title: string, kind_title: string, description: string, enabled: boolean, channel_policy: ClientAutomationChannelPolicy, quiet_hours_mode: ClientAutomationQuietHoursMode, trigger_value?: number | null, bonus_points?: number | null, bonus_expiry_days?: number | null, template: string, default_template: string, variables: Array<string>, button_label?: string | null, required: boolean, footer?: string | null, link_code?: string | null, is_modified: boolean, active_providers: Array<MessengerProvider>, trigger_options: Array<{ __typename?: 'ClientAutomationTriggerOption', value: number, description: string, quiet_hours_mode: ClientAutomationQuietHoursMode }>, last_30_days: { __typename?: 'ClientAutomationCounters', sent: number, delivered: number, failed: number } } };

export type UpdateClientAutomationMutationVariables = Exact<{
  kind: ClientAutomationKind;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ClientAutomationInput;
}>;


export type UpdateClientAutomationMutation = { __typename?: 'Mutation', updateClientAutomation: { __typename?: 'ClientAutomation', id?: string | null, kind: ClientAutomationKind, section: ClientAutomationSection, title: string, kind_title: string, description: string, enabled: boolean, channel_policy: ClientAutomationChannelPolicy, quiet_hours_mode: ClientAutomationQuietHoursMode, trigger_value?: number | null, bonus_points?: number | null, bonus_expiry_days?: number | null, template: string, default_template: string, variables: Array<string>, button_label?: string | null, required: boolean, footer?: string | null, link_code?: string | null, is_modified: boolean, active_providers: Array<MessengerProvider>, trigger_options: Array<{ __typename?: 'ClientAutomationTriggerOption', value: number, description: string, quiet_hours_mode: ClientAutomationQuietHoursMode }>, last_30_days: { __typename?: 'ClientAutomationCounters', sent: number, delivered: number, failed: number } } };

export type DeleteClientAutomationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClientAutomationMutation = { __typename?: 'Mutation', deleteClientAutomation: { __typename?: 'ClientAutomation', id?: string | null, kind: ClientAutomationKind, section: ClientAutomationSection, title: string, kind_title: string, description: string, enabled: boolean, channel_policy: ClientAutomationChannelPolicy, quiet_hours_mode: ClientAutomationQuietHoursMode, trigger_value?: number | null, bonus_points?: number | null, bonus_expiry_days?: number | null, template: string, default_template: string, variables: Array<string>, button_label?: string | null, required: boolean, footer?: string | null, link_code?: string | null, is_modified: boolean, active_providers: Array<MessengerProvider>, trigger_options: Array<{ __typename?: 'ClientAutomationTriggerOption', value: number, description: string, quiet_hours_mode: ClientAutomationQuietHoursMode }>, last_30_days: { __typename?: 'ClientAutomationCounters', sent: number, delivered: number, failed: number } } };

export type ResetClientAutomationMutationVariables = Exact<{
  kind: ClientAutomationKind;
}>;


export type ResetClientAutomationMutation = { __typename?: 'Mutation', resetClientAutomation: { __typename?: 'ClientAutomation', id?: string | null, kind: ClientAutomationKind, section: ClientAutomationSection, title: string, kind_title: string, description: string, enabled: boolean, channel_policy: ClientAutomationChannelPolicy, quiet_hours_mode: ClientAutomationQuietHoursMode, trigger_value?: number | null, bonus_points?: number | null, bonus_expiry_days?: number | null, template: string, default_template: string, variables: Array<string>, button_label?: string | null, required: boolean, footer?: string | null, link_code?: string | null, is_modified: boolean, active_providers: Array<MessengerProvider>, trigger_options: Array<{ __typename?: 'ClientAutomationTriggerOption', value: number, description: string, quiet_hours_mode: ClientAutomationQuietHoursMode }>, last_30_days: { __typename?: 'ClientAutomationCounters', sent: number, delivered: number, failed: number } } };

export type UpdateClientQuietHoursMutationVariables = Exact<{
  input: ClientQuietHoursInput;
}>;


export type UpdateClientQuietHoursMutation = { __typename?: 'Mutation', updateClientQuietHours: { __typename?: 'ClientQuietHours', enabled: boolean, start: string, end: string } };

export type SendClientAutomationTestMutationVariables = Exact<{
  kind: ClientAutomationKind;
  id?: InputMaybe<Scalars['ID']['input']>;
  target: MarketingBroadcastTestTargetInput;
}>;


export type SendClientAutomationTestMutation = { __typename?: 'Mutation', sendClientAutomationTest: { __typename?: 'MessengerMessage', id: string } };

export type CreateClientMutationVariables = Exact<{
  input: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, type: ClientType, legal_form?: LegalForm | null, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, sex?: ClientSex | null, birthday?: string | null, importance?: string | null, discount?: number | null, visits_count?: number | null, hours_total?: number | null, ltv?: number | null, avg_check?: number | null, note?: string | null, created_at: string, last_visit_at?: string | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, first_visit_location?: { __typename?: 'Location', id: string, title: string } | null, last_visit_location?: { __typename?: 'Location', id: string, title: string } | null, active_scenario_runs: Array<{ __typename?: 'ScenarioRun', id: string, current_step_index: number, status: ScenarioRunStatus, started_at?: string | null, last_step_at?: string | null, scenario: { __typename?: 'Scenario', id: string, name: string, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null }> } }> } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string, type: ClientType, legal_form?: LegalForm | null, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email?: string | null, sex?: ClientSex | null, birthday?: string | null, importance?: string | null, discount?: number | null, visits_count?: number | null, hours_total?: number | null, ltv?: number | null, avg_check?: number | null, note?: string | null, created_at: string, last_visit_at?: string | null, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string } | null, first_visit_location?: { __typename?: 'Location', id: string, title: string } | null, last_visit_location?: { __typename?: 'Location', id: string, title: string } | null, active_scenario_runs: Array<{ __typename?: 'ScenarioRun', id: string, current_step_index: number, status: ScenarioRunStatus, started_at?: string | null, last_step_at?: string | null, scenario: { __typename?: 'Scenario', id: string, name: string, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null }> } }> } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: boolean };

export type CreateClientSegmentMutationVariables = Exact<{
  input: ClientSegmentInput;
}>;


export type CreateClientSegmentMutation = { __typename?: 'Mutation', createClientSegment: { __typename?: 'ClientSegment', id: string, kind: ClientSegmentKind, code?: ClientSegmentStandardCode | null, name: string, description: string, badge_enabled: boolean, badge_color?: string | null, is_modified: boolean, position: number, clients_count: number, members_computed_at?: string | null, rules: Array<{ __typename?: 'ClientSegmentRule', subject: ClientSegmentRuleSubject, predicate: ClientSegmentRulePredicate, value?: number | null, values: Array<string>, window?: { __typename?: 'ClientSegmentRuleWindow', unit: ClientSegmentWindowUnit, amount: number } | null, conditions: Array<{ __typename?: 'ClientSegmentRuleCondition', field: ClientSegmentConditionField, operator: ClientSegmentConditionOperator, activity_types: Array<ClientActivityType>, location_ids: Array<string>, booking_channels: Array<BookingPlatform> }> }> } };

export type UpdateClientSegmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ClientSegmentInput;
}>;


export type UpdateClientSegmentMutation = { __typename?: 'Mutation', updateClientSegment: { __typename?: 'ClientSegment', id: string, kind: ClientSegmentKind, code?: ClientSegmentStandardCode | null, name: string, description: string, badge_enabled: boolean, badge_color?: string | null, is_modified: boolean, position: number, clients_count: number, members_computed_at?: string | null, rules: Array<{ __typename?: 'ClientSegmentRule', subject: ClientSegmentRuleSubject, predicate: ClientSegmentRulePredicate, value?: number | null, values: Array<string>, window?: { __typename?: 'ClientSegmentRuleWindow', unit: ClientSegmentWindowUnit, amount: number } | null, conditions: Array<{ __typename?: 'ClientSegmentRuleCondition', field: ClientSegmentConditionField, operator: ClientSegmentConditionOperator, activity_types: Array<ClientActivityType>, location_ids: Array<string>, booking_channels: Array<BookingPlatform> }> }> } };

export type DeleteClientSegmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClientSegmentMutation = { __typename?: 'Mutation', deleteClientSegment: { __typename?: 'ClientSegment', id: string } };

export type ResetClientSegmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResetClientSegmentMutation = { __typename?: 'Mutation', resetClientSegment: { __typename?: 'ClientSegment', id: string, kind: ClientSegmentKind, code?: ClientSegmentStandardCode | null, name: string, description: string, badge_enabled: boolean, badge_color?: string | null, is_modified: boolean, position: number, clients_count: number, members_computed_at?: string | null, rules: Array<{ __typename?: 'ClientSegmentRule', subject: ClientSegmentRuleSubject, predicate: ClientSegmentRulePredicate, value?: number | null, values: Array<string>, window?: { __typename?: 'ClientSegmentRuleWindow', unit: ClientSegmentWindowUnit, amount: number } | null, conditions: Array<{ __typename?: 'ClientSegmentRuleCondition', field: ClientSegmentConditionField, operator: ClientSegmentConditionOperator, activity_types: Array<ClientActivityType>, location_ids: Array<string>, booking_channels: Array<BookingPlatform> }> }> } };

export type IssueInvoiceMutationVariables = Exact<{
  input: IssueInvoiceInput;
}>;


export type IssueInvoiceMutation = { __typename?: 'Mutation', issueInvoice: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, order_id: string, order_title: string, client_id: string, client_title: string, paid_at?: string | null, annulled_at?: string | null, created_at: string, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, payer: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, lines: Array<{ __typename?: 'InvoiceLine', position: number, title: string, quantity: number, unit: InvoiceLineUnit, unit_price: number, amount: number }>, receipts: Array<{ __typename?: 'InvoiceReceipt', id: string, status: InvoiceReceiptStatus, amount: number, received_on: string, payment_order_number: string, payment_id: string, confirmed_at: string, confirmed_by_title?: string | null, void_reason?: string | null, voided_at?: string | null, voided_by_title?: string | null, returned_on?: string | null, return_payment_order_number?: string | null, returned_at?: string | null, returned_by_title?: string | null }>, history: Array<{ __typename?: 'InvoiceHistoryEntry', kind: InvoiceHistoryKind, at: string, actor_title?: string | null, amount?: number | null, reference?: string | null, reason?: string | null }> } };

export type AnnulInvoiceMutationVariables = Exact<{
  input: AnnulInvoiceInput;
}>;


export type AnnulInvoiceMutation = { __typename?: 'Mutation', annulInvoice: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, order_id: string, order_title: string, client_id: string, client_title: string, paid_at?: string | null, annulled_at?: string | null, created_at: string, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, payer: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, lines: Array<{ __typename?: 'InvoiceLine', position: number, title: string, quantity: number, unit: InvoiceLineUnit, unit_price: number, amount: number }>, receipts: Array<{ __typename?: 'InvoiceReceipt', id: string, status: InvoiceReceiptStatus, amount: number, received_on: string, payment_order_number: string, payment_id: string, confirmed_at: string, confirmed_by_title?: string | null, void_reason?: string | null, voided_at?: string | null, voided_by_title?: string | null, returned_on?: string | null, return_payment_order_number?: string | null, returned_at?: string | null, returned_by_title?: string | null }>, history: Array<{ __typename?: 'InvoiceHistoryEntry', kind: InvoiceHistoryKind, at: string, actor_title?: string | null, amount?: number | null, reference?: string | null, reason?: string | null }> } };

export type ConfirmInvoiceReceiptMutationVariables = Exact<{
  input: ConfirmInvoiceReceiptInput;
}>;


export type ConfirmInvoiceReceiptMutation = { __typename?: 'Mutation', confirmInvoiceReceipt: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, order_id: string, order_title: string, client_id: string, client_title: string, paid_at?: string | null, annulled_at?: string | null, created_at: string, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, payer: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, lines: Array<{ __typename?: 'InvoiceLine', position: number, title: string, quantity: number, unit: InvoiceLineUnit, unit_price: number, amount: number }>, receipts: Array<{ __typename?: 'InvoiceReceipt', id: string, status: InvoiceReceiptStatus, amount: number, received_on: string, payment_order_number: string, payment_id: string, confirmed_at: string, confirmed_by_title?: string | null, void_reason?: string | null, voided_at?: string | null, voided_by_title?: string | null, returned_on?: string | null, return_payment_order_number?: string | null, returned_at?: string | null, returned_by_title?: string | null }>, history: Array<{ __typename?: 'InvoiceHistoryEntry', kind: InvoiceHistoryKind, at: string, actor_title?: string | null, amount?: number | null, reference?: string | null, reason?: string | null }> } };

export type VoidInvoiceReceiptMutationVariables = Exact<{
  input: VoidInvoiceReceiptInput;
}>;


export type VoidInvoiceReceiptMutation = { __typename?: 'Mutation', voidInvoiceReceipt: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, order_id: string, order_title: string, client_id: string, client_title: string, paid_at?: string | null, annulled_at?: string | null, created_at: string, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, payer: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, lines: Array<{ __typename?: 'InvoiceLine', position: number, title: string, quantity: number, unit: InvoiceLineUnit, unit_price: number, amount: number }>, receipts: Array<{ __typename?: 'InvoiceReceipt', id: string, status: InvoiceReceiptStatus, amount: number, received_on: string, payment_order_number: string, payment_id: string, confirmed_at: string, confirmed_by_title?: string | null, void_reason?: string | null, voided_at?: string | null, voided_by_title?: string | null, returned_on?: string | null, return_payment_order_number?: string | null, returned_at?: string | null, returned_by_title?: string | null }>, history: Array<{ __typename?: 'InvoiceHistoryEntry', kind: InvoiceHistoryKind, at: string, actor_title?: string | null, amount?: number | null, reference?: string | null, reason?: string | null }> } };

export type ReturnInvoiceReceiptMutationVariables = Exact<{
  input: ReturnInvoiceReceiptInput;
}>;


export type ReturnInvoiceReceiptMutation = { __typename?: 'Mutation', returnInvoiceReceipt: { __typename?: 'Invoice', id: string, number: number, status: InvoiceStatus, is_overdue: boolean, issued_on: string, due_on: string, total_amount: number, paid_amount: number, remaining_amount: number, order_id: string, order_title: string, client_id: string, client_title: string, paid_at?: string | null, annulled_at?: string | null, created_at: string, location: { __typename?: 'InvoiceLocation', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, seller: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, payer: { __typename?: 'InvoiceParty', legal_form: LegalForm, name: string, tin: string, kpp?: string | null, address: string, ogrn?: string | null, bank_name?: string | null, bik?: string | null, correspondent_account?: string | null, account?: string | null, director_name?: string | null }, lines: Array<{ __typename?: 'InvoiceLine', position: number, title: string, quantity: number, unit: InvoiceLineUnit, unit_price: number, amount: number }>, receipts: Array<{ __typename?: 'InvoiceReceipt', id: string, status: InvoiceReceiptStatus, amount: number, received_on: string, payment_order_number: string, payment_id: string, confirmed_at: string, confirmed_by_title?: string | null, void_reason?: string | null, voided_at?: string | null, voided_by_title?: string | null, returned_on?: string | null, return_payment_order_number?: string | null, returned_at?: string | null, returned_by_title?: string | null }>, history: Array<{ __typename?: 'InvoiceHistoryEntry', kind: InvoiceHistoryKind, at: string, actor_title?: string | null, amount?: number | null, reference?: string | null, reason?: string | null }> } };

export type RecordOrderFiscalCommandLogsMutationVariables = Exact<{
  input: RecordOrderFiscalCommandLogsInput;
}>;


export type RecordOrderFiscalCommandLogsMutation = { __typename?: 'Mutation', recordOrderFiscalCommandLogs: boolean };

export type CreateMarketingSourceMutationVariables = Exact<{
  input: CreateMarketingSourceInput;
}>;


export type CreateMarketingSourceMutation = { __typename?: 'Mutation', createMarketingSource: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean, is_system: boolean, created_at?: string | null } };

export type UpdateMarketingSourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateMarketingSourceInput;
}>;


export type UpdateMarketingSourceMutation = { __typename?: 'Mutation', updateMarketingSource: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean, is_system: boolean, created_at?: string | null } };

export type DeleteMarketingSourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMarketingSourceMutation = { __typename?: 'Mutation', deleteMarketingSource: boolean };

export type OpenCashShiftMutationVariables = Exact<{
  input: OpenShiftInput;
}>;


export type OpenCashShiftMutation = { __typename?: 'Mutation', openShift: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } };

export type ConfirmCashShiftKktMutationVariables = Exact<{
  input: ConfirmShiftKktInput;
}>;


export type ConfirmCashShiftKktMutation = { __typename?: 'Mutation', confirmShiftKkt: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } };

export type AbortCashShiftOpeningMutationVariables = Exact<{
  shiftId: Scalars['ID']['input'];
}>;


export type AbortCashShiftOpeningMutation = { __typename?: 'Mutation', abortShiftOpening: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } };

export type CashShiftClosingContextQueryVariables = Exact<{
  shiftId: Scalars['ID']['input'];
}>;


export type CashShiftClosingContextQuery = { __typename?: 'Query', shiftClosingContext: { __typename?: 'ShiftClosingContext', revenue_mors_cash: number, revenue_mors_card: number, revenue_mors_other: number, revenue_mors_total: number, shift: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> }, pending_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }> } };

export type StartCashShiftClosingMutationVariables = Exact<{
  shiftId: Scalars['ID']['input'];
}>;


export type StartCashShiftClosingMutation = { __typename?: 'Mutation', startShiftClosing: { __typename?: 'ShiftClosingContext', revenue_mors_cash: number, revenue_mors_card: number, revenue_mors_other: number, revenue_mors_total: number, shift: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> }, pending_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }> } };

export type CloseCashShiftMutationVariables = Exact<{
  input: CloseShiftInput;
}>;


export type CloseCashShiftMutation = { __typename?: 'Mutation', closeShift: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } };

export type CancelCashShiftClosingMutationVariables = Exact<{
  shiftId: Scalars['ID']['input'];
}>;


export type CancelCashShiftClosingMutation = { __typename?: 'Mutation', cancelShiftClosing: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } };

export type RegisterCashShiftKktReopenMutationVariables = Exact<{
  input: RegisterShiftKktReopenInput;
}>;


export type RegisterCashShiftKktReopenMutation = { __typename?: 'Mutation', registerShiftKktReopen: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } };

export type ForceCloseCashShiftMutationVariables = Exact<{
  input: ForceCloseShiftInput;
}>;


export type ForceCloseCashShiftMutation = { __typename?: 'Mutation', forceCloseShift: { __typename?: 'Shift', id: string, organization_id: string, location_id: string, status: ShiftStatus, opened_at: string, closed_at?: string | null, opening_cash: number, closing_cash?: number | null, closing_cash_expected?: number | null, closing_cash_diff?: number | null, closing_revenue_mors?: number | null, closing_revenue_kkt?: number | null, closing_revenue_diff?: number | null, kkt_sync: ShiftKktSyncState, kkt_fn_serial_masked?: string | null, close_comment?: string | null, expires_at: string, cashier_vatin?: string | null, opened_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, closed_by?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, kkt_sessions: Array<{ __typename?: 'ShiftKktSession', id: string, shift_id: string, fn_serial_masked: string, kkt_shift_number?: number | null, opened_at: string, closed_at?: string | null, close_reason?: ShiftKktSessionCloseReason | null }> } };

export type GetOrderFiscalOperationQueryVariables = Exact<{
  operationId: Scalars['ID']['input'];
}>;


export type GetOrderFiscalOperationQuery = { __typename?: 'Query', orderFiscalOperation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } } };

export type ForceCloseOrderFiscalOperationMutationVariables = Exact<{
  input: ForceCloseOrderFiscalOperationInput;
}>;


export type ForceCloseOrderFiscalOperationMutation = { __typename?: 'Mutation', forceCloseOrderFiscalOperation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } } };

export type StartOrderFiscalPaymentReturnMutationVariables = Exact<{
  operationId: Scalars['ID']['input'];
}>;


export type StartOrderFiscalPaymentReturnMutation = { __typename?: 'Mutation', startOrderFiscalPaymentReturn: { __typename?: 'OrderFiscalPaymentReturnExecution', command: OrderFiscalPaymentReturnCommand, id_command: string, amount: number, kkt_device_id: string, terminal_device_id: string, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } } } };

export type CompleteOrderFiscalPaymentReturnMutationVariables = Exact<{
  input: CompleteOrderFiscalPaymentReturnInput;
}>;


export type CompleteOrderFiscalPaymentReturnMutation = { __typename?: 'Mutation', completeOrderFiscalPaymentReturn: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } } };

export type GetOrderFiscalRefundOperationQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderFiscalRefundOperationQuery = { __typename?: 'Query', orderFiscalRefundOperation?: { __typename?: 'OrderFiscalRefundExecution', id_command: string, payload_hash: string, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalRefundReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalRefundPayment', payment_id: string, method: OrderPaymentMethod, amount: number, use_acquiring: boolean, execution_order: number, original_rrn?: string | null, original_terminal_transaction_id?: string | null }> } } | null };

export type PrepareOrderFiscalRefundMutationVariables = Exact<{
  input: PrepareOrderFiscalRefundInput;
}>;


export type PrepareOrderFiscalRefundMutation = { __typename?: 'Mutation', prepareOrderFiscalRefund: { __typename?: 'OrderFiscalRefundExecution', id_command: string, payload_hash: string, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalRefundReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalRefundPayment', payment_id: string, method: OrderPaymentMethod, amount: number, use_acquiring: boolean, execution_order: number, original_rrn?: string | null, original_terminal_transaction_id?: string | null }> } } };

export type StartOrderFiscalRefundMutationVariables = Exact<{
  input: OrderFiscalOperationIdentityInput;
}>;


export type StartOrderFiscalRefundMutation = { __typename?: 'Mutation', startOrderFiscalRefund: { __typename?: 'OrderFiscalRefundExecution', id_command: string, payload_hash: string, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalRefundReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalRefundPayment', payment_id: string, method: OrderPaymentMethod, amount: number, use_acquiring: boolean, execution_order: number, original_rrn?: string | null, original_terminal_transaction_id?: string | null }> } } };

export type CompleteOrderFiscalRefundMutationVariables = Exact<{
  input: CompleteOrderFiscalRefundInput;
}>;


export type CompleteOrderFiscalRefundMutation = { __typename?: 'Mutation', completeOrderFiscalRefund: { __typename?: 'OrderFiscalRefundMutationResult', order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> }, execution: { __typename?: 'OrderFiscalRefundExecution', id_command: string, payload_hash: string, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalRefundReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalRefundPayment', payment_id: string, method: OrderPaymentMethod, amount: number, use_acquiring: boolean, execution_order: number, original_rrn?: string | null, original_terminal_transaction_id?: string | null }> } } } };

export type RetryOrderFiscalRefundReceiptMutationVariables = Exact<{
  input: RetryOrderFiscalReceiptInput;
}>;


export type RetryOrderFiscalRefundReceiptMutation = { __typename?: 'Mutation', retryOrderFiscalReceipt: { __typename?: 'OrderFiscalSettlementExecution', next_action: OrderFiscalRecoveryAction, operation: { __typename?: 'OrderFiscalOperation', id: string, status: OrderFiscalOperationStatus } } };

export type ResolveOrderFiscalRefundReceiptMutationVariables = Exact<{
  input: ResolveOrderFiscalReceiptInput;
}>;


export type ResolveOrderFiscalRefundReceiptMutation = { __typename?: 'Mutation', resolveOrderFiscalReceipt: { __typename?: 'OrderFiscalSettlementMutationResult', execution: { __typename?: 'OrderFiscalSettlementExecution', next_action: OrderFiscalRecoveryAction, operation: { __typename?: 'OrderFiscalOperation', id: string, status: OrderFiscalOperationStatus } } } };

export type AnswerOrderFiscalRefundReceiptPrintedMutationVariables = Exact<{
  input: AnswerOrderFiscalReceiptPrintedInput;
}>;


export type AnswerOrderFiscalRefundReceiptPrintedMutation = { __typename?: 'Mutation', answerOrderFiscalReceiptPrinted: { __typename?: 'OrderFiscalSettlementMutationResult', execution: { __typename?: 'OrderFiscalSettlementExecution', next_action: OrderFiscalRecoveryAction, operation: { __typename?: 'OrderFiscalOperation', id: string, status: OrderFiscalOperationStatus } } } };

export type FailOrderFiscalRefundMutationVariables = Exact<{
  input: FailOrderFiscalRefundInput;
}>;


export type FailOrderFiscalRefundMutation = { __typename?: 'Mutation', failOrderFiscalRefund: { __typename?: 'OrderFiscalRefundMutationResult', order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> }, execution: { __typename?: 'OrderFiscalRefundExecution', id_command: string, payload_hash: string, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalRefundReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalRefundPayment', payment_id: string, method: OrderPaymentMethod, amount: number, use_acquiring: boolean, execution_order: number, original_rrn?: string | null, original_terminal_transaction_id?: string | null }> } } } };

export type OrderFiscalOperationFieldsFragment = { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } };

export type OrderFiscalReceiptItemFieldsFragment = { __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null };

export type OrderFiscalExecutionFieldsFragment = { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } };

export type OrderFiscalRefundExecutionFieldsFragment = { __typename?: 'OrderFiscalRefundExecution', id_command: string, payload_hash: string, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalRefundReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalRefundPayment', payment_id: string, method: OrderPaymentMethod, amount: number, use_acquiring: boolean, execution_order: number, original_rrn?: string | null, original_terminal_transaction_id?: string | null }> } };

export type GetOrderFiscalSettlementOperationQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderFiscalSettlementOperationQuery = { __typename?: 'Query', orderFiscalSettlementOperation?: { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } } | null };

export type PrepareOrderFiscalSettlementMutationVariables = Exact<{
  input: PrepareOrderFiscalSettlementInput;
}>;


export type PrepareOrderFiscalSettlementMutation = { __typename?: 'Mutation', prepareOrderFiscalSettlement: { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } } };

export type StartOrderFiscalSettlementMutationVariables = Exact<{
  input: OrderFiscalOperationIdentityInput;
}>;


export type StartOrderFiscalSettlementMutation = { __typename?: 'Mutation', startOrderFiscalSettlement: { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } } };

export type CompleteOrderFiscalSettlementMutationVariables = Exact<{
  input: CompleteOrderFiscalSettlementInput;
}>;


export type CompleteOrderFiscalSettlementMutation = { __typename?: 'Mutation', completeOrderFiscalSettlement: { __typename?: 'OrderFiscalSettlementMutationResult', order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> }, execution: { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } } } };

export type FailOrderFiscalSettlementMutationVariables = Exact<{
  input: FailOrderFiscalSettlementInput;
}>;


export type FailOrderFiscalSettlementMutation = { __typename?: 'Mutation', failOrderFiscalSettlement: { __typename?: 'OrderFiscalSettlementMutationResult', order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> }, execution: { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } } } };

export type RetryOrderFiscalReceiptMutationVariables = Exact<{
  input: RetryOrderFiscalReceiptInput;
}>;


export type RetryOrderFiscalReceiptMutation = { __typename?: 'Mutation', retryOrderFiscalReceipt: { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } } };

export type ResolveOrderFiscalReceiptMutationVariables = Exact<{
  input: ResolveOrderFiscalReceiptInput;
}>;


export type ResolveOrderFiscalReceiptMutation = { __typename?: 'Mutation', resolveOrderFiscalReceipt: { __typename?: 'OrderFiscalSettlementMutationResult', order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> }, execution: { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } } } };

export type AnswerOrderFiscalReceiptPrintedMutationVariables = Exact<{
  input: AnswerOrderFiscalReceiptPrintedInput;
}>;


export type AnswerOrderFiscalReceiptPrintedMutation = { __typename?: 'Mutation', answerOrderFiscalReceiptPrinted: { __typename?: 'OrderFiscalSettlementMutationResult', order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> }, execution: { __typename?: 'OrderFiscalSettlementExecution', id_command: string, payload_hash: string, terminal_transaction_id?: string | null, next_action: OrderFiscalRecoveryAction, receipt_kind: OrderFiscalReceiptKind, settled_at: string, fiscal_scan_from?: number | null, same_fiscal_drive?: boolean | null, operation: { __typename?: 'OrderFiscalOperation', timezone: string, id: string, organization_id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, acquiring_mode: OrderFiscalAcquiringMode, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, receipt_kind?: OrderFiscalReceiptKind | null, receipt_confirmed_at?: string | null, return_command_id?: string | null, cash_amount: number, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, workstation_id: string, name: string } }, execution_target: { __typename?: 'OrderFiscalExecutionTarget', timezone: string, provider: OrderFiscalizationProvider, browser_workstation_id: string, kkt_device_id: string, terminal_device_id?: string | null, settings_version: number, kkt_identity_hash?: string | null, terminal_identity_hash?: string | null }, receipt_plan: { __typename?: 'OrderFiscalReceiptPlan', schema_version: number, advance_amount: number, operation_type: OrderFiscalOperationType, cashier_name: string, currency: OrderCurrency, taxation_system: OrderFiscalTaxationSystem, total_amount: number, loyalty_points: number, contact: { __typename?: 'OrderFiscalReceiptContact', email?: string | null, phone?: string | null }, items: Array<{ __typename?: 'OrderFiscalReceiptItem', order_line_id: string, position: number, title: string, quantity: number, unit_price: number, amount: number, vat_rate: OrderFiscalVatRate, payment_method: OrderFiscalPaymentMethod, payment_subject: OrderFiscalPaymentSubject, marking_code?: string | null }>, payments: Array<{ __typename?: 'OrderFiscalReceiptPayment', method: OrderPaymentMethod, amount: number, tendered_amount?: number | null, change_amount: number, use_acquiring: boolean, execution_order: number }> } } } };

export type CancelOrderFiscalPaymentMutationVariables = Exact<{
  input: CancelOrderFiscalPaymentInput;
}>;


export type CancelOrderFiscalPaymentMutation = { __typename?: 'Mutation', cancelOrderFiscalPayment: { __typename?: 'OrderFiscalOperation', id: string, status: OrderFiscalOperationStatus, failure_kind?: OrderFiscalFailureKind | null, bank_payment_status?: OrderFiscalBankPaymentStatus | null, failed_at?: string | null, cash_amount: number } };

export type SendPaymentLinkMutationVariables = Exact<{
  input: SendPaymentLinkInput;
}>;


export type SendPaymentLinkMutation = { __typename?: 'Mutation', sendPaymentLink: { __typename?: 'PaymentLinkSendTarget', conversation_id: string, provider: MessengerProvider } };

export type RefundAdvanceMutationVariables = Exact<{
  input: RefundAdvanceInput;
}>;


export type RefundAdvanceMutation = { __typename?: 'Mutation', refundAdvance: { __typename?: 'RefundAdvancePayload', refund: { __typename?: 'PaymentRefund', id: string, status: PaymentRefundStatus } } };

export type RefundOrderMutationVariables = Exact<{
  input: RefundOrderInput;
}>;


export type RefundOrderMutation = { __typename?: 'Mutation', refundOrder: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } };

export type RequestOrderRefundApprovalMutationVariables = Exact<{
  input: RequestOrderRefundApprovalInput;
}>;


export type RequestOrderRefundApprovalMutation = { __typename?: 'Mutation', requestOrderRefundApproval: { __typename?: 'OrderRefundApproval', id: string, order_id: string, location_id: string, status: OrderRefundApprovalStatus, kind: OrderRefundApprovalKind, transfer_amount?: number | null, requested_at: string, request_comment?: string | null, resolved_at?: string | null, resolve_comment?: string | null, expires_at?: string | null, location: { __typename?: 'Location', id: string, title: string }, requested_by_employee: { __typename?: 'OrderActor', id: string, title?: string | null }, resolved_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, order: { __typename?: 'Order', id: string, status: OrderStatus, total_amount: number, refunded_amount: number, created_at: string, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null } } };

export type ResolveOrderRefundApprovalMutationVariables = Exact<{
  input: ResolveOrderRefundApprovalInput;
}>;


export type ResolveOrderRefundApprovalMutation = { __typename?: 'Mutation', resolveOrderRefundApproval: { __typename?: 'OrderRefundApproval', id: string, order_id: string, location_id: string, status: OrderRefundApprovalStatus, kind: OrderRefundApprovalKind, transfer_amount?: number | null, requested_at: string, request_comment?: string | null, resolved_at?: string | null, resolve_comment?: string | null, expires_at?: string | null, location: { __typename?: 'Location', id: string, title: string }, requested_by_employee: { __typename?: 'OrderActor', id: string, title?: string | null }, resolved_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, order: { __typename?: 'Order', id: string, status: OrderStatus, total_amount: number, refunded_amount: number, created_at: string, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null } } };

export type RecordOrderOutsideTerminalRefundMutationVariables = Exact<{
  input: RecordOrderOutsideTerminalRefundInput;
}>;


export type RecordOrderOutsideTerminalRefundMutation = { __typename?: 'Mutation', recordOrderOutsideTerminalRefund: { __typename?: 'OrderFiscalRefundMutationResult', order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } } };

export type CompleteOrderRefundTransferMutationVariables = Exact<{
  input: CompleteOrderRefundTransferInput;
}>;


export type CompleteOrderRefundTransferMutation = { __typename?: 'Mutation', completeOrderRefundTransfer: { __typename?: 'OrderFiscalRefundMutationResult', order: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } } };

export type CreatePlatformOrganizationMutationVariables = Exact<{
  input: PlatformCreateOrganizationInput;
}>;


export type CreatePlatformOrganizationMutation = { __typename?: 'Mutation', platformCreateOrganization: { __typename?: 'Organization', id: string, title: string, domain?: string | null, enabled_modules: Array<OrganizationModule> } };

export type CreatePlatformEmployeeMutationVariables = Exact<{
  input: PlatformCreateEmployeeInput;
}>;


export type CreatePlatformEmployeeMutation = { __typename?: 'Mutation', platformCreateEmployee: { __typename?: 'Employee', id: string, has_all_locations_access: boolean, user: { __typename?: 'User', id: string, phone?: string | null, first_name?: string | null, last_name?: string | null } } };

export type GetPlatformOrganizationRolesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetPlatformOrganizationRolesQuery = { __typename?: 'Query', platformOrganizationRoles: Array<{ __typename?: 'Role', id: string, name: string, title: string }> };

export type CreateProductMutationVariables = Exact<{
  input: ProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, purchase_price: number, sale_price: number, category_id?: string | null, description?: string | null, total_stock_quantity: number, archived_at?: string | null, created_at: string, updated_at: string, stocks: Array<{ __typename?: 'ProductStock', id: string, quantity: number, location: { __typename?: 'Location', id: string, title: string } }> } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, title: string, gtins: Array<string>, is_marked: boolean, is_excisable: boolean, photo_url?: string | null, purchase_price: number, sale_price: number, category_id?: string | null, description?: string | null, total_stock_quantity: number, archived_at?: string | null, created_at: string, updated_at: string, stocks: Array<{ __typename?: 'ProductStock', id: string, quantity: number, location: { __typename?: 'Location', id: string, title: string } }> } };

export type ReceiveProductMutationVariables = Exact<{
  input: ProductMovementInput;
}>;


export type ReceiveProductMutation = { __typename?: 'Mutation', receiveProduct: { __typename?: 'ProductMovement', id: string, reason: ProductMovementReason, delta: number, comment?: string | null, unit_purchase_price: number, marking_codes: Array<string>, order_id?: string | null, created_at: string, location: { __typename?: 'Location', id: string, title: string }, employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, reversal?: { __typename?: 'ProductMovement', id: string } | null, transfer_source?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null, transfer_target?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null } };

export type WriteOffProductMutationVariables = Exact<{
  input: ProductMovementInput;
}>;


export type WriteOffProductMutation = { __typename?: 'Mutation', writeOffProduct: { __typename?: 'ProductMovement', id: string, reason: ProductMovementReason, delta: number, comment?: string | null, unit_purchase_price: number, marking_codes: Array<string>, order_id?: string | null, created_at: string, location: { __typename?: 'Location', id: string, title: string }, employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, reversal?: { __typename?: 'ProductMovement', id: string } | null, transfer_source?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null, transfer_target?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null } };

export type TransferProductMutationVariables = Exact<{
  input: ProductTransferInput;
}>;


export type TransferProductMutation = { __typename?: 'Mutation', transferProduct: { __typename?: 'ProductMovement', id: string, reason: ProductMovementReason, delta: number, comment?: string | null, unit_purchase_price: number, marking_codes: Array<string>, order_id?: string | null, created_at: string, location: { __typename?: 'Location', id: string, title: string }, employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, reversal?: { __typename?: 'ProductMovement', id: string } | null, transfer_source?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null, transfer_target?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null } };

export type ReverseProductReceiptMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReverseProductReceiptMutation = { __typename?: 'Mutation', reverseProductReceipt: { __typename?: 'ProductMovement', id: string, reason: ProductMovementReason, delta: number, comment?: string | null, unit_purchase_price: number, marking_codes: Array<string>, order_id?: string | null, created_at: string, location: { __typename?: 'Location', id: string, title: string }, employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, reversal?: { __typename?: 'ProductMovement', id: string } | null, transfer_source?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null, transfer_target?: { __typename?: 'ProductMovement', id: string, location: { __typename?: 'Location', id: string, title: string } } | null } };

export type UploadProductPhotoMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadProductPhotoMutation = { __typename?: 'Mutation', uploadProductPhoto: { __typename?: 'ProductPhotoUploadPayload', url: string } };

export type PushNotificationCapabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type PushNotificationCapabilityQuery = { __typename?: 'Query', webPushContext: { __typename?: 'WebPushContext', capability: { __typename?: 'WebPushCapability', enabled: boolean, public_key?: string | null } } };

export type PushNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type PushNotificationPreferencesQuery = { __typename?: 'Query', webPushContext: { __typename?: 'WebPushContext', preferences: Array<{ __typename?: 'WebPushNotificationPreference', kind: WebPushNotificationKind, enabled: boolean, available?: boolean | null }> } };

export type UpsertCurrentPushSubscriptionMutationVariables = Exact<{
  input: UpsertWebPushSubscriptionInput;
}>;


export type UpsertCurrentPushSubscriptionMutation = { __typename?: 'Mutation', upsertWebPushSubscription: { __typename?: 'User', id: string } };

export type DeleteCurrentPushSubscriptionMutationVariables = Exact<{
  input: WebPushEndpointInput;
}>;


export type DeleteCurrentPushSubscriptionMutation = { __typename?: 'Mutation', deleteWebPushSubscription: { __typename?: 'User', id: string } };

export type TestCurrentPushSubscriptionMutationVariables = Exact<{
  input: WebPushEndpointInput;
}>;


export type TestCurrentPushSubscriptionMutation = { __typename?: 'Mutation', testWebPushSubscription: { __typename?: 'User', id: string } };

export type UpdatePushNotificationPreferenceMutationVariables = Exact<{
  input: UpdateWebPushNotificationPreferenceInput;
}>;


export type UpdatePushNotificationPreferenceMutation = { __typename?: 'Mutation', updateWebPushNotificationPreference: { __typename?: 'User', web_push_notification_preferences: Array<{ __typename?: 'WebPushNotificationPreference', kind: WebPushNotificationKind, enabled: boolean, available?: boolean | null }> } };

export type CreateQrLinkMutationVariables = Exact<{
  input: CreateQrLinkInput;
}>;


export type CreateQrLinkMutation = { __typename?: 'Mutation', createQrLink: { __typename?: 'QrLink', id: string, name: string, code: string, target_url: string, total_clicks: number, public_url: string, style_config: string, deleted_at?: string | null, created_at: string, updated_at: string } };

export type UpdateQrLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateQrLinkInput;
}>;


export type UpdateQrLinkMutation = { __typename?: 'Mutation', updateQrLink: { __typename?: 'QrLink', id: string, name: string, code: string, target_url: string, total_clicks: number, public_url: string, style_config: string, deleted_at?: string | null, created_at: string, updated_at: string } };

export type DeleteQrLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteQrLinkMutation = { __typename?: 'Mutation', deleteQrLink: boolean };

export type RestoreQrLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreQrLinkMutation = { __typename?: 'Mutation', restoreQrLink: { __typename?: 'QrLink', id: string, name: string, code: string, target_url: string, total_clicks: number, public_url: string, style_config: string, deleted_at?: string | null, created_at: string, updated_at: string } };

export type CreateScenarioMutationVariables = Exact<{
  input: CreateScenarioInput;
}>;


export type CreateScenarioMutation = { __typename?: 'Mutation', createScenario: { __typename?: 'Scenario', id: string, name: string, code?: string | null, is_active: boolean, active_from?: string | null, active_to?: string | null, stop_if_booked: boolean, restart_on_reactivation: boolean, registration_bonus_points?: number | null, available_providers: Array<string>, runs_count: number, structural_edit_locked: boolean, created_at: string, updated_at: string, statistics: { __typename?: 'ScenarioStatistics', overview: { __typename?: 'ScenarioStatsOverview', contacts_collected: number, new_clients: number, new_clients_revenue: number, reactivated_clients: number, reactivated_revenue: number }, funnel: { __typename?: 'ScenarioStatsFunnel', contacts_collected: number, identified: number, reached_club: number } }, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean } | null, default_city?: { __typename?: 'City', id: string, name: string } | null, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null, on_timeout?: string | null, buttons?: Array<{ __typename?: 'ScenarioStepButton', text: string, url: string }> | null }> } };

export type UpdateScenarioMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateScenarioInput;
}>;


export type UpdateScenarioMutation = { __typename?: 'Mutation', updateScenario: { __typename?: 'Scenario', id: string, name: string, code?: string | null, is_active: boolean, active_from?: string | null, active_to?: string | null, stop_if_booked: boolean, restart_on_reactivation: boolean, registration_bonus_points?: number | null, available_providers: Array<string>, runs_count: number, structural_edit_locked: boolean, created_at: string, updated_at: string, statistics: { __typename?: 'ScenarioStatistics', overview: { __typename?: 'ScenarioStatsOverview', contacts_collected: number, new_clients: number, new_clients_revenue: number, reactivated_clients: number, reactivated_revenue: number }, funnel: { __typename?: 'ScenarioStatsFunnel', contacts_collected: number, identified: number, reached_club: number } }, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean } | null, default_city?: { __typename?: 'City', id: string, name: string } | null, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null, on_timeout?: string | null, buttons?: Array<{ __typename?: 'ScenarioStepButton', text: string, url: string }> | null }> } };

export type DeleteScenarioMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScenarioMutation = { __typename?: 'Mutation', deleteScenario: boolean };

export type ActivateScenarioMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateScenarioMutation = { __typename?: 'Mutation', activateScenario: { __typename?: 'Scenario', id: string, name: string, code?: string | null, is_active: boolean, active_from?: string | null, active_to?: string | null, stop_if_booked: boolean, restart_on_reactivation: boolean, registration_bonus_points?: number | null, available_providers: Array<string>, runs_count: number, structural_edit_locked: boolean, created_at: string, updated_at: string, statistics: { __typename?: 'ScenarioStatistics', overview: { __typename?: 'ScenarioStatsOverview', contacts_collected: number, new_clients: number, new_clients_revenue: number, reactivated_clients: number, reactivated_revenue: number }, funnel: { __typename?: 'ScenarioStatsFunnel', contacts_collected: number, identified: number, reached_club: number } }, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean } | null, default_city?: { __typename?: 'City', id: string, name: string } | null, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null, on_timeout?: string | null, buttons?: Array<{ __typename?: 'ScenarioStepButton', text: string, url: string }> | null }> } };

export type DeactivateScenarioMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateScenarioMutation = { __typename?: 'Mutation', deactivateScenario: { __typename?: 'Scenario', id: string, name: string, code?: string | null, is_active: boolean, active_from?: string | null, active_to?: string | null, stop_if_booked: boolean, restart_on_reactivation: boolean, registration_bonus_points?: number | null, available_providers: Array<string>, runs_count: number, structural_edit_locked: boolean, created_at: string, updated_at: string, statistics: { __typename?: 'ScenarioStatistics', overview: { __typename?: 'ScenarioStatsOverview', contacts_collected: number, new_clients: number, new_clients_revenue: number, reactivated_clients: number, reactivated_revenue: number }, funnel: { __typename?: 'ScenarioStatsFunnel', contacts_collected: number, identified: number, reached_club: number } }, marketing_source?: { __typename?: 'MarketingSource', id: string, title: string, is_manual_selectable: boolean } | null, default_city?: { __typename?: 'City', id: string, name: string } | null, flow_definition: Array<{ __typename?: 'ScenarioStep', type: string, body?: string | null, delay_value?: number | null, delay_unit?: string | null, button_text?: string | null, timeout_value?: number | null, timeout_unit?: string | null, on_timeout?: string | null, buttons?: Array<{ __typename?: 'ScenarioStepButton', text: string, url: string }> | null }> } };

export type CreateTireCarMutationVariables = Exact<{
  input: TireCarInput;
}>;


export type CreateTireCarMutation = { __typename?: 'Mutation', createTireCar: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } };

export type UpdateTireCarMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TireCarInput;
}>;


export type UpdateTireCarMutation = { __typename?: 'Mutation', updateTireCar: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } };

export type DeleteTireCarMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTireCarMutation = { __typename?: 'Mutation', deleteTireCar: boolean };

export type OrganizationAddOnFieldsFragment = { __typename?: 'OrganizationAddOn', module: OrganizationModule, status: OrganizationAddOnStatus };

export type ConnectOrganizationAddOnMutationVariables = Exact<{
  module: OrganizationModule;
}>;


export type ConnectOrganizationAddOnMutation = { __typename?: 'Mutation', connectOrganizationAddOn: { __typename?: 'OrganizationAddOn', module: OrganizationModule, status: OrganizationAddOnStatus } };

export type DisconnectOrganizationAddOnMutationVariables = Exact<{
  module: OrganizationModule;
}>;


export type DisconnectOrganizationAddOnMutation = { __typename?: 'Mutation', disconnectOrganizationAddOn: { __typename?: 'OrganizationAddOn', module: OrganizationModule, status: OrganizationAddOnStatus } };

export type AddTireServiceTemplateMutationVariables = Exact<{
  groups: Array<TireServiceTemplateGroup> | TireServiceTemplateGroup;
}>;


export type AddTireServiceTemplateMutation = { __typename?: 'Mutation', addTireServiceTemplate: number };

export type RobokassaConnectionFieldsFragment = { __typename?: 'RobokassaConnection', id: string, mode: PaymentConnectionMode, status: PaymentConnectionStatus, merchant_login: string, password1_mask?: string | null, password2_mask?: string | null, password3_mask?: string | null, test_password1_mask?: string | null, test_password2_mask?: string | null, hash_algorithm?: PaymentHashAlgorithm | null, tax_system?: PaymentTaxSystem | null, fiscal_scheme?: PaymentFiscalScheme | null, single_receipt_confirmed_at?: string | null, vat_payer: boolean, result_url: string, version: number, readiness: { __typename?: 'RobokassaReadiness', payments: boolean, refunds: boolean, income_receipts: boolean, reasons: Array<PaymentReadinessReason>, final_receipt_locations: Array<{ __typename?: 'PaymentReceiptLocation', id: string, title: string }> } };

export type GetRobokassaConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRobokassaConnectionQuery = { __typename?: 'Query', robokassaConnection?: { __typename?: 'RobokassaConnection', id: string, mode: PaymentConnectionMode, status: PaymentConnectionStatus, merchant_login: string, password1_mask?: string | null, password2_mask?: string | null, password3_mask?: string | null, test_password1_mask?: string | null, test_password2_mask?: string | null, hash_algorithm?: PaymentHashAlgorithm | null, tax_system?: PaymentTaxSystem | null, fiscal_scheme?: PaymentFiscalScheme | null, single_receipt_confirmed_at?: string | null, vat_payer: boolean, result_url: string, version: number, readiness: { __typename?: 'RobokassaReadiness', payments: boolean, refunds: boolean, income_receipts: boolean, reasons: Array<PaymentReadinessReason>, final_receipt_locations: Array<{ __typename?: 'PaymentReceiptLocation', id: string, title: string }> } } | null };

export type ConnectRobokassaMutationVariables = Exact<{
  input: RobokassaConnectionInput;
}>;


export type ConnectRobokassaMutation = { __typename?: 'Mutation', connectRobokassa: { __typename?: 'RobokassaConnection', id: string, mode: PaymentConnectionMode, status: PaymentConnectionStatus, merchant_login: string, password1_mask?: string | null, password2_mask?: string | null, password3_mask?: string | null, test_password1_mask?: string | null, test_password2_mask?: string | null, hash_algorithm?: PaymentHashAlgorithm | null, tax_system?: PaymentTaxSystem | null, fiscal_scheme?: PaymentFiscalScheme | null, single_receipt_confirmed_at?: string | null, vat_payer: boolean, result_url: string, version: number, readiness: { __typename?: 'RobokassaReadiness', payments: boolean, refunds: boolean, income_receipts: boolean, reasons: Array<PaymentReadinessReason>, final_receipt_locations: Array<{ __typename?: 'PaymentReceiptLocation', id: string, title: string }> } } };

export type UpdateRobokassaConnectionMutationVariables = Exact<{
  input: RobokassaConnectionInput;
}>;


export type UpdateRobokassaConnectionMutation = { __typename?: 'Mutation', updateRobokassaConnection: { __typename?: 'RobokassaConnection', id: string, mode: PaymentConnectionMode, status: PaymentConnectionStatus, merchant_login: string, password1_mask?: string | null, password2_mask?: string | null, password3_mask?: string | null, test_password1_mask?: string | null, test_password2_mask?: string | null, hash_algorithm?: PaymentHashAlgorithm | null, tax_system?: PaymentTaxSystem | null, fiscal_scheme?: PaymentFiscalScheme | null, single_receipt_confirmed_at?: string | null, vat_payer: boolean, result_url: string, version: number, readiness: { __typename?: 'RobokassaReadiness', payments: boolean, refunds: boolean, income_receipts: boolean, reasons: Array<PaymentReadinessReason>, final_receipt_locations: Array<{ __typename?: 'PaymentReceiptLocation', id: string, title: string }> } } };

export type DisableRobokassaConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableRobokassaConnectionMutation = { __typename?: 'Mutation', disableRobokassaConnection: { __typename?: 'RobokassaConnection', id: string, mode: PaymentConnectionMode, status: PaymentConnectionStatus, merchant_login: string, password1_mask?: string | null, password2_mask?: string | null, password3_mask?: string | null, test_password1_mask?: string | null, test_password2_mask?: string | null, hash_algorithm?: PaymentHashAlgorithm | null, tax_system?: PaymentTaxSystem | null, fiscal_scheme?: PaymentFiscalScheme | null, single_receipt_confirmed_at?: string | null, vat_payer: boolean, result_url: string, version: number, readiness: { __typename?: 'RobokassaReadiness', payments: boolean, refunds: boolean, income_receipts: boolean, reasons: Array<PaymentReadinessReason>, final_receipt_locations: Array<{ __typename?: 'PaymentReceiptLocation', id: string, title: string }> } } };

export type UpdateMyProfileMutationVariables = Exact<{
  input: UpdateMyProfileInput;
}>;


export type UpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProfile: { __typename?: 'User', id: string, phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, telegram_id?: string | null, is_super_user?: boolean | null } };

export type CreateBookingMutationVariables = Exact<{
  input: CreateBookingInput;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking: boolean };

export type UpdateBookingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateBookingInput;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking: boolean };

export type ReplaceBookingClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ReplaceBookingClientInput;
}>;


export type ReplaceBookingClientMutation = { __typename?: 'Mutation', replaceBookingClient: boolean };

export type UpdateBookingStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateBookingStatusInput;
}>;


export type UpdateBookingStatusMutation = { __typename?: 'Mutation', updateBookingStatus: boolean };

export type CreateOrderFromBookingGroupMutationVariables = Exact<{
  bookingGroupId: Scalars['ID']['input'];
}>;


export type CreateOrderFromBookingGroupMutation = { __typename?: 'Mutation', createOrderFromBookingGroup: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } };

export type RefreshOrderDraftMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type RefreshOrderDraftMutation = { __typename?: 'Mutation', refreshOrderDraft: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } };

export type SettleOrderMutationVariables = Exact<{
  input: SettleOrderInput;
}>;


export type SettleOrderMutation = { __typename?: 'Mutation', settleOrder: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } };

export type UnitUnavailabilityPayloadFieldsFragment = { __typename?: 'UnitUnavailabilityMutationPayload', unit_unavailability?: { __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> };

export type CreateUnitUnavailabilityMutationVariables = Exact<{
  input: CreateUnitUnavailabilityInput;
}>;


export type CreateUnitUnavailabilityMutation = { __typename?: 'Mutation', createUnitUnavailability: { __typename?: 'UnitUnavailabilityMutationPayload', unit_unavailability?: { __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type UpdateUnitUnavailabilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUnitUnavailabilityInput;
}>;


export type UpdateUnitUnavailabilityMutation = { __typename?: 'Mutation', updateUnitUnavailability: { __typename?: 'UnitUnavailabilityMutationPayload', unit_unavailability?: { __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type FinishUnitUnavailabilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinishUnitUnavailabilityMutation = { __typename?: 'Mutation', finishUnitUnavailability: { __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string } };

export type DeleteUnitUnavailabilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUnitUnavailabilityMutation = { __typename?: 'Mutation', deleteUnitUnavailability: boolean };

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', id: string, status: EmployeeStatus, has_all_locations_access: boolean, created_at: string, last_activity_at?: string | null, is_owner: boolean, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, locations: Array<{ __typename?: 'Location', id: string, title: string }>, roles: Array<{ __typename?: 'Role', id: string, title: string }> } };

export type UpdateEmployeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', id: string, status: EmployeeStatus, has_all_locations_access: boolean, created_at: string, last_activity_at?: string | null, is_owner: boolean, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, locations: Array<{ __typename?: 'Location', id: string, title: string }>, roles: Array<{ __typename?: 'Role', id: string, title: string }> } };

export type FireEmployeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: FireEmployeeInput;
}>;


export type FireEmployeeMutation = { __typename?: 'Mutation', fireEmployee: { __typename?: 'Employee', id: string, status: EmployeeStatus, fired_at?: string | null, firing_reason?: string | null } };

export type UnfireEmployeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnfireEmployeeMutation = { __typename?: 'Mutation', unfireEmployee: { __typename?: 'Employee', id: string, status: EmployeeStatus, fired_at?: string | null, firing_reason?: string | null } };

export type GetEmployeesQueryVariables = Exact<{
  status?: InputMaybe<EmployeeStatus>;
  location_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEmployeesQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeConnection', edges: Array<{ __typename?: 'EmployeeEdge', cursor: string, node: { __typename?: 'Employee', id: string, status: EmployeeStatus, has_all_locations_access: boolean, fired_at?: string | null, firing_reason?: string | null, created_at: string, last_activity_at?: string | null, is_owner: boolean, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null }, locations: Array<{ __typename?: 'Location', id: string, title: string }>, roles: Array<{ __typename?: 'Role', id: string, title: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string, title: string }> };

export type CheckPaymentStatusMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type CheckPaymentStatusMutation = { __typename?: 'Mutation', checkPaymentStatus: { __typename?: 'PaymentDetails', id: string, status?: PaymentStatus | null, available_actions: Array<PaymentAvailableAction>, attention_reasons: Array<PaymentAttentionReason> } };

export type AttachRecoveredRefundRequestMutationVariables = Exact<{
  refundId: Scalars['ID']['input'];
  requestId: Scalars['String']['input'];
}>;


export type AttachRecoveredRefundRequestMutation = { __typename?: 'Mutation', attachRecoveredRefundRequest: { __typename?: 'PaymentRefund', id: string, status: PaymentRefundStatus, provider_request_id?: string | null } };

export type RadioTrackLoudnessFragmentFragment = { __typename?: 'RadioTrack', id: string, loudness_analysis_status: RadioLoudnessAnalysisStatus, normalization_gain_db?: number | null, loudness_analysis_version: number };

export type GetRadioTrackLoudnessQueryVariables = Exact<{
  trackIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetRadioTrackLoudnessQuery = { __typename?: 'Query', radioTrackLoudness: Array<{ __typename?: 'RadioTrack', id: string, loudness_analysis_status: RadioLoudnessAnalysisStatus, normalization_gain_db?: number | null, loudness_analysis_version: number }> };

export type RequestTrackUploadMutationVariables = Exact<{
  input: RequestTrackUploadInput;
}>;


export type RequestTrackUploadMutation = { __typename?: 'Mutation', requestTrackUpload: { __typename?: 'TrackUploadUrl', uploadUrl: string, trackId: string, s3Path: string, expiresAt: string } };

export type ConfirmTrackUploadMutationVariables = Exact<{
  trackId: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
}>;


export type ConfirmTrackUploadMutation = { __typename?: 'Mutation', confirmTrackUpload: { __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string } };

export type DeleteRadioTrackMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRadioTrackMutation = { __typename?: 'Mutation', deleteRadioTrack: { __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string } };

export type UpdateRadioTrackMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRadioTrackInput;
}>;


export type UpdateRadioTrackMutation = { __typename?: 'Mutation', updateRadioTrack: { __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string } };

export type CreateRadioPlaylistMutationVariables = Exact<{
  input: CreateRadioPlaylistInput;
}>;


export type CreateRadioPlaylistMutation = { __typename?: 'Mutation', createRadioPlaylist: { __typename?: 'RadioPlaylist', id: string, title: string, is_default: boolean, created_at: string, tracks: Array<{ __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string }> } };

export type UpdateRadioPlaylistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRadioPlaylistInput;
}>;


export type UpdateRadioPlaylistMutation = { __typename?: 'Mutation', updateRadioPlaylist: { __typename?: 'RadioPlaylist', id: string, title: string, is_default: boolean, created_at: string, tracks: Array<{ __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string }> } };

export type DeleteRadioPlaylistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRadioPlaylistMutation = { __typename?: 'Mutation', deleteRadioPlaylist: { __typename?: 'RadioPlaylist', id: string, title: string, is_default: boolean, created_at: string, tracks: Array<{ __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string }> } };

export type AddTracksToRadioPlaylistMutationVariables = Exact<{
  playlistId: Scalars['ID']['input'];
  trackIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddTracksToRadioPlaylistMutation = { __typename?: 'Mutation', addTracksToRadioPlaylist: { __typename?: 'RadioPlaylist', id: string, title: string, is_default: boolean, created_at: string, tracks: Array<{ __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string }> } };

export type RemoveTrackFromRadioPlaylistMutationVariables = Exact<{
  playlistId: Scalars['ID']['input'];
  trackId: Scalars['ID']['input'];
}>;


export type RemoveTrackFromRadioPlaylistMutation = { __typename?: 'Mutation', removeTrackFromRadioPlaylist: { __typename?: 'RadioPlaylist', id: string, title: string, is_default: boolean, created_at: string, tracks: Array<{ __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string }> } };

export type RadioTrackFragmentFragment = { __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string };

export type RadioPlaylistFragmentFragment = { __typename?: 'RadioPlaylist', id: string, title: string, is_default: boolean, created_at: string, tracks: Array<{ __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string }> };

export type GetRadioTracksQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRadioTracksQuery = { __typename?: 'Query', radioTracks: { __typename?: 'RadioTrackConnection', edges: Array<{ __typename?: 'RadioTrackEdge', cursor: string, node: { __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetRadioPlaylistsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRadioPlaylistsQuery = { __typename?: 'Query', radioPlaylists: Array<{ __typename?: 'RadioPlaylist', id: string, title: string, is_default: boolean, created_at: string, tracks: Array<{ __typename?: 'RadioTrack', id: string, title: string, artist?: string | null, duration: number, file_size: number, url: string, created_at: string }> }> };

export type GetShiftLoyaltyRegistrationsReportQueryVariables = Exact<{
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
}>;


export type GetShiftLoyaltyRegistrationsReportQuery = { __typename?: 'Query', shiftLoyaltyRegistrationsReport: Array<{ __typename?: 'ShiftLoyaltyRegistrationsReportRow', employee_id: string, employee_name: string, shifts_count: number, potential_clients: number, registered_clients: number }> };

export type GetNewClientRetentionReportQueryVariables = Exact<{
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  dimension: NewClientRetentionDimension;
}>;


export type GetNewClientRetentionReportQuery = { __typename?: 'Query', newClientRetentionReport: Array<{ __typename?: 'NewClientRetentionRow', key?: string | null, title: string, row_kind: AnalyticsBreakdownRowKind, cohorts: Array<{ __typename?: 'NewClientRetentionCohort', month: string, first_visit_date?: string | null, new_clients: number, matured_30: number, returned_30: number, matured_90: number, returned_90: number, returned_any: number }> }> };

export type GetRegularClientsReportQueryVariables = Exact<{
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
}>;


export type GetRegularClientsReportQuery = { __typename?: 'Query', regularClientsReport: Array<{ __typename?: 'RegularClientsMonth', month: string, point_date: string, is_partial: boolean, loyal: number, entered: number, left: number, active: number, visits: number, revenue: number }> };

export type GetShiftLoyaltyReportItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShiftLoyaltyReportItemsQuery = { __typename?: 'Query', shiftLoyaltyReportItems: Array<string> };

export type SetShiftLoyaltyReportItemsMutationVariables = Exact<{
  catalogItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SetShiftLoyaltyReportItemsMutation = { __typename?: 'Mutation', setShiftLoyaltyReportItems: Array<string> };

export type GetCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'City', id: string, name: string, slug: string }> };

export type BusinessSettingsFieldsFragment = { __typename?: 'BusinessSettings', id: string, title: string, sphere_id?: OrganizationSphere | null, resource_term: ResourceTerm, country_code?: string | null, currency: OrganizationCurrency, timezone: string, website_url?: string | null, facebook_url?: string | null, instagram_url?: string | null, vk_url?: string | null };

export type GetBusinessLocationScheduleQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetBusinessLocationScheduleQuery = { __typename?: 'Query', locationSchedule: { __typename?: 'LocationSchedule', current: Array<{ __typename?: 'LocationScheduleDay', day_of_week: ScheduleWeekday, is_day_off: boolean, start?: string | null, end?: string | null, closes_next_day: boolean, effective_from: string }>, upcoming: Array<{ __typename?: 'LocationScheduleDay', day_of_week: ScheduleWeekday, is_day_off: boolean, start?: string | null, end?: string | null, closes_next_day: boolean, effective_from: string }> } };

export type BusinessLocationShellFragment = { __typename?: 'BusinessLocation', id: string, title: string, alias: string, city?: string | null, address?: string | null, full_address?: string | null, timezone: string, opened_from?: string | null, closed_from?: string | null, business_status: BusinessLocationStatus };

export type BusinessLocationDetailsFieldsFragment = { __typename?: 'BusinessLocationDetails', title: string, alias: string, short_name: string, color: LocationColor, phone?: string | null, email?: string | null, legal_name?: string | null, legal_address?: string | null, legal_tin?: string | null, legal_ogrn?: string | null, legal_form?: LegalForm | null, legal_kpp?: string | null, legal_director_name?: string | null, bank_name?: string | null, bank_bik?: string | null, bank_correspondent_account?: string | null, bank_account?: string | null };

export type BusinessLocationAddressFieldsFragment = { __typename?: 'BusinessLocationAddress', country_code?: string | null, country?: string | null, region?: string | null, city?: string | null, address?: string | null, street?: string | null, house?: string | null, floor?: string | null, room?: string | null, address_line?: string | null, full_address?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null };

export type GetBusinessSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessSettingsQuery = { __typename?: 'Query', businessSettings: { __typename?: 'BusinessSettings', id: string, title: string, sphere_id?: OrganizationSphere | null, resource_term: ResourceTerm, country_code?: string | null, currency: OrganizationCurrency, timezone: string, website_url?: string | null, facebook_url?: string | null, instagram_url?: string | null, vk_url?: string | null } };

export type GetBusinessSettingsCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessSettingsCatalogQuery = { __typename?: 'Query', businessSettingsCatalog: { __typename?: 'BusinessSettingsCatalog', countries: Array<{ __typename?: 'BusinessCountryOption', id: string, title: string }>, timezones: Array<{ __typename?: 'BusinessTimezoneOption', id: string, title: string }> } };

export type GetBusinessLocationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BusinessLocationStatus>;
  first?: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBusinessLocationsQuery = { __typename?: 'Query', businessLocations: { __typename?: 'BusinessLocationConnection', edges: Array<{ __typename?: 'BusinessLocationEdge', cursor: string, node: { __typename?: 'BusinessLocation', id: string, title: string, alias: string, city?: string | null, address?: string | null, full_address?: string | null, timezone: string, opened_from?: string | null, closed_from?: string | null, business_status: BusinessLocationStatus } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, total: number } } };

export type GetBusinessLocationQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  includePrivate: Scalars['Boolean']['input'];
}>;


export type GetBusinessLocationQuery = { __typename?: 'Query', businessLocation: { __typename?: 'BusinessLocation', id: string, title: string, alias: string, city?: string | null, address?: string | null, full_address?: string | null, timezone: string, opened_from?: string | null, closed_from?: string | null, business_status: BusinessLocationStatus, details?: { __typename?: 'BusinessLocationDetails', title: string, alias: string, short_name: string, color: LocationColor, phone?: string | null, email?: string | null, legal_name?: string | null, legal_address?: string | null, legal_tin?: string | null, legal_ogrn?: string | null, legal_form?: LegalForm | null, legal_kpp?: string | null, legal_director_name?: string | null, bank_name?: string | null, bank_bik?: string | null, bank_correspondent_account?: string | null, bank_account?: string | null } | null, location_address?: { __typename?: 'BusinessLocationAddress', country_code?: string | null, country?: string | null, region?: string | null, city?: string | null, address?: string | null, street?: string | null, house?: string | null, floor?: string | null, room?: string | null, address_line?: string | null, full_address?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null } | null } };

export type UpdateBusinessSettingsMutationVariables = Exact<{
  input: UpdateBusinessSettingsInput;
}>;


export type UpdateBusinessSettingsMutation = { __typename?: 'Mutation', updateBusinessSettings: { __typename?: 'BusinessSettings', id: string, title: string, sphere_id?: OrganizationSphere | null, resource_term: ResourceTerm, country_code?: string | null, currency: OrganizationCurrency, timezone: string, website_url?: string | null, facebook_url?: string | null, instagram_url?: string | null, vk_url?: string | null } };

export type ChangeBusinessTimezoneMutationVariables = Exact<{
  timezone: Scalars['String']['input'];
}>;


export type ChangeBusinessTimezoneMutation = { __typename?: 'Mutation', changeBusinessTimezone: { __typename?: 'BusinessSettings', id: string, title: string, sphere_id?: OrganizationSphere | null, resource_term: ResourceTerm, country_code?: string | null, currency: OrganizationCurrency, timezone: string, website_url?: string | null, facebook_url?: string | null, instagram_url?: string | null, vk_url?: string | null } };

export type UpdateBusinessLocationDetailsMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  input: UpdateBusinessLocationDetailsInput;
}>;


export type UpdateBusinessLocationDetailsMutation = { __typename?: 'Mutation', updateBusinessLocationDetails: { __typename?: 'BusinessLocation', id: string, title: string, alias: string, city?: string | null, address?: string | null, full_address?: string | null, timezone: string, opened_from?: string | null, closed_from?: string | null, business_status: BusinessLocationStatus, details?: { __typename?: 'BusinessLocationDetails', title: string, alias: string, short_name: string, color: LocationColor, phone?: string | null, email?: string | null, legal_name?: string | null, legal_address?: string | null, legal_tin?: string | null, legal_ogrn?: string | null, legal_form?: LegalForm | null, legal_kpp?: string | null, legal_director_name?: string | null, bank_name?: string | null, bank_bik?: string | null, bank_correspondent_account?: string | null, bank_account?: string | null } | null } };

export type UpdateBusinessLocationAddressMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  input: UpdateBusinessLocationAddressInput;
}>;


export type UpdateBusinessLocationAddressMutation = { __typename?: 'Mutation', updateBusinessLocationAddress: { __typename?: 'BusinessLocation', id: string, title: string, alias: string, city?: string | null, address?: string | null, full_address?: string | null, timezone: string, opened_from?: string | null, closed_from?: string | null, business_status: BusinessLocationStatus, location_address?: { __typename?: 'BusinessLocationAddress', country_code?: string | null, country?: string | null, region?: string | null, city?: string | null, address?: string | null, street?: string | null, house?: string | null, floor?: string | null, room?: string | null, address_line?: string | null, full_address?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null } | null } };

export type CreateBusinessLocationMutationVariables = Exact<{
  input: CreateBusinessLocationInput;
}>;


export type CreateBusinessLocationMutation = { __typename?: 'Mutation', createBusinessLocation: { __typename?: 'BusinessLocation', id: string, title: string, alias: string, city?: string | null, address?: string | null, full_address?: string | null, timezone: string, opened_from?: string | null, closed_from?: string | null, business_status: BusinessLocationStatus } };

export type ChangeBusinessLocationTimezoneMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
}>;


export type ChangeBusinessLocationTimezoneMutation = { __typename?: 'Mutation', changeBusinessLocationTimezone: { __typename?: 'ChangeBusinessLocationTimezonePayload', saved: boolean, timezone: string, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type GetLocationAddressSuggestionsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  count: Scalars['Int']['input'];
}>;


export type GetLocationAddressSuggestionsQuery = { __typename?: 'Query', locationAddressSuggestions: Array<{ __typename?: 'LocationAddressSuggestion', label: string, query: string, country_code?: string | null, region?: string | null, city?: string | null, address?: string | null, street?: string | null, house?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null, coordinates_exact: boolean }> };

export type GeocodeLocationAddressQueryVariables = Exact<{
  query: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type GeocodeLocationAddressQuery = { __typename?: 'Query', locationAddressGeocode?: { __typename?: 'LocationAddressGeocodeResult', label: string, country_code?: string | null, region?: string | null, city?: string | null, address?: string | null, postal_code?: string | null, latitude: number, longitude: number, coordinates_exact: boolean, requires_review: boolean } | null };

export type BookingSettingsServiceMutationFieldsFragment = { __typename?: 'BookingSettingsService', id: string, unit_ids: Array<string> };

export type BookingSettingsConflictFieldsFragment = { __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null };

export type BookingSettingsUnitMutationFieldsFragment = { __typename?: 'BookingSettingsUnit', id: string, title: string, is_active: boolean, active_unavailability?: { __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string } | null };

export type UpsertBookingCatalogMutationVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertBookingCatalogInput;
}>;


export type UpsertBookingCatalogMutation = { __typename?: 'Mutation', upsertBookingCatalog: { __typename?: 'BookingCatalogMutationPayload', units?: Array<{ __typename?: 'BookingSettingsUnit', id: string, title: string, is_active: boolean, active_unavailability?: { __typename?: 'UnitUnavailability', id: string, unit_id: string, start: string, end: string, reason: string } | null }> | null, services?: Array<{ __typename?: 'BookingSettingsService', id: string, unit_ids: Array<string> }> | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type UpsertLocationScheduleMutationVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  input: UpsertLocationScheduleInput;
}>;


export type UpsertLocationScheduleMutation = { __typename?: 'Mutation', upsertLocationSchedule: { __typename?: 'LocationScheduleMutationPayload', schedule?: { __typename?: 'LocationSchedule', current: Array<{ __typename?: 'LocationScheduleDay', day_of_week: ScheduleWeekday, is_day_off: boolean, start?: string | null, end?: string | null, closes_next_day: boolean, effective_from: string }>, upcoming: Array<{ __typename?: 'LocationScheduleDay', day_of_week: ScheduleWeekday, is_day_off: boolean, start?: string | null, end?: string | null, closes_next_day: boolean, effective_from: string }> } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type LocationLifecycleFieldsFragment = { __typename?: 'Location', id: string, opened_from?: string | null, closed_from?: string | null };

export type CloseLocationMutationVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  input: CloseLocationInput;
}>;


export type CloseLocationMutation = { __typename?: 'Mutation', closeLocation: { __typename?: 'LocationClosureMutationPayload', earliest_allowed_closed_from?: string | null, location?: { __typename?: 'Location', id: string, opened_from?: string | null, closed_from?: string | null } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type ReopenLocationMutationVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReopenLocationMutation = { __typename?: 'Mutation', reopenLocation: { __typename?: 'LocationClosureMutationPayload', location?: { __typename?: 'Location', id: string, opened_from?: string | null, closed_from?: string | null } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type CatalogItemMutationPayloadFieldsFragment = { __typename?: 'CatalogItemMutationPayload', item?: { __typename?: 'CatalogItem', id: string, kind: CatalogItemKind, category_id?: string | null, title: string, position: number, price_rule: CatalogPriceRule, fixed_price?: number | null, range_min?: number | null, range_max?: number | null, booking_min_duration_minutes?: number | null, booking_max_duration_minutes?: number | null, booking_slot_step_minutes?: number | null, booking_available_online: boolean, archived: boolean, price_from?: number | null, allowed_price_rules: Array<CatalogPriceRule>, booking_allowed: boolean, archive_allowed: boolean, tariffs: Array<{ __typename?: 'CatalogTariff', id: string, duration_minutes: number, price: number, available_online: boolean, locations: Array<{ __typename?: 'CatalogTariffLocation', location_id: string, price?: number | null }> }>, locations: Array<{ __typename?: 'CatalogItemLocation', location_id: string, price?: number | null }> } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> };

export type SaveCatalogCategoryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  position: Scalars['Int']['input'];
}>;


export type SaveCatalogCategoryMutation = { __typename?: 'Mutation', saveCatalogCategory: { __typename?: 'CatalogCategory', id: string, title: string, position: number } };

export type DeleteCatalogCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCatalogCategoryMutation = { __typename?: 'Mutation', deleteCatalogCategory: boolean };

export type ReorderCatalogServicesMutationVariables = Exact<{
  groups: Array<CatalogServiceGroupInput> | CatalogServiceGroupInput;
}>;


export type ReorderCatalogServicesMutation = { __typename?: 'Mutation', reorderCatalogServices: Array<{ __typename?: 'CatalogCategory', id: string, title: string, position: number }> };

export type SaveCatalogServiceMutationVariables = Exact<{
  input: CatalogServiceInput;
}>;


export type SaveCatalogServiceMutation = { __typename?: 'Mutation', saveCatalogService: { __typename?: 'CatalogItemMutationPayload', item?: { __typename?: 'CatalogItem', id: string, kind: CatalogItemKind, category_id?: string | null, title: string, position: number, price_rule: CatalogPriceRule, fixed_price?: number | null, range_min?: number | null, range_max?: number | null, booking_min_duration_minutes?: number | null, booking_max_duration_minutes?: number | null, booking_slot_step_minutes?: number | null, booking_available_online: boolean, archived: boolean, price_from?: number | null, allowed_price_rules: Array<CatalogPriceRule>, booking_allowed: boolean, archive_allowed: boolean, tariffs: Array<{ __typename?: 'CatalogTariff', id: string, duration_minutes: number, price: number, available_online: boolean, locations: Array<{ __typename?: 'CatalogTariffLocation', location_id: string, price?: number | null }> }>, locations: Array<{ __typename?: 'CatalogItemLocation', location_id: string, price?: number | null }> } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type SetCatalogItemArchivedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type SetCatalogItemArchivedMutation = { __typename?: 'Mutation', setCatalogItemArchived: { __typename?: 'CatalogItemMutationPayload', item?: { __typename?: 'CatalogItem', id: string, kind: CatalogItemKind, category_id?: string | null, title: string, position: number, price_rule: CatalogPriceRule, fixed_price?: number | null, range_min?: number | null, range_max?: number | null, booking_min_duration_minutes?: number | null, booking_max_duration_minutes?: number | null, booking_slot_step_minutes?: number | null, booking_available_online: boolean, archived: boolean, price_from?: number | null, allowed_price_rules: Array<CatalogPriceRule>, booking_allowed: boolean, archive_allowed: boolean, tariffs: Array<{ __typename?: 'CatalogTariff', id: string, duration_minutes: number, price: number, available_online: boolean, locations: Array<{ __typename?: 'CatalogTariffLocation', location_id: string, price?: number | null }> }>, locations: Array<{ __typename?: 'CatalogItemLocation', location_id: string, price?: number | null }> } | null, conflicts: Array<{ __typename?: 'UnitUnavailabilityBookingConflict', booking_id: string, group_id: string, start: string, end: string, client_title?: string | null, service_title?: string | null }> } };

export type GetCatalogServicesQueryVariables = Exact<{
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCatalogServicesQuery = { __typename?: 'Query', catalogItems: Array<{ __typename?: 'CatalogItem', tire_kind: TireServiceItemKind, id: string, kind: CatalogItemKind, category_id?: string | null, title: string, position: number, price_rule: CatalogPriceRule, fixed_price?: number | null, range_min?: number | null, range_max?: number | null, booking_min_duration_minutes?: number | null, booking_max_duration_minutes?: number | null, booking_slot_step_minutes?: number | null, booking_available_online: boolean, archived: boolean, price_from?: number | null, allowed_price_rules: Array<CatalogPriceRule>, booking_allowed: boolean, archive_allowed: boolean, tariffs: Array<{ __typename?: 'CatalogTariff', id: string, duration_minutes: number, price: number, available_online: boolean, locations: Array<{ __typename?: 'CatalogTariffLocation', location_id: string, price?: number | null }> }>, locations: Array<{ __typename?: 'CatalogItemLocation', location_id: string, price?: number | null }> }> };

export type SaveTireServiceSettingsMutationVariables = Exact<{
  input: SaveTireServiceSettingsInput;
}>;


export type SaveTireServiceSettingsMutation = { __typename?: 'Mutation', saveTireServiceSettings: { __typename?: 'TireServiceSettings', diameter_min: number, diameter_max: number, run_flat_enabled: boolean, car_classes: Array<{ __typename?: 'TireCarClass', id: string, title: string }>, archived_car_classes: Array<{ __typename?: 'TireCarClass', id: string, title: string }> } };

export type SetTireStorageEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type SetTireStorageEnabledMutation = { __typename?: 'Mutation', setTireStorageEnabled: { __typename?: 'OrganizationAddOn', module: OrganizationModule, status: OrganizationAddOnStatus } };

export type SaveTireStorageWarehouseMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  rackCount: Scalars['Int']['input'];
  cellCount: Scalars['Int']['input'];
}>;


export type SaveTireStorageWarehouseMutation = { __typename?: 'Mutation', saveTireStorageWarehouse: { __typename?: 'TireStorageWarehouse', id: string, title: string, rack_count: number, cell_count: number, occupied_cells: number, location_id: string } };

export type DeleteTireStorageWarehouseMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteTireStorageWarehouseMutation = { __typename?: 'Mutation', deleteTireStorageWarehouse: boolean };

export type CreateShopOrderDraftMutationVariables = Exact<{
  input: ShopOrderDraftInput;
}>;


export type CreateShopOrderDraftMutation = { __typename?: 'Mutation', createShopOrderDraft: { __typename?: 'Order', final_receipt_outside_mors: boolean, id: string, organization_id: string, location_id: string, client_id?: string | null, booking_group_id?: string | null, revision: number, status: OrderStatus, source: OrderSource, currency: OrderCurrency, gross_amount: number, discount_amount: number, total_amount: number, paid_amount: number, refunded_amount: number, fiscal_receipt_state: OrderFiscalReceiptState, unowned_marking_codes: Array<string>, acquiring_instrument?: OrderAcquiringInstrument | null, remaining_amount: number, advance_amount: number, version: number, paid_at?: string | null, cancelled_at?: string | null, created_at: string, updated_at: string, refunds: Array<{ __typename?: 'OrderRefund', id: string, status: OrderRefundStatus, amount: number, reason_code?: string | null, reason: string, completed_at: string, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderRefundLine', id: string, order_line_id: string, quantity: number, amount: number, order_line: { __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number } }>, money_parts: Array<{ __typename?: 'OrderRefundMoneyPart', money_part_id: string, method: PaymentMoneyPartMethod, amount: number }> }>, fiscal_operations: Array<{ __typename?: 'OrderFiscalOperation', timezone: string, id: string, location_id: string, order_id: string, refund_id?: string | null, operation_type: OrderFiscalOperationType, status: OrderFiscalOperationStatus, bank_payment_status?: OrderFiscalBankPaymentStatus | null, kkm_command_status?: OrderFiscalKkmCommandStatus | null, failure_kind?: OrderFiscalFailureKind | null, error_code?: string | null, error_message?: string | null, warning_code?: string | null, payment_captured_at?: string | null, fiscal_drive_number_masked?: string | null, fiscal_document_number?: string | null, fiscal_document_sign?: string | null, shift_number?: number | null, receipt_number?: number | null, receipt_url?: string | null, fiscalized_at?: string | null, prepared_at: string, started_at?: string | null, reconciliation_required_at?: string | null, failed_at?: string | null, completed_at?: string | null, workstation: { __typename?: 'OrderFiscalWorkstation', id: string, name: string } }>, audit_logs: Array<{ __typename?: 'OrderAuditLog', id: string, action: OrderAuditAction, actor_employee_id?: string | null, old_values?: any | null, new_values?: any | null, metadata?: any | null, created_at: string, actor_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }>, customer_snapshot?: { __typename?: 'OrderCustomerSnapshot', id: string, type?: ClientType | null, legal_name?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, email_masked?: string | null } | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, created_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, paid_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, cancelled_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null, lines: Array<{ __typename?: 'OrderLine', id: string, booking_id?: string | null, catalog_item_id?: string | null, catalog_tariff_id?: string | null, line_type: OrderLineType, position: number, title_snapshot: string, duration_minutes_snapshot?: number | null, quantity: number, unit_price: number, gross_amount: number, discount_amount: number, net_amount: number, refunded_amount: number }>, adjustments: Array<{ __typename?: 'OrderAdjustment', id: string, order_line_id?: string | null, adjustment_type: OrderAdjustmentType, source: string, label?: string | null, amount: number, line_points: Array<{ __typename?: 'OrderAdjustmentLinePoints', order_line_id: string, points: number }> }>, money_parts: Array<{ __typename?: 'OrderMoneyPart', id: string, payment_id: string, method: PaymentMoneyPartMethod, amount: number, refundable_amount: number, captured_at?: string | null, captured_by_employee?: { __typename?: 'OrderActor', id: string, title?: string | null } | null }> } };

export type UploadSopImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadSopImageMutation = { __typename?: 'Mutation', uploadSopImage: { __typename?: 'SopImageUploadPayload', url: string } };

export type SopSectionFragmentFragment = { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string };

export type SopVersionDetailFragmentFragment = { __typename?: 'SopVersion', id: string, version_number: number, title: string, content?: string | null, change_summary?: string | null, created_at: string, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null };

export type SopPermissionFragmentFragment = { __typename?: 'SopPermissionType', id: string, access_level: SopAccessLevel, employee?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, role?: { __typename?: 'Role', id: string, name: string } | null };

export type SopListFragmentFragment = { __typename?: 'Sop', id: string, title: string, status: SopStatus, current_version: number, published_at?: string | null, created_at: string, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } | null, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, updater?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null };

export type SopDetailFragmentFragment = { __typename?: 'Sop', id: string, title: string, content?: string | null, status: SopStatus, current_version: number, published_at?: string | null, created_at: string, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } | null, versions: Array<{ __typename?: 'SopVersion', id: string, version_number: number, title: string, content?: string | null, change_summary?: string | null, created_at: string, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null }>, permissions: Array<{ __typename?: 'SopPermissionType', id: string, access_level: SopAccessLevel, employee?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, updater?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null };

export type SopSearchFragmentFragment = { __typename?: 'Sop', id: string, title: string, status: SopStatus, search_highlight_title?: string | null, search_highlight_content?: string | null, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null } | null };

export type SearchSopsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchSopsQuery = { __typename?: 'Query', sops: { __typename?: 'SopConnection', edges: Array<{ __typename?: 'SopEdge', cursor: string, node: { __typename?: 'Sop', id: string, title: string, status: SopStatus, search_highlight_title?: string | null, search_highlight_content?: string | null, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total: number } } };

export type GetSopsQueryVariables = Exact<{
  status?: InputMaybe<SopStatus>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSopsQuery = { __typename?: 'Query', sops: { __typename?: 'SopConnection', edges: Array<{ __typename?: 'SopEdge', cursor: string, node: { __typename?: 'Sop', id: string, title: string, status: SopStatus, current_version: number, published_at?: string | null, created_at: string, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } | null, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, updater?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, total: number } } };

export type GetSopQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSopQuery = { __typename?: 'Query', sop?: { __typename?: 'Sop', id: string, title: string, content?: string | null, status: SopStatus, current_version: number, published_at?: string | null, created_at: string, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } | null, versions: Array<{ __typename?: 'SopVersion', id: string, version_number: number, title: string, content?: string | null, change_summary?: string | null, created_at: string, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null }>, permissions: Array<{ __typename?: 'SopPermissionType', id: string, access_level: SopAccessLevel, employee?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, updater?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null } | null };

export type GetSopSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSopSectionsQuery = { __typename?: 'Query', sopSections: Array<{ __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string, parent?: { __typename?: 'SopSection', id: string, name: string } | null, children: Array<{ __typename?: 'SopSection', id: string, name: string, sops_count: number }> }> };

export type CreateSopMutationVariables = Exact<{
  input: CreateSopInput;
}>;


export type CreateSopMutation = { __typename?: 'Mutation', createSop: { __typename?: 'Sop', id: string, title: string, content?: string | null, status: SopStatus, current_version: number, published_at?: string | null, created_at: string, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } | null, versions: Array<{ __typename?: 'SopVersion', id: string, version_number: number, title: string, content?: string | null, change_summary?: string | null, created_at: string, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null }>, permissions: Array<{ __typename?: 'SopPermissionType', id: string, access_level: SopAccessLevel, employee?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, updater?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null } };

export type UpdateSopMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSopInput;
}>;


export type UpdateSopMutation = { __typename?: 'Mutation', updateSop: { __typename?: 'Sop', id: string, title: string, content?: string | null, status: SopStatus, current_version: number, published_at?: string | null, created_at: string, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } | null, versions: Array<{ __typename?: 'SopVersion', id: string, version_number: number, title: string, content?: string | null, change_summary?: string | null, created_at: string, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null }>, permissions: Array<{ __typename?: 'SopPermissionType', id: string, access_level: SopAccessLevel, employee?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, updater?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null } };

export type DeleteSopMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSopMutation = { __typename?: 'Mutation', deleteSop: boolean };

export type PublishSopMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishSopMutation = { __typename?: 'Mutation', publishSop: { __typename?: 'Sop', id: string, title: string, content?: string | null, status: SopStatus, current_version: number, published_at?: string | null, created_at: string, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } | null, versions: Array<{ __typename?: 'SopVersion', id: string, version_number: number, title: string, content?: string | null, change_summary?: string | null, created_at: string, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null }>, permissions: Array<{ __typename?: 'SopPermissionType', id: string, access_level: SopAccessLevel, employee?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, updater?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null } };

export type ArchiveSopMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveSopMutation = { __typename?: 'Mutation', archiveSop: { __typename?: 'Sop', id: string, title: string, content?: string | null, status: SopStatus, current_version: number, published_at?: string | null, created_at: string, updated_at: string, section?: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } | null, versions: Array<{ __typename?: 'SopVersion', id: string, version_number: number, title: string, content?: string | null, change_summary?: string | null, created_at: string, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null }>, permissions: Array<{ __typename?: 'SopPermissionType', id: string, access_level: SopAccessLevel, employee?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, role?: { __typename?: 'Role', id: string, name: string } | null }>, creator?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null, updater?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null } } | null } };

export type CreateSopSectionMutationVariables = Exact<{
  input: CreateSopSectionInput;
}>;


export type CreateSopSectionMutation = { __typename?: 'Mutation', createSopSection: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } };

export type UpdateSopSectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSopSectionInput;
}>;


export type UpdateSopSectionMutation = { __typename?: 'Mutation', updateSopSection: { __typename?: 'SopSection', id: string, name: string, color?: string | null, description?: string | null, sops_count: number, created_at: string } };

export type DeleteSopSectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSopSectionMutation = { __typename?: 'Mutation', deleteSopSection: boolean };

export type AssignTireStoragePlaceMutationVariables = Exact<{
  storageId: Scalars['ID']['input'];
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
  rackNo?: InputMaybe<Scalars['Int']['input']>;
  cellNo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AssignTireStoragePlaceMutation = { __typename?: 'Mutation', assignTireStoragePlace: { __typename?: 'TireStorage', overdue_days: number, released_at?: string | null, created_at: string, location_id: string, id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null }, car: { __typename?: 'TireCar', id: string }, car_details: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null }, intake_work_order: { __typename?: 'TireWorkOrder', id: string, number: number }, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } };

export type ReleaseTireStorageMutationVariables = Exact<{
  storageId: Scalars['ID']['input'];
  items: Array<TireStorageReleaseItemInput> | TireStorageReleaseItemInput;
}>;


export type ReleaseTireStorageMutation = { __typename?: 'Mutation', releaseTireStorage: { __typename?: 'TireStorageRelease', id: string, storage: { __typename?: 'TireStorage', overdue_days: number, released_at?: string | null, created_at: string, location_id: string, id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, releases: Array<{ __typename?: 'TireStorageRelease', id: string, released_at: string, remaining_quantity: number, items: Array<{ __typename?: 'TireStorageReleaseItem', item_id: string, quantity: number }> }>, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null }, car: { __typename?: 'TireCar', id: string }, car_details: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null }, intake_work_order: { __typename?: 'TireWorkOrder', id: string, number: number }, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } } };

export type CreateTireWorkOrderMutationVariables = Exact<{
  carId?: InputMaybe<Scalars['ID']['input']>;
  bookingGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTireWorkOrderMutation = { __typename?: 'Mutation', createTireWorkOrder: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export type SetTireWorkOrderCarMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  carId: Scalars['ID']['input'];
}>;


export type SetTireWorkOrderCarMutation = { __typename?: 'Mutation', setTireWorkOrderCar: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export type UpdateTireWorkOrderParamsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  carClassId?: InputMaybe<Scalars['ID']['input']>;
  wheelDiameter?: InputMaybe<Scalars['Int']['input']>;
  runFlat?: InputMaybe<Scalars['Boolean']['input']>;
  discountPercent?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateTireWorkOrderParamsMutation = { __typename?: 'Mutation', updateTireWorkOrderParams: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export type AddTireWorkOrderLineMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  catalogItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  enteredPrice?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddTireWorkOrderLineMutation = { __typename?: 'Mutation', addTireWorkOrderLine: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export type ChangeTireWorkOrderLineQuantityMutationVariables = Exact<{
  lineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type ChangeTireWorkOrderLineQuantityMutation = { __typename?: 'Mutation', changeTireWorkOrderLineQuantity: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export type RemoveTireWorkOrderLineMutationVariables = Exact<{
  lineId: Scalars['ID']['input'];
}>;


export type RemoveTireWorkOrderLineMutation = { __typename?: 'Mutation', removeTireWorkOrderLine: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export type DeleteTireWorkOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTireWorkOrderMutation = { __typename?: 'Mutation', deleteTireWorkOrder: boolean };

export type OpenTireWorkOrderCheckoutMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpenTireWorkOrderCheckoutMutation = { __typename?: 'Mutation', openTireWorkOrderCheckout: { __typename?: 'Order', id: string, version: number } };

export type AddTireStorageIntakeMutationVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
  catalogItemId: Scalars['ID']['input'];
  input: TireStorageInput;
}>;


export type AddTireStorageIntakeMutation = { __typename?: 'Mutation', addTireStorageIntake: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export type UpdateTireStorageIntakeMutationVariables = Exact<{
  storageId: Scalars['ID']['input'];
  input: TireStorageInput;
}>;


export type UpdateTireStorageIntakeMutation = { __typename?: 'Mutation', updateTireStorageIntake: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export type AddTireStorageExtensionMutationVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
  storageId: Scalars['ID']['input'];
  enteredPrice?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddTireStorageExtensionMutation = { __typename?: 'Mutation', addTireStorageExtension: { __typename?: 'TireWorkOrder', id: string, number: number, status: TireWorkOrderStatus, created_at: string, closed_at?: string | null, location_id: string, car_class_id?: string | null, car_class_title?: string | null, wheel_diameter?: number | null, run_flat: boolean, discount_percent: number, booking_group_id?: string | null, order_id?: string | null, gross_amount: number, discount_amount: number, total_amount: number, location: { __typename?: 'Location', id: string, title: string, short_name: string, color: LocationColor, timezone: string }, client?: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null, discount?: number | null } | null, car?: { __typename?: 'TireCar', id: string, plate?: string | null, mark: string, model: string, car_class?: { __typename?: 'TireCarClass', id: string, title: string } | null, client: { __typename?: 'Client', id: string, type: ClientType, legal_name?: string | null, legal_tin?: string | null, legal_kpp?: string | null, legal_address?: string | null, contact_person?: string | null, contact_phone?: string | null, first_name?: string | null, last_name?: string | null, patronymic_name?: string | null, phone_masked?: string | null } } | null, car_details?: { __typename?: 'TireCarDetails', mark: string, model?: string | null, plate?: string | null } | null, lines: Array<{ __typename?: 'TireWorkOrderLine', id: string, catalog_item_id: string, title: string, kind: TireServiceItemKind, price_rule: CatalogPriceRule, quantity: number, unit_price: number, wheel_diameter?: number | null, run_flat: boolean, amount: number, storage_id?: string | null, storage?: { __typename?: 'TireStorage', id: string, number?: number | null, status: TireStorageStatus, quantity: number, remaining_quantity: number, condition_note?: string | null, declared_value?: number | null, stored_until?: string | null, rack_no?: number | null, cell_no?: number | null, items: Array<{ __typename?: 'TireStorageItem', id: string, content: TireStorageContent, season?: TireSeason | null, quantity: number, remaining: number, tire_width?: number | null, tire_profile?: number | null, wheel_diameter: number, tread_depth_mm?: number | null, brand?: string | null, model?: string | null, dot?: string | null, disc_model?: string | null }>, warehouse?: { __typename?: 'TireStorageWarehouse', id: string, title: string } | null } | null }> } };

export const AuthLocationFragmentFragmentDoc = gql`
    fragment AuthLocationFragment on Location {
  id
  location_id
  organization_id
  alias
  title
  short_name
  color
  enabled
  photo
  icon
  city
  address
  full_address
  phone
  latitude
  longitude
  coordinate
  timezone
  opened_from
  closed_from
}
    `;
export const AuthOrganizationFragmentFragmentDoc = gql`
    fragment AuthOrganizationFragment on Organization {
  id
  alias
  title
  sphere_id
  resource_term
  domain
  enabled_modules
  known_add_ons
  timezone
  currency
  country_code
  has_locations
  created_at
  updated_at
  locations {
    ...AuthLocationFragment
  }
}
    ${AuthLocationFragmentFragmentDoc}`;
export const BookingGroupAuditLogFragmentDoc = gql`
    fragment BookingGroupAuditLog on BookingGroupAuditLog {
  id
  action
  changed_by_type
  changed_via
  changed_fields
  old_data
  new_data
  created_at
  changed_by_employee {
    id
    title
  }
}
    `;
export const BookingClientProfileClientFragmentDoc = gql`
    fragment BookingClientProfileClient on BookingClientProfileClient {
  id
  type
  legal_name
  first_name
  last_name
  patronymic_name
  phone_masked
  email
  sex
  birthday
  importance
  discount
  note
  created_at
  last_visit_at
  marketing_source_id
}
    `;
export const BookingClientRecentSlotFragmentDoc = gql`
    fragment BookingClientRecentSlot on BookingClientRecentSlot {
  id
  start
  end
  service_title
  unit_title
}
    `;
export const BookingClientRecentBookingFragmentDoc = gql`
    fragment BookingClientRecentBooking on BookingClientRecentBooking {
  id
  min_start
  max_end
  status
  discount
  subtotal_price
  price
  location_id
  location_title
  slots {
    ...BookingClientRecentSlot
  }
}
    ${BookingClientRecentSlotFragmentDoc}`;
export const BroadcastSnapshotFieldsFragmentDoc = gql`
    fragment BroadcastSnapshotFields on MarketingBroadcastAudienceSnapshot {
  id
  definition_version
  status
  as_of
  total_count
  ready_count
  excluded_count
  no_channel_count
  linked_ready_count
  unlinked_ready_count
  failed_reason
  windows {
    rule_id
    months
    from_at
    to_at
  }
  channel_counts {
    channel_label
    count
  }
}
    `;
export const BroadcastFieldsFragmentDoc = gql`
    fragment BroadcastFields on MarketingBroadcast {
  id
  name
  body
  version
  audience_definition_version
  audience_snapshot_id
  audience_definition {
    additions {
      id
      kind
      months
      broadcast_id
    }
    exclusions {
      id
      kind
      months
      broadcast_id
    }
  }
  audience_snapshot {
    ...BroadcastSnapshotFields
  }
  status
  image {
    url
    file_name
    mime_type
    file_size
    width
    height
  }
  bonus_enabled
  bonus_amount
  bonus_expires_on
  bonus_timezone
  bonus_expires_at
  total_count
  sent_count
  failed_count
  unknown_count
  started_at
  snapshot_at
  completed_at
  failed_reason
  created_at
  updated_at
}
    ${BroadcastSnapshotFieldsFragmentDoc}`;
export const BroadcastDeliveryFieldsFragmentDoc = gql`
    fragment BroadcastDeliveryFields on MarketingBroadcastRecipient {
  id
  client_id
  conversation_id
  channel_id
  external_chat_id
  audience_entry_id
  message_id
  status
  failed_reason
  loyalty_transaction_id
}
    `;
export const ClientAutomationFieldsFragmentDoc = gql`
    fragment ClientAutomationFields on ClientAutomation {
  id
  kind
  section
  title
  kind_title
  description
  enabled
  channel_policy
  quiet_hours_mode
  trigger_value
  trigger_options {
    value
    description
    quiet_hours_mode
  }
  bonus_points
  bonus_expiry_days
  template
  default_template
  variables
  button_label
  required
  footer
  link_code
  is_modified
  active_providers
  last_30_days {
    sent
    delivered
    failed
  }
}
    `;
export const ClientSegmentFieldsFragmentDoc = gql`
    fragment ClientSegmentFields on ClientSegment {
  id
  kind
  code
  name
  description
  badge_enabled
  badge_color
  is_modified
  position
  clients_count
  members_computed_at
  rules {
    subject
    predicate
    value
    values
    window {
      unit
      amount
    }
    conditions {
      field
      operator
      activity_types
      location_ids
      booking_channels
    }
  }
}
    `;
export const ClientWithLocationsFragmentDoc = gql`
    fragment ClientWithLocations on Client {
  id
  type
  legal_form
  legal_name
  legal_tin
  legal_kpp
  legal_address
  contact_person
  contact_phone
  first_name
  last_name
  patronymic_name
  phone_masked
  email
  sex
  birthday
  importance
  discount
  visits_count
  hours_total
  ltv
  avg_check
  note
  created_at
  last_visit_at
  marketing_source {
    id
    title
  }
  first_visit_location {
    id
    title
  }
  last_visit_location {
    id
    title
  }
  active_scenario_runs {
    id
    current_step_index
    status
    started_at
    last_step_at
    scenario {
      id
      name
      flow_definition {
        type
        body
        delay_value
        delay_unit
        button_text
        timeout_value
        timeout_unit
      }
    }
  }
}
    `;
export const BookingClientOptionFragmentDoc = gql`
    fragment BookingClientOption on Client {
  id
  type
  legal_form
  legal_name
  legal_tin
  legal_kpp
  legal_address
  contact_person
  contact_phone
  first_name
  last_name
  patronymic_name
  phone_masked
  email
  importance
  discount
  created_at
}
    `;
export const OrderFiscalizationSettingFieldsFragmentDoc = gql`
    fragment OrderFiscalizationSettingFields on OrderFiscalizationSetting {
  id
  organization_id
  location_id
  provider
  enabled
  shifts_enabled
  expected_kkt_inn_masked
  cashier_position
  cashier_last_name
  cashier_display_name
  taxation_system
  vat_rate
  payment_subject
  payment_method
  config_version
  created_at
  updated_at
}
    `;
export const OrderFiscalWorkstationFieldsFragmentDoc = gql`
    fragment OrderFiscalWorkstationFields on OrderFiscalWorkstation {
  id
  organization_id
  location_id
  workstation_id
  name
  active
  deletable
  kkmserver_version
  kkt_model_masked
  kkt_number_masked
  fn_number_masked
  kkt_status
  terminal_name_masked
  terminal_number_masked
  terminal_status
  kkt_verified_at
  terminal_verified_at
  activated_at
  deactivated_at
  created_at
  updated_at
}
    `;
export const OrderFiscalizationReadinessFieldsFragmentDoc = gql`
    fragment OrderFiscalizationReadinessFields on OrderFiscalizationReadiness {
  setting_enabled
  effective_enabled
  kkt_status
  terminal_status
  setting {
    ...OrderFiscalizationSettingFields
  }
  active_workstation {
    ...OrderFiscalWorkstationFields
  }
  last_workstation {
    ...OrderFiscalWorkstationFields
  }
}
    ${OrderFiscalizationSettingFieldsFragmentDoc}
${OrderFiscalWorkstationFieldsFragmentDoc}`;
export const ShiftFieldsFragmentDoc = gql`
    fragment ShiftFields on Shift {
  id
  organization_id
  location_id
  status
  opened_at
  closed_at
  opening_cash
  closing_cash
  closing_cash_expected
  closing_cash_diff
  closing_revenue_mors
  closing_revenue_kkt
  closing_revenue_diff
  kkt_sync
  kkt_fn_serial_masked
  close_comment
  expires_at
  cashier_vatin
  opened_by {
    id
    title
  }
  closed_by {
    id
    title
  }
  kkt_sessions {
    id
    shift_id
    fn_serial_masked
    kkt_shift_number
    opened_at
    closed_at
    close_reason
  }
}
    `;
export const InvoiceLocationFieldsFragmentDoc = gql`
    fragment InvoiceLocationFields on InvoiceLocation {
  id
  title
  short_name
  color
  timezone
}
    `;
export const InvoicePartyFieldsFragmentDoc = gql`
    fragment InvoicePartyFields on InvoiceParty {
  legal_form
  name
  tin
  kpp
  address
  ogrn
  bank_name
  bik
  correspondent_account
  account
  director_name
}
    `;
export const InvoiceFieldsFragmentDoc = gql`
    fragment InvoiceFields on Invoice {
  id
  number
  status
  is_overdue
  issued_on
  due_on
  total_amount
  paid_amount
  remaining_amount
  order_id
  order_title
  client_id
  client_title
  location {
    ...InvoiceLocationFields
  }
  seller {
    ...InvoicePartyFields
  }
  payer {
    ...InvoicePartyFields
  }
  lines {
    position
    title
    quantity
    unit
    unit_price
    amount
  }
  receipts {
    id
    status
    amount
    received_on
    payment_order_number
    payment_id
    confirmed_at
    confirmed_by_title
    void_reason
    voided_at
    voided_by_title
    returned_on
    return_payment_order_number
    returned_at
    returned_by_title
  }
  history {
    kind
    at
    actor_title
    amount
    reference
    reason
  }
  paid_at
  annulled_at
  created_at
}
    ${InvoiceLocationFieldsFragmentDoc}
${InvoicePartyFieldsFragmentDoc}`;
export const LoyaltyTierFieldsFragmentDoc = gql`
    fragment LoyaltyTierFields on LoyaltyTier {
  id
  name
  min_spent_amount
  base_rate_percent
  item_rates {
    catalog_item_id
    rate_percent
  }
}
    `;
export const LoyaltyProgramFieldsFragmentDoc = gql`
    fragment LoyaltyProgramFields on LoyaltyProgram {
  id
  organization_id
  is_active
  expiry_months
  max_redemption_percent
  tiers {
    ...LoyaltyTierFields
  }
}
    ${LoyaltyTierFieldsFragmentDoc}`;
export const LoyaltyAccountFieldsFragmentDoc = gql`
    fragment LoyaltyAccountFields on LoyaltyAccount {
  id
  client_id
  available_balance
  lifetime_spent_amount
  debt
  current_tier {
    ...LoyaltyTierFields
  }
  nearest_expiry {
    date
    amount
  }
}
    ${LoyaltyTierFieldsFragmentDoc}`;
export const LoyaltyTransactionFieldsFragmentDoc = gql`
    fragment LoyaltyTransactionFields on LoyaltyTransaction {
  id
  client_id
  type
  amount
  order_id
  order_refund_id
  created_by_employee_id
  note
  metadata
  created_at
  created_by_employee {
    id
    title
  }
}
    `;
export const MessengerChannelFragmentFragmentDoc = gql`
    fragment MessengerChannelFragment on MessengerChannel {
  id
  title
  provider
  is_active
  is_fallback
  priority
  conversation_count
  health_status {
    status
    webhook {
      status
      error
      checked_at
    }
    api {
      status
      error
      checked_at
    }
  }
  credentials {
    token
    username
    access_token
    group_id
    confirmation
    secret
    screen_name
  }
  created_at
  updated_at
}
    `;
export const MessengerClientFragmentFragmentDoc = gql`
    fragment MessengerClientFragment on MessengerClient {
  id
  first_name
  last_name
  phone_masked
  type
  marketing_source {
    id
    title
  }
  city {
    id
    name
  }
  active_bookings_count
}
    `;
export const MessengerConversationFragmentFragmentDoc = gql`
    fragment MessengerConversationFragment on MessengerConversation {
  id
  channel_id
  channel {
    id
    title
    provider
    is_active
    priority
  }
  client {
    ...MessengerClientFragment
  }
  chat_metadata {
    first_name
    last_name
    username
    avatar_url
    type
  }
  external_chat_id
  is_active
  is_default
  connected_at
  disconnected_at
  last_message_at
  messages_count
  created_at
  updated_at
}
    ${MessengerClientFragmentFragmentDoc}`;
export const MessengerMessageFragmentFragmentDoc = gql`
    fragment MessengerMessageFragment on MessengerMessage {
  id
  conversation_id
  channel_id
  direction
  sender_type
  message_type
  messenger_type
  employee_name
  body
  body_preview
  status
  external_message_id
  metadata
  file_url
  file_name
  file_size
  failed_reason
  scheduled_at
  sent_at
  delivered_at
  deliver_deadline
  read_at
  deleted_at
  created_at
  updated_at
}
    `;
export const MessengerDialogFragmentFragmentDoc = gql`
    fragment MessengerDialogFragment on MessengerDialog {
  id
  status
  waiting_since
  assignee {
    id
    first_name
    last_name
  }
}
    `;
export const OrderActorFieldsFragmentDoc = gql`
    fragment OrderActorFields on OrderActor {
  id
  title
}
    `;
export const OrderLineFieldsFragmentDoc = gql`
    fragment OrderLineFields on OrderLine {
  id
  booking_id
  catalog_item_id
  catalog_tariff_id
  line_type
  position
  title_snapshot
  duration_minutes_snapshot
  quantity
  unit_price
  gross_amount
  discount_amount
  net_amount
  refunded_amount
}
    `;
export const OrderMoneyPartFieldsFragmentDoc = gql`
    fragment OrderMoneyPartFields on OrderMoneyPart {
  id
  payment_id
  method
  amount
  refundable_amount
  captured_at
  captured_by_employee {
    ...OrderActorFields
  }
}
    ${OrderActorFieldsFragmentDoc}`;
export const OrderListFieldsFragmentDoc = gql`
    fragment OrderListFields on Order {
  id
  organization_id
  location_id
  client_id
  booking_group_id
  revision
  status
  source
  currency
  customer_snapshot {
    id
    type
    legal_name
    first_name
    last_name
    patronymic_name
    phone_masked
    email_masked
  }
  gross_amount
  discount_amount
  total_amount
  paid_amount
  refunded_amount
  fiscal_receipt_state
  unowned_marking_codes
  acquiring_instrument
  remaining_amount
  advance_amount
  version
  paid_at
  cancelled_at
  created_at
  updated_at
  location {
    id
    title
    short_name
    color
    timezone
  }
  created_by_employee {
    ...OrderActorFields
  }
  paid_by_employee {
    ...OrderActorFields
  }
  cancelled_by_employee {
    ...OrderActorFields
  }
  lines {
    ...OrderLineFields
  }
  adjustments {
    id
    order_line_id
    adjustment_type
    source
    label
    amount
    line_points {
      order_line_id
      points
    }
  }
  money_parts {
    ...OrderMoneyPartFields
  }
}
    ${OrderActorFieldsFragmentDoc}
${OrderLineFieldsFragmentDoc}
${OrderMoneyPartFieldsFragmentDoc}`;
export const OrderFieldsFragmentDoc = gql`
    fragment OrderFields on Order {
  ...OrderListFields
  final_receipt_outside_mors
  refunds {
    id
    status
    amount
    reason_code
    reason
    completed_at
    created_by_employee {
      ...OrderActorFields
    }
    lines {
      id
      order_line_id
      quantity
      amount
      order_line {
        ...OrderLineFields
      }
    }
    money_parts {
      money_part_id
      method
      amount
    }
  }
  fiscal_operations {
    timezone
    id
    location_id
    order_id
    refund_id
    operation_type
    status
    bank_payment_status
    kkm_command_status
    failure_kind
    error_code
    error_message
    warning_code
    payment_captured_at
    fiscal_drive_number_masked
    fiscal_document_number
    fiscal_document_sign
    shift_number
    receipt_number
    receipt_url
    fiscalized_at
    prepared_at
    started_at
    reconciliation_required_at
    failed_at
    completed_at
    workstation {
      id
      name
    }
  }
  audit_logs {
    id
    action
    actor_employee_id
    old_values
    new_values
    metadata
    created_at
    actor_employee {
      ...OrderActorFields
    }
  }
}
    ${OrderListFieldsFragmentDoc}
${OrderActorFieldsFragmentDoc}
${OrderLineFieldsFragmentDoc}`;
export const OrderCheckoutContextFieldsFragmentDoc = gql`
    fragment OrderCheckoutContextFields on OrderCheckoutContext {
  advances {
    id
    amount
    available_amount
    fiscal_scheme
    created_at
    receipt_status
  }
  open_payment_links {
    id
    payment_id
    amount
    inv_id
    status
    expires_at
    url
  }
  payment_link_availability {
    available
    reason_code
  }
  pay_url
  send_targets {
    conversation_id
    provider
  }
  advance_total
  remaining_to_pay
  overpayment_to_refund
  final_receipt_required
  order {
    ...OrderFields
  }
  source_state
  allowed_payment_methods
  fiscalization_required
  shift_required
  shift_state
  shift_blocker_reason
  shift_expires_at
  fiscalization_readiness {
    setting_enabled
    effective_enabled
    kkt_status
    terminal_status
    setting {
      id
      expected_kkt_inn_masked
      cashier_display_name
      config_version
    }
    active_workstation {
      id
      workstation_id
      active
      kkt_status
      terminal_status
      kkt_verified_at
      terminal_verified_at
    }
    last_workstation {
      id
      workstation_id
      active
      kkt_status
      terminal_status
      kkt_verified_at
      terminal_verified_at
    }
  }
  active_fiscal_operation {
    timezone
    id
    order_id
    location_id
    operation_type
    status
    bank_payment_status
    kkm_command_status
    failure_kind
    error_code
    error_message
    warning_code
    payment_captured_at
    fiscal_drive_number_masked
    fiscal_document_number
    fiscal_document_sign
    shift_number
    receipt_number
    receipt_url
    fiscalized_at
    completed_at
  }
  loyalty {
    available_balance
    max_redeemable_points
  }
  loyalty_program_active
  invoice {
    id
    number
    status
    remaining_amount
  }
}
    ${OrderFieldsFragmentDoc}`;
export const OrderRefundApprovalFieldsFragmentDoc = gql`
    fragment OrderRefundApprovalFields on OrderRefundApproval {
  id
  order_id
  location_id
  status
  kind
  transfer_amount
  requested_at
  request_comment
  resolved_at
  resolve_comment
  expires_at
  location {
    id
    title
  }
  requested_by_employee {
    id
    title
  }
  resolved_by_employee {
    id
    title
  }
  order {
    id
    status
    total_amount
    refunded_amount
    created_at
    customer_snapshot {
      id
      type
      legal_name
      first_name
      last_name
      patronymic_name
      phone_masked
      email_masked
    }
  }
}
    `;
export const PaymentDetailsFieldsFragmentDoc = gql`
    fragment PaymentDetailsFields on PaymentDetails {
  id
  amount
  confirmed_amount
  refundable_amount
  provider
  mode
  location_id
  location_title
  timezone
  created_at
  captured_at
  actor_title
  source_summary {
    customer_name
    description
  }
  status
  application_status
  order_id
  fiscal_operation_id
  transfer_details {
    payment_order_number
    received_on
    invoice_number
  }
  block_scope
  attention_reasons
  available_actions
  money_parts {
    id
    method
    planned_amount
    confirmed_amount
  }
  attempts {
    id
    status
    created_at
  }
  links {
    id
    status
    amount
    inv_id
    expires_at
    url
  }
  refunds {
    id
    amount
    status
    reason
    provider_request_id
    created_at
    actor_title
    transfer_reference
    transferred_on
    parts {
      method
      amount
    }
  }
  receipts {
    id
    issuer
    operation
    settlement_method
    status
    fn_number
    fd_number
    fiscal_sign
    fiscal_at
  }
  events {
    id
    type
    created_at
    from_status
    to_status
    reason_code
    message
    reason
    amount
  }
}
    `;
export const PlatformOrganizationRowFieldsFragmentDoc = gql`
    fragment PlatformOrganizationRowFields on PlatformOrganizationRow {
  organization {
    id
    alias
    title
    domain
    enabled_modules
    created_at
    updated_at
  }
  locations {
    id
    title
    city
    address
    full_address
    phone
    opened_from
    closed_from
  }
  employee_count
  uses_default_modules
}
    `;
export const PlatformUserRowFieldsFragmentDoc = gql`
    fragment PlatformUserRowFields on PlatformUserRow {
  user {
    id
    first_name
    last_name
    patronymic_name
    phone
    last_activity_at
    created_at
    is_super_user
  }
  memberships {
    employee {
      id
      status
      is_owner
      title
      created_at
      last_activity_at
    }
    organization {
      id
      alias
      title
    }
    locations {
      id
      title
    }
  }
}
    `;
export const PlatformImpersonationSessionRowFieldsFragmentDoc = gql`
    fragment PlatformImpersonationSessionRowFields on PlatformImpersonationSession {
  id
  impersonator {
    id
    first_name
    last_name
    phone
  }
  target_user {
    id
    first_name
    last_name
    phone
  }
  organization {
    id
    title
  }
  reason
  ip
  user_agent
  started_at
  ended_at
  end_reason
  actions_count
}
    `;
export const PlatformImpersonationActionRowFieldsFragmentDoc = gql`
    fragment PlatformImpersonationActionRowFields on PlatformImpersonationAction {
  id
  operation_name
  operation_type
  root_fields
  created_at
}
    `;
export const ProductStockFieldsFragmentDoc = gql`
    fragment ProductStockFields on ProductStock {
  id
  quantity
  location {
    id
    title
  }
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  title
  gtins
  is_marked
  is_excisable
  photo_url
  purchase_price
  sale_price
  category_id
  description
  total_stock_quantity
  archived_at
  stocks {
    ...ProductStockFields
  }
  created_at
  updated_at
}
    ${ProductStockFieldsFragmentDoc}`;
export const ShowcaseProductFieldsFragmentDoc = gql`
    fragment ShowcaseProductFields on Product {
  id
  title
  gtins
  is_marked
  is_excisable
  photo_url
  sale_price
}
    `;
export const StockBalanceFieldsFragmentDoc = gql`
    fragment StockBalanceFields on StockBalance {
  id
  title
  gtins
  is_marked
  is_excisable
  photo_url
  stock_quantity
  stocks {
    id
    quantity
    location {
      id
      title
    }
  }
}
    `;
export const ProductMovementFieldsFragmentDoc = gql`
    fragment ProductMovementFields on ProductMovement {
  id
  reason
  delta
  comment
  unit_purchase_price
  marking_codes
  order_id
  created_at
  location {
    id
    title
  }
  employee {
    id
    title
  }
  reversal {
    id
  }
  transfer_source {
    id
    location {
      id
      title
    }
  }
  transfer_target {
    id
    location {
      id
      title
    }
  }
}
    `;
export const QrLinkFragmentFragmentDoc = gql`
    fragment QrLinkFragment on QrLink {
  id
  name
  code
  target_url
  total_clicks
  public_url
  style_config
  deleted_at
  created_at
  updated_at
}
    `;
export const ScenarioListFragmentFragmentDoc = gql`
    fragment ScenarioListFragment on Scenario {
  id
  name
  code
  is_active
  active_from
  active_to
  stop_if_booked
  restart_on_reactivation
  runs_count
  marketing_source {
    id
    title
    is_manual_selectable
  }
  default_city {
    id
    name
  }
  created_at
  updated_at
}
    `;
export const ScenarioStepFragmentFragmentDoc = gql`
    fragment ScenarioStepFragment on ScenarioStep {
  type
  body
  delay_value
  delay_unit
  button_text
  timeout_value
  timeout_unit
  on_timeout
  buttons {
    text
    url
  }
}
    `;
export const ScenarioDetailFragmentFragmentDoc = gql`
    fragment ScenarioDetailFragment on Scenario {
  id
  name
  code
  is_active
  active_from
  active_to
  stop_if_booked
  restart_on_reactivation
  registration_bonus_points
  available_providers
  runs_count
  structural_edit_locked
  statistics {
    overview {
      contacts_collected
      new_clients
      new_clients_revenue
      reactivated_clients
      reactivated_revenue
    }
    funnel {
      contacts_collected
      identified
      reached_club
    }
  }
  marketing_source {
    id
    title
    is_manual_selectable
  }
  default_city {
    id
    name
  }
  flow_definition {
    ...ScenarioStepFragment
  }
  created_at
  updated_at
}
    ${ScenarioStepFragmentFragmentDoc}`;
export const TireStorageItemFieldsFragmentDoc = gql`
    fragment TireStorageItemFields on TireStorageItem {
  id
  content
  season
  quantity
  remaining
  tire_width
  tire_profile
  wheel_diameter
  tread_depth_mm
  brand
  model
  dot
  disc_model
}
    `;
export const TireStorageSummaryFieldsFragmentDoc = gql`
    fragment TireStorageSummaryFields on TireStorage {
  id
  number
  status
  items {
    ...TireStorageItemFields
  }
  quantity
  remaining_quantity
  condition_note
  declared_value
  stored_until
  rack_no
  cell_no
  warehouse {
    id
    title
  }
}
    ${TireStorageItemFieldsFragmentDoc}`;
export const TireStorageFieldsFragmentDoc = gql`
    fragment TireStorageFields on TireStorage {
  ...TireStorageSummaryFields
  overdue_days
  released_at
  created_at
  location_id
  location {
    id
    title
    short_name
    color
    timezone
  }
  client {
    id
    type
    legal_name
    legal_tin
    legal_kpp
    legal_address
    contact_person
    contact_phone
    first_name
    last_name
    patronymic_name
    phone_masked
  }
  car {
    id
  }
  car_details {
    mark
    model
    plate
  }
  intake_work_order {
    id
    number
  }
}
    ${TireStorageSummaryFieldsFragmentDoc}`;
export const TireStorageReleaseFieldsFragmentDoc = gql`
    fragment TireStorageReleaseFields on TireStorageRelease {
  id
  released_at
  remaining_quantity
  items {
    item_id
    quantity
  }
}
    `;
export const TireCarFieldsFragmentDoc = gql`
    fragment TireCarFields on TireCar {
  id
  plate
  mark
  model
  car_class {
    id
    title
  }
  client {
    id
    type
    legal_name
    legal_tin
    legal_kpp
    legal_address
    contact_person
    contact_phone
    first_name
    last_name
    patronymic_name
    phone_masked
  }
}
    `;
export const TireWorkOrderFieldsFragmentDoc = gql`
    fragment TireWorkOrderFields on TireWorkOrder {
  id
  number
  status
  created_at
  closed_at
  location_id
  location {
    id
    title
    short_name
    color
    timezone
  }
  car_class_id
  car_class_title
  wheel_diameter
  run_flat
  discount_percent
  booking_group_id
  order_id
  gross_amount
  discount_amount
  total_amount
  client {
    id
    type
    legal_name
    legal_tin
    legal_kpp
    legal_address
    contact_person
    contact_phone
    first_name
    last_name
    patronymic_name
    phone_masked
    discount
  }
  car {
    ...TireCarFields
  }
  car_details {
    mark
    model
    plate
  }
  lines {
    id
    catalog_item_id
    title
    kind
    price_rule
    quantity
    unit_price
    wheel_diameter
    run_flat
    amount
    storage_id
    storage {
      ...TireStorageSummaryFields
    }
  }
}
    ${TireCarFieldsFragmentDoc}
${TireStorageSummaryFieldsFragmentDoc}`;
export const TireServiceItemFieldsFragmentDoc = gql`
    fragment TireServiceItemFields on CatalogItem {
  id
  category_id
  title
  position
  price_rule
  fixed_price
  range_min
  range_max
  price_from
  tire_kind
  tire_prices(locationId: $locationId) {
    location_id
    car_class_id
    wheel_diameter
    run_flat
    price
  }
}
    `;
export const TireServiceSettingsFieldsFragmentDoc = gql`
    fragment TireServiceSettingsFields on TireServiceSettings {
  diameter_min
  diameter_max
  run_flat_enabled
  car_classes {
    id
    title
  }
  archived_car_classes {
    id
    title
  }
}
    `;
export const TireStorageWarehouseFieldsFragmentDoc = gql`
    fragment TireStorageWarehouseFields on TireStorageWarehouse {
  id
  title
  rack_count
  cell_count
  occupied_cells
  location_id
}
    `;
export const TireStoragePaidWorkOrderFieldsFragmentDoc = gql`
    fragment TireStoragePaidWorkOrderFields on TireWorkOrder {
  id
  number
  closed_at
  lines {
    id
    kind
    storage_id
    amount
    storage_until
  }
}
    `;
export const OrderFiscalOperationFieldsFragmentDoc = gql`
    fragment OrderFiscalOperationFields on OrderFiscalOperation {
  timezone
  id
  organization_id
  location_id
  order_id
  refund_id
  operation_type
  status
  acquiring_mode
  bank_payment_status
  kkm_command_status
  failure_kind
  error_code
  error_message
  warning_code
  payment_captured_at
  fiscal_drive_number_masked
  fiscal_document_number
  fiscal_document_sign
  shift_number
  receipt_number
  receipt_url
  fiscalized_at
  prepared_at
  started_at
  reconciliation_required_at
  failed_at
  completed_at
  receipt_kind
  receipt_confirmed_at
  return_command_id
  cash_amount
  workstation {
    id
    workstation_id
    name
  }
}
    `;
export const OrderFiscalReceiptItemFieldsFragmentDoc = gql`
    fragment OrderFiscalReceiptItemFields on OrderFiscalReceiptItem {
  order_line_id
  position
  title
  quantity
  unit_price
  amount
  vat_rate
  payment_method
  payment_subject
  marking_code
}
    `;
export const OrderFiscalExecutionFieldsFragmentDoc = gql`
    fragment OrderFiscalExecutionFields on OrderFiscalSettlementExecution {
  id_command
  payload_hash
  terminal_transaction_id
  next_action
  receipt_kind
  settled_at
  fiscal_scan_from
  same_fiscal_drive
  operation {
    ...OrderFiscalOperationFields
  }
  execution_target {
    timezone
    provider
    browser_workstation_id
    kkt_device_id
    terminal_device_id
    settings_version
    kkt_identity_hash
    terminal_identity_hash
  }
  receipt_plan {
    schema_version
    advance_amount
    operation_type
    cashier_name
    currency
    taxation_system
    total_amount
    loyalty_points
    contact {
      email
      phone
    }
    items {
      ...OrderFiscalReceiptItemFields
    }
    payments {
      method
      amount
      tendered_amount
      change_amount
      use_acquiring
      execution_order
    }
  }
}
    ${OrderFiscalOperationFieldsFragmentDoc}
${OrderFiscalReceiptItemFieldsFragmentDoc}`;
export const OrderFiscalRefundExecutionFieldsFragmentDoc = gql`
    fragment OrderFiscalRefundExecutionFields on OrderFiscalRefundExecution {
  id_command
  payload_hash
  next_action
  receipt_kind
  settled_at
  fiscal_scan_from
  same_fiscal_drive
  operation {
    ...OrderFiscalOperationFields
  }
  execution_target {
    timezone
    provider
    browser_workstation_id
    kkt_device_id
    terminal_device_id
    settings_version
    kkt_identity_hash
    terminal_identity_hash
  }
  receipt_plan {
    schema_version
    advance_amount
    operation_type
    cashier_name
    currency
    taxation_system
    total_amount
    items {
      ...OrderFiscalReceiptItemFields
    }
    payments {
      payment_id
      method
      amount
      use_acquiring
      execution_order
      original_rrn
      original_terminal_transaction_id
    }
  }
}
    ${OrderFiscalOperationFieldsFragmentDoc}
${OrderFiscalReceiptItemFieldsFragmentDoc}`;
export const OrganizationAddOnFieldsFragmentDoc = gql`
    fragment OrganizationAddOnFields on OrganizationAddOn {
  module
  status
}
    `;
export const RobokassaConnectionFieldsFragmentDoc = gql`
    fragment RobokassaConnectionFields on RobokassaConnection {
  id
  mode
  status
  merchant_login
  password1_mask
  password2_mask
  password3_mask
  test_password1_mask
  test_password2_mask
  hash_algorithm
  tax_system
  fiscal_scheme
  single_receipt_confirmed_at
  vat_payer
  result_url
  version
  readiness {
    payments
    refunds
    income_receipts
    reasons
    final_receipt_locations {
      id
      title
    }
  }
}
    `;
export const UnitUnavailabilityPayloadFieldsFragmentDoc = gql`
    fragment UnitUnavailabilityPayloadFields on UnitUnavailabilityMutationPayload {
  unit_unavailability {
    id
    unit_id
    start
    end
    reason
  }
  conflicts {
    booking_id
    group_id
    start
    end
    client_title
    service_title
  }
}
    `;
export const RadioTrackLoudnessFragmentFragmentDoc = gql`
    fragment RadioTrackLoudnessFragment on RadioTrack {
  id
  loudness_analysis_status
  normalization_gain_db
  loudness_analysis_version
}
    `;
export const RadioTrackFragmentFragmentDoc = gql`
    fragment RadioTrackFragment on RadioTrack {
  id
  title
  artist
  duration
  file_size
  url
  created_at
}
    `;
export const RadioPlaylistFragmentFragmentDoc = gql`
    fragment RadioPlaylistFragment on RadioPlaylist {
  id
  title
  is_default
  tracks {
    ...RadioTrackFragment
  }
  created_at
}
    ${RadioTrackFragmentFragmentDoc}`;
export const BusinessSettingsFieldsFragmentDoc = gql`
    fragment BusinessSettingsFields on BusinessSettings {
  id
  title
  sphere_id
  resource_term
  country_code
  currency
  timezone
  website_url
  facebook_url
  instagram_url
  vk_url
}
    `;
export const BusinessLocationShellFragmentDoc = gql`
    fragment BusinessLocationShell on BusinessLocation {
  id
  title
  alias
  city
  address
  full_address
  timezone
  opened_from
  closed_from
  business_status
}
    `;
export const BusinessLocationDetailsFieldsFragmentDoc = gql`
    fragment BusinessLocationDetailsFields on BusinessLocationDetails {
  title
  alias
  short_name
  color
  phone
  email
  legal_name
  legal_address
  legal_tin
  legal_ogrn
  legal_form
  legal_kpp
  legal_director_name
  bank_name
  bank_bik
  bank_correspondent_account
  bank_account
}
    `;
export const BusinessLocationAddressFieldsFragmentDoc = gql`
    fragment BusinessLocationAddressFields on BusinessLocationAddress {
  country_code
  country
  region
  city
  address
  street
  house
  floor
  room
  address_line
  full_address
  postal_code
  latitude
  longitude
}
    `;
export const BookingSettingsServiceMutationFieldsFragmentDoc = gql`
    fragment BookingSettingsServiceMutationFields on BookingSettingsService {
  id
  unit_ids
}
    `;
export const BookingSettingsConflictFieldsFragmentDoc = gql`
    fragment BookingSettingsConflictFields on UnitUnavailabilityBookingConflict {
  booking_id
  group_id
  start
  end
  client_title
  service_title
}
    `;
export const BookingSettingsUnitMutationFieldsFragmentDoc = gql`
    fragment BookingSettingsUnitMutationFields on BookingSettingsUnit {
  id
  title
  is_active
  active_unavailability {
    id
    unit_id
    start
    end
    reason
  }
}
    `;
export const LocationLifecycleFieldsFragmentDoc = gql`
    fragment LocationLifecycleFields on Location {
  id
  opened_from
  closed_from
}
    `;
export const CatalogItemFieldsFragmentDoc = gql`
    fragment CatalogItemFields on CatalogItem {
  id
  kind
  category_id
  title
  position
  price_rule
  fixed_price
  range_min
  range_max
  booking_min_duration_minutes
  booking_max_duration_minutes
  booking_slot_step_minutes
  booking_available_online
  archived
  price_from
  allowed_price_rules
  booking_allowed
  archive_allowed
  tariffs {
    id
    duration_minutes
    price
    available_online
    locations {
      location_id
      price
    }
  }
  locations {
    location_id
    price
  }
}
    `;
export const CatalogItemMutationPayloadFieldsFragmentDoc = gql`
    fragment CatalogItemMutationPayloadFields on CatalogItemMutationPayload {
  item {
    ...CatalogItemFields
  }
  conflicts {
    booking_id
    group_id
    start
    end
    client_title
    service_title
  }
}
    ${CatalogItemFieldsFragmentDoc}`;
export const SopSectionFragmentFragmentDoc = gql`
    fragment SopSectionFragment on SopSection {
  id
  name
  color
  description
  sops_count
  created_at
}
    `;
export const SopListFragmentFragmentDoc = gql`
    fragment SopListFragment on Sop {
  id
  title
  status
  current_version
  section {
    ...SopSectionFragment
  }
  creator {
    id
    user {
      first_name
      last_name
    }
  }
  updater {
    id
    user {
      first_name
      last_name
    }
  }
  published_at
  created_at
  updated_at
}
    ${SopSectionFragmentFragmentDoc}`;
export const SopVersionDetailFragmentFragmentDoc = gql`
    fragment SopVersionDetailFragment on SopVersion {
  id
  version_number
  title
  content
  change_summary
  creator {
    id
    user {
      first_name
      last_name
    }
  }
  created_at
}
    `;
export const SopPermissionFragmentFragmentDoc = gql`
    fragment SopPermissionFragment on SopPermissionType {
  id
  employee {
    id
    user {
      first_name
      last_name
    }
  }
  role {
    id
    name
  }
  access_level
}
    `;
export const SopDetailFragmentFragmentDoc = gql`
    fragment SopDetailFragment on Sop {
  id
  title
  content
  status
  current_version
  section {
    ...SopSectionFragment
  }
  versions {
    ...SopVersionDetailFragment
  }
  permissions {
    ...SopPermissionFragment
  }
  creator {
    id
    user {
      first_name
      last_name
    }
  }
  updater {
    id
    user {
      first_name
      last_name
    }
  }
  published_at
  created_at
  updated_at
}
    ${SopSectionFragmentFragmentDoc}
${SopVersionDetailFragmentFragmentDoc}
${SopPermissionFragmentFragmentDoc}`;
export const SopSearchFragmentFragmentDoc = gql`
    fragment SopSearchFragment on Sop {
  id
  title
  status
  search_highlight_title
  search_highlight_content
  section {
    id
    name
    color
  }
  updated_at
}
    `;
export const GetAnalyticsOverviewDocument = gql`
    query GetAnalyticsOverview($period: AnalyticsPeriodInput!, $locationId: ID) {
  analyticsOverview(period: $period, locationId: $locationId) {
    kpis {
      revenue_total
      orders_count
      avg_check
      visits_count
      new_clients_count
      utilization_percent
      available_unit_hours
    }
    kpis_comparable {
      revenue_total
      orders_count
      avg_check
      visits_count
      new_clients_count
      utilization_percent
      available_unit_hours
    }
    kpis_previous {
      revenue_total
      orders_count
      avg_check
      visits_count
      new_clients_count
      utilization_percent
      available_unit_hours
    }
    comparison {
      mode
      current_date_from
      current_date_to
      previous_date_from
      previous_date_to
      excluded_incomplete_day
      equal_length
    }
    locations {
      location_id
      title
      closed_from
      is_closed
      revenue_total
      revenue_comparable
      revenue_previous
      revenue_trend {
        date
        value
        is_partial
      }
      utilization_percent
      utilization_norm_percent
      utilization_deviation_percent
      utilization_days_below_norm
      utilization_days_compared
      utilization_norm_state
      utilization_norm_unavailable_reason
      utilization_norm_window_start
      utilization_norm_window_end
      revenue_per_unit_hour
      new_clients_count
    }
    revenue_series {
      date
      value
      is_partial
    }
    revenue_series_previous {
      date
      value
      is_partial
    }
    trend_granularity
    utilization_series {
      date
      utilization_percent
      available_unit_hours
      occupied_unit_hours
    }
    utilization_series_previous {
      date
      utilization_percent
      available_unit_hours
      occupied_unit_hours
    }
    top_services {
      catalog_item_id
      title
      revenue_total
      row_kind
    }
    new_client_sources {
      source_id
      title
      clients_count
      row_kind
    }
  }
}
    `;

/**
 * __useGetAnalyticsOverviewQuery__
 *
 * To run a query within a Vue component, call `useGetAnalyticsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsOverviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAnalyticsOverviewQuery({
 *   period: // value for 'period'
 *   locationId: // value for 'locationId'
 * });
 */
export function useGetAnalyticsOverviewQuery(variables: GetAnalyticsOverviewQueryVariables | VueCompositionApi.Ref<GetAnalyticsOverviewQueryVariables> | ReactiveFunction<GetAnalyticsOverviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables>(GetAnalyticsOverviewDocument, variables, options);
}
export function useGetAnalyticsOverviewLazyQuery(variables?: GetAnalyticsOverviewQueryVariables | VueCompositionApi.Ref<GetAnalyticsOverviewQueryVariables> | ReactiveFunction<GetAnalyticsOverviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables>(GetAnalyticsOverviewDocument, variables, options);
}
export type GetAnalyticsOverviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables>;
export const GetAnalyticsMetricDetailDocument = gql`
    query GetAnalyticsMetricDetail($period: AnalyticsPeriodInput!) {
  analyticsOverview(period: $period) {
    kpis {
      revenue_total
    }
    kpis_comparable {
      revenue_total
    }
    kpis_previous {
      revenue_total
    }
    comparison {
      mode
      current_date_from
      current_date_to
      previous_date_from
      previous_date_to
      excluded_incomplete_day
      equal_length
    }
    revenue_series {
      date
      value
      is_partial
    }
    trend_granularity
    locations {
      location_id
      title
      closed_from
      is_closed
      revenue_total
      revenue_series {
        date
        value
        is_partial
      }
    }
  }
}
    `;

/**
 * __useGetAnalyticsMetricDetailQuery__
 *
 * To run a query within a Vue component, call `useGetAnalyticsMetricDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsMetricDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAnalyticsMetricDetailQuery({
 *   period: // value for 'period'
 * });
 */
export function useGetAnalyticsMetricDetailQuery(variables: GetAnalyticsMetricDetailQueryVariables | VueCompositionApi.Ref<GetAnalyticsMetricDetailQueryVariables> | ReactiveFunction<GetAnalyticsMetricDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables>(GetAnalyticsMetricDetailDocument, variables, options);
}
export function useGetAnalyticsMetricDetailLazyQuery(variables?: GetAnalyticsMetricDetailQueryVariables | VueCompositionApi.Ref<GetAnalyticsMetricDetailQueryVariables> | ReactiveFunction<GetAnalyticsMetricDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables>(GetAnalyticsMetricDetailDocument, variables, options);
}
export type GetAnalyticsMetricDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAnalyticsMetricDetailQuery, GetAnalyticsMetricDetailQueryVariables>;
export const AuthContextDocument = gql`
    query AuthContext {
  authContext {
    user {
      id
      phone
      first_name
      last_name
      patronymic_name
      telegram_id
      is_super_user
    }
    employee {
      id
      title
      first_name
      last_name
      patronymic_name
      phone
      employee_id
      role_id
      status
      fired_at
      fired_reason
      created_at
      last_activity_at
      has_all_locations_access
      location_ids
      is_owner
    }
    organization {
      ...AuthOrganizationFragment
    }
    location {
      ...AuthLocationFragment
    }
    permissions
    available_organizations {
      ...AuthOrganizationFragment
    }
  }
  impersonationState {
    active
    session_id
    started_at
    impersonator {
      id
      phone
      first_name
      last_name
      patronymic_name
      is_super_user
    }
    target_user {
      id
      phone
      first_name
      last_name
      patronymic_name
      is_super_user
    }
    organization {
      id
      alias
      title
    }
  }
}
    ${AuthOrganizationFragmentFragmentDoc}
${AuthLocationFragmentFragmentDoc}`;

/**
 * __useAuthContextQuery__
 *
 * To run a query within a Vue component, call `useAuthContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAuthContextQuery();
 */
export function useAuthContextQuery(options: VueApolloComposable.UseQueryOptions<AuthContextQuery, AuthContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AuthContextQuery, AuthContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AuthContextQuery, AuthContextQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AuthContextQuery, AuthContextQueryVariables>(AuthContextDocument, {}, options);
}
export function useAuthContextLazyQuery(options: VueApolloComposable.UseQueryOptions<AuthContextQuery, AuthContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AuthContextQuery, AuthContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AuthContextQuery, AuthContextQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AuthContextQuery, AuthContextQueryVariables>(AuthContextDocument, {}, options);
}
export type AuthContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AuthContextQuery, AuthContextQueryVariables>;
export const GetBookingGroupAuditLogsDocument = gql`
    query GetBookingGroupAuditLogs($bookingGroupId: ID!, $first: Int!, $after: String) {
  bookingGroupAuditLogs(
    bookingGroupId: $bookingGroupId
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...BookingGroupAuditLog
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${BookingGroupAuditLogFragmentDoc}`;

/**
 * __useGetBookingGroupAuditLogsQuery__
 *
 * To run a query within a Vue component, call `useGetBookingGroupAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingGroupAuditLogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBookingGroupAuditLogsQuery({
 *   bookingGroupId: // value for 'bookingGroupId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetBookingGroupAuditLogsQuery(variables: GetBookingGroupAuditLogsQueryVariables | VueCompositionApi.Ref<GetBookingGroupAuditLogsQueryVariables> | ReactiveFunction<GetBookingGroupAuditLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables>(GetBookingGroupAuditLogsDocument, variables, options);
}
export function useGetBookingGroupAuditLogsLazyQuery(variables?: GetBookingGroupAuditLogsQueryVariables | VueCompositionApi.Ref<GetBookingGroupAuditLogsQueryVariables> | ReactiveFunction<GetBookingGroupAuditLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables>(GetBookingGroupAuditLogsDocument, variables, options);
}
export type GetBookingGroupAuditLogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBookingGroupAuditLogsQuery, GetBookingGroupAuditLogsQueryVariables>;
export const GetBookingClientProfileDocument = gql`
    query GetBookingClientProfile($clientId: ID!) {
  bookingClientProfile(clientId: $clientId) {
    client {
      ...BookingClientProfileClient
    }
    visits_count
    hours_total
    recent_bookings {
      ...BookingClientRecentBooking
    }
  }
}
    ${BookingClientProfileClientFragmentDoc}
${BookingClientRecentBookingFragmentDoc}`;

/**
 * __useGetBookingClientProfileQuery__
 *
 * To run a query within a Vue component, call `useGetBookingClientProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingClientProfileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBookingClientProfileQuery({
 *   clientId: // value for 'clientId'
 * });
 */
export function useGetBookingClientProfileQuery(variables: GetBookingClientProfileQueryVariables | VueCompositionApi.Ref<GetBookingClientProfileQueryVariables> | ReactiveFunction<GetBookingClientProfileQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables>(GetBookingClientProfileDocument, variables, options);
}
export function useGetBookingClientProfileLazyQuery(variables?: GetBookingClientProfileQueryVariables | VueCompositionApi.Ref<GetBookingClientProfileQueryVariables> | ReactiveFunction<GetBookingClientProfileQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables>(GetBookingClientProfileDocument, variables, options);
}
export type GetBookingClientProfileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBookingClientProfileQuery, GetBookingClientProfileQueryVariables>;
export const GetBookingSettingsDocument = gql`
    query GetBookingSettings($locationId: ID) {
  locationSchedule(locationId: $locationId) {
    current {
      day_of_week
      is_day_off
      start
      end
      closes_next_day
      effective_from
    }
    upcoming {
      day_of_week
      is_day_off
      start
      end
      closes_next_day
      effective_from
    }
  }
  bookingSettingsServices(locationId: $locationId) {
    id
    unit_ids
  }
  bookingSettingsUnits(locationId: $locationId) {
    id
    title
    is_active
    active_unavailability {
      id
      unit_id
      start
      end
      reason
    }
  }
}
    `;

/**
 * __useGetBookingSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetBookingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBookingSettingsQuery({
 *   locationId: // value for 'locationId'
 * });
 */
export function useGetBookingSettingsQuery(variables: GetBookingSettingsQueryVariables | VueCompositionApi.Ref<GetBookingSettingsQueryVariables> | ReactiveFunction<GetBookingSettingsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetBookingSettingsQuery, GetBookingSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingSettingsQuery, GetBookingSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingSettingsQuery, GetBookingSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBookingSettingsQuery, GetBookingSettingsQueryVariables>(GetBookingSettingsDocument, variables, options);
}
export function useGetBookingSettingsLazyQuery(variables: GetBookingSettingsQueryVariables | VueCompositionApi.Ref<GetBookingSettingsQueryVariables> | ReactiveFunction<GetBookingSettingsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetBookingSettingsQuery, GetBookingSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingSettingsQuery, GetBookingSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingSettingsQuery, GetBookingSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBookingSettingsQuery, GetBookingSettingsQueryVariables>(GetBookingSettingsDocument, variables, options);
}
export type GetBookingSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBookingSettingsQuery, GetBookingSettingsQueryVariables>;
export const GetBookingScheduleDocument = gql`
    query GetBookingSchedule($start: Date!, $end: Date!) {
  bookingSchedule(start: $start, end: $end) {
    unit_id
    unit_title
    index
    is_active
    is_deleted
    schedule {
      type
      start
      end
      reason
      unavailability {
        id
        unit_id
        start
        end
        reason
      }
      booking_details {
        booking_id
        group_id
        unit_id
        status
        payment_status
        payment_delegation
        catalog_item_id
        catalog_tariff_id
        tariff_price
        tariff_duration
        service_title
        note
        discount
        subtotal_price
        price
        client_summary {
          id
          title
          first_name
          last_name
          patronymic_name
          phone
          importance
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingScheduleQuery__
 *
 * To run a query within a Vue component, call `useGetBookingScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingScheduleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBookingScheduleQuery({
 *   start: // value for 'start'
 *   end: // value for 'end'
 * });
 */
export function useGetBookingScheduleQuery(variables: GetBookingScheduleQueryVariables | VueCompositionApi.Ref<GetBookingScheduleQueryVariables> | ReactiveFunction<GetBookingScheduleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBookingScheduleQuery, GetBookingScheduleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingScheduleQuery, GetBookingScheduleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingScheduleQuery, GetBookingScheduleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBookingScheduleQuery, GetBookingScheduleQueryVariables>(GetBookingScheduleDocument, variables, options);
}
export function useGetBookingScheduleLazyQuery(variables?: GetBookingScheduleQueryVariables | VueCompositionApi.Ref<GetBookingScheduleQueryVariables> | ReactiveFunction<GetBookingScheduleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBookingScheduleQuery, GetBookingScheduleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingScheduleQuery, GetBookingScheduleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingScheduleQuery, GetBookingScheduleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBookingScheduleQuery, GetBookingScheduleQueryVariables>(GetBookingScheduleDocument, variables, options);
}
export type GetBookingScheduleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBookingScheduleQuery, GetBookingScheduleQueryVariables>;
export const GetBookingServiceCatalogDocument = gql`
    query GetBookingServiceCatalog {
  bookingServiceCatalog {
    id
    title
    price_rule
    price
    min_duration_minutes
    max_duration_minutes
    slot_step_minutes
    tariffs {
      id
      duration_minutes
      price
      available_online
    }
    unit_ids
  }
}
    `;

/**
 * __useGetBookingServiceCatalogQuery__
 *
 * To run a query within a Vue component, call `useGetBookingServiceCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingServiceCatalogQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBookingServiceCatalogQuery();
 */
export function useGetBookingServiceCatalogQuery(options: VueApolloComposable.UseQueryOptions<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables>(GetBookingServiceCatalogDocument, {}, options);
}
export function useGetBookingServiceCatalogLazyQuery(options: VueApolloComposable.UseQueryOptions<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables>(GetBookingServiceCatalogDocument, {}, options);
}
export type GetBookingServiceCatalogQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBookingServiceCatalogQuery, GetBookingServiceCatalogQueryVariables>;
export const GetUnitUnavailabilitiesDocument = gql`
    query GetUnitUnavailabilities($unitId: ID, $activeOrFuture: Boolean = true) {
  unitUnavailabilities(unitId: $unitId, activeOrFuture: $activeOrFuture) {
    data {
      id
      unit_id
      start
      end
      reason
    }
  }
}
    `;

/**
 * __useGetUnitUnavailabilitiesQuery__
 *
 * To run a query within a Vue component, call `useGetUnitUnavailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitUnavailabilitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUnitUnavailabilitiesQuery({
 *   unitId: // value for 'unitId'
 *   activeOrFuture: // value for 'activeOrFuture'
 * });
 */
export function useGetUnitUnavailabilitiesQuery(variables: GetUnitUnavailabilitiesQueryVariables | VueCompositionApi.Ref<GetUnitUnavailabilitiesQueryVariables> | ReactiveFunction<GetUnitUnavailabilitiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables>(GetUnitUnavailabilitiesDocument, variables, options);
}
export function useGetUnitUnavailabilitiesLazyQuery(variables: GetUnitUnavailabilitiesQueryVariables | VueCompositionApi.Ref<GetUnitUnavailabilitiesQueryVariables> | ReactiveFunction<GetUnitUnavailabilitiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables>(GetUnitUnavailabilitiesDocument, variables, options);
}
export type GetUnitUnavailabilitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUnitUnavailabilitiesQuery, GetUnitUnavailabilitiesQueryVariables>;
export const GetMarketingBroadcastsDocument = gql`
    query GetMarketingBroadcasts($first: Int!, $after: String) {
  marketingBroadcasts(first: $first, after: $after) {
    edges {
      cursor
      node {
        ...BroadcastFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${BroadcastFieldsFragmentDoc}`;

/**
 * __useGetMarketingBroadcastsQuery__
 *
 * To run a query within a Vue component, call `useGetMarketingBroadcastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingBroadcastsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMarketingBroadcastsQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetMarketingBroadcastsQuery(variables: GetMarketingBroadcastsQueryVariables | VueCompositionApi.Ref<GetMarketingBroadcastsQueryVariables> | ReactiveFunction<GetMarketingBroadcastsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables>(GetMarketingBroadcastsDocument, variables, options);
}
export function useGetMarketingBroadcastsLazyQuery(variables?: GetMarketingBroadcastsQueryVariables | VueCompositionApi.Ref<GetMarketingBroadcastsQueryVariables> | ReactiveFunction<GetMarketingBroadcastsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables>(GetMarketingBroadcastsDocument, variables, options);
}
export type GetMarketingBroadcastsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMarketingBroadcastsQuery, GetMarketingBroadcastsQueryVariables>;
export const GetMarketingBroadcastDocument = gql`
    query GetMarketingBroadcast($id: ID!) {
  marketingBroadcast(id: $id) {
    ...BroadcastFields
  }
}
    ${BroadcastFieldsFragmentDoc}`;

/**
 * __useGetMarketingBroadcastQuery__
 *
 * To run a query within a Vue component, call `useGetMarketingBroadcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingBroadcastQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMarketingBroadcastQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMarketingBroadcastQuery(variables: GetMarketingBroadcastQueryVariables | VueCompositionApi.Ref<GetMarketingBroadcastQueryVariables> | ReactiveFunction<GetMarketingBroadcastQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables>(GetMarketingBroadcastDocument, variables, options);
}
export function useGetMarketingBroadcastLazyQuery(variables?: GetMarketingBroadcastQueryVariables | VueCompositionApi.Ref<GetMarketingBroadcastQueryVariables> | ReactiveFunction<GetMarketingBroadcastQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables>(GetMarketingBroadcastDocument, variables, options);
}
export type GetMarketingBroadcastQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMarketingBroadcastQuery, GetMarketingBroadcastQueryVariables>;
export const GetMarketingBroadcastAudienceEnabledDocument = gql`
    query GetMarketingBroadcastAudienceEnabled {
  marketingBroadcastAudienceEnabled
}
    `;

/**
 * __useGetMarketingBroadcastAudienceEnabledQuery__
 *
 * To run a query within a Vue component, call `useGetMarketingBroadcastAudienceEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingBroadcastAudienceEnabledQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMarketingBroadcastAudienceEnabledQuery();
 */
export function useGetMarketingBroadcastAudienceEnabledQuery(options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables>(GetMarketingBroadcastAudienceEnabledDocument, {}, options);
}
export function useGetMarketingBroadcastAudienceEnabledLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables>(GetMarketingBroadcastAudienceEnabledDocument, {}, options);
}
export type GetMarketingBroadcastAudienceEnabledQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMarketingBroadcastAudienceEnabledQuery, GetMarketingBroadcastAudienceEnabledQueryVariables>;
export const GetBroadcastExclusionsDocument = gql`
    query GetBroadcastExclusions($first: Int!, $after: String, $search: String, $excludeId: ID) {
  marketingBroadcasts(
    first: $first
    after: $after
    search: $search
    startedOnly: true
    excludeId: $excludeId
  ) {
    edges {
      node {
        id
        name
        started_at
        status
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    `;

/**
 * __useGetBroadcastExclusionsQuery__
 *
 * To run a query within a Vue component, call `useGetBroadcastExclusionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastExclusionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBroadcastExclusionsQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   search: // value for 'search'
 *   excludeId: // value for 'excludeId'
 * });
 */
export function useGetBroadcastExclusionsQuery(variables: GetBroadcastExclusionsQueryVariables | VueCompositionApi.Ref<GetBroadcastExclusionsQueryVariables> | ReactiveFunction<GetBroadcastExclusionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables>(GetBroadcastExclusionsDocument, variables, options);
}
export function useGetBroadcastExclusionsLazyQuery(variables?: GetBroadcastExclusionsQueryVariables | VueCompositionApi.Ref<GetBroadcastExclusionsQueryVariables> | ReactiveFunction<GetBroadcastExclusionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables>(GetBroadcastExclusionsDocument, variables, options);
}
export type GetBroadcastExclusionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBroadcastExclusionsQuery, GetBroadcastExclusionsQueryVariables>;
export const GetMarketingBroadcastAudienceEntriesDocument = gql`
    query GetMarketingBroadcastAudienceEntries($broadcastId: ID!, $snapshotId: ID!, $first: Int!, $after: String, $decision: BroadcastAudienceEntryDecision, $status: MarketingBroadcastRecipientStatus, $search: String) {
  marketingBroadcastAudienceEntries(
    broadcastId: $broadcastId
    snapshotId: $snapshotId
    first: $first
    after: $after
    decision: $decision
    status: $status
    search: $search
  ) {
    edges {
      node {
        id
        client_id
        conversation_id
        channel_id
        external_chat_id
        recipient_name
        recipient_username
        channel_label
        client {
          id
          phone_masked
        }
        decision
        unavailable_reason
        inclusion_reasons {
          rule_id
          kind
          months
          from_at
          to_at
          last_booking_at
          broadcast_id
          broadcast_name
        }
        exclusion_reasons {
          rule_id
          kind
          months
          from_at
          to_at
          last_booking_at
          broadcast_id
          broadcast_name
        }
        delivery {
          ...BroadcastDeliveryFields
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${BroadcastDeliveryFieldsFragmentDoc}`;

/**
 * __useGetMarketingBroadcastAudienceEntriesQuery__
 *
 * To run a query within a Vue component, call `useGetMarketingBroadcastAudienceEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingBroadcastAudienceEntriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMarketingBroadcastAudienceEntriesQuery({
 *   broadcastId: // value for 'broadcastId'
 *   snapshotId: // value for 'snapshotId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   decision: // value for 'decision'
 *   status: // value for 'status'
 *   search: // value for 'search'
 * });
 */
export function useGetMarketingBroadcastAudienceEntriesQuery(variables: GetMarketingBroadcastAudienceEntriesQueryVariables | VueCompositionApi.Ref<GetMarketingBroadcastAudienceEntriesQueryVariables> | ReactiveFunction<GetMarketingBroadcastAudienceEntriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables>(GetMarketingBroadcastAudienceEntriesDocument, variables, options);
}
export function useGetMarketingBroadcastAudienceEntriesLazyQuery(variables?: GetMarketingBroadcastAudienceEntriesQueryVariables | VueCompositionApi.Ref<GetMarketingBroadcastAudienceEntriesQueryVariables> | ReactiveFunction<GetMarketingBroadcastAudienceEntriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables>(GetMarketingBroadcastAudienceEntriesDocument, variables, options);
}
export type GetMarketingBroadcastAudienceEntriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMarketingBroadcastAudienceEntriesQuery, GetMarketingBroadcastAudienceEntriesQueryVariables>;
export const GetMarketingBroadcastTestRecipientsDocument = gql`
    query GetMarketingBroadcastTestRecipients {
  marketingBroadcastTestRecipients {
    client_id
    conversation_id
    channel_id
    channel_title
    client {
      id
      first_name
      last_name
      patronymic_name
      phone_masked
    }
  }
}
    `;

/**
 * __useGetMarketingBroadcastTestRecipientsQuery__
 *
 * To run a query within a Vue component, call `useGetMarketingBroadcastTestRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingBroadcastTestRecipientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMarketingBroadcastTestRecipientsQuery();
 */
export function useGetMarketingBroadcastTestRecipientsQuery(options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables>(GetMarketingBroadcastTestRecipientsDocument, {}, options);
}
export function useGetMarketingBroadcastTestRecipientsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables>(GetMarketingBroadcastTestRecipientsDocument, {}, options);
}
export type GetMarketingBroadcastTestRecipientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMarketingBroadcastTestRecipientsQuery, GetMarketingBroadcastTestRecipientsQueryVariables>;
export const GetMarketingBroadcastTestDeliveryDocument = gql`
    query GetMarketingBroadcastTestDelivery($broadcastId: ID!, $messageId: ID!) {
  marketingBroadcastTestDelivery(broadcastId: $broadcastId, messageId: $messageId) {
    message_id
    status
    failed_reason
  }
}
    `;

/**
 * __useGetMarketingBroadcastTestDeliveryQuery__
 *
 * To run a query within a Vue component, call `useGetMarketingBroadcastTestDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingBroadcastTestDeliveryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMarketingBroadcastTestDeliveryQuery({
 *   broadcastId: // value for 'broadcastId'
 *   messageId: // value for 'messageId'
 * });
 */
export function useGetMarketingBroadcastTestDeliveryQuery(variables: GetMarketingBroadcastTestDeliveryQueryVariables | VueCompositionApi.Ref<GetMarketingBroadcastTestDeliveryQueryVariables> | ReactiveFunction<GetMarketingBroadcastTestDeliveryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables>(GetMarketingBroadcastTestDeliveryDocument, variables, options);
}
export function useGetMarketingBroadcastTestDeliveryLazyQuery(variables?: GetMarketingBroadcastTestDeliveryQueryVariables | VueCompositionApi.Ref<GetMarketingBroadcastTestDeliveryQueryVariables> | ReactiveFunction<GetMarketingBroadcastTestDeliveryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables>(GetMarketingBroadcastTestDeliveryDocument, variables, options);
}
export type GetMarketingBroadcastTestDeliveryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMarketingBroadcastTestDeliveryQuery, GetMarketingBroadcastTestDeliveryQueryVariables>;
export const GetCatalogCategoriesDocument = gql`
    query GetCatalogCategories {
  catalogCategories {
    id
    title
    position
  }
}
    `;

/**
 * __useGetCatalogCategoriesQuery__
 *
 * To run a query within a Vue component, call `useGetCatalogCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCatalogCategoriesQuery();
 */
export function useGetCatalogCategoriesQuery(options: VueApolloComposable.UseQueryOptions<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables>(GetCatalogCategoriesDocument, {}, options);
}
export function useGetCatalogCategoriesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables>(GetCatalogCategoriesDocument, {}, options);
}
export type GetCatalogCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables>;
export const GetCatalogItemsDocument = gql`
    query GetCatalogItems($kind: CatalogItemKind, $includeArchived: Boolean) {
  catalogItems(kind: $kind, includeArchived: $includeArchived) {
    ...CatalogItemFields
  }
}
    ${CatalogItemFieldsFragmentDoc}`;

/**
 * __useGetCatalogItemsQuery__
 *
 * To run a query within a Vue component, call `useGetCatalogItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCatalogItemsQuery({
 *   kind: // value for 'kind'
 *   includeArchived: // value for 'includeArchived'
 * });
 */
export function useGetCatalogItemsQuery(variables: GetCatalogItemsQueryVariables | VueCompositionApi.Ref<GetCatalogItemsQueryVariables> | ReactiveFunction<GetCatalogItemsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetCatalogItemsQuery, GetCatalogItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>(GetCatalogItemsDocument, variables, options);
}
export function useGetCatalogItemsLazyQuery(variables: GetCatalogItemsQueryVariables | VueCompositionApi.Ref<GetCatalogItemsQueryVariables> | ReactiveFunction<GetCatalogItemsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetCatalogItemsQuery, GetCatalogItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>(GetCatalogItemsDocument, variables, options);
}
export type GetCatalogItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCatalogItemsQuery, GetCatalogItemsQueryVariables>;
export const GetClientAutomationsDocument = gql`
    query GetClientAutomations {
  clientAutomations {
    ...ClientAutomationFields
  }
}
    ${ClientAutomationFieldsFragmentDoc}`;

/**
 * __useGetClientAutomationsQuery__
 *
 * To run a query within a Vue component, call `useGetClientAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAutomationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientAutomationsQuery();
 */
export function useGetClientAutomationsQuery(options: VueApolloComposable.UseQueryOptions<GetClientAutomationsQuery, GetClientAutomationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientAutomationsQuery, GetClientAutomationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientAutomationsQuery, GetClientAutomationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientAutomationsQuery, GetClientAutomationsQueryVariables>(GetClientAutomationsDocument, {}, options);
}
export function useGetClientAutomationsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetClientAutomationsQuery, GetClientAutomationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientAutomationsQuery, GetClientAutomationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientAutomationsQuery, GetClientAutomationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientAutomationsQuery, GetClientAutomationsQueryVariables>(GetClientAutomationsDocument, {}, options);
}
export type GetClientAutomationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientAutomationsQuery, GetClientAutomationsQueryVariables>;
export const GetClientQuietHoursDocument = gql`
    query GetClientQuietHours {
  clientQuietHours {
    enabled
    start
    end
  }
}
    `;

/**
 * __useGetClientQuietHoursQuery__
 *
 * To run a query within a Vue component, call `useGetClientQuietHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuietHoursQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientQuietHoursQuery();
 */
export function useGetClientQuietHoursQuery(options: VueApolloComposable.UseQueryOptions<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables>(GetClientQuietHoursDocument, {}, options);
}
export function useGetClientQuietHoursLazyQuery(options: VueApolloComposable.UseQueryOptions<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables>(GetClientQuietHoursDocument, {}, options);
}
export type GetClientQuietHoursQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientQuietHoursQuery, GetClientQuietHoursQueryVariables>;
export const GetClientAutomationStatisticsDocument = gql`
    query GetClientAutomationStatistics($kind: ClientAutomationKind!, $id: ID, $dateFrom: Date!, $dateTo: Date!) {
  clientAutomationStatistics(
    kind: $kind
    id: $id
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    dates
    totals {
      sent
      delivered
      failed
    }
    by_channel {
      provider
      sent
      delivered
      failed
    }
    series {
      provider
      values
    }
  }
}
    `;

/**
 * __useGetClientAutomationStatisticsQuery__
 *
 * To run a query within a Vue component, call `useGetClientAutomationStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAutomationStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientAutomationStatisticsQuery({
 *   kind: // value for 'kind'
 *   id: // value for 'id'
 *   dateFrom: // value for 'dateFrom'
 *   dateTo: // value for 'dateTo'
 * });
 */
export function useGetClientAutomationStatisticsQuery(variables: GetClientAutomationStatisticsQueryVariables | VueCompositionApi.Ref<GetClientAutomationStatisticsQueryVariables> | ReactiveFunction<GetClientAutomationStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables>(GetClientAutomationStatisticsDocument, variables, options);
}
export function useGetClientAutomationStatisticsLazyQuery(variables?: GetClientAutomationStatisticsQueryVariables | VueCompositionApi.Ref<GetClientAutomationStatisticsQueryVariables> | ReactiveFunction<GetClientAutomationStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables>(GetClientAutomationStatisticsDocument, variables, options);
}
export type GetClientAutomationStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientAutomationStatisticsQuery, GetClientAutomationStatisticsQueryVariables>;
export const GetClientAutomationSampleDocument = gql`
    query GetClientAutomationSample {
  clientAutomationSample {
    date
    time
    services
    location
    address
    booking_link
  }
}
    `;

/**
 * __useGetClientAutomationSampleQuery__
 *
 * To run a query within a Vue component, call `useGetClientAutomationSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAutomationSampleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientAutomationSampleQuery();
 */
export function useGetClientAutomationSampleQuery(options: VueApolloComposable.UseQueryOptions<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables>(GetClientAutomationSampleDocument, {}, options);
}
export function useGetClientAutomationSampleLazyQuery(options: VueApolloComposable.UseQueryOptions<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables>(GetClientAutomationSampleDocument, {}, options);
}
export type GetClientAutomationSampleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientAutomationSampleQuery, GetClientAutomationSampleQueryVariables>;
export const GetClientAutomationTestRecipientsDocument = gql`
    query GetClientAutomationTestRecipients {
  clientAutomationTestRecipients {
    client_id
    conversation_id
    channel_id
    channel_title
    client {
      id
      first_name
      last_name
      patronymic_name
    }
  }
}
    `;

/**
 * __useGetClientAutomationTestRecipientsQuery__
 *
 * To run a query within a Vue component, call `useGetClientAutomationTestRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAutomationTestRecipientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientAutomationTestRecipientsQuery();
 */
export function useGetClientAutomationTestRecipientsQuery(options: VueApolloComposable.UseQueryOptions<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables>(GetClientAutomationTestRecipientsDocument, {}, options);
}
export function useGetClientAutomationTestRecipientsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables>(GetClientAutomationTestRecipientsDocument, {}, options);
}
export type GetClientAutomationTestRecipientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientAutomationTestRecipientsQuery, GetClientAutomationTestRecipientsQueryVariables>;
export const GetClientSegmentsDocument = gql`
    query GetClientSegments {
  clientSegments {
    ...ClientSegmentFields
  }
}
    ${ClientSegmentFieldsFragmentDoc}`;

/**
 * __useGetClientSegmentsQuery__
 *
 * To run a query within a Vue component, call `useGetClientSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSegmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientSegmentsQuery();
 */
export function useGetClientSegmentsQuery(options: VueApolloComposable.UseQueryOptions<GetClientSegmentsQuery, GetClientSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientSegmentsQuery, GetClientSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientSegmentsQuery, GetClientSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientSegmentsQuery, GetClientSegmentsQueryVariables>(GetClientSegmentsDocument, {}, options);
}
export function useGetClientSegmentsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetClientSegmentsQuery, GetClientSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientSegmentsQuery, GetClientSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientSegmentsQuery, GetClientSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientSegmentsQuery, GetClientSegmentsQueryVariables>(GetClientSegmentsDocument, {}, options);
}
export type GetClientSegmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientSegmentsQuery, GetClientSegmentsQueryVariables>;
export const GetClientSegmentPreviewDocument = gql`
    query GetClientSegmentPreview($rules: [ClientSegmentRuleInput!]!) {
  clientSegmentPreview(rules: $rules) {
    clients_count
  }
}
    `;

/**
 * __useGetClientSegmentPreviewQuery__
 *
 * To run a query within a Vue component, call `useGetClientSegmentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSegmentPreviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientSegmentPreviewQuery({
 *   rules: // value for 'rules'
 * });
 */
export function useGetClientSegmentPreviewQuery(variables: GetClientSegmentPreviewQueryVariables | VueCompositionApi.Ref<GetClientSegmentPreviewQueryVariables> | ReactiveFunction<GetClientSegmentPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables>(GetClientSegmentPreviewDocument, variables, options);
}
export function useGetClientSegmentPreviewLazyQuery(variables?: GetClientSegmentPreviewQueryVariables | VueCompositionApi.Ref<GetClientSegmentPreviewQueryVariables> | ReactiveFunction<GetClientSegmentPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables>(GetClientSegmentPreviewDocument, variables, options);
}
export type GetClientSegmentPreviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientSegmentPreviewQuery, GetClientSegmentPreviewQueryVariables>;
export const GetClientsDocument = gql`
    query GetClients($searchQuery: String, $first: Int!, $after: String, $orderBy: ClientOrderByField, $sortOrder: SortOrder, $segmentIds: [ID!], $marketingSourceIds: [ID!], $firstVisitLocationIds: [ID!], $lastVisitLocationIds: [ID!], $type: ClientType) {
  clients(
    searchQuery: $searchQuery
    first: $first
    after: $after
    orderBy: $orderBy
    sortOrder: $sortOrder
    segmentIds: $segmentIds
    marketingSourceIds: $marketingSourceIds
    firstVisitLocationIds: $firstVisitLocationIds
    lastVisitLocationIds: $lastVisitLocationIds
    type: $type
  ) {
    edges {
      cursor
      node {
        ...ClientWithLocations
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${ClientWithLocationsFragmentDoc}`;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a Vue component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientsQuery({
 *   searchQuery: // value for 'searchQuery'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   orderBy: // value for 'orderBy'
 *   sortOrder: // value for 'sortOrder'
 *   segmentIds: // value for 'segmentIds'
 *   marketingSourceIds: // value for 'marketingSourceIds'
 *   firstVisitLocationIds: // value for 'firstVisitLocationIds'
 *   lastVisitLocationIds: // value for 'lastVisitLocationIds'
 *   type: // value for 'type'
 * });
 */
export function useGetClientsQuery(variables: GetClientsQueryVariables | VueCompositionApi.Ref<GetClientsQueryVariables> | ReactiveFunction<GetClientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientsQuery, GetClientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientsQuery, GetClientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientsQuery, GetClientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, variables, options);
}
export function useGetClientsLazyQuery(variables?: GetClientsQueryVariables | VueCompositionApi.Ref<GetClientsQueryVariables> | ReactiveFunction<GetClientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientsQuery, GetClientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientsQuery, GetClientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientsQuery, GetClientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, variables, options);
}
export type GetClientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientsQuery, GetClientsQueryVariables>;
export const GetClientDocument = gql`
    query GetClient($id: ID!) {
  client(id: $id) {
    ...ClientWithLocations
  }
}
    ${ClientWithLocationsFragmentDoc}`;

/**
 * __useGetClientQuery__
 *
 * To run a query within a Vue component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetClientQuery(variables: GetClientQueryVariables | VueCompositionApi.Ref<GetClientQueryVariables> | ReactiveFunction<GetClientQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientQuery, GetClientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientQuery, GetClientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientQuery, GetClientQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, variables, options);
}
export function useGetClientLazyQuery(variables?: GetClientQueryVariables | VueCompositionApi.Ref<GetClientQueryVariables> | ReactiveFunction<GetClientQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientQuery, GetClientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientQuery, GetClientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientQuery, GetClientQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, variables, options);
}
export type GetClientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientQuery, GetClientQueryVariables>;
export const GetBookingClientsDocument = gql`
    query GetBookingClients($searchQuery: String, $first: Int!, $after: String, $type: ClientType) {
  clients(searchQuery: $searchQuery, first: $first, after: $after, type: $type) {
    edges {
      cursor
      node {
        ...BookingClientOption
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${BookingClientOptionFragmentDoc}`;

/**
 * __useGetBookingClientsQuery__
 *
 * To run a query within a Vue component, call `useGetBookingClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingClientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBookingClientsQuery({
 *   searchQuery: // value for 'searchQuery'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   type: // value for 'type'
 * });
 */
export function useGetBookingClientsQuery(variables: GetBookingClientsQueryVariables | VueCompositionApi.Ref<GetBookingClientsQueryVariables> | ReactiveFunction<GetBookingClientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBookingClientsQuery, GetBookingClientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingClientsQuery, GetBookingClientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingClientsQuery, GetBookingClientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBookingClientsQuery, GetBookingClientsQueryVariables>(GetBookingClientsDocument, variables, options);
}
export function useGetBookingClientsLazyQuery(variables?: GetBookingClientsQueryVariables | VueCompositionApi.Ref<GetBookingClientsQueryVariables> | ReactiveFunction<GetBookingClientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBookingClientsQuery, GetBookingClientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBookingClientsQuery, GetBookingClientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBookingClientsQuery, GetBookingClientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBookingClientsQuery, GetBookingClientsQueryVariables>(GetBookingClientsDocument, variables, options);
}
export type GetBookingClientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBookingClientsQuery, GetBookingClientsQueryVariables>;
export const GetClientWithStatisticsDocument = gql`
    query GetClientWithStatistics($id: ID!) {
  client(id: $id) {
    ...ClientWithLocations
    segment_badges {
      id
      name
      badge_color
    }
    statistics_by_location {
      location_id
      location_name
      visits_count
      hours_total
      first_visit_at
      last_visit_at
    }
  }
}
    ${ClientWithLocationsFragmentDoc}`;

/**
 * __useGetClientWithStatisticsQuery__
 *
 * To run a query within a Vue component, call `useGetClientWithStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientWithStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientWithStatisticsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetClientWithStatisticsQuery(variables: GetClientWithStatisticsQueryVariables | VueCompositionApi.Ref<GetClientWithStatisticsQueryVariables> | ReactiveFunction<GetClientWithStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables>(GetClientWithStatisticsDocument, variables, options);
}
export function useGetClientWithStatisticsLazyQuery(variables?: GetClientWithStatisticsQueryVariables | VueCompositionApi.Ref<GetClientWithStatisticsQueryVariables> | ReactiveFunction<GetClientWithStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables>(GetClientWithStatisticsDocument, variables, options);
}
export type GetClientWithStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientWithStatisticsQuery, GetClientWithStatisticsQueryVariables>;
export const RevealClientPhoneDocument = gql`
    query RevealClientPhone($id: ID!) {
  revealClientPhone(id: $id)
}
    `;

/**
 * __useRevealClientPhoneQuery__
 *
 * To run a query within a Vue component, call `useRevealClientPhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevealClientPhoneQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRevealClientPhoneQuery({
 *   id: // value for 'id'
 * });
 */
export function useRevealClientPhoneQuery(variables: RevealClientPhoneQueryVariables | VueCompositionApi.Ref<RevealClientPhoneQueryVariables> | ReactiveFunction<RevealClientPhoneQueryVariables>, options: VueApolloComposable.UseQueryOptions<RevealClientPhoneQuery, RevealClientPhoneQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RevealClientPhoneQuery, RevealClientPhoneQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RevealClientPhoneQuery, RevealClientPhoneQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RevealClientPhoneQuery, RevealClientPhoneQueryVariables>(RevealClientPhoneDocument, variables, options);
}
export function useRevealClientPhoneLazyQuery(variables?: RevealClientPhoneQueryVariables | VueCompositionApi.Ref<RevealClientPhoneQueryVariables> | ReactiveFunction<RevealClientPhoneQueryVariables>, options: VueApolloComposable.UseQueryOptions<RevealClientPhoneQuery, RevealClientPhoneQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RevealClientPhoneQuery, RevealClientPhoneQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RevealClientPhoneQuery, RevealClientPhoneQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RevealClientPhoneQuery, RevealClientPhoneQueryVariables>(RevealClientPhoneDocument, variables, options);
}
export type RevealClientPhoneQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RevealClientPhoneQuery, RevealClientPhoneQueryVariables>;
export const GetOrderFiscalizationSetupDocument = gql`
    query GetOrderFiscalizationSetup($locationId: ID!) {
  orderFiscalizationReadiness(locationId: $locationId) {
    ...OrderFiscalizationReadinessFields
  }
}
    ${OrderFiscalizationReadinessFieldsFragmentDoc}`;

/**
 * __useGetOrderFiscalizationSetupQuery__
 *
 * To run a query within a Vue component, call `useGetOrderFiscalizationSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderFiscalizationSetupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderFiscalizationSetupQuery({
 *   locationId: // value for 'locationId'
 * });
 */
export function useGetOrderFiscalizationSetupQuery(variables: GetOrderFiscalizationSetupQueryVariables | VueCompositionApi.Ref<GetOrderFiscalizationSetupQueryVariables> | ReactiveFunction<GetOrderFiscalizationSetupQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables>(GetOrderFiscalizationSetupDocument, variables, options);
}
export function useGetOrderFiscalizationSetupLazyQuery(variables?: GetOrderFiscalizationSetupQueryVariables | VueCompositionApi.Ref<GetOrderFiscalizationSetupQueryVariables> | ReactiveFunction<GetOrderFiscalizationSetupQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables>(GetOrderFiscalizationSetupDocument, variables, options);
}
export type GetOrderFiscalizationSetupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderFiscalizationSetupQuery, GetOrderFiscalizationSetupQueryVariables>;
export const GetOrderRefundContextDocument = gql`
    query GetOrderRefundContext($orderId: ID!) {
  orderRefundContext(orderId: $orderId) {
    online_payments {
      money_part_id
      fiscal_scheme
    }
    online_refunds {
      id
      payment_id
      amount
      status
    }
    fiscalization_required
    cashier_display_name
    allowed_payment_methods
    shift_required
    shift_state
    shift_blocker_reason
    shift_expires_at
    approval_required
    approval_status
    approval_expires_at
    manual_bank_reference_required
    expected_kkt_device_id
  }
}
    `;

/**
 * __useGetOrderRefundContextQuery__
 *
 * To run a query within a Vue component, call `useGetOrderRefundContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderRefundContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderRefundContextQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetOrderRefundContextQuery(variables: GetOrderRefundContextQueryVariables | VueCompositionApi.Ref<GetOrderRefundContextQueryVariables> | ReactiveFunction<GetOrderRefundContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables>(GetOrderRefundContextDocument, variables, options);
}
export function useGetOrderRefundContextLazyQuery(variables?: GetOrderRefundContextQueryVariables | VueCompositionApi.Ref<GetOrderRefundContextQueryVariables> | ReactiveFunction<GetOrderRefundContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables>(GetOrderRefundContextDocument, variables, options);
}
export type GetOrderRefundContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderRefundContextQuery, GetOrderRefundContextQueryVariables>;
export const GetOrderFiscalOperationalStatusDocument = gql`
    query GetOrderFiscalOperationalStatus($locationId: ID!) {
  orderFiscalOperationalStatus(locationId: $locationId) {
    fiscalization_enabled
    shifts_enabled
    paused
    pause_reason
    paused_at
    cashier_display_name
    expected_kkt_device_id
    workstation_binding
    browser_workstation_id
    location_closes_at
  }
}
    `;

/**
 * __useGetOrderFiscalOperationalStatusQuery__
 *
 * To run a query within a Vue component, call `useGetOrderFiscalOperationalStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderFiscalOperationalStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderFiscalOperationalStatusQuery({
 *   locationId: // value for 'locationId'
 * });
 */
export function useGetOrderFiscalOperationalStatusQuery(variables: GetOrderFiscalOperationalStatusQueryVariables | VueCompositionApi.Ref<GetOrderFiscalOperationalStatusQueryVariables> | ReactiveFunction<GetOrderFiscalOperationalStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables>(GetOrderFiscalOperationalStatusDocument, variables, options);
}
export function useGetOrderFiscalOperationalStatusLazyQuery(variables?: GetOrderFiscalOperationalStatusQueryVariables | VueCompositionApi.Ref<GetOrderFiscalOperationalStatusQueryVariables> | ReactiveFunction<GetOrderFiscalOperationalStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables>(GetOrderFiscalOperationalStatusDocument, variables, options);
}
export type GetOrderFiscalOperationalStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderFiscalOperationalStatusQuery, GetOrderFiscalOperationalStatusQueryVariables>;
export const GetCurrentShiftDocument = gql`
    query GetCurrentShift($locationId: ID!) {
  currentShift(locationId: $locationId) {
    ...ShiftFields
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useGetCurrentShiftQuery__
 *
 * To run a query within a Vue component, call `useGetCurrentShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentShiftQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCurrentShiftQuery({
 *   locationId: // value for 'locationId'
 * });
 */
export function useGetCurrentShiftQuery(variables: GetCurrentShiftQueryVariables | VueCompositionApi.Ref<GetCurrentShiftQueryVariables> | ReactiveFunction<GetCurrentShiftQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCurrentShiftQuery, GetCurrentShiftQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCurrentShiftQuery, GetCurrentShiftQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCurrentShiftQuery, GetCurrentShiftQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCurrentShiftQuery, GetCurrentShiftQueryVariables>(GetCurrentShiftDocument, variables, options);
}
export function useGetCurrentShiftLazyQuery(variables?: GetCurrentShiftQueryVariables | VueCompositionApi.Ref<GetCurrentShiftQueryVariables> | ReactiveFunction<GetCurrentShiftQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCurrentShiftQuery, GetCurrentShiftQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCurrentShiftQuery, GetCurrentShiftQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCurrentShiftQuery, GetCurrentShiftQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCurrentShiftQuery, GetCurrentShiftQueryVariables>(GetCurrentShiftDocument, variables, options);
}
export type GetCurrentShiftQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCurrentShiftQuery, GetCurrentShiftQueryVariables>;
export const GetShiftsDocument = gql`
    query GetShifts($locationId: ID, $dateFrom: Date, $dateTo: Date, $first: Int!, $after: String) {
  shifts(
    locationId: $locationId
    dateFrom: $dateFrom
    dateTo: $dateTo
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        status
        opened_at
        closed_at
        closing_cash_diff
        closing_revenue_mors
        closing_revenue_diff
        kkt_sync
        location {
          id
          title
          timezone
        }
        opened_by {
          id
          title
        }
        closed_by {
          id
          title
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    `;

/**
 * __useGetShiftsQuery__
 *
 * To run a query within a Vue component, call `useGetShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetShiftsQuery({
 *   locationId: // value for 'locationId'
 *   dateFrom: // value for 'dateFrom'
 *   dateTo: // value for 'dateTo'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetShiftsQuery(variables: GetShiftsQueryVariables | VueCompositionApi.Ref<GetShiftsQueryVariables> | ReactiveFunction<GetShiftsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShiftsQuery, GetShiftsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShiftsQuery, GetShiftsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShiftsQuery, GetShiftsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetShiftsQuery, GetShiftsQueryVariables>(GetShiftsDocument, variables, options);
}
export function useGetShiftsLazyQuery(variables?: GetShiftsQueryVariables | VueCompositionApi.Ref<GetShiftsQueryVariables> | ReactiveFunction<GetShiftsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShiftsQuery, GetShiftsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShiftsQuery, GetShiftsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShiftsQuery, GetShiftsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetShiftsQuery, GetShiftsQueryVariables>(GetShiftsDocument, variables, options);
}
export type GetShiftsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetShiftsQuery, GetShiftsQueryVariables>;
export const GetShiftDocument = gql`
    query GetShift($id: ID!) {
  shift(id: $id) {
    ...ShiftFields
    location {
      id
      title
      timezone
    }
    revenue_mors {
      cash
      card
      other
      total
    }
    events {
      id
      type
      created_at
      actor {
        id
        title
      }
    }
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useGetShiftQuery__
 *
 * To run a query within a Vue component, call `useGetShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetShiftQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetShiftQuery(variables: GetShiftQueryVariables | VueCompositionApi.Ref<GetShiftQueryVariables> | ReactiveFunction<GetShiftQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShiftQuery, GetShiftQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShiftQuery, GetShiftQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShiftQuery, GetShiftQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetShiftQuery, GetShiftQueryVariables>(GetShiftDocument, variables, options);
}
export function useGetShiftLazyQuery(variables?: GetShiftQueryVariables | VueCompositionApi.Ref<GetShiftQueryVariables> | ReactiveFunction<GetShiftQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShiftQuery, GetShiftQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShiftQuery, GetShiftQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShiftQuery, GetShiftQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetShiftQuery, GetShiftQueryVariables>(GetShiftDocument, variables, options);
}
export type GetShiftQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetShiftQuery, GetShiftQueryVariables>;
export const UpdateOrderFiscalizationSettingsDocument = gql`
    mutation UpdateOrderFiscalizationSettings($input: UpdateOrderFiscalizationSettingsInput!) {
  updateOrderFiscalizationSettings(input: $input) {
    ...OrderFiscalizationSettingFields
  }
}
    ${OrderFiscalizationSettingFieldsFragmentDoc}`;

/**
 * __useUpdateOrderFiscalizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrderFiscalizationSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderFiscalizationSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrderFiscalizationSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderFiscalizationSettingsMutation(options: VueApolloComposable.UseMutationOptions<UpdateOrderFiscalizationSettingsMutation, UpdateOrderFiscalizationSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOrderFiscalizationSettingsMutation, UpdateOrderFiscalizationSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOrderFiscalizationSettingsMutation, UpdateOrderFiscalizationSettingsMutationVariables>(UpdateOrderFiscalizationSettingsDocument, options);
}
export type UpdateOrderFiscalizationSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOrderFiscalizationSettingsMutation, UpdateOrderFiscalizationSettingsMutationVariables>;
export const ApplyOrderFiscalizationConnectionDocument = gql`
    mutation ApplyOrderFiscalizationConnection($input: ApplyOrderFiscalizationConnectionInput!) {
  applyOrderFiscalizationConnection(input: $input) {
    ...OrderFiscalWorkstationFields
    setting {
      ...OrderFiscalizationSettingFields
    }
  }
}
    ${OrderFiscalWorkstationFieldsFragmentDoc}
${OrderFiscalizationSettingFieldsFragmentDoc}`;

/**
 * __useApplyOrderFiscalizationConnectionMutation__
 *
 * To run a mutation, you first call `useApplyOrderFiscalizationConnectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplyOrderFiscalizationConnectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplyOrderFiscalizationConnectionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useApplyOrderFiscalizationConnectionMutation(options: VueApolloComposable.UseMutationOptions<ApplyOrderFiscalizationConnectionMutation, ApplyOrderFiscalizationConnectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApplyOrderFiscalizationConnectionMutation, ApplyOrderFiscalizationConnectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApplyOrderFiscalizationConnectionMutation, ApplyOrderFiscalizationConnectionMutationVariables>(ApplyOrderFiscalizationConnectionDocument, options);
}
export type ApplyOrderFiscalizationConnectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApplyOrderFiscalizationConnectionMutation, ApplyOrderFiscalizationConnectionMutationVariables>;
export const DeactivateOrderFiscalWorkstationDocument = gql`
    mutation DeactivateOrderFiscalWorkstation($locationId: ID!, $workstationId: ID!) {
  deactivateOrderFiscalWorkstation(
    locationId: $locationId
    workstationId: $workstationId
  ) {
    ...OrderFiscalWorkstationFields
  }
}
    ${OrderFiscalWorkstationFieldsFragmentDoc}`;

/**
 * __useDeactivateOrderFiscalWorkstationMutation__
 *
 * To run a mutation, you first call `useDeactivateOrderFiscalWorkstationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateOrderFiscalWorkstationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateOrderFiscalWorkstationMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     workstationId: // value for 'workstationId'
 *   },
 * });
 */
export function useDeactivateOrderFiscalWorkstationMutation(options: VueApolloComposable.UseMutationOptions<DeactivateOrderFiscalWorkstationMutation, DeactivateOrderFiscalWorkstationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateOrderFiscalWorkstationMutation, DeactivateOrderFiscalWorkstationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateOrderFiscalWorkstationMutation, DeactivateOrderFiscalWorkstationMutationVariables>(DeactivateOrderFiscalWorkstationDocument, options);
}
export type DeactivateOrderFiscalWorkstationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateOrderFiscalWorkstationMutation, DeactivateOrderFiscalWorkstationMutationVariables>;
export const DeleteOrderFiscalWorkstationDocument = gql`
    mutation DeleteOrderFiscalWorkstation($locationId: ID!, $workstationId: ID!) {
  deleteOrderFiscalWorkstation(
    locationId: $locationId
    workstationId: $workstationId
  )
}
    `;

/**
 * __useDeleteOrderFiscalWorkstationMutation__
 *
 * To run a mutation, you first call `useDeleteOrderFiscalWorkstationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderFiscalWorkstationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOrderFiscalWorkstationMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     workstationId: // value for 'workstationId'
 *   },
 * });
 */
export function useDeleteOrderFiscalWorkstationMutation(options: VueApolloComposable.UseMutationOptions<DeleteOrderFiscalWorkstationMutation, DeleteOrderFiscalWorkstationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOrderFiscalWorkstationMutation, DeleteOrderFiscalWorkstationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOrderFiscalWorkstationMutation, DeleteOrderFiscalWorkstationMutationVariables>(DeleteOrderFiscalWorkstationDocument, options);
}
export type DeleteOrderFiscalWorkstationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOrderFiscalWorkstationMutation, DeleteOrderFiscalWorkstationMutationVariables>;
export const GetInvoicesDocument = gql`
    query GetInvoices($filter: InvoiceListFilter, $search: String, $locationId: ID, $from: Date, $to: Date, $first: Int, $page: Int, $withCounts: Boolean! = true) {
  invoices(
    filter: $filter
    search: $search
    locationId: $locationId
    from: $from
    to: $to
    first: $first
    page: $page
  ) {
    items {
      id
      number
      status
      is_overdue
      issued_on
      due_on
      total_amount
      paid_amount
      remaining_amount
      client_title
      payer {
        name
        tin
      }
      location {
        ...InvoiceLocationFields
      }
      seller {
        name
        legal_form
      }
    }
    total
    seller_count @include(if: $withCounts)
    counts @include(if: $withCounts) {
      all
      awaiting_payment
      overdue
      paid
    }
  }
}
    ${InvoiceLocationFieldsFragmentDoc}`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a Vue component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoicesQuery({
 *   filter: // value for 'filter'
 *   search: // value for 'search'
 *   locationId: // value for 'locationId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   withCounts: // value for 'withCounts'
 * });
 */
export function useGetInvoicesQuery(variables: GetInvoicesQueryVariables | VueCompositionApi.Ref<GetInvoicesQueryVariables> | ReactiveFunction<GetInvoicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoicesQuery, GetInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoicesQuery, GetInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoicesQuery, GetInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, variables, options);
}
export function useGetInvoicesLazyQuery(variables?: GetInvoicesQueryVariables | VueCompositionApi.Ref<GetInvoicesQueryVariables> | ReactiveFunction<GetInvoicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoicesQuery, GetInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoicesQuery, GetInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoicesQuery, GetInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, variables, options);
}
export type GetInvoicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetInvoiceDocument = gql`
    query GetInvoice($id: ID!) {
  invoice(id: $id) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a Vue component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoiceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetInvoiceQuery(variables: GetInvoiceQueryVariables | VueCompositionApi.Ref<GetInvoiceQueryVariables> | ReactiveFunction<GetInvoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, variables, options);
}
export function useGetInvoiceLazyQuery(variables?: GetInvoiceQueryVariables | VueCompositionApi.Ref<GetInvoiceQueryVariables> | ReactiveFunction<GetInvoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, variables, options);
}
export type GetInvoiceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const GetOrderInvoiceStateDocument = gql`
    query GetOrderInvoiceState($orderId: ID!) {
  orderInvoiceState(orderId: $orderId) {
    invoice {
      ...InvoiceFields
    }
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useGetOrderInvoiceStateQuery__
 *
 * To run a query within a Vue component, call `useGetOrderInvoiceStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderInvoiceStateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderInvoiceStateQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetOrderInvoiceStateQuery(variables: GetOrderInvoiceStateQueryVariables | VueCompositionApi.Ref<GetOrderInvoiceStateQueryVariables> | ReactiveFunction<GetOrderInvoiceStateQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables>(GetOrderInvoiceStateDocument, variables, options);
}
export function useGetOrderInvoiceStateLazyQuery(variables?: GetOrderInvoiceStateQueryVariables | VueCompositionApi.Ref<GetOrderInvoiceStateQueryVariables> | ReactiveFunction<GetOrderInvoiceStateQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables>(GetOrderInvoiceStateDocument, variables, options);
}
export type GetOrderInvoiceStateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderInvoiceStateQuery, GetOrderInvoiceStateQueryVariables>;
export const GetOrderInvoiceHoldDocument = gql`
    query GetOrderInvoiceHold($orderId: ID!) {
  orderInvoiceState(orderId: $orderId) {
    invoice {
      id
      number
      status
    }
  }
}
    `;

/**
 * __useGetOrderInvoiceHoldQuery__
 *
 * To run a query within a Vue component, call `useGetOrderInvoiceHoldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderInvoiceHoldQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderInvoiceHoldQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetOrderInvoiceHoldQuery(variables: GetOrderInvoiceHoldQueryVariables | VueCompositionApi.Ref<GetOrderInvoiceHoldQueryVariables> | ReactiveFunction<GetOrderInvoiceHoldQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables>(GetOrderInvoiceHoldDocument, variables, options);
}
export function useGetOrderInvoiceHoldLazyQuery(variables?: GetOrderInvoiceHoldQueryVariables | VueCompositionApi.Ref<GetOrderInvoiceHoldQueryVariables> | ReactiveFunction<GetOrderInvoiceHoldQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables>(GetOrderInvoiceHoldDocument, variables, options);
}
export type GetOrderInvoiceHoldQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderInvoiceHoldQuery, GetOrderInvoiceHoldQueryVariables>;
export const GetOrderInvoiceAvailabilityDocument = gql`
    query GetOrderInvoiceAvailability($orderId: ID!) {
  orderInvoiceState(orderId: $orderId) {
    issue_availability {
      available
      reason
      reason_message
      missing_seller
      missing_payer
      seller_name
      payer_preview {
        ...InvoicePartyFields
      }
    }
  }
}
    ${InvoicePartyFieldsFragmentDoc}`;

/**
 * __useGetOrderInvoiceAvailabilityQuery__
 *
 * To run a query within a Vue component, call `useGetOrderInvoiceAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderInvoiceAvailabilityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderInvoiceAvailabilityQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetOrderInvoiceAvailabilityQuery(variables: GetOrderInvoiceAvailabilityQueryVariables | VueCompositionApi.Ref<GetOrderInvoiceAvailabilityQueryVariables> | ReactiveFunction<GetOrderInvoiceAvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables>(GetOrderInvoiceAvailabilityDocument, variables, options);
}
export function useGetOrderInvoiceAvailabilityLazyQuery(variables?: GetOrderInvoiceAvailabilityQueryVariables | VueCompositionApi.Ref<GetOrderInvoiceAvailabilityQueryVariables> | ReactiveFunction<GetOrderInvoiceAvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables>(GetOrderInvoiceAvailabilityDocument, variables, options);
}
export type GetOrderInvoiceAvailabilityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderInvoiceAvailabilityQuery, GetOrderInvoiceAvailabilityQueryVariables>;
export const GetInvoiceSellerReadinessDocument = gql`
    query GetInvoiceSellerReadiness {
  invoiceSellerReadiness {
    location {
      ...InvoiceLocationFields
    }
    seller_name
    missing
  }
}
    ${InvoiceLocationFieldsFragmentDoc}`;

/**
 * __useGetInvoiceSellerReadinessQuery__
 *
 * To run a query within a Vue component, call `useGetInvoiceSellerReadinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceSellerReadinessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoiceSellerReadinessQuery();
 */
export function useGetInvoiceSellerReadinessQuery(options: VueApolloComposable.UseQueryOptions<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables>(GetInvoiceSellerReadinessDocument, {}, options);
}
export function useGetInvoiceSellerReadinessLazyQuery(options: VueApolloComposable.UseQueryOptions<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables>(GetInvoiceSellerReadinessDocument, {}, options);
}
export type GetInvoiceSellerReadinessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoiceSellerReadinessQuery, GetInvoiceSellerReadinessQueryVariables>;
export const LegalEntitySuggestionsDocument = gql`
    query LegalEntitySuggestions($query: String!, $locationId: ID) {
  legalEntitySuggestions(query: $query, locationId: $locationId) {
    name
    legal_form
    tin
    kpp
    ogrn
    address
    status
    liquidated_on
  }
}
    `;

/**
 * __useLegalEntitySuggestionsQuery__
 *
 * To run a query within a Vue component, call `useLegalEntitySuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalEntitySuggestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLegalEntitySuggestionsQuery({
 *   query: // value for 'query'
 *   locationId: // value for 'locationId'
 * });
 */
export function useLegalEntitySuggestionsQuery(variables: LegalEntitySuggestionsQueryVariables | VueCompositionApi.Ref<LegalEntitySuggestionsQueryVariables> | ReactiveFunction<LegalEntitySuggestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables>(LegalEntitySuggestionsDocument, variables, options);
}
export function useLegalEntitySuggestionsLazyQuery(variables?: LegalEntitySuggestionsQueryVariables | VueCompositionApi.Ref<LegalEntitySuggestionsQueryVariables> | ReactiveFunction<LegalEntitySuggestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables>(LegalEntitySuggestionsDocument, variables, options);
}
export type LegalEntitySuggestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LegalEntitySuggestionsQuery, LegalEntitySuggestionsQueryVariables>;
export const BankByBikDocument = gql`
    query BankByBik($bik: String!) {
  bankByBik(bik: $bik) {
    name
    bik
    correspondent_account
  }
}
    `;

/**
 * __useBankByBikQuery__
 *
 * To run a query within a Vue component, call `useBankByBikQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankByBikQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBankByBikQuery({
 *   bik: // value for 'bik'
 * });
 */
export function useBankByBikQuery(variables: BankByBikQueryVariables | VueCompositionApi.Ref<BankByBikQueryVariables> | ReactiveFunction<BankByBikQueryVariables>, options: VueApolloComposable.UseQueryOptions<BankByBikQuery, BankByBikQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BankByBikQuery, BankByBikQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BankByBikQuery, BankByBikQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BankByBikQuery, BankByBikQueryVariables>(BankByBikDocument, variables, options);
}
export function useBankByBikLazyQuery(variables?: BankByBikQueryVariables | VueCompositionApi.Ref<BankByBikQueryVariables> | ReactiveFunction<BankByBikQueryVariables>, options: VueApolloComposable.UseQueryOptions<BankByBikQuery, BankByBikQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BankByBikQuery, BankByBikQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BankByBikQuery, BankByBikQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BankByBikQuery, BankByBikQueryVariables>(BankByBikDocument, variables, options);
}
export type BankByBikQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BankByBikQuery, BankByBikQueryVariables>;
export const GetLocationAttentionDocument = gql`
    query GetLocationAttention {
  locationAttention {
    location_id
    shift_state
    shift_expires_at
    location_closes_at
    payment_attention_count
    refund_approval_count
  }
}
    `;

/**
 * __useGetLocationAttentionQuery__
 *
 * To run a query within a Vue component, call `useGetLocationAttentionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationAttentionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLocationAttentionQuery();
 */
export function useGetLocationAttentionQuery(options: VueApolloComposable.UseQueryOptions<GetLocationAttentionQuery, GetLocationAttentionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLocationAttentionQuery, GetLocationAttentionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLocationAttentionQuery, GetLocationAttentionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLocationAttentionQuery, GetLocationAttentionQueryVariables>(GetLocationAttentionDocument, {}, options);
}
export function useGetLocationAttentionLazyQuery(options: VueApolloComposable.UseQueryOptions<GetLocationAttentionQuery, GetLocationAttentionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLocationAttentionQuery, GetLocationAttentionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLocationAttentionQuery, GetLocationAttentionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLocationAttentionQuery, GetLocationAttentionQueryVariables>(GetLocationAttentionDocument, {}, options);
}
export type GetLocationAttentionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLocationAttentionQuery, GetLocationAttentionQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations {
  locations {
    id
    title
    opened_from
    closed_from
  }
}
    `;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a Vue component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLocationsQuery();
 */
export function useGetLocationsQuery(options: VueApolloComposable.UseQueryOptions<GetLocationsQuery, GetLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLocationsQuery, GetLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLocationsQuery, GetLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, {}, options);
}
export function useGetLocationsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetLocationsQuery, GetLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLocationsQuery, GetLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLocationsQuery, GetLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, {}, options);
}
export type GetLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetClientLoyaltyDocument = gql`
    query GetClientLoyalty($clientId: ID!) {
  clientLoyalty(clientId: $clientId) {
    ...LoyaltyAccountFields
  }
}
    ${LoyaltyAccountFieldsFragmentDoc}`;

/**
 * __useGetClientLoyaltyQuery__
 *
 * To run a query within a Vue component, call `useGetClientLoyaltyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientLoyaltyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientLoyaltyQuery({
 *   clientId: // value for 'clientId'
 * });
 */
export function useGetClientLoyaltyQuery(variables: GetClientLoyaltyQueryVariables | VueCompositionApi.Ref<GetClientLoyaltyQueryVariables> | ReactiveFunction<GetClientLoyaltyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables>(GetClientLoyaltyDocument, variables, options);
}
export function useGetClientLoyaltyLazyQuery(variables?: GetClientLoyaltyQueryVariables | VueCompositionApi.Ref<GetClientLoyaltyQueryVariables> | ReactiveFunction<GetClientLoyaltyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables>(GetClientLoyaltyDocument, variables, options);
}
export type GetClientLoyaltyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientLoyaltyQuery, GetClientLoyaltyQueryVariables>;
export const GetLoyaltyTransactionsDocument = gql`
    query GetLoyaltyTransactions($clientId: ID!, $first: Int!, $after: String) {
  loyaltyTransactions(clientId: $clientId, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...LoyaltyTransactionFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${LoyaltyTransactionFieldsFragmentDoc}`;

/**
 * __useGetLoyaltyTransactionsQuery__
 *
 * To run a query within a Vue component, call `useGetLoyaltyTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyTransactionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLoyaltyTransactionsQuery({
 *   clientId: // value for 'clientId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetLoyaltyTransactionsQuery(variables: GetLoyaltyTransactionsQueryVariables | VueCompositionApi.Ref<GetLoyaltyTransactionsQueryVariables> | ReactiveFunction<GetLoyaltyTransactionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables>(GetLoyaltyTransactionsDocument, variables, options);
}
export function useGetLoyaltyTransactionsLazyQuery(variables?: GetLoyaltyTransactionsQueryVariables | VueCompositionApi.Ref<GetLoyaltyTransactionsQueryVariables> | ReactiveFunction<GetLoyaltyTransactionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables>(GetLoyaltyTransactionsDocument, variables, options);
}
export type GetLoyaltyTransactionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLoyaltyTransactionsQuery, GetLoyaltyTransactionsQueryVariables>;
export const GetLoyaltyProgramDocument = gql`
    query GetLoyaltyProgram {
  loyaltyProgram {
    ...LoyaltyProgramFields
  }
}
    ${LoyaltyProgramFieldsFragmentDoc}`;

/**
 * __useGetLoyaltyProgramQuery__
 *
 * To run a query within a Vue component, call `useGetLoyaltyProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyProgramQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLoyaltyProgramQuery();
 */
export function useGetLoyaltyProgramQuery(options: VueApolloComposable.UseQueryOptions<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables>(GetLoyaltyProgramDocument, {}, options);
}
export function useGetLoyaltyProgramLazyQuery(options: VueApolloComposable.UseQueryOptions<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables>(GetLoyaltyProgramDocument, {}, options);
}
export type GetLoyaltyProgramQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLoyaltyProgramQuery, GetLoyaltyProgramQueryVariables>;
export const UpsertLoyaltyProgramDocument = gql`
    mutation UpsertLoyaltyProgram($input: UpsertLoyaltyProgramInput!) {
  upsertLoyaltyProgram(input: $input) {
    ...LoyaltyProgramFields
  }
}
    ${LoyaltyProgramFieldsFragmentDoc}`;

/**
 * __useUpsertLoyaltyProgramMutation__
 *
 * To run a mutation, you first call `useUpsertLoyaltyProgramMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLoyaltyProgramMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertLoyaltyProgramMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLoyaltyProgramMutation(options: VueApolloComposable.UseMutationOptions<UpsertLoyaltyProgramMutation, UpsertLoyaltyProgramMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertLoyaltyProgramMutation, UpsertLoyaltyProgramMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertLoyaltyProgramMutation, UpsertLoyaltyProgramMutationVariables>(UpsertLoyaltyProgramDocument, options);
}
export type UpsertLoyaltyProgramMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertLoyaltyProgramMutation, UpsertLoyaltyProgramMutationVariables>;
export const ManualLoyaltyAccrualDocument = gql`
    mutation ManualLoyaltyAccrual($clientId: ID!, $amount: Int!, $note: String!, $expiresAt: DateTime) {
  manualLoyaltyAccrual(
    clientId: $clientId
    amount: $amount
    note: $note
    expiresAt: $expiresAt
  ) {
    ...LoyaltyTransactionFields
  }
}
    ${LoyaltyTransactionFieldsFragmentDoc}`;

/**
 * __useManualLoyaltyAccrualMutation__
 *
 * To run a mutation, you first call `useManualLoyaltyAccrualMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useManualLoyaltyAccrualMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useManualLoyaltyAccrualMutation({
 *   variables: {
 *     clientId: // value for 'clientId'
 *     amount: // value for 'amount'
 *     note: // value for 'note'
 *     expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useManualLoyaltyAccrualMutation(options: VueApolloComposable.UseMutationOptions<ManualLoyaltyAccrualMutation, ManualLoyaltyAccrualMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ManualLoyaltyAccrualMutation, ManualLoyaltyAccrualMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ManualLoyaltyAccrualMutation, ManualLoyaltyAccrualMutationVariables>(ManualLoyaltyAccrualDocument, options);
}
export type ManualLoyaltyAccrualMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ManualLoyaltyAccrualMutation, ManualLoyaltyAccrualMutationVariables>;
export const ManualLoyaltyDeductionDocument = gql`
    mutation ManualLoyaltyDeduction($clientId: ID!, $amount: Int!, $note: String!) {
  manualLoyaltyDeduction(clientId: $clientId, amount: $amount, note: $note) {
    ...LoyaltyTransactionFields
  }
}
    ${LoyaltyTransactionFieldsFragmentDoc}`;

/**
 * __useManualLoyaltyDeductionMutation__
 *
 * To run a mutation, you first call `useManualLoyaltyDeductionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useManualLoyaltyDeductionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useManualLoyaltyDeductionMutation({
 *   variables: {
 *     clientId: // value for 'clientId'
 *     amount: // value for 'amount'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useManualLoyaltyDeductionMutation(options: VueApolloComposable.UseMutationOptions<ManualLoyaltyDeductionMutation, ManualLoyaltyDeductionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ManualLoyaltyDeductionMutation, ManualLoyaltyDeductionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ManualLoyaltyDeductionMutation, ManualLoyaltyDeductionMutationVariables>(ManualLoyaltyDeductionDocument, options);
}
export type ManualLoyaltyDeductionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ManualLoyaltyDeductionMutation, ManualLoyaltyDeductionMutationVariables>;
export const GetMarketingSourcesDocument = gql`
    query GetMarketingSources {
  marketingSources {
    id
    title
    is_manual_selectable
    is_system
    created_at
  }
}
    `;

/**
 * __useGetMarketingSourcesQuery__
 *
 * To run a query within a Vue component, call `useGetMarketingSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingSourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMarketingSourcesQuery();
 */
export function useGetMarketingSourcesQuery(options: VueApolloComposable.UseQueryOptions<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables>(GetMarketingSourcesDocument, {}, options);
}
export function useGetMarketingSourcesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables>(GetMarketingSourcesDocument, {}, options);
}
export type GetMarketingSourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMarketingSourcesQuery, GetMarketingSourcesQueryVariables>;
export const GetMarketingSourceDocument = gql`
    query GetMarketingSource($id: ID!) {
  marketingSource(id: $id) {
    id
    title
    is_manual_selectable
    is_system
    created_at
  }
}
    `;

/**
 * __useGetMarketingSourceQuery__
 *
 * To run a query within a Vue component, call `useGetMarketingSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingSourceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMarketingSourceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMarketingSourceQuery(variables: GetMarketingSourceQueryVariables | VueCompositionApi.Ref<GetMarketingSourceQueryVariables> | ReactiveFunction<GetMarketingSourceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingSourceQuery, GetMarketingSourceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingSourceQuery, GetMarketingSourceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingSourceQuery, GetMarketingSourceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMarketingSourceQuery, GetMarketingSourceQueryVariables>(GetMarketingSourceDocument, variables, options);
}
export function useGetMarketingSourceLazyQuery(variables?: GetMarketingSourceQueryVariables | VueCompositionApi.Ref<GetMarketingSourceQueryVariables> | ReactiveFunction<GetMarketingSourceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMarketingSourceQuery, GetMarketingSourceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMarketingSourceQuery, GetMarketingSourceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMarketingSourceQuery, GetMarketingSourceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMarketingSourceQuery, GetMarketingSourceQueryVariables>(GetMarketingSourceDocument, variables, options);
}
export type GetMarketingSourceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMarketingSourceQuery, GetMarketingSourceQueryVariables>;
export const GetMessengerChannelsDocument = gql`
    query GetMessengerChannels {
  messengerChannels {
    ...MessengerChannelFragment
  }
}
    ${MessengerChannelFragmentFragmentDoc}`;

/**
 * __useGetMessengerChannelsQuery__
 *
 * To run a query within a Vue component, call `useGetMessengerChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessengerChannelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMessengerChannelsQuery();
 */
export function useGetMessengerChannelsQuery(options: VueApolloComposable.UseQueryOptions<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables>(GetMessengerChannelsDocument, {}, options);
}
export function useGetMessengerChannelsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables>(GetMessengerChannelsDocument, {}, options);
}
export type GetMessengerChannelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMessengerChannelsQuery, GetMessengerChannelsQueryVariables>;
export const CreateMessengerChannelDocument = gql`
    mutation CreateMessengerChannel($input: CreateMessengerChannelInput!) {
  createMessengerChannel(input: $input) {
    ...MessengerChannelFragment
  }
}
    ${MessengerChannelFragmentFragmentDoc}`;

/**
 * __useCreateMessengerChannelMutation__
 *
 * To run a mutation, you first call `useCreateMessengerChannelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessengerChannelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMessengerChannelMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessengerChannelMutation(options: VueApolloComposable.UseMutationOptions<CreateMessengerChannelMutation, CreateMessengerChannelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMessengerChannelMutation, CreateMessengerChannelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMessengerChannelMutation, CreateMessengerChannelMutationVariables>(CreateMessengerChannelDocument, options);
}
export type CreateMessengerChannelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMessengerChannelMutation, CreateMessengerChannelMutationVariables>;
export const UpdateMessengerChannelDocument = gql`
    mutation UpdateMessengerChannel($id: ID!, $input: UpdateMessengerChannelInput!) {
  updateMessengerChannel(id: $id, input: $input) {
    ...MessengerChannelFragment
  }
}
    ${MessengerChannelFragmentFragmentDoc}`;

/**
 * __useUpdateMessengerChannelMutation__
 *
 * To run a mutation, you first call `useUpdateMessengerChannelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessengerChannelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMessengerChannelMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessengerChannelMutation(options: VueApolloComposable.UseMutationOptions<UpdateMessengerChannelMutation, UpdateMessengerChannelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMessengerChannelMutation, UpdateMessengerChannelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMessengerChannelMutation, UpdateMessengerChannelMutationVariables>(UpdateMessengerChannelDocument, options);
}
export type UpdateMessengerChannelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMessengerChannelMutation, UpdateMessengerChannelMutationVariables>;
export const DeleteMessengerChannelDocument = gql`
    mutation DeleteMessengerChannel($id: ID!) {
  deleteMessengerChannel(id: $id)
}
    `;

/**
 * __useDeleteMessengerChannelMutation__
 *
 * To run a mutation, you first call `useDeleteMessengerChannelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessengerChannelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMessengerChannelMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessengerChannelMutation(options: VueApolloComposable.UseMutationOptions<DeleteMessengerChannelMutation, DeleteMessengerChannelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMessengerChannelMutation, DeleteMessengerChannelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMessengerChannelMutation, DeleteMessengerChannelMutationVariables>(DeleteMessengerChannelDocument, options);
}
export type DeleteMessengerChannelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMessengerChannelMutation, DeleteMessengerChannelMutationVariables>;
export const LinkConversationClientDocument = gql`
    mutation LinkConversationClient($conversationId: ID!, $clientId: ID!, $force: Boolean) {
  linkConversationClient(
    conversationId: $conversationId
    clientId: $clientId
    force: $force
  ) {
    conversation {
      ...MessengerConversationFragment
    }
    warnings
  }
}
    ${MessengerConversationFragmentFragmentDoc}`;

/**
 * __useLinkConversationClientMutation__
 *
 * To run a mutation, you first call `useLinkConversationClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLinkConversationClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLinkConversationClientMutation({
 *   variables: {
 *     conversationId: // value for 'conversationId'
 *     clientId: // value for 'clientId'
 *     force: // value for 'force'
 *   },
 * });
 */
export function useLinkConversationClientMutation(options: VueApolloComposable.UseMutationOptions<LinkConversationClientMutation, LinkConversationClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LinkConversationClientMutation, LinkConversationClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LinkConversationClientMutation, LinkConversationClientMutationVariables>(LinkConversationClientDocument, options);
}
export type LinkConversationClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LinkConversationClientMutation, LinkConversationClientMutationVariables>;
export const UnlinkConversationClientDocument = gql`
    mutation UnlinkConversationClient($conversationId: ID!) {
  unlinkConversationClient(conversationId: $conversationId) {
    ...MessengerConversationFragment
  }
}
    ${MessengerConversationFragmentFragmentDoc}`;

/**
 * __useUnlinkConversationClientMutation__
 *
 * To run a mutation, you first call `useUnlinkConversationClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkConversationClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnlinkConversationClientMutation({
 *   variables: {
 *     conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useUnlinkConversationClientMutation(options: VueApolloComposable.UseMutationOptions<UnlinkConversationClientMutation, UnlinkConversationClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnlinkConversationClientMutation, UnlinkConversationClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnlinkConversationClientMutation, UnlinkConversationClientMutationVariables>(UnlinkConversationClientDocument, options);
}
export type UnlinkConversationClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnlinkConversationClientMutation, UnlinkConversationClientMutationVariables>;
export const SetConversationDefaultDocument = gql`
    mutation SetConversationDefault($conversationId: ID!) {
  setConversationDefault(conversationId: $conversationId) {
    ...MessengerConversationFragment
  }
}
    ${MessengerConversationFragmentFragmentDoc}`;

/**
 * __useSetConversationDefaultMutation__
 *
 * To run a mutation, you first call `useSetConversationDefaultMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetConversationDefaultMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetConversationDefaultMutation({
 *   variables: {
 *     conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useSetConversationDefaultMutation(options: VueApolloComposable.UseMutationOptions<SetConversationDefaultMutation, SetConversationDefaultMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetConversationDefaultMutation, SetConversationDefaultMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetConversationDefaultMutation, SetConversationDefaultMutationVariables>(SetConversationDefaultDocument, options);
}
export type SetConversationDefaultMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetConversationDefaultMutation, SetConversationDefaultMutationVariables>;
export const CreateClientFromConversationDocument = gql`
    mutation CreateClientFromConversation($conversationId: ID!, $input: CreateClientFromConversationInput!) {
  createClientFromConversation(conversationId: $conversationId, input: $input) {
    conversation {
      ...MessengerConversationFragment
    }
    existing
    warnings
  }
}
    ${MessengerConversationFragmentFragmentDoc}`;

/**
 * __useCreateClientFromConversationMutation__
 *
 * To run a mutation, you first call `useCreateClientFromConversationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientFromConversationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateClientFromConversationMutation({
 *   variables: {
 *     conversationId: // value for 'conversationId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientFromConversationMutation(options: VueApolloComposable.UseMutationOptions<CreateClientFromConversationMutation, CreateClientFromConversationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateClientFromConversationMutation, CreateClientFromConversationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateClientFromConversationMutation, CreateClientFromConversationMutationVariables>(CreateClientFromConversationDocument, options);
}
export type CreateClientFromConversationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateClientFromConversationMutation, CreateClientFromConversationMutationVariables>;
export const GetMessengerConversationGroupsDocument = gql`
    query GetMessengerConversationGroups($search: String, $page: Int!, $perPage: Int!, $section: MessengerDialogSection) {
  messengerConversationGroups(
    search: $search
    page: $page
    perPage: $perPage
    section: $section
  ) {
    groups {
      client_id
      client {
        ...MessengerClientFragment
      }
      conversations {
        ...MessengerConversationFragment
      }
      last_message {
        ...MessengerMessageFragment
      }
      unread_count
      last_message_at
      dialog {
        ...MessengerDialogFragment
      }
    }
    meta {
      current_page
      per_page
      total
      last_page
      has_more
    }
  }
}
    ${MessengerClientFragmentFragmentDoc}
${MessengerConversationFragmentFragmentDoc}
${MessengerMessageFragmentFragmentDoc}
${MessengerDialogFragmentFragmentDoc}`;

/**
 * __useGetMessengerConversationGroupsQuery__
 *
 * To run a query within a Vue component, call `useGetMessengerConversationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessengerConversationGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMessengerConversationGroupsQuery({
 *   search: // value for 'search'
 *   page: // value for 'page'
 *   perPage: // value for 'perPage'
 *   section: // value for 'section'
 * });
 */
export function useGetMessengerConversationGroupsQuery(variables: GetMessengerConversationGroupsQueryVariables | VueCompositionApi.Ref<GetMessengerConversationGroupsQueryVariables> | ReactiveFunction<GetMessengerConversationGroupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables>(GetMessengerConversationGroupsDocument, variables, options);
}
export function useGetMessengerConversationGroupsLazyQuery(variables?: GetMessengerConversationGroupsQueryVariables | VueCompositionApi.Ref<GetMessengerConversationGroupsQueryVariables> | ReactiveFunction<GetMessengerConversationGroupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables>(GetMessengerConversationGroupsDocument, variables, options);
}
export type GetMessengerConversationGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMessengerConversationGroupsQuery, GetMessengerConversationGroupsQueryVariables>;
export const GetMessengerConversationGroupDocument = gql`
    query GetMessengerConversationGroup($conversationId: ID!) {
  messengerConversationGroup(conversationId: $conversationId) {
    client_id
    client {
      ...MessengerClientFragment
    }
    conversations {
      ...MessengerConversationFragment
    }
    last_message {
      ...MessengerMessageFragment
    }
    unread_count
    last_message_at
    dialog {
      ...MessengerDialogFragment
    }
  }
}
    ${MessengerClientFragmentFragmentDoc}
${MessengerConversationFragmentFragmentDoc}
${MessengerMessageFragmentFragmentDoc}
${MessengerDialogFragmentFragmentDoc}`;

/**
 * __useGetMessengerConversationGroupQuery__
 *
 * To run a query within a Vue component, call `useGetMessengerConversationGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessengerConversationGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMessengerConversationGroupQuery({
 *   conversationId: // value for 'conversationId'
 * });
 */
export function useGetMessengerConversationGroupQuery(variables: GetMessengerConversationGroupQueryVariables | VueCompositionApi.Ref<GetMessengerConversationGroupQueryVariables> | ReactiveFunction<GetMessengerConversationGroupQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables>(GetMessengerConversationGroupDocument, variables, options);
}
export function useGetMessengerConversationGroupLazyQuery(variables?: GetMessengerConversationGroupQueryVariables | VueCompositionApi.Ref<GetMessengerConversationGroupQueryVariables> | ReactiveFunction<GetMessengerConversationGroupQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables>(GetMessengerConversationGroupDocument, variables, options);
}
export type GetMessengerConversationGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMessengerConversationGroupQuery, GetMessengerConversationGroupQueryVariables>;
export const GetMessengerDialogCountsDocument = gql`
    query GetMessengerDialogCounts {
  messengerDialogCounts {
    open
    unanswered
    resolved
  }
}
    `;

/**
 * __useGetMessengerDialogCountsQuery__
 *
 * To run a query within a Vue component, call `useGetMessengerDialogCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessengerDialogCountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMessengerDialogCountsQuery();
 */
export function useGetMessengerDialogCountsQuery(options: VueApolloComposable.UseQueryOptions<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables>(GetMessengerDialogCountsDocument, {}, options);
}
export function useGetMessengerDialogCountsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables>(GetMessengerDialogCountsDocument, {}, options);
}
export type GetMessengerDialogCountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMessengerDialogCountsQuery, GetMessengerDialogCountsQueryVariables>;
export const GetMessengerOperatorsDocument = gql`
    query GetMessengerOperators {
  messengerOperators {
    id
    first_name
    last_name
  }
}
    `;

/**
 * __useGetMessengerOperatorsQuery__
 *
 * To run a query within a Vue component, call `useGetMessengerOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessengerOperatorsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMessengerOperatorsQuery();
 */
export function useGetMessengerOperatorsQuery(options: VueApolloComposable.UseQueryOptions<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables>(GetMessengerOperatorsDocument, {}, options);
}
export function useGetMessengerOperatorsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables>(GetMessengerOperatorsDocument, {}, options);
}
export type GetMessengerOperatorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMessengerOperatorsQuery, GetMessengerOperatorsQueryVariables>;
export const GetClientMessengerConversationsDocument = gql`
    query GetClientMessengerConversations($clientId: ID!) {
  clientMessengerConversations(clientId: $clientId) {
    ...MessengerConversationFragment
  }
}
    ${MessengerConversationFragmentFragmentDoc}`;

/**
 * __useGetClientMessengerConversationsQuery__
 *
 * To run a query within a Vue component, call `useGetClientMessengerConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientMessengerConversationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClientMessengerConversationsQuery({
 *   clientId: // value for 'clientId'
 * });
 */
export function useGetClientMessengerConversationsQuery(variables: GetClientMessengerConversationsQueryVariables | VueCompositionApi.Ref<GetClientMessengerConversationsQueryVariables> | ReactiveFunction<GetClientMessengerConversationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables>(GetClientMessengerConversationsDocument, variables, options);
}
export function useGetClientMessengerConversationsLazyQuery(variables?: GetClientMessengerConversationsQueryVariables | VueCompositionApi.Ref<GetClientMessengerConversationsQueryVariables> | ReactiveFunction<GetClientMessengerConversationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables>(GetClientMessengerConversationsDocument, variables, options);
}
export type GetClientMessengerConversationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetClientMessengerConversationsQuery, GetClientMessengerConversationsQueryVariables>;
export const GetMessengerClientNextBookingDocument = gql`
    query GetMessengerClientNextBooking($clientId: ID!) {
  messengerClientNextBooking(clientId: $clientId) {
    start
    end
    status
    service_variant_title
    location_title
  }
}
    `;

/**
 * __useGetMessengerClientNextBookingQuery__
 *
 * To run a query within a Vue component, call `useGetMessengerClientNextBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessengerClientNextBookingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMessengerClientNextBookingQuery({
 *   clientId: // value for 'clientId'
 * });
 */
export function useGetMessengerClientNextBookingQuery(variables: GetMessengerClientNextBookingQueryVariables | VueCompositionApi.Ref<GetMessengerClientNextBookingQueryVariables> | ReactiveFunction<GetMessengerClientNextBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables>(GetMessengerClientNextBookingDocument, variables, options);
}
export function useGetMessengerClientNextBookingLazyQuery(variables?: GetMessengerClientNextBookingQueryVariables | VueCompositionApi.Ref<GetMessengerClientNextBookingQueryVariables> | ReactiveFunction<GetMessengerClientNextBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables>(GetMessengerClientNextBookingDocument, variables, options);
}
export type GetMessengerClientNextBookingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMessengerClientNextBookingQuery, GetMessengerClientNextBookingQueryVariables>;
export const GetConversationMessagesDocument = gql`
    query GetConversationMessages($conversationId: ID!, $beforeMessageId: ID, $perPage: Int!, $filter: MessageFilter!) {
  conversationMessages(
    conversationId: $conversationId
    beforeMessageId: $beforeMessageId
    perPage: $perPage
    filter: $filter
  ) {
    messages {
      ...MessengerMessageFragment
    }
    has_more
    scheduled_count
  }
}
    ${MessengerMessageFragmentFragmentDoc}`;

/**
 * __useGetConversationMessagesQuery__
 *
 * To run a query within a Vue component, call `useGetConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConversationMessagesQuery({
 *   conversationId: // value for 'conversationId'
 *   beforeMessageId: // value for 'beforeMessageId'
 *   perPage: // value for 'perPage'
 *   filter: // value for 'filter'
 * });
 */
export function useGetConversationMessagesQuery(variables: GetConversationMessagesQueryVariables | VueCompositionApi.Ref<GetConversationMessagesQueryVariables> | ReactiveFunction<GetConversationMessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, variables, options);
}
export function useGetConversationMessagesLazyQuery(variables?: GetConversationMessagesQueryVariables | VueCompositionApi.Ref<GetConversationMessagesQueryVariables> | ReactiveFunction<GetConversationMessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, variables, options);
}
export type GetConversationMessagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>;
export const GetMessengerMessageDocument = gql`
    query GetMessengerMessage($id: ID!) {
  messengerMessage(id: $id) {
    ...MessengerMessageFragment
  }
}
    ${MessengerMessageFragmentFragmentDoc}`;

/**
 * __useGetMessengerMessageQuery__
 *
 * To run a query within a Vue component, call `useGetMessengerMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessengerMessageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMessengerMessageQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMessengerMessageQuery(variables: GetMessengerMessageQueryVariables | VueCompositionApi.Ref<GetMessengerMessageQueryVariables> | ReactiveFunction<GetMessengerMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMessengerMessageQuery, GetMessengerMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerMessageQuery, GetMessengerMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerMessageQuery, GetMessengerMessageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMessengerMessageQuery, GetMessengerMessageQueryVariables>(GetMessengerMessageDocument, variables, options);
}
export function useGetMessengerMessageLazyQuery(variables?: GetMessengerMessageQueryVariables | VueCompositionApi.Ref<GetMessengerMessageQueryVariables> | ReactiveFunction<GetMessengerMessageQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMessengerMessageQuery, GetMessengerMessageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMessengerMessageQuery, GetMessengerMessageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMessengerMessageQuery, GetMessengerMessageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMessengerMessageQuery, GetMessengerMessageQueryVariables>(GetMessengerMessageDocument, variables, options);
}
export type GetMessengerMessageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMessengerMessageQuery, GetMessengerMessageQueryVariables>;
export const SendMessengerMessageDocument = gql`
    mutation SendMessengerMessage($input: SendMessengerMessageInput!) {
  sendMessengerMessage(input: $input) {
    ...MessengerMessageFragment
  }
}
    ${MessengerMessageFragmentFragmentDoc}`;

/**
 * __useSendMessengerMessageMutation__
 *
 * To run a mutation, you first call `useSendMessengerMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendMessengerMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendMessengerMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendMessengerMessageMutation(options: VueApolloComposable.UseMutationOptions<SendMessengerMessageMutation, SendMessengerMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendMessengerMessageMutation, SendMessengerMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendMessengerMessageMutation, SendMessengerMessageMutationVariables>(SendMessengerMessageDocument, options);
}
export type SendMessengerMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendMessengerMessageMutation, SendMessengerMessageMutationVariables>;
export const DeleteMessengerMessageDocument = gql`
    mutation DeleteMessengerMessage($id: ID!) {
  deleteMessengerMessage(id: $id)
}
    `;

/**
 * __useDeleteMessengerMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessengerMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessengerMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMessengerMessageMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessengerMessageMutation(options: VueApolloComposable.UseMutationOptions<DeleteMessengerMessageMutation, DeleteMessengerMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMessengerMessageMutation, DeleteMessengerMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMessengerMessageMutation, DeleteMessengerMessageMutationVariables>(DeleteMessengerMessageDocument, options);
}
export type DeleteMessengerMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMessengerMessageMutation, DeleteMessengerMessageMutationVariables>;
export const MarkConversationAsReadDocument = gql`
    mutation MarkConversationAsRead($conversationId: ID!) {
  markConversationAsRead(conversationId: $conversationId)
}
    `;

/**
 * __useMarkConversationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkConversationAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkConversationAsReadMutation({
 *   variables: {
 *     conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useMarkConversationAsReadMutation(options: VueApolloComposable.UseMutationOptions<MarkConversationAsReadMutation, MarkConversationAsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkConversationAsReadMutation, MarkConversationAsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkConversationAsReadMutation, MarkConversationAsReadMutationVariables>(MarkConversationAsReadDocument, options);
}
export type MarkConversationAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkConversationAsReadMutation, MarkConversationAsReadMutationVariables>;
export const TakeMessengerDialogDocument = gql`
    mutation TakeMessengerDialog($dialogId: ID!) {
  takeMessengerDialog(dialogId: $dialogId) {
    ...MessengerDialogFragment
  }
}
    ${MessengerDialogFragmentFragmentDoc}`;

/**
 * __useTakeMessengerDialogMutation__
 *
 * To run a mutation, you first call `useTakeMessengerDialogMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTakeMessengerDialogMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTakeMessengerDialogMutation({
 *   variables: {
 *     dialogId: // value for 'dialogId'
 *   },
 * });
 */
export function useTakeMessengerDialogMutation(options: VueApolloComposable.UseMutationOptions<TakeMessengerDialogMutation, TakeMessengerDialogMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TakeMessengerDialogMutation, TakeMessengerDialogMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TakeMessengerDialogMutation, TakeMessengerDialogMutationVariables>(TakeMessengerDialogDocument, options);
}
export type TakeMessengerDialogMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TakeMessengerDialogMutation, TakeMessengerDialogMutationVariables>;
export const ResolveMessengerDialogDocument = gql`
    mutation ResolveMessengerDialog($dialogId: ID!) {
  resolveMessengerDialog(dialogId: $dialogId) {
    ...MessengerDialogFragment
  }
}
    ${MessengerDialogFragmentFragmentDoc}`;

/**
 * __useResolveMessengerDialogMutation__
 *
 * To run a mutation, you first call `useResolveMessengerDialogMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResolveMessengerDialogMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResolveMessengerDialogMutation({
 *   variables: {
 *     dialogId: // value for 'dialogId'
 *   },
 * });
 */
export function useResolveMessengerDialogMutation(options: VueApolloComposable.UseMutationOptions<ResolveMessengerDialogMutation, ResolveMessengerDialogMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResolveMessengerDialogMutation, ResolveMessengerDialogMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResolveMessengerDialogMutation, ResolveMessengerDialogMutationVariables>(ResolveMessengerDialogDocument, options);
}
export type ResolveMessengerDialogMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResolveMessengerDialogMutation, ResolveMessengerDialogMutationVariables>;
export const ReassignMessengerDialogDocument = gql`
    mutation ReassignMessengerDialog($dialogId: ID!, $employeeId: ID!) {
  reassignMessengerDialog(dialogId: $dialogId, employeeId: $employeeId) {
    ...MessengerDialogFragment
  }
}
    ${MessengerDialogFragmentFragmentDoc}`;

/**
 * __useReassignMessengerDialogMutation__
 *
 * To run a mutation, you first call `useReassignMessengerDialogMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReassignMessengerDialogMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReassignMessengerDialogMutation({
 *   variables: {
 *     dialogId: // value for 'dialogId'
 *     employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useReassignMessengerDialogMutation(options: VueApolloComposable.UseMutationOptions<ReassignMessengerDialogMutation, ReassignMessengerDialogMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReassignMessengerDialogMutation, ReassignMessengerDialogMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReassignMessengerDialogMutation, ReassignMessengerDialogMutationVariables>(ReassignMessengerDialogDocument, options);
}
export type ReassignMessengerDialogMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReassignMessengerDialogMutation, ReassignMessengerDialogMutationVariables>;
export const UnassignMessengerDialogDocument = gql`
    mutation UnassignMessengerDialog($dialogId: ID!) {
  unassignMessengerDialog(dialogId: $dialogId) {
    ...MessengerDialogFragment
  }
}
    ${MessengerDialogFragmentFragmentDoc}`;

/**
 * __useUnassignMessengerDialogMutation__
 *
 * To run a mutation, you first call `useUnassignMessengerDialogMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnassignMessengerDialogMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnassignMessengerDialogMutation({
 *   variables: {
 *     dialogId: // value for 'dialogId'
 *   },
 * });
 */
export function useUnassignMessengerDialogMutation(options: VueApolloComposable.UseMutationOptions<UnassignMessengerDialogMutation, UnassignMessengerDialogMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnassignMessengerDialogMutation, UnassignMessengerDialogMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnassignMessengerDialogMutation, UnassignMessengerDialogMutationVariables>(UnassignMessengerDialogDocument, options);
}
export type UnassignMessengerDialogMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnassignMessengerDialogMutation, UnassignMessengerDialogMutationVariables>;
export const MarkMessengerDialogAnsweredDocument = gql`
    mutation MarkMessengerDialogAnswered($dialogId: ID!) {
  markMessengerDialogAnswered(dialogId: $dialogId) {
    ...MessengerDialogFragment
  }
}
    ${MessengerDialogFragmentFragmentDoc}`;

/**
 * __useMarkMessengerDialogAnsweredMutation__
 *
 * To run a mutation, you first call `useMarkMessengerDialogAnsweredMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessengerDialogAnsweredMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkMessengerDialogAnsweredMutation({
 *   variables: {
 *     dialogId: // value for 'dialogId'
 *   },
 * });
 */
export function useMarkMessengerDialogAnsweredMutation(options: VueApolloComposable.UseMutationOptions<MarkMessengerDialogAnsweredMutation, MarkMessengerDialogAnsweredMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkMessengerDialogAnsweredMutation, MarkMessengerDialogAnsweredMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkMessengerDialogAnsweredMutation, MarkMessengerDialogAnsweredMutationVariables>(MarkMessengerDialogAnsweredDocument, options);
}
export type MarkMessengerDialogAnsweredMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkMessengerDialogAnsweredMutation, MarkMessengerDialogAnsweredMutationVariables>;
export const GetOrderDocument = gql`
    query GetOrder($id: ID!) {
  order(id: $id) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a Vue component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetOrderQuery(variables: GetOrderQueryVariables | VueCompositionApi.Ref<GetOrderQueryVariables> | ReactiveFunction<GetOrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderQuery, GetOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderQuery, GetOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderQuery, GetOrderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, variables, options);
}
export function useGetOrderLazyQuery(variables?: GetOrderQueryVariables | VueCompositionApi.Ref<GetOrderQueryVariables> | ReactiveFunction<GetOrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderQuery, GetOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderQuery, GetOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderQuery, GetOrderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, variables, options);
}
export type GetOrderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrderPaymentSummaryDocument = gql`
    query GetOrderPaymentSummary($id: ID!) {
  order(id: $id) {
    id
    status
    refunded_amount
    acquiring_instrument
    money_parts {
      id
      method
      amount
      captured_at
    }
    refunds {
      id
      amount
      completed_at
      money_parts {
        money_part_id
        method
      }
    }
  }
}
    `;

/**
 * __useGetOrderPaymentSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetOrderPaymentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPaymentSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderPaymentSummaryQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetOrderPaymentSummaryQuery(variables: GetOrderPaymentSummaryQueryVariables | VueCompositionApi.Ref<GetOrderPaymentSummaryQueryVariables> | ReactiveFunction<GetOrderPaymentSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables>(GetOrderPaymentSummaryDocument, variables, options);
}
export function useGetOrderPaymentSummaryLazyQuery(variables?: GetOrderPaymentSummaryQueryVariables | VueCompositionApi.Ref<GetOrderPaymentSummaryQueryVariables> | ReactiveFunction<GetOrderPaymentSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables>(GetOrderPaymentSummaryDocument, variables, options);
}
export type GetOrderPaymentSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderPaymentSummaryQuery, GetOrderPaymentSummaryQueryVariables>;
export const GetOrderByBookingGroupDocument = gql`
    query GetOrderByBookingGroup($bookingGroupId: ID!) {
  orderByBookingGroup(bookingGroupId: $bookingGroupId) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useGetOrderByBookingGroupQuery__
 *
 * To run a query within a Vue component, call `useGetOrderByBookingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderByBookingGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderByBookingGroupQuery({
 *   bookingGroupId: // value for 'bookingGroupId'
 * });
 */
export function useGetOrderByBookingGroupQuery(variables: GetOrderByBookingGroupQueryVariables | VueCompositionApi.Ref<GetOrderByBookingGroupQueryVariables> | ReactiveFunction<GetOrderByBookingGroupQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables>(GetOrderByBookingGroupDocument, variables, options);
}
export function useGetOrderByBookingGroupLazyQuery(variables?: GetOrderByBookingGroupQueryVariables | VueCompositionApi.Ref<GetOrderByBookingGroupQueryVariables> | ReactiveFunction<GetOrderByBookingGroupQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables>(GetOrderByBookingGroupDocument, variables, options);
}
export type GetOrderByBookingGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderByBookingGroupQuery, GetOrderByBookingGroupQueryVariables>;
export const GetOrderCheckoutContextDocument = gql`
    query GetOrderCheckoutContext($orderId: ID!) {
  orderCheckoutContext(orderId: $orderId) {
    ...OrderCheckoutContextFields
  }
}
    ${OrderCheckoutContextFieldsFragmentDoc}`;

/**
 * __useGetOrderCheckoutContextQuery__
 *
 * To run a query within a Vue component, call `useGetOrderCheckoutContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderCheckoutContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderCheckoutContextQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetOrderCheckoutContextQuery(variables: GetOrderCheckoutContextQueryVariables | VueCompositionApi.Ref<GetOrderCheckoutContextQueryVariables> | ReactiveFunction<GetOrderCheckoutContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables>(GetOrderCheckoutContextDocument, variables, options);
}
export function useGetOrderCheckoutContextLazyQuery(variables?: GetOrderCheckoutContextQueryVariables | VueCompositionApi.Ref<GetOrderCheckoutContextQueryVariables> | ReactiveFunction<GetOrderCheckoutContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables>(GetOrderCheckoutContextDocument, variables, options);
}
export type GetOrderCheckoutContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderCheckoutContextQuery, GetOrderCheckoutContextQueryVariables>;
export const GetOrderRefundApprovalsDocument = gql`
    query GetOrderRefundApprovals($live: Boolean, $first: Int!, $after: String) {
  orderRefundApprovals(live: $live, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...OrderRefundApprovalFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${OrderRefundApprovalFieldsFragmentDoc}`;

/**
 * __useGetOrderRefundApprovalsQuery__
 *
 * To run a query within a Vue component, call `useGetOrderRefundApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderRefundApprovalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderRefundApprovalsQuery({
 *   live: // value for 'live'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetOrderRefundApprovalsQuery(variables: GetOrderRefundApprovalsQueryVariables | VueCompositionApi.Ref<GetOrderRefundApprovalsQueryVariables> | ReactiveFunction<GetOrderRefundApprovalsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables>(GetOrderRefundApprovalsDocument, variables, options);
}
export function useGetOrderRefundApprovalsLazyQuery(variables?: GetOrderRefundApprovalsQueryVariables | VueCompositionApi.Ref<GetOrderRefundApprovalsQueryVariables> | ReactiveFunction<GetOrderRefundApprovalsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables>(GetOrderRefundApprovalsDocument, variables, options);
}
export type GetOrderRefundApprovalsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderRefundApprovalsQuery, GetOrderRefundApprovalsQueryVariables>;
export const GetRecentLocationOrdersDocument = gql`
    query GetRecentLocationOrders($first: Int!, $after: String) {
  recentLocationOrders(first: $first, after: $after) {
    edges {
      cursor
      node {
        ...OrderListFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${OrderListFieldsFragmentDoc}`;

/**
 * __useGetRecentLocationOrdersQuery__
 *
 * To run a query within a Vue component, call `useGetRecentLocationOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentLocationOrdersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRecentLocationOrdersQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetRecentLocationOrdersQuery(variables: GetRecentLocationOrdersQueryVariables | VueCompositionApi.Ref<GetRecentLocationOrdersQueryVariables> | ReactiveFunction<GetRecentLocationOrdersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables>(GetRecentLocationOrdersDocument, variables, options);
}
export function useGetRecentLocationOrdersLazyQuery(variables?: GetRecentLocationOrdersQueryVariables | VueCompositionApi.Ref<GetRecentLocationOrdersQueryVariables> | ReactiveFunction<GetRecentLocationOrdersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables>(GetRecentLocationOrdersDocument, variables, options);
}
export type GetRecentLocationOrdersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRecentLocationOrdersQuery, GetRecentLocationOrdersQueryVariables>;
export const GetSwitchableOrganizationsDocument = gql`
    query GetSwitchableOrganizations($search: String, $first: Int!, $after: String) {
  switchableOrganizations(search: $search, first: $first, after: $after) {
    edges {
      node {
        id
        title
        access
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    `;

/**
 * __useGetSwitchableOrganizationsQuery__
 *
 * To run a query within a Vue component, call `useGetSwitchableOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchableOrganizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSwitchableOrganizationsQuery({
 *   search: // value for 'search'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetSwitchableOrganizationsQuery(variables: GetSwitchableOrganizationsQueryVariables | VueCompositionApi.Ref<GetSwitchableOrganizationsQueryVariables> | ReactiveFunction<GetSwitchableOrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables>(GetSwitchableOrganizationsDocument, variables, options);
}
export function useGetSwitchableOrganizationsLazyQuery(variables?: GetSwitchableOrganizationsQueryVariables | VueCompositionApi.Ref<GetSwitchableOrganizationsQueryVariables> | ReactiveFunction<GetSwitchableOrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables>(GetSwitchableOrganizationsDocument, variables, options);
}
export type GetSwitchableOrganizationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables>;
export const GetPaymentJournalDocument = gql`
    query GetPaymentJournal($filter: PaymentJournalFilter, $first: Int!, $after: String) {
  paymentJournal(filter: $filter, first: $first, after: $after) {
    edges {
      cursor
      node {
        key
        id
        payment_id
        kind
        amount
        provider
        methods
        transfer_details {
          payment_order_number
          received_on
          invoice_number
        }
        receipt_operation
        receipt_settlement_method
        receipt_fd_number
        receipt_issuer
        receipts_count
        location_id
        location_title
        timezone
        created_at
        actor_title
        reason
        payment_captured_at
        failure_kind
        failure_message
        failure_reason_code
        source_summary {
          customer_name
          description
        }
        money_status
        receipt_status
        attention_reasons
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    `;

/**
 * __useGetPaymentJournalQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentJournalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentJournalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentJournalQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetPaymentJournalQuery(variables: GetPaymentJournalQueryVariables | VueCompositionApi.Ref<GetPaymentJournalQueryVariables> | ReactiveFunction<GetPaymentJournalQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentJournalQuery, GetPaymentJournalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentJournalQuery, GetPaymentJournalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentJournalQuery, GetPaymentJournalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaymentJournalQuery, GetPaymentJournalQueryVariables>(GetPaymentJournalDocument, variables, options);
}
export function useGetPaymentJournalLazyQuery(variables?: GetPaymentJournalQueryVariables | VueCompositionApi.Ref<GetPaymentJournalQueryVariables> | ReactiveFunction<GetPaymentJournalQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentJournalQuery, GetPaymentJournalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentJournalQuery, GetPaymentJournalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentJournalQuery, GetPaymentJournalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaymentJournalQuery, GetPaymentJournalQueryVariables>(GetPaymentJournalDocument, variables, options);
}
export type GetPaymentJournalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaymentJournalQuery, GetPaymentJournalQueryVariables>;
export const GetPaymentDocument = gql`
    query GetPayment($id: ID!) {
  payment(id: $id) {
    ...PaymentDetailsFields
  }
}
    ${PaymentDetailsFieldsFragmentDoc}`;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPaymentQuery(variables: GetPaymentQueryVariables | VueCompositionApi.Ref<GetPaymentQueryVariables> | ReactiveFunction<GetPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentQuery, GetPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentQuery, GetPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentQuery, GetPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, variables, options);
}
export function useGetPaymentLazyQuery(variables?: GetPaymentQueryVariables | VueCompositionApi.Ref<GetPaymentQueryVariables> | ReactiveFunction<GetPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentQuery, GetPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentQuery, GetPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentQuery, GetPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, variables, options);
}
export type GetPaymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaymentQuery, GetPaymentQueryVariables>;
export const GetPersonNameSuggestionsDocument = gql`
    query GetPersonNameSuggestions($kind: PersonNameKind!, $query: String!, $firstName: String) {
  personNameSuggestions(kind: $kind, query: $query, firstName: $firstName) {
    items {
      text
    }
    correction
    split {
      first_name
      last_name
      patronymic_name
    }
  }
}
    `;

/**
 * __useGetPersonNameSuggestionsQuery__
 *
 * To run a query within a Vue component, call `useGetPersonNameSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonNameSuggestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPersonNameSuggestionsQuery({
 *   kind: // value for 'kind'
 *   query: // value for 'query'
 *   firstName: // value for 'firstName'
 * });
 */
export function useGetPersonNameSuggestionsQuery(variables: GetPersonNameSuggestionsQueryVariables | VueCompositionApi.Ref<GetPersonNameSuggestionsQueryVariables> | ReactiveFunction<GetPersonNameSuggestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables>(GetPersonNameSuggestionsDocument, variables, options);
}
export function useGetPersonNameSuggestionsLazyQuery(variables?: GetPersonNameSuggestionsQueryVariables | VueCompositionApi.Ref<GetPersonNameSuggestionsQueryVariables> | ReactiveFunction<GetPersonNameSuggestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables>(GetPersonNameSuggestionsDocument, variables, options);
}
export type GetPersonNameSuggestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPersonNameSuggestionsQuery, GetPersonNameSuggestionsQueryVariables>;
export const GetPlatformOrganizationsDocument = gql`
    query GetPlatformOrganizations($search: String, $first: Int!, $after: String) {
  platformOrganizations(search: $search, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...PlatformOrganizationRowFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${PlatformOrganizationRowFieldsFragmentDoc}`;

/**
 * __useGetPlatformOrganizationsQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformOrganizationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformOrganizationsQuery({
 *   search: // value for 'search'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetPlatformOrganizationsQuery(variables: GetPlatformOrganizationsQueryVariables | VueCompositionApi.Ref<GetPlatformOrganizationsQueryVariables> | ReactiveFunction<GetPlatformOrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables>(GetPlatformOrganizationsDocument, variables, options);
}
export function useGetPlatformOrganizationsLazyQuery(variables?: GetPlatformOrganizationsQueryVariables | VueCompositionApi.Ref<GetPlatformOrganizationsQueryVariables> | ReactiveFunction<GetPlatformOrganizationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables>(GetPlatformOrganizationsDocument, variables, options);
}
export type GetPlatformOrganizationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformOrganizationsQuery, GetPlatformOrganizationsQueryVariables>;
export const GetPlatformUsersDocument = gql`
    query GetPlatformUsers($search: String, $organizationId: ID, $orderBy: PlatformUserSortField, $sortOrder: SortOrder, $first: Int!, $after: String) {
  platformUsers(
    search: $search
    organizationId: $organizationId
    orderBy: $orderBy
    sortOrder: $sortOrder
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...PlatformUserRowFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${PlatformUserRowFieldsFragmentDoc}`;

/**
 * __useGetPlatformUsersQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformUsersQuery({
 *   search: // value for 'search'
 *   organizationId: // value for 'organizationId'
 *   orderBy: // value for 'orderBy'
 *   sortOrder: // value for 'sortOrder'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetPlatformUsersQuery(variables: GetPlatformUsersQueryVariables | VueCompositionApi.Ref<GetPlatformUsersQueryVariables> | ReactiveFunction<GetPlatformUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>(GetPlatformUsersDocument, variables, options);
}
export function useGetPlatformUsersLazyQuery(variables?: GetPlatformUsersQueryVariables | VueCompositionApi.Ref<GetPlatformUsersQueryVariables> | ReactiveFunction<GetPlatformUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>(GetPlatformUsersDocument, variables, options);
}
export type GetPlatformUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>;
export const GetPlatformOrganizationDocument = gql`
    query GetPlatformOrganization($organizationSearch: String!, $organizationId: ID!, $first: Int!) {
  platformOrganizations(search: $organizationSearch, first: 1) {
    edges {
      node {
        ...PlatformOrganizationRowFields
      }
    }
  }
  platformUsers(organizationId: $organizationId, first: $first) {
    edges {
      node {
        ...PlatformUserRowFields
      }
    }
    pageInfo {
      total
    }
  }
}
    ${PlatformOrganizationRowFieldsFragmentDoc}
${PlatformUserRowFieldsFragmentDoc}`;

/**
 * __useGetPlatformOrganizationQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformOrganizationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformOrganizationQuery({
 *   organizationSearch: // value for 'organizationSearch'
 *   organizationId: // value for 'organizationId'
 *   first: // value for 'first'
 * });
 */
export function useGetPlatformOrganizationQuery(variables: GetPlatformOrganizationQueryVariables | VueCompositionApi.Ref<GetPlatformOrganizationQueryVariables> | ReactiveFunction<GetPlatformOrganizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables>(GetPlatformOrganizationDocument, variables, options);
}
export function useGetPlatformOrganizationLazyQuery(variables?: GetPlatformOrganizationQueryVariables | VueCompositionApi.Ref<GetPlatformOrganizationQueryVariables> | ReactiveFunction<GetPlatformOrganizationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables>(GetPlatformOrganizationDocument, variables, options);
}
export type GetPlatformOrganizationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformOrganizationQuery, GetPlatformOrganizationQueryVariables>;
export const StartPlatformImpersonationDocument = gql`
    mutation StartPlatformImpersonation($input: PlatformStartImpersonationInput!) {
  platformStartImpersonation(input: $input) {
    active
    session_id
    started_at
    target_user {
      id
      first_name
      last_name
      patronymic_name
      phone
    }
    organization {
      id
      title
    }
  }
}
    `;

/**
 * __useStartPlatformImpersonationMutation__
 *
 * To run a mutation, you first call `useStartPlatformImpersonationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartPlatformImpersonationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartPlatformImpersonationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useStartPlatformImpersonationMutation(options: VueApolloComposable.UseMutationOptions<StartPlatformImpersonationMutation, StartPlatformImpersonationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartPlatformImpersonationMutation, StartPlatformImpersonationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StartPlatformImpersonationMutation, StartPlatformImpersonationMutationVariables>(StartPlatformImpersonationDocument, options);
}
export type StartPlatformImpersonationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartPlatformImpersonationMutation, StartPlatformImpersonationMutationVariables>;
export const EnterOrganizationAsOwnerDocument = gql`
    mutation EnterOrganizationAsOwner($organizationId: ID!) {
  enterOrganizationAsOwner(organizationId: $organizationId) {
    active
    organization {
      id
    }
  }
}
    `;

/**
 * __useEnterOrganizationAsOwnerMutation__
 *
 * To run a mutation, you first call `useEnterOrganizationAsOwnerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnterOrganizationAsOwnerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnterOrganizationAsOwnerMutation({
 *   variables: {
 *     organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEnterOrganizationAsOwnerMutation(options: VueApolloComposable.UseMutationOptions<EnterOrganizationAsOwnerMutation, EnterOrganizationAsOwnerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnterOrganizationAsOwnerMutation, EnterOrganizationAsOwnerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EnterOrganizationAsOwnerMutation, EnterOrganizationAsOwnerMutationVariables>(EnterOrganizationAsOwnerDocument, options);
}
export type EnterOrganizationAsOwnerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EnterOrganizationAsOwnerMutation, EnterOrganizationAsOwnerMutationVariables>;
export const StopPlatformImpersonationDocument = gql`
    mutation StopPlatformImpersonation {
  platformStopImpersonation {
    active
    impersonator {
      id
      first_name
      last_name
      phone
      is_super_user
    }
  }
}
    `;

/**
 * __useStopPlatformImpersonationMutation__
 *
 * To run a mutation, you first call `useStopPlatformImpersonationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopPlatformImpersonationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopPlatformImpersonationMutation();
 */
export function useStopPlatformImpersonationMutation(options: VueApolloComposable.UseMutationOptions<StopPlatformImpersonationMutation, StopPlatformImpersonationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StopPlatformImpersonationMutation, StopPlatformImpersonationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StopPlatformImpersonationMutation, StopPlatformImpersonationMutationVariables>(StopPlatformImpersonationDocument, options);
}
export type StopPlatformImpersonationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StopPlatformImpersonationMutation, StopPlatformImpersonationMutationVariables>;
export const SetPlatformOrganizationModulesDocument = gql`
    mutation SetPlatformOrganizationModules($input: PlatformSetOrganizationModulesInput!) {
  platformSetOrganizationModules(input: $input) {
    id
    enabled_modules
  }
}
    `;

/**
 * __useSetPlatformOrganizationModulesMutation__
 *
 * To run a mutation, you first call `useSetPlatformOrganizationModulesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPlatformOrganizationModulesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPlatformOrganizationModulesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetPlatformOrganizationModulesMutation(options: VueApolloComposable.UseMutationOptions<SetPlatformOrganizationModulesMutation, SetPlatformOrganizationModulesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetPlatformOrganizationModulesMutation, SetPlatformOrganizationModulesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetPlatformOrganizationModulesMutation, SetPlatformOrganizationModulesMutationVariables>(SetPlatformOrganizationModulesDocument, options);
}
export type SetPlatformOrganizationModulesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetPlatformOrganizationModulesMutation, SetPlatformOrganizationModulesMutationVariables>;
export const ForceStopPlatformImpersonationSessionDocument = gql`
    mutation ForceStopPlatformImpersonationSession($id: ID!) {
  platformForceStopImpersonationSession(id: $id) {
    ...PlatformImpersonationSessionRowFields
  }
}
    ${PlatformImpersonationSessionRowFieldsFragmentDoc}`;

/**
 * __useForceStopPlatformImpersonationSessionMutation__
 *
 * To run a mutation, you first call `useForceStopPlatformImpersonationSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForceStopPlatformImpersonationSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForceStopPlatformImpersonationSessionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useForceStopPlatformImpersonationSessionMutation(options: VueApolloComposable.UseMutationOptions<ForceStopPlatformImpersonationSessionMutation, ForceStopPlatformImpersonationSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ForceStopPlatformImpersonationSessionMutation, ForceStopPlatformImpersonationSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ForceStopPlatformImpersonationSessionMutation, ForceStopPlatformImpersonationSessionMutationVariables>(ForceStopPlatformImpersonationSessionDocument, options);
}
export type ForceStopPlatformImpersonationSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ForceStopPlatformImpersonationSessionMutation, ForceStopPlatformImpersonationSessionMutationVariables>;
export const GetPlatformImpersonationSessionsDocument = gql`
    query GetPlatformImpersonationSessions($targetUserId: ID, $organizationId: ID, $active: Boolean, $first: Int!, $after: String) {
  platformImpersonationSessions(
    targetUserId: $targetUserId
    organizationId: $organizationId
    active: $active
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...PlatformImpersonationSessionRowFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${PlatformImpersonationSessionRowFieldsFragmentDoc}`;

/**
 * __useGetPlatformImpersonationSessionsQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformImpersonationSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformImpersonationSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformImpersonationSessionsQuery({
 *   targetUserId: // value for 'targetUserId'
 *   organizationId: // value for 'organizationId'
 *   active: // value for 'active'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetPlatformImpersonationSessionsQuery(variables: GetPlatformImpersonationSessionsQueryVariables | VueCompositionApi.Ref<GetPlatformImpersonationSessionsQueryVariables> | ReactiveFunction<GetPlatformImpersonationSessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables>(GetPlatformImpersonationSessionsDocument, variables, options);
}
export function useGetPlatformImpersonationSessionsLazyQuery(variables?: GetPlatformImpersonationSessionsQueryVariables | VueCompositionApi.Ref<GetPlatformImpersonationSessionsQueryVariables> | ReactiveFunction<GetPlatformImpersonationSessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables>(GetPlatformImpersonationSessionsDocument, variables, options);
}
export type GetPlatformImpersonationSessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformImpersonationSessionsQuery, GetPlatformImpersonationSessionsQueryVariables>;
export const GetPlatformImpersonationActionsDocument = gql`
    query GetPlatformImpersonationActions($sessionId: ID!, $first: Int!, $after: String) {
  platformImpersonationActions(
    sessionId: $sessionId
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...PlatformImpersonationActionRowFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${PlatformImpersonationActionRowFieldsFragmentDoc}`;

/**
 * __useGetPlatformImpersonationActionsQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformImpersonationActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformImpersonationActionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformImpersonationActionsQuery({
 *   sessionId: // value for 'sessionId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetPlatformImpersonationActionsQuery(variables: GetPlatformImpersonationActionsQueryVariables | VueCompositionApi.Ref<GetPlatformImpersonationActionsQueryVariables> | ReactiveFunction<GetPlatformImpersonationActionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables>(GetPlatformImpersonationActionsDocument, variables, options);
}
export function useGetPlatformImpersonationActionsLazyQuery(variables?: GetPlatformImpersonationActionsQueryVariables | VueCompositionApi.Ref<GetPlatformImpersonationActionsQueryVariables> | ReactiveFunction<GetPlatformImpersonationActionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables>(GetPlatformImpersonationActionsDocument, variables, options);
}
export type GetPlatformImpersonationActionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformImpersonationActionsQuery, GetPlatformImpersonationActionsQueryVariables>;
export const GetPlatformUserDocument = gql`
    query GetPlatformUser($id: ID!, $first: Int!, $after: String) {
  platformUser(id: $id) {
    ...PlatformUserRowFields
  }
  platformImpersonationSessions(targetUserId: $id, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...PlatformImpersonationSessionRowFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${PlatformUserRowFieldsFragmentDoc}
${PlatformImpersonationSessionRowFieldsFragmentDoc}`;

/**
 * __useGetPlatformUserQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformUserQuery({
 *   id: // value for 'id'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetPlatformUserQuery(variables: GetPlatformUserQueryVariables | VueCompositionApi.Ref<GetPlatformUserQueryVariables> | ReactiveFunction<GetPlatformUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformUserQuery, GetPlatformUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformUserQuery, GetPlatformUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformUserQuery, GetPlatformUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformUserQuery, GetPlatformUserQueryVariables>(GetPlatformUserDocument, variables, options);
}
export function useGetPlatformUserLazyQuery(variables?: GetPlatformUserQueryVariables | VueCompositionApi.Ref<GetPlatformUserQueryVariables> | ReactiveFunction<GetPlatformUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformUserQuery, GetPlatformUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformUserQuery, GetPlatformUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformUserQuery, GetPlatformUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformUserQuery, GetPlatformUserQueryVariables>(GetPlatformUserDocument, variables, options);
}
export type GetPlatformUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformUserQuery, GetPlatformUserQueryVariables>;
export const GetPlatformOverviewDocument = gql`
    query GetPlatformOverview($period: PlatformOverviewPeriod!, $organizationId: ID) {
  platformOverview(period: $period, organizationId: $organizationId) {
    granularity
    buckets
    bookings {
      total
      previous_total
      previous
      by_source {
        source
        total
        values
      }
    }
    turnover {
      total
      previous_total
      previous
      by_provider {
        provider
        total
        values
      }
    }
    new_clients {
      total
      previous_total
      values
    }
    messages {
      incoming_total
      outgoing_total
      previous_total
      previous
      by_provider {
        provider
        incoming
        outgoing
        values
      }
    }
    organizations {
      organization {
        id
        title
        domain
      }
      total
      previous_total
      values
    }
  }
}
    `;

/**
 * __useGetPlatformOverviewQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformOverviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformOverviewQuery({
 *   period: // value for 'period'
 *   organizationId: // value for 'organizationId'
 * });
 */
export function useGetPlatformOverviewQuery(variables: GetPlatformOverviewQueryVariables | VueCompositionApi.Ref<GetPlatformOverviewQueryVariables> | ReactiveFunction<GetPlatformOverviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables>(GetPlatformOverviewDocument, variables, options);
}
export function useGetPlatformOverviewLazyQuery(variables?: GetPlatformOverviewQueryVariables | VueCompositionApi.Ref<GetPlatformOverviewQueryVariables> | ReactiveFunction<GetPlatformOverviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables>(GetPlatformOverviewDocument, variables, options);
}
export type GetPlatformOverviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformOverviewQuery, GetPlatformOverviewQueryVariables>;
export const GetPlatformActivityFeedDocument = gql`
    query GetPlatformActivityFeed($kinds: [PlatformActivityKind!], $organizationId: ID, $before: String) {
  platformActivityFeed(
    kinds: $kinds
    organizationId: $organizationId
    before: $before
  ) {
    id
    cursor
    kind
    occurred_at
    organization {
      id
      title
    }
    location {
      id
      title
      timezone
    }
    booking_source
    payment_provider
    order_source
    amount
    scheduled_for
  }
}
    `;

/**
 * __useGetPlatformActivityFeedQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformActivityFeedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformActivityFeedQuery({
 *   kinds: // value for 'kinds'
 *   organizationId: // value for 'organizationId'
 *   before: // value for 'before'
 * });
 */
export function useGetPlatformActivityFeedQuery(variables: GetPlatformActivityFeedQueryVariables | VueCompositionApi.Ref<GetPlatformActivityFeedQueryVariables> | ReactiveFunction<GetPlatformActivityFeedQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables>(GetPlatformActivityFeedDocument, variables, options);
}
export function useGetPlatformActivityFeedLazyQuery(variables: GetPlatformActivityFeedQueryVariables | VueCompositionApi.Ref<GetPlatformActivityFeedQueryVariables> | ReactiveFunction<GetPlatformActivityFeedQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables>(GetPlatformActivityFeedDocument, variables, options);
}
export type GetPlatformActivityFeedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformActivityFeedQuery, GetPlatformActivityFeedQueryVariables>;
export const GetPlatformQueueStatsDocument = gql`
    query GetPlatformQueueStats {
  platformQueueStats {
    queue
    pending
    oldest_pending_seconds
    failed_last_day
  }
}
    `;

/**
 * __useGetPlatformQueueStatsQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformQueueStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformQueueStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformQueueStatsQuery();
 */
export function useGetPlatformQueueStatsQuery(options: VueApolloComposable.UseQueryOptions<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables>(GetPlatformQueueStatsDocument, {}, options);
}
export function useGetPlatformQueueStatsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables>(GetPlatformQueueStatsDocument, {}, options);
}
export type GetPlatformQueueStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformQueueStatsQuery, GetPlatformQueueStatsQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($search: String, $first: Int!, $after: String) {
  products(search: $search, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...ProductFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a Vue component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProductsQuery({
 *   search: // value for 'search'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetProductsQuery(variables: GetProductsQueryVariables | VueCompositionApi.Ref<GetProductsQueryVariables> | ReactiveFunction<GetProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductsQuery, GetProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductsQuery, GetProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductsQuery, GetProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, variables, options);
}
export function useGetProductsLazyQuery(variables?: GetProductsQueryVariables | VueCompositionApi.Ref<GetProductsQueryVariables> | ReactiveFunction<GetProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductsQuery, GetProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductsQuery, GetProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductsQuery, GetProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, variables, options);
}
export type GetProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($id: ID!) {
  product(id: $id) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a Vue component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProductQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetProductQuery(variables: GetProductQueryVariables | VueCompositionApi.Ref<GetProductQueryVariables> | ReactiveFunction<GetProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductQuery, GetProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductQuery, GetProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductQuery, GetProductQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, variables, options);
}
export function useGetProductLazyQuery(variables?: GetProductQueryVariables | VueCompositionApi.Ref<GetProductQueryVariables> | ReactiveFunction<GetProductQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductQuery, GetProductQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductQuery, GetProductQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductQuery, GetProductQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, variables, options);
}
export type GetProductQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProductQuery, GetProductQueryVariables>;
export const GetProductMovementsDocument = gql`
    query GetProductMovements($productId: ID!, $first: Int!, $after: String) {
  productMovements(productId: $productId, first: $first, after: $after) {
    edges {
      cursor
      node {
        ...ProductMovementFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${ProductMovementFieldsFragmentDoc}`;

/**
 * __useGetProductMovementsQuery__
 *
 * To run a query within a Vue component, call `useGetProductMovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductMovementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProductMovementsQuery({
 *   productId: // value for 'productId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetProductMovementsQuery(variables: GetProductMovementsQueryVariables | VueCompositionApi.Ref<GetProductMovementsQueryVariables> | ReactiveFunction<GetProductMovementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductMovementsQuery, GetProductMovementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductMovementsQuery, GetProductMovementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductMovementsQuery, GetProductMovementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProductMovementsQuery, GetProductMovementsQueryVariables>(GetProductMovementsDocument, variables, options);
}
export function useGetProductMovementsLazyQuery(variables?: GetProductMovementsQueryVariables | VueCompositionApi.Ref<GetProductMovementsQueryVariables> | ReactiveFunction<GetProductMovementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductMovementsQuery, GetProductMovementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductMovementsQuery, GetProductMovementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductMovementsQuery, GetProductMovementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProductMovementsQuery, GetProductMovementsQueryVariables>(GetProductMovementsDocument, variables, options);
}
export type GetProductMovementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProductMovementsQuery, GetProductMovementsQueryVariables>;
export const GetShowcaseProductsDocument = gql`
    query GetShowcaseProducts($locationId: ID!, $search: String, $first: Int!, $after: String) {
  showcaseProducts(
    locationId: $locationId
    search: $search
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        stock_quantity
        product {
          ...ShowcaseProductFields
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${ShowcaseProductFieldsFragmentDoc}`;

/**
 * __useGetShowcaseProductsQuery__
 *
 * To run a query within a Vue component, call `useGetShowcaseProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowcaseProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetShowcaseProductsQuery({
 *   locationId: // value for 'locationId'
 *   search: // value for 'search'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetShowcaseProductsQuery(variables: GetShowcaseProductsQueryVariables | VueCompositionApi.Ref<GetShowcaseProductsQueryVariables> | ReactiveFunction<GetShowcaseProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables>(GetShowcaseProductsDocument, variables, options);
}
export function useGetShowcaseProductsLazyQuery(variables?: GetShowcaseProductsQueryVariables | VueCompositionApi.Ref<GetShowcaseProductsQueryVariables> | ReactiveFunction<GetShowcaseProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables>(GetShowcaseProductsDocument, variables, options);
}
export type GetShowcaseProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetShowcaseProductsQuery, GetShowcaseProductsQueryVariables>;
export const GetStockProductsDocument = gql`
    query GetStockProducts($locationId: ID!, $search: String, $productId: ID, $first: Int!, $after: String) {
  stockProducts(
    locationId: $locationId
    search: $search
    productId: $productId
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        stock_quantity
        product {
          ...ShowcaseProductFields
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${ShowcaseProductFieldsFragmentDoc}`;

/**
 * __useGetStockProductsQuery__
 *
 * To run a query within a Vue component, call `useGetStockProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStockProductsQuery({
 *   locationId: // value for 'locationId'
 *   search: // value for 'search'
 *   productId: // value for 'productId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetStockProductsQuery(variables: GetStockProductsQueryVariables | VueCompositionApi.Ref<GetStockProductsQueryVariables> | ReactiveFunction<GetStockProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStockProductsQuery, GetStockProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStockProductsQuery, GetStockProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStockProductsQuery, GetStockProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStockProductsQuery, GetStockProductsQueryVariables>(GetStockProductsDocument, variables, options);
}
export function useGetStockProductsLazyQuery(variables?: GetStockProductsQueryVariables | VueCompositionApi.Ref<GetStockProductsQueryVariables> | ReactiveFunction<GetStockProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStockProductsQuery, GetStockProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStockProductsQuery, GetStockProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStockProductsQuery, GetStockProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetStockProductsQuery, GetStockProductsQueryVariables>(GetStockProductsDocument, variables, options);
}
export type GetStockProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStockProductsQuery, GetStockProductsQueryVariables>;
export const GetStockBalancesDocument = gql`
    query GetStockBalances($locationId: ID, $search: String, $productId: ID, $first: Int!, $after: String) {
  stockBalances(
    locationId: $locationId
    search: $search
    productId: $productId
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...StockBalanceFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${StockBalanceFieldsFragmentDoc}`;

/**
 * __useGetStockBalancesQuery__
 *
 * To run a query within a Vue component, call `useGetStockBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockBalancesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStockBalancesQuery({
 *   locationId: // value for 'locationId'
 *   search: // value for 'search'
 *   productId: // value for 'productId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetStockBalancesQuery(variables: GetStockBalancesQueryVariables | VueCompositionApi.Ref<GetStockBalancesQueryVariables> | ReactiveFunction<GetStockBalancesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStockBalancesQuery, GetStockBalancesQueryVariables>(GetStockBalancesDocument, variables, options);
}
export function useGetStockBalancesLazyQuery(variables?: GetStockBalancesQueryVariables | VueCompositionApi.Ref<GetStockBalancesQueryVariables> | ReactiveFunction<GetStockBalancesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetStockBalancesQuery, GetStockBalancesQueryVariables>(GetStockBalancesDocument, variables, options);
}
export type GetStockBalancesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStockBalancesQuery, GetStockBalancesQueryVariables>;
export const GetStockMovementsDocument = gql`
    query GetStockMovements($locationId: ID!, $productId: ID, $first: Int!, $after: String) {
  stockMovements(
    locationId: $locationId
    productId: $productId
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...ProductMovementFields
        product {
          id
          title
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${ProductMovementFieldsFragmentDoc}`;

/**
 * __useGetStockMovementsQuery__
 *
 * To run a query within a Vue component, call `useGetStockMovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockMovementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStockMovementsQuery({
 *   locationId: // value for 'locationId'
 *   productId: // value for 'productId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetStockMovementsQuery(variables: GetStockMovementsQueryVariables | VueCompositionApi.Ref<GetStockMovementsQueryVariables> | ReactiveFunction<GetStockMovementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStockMovementsQuery, GetStockMovementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStockMovementsQuery, GetStockMovementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStockMovementsQuery, GetStockMovementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStockMovementsQuery, GetStockMovementsQueryVariables>(GetStockMovementsDocument, variables, options);
}
export function useGetStockMovementsLazyQuery(variables?: GetStockMovementsQueryVariables | VueCompositionApi.Ref<GetStockMovementsQueryVariables> | ReactiveFunction<GetStockMovementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStockMovementsQuery, GetStockMovementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStockMovementsQuery, GetStockMovementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStockMovementsQuery, GetStockMovementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetStockMovementsQuery, GetStockMovementsQueryVariables>(GetStockMovementsDocument, variables, options);
}
export type GetStockMovementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStockMovementsQuery, GetStockMovementsQueryVariables>;
export const GetProductUnitDocument = gql`
    query GetProductUnit($code: String!) {
  productUnit(code: $code) {
    code
    status
    location {
      id
      title
    }
    product {
      id
      title
    }
  }
}
    `;

/**
 * __useGetProductUnitQuery__
 *
 * To run a query within a Vue component, call `useGetProductUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductUnitQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProductUnitQuery({
 *   code: // value for 'code'
 * });
 */
export function useGetProductUnitQuery(variables: GetProductUnitQueryVariables | VueCompositionApi.Ref<GetProductUnitQueryVariables> | ReactiveFunction<GetProductUnitQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductUnitQuery, GetProductUnitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductUnitQuery, GetProductUnitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductUnitQuery, GetProductUnitQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProductUnitQuery, GetProductUnitQueryVariables>(GetProductUnitDocument, variables, options);
}
export function useGetProductUnitLazyQuery(variables?: GetProductUnitQueryVariables | VueCompositionApi.Ref<GetProductUnitQueryVariables> | ReactiveFunction<GetProductUnitQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetProductUnitQuery, GetProductUnitQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProductUnitQuery, GetProductUnitQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProductUnitQuery, GetProductUnitQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProductUnitQuery, GetProductUnitQueryVariables>(GetProductUnitDocument, variables, options);
}
export type GetProductUnitQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProductUnitQuery, GetProductUnitQueryVariables>;
export const GetQrLinksDocument = gql`
    query GetQrLinks {
  qrLinks {
    ...QrLinkFragment
  }
}
    ${QrLinkFragmentFragmentDoc}`;

/**
 * __useGetQrLinksQuery__
 *
 * To run a query within a Vue component, call `useGetQrLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQrLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQrLinksQuery();
 */
export function useGetQrLinksQuery(options: VueApolloComposable.UseQueryOptions<GetQrLinksQuery, GetQrLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQrLinksQuery, GetQrLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQrLinksQuery, GetQrLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQrLinksQuery, GetQrLinksQueryVariables>(GetQrLinksDocument, {}, options);
}
export function useGetQrLinksLazyQuery(options: VueApolloComposable.UseQueryOptions<GetQrLinksQuery, GetQrLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQrLinksQuery, GetQrLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQrLinksQuery, GetQrLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQrLinksQuery, GetQrLinksQueryVariables>(GetQrLinksDocument, {}, options);
}
export type GetQrLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQrLinksQuery, GetQrLinksQueryVariables>;
export const GetQrLinkDocument = gql`
    query GetQrLink($id: ID!) {
  qrLink(id: $id) {
    ...QrLinkFragment
  }
}
    ${QrLinkFragmentFragmentDoc}`;

/**
 * __useGetQrLinkQuery__
 *
 * To run a query within a Vue component, call `useGetQrLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQrLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQrLinkQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetQrLinkQuery(variables: GetQrLinkQueryVariables | VueCompositionApi.Ref<GetQrLinkQueryVariables> | ReactiveFunction<GetQrLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQrLinkQuery, GetQrLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQrLinkQuery, GetQrLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQrLinkQuery, GetQrLinkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQrLinkQuery, GetQrLinkQueryVariables>(GetQrLinkDocument, variables, options);
}
export function useGetQrLinkLazyQuery(variables?: GetQrLinkQueryVariables | VueCompositionApi.Ref<GetQrLinkQueryVariables> | ReactiveFunction<GetQrLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQrLinkQuery, GetQrLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQrLinkQuery, GetQrLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQrLinkQuery, GetQrLinkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQrLinkQuery, GetQrLinkQueryVariables>(GetQrLinkDocument, variables, options);
}
export type GetQrLinkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQrLinkQuery, GetQrLinkQueryVariables>;
export const GetQrLinksTrashedDocument = gql`
    query GetQrLinksTrashed {
  qrLinksTrashed {
    ...QrLinkFragment
  }
}
    ${QrLinkFragmentFragmentDoc}`;

/**
 * __useGetQrLinksTrashedQuery__
 *
 * To run a query within a Vue component, call `useGetQrLinksTrashedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQrLinksTrashedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQrLinksTrashedQuery();
 */
export function useGetQrLinksTrashedQuery(options: VueApolloComposable.UseQueryOptions<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables>(GetQrLinksTrashedDocument, {}, options);
}
export function useGetQrLinksTrashedLazyQuery(options: VueApolloComposable.UseQueryOptions<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables>(GetQrLinksTrashedDocument, {}, options);
}
export type GetQrLinksTrashedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQrLinksTrashedQuery, GetQrLinksTrashedQueryVariables>;
export const GetScenariosDocument = gql`
    query GetScenarios($search: String, $isActive: Boolean, $first: Int!, $after: String) {
  scenarios(search: $search, isActive: $isActive, first: $first, after: $after) {
    edges {
      node {
        ...ScenarioListFragment
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${ScenarioListFragmentFragmentDoc}`;

/**
 * __useGetScenariosQuery__
 *
 * To run a query within a Vue component, call `useGetScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenariosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetScenariosQuery({
 *   search: // value for 'search'
 *   isActive: // value for 'isActive'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetScenariosQuery(variables: GetScenariosQueryVariables | VueCompositionApi.Ref<GetScenariosQueryVariables> | ReactiveFunction<GetScenariosQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetScenariosQuery, GetScenariosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetScenariosQuery, GetScenariosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetScenariosQuery, GetScenariosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetScenariosQuery, GetScenariosQueryVariables>(GetScenariosDocument, variables, options);
}
export function useGetScenariosLazyQuery(variables?: GetScenariosQueryVariables | VueCompositionApi.Ref<GetScenariosQueryVariables> | ReactiveFunction<GetScenariosQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetScenariosQuery, GetScenariosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetScenariosQuery, GetScenariosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetScenariosQuery, GetScenariosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetScenariosQuery, GetScenariosQueryVariables>(GetScenariosDocument, variables, options);
}
export type GetScenariosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetScenariosQuery, GetScenariosQueryVariables>;
export const GetScenarioDocument = gql`
    query GetScenario($id: ID!) {
  scenario(id: $id) {
    ...ScenarioDetailFragment
  }
}
    ${ScenarioDetailFragmentFragmentDoc}`;

/**
 * __useGetScenarioQuery__
 *
 * To run a query within a Vue component, call `useGetScenarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenarioQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetScenarioQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetScenarioQuery(variables: GetScenarioQueryVariables | VueCompositionApi.Ref<GetScenarioQueryVariables> | ReactiveFunction<GetScenarioQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetScenarioQuery, GetScenarioQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetScenarioQuery, GetScenarioQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetScenarioQuery, GetScenarioQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetScenarioQuery, GetScenarioQueryVariables>(GetScenarioDocument, variables, options);
}
export function useGetScenarioLazyQuery(variables?: GetScenarioQueryVariables | VueCompositionApi.Ref<GetScenarioQueryVariables> | ReactiveFunction<GetScenarioQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetScenarioQuery, GetScenarioQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetScenarioQuery, GetScenarioQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetScenarioQuery, GetScenarioQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetScenarioQuery, GetScenarioQueryVariables>(GetScenarioDocument, variables, options);
}
export type GetScenarioQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetScenarioQuery, GetScenarioQueryVariables>;
export const GetTireCarsDocument = gql`
    query GetTireCars($clientId: ID!) {
  tireCars(clientId: $clientId) {
    ...TireCarFields
  }
}
    ${TireCarFieldsFragmentDoc}`;

/**
 * __useGetTireCarsQuery__
 *
 * To run a query within a Vue component, call `useGetTireCarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireCarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireCarsQuery({
 *   clientId: // value for 'clientId'
 * });
 */
export function useGetTireCarsQuery(variables: GetTireCarsQueryVariables | VueCompositionApi.Ref<GetTireCarsQueryVariables> | ReactiveFunction<GetTireCarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireCarsQuery, GetTireCarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireCarsQuery, GetTireCarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireCarsQuery, GetTireCarsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireCarsQuery, GetTireCarsQueryVariables>(GetTireCarsDocument, variables, options);
}
export function useGetTireCarsLazyQuery(variables?: GetTireCarsQueryVariables | VueCompositionApi.Ref<GetTireCarsQueryVariables> | ReactiveFunction<GetTireCarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireCarsQuery, GetTireCarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireCarsQuery, GetTireCarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireCarsQuery, GetTireCarsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireCarsQuery, GetTireCarsQueryVariables>(GetTireCarsDocument, variables, options);
}
export type GetTireCarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireCarsQuery, GetTireCarsQueryVariables>;
export const GetTireCarLookupDocument = gql`
    query GetTireCarLookup($query: String!) {
  tireCarLookup(query: $query) {
    ...TireCarFields
  }
}
    ${TireCarFieldsFragmentDoc}`;

/**
 * __useGetTireCarLookupQuery__
 *
 * To run a query within a Vue component, call `useGetTireCarLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireCarLookupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireCarLookupQuery({
 *   query: // value for 'query'
 * });
 */
export function useGetTireCarLookupQuery(variables: GetTireCarLookupQueryVariables | VueCompositionApi.Ref<GetTireCarLookupQueryVariables> | ReactiveFunction<GetTireCarLookupQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireCarLookupQuery, GetTireCarLookupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireCarLookupQuery, GetTireCarLookupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireCarLookupQuery, GetTireCarLookupQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireCarLookupQuery, GetTireCarLookupQueryVariables>(GetTireCarLookupDocument, variables, options);
}
export function useGetTireCarLookupLazyQuery(variables?: GetTireCarLookupQueryVariables | VueCompositionApi.Ref<GetTireCarLookupQueryVariables> | ReactiveFunction<GetTireCarLookupQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireCarLookupQuery, GetTireCarLookupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireCarLookupQuery, GetTireCarLookupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireCarLookupQuery, GetTireCarLookupQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireCarLookupQuery, GetTireCarLookupQueryVariables>(GetTireCarLookupDocument, variables, options);
}
export type GetTireCarLookupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireCarLookupQuery, GetTireCarLookupQueryVariables>;
export const GetTireCarMarksDocument = gql`
    query GetTireCarMarks($search: String, $limit: Int!) {
  tireCarMarks(search: $search, limit: $limit) {
    match
    items
  }
}
    `;

/**
 * __useGetTireCarMarksQuery__
 *
 * To run a query within a Vue component, call `useGetTireCarMarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireCarMarksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireCarMarksQuery({
 *   search: // value for 'search'
 *   limit: // value for 'limit'
 * });
 */
export function useGetTireCarMarksQuery(variables: GetTireCarMarksQueryVariables | VueCompositionApi.Ref<GetTireCarMarksQueryVariables> | ReactiveFunction<GetTireCarMarksQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireCarMarksQuery, GetTireCarMarksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireCarMarksQuery, GetTireCarMarksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireCarMarksQuery, GetTireCarMarksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireCarMarksQuery, GetTireCarMarksQueryVariables>(GetTireCarMarksDocument, variables, options);
}
export function useGetTireCarMarksLazyQuery(variables?: GetTireCarMarksQueryVariables | VueCompositionApi.Ref<GetTireCarMarksQueryVariables> | ReactiveFunction<GetTireCarMarksQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireCarMarksQuery, GetTireCarMarksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireCarMarksQuery, GetTireCarMarksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireCarMarksQuery, GetTireCarMarksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireCarMarksQuery, GetTireCarMarksQueryVariables>(GetTireCarMarksDocument, variables, options);
}
export type GetTireCarMarksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireCarMarksQuery, GetTireCarMarksQueryVariables>;
export const GetTireCarModelsDocument = gql`
    query GetTireCarModels($mark: String!, $search: String, $limit: Int!) {
  tireCarModels(mark: $mark, search: $search, limit: $limit) {
    match
    items
  }
}
    `;

/**
 * __useGetTireCarModelsQuery__
 *
 * To run a query within a Vue component, call `useGetTireCarModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireCarModelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireCarModelsQuery({
 *   mark: // value for 'mark'
 *   search: // value for 'search'
 *   limit: // value for 'limit'
 * });
 */
export function useGetTireCarModelsQuery(variables: GetTireCarModelsQueryVariables | VueCompositionApi.Ref<GetTireCarModelsQueryVariables> | ReactiveFunction<GetTireCarModelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireCarModelsQuery, GetTireCarModelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireCarModelsQuery, GetTireCarModelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireCarModelsQuery, GetTireCarModelsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireCarModelsQuery, GetTireCarModelsQueryVariables>(GetTireCarModelsDocument, variables, options);
}
export function useGetTireCarModelsLazyQuery(variables?: GetTireCarModelsQueryVariables | VueCompositionApi.Ref<GetTireCarModelsQueryVariables> | ReactiveFunction<GetTireCarModelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireCarModelsQuery, GetTireCarModelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireCarModelsQuery, GetTireCarModelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireCarModelsQuery, GetTireCarModelsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireCarModelsQuery, GetTireCarModelsQueryVariables>(GetTireCarModelsDocument, variables, options);
}
export type GetTireCarModelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireCarModelsQuery, GetTireCarModelsQueryVariables>;
export const GetTireBrandsDocument = gql`
    query GetTireBrands($search: String) {
  tireBrands(search: $search)
}
    `;

/**
 * __useGetTireBrandsQuery__
 *
 * To run a query within a Vue component, call `useGetTireBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireBrandsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireBrandsQuery({
 *   search: // value for 'search'
 * });
 */
export function useGetTireBrandsQuery(variables: GetTireBrandsQueryVariables | VueCompositionApi.Ref<GetTireBrandsQueryVariables> | ReactiveFunction<GetTireBrandsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetTireBrandsQuery, GetTireBrandsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireBrandsQuery, GetTireBrandsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireBrandsQuery, GetTireBrandsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireBrandsQuery, GetTireBrandsQueryVariables>(GetTireBrandsDocument, variables, options);
}
export function useGetTireBrandsLazyQuery(variables: GetTireBrandsQueryVariables | VueCompositionApi.Ref<GetTireBrandsQueryVariables> | ReactiveFunction<GetTireBrandsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetTireBrandsQuery, GetTireBrandsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireBrandsQuery, GetTireBrandsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireBrandsQuery, GetTireBrandsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireBrandsQuery, GetTireBrandsQueryVariables>(GetTireBrandsDocument, variables, options);
}
export type GetTireBrandsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireBrandsQuery, GetTireBrandsQueryVariables>;
export const GetTireModelsDocument = gql`
    query GetTireModels($brand: String!, $search: String) {
  tireModels(brand: $brand, search: $search)
}
    `;

/**
 * __useGetTireModelsQuery__
 *
 * To run a query within a Vue component, call `useGetTireModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireModelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireModelsQuery({
 *   brand: // value for 'brand'
 *   search: // value for 'search'
 * });
 */
export function useGetTireModelsQuery(variables: GetTireModelsQueryVariables | VueCompositionApi.Ref<GetTireModelsQueryVariables> | ReactiveFunction<GetTireModelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireModelsQuery, GetTireModelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireModelsQuery, GetTireModelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireModelsQuery, GetTireModelsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireModelsQuery, GetTireModelsQueryVariables>(GetTireModelsDocument, variables, options);
}
export function useGetTireModelsLazyQuery(variables?: GetTireModelsQueryVariables | VueCompositionApi.Ref<GetTireModelsQueryVariables> | ReactiveFunction<GetTireModelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireModelsQuery, GetTireModelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireModelsQuery, GetTireModelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireModelsQuery, GetTireModelsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireModelsQuery, GetTireModelsQueryVariables>(GetTireModelsDocument, variables, options);
}
export type GetTireModelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireModelsQuery, GetTireModelsQueryVariables>;
export const GetTireServiceCatalogDocument = gql`
    query GetTireServiceCatalog($locationId: ID!) {
  catalogCategories {
    id
    title
    position
  }
  catalogItems(kind: SERVICE, locationId: $locationId) {
    ...TireServiceItemFields
  }
}
    ${TireServiceItemFieldsFragmentDoc}`;

/**
 * __useGetTireServiceCatalogQuery__
 *
 * To run a query within a Vue component, call `useGetTireServiceCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireServiceCatalogQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireServiceCatalogQuery({
 *   locationId: // value for 'locationId'
 * });
 */
export function useGetTireServiceCatalogQuery(variables: GetTireServiceCatalogQueryVariables | VueCompositionApi.Ref<GetTireServiceCatalogQueryVariables> | ReactiveFunction<GetTireServiceCatalogQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables>(GetTireServiceCatalogDocument, variables, options);
}
export function useGetTireServiceCatalogLazyQuery(variables?: GetTireServiceCatalogQueryVariables | VueCompositionApi.Ref<GetTireServiceCatalogQueryVariables> | ReactiveFunction<GetTireServiceCatalogQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables>(GetTireServiceCatalogDocument, variables, options);
}
export type GetTireServiceCatalogQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireServiceCatalogQuery, GetTireServiceCatalogQueryVariables>;
export const GetTireServicePricingDocument = gql`
    query GetTireServicePricing($id: ID!) {
  catalogItem(id: $id) {
    id
    tire_prices {
      location_id
      car_class_id
      wheel_diameter
      run_flat
      price
    }
  }
}
    `;

/**
 * __useGetTireServicePricingQuery__
 *
 * To run a query within a Vue component, call `useGetTireServicePricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireServicePricingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireServicePricingQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTireServicePricingQuery(variables: GetTireServicePricingQueryVariables | VueCompositionApi.Ref<GetTireServicePricingQueryVariables> | ReactiveFunction<GetTireServicePricingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireServicePricingQuery, GetTireServicePricingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireServicePricingQuery, GetTireServicePricingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireServicePricingQuery, GetTireServicePricingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireServicePricingQuery, GetTireServicePricingQueryVariables>(GetTireServicePricingDocument, variables, options);
}
export function useGetTireServicePricingLazyQuery(variables?: GetTireServicePricingQueryVariables | VueCompositionApi.Ref<GetTireServicePricingQueryVariables> | ReactiveFunction<GetTireServicePricingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireServicePricingQuery, GetTireServicePricingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireServicePricingQuery, GetTireServicePricingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireServicePricingQuery, GetTireServicePricingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireServicePricingQuery, GetTireServicePricingQueryVariables>(GetTireServicePricingDocument, variables, options);
}
export type GetTireServicePricingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireServicePricingQuery, GetTireServicePricingQueryVariables>;
export const GetTireServiceSettingsDocument = gql`
    query GetTireServiceSettings {
  tireServiceSettings {
    ...TireServiceSettingsFields
  }
}
    ${TireServiceSettingsFieldsFragmentDoc}`;

/**
 * __useGetTireServiceSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetTireServiceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireServiceSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireServiceSettingsQuery();
 */
export function useGetTireServiceSettingsQuery(options: VueApolloComposable.UseQueryOptions<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables>(GetTireServiceSettingsDocument, {}, options);
}
export function useGetTireServiceSettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables>(GetTireServiceSettingsDocument, {}, options);
}
export type GetTireServiceSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireServiceSettingsQuery, GetTireServiceSettingsQueryVariables>;
export const GetTireStorageWarehousesDocument = gql`
    query GetTireStorageWarehouses {
  tireStorageWarehouses {
    ...TireStorageWarehouseFields
  }
}
    ${TireStorageWarehouseFieldsFragmentDoc}`;

/**
 * __useGetTireStorageWarehousesQuery__
 *
 * To run a query within a Vue component, call `useGetTireStorageWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireStorageWarehousesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireStorageWarehousesQuery();
 */
export function useGetTireStorageWarehousesQuery(options: VueApolloComposable.UseQueryOptions<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables>(GetTireStorageWarehousesDocument, {}, options);
}
export function useGetTireStorageWarehousesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables>(GetTireStorageWarehousesDocument, {}, options);
}
export type GetTireStorageWarehousesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireStorageWarehousesQuery, GetTireStorageWarehousesQueryVariables>;
export const GetTireSettingsWarehousesDocument = gql`
    query GetTireSettingsWarehouses {
  tireSettingsWarehouses {
    ...TireStorageWarehouseFields
  }
}
    ${TireStorageWarehouseFieldsFragmentDoc}`;

/**
 * __useGetTireSettingsWarehousesQuery__
 *
 * To run a query within a Vue component, call `useGetTireSettingsWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireSettingsWarehousesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireSettingsWarehousesQuery();
 */
export function useGetTireSettingsWarehousesQuery(options: VueApolloComposable.UseQueryOptions<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables>(GetTireSettingsWarehousesDocument, {}, options);
}
export function useGetTireSettingsWarehousesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables>(GetTireSettingsWarehousesDocument, {}, options);
}
export type GetTireSettingsWarehousesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireSettingsWarehousesQuery, GetTireSettingsWarehousesQueryVariables>;
export const GetTireWorkOrderDocument = gql`
    query GetTireWorkOrder($id: ID!) {
  tireWorkOrder(id: $id) {
    ...TireWorkOrderFields
    created_by_employee {
      id
      title
    }
    closed_by_employee {
      id
      title
    }
    print_requisites {
      location_title
      address
      phone
      legal_name
      legal_address
      legal_tin
      legal_ogrn
    }
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useGetTireWorkOrderQuery__
 *
 * To run a query within a Vue component, call `useGetTireWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireWorkOrderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireWorkOrderQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTireWorkOrderQuery(variables: GetTireWorkOrderQueryVariables | VueCompositionApi.Ref<GetTireWorkOrderQueryVariables> | ReactiveFunction<GetTireWorkOrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables>(GetTireWorkOrderDocument, variables, options);
}
export function useGetTireWorkOrderLazyQuery(variables?: GetTireWorkOrderQueryVariables | VueCompositionApi.Ref<GetTireWorkOrderQueryVariables> | ReactiveFunction<GetTireWorkOrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables>(GetTireWorkOrderDocument, variables, options);
}
export type GetTireWorkOrderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireWorkOrderQuery, GetTireWorkOrderQueryVariables>;
export const GetTireWorkOrdersDocument = gql`
    query GetTireWorkOrders($status: TireWorkOrderStatus, $shift: Boolean, $search: String, $locationIds: [ID!], $first: Int!, $after: String) {
  tireWorkOrders(
    status: $status
    shift: $shift
    search: $search
    locationIds: $locationIds
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        number
        status
        created_at
        closed_at
        location_id
        location {
          id
          title
          short_name
          color
          timezone
        }
        total_amount
        lines {
          id
          title
          quantity
          kind
        }
        client {
          id
          type
          legal_name
          legal_tin
          legal_kpp
          legal_address
          contact_person
          contact_phone
          first_name
          last_name
          patronymic_name
          phone_masked
        }
        car {
          id
          plate
          mark
          model
        }
        car_details {
          mark
          model
          plate
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetTireWorkOrdersQuery__
 *
 * To run a query within a Vue component, call `useGetTireWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireWorkOrdersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireWorkOrdersQuery({
 *   status: // value for 'status'
 *   shift: // value for 'shift'
 *   search: // value for 'search'
 *   locationIds: // value for 'locationIds'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetTireWorkOrdersQuery(variables: GetTireWorkOrdersQueryVariables | VueCompositionApi.Ref<GetTireWorkOrdersQueryVariables> | ReactiveFunction<GetTireWorkOrdersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables>(GetTireWorkOrdersDocument, variables, options);
}
export function useGetTireWorkOrdersLazyQuery(variables?: GetTireWorkOrdersQueryVariables | VueCompositionApi.Ref<GetTireWorkOrdersQueryVariables> | ReactiveFunction<GetTireWorkOrdersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables>(GetTireWorkOrdersDocument, variables, options);
}
export type GetTireWorkOrdersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireWorkOrdersQuery, GetTireWorkOrdersQueryVariables>;
export const GetTireWorkOrderJournalDocument = gql`
    query GetTireWorkOrderJournal($locationIds: [ID!]) {
  tireWorkOrderJournal(locationIds: $locationIds) {
    open_count
    shift {
      opened_at
      closed_at
      closed_count
      closed_amount
    }
  }
}
    `;

/**
 * __useGetTireWorkOrderJournalQuery__
 *
 * To run a query within a Vue component, call `useGetTireWorkOrderJournalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireWorkOrderJournalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireWorkOrderJournalQuery({
 *   locationIds: // value for 'locationIds'
 * });
 */
export function useGetTireWorkOrderJournalQuery(variables: GetTireWorkOrderJournalQueryVariables | VueCompositionApi.Ref<GetTireWorkOrderJournalQueryVariables> | ReactiveFunction<GetTireWorkOrderJournalQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables>(GetTireWorkOrderJournalDocument, variables, options);
}
export function useGetTireWorkOrderJournalLazyQuery(variables: GetTireWorkOrderJournalQueryVariables | VueCompositionApi.Ref<GetTireWorkOrderJournalQueryVariables> | ReactiveFunction<GetTireWorkOrderJournalQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables>(GetTireWorkOrderJournalDocument, variables, options);
}
export type GetTireWorkOrderJournalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireWorkOrderJournalQuery, GetTireWorkOrderJournalQueryVariables>;
export const GetTireWorkOrderForBookingDocument = gql`
    query GetTireWorkOrderForBooking($bookingGroupId: ID!) {
  tireWorkOrderForBooking(bookingGroupId: $bookingGroupId) {
    id
    number
    status
  }
}
    `;

/**
 * __useGetTireWorkOrderForBookingQuery__
 *
 * To run a query within a Vue component, call `useGetTireWorkOrderForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireWorkOrderForBookingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireWorkOrderForBookingQuery({
 *   bookingGroupId: // value for 'bookingGroupId'
 * });
 */
export function useGetTireWorkOrderForBookingQuery(variables: GetTireWorkOrderForBookingQueryVariables | VueCompositionApi.Ref<GetTireWorkOrderForBookingQueryVariables> | ReactiveFunction<GetTireWorkOrderForBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables>(GetTireWorkOrderForBookingDocument, variables, options);
}
export function useGetTireWorkOrderForBookingLazyQuery(variables?: GetTireWorkOrderForBookingQueryVariables | VueCompositionApi.Ref<GetTireWorkOrderForBookingQueryVariables> | ReactiveFunction<GetTireWorkOrderForBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables>(GetTireWorkOrderForBookingDocument, variables, options);
}
export type GetTireWorkOrderForBookingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireWorkOrderForBookingQuery, GetTireWorkOrderForBookingQueryVariables>;
export const GetTireStoragesDocument = gql`
    query GetTireStorages($tab: TireStorageTab!, $search: String, $locationIds: [ID!], $first: Int!, $after: String) {
  tireStorages(
    tab: $tab
    search: $search
    locationIds: $locationIds
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...TireStorageFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${TireStorageFieldsFragmentDoc}`;

/**
 * __useGetTireStoragesQuery__
 *
 * To run a query within a Vue component, call `useGetTireStoragesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireStoragesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireStoragesQuery({
 *   tab: // value for 'tab'
 *   search: // value for 'search'
 *   locationIds: // value for 'locationIds'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetTireStoragesQuery(variables: GetTireStoragesQueryVariables | VueCompositionApi.Ref<GetTireStoragesQueryVariables> | ReactiveFunction<GetTireStoragesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireStoragesQuery, GetTireStoragesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStoragesQuery, GetTireStoragesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStoragesQuery, GetTireStoragesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireStoragesQuery, GetTireStoragesQueryVariables>(GetTireStoragesDocument, variables, options);
}
export function useGetTireStoragesLazyQuery(variables?: GetTireStoragesQueryVariables | VueCompositionApi.Ref<GetTireStoragesQueryVariables> | ReactiveFunction<GetTireStoragesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireStoragesQuery, GetTireStoragesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStoragesQuery, GetTireStoragesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStoragesQuery, GetTireStoragesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireStoragesQuery, GetTireStoragesQueryVariables>(GetTireStoragesDocument, variables, options);
}
export type GetTireStoragesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireStoragesQuery, GetTireStoragesQueryVariables>;
export const GetTireStorageDocument = gql`
    query GetTireStorage($id: ID!) {
  tireStorage(id: $id) {
    ...TireStorageFields
    releases {
      ...TireStorageReleaseFields
    }
    extension_work_orders {
      ...TireStoragePaidWorkOrderFields
    }
    intake_work_order {
      ...TireStoragePaidWorkOrderFields
    }
    print_requisites {
      location_title
      address
      phone
      legal_name
      legal_address
      legal_tin
      legal_ogrn
    }
  }
}
    ${TireStorageFieldsFragmentDoc}
${TireStorageReleaseFieldsFragmentDoc}
${TireStoragePaidWorkOrderFieldsFragmentDoc}`;

/**
 * __useGetTireStorageQuery__
 *
 * To run a query within a Vue component, call `useGetTireStorageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireStorageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireStorageQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTireStorageQuery(variables: GetTireStorageQueryVariables | VueCompositionApi.Ref<GetTireStorageQueryVariables> | ReactiveFunction<GetTireStorageQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireStorageQuery, GetTireStorageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageQuery, GetTireStorageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageQuery, GetTireStorageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireStorageQuery, GetTireStorageQueryVariables>(GetTireStorageDocument, variables, options);
}
export function useGetTireStorageLazyQuery(variables?: GetTireStorageQueryVariables | VueCompositionApi.Ref<GetTireStorageQueryVariables> | ReactiveFunction<GetTireStorageQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireStorageQuery, GetTireStorageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageQuery, GetTireStorageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageQuery, GetTireStorageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireStorageQuery, GetTireStorageQueryVariables>(GetTireStorageDocument, variables, options);
}
export type GetTireStorageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireStorageQuery, GetTireStorageQueryVariables>;
export const GetTireStorageClientPhoneDocument = gql`
    query GetTireStorageClientPhone($id: ID!) {
  tireStorageClientPhone(id: $id)
}
    `;

/**
 * __useGetTireStorageClientPhoneQuery__
 *
 * To run a query within a Vue component, call `useGetTireStorageClientPhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireStorageClientPhoneQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireStorageClientPhoneQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTireStorageClientPhoneQuery(variables: GetTireStorageClientPhoneQueryVariables | VueCompositionApi.Ref<GetTireStorageClientPhoneQueryVariables> | ReactiveFunction<GetTireStorageClientPhoneQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables>(GetTireStorageClientPhoneDocument, variables, options);
}
export function useGetTireStorageClientPhoneLazyQuery(variables?: GetTireStorageClientPhoneQueryVariables | VueCompositionApi.Ref<GetTireStorageClientPhoneQueryVariables> | ReactiveFunction<GetTireStorageClientPhoneQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables>(GetTireStorageClientPhoneDocument, variables, options);
}
export type GetTireStorageClientPhoneQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireStorageClientPhoneQuery, GetTireStorageClientPhoneQueryVariables>;
export const GetTireClientStoragesDocument = gql`
    query GetTireClientStorages($clientId: ID!) {
  tireClientStorages(clientId: $clientId) {
    ...TireStorageFields
  }
}
    ${TireStorageFieldsFragmentDoc}`;

/**
 * __useGetTireClientStoragesQuery__
 *
 * To run a query within a Vue component, call `useGetTireClientStoragesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireClientStoragesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireClientStoragesQuery({
 *   clientId: // value for 'clientId'
 * });
 */
export function useGetTireClientStoragesQuery(variables: GetTireClientStoragesQueryVariables | VueCompositionApi.Ref<GetTireClientStoragesQueryVariables> | ReactiveFunction<GetTireClientStoragesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables>(GetTireClientStoragesDocument, variables, options);
}
export function useGetTireClientStoragesLazyQuery(variables?: GetTireClientStoragesQueryVariables | VueCompositionApi.Ref<GetTireClientStoragesQueryVariables> | ReactiveFunction<GetTireClientStoragesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables>(GetTireClientStoragesDocument, variables, options);
}
export type GetTireClientStoragesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireClientStoragesQuery, GetTireClientStoragesQueryVariables>;
export const GetTireStorageInStockCountDocument = gql`
    query GetTireStorageInStockCount {
  tireStorageInStockCount
}
    `;

/**
 * __useGetTireStorageInStockCountQuery__
 *
 * To run a query within a Vue component, call `useGetTireStorageInStockCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireStorageInStockCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireStorageInStockCountQuery();
 */
export function useGetTireStorageInStockCountQuery(options: VueApolloComposable.UseQueryOptions<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables>(GetTireStorageInStockCountDocument, {}, options);
}
export function useGetTireStorageInStockCountLazyQuery(options: VueApolloComposable.UseQueryOptions<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables>(GetTireStorageInStockCountDocument, {}, options);
}
export type GetTireStorageInStockCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireStorageInStockCountQuery, GetTireStorageInStockCountQueryVariables>;
export const GetTireStorageFreeCellDocument = gql`
    query GetTireStorageFreeCell($warehouseId: ID!) {
  tireStorageFreeCell(warehouseId: $warehouseId) {
    rack_no
    cell_no
  }
}
    `;

/**
 * __useGetTireStorageFreeCellQuery__
 *
 * To run a query within a Vue component, call `useGetTireStorageFreeCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTireStorageFreeCellQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTireStorageFreeCellQuery({
 *   warehouseId: // value for 'warehouseId'
 * });
 */
export function useGetTireStorageFreeCellQuery(variables: GetTireStorageFreeCellQueryVariables | VueCompositionApi.Ref<GetTireStorageFreeCellQueryVariables> | ReactiveFunction<GetTireStorageFreeCellQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables>(GetTireStorageFreeCellDocument, variables, options);
}
export function useGetTireStorageFreeCellLazyQuery(variables?: GetTireStorageFreeCellQueryVariables | VueCompositionApi.Ref<GetTireStorageFreeCellQueryVariables> | ReactiveFunction<GetTireStorageFreeCellQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables>(GetTireStorageFreeCellDocument, variables, options);
}
export type GetTireStorageFreeCellQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTireStorageFreeCellQuery, GetTireStorageFreeCellQueryVariables>;
export const CreateMarketingBroadcastDocument = gql`
    mutation CreateMarketingBroadcast($input: MarketingBroadcastInput!) {
  createMarketingBroadcast(input: $input) {
    ...BroadcastFields
  }
}
    ${BroadcastFieldsFragmentDoc}`;

/**
 * __useCreateMarketingBroadcastMutation__
 *
 * To run a mutation, you first call `useCreateMarketingBroadcastMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketingBroadcastMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMarketingBroadcastMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketingBroadcastMutation(options: VueApolloComposable.UseMutationOptions<CreateMarketingBroadcastMutation, CreateMarketingBroadcastMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMarketingBroadcastMutation, CreateMarketingBroadcastMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMarketingBroadcastMutation, CreateMarketingBroadcastMutationVariables>(CreateMarketingBroadcastDocument, options);
}
export type CreateMarketingBroadcastMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMarketingBroadcastMutation, CreateMarketingBroadcastMutationVariables>;
export const UpdateMarketingBroadcastDocument = gql`
    mutation UpdateMarketingBroadcast($id: ID!, $version: Int!, $input: MarketingBroadcastInput!) {
  updateMarketingBroadcast(id: $id, version: $version, input: $input) {
    ...BroadcastFields
  }
}
    ${BroadcastFieldsFragmentDoc}`;

/**
 * __useUpdateMarketingBroadcastMutation__
 *
 * To run a mutation, you first call `useUpdateMarketingBroadcastMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketingBroadcastMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMarketingBroadcastMutation({
 *   variables: {
 *     id: // value for 'id'
 *     version: // value for 'version'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketingBroadcastMutation(options: VueApolloComposable.UseMutationOptions<UpdateMarketingBroadcastMutation, UpdateMarketingBroadcastMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMarketingBroadcastMutation, UpdateMarketingBroadcastMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMarketingBroadcastMutation, UpdateMarketingBroadcastMutationVariables>(UpdateMarketingBroadcastDocument, options);
}
export type UpdateMarketingBroadcastMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMarketingBroadcastMutation, UpdateMarketingBroadcastMutationVariables>;
export const StartMarketingBroadcastDocument = gql`
    mutation StartMarketingBroadcast($id: ID!, $version: Int!, $snapshotId: ID!) {
  startMarketingBroadcast(id: $id, version: $version, snapshotId: $snapshotId) {
    ...BroadcastFields
  }
}
    ${BroadcastFieldsFragmentDoc}`;

/**
 * __useStartMarketingBroadcastMutation__
 *
 * To run a mutation, you first call `useStartMarketingBroadcastMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartMarketingBroadcastMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartMarketingBroadcastMutation({
 *   variables: {
 *     id: // value for 'id'
 *     version: // value for 'version'
 *     snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useStartMarketingBroadcastMutation(options: VueApolloComposable.UseMutationOptions<StartMarketingBroadcastMutation, StartMarketingBroadcastMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartMarketingBroadcastMutation, StartMarketingBroadcastMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StartMarketingBroadcastMutation, StartMarketingBroadcastMutationVariables>(StartMarketingBroadcastDocument, options);
}
export type StartMarketingBroadcastMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartMarketingBroadcastMutation, StartMarketingBroadcastMutationVariables>;
export const PrepareMarketingBroadcastAudienceDocument = gql`
    mutation PrepareMarketingBroadcastAudience($id: ID!, $version: Int!, $requestId: ID!) {
  prepareMarketingBroadcastAudience(
    id: $id
    version: $version
    requestId: $requestId
  ) {
    ...BroadcastSnapshotFields
  }
}
    ${BroadcastSnapshotFieldsFragmentDoc}`;

/**
 * __usePrepareMarketingBroadcastAudienceMutation__
 *
 * To run a mutation, you first call `usePrepareMarketingBroadcastAudienceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePrepareMarketingBroadcastAudienceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePrepareMarketingBroadcastAudienceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     version: // value for 'version'
 *     requestId: // value for 'requestId'
 *   },
 * });
 */
export function usePrepareMarketingBroadcastAudienceMutation(options: VueApolloComposable.UseMutationOptions<PrepareMarketingBroadcastAudienceMutation, PrepareMarketingBroadcastAudienceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PrepareMarketingBroadcastAudienceMutation, PrepareMarketingBroadcastAudienceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PrepareMarketingBroadcastAudienceMutation, PrepareMarketingBroadcastAudienceMutationVariables>(PrepareMarketingBroadcastAudienceDocument, options);
}
export type PrepareMarketingBroadcastAudienceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PrepareMarketingBroadcastAudienceMutation, PrepareMarketingBroadcastAudienceMutationVariables>;
export const SendMarketingBroadcastTestDocument = gql`
    mutation SendMarketingBroadcastTest($id: ID!, $version: Int!, $target: MarketingBroadcastTestTargetInput!) {
  sendMarketingBroadcastTest(id: $id, version: $version, target: $target) {
    message_id
    status
    failed_reason
  }
}
    `;

/**
 * __useSendMarketingBroadcastTestMutation__
 *
 * To run a mutation, you first call `useSendMarketingBroadcastTestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendMarketingBroadcastTestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendMarketingBroadcastTestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     version: // value for 'version'
 *     target: // value for 'target'
 *   },
 * });
 */
export function useSendMarketingBroadcastTestMutation(options: VueApolloComposable.UseMutationOptions<SendMarketingBroadcastTestMutation, SendMarketingBroadcastTestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendMarketingBroadcastTestMutation, SendMarketingBroadcastTestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendMarketingBroadcastTestMutation, SendMarketingBroadcastTestMutationVariables>(SendMarketingBroadcastTestDocument, options);
}
export type SendMarketingBroadcastTestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendMarketingBroadcastTestMutation, SendMarketingBroadcastTestMutationVariables>;
export const CreateClientAutomationDocument = gql`
    mutation CreateClientAutomation($kind: ClientAutomationKind!, $input: ClientAutomationInput!) {
  createClientAutomation(kind: $kind, input: $input) {
    ...ClientAutomationFields
  }
}
    ${ClientAutomationFieldsFragmentDoc}`;

/**
 * __useCreateClientAutomationMutation__
 *
 * To run a mutation, you first call `useCreateClientAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateClientAutomationMutation({
 *   variables: {
 *     kind: // value for 'kind'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientAutomationMutation(options: VueApolloComposable.UseMutationOptions<CreateClientAutomationMutation, CreateClientAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateClientAutomationMutation, CreateClientAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateClientAutomationMutation, CreateClientAutomationMutationVariables>(CreateClientAutomationDocument, options);
}
export type CreateClientAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateClientAutomationMutation, CreateClientAutomationMutationVariables>;
export const UpdateClientAutomationDocument = gql`
    mutation UpdateClientAutomation($kind: ClientAutomationKind!, $id: ID, $input: ClientAutomationInput!) {
  updateClientAutomation(kind: $kind, id: $id, input: $input) {
    ...ClientAutomationFields
  }
}
    ${ClientAutomationFieldsFragmentDoc}`;

/**
 * __useUpdateClientAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateClientAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateClientAutomationMutation({
 *   variables: {
 *     kind: // value for 'kind'
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientAutomationMutation(options: VueApolloComposable.UseMutationOptions<UpdateClientAutomationMutation, UpdateClientAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateClientAutomationMutation, UpdateClientAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateClientAutomationMutation, UpdateClientAutomationMutationVariables>(UpdateClientAutomationDocument, options);
}
export type UpdateClientAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateClientAutomationMutation, UpdateClientAutomationMutationVariables>;
export const DeleteClientAutomationDocument = gql`
    mutation DeleteClientAutomation($id: ID!) {
  deleteClientAutomation(id: $id) {
    ...ClientAutomationFields
  }
}
    ${ClientAutomationFieldsFragmentDoc}`;

/**
 * __useDeleteClientAutomationMutation__
 *
 * To run a mutation, you first call `useDeleteClientAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteClientAutomationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientAutomationMutation(options: VueApolloComposable.UseMutationOptions<DeleteClientAutomationMutation, DeleteClientAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteClientAutomationMutation, DeleteClientAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteClientAutomationMutation, DeleteClientAutomationMutationVariables>(DeleteClientAutomationDocument, options);
}
export type DeleteClientAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteClientAutomationMutation, DeleteClientAutomationMutationVariables>;
export const ResetClientAutomationDocument = gql`
    mutation ResetClientAutomation($kind: ClientAutomationKind!) {
  resetClientAutomation(kind: $kind) {
    ...ClientAutomationFields
  }
}
    ${ClientAutomationFieldsFragmentDoc}`;

/**
 * __useResetClientAutomationMutation__
 *
 * To run a mutation, you first call `useResetClientAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetClientAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetClientAutomationMutation({
 *   variables: {
 *     kind: // value for 'kind'
 *   },
 * });
 */
export function useResetClientAutomationMutation(options: VueApolloComposable.UseMutationOptions<ResetClientAutomationMutation, ResetClientAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResetClientAutomationMutation, ResetClientAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResetClientAutomationMutation, ResetClientAutomationMutationVariables>(ResetClientAutomationDocument, options);
}
export type ResetClientAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResetClientAutomationMutation, ResetClientAutomationMutationVariables>;
export const UpdateClientQuietHoursDocument = gql`
    mutation UpdateClientQuietHours($input: ClientQuietHoursInput!) {
  updateClientQuietHours(input: $input) {
    enabled
    start
    end
  }
}
    `;

/**
 * __useUpdateClientQuietHoursMutation__
 *
 * To run a mutation, you first call `useUpdateClientQuietHoursMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientQuietHoursMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateClientQuietHoursMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientQuietHoursMutation(options: VueApolloComposable.UseMutationOptions<UpdateClientQuietHoursMutation, UpdateClientQuietHoursMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateClientQuietHoursMutation, UpdateClientQuietHoursMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateClientQuietHoursMutation, UpdateClientQuietHoursMutationVariables>(UpdateClientQuietHoursDocument, options);
}
export type UpdateClientQuietHoursMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateClientQuietHoursMutation, UpdateClientQuietHoursMutationVariables>;
export const SendClientAutomationTestDocument = gql`
    mutation SendClientAutomationTest($kind: ClientAutomationKind!, $id: ID, $target: MarketingBroadcastTestTargetInput!) {
  sendClientAutomationTest(kind: $kind, id: $id, target: $target) {
    id
  }
}
    `;

/**
 * __useSendClientAutomationTestMutation__
 *
 * To run a mutation, you first call `useSendClientAutomationTestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendClientAutomationTestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendClientAutomationTestMutation({
 *   variables: {
 *     kind: // value for 'kind'
 *     id: // value for 'id'
 *     target: // value for 'target'
 *   },
 * });
 */
export function useSendClientAutomationTestMutation(options: VueApolloComposable.UseMutationOptions<SendClientAutomationTestMutation, SendClientAutomationTestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendClientAutomationTestMutation, SendClientAutomationTestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendClientAutomationTestMutation, SendClientAutomationTestMutationVariables>(SendClientAutomationTestDocument, options);
}
export type SendClientAutomationTestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendClientAutomationTestMutation, SendClientAutomationTestMutationVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($input: CreateClientInput!) {
  createClient(input: $input) {
    ...ClientWithLocations
  }
}
    ${ClientWithLocationsFragmentDoc}`;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateClientMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientMutation(options: VueApolloComposable.UseMutationOptions<CreateClientMutation, CreateClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateClientMutation, CreateClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
}
export type CreateClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($id: ID!, $input: UpdateClientInput!) {
  updateClient(id: $id, input: $input) {
    ...ClientWithLocations
  }
}
    ${ClientWithLocationsFragmentDoc}`;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateClientMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientMutation(options: VueApolloComposable.UseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
}
export type UpdateClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateClientMutation, UpdateClientMutationVariables>;
export const DeleteClientDocument = gql`
    mutation DeleteClient($id: ID!) {
  deleteClient(id: $id)
}
    `;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteClientMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(options: VueApolloComposable.UseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
}
export type DeleteClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteClientMutation, DeleteClientMutationVariables>;
export const CreateClientSegmentDocument = gql`
    mutation CreateClientSegment($input: ClientSegmentInput!) {
  createClientSegment(input: $input) {
    ...ClientSegmentFields
  }
}
    ${ClientSegmentFieldsFragmentDoc}`;

/**
 * __useCreateClientSegmentMutation__
 *
 * To run a mutation, you first call `useCreateClientSegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientSegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateClientSegmentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientSegmentMutation(options: VueApolloComposable.UseMutationOptions<CreateClientSegmentMutation, CreateClientSegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateClientSegmentMutation, CreateClientSegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateClientSegmentMutation, CreateClientSegmentMutationVariables>(CreateClientSegmentDocument, options);
}
export type CreateClientSegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateClientSegmentMutation, CreateClientSegmentMutationVariables>;
export const UpdateClientSegmentDocument = gql`
    mutation UpdateClientSegment($id: ID!, $input: ClientSegmentInput!) {
  updateClientSegment(id: $id, input: $input) {
    ...ClientSegmentFields
  }
}
    ${ClientSegmentFieldsFragmentDoc}`;

/**
 * __useUpdateClientSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateClientSegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientSegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateClientSegmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientSegmentMutation(options: VueApolloComposable.UseMutationOptions<UpdateClientSegmentMutation, UpdateClientSegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateClientSegmentMutation, UpdateClientSegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateClientSegmentMutation, UpdateClientSegmentMutationVariables>(UpdateClientSegmentDocument, options);
}
export type UpdateClientSegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateClientSegmentMutation, UpdateClientSegmentMutationVariables>;
export const DeleteClientSegmentDocument = gql`
    mutation DeleteClientSegment($id: ID!) {
  deleteClientSegment(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteClientSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteClientSegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientSegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteClientSegmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientSegmentMutation(options: VueApolloComposable.UseMutationOptions<DeleteClientSegmentMutation, DeleteClientSegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteClientSegmentMutation, DeleteClientSegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteClientSegmentMutation, DeleteClientSegmentMutationVariables>(DeleteClientSegmentDocument, options);
}
export type DeleteClientSegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteClientSegmentMutation, DeleteClientSegmentMutationVariables>;
export const ResetClientSegmentDocument = gql`
    mutation ResetClientSegment($id: ID!) {
  resetClientSegment(id: $id) {
    ...ClientSegmentFields
  }
}
    ${ClientSegmentFieldsFragmentDoc}`;

/**
 * __useResetClientSegmentMutation__
 *
 * To run a mutation, you first call `useResetClientSegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetClientSegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetClientSegmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useResetClientSegmentMutation(options: VueApolloComposable.UseMutationOptions<ResetClientSegmentMutation, ResetClientSegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResetClientSegmentMutation, ResetClientSegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResetClientSegmentMutation, ResetClientSegmentMutationVariables>(ResetClientSegmentDocument, options);
}
export type ResetClientSegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResetClientSegmentMutation, ResetClientSegmentMutationVariables>;
export const IssueInvoiceDocument = gql`
    mutation IssueInvoice($input: IssueInvoiceInput!) {
  issueInvoice(input: $input) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useIssueInvoiceMutation__
 *
 * To run a mutation, you first call `useIssueInvoiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueInvoiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueInvoiceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIssueInvoiceMutation(options: VueApolloComposable.UseMutationOptions<IssueInvoiceMutation, IssueInvoiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueInvoiceMutation, IssueInvoiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueInvoiceMutation, IssueInvoiceMutationVariables>(IssueInvoiceDocument, options);
}
export type IssueInvoiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueInvoiceMutation, IssueInvoiceMutationVariables>;
export const AnnulInvoiceDocument = gql`
    mutation AnnulInvoice($input: AnnulInvoiceInput!) {
  annulInvoice(input: $input) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useAnnulInvoiceMutation__
 *
 * To run a mutation, you first call `useAnnulInvoiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAnnulInvoiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAnnulInvoiceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAnnulInvoiceMutation(options: VueApolloComposable.UseMutationOptions<AnnulInvoiceMutation, AnnulInvoiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AnnulInvoiceMutation, AnnulInvoiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AnnulInvoiceMutation, AnnulInvoiceMutationVariables>(AnnulInvoiceDocument, options);
}
export type AnnulInvoiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AnnulInvoiceMutation, AnnulInvoiceMutationVariables>;
export const ConfirmInvoiceReceiptDocument = gql`
    mutation ConfirmInvoiceReceipt($input: ConfirmInvoiceReceiptInput!) {
  confirmInvoiceReceipt(input: $input) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useConfirmInvoiceReceiptMutation__
 *
 * To run a mutation, you first call `useConfirmInvoiceReceiptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmInvoiceReceiptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmInvoiceReceiptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConfirmInvoiceReceiptMutation(options: VueApolloComposable.UseMutationOptions<ConfirmInvoiceReceiptMutation, ConfirmInvoiceReceiptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmInvoiceReceiptMutation, ConfirmInvoiceReceiptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConfirmInvoiceReceiptMutation, ConfirmInvoiceReceiptMutationVariables>(ConfirmInvoiceReceiptDocument, options);
}
export type ConfirmInvoiceReceiptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmInvoiceReceiptMutation, ConfirmInvoiceReceiptMutationVariables>;
export const VoidInvoiceReceiptDocument = gql`
    mutation VoidInvoiceReceipt($input: VoidInvoiceReceiptInput!) {
  voidInvoiceReceipt(input: $input) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useVoidInvoiceReceiptMutation__
 *
 * To run a mutation, you first call `useVoidInvoiceReceiptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVoidInvoiceReceiptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVoidInvoiceReceiptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useVoidInvoiceReceiptMutation(options: VueApolloComposable.UseMutationOptions<VoidInvoiceReceiptMutation, VoidInvoiceReceiptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<VoidInvoiceReceiptMutation, VoidInvoiceReceiptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<VoidInvoiceReceiptMutation, VoidInvoiceReceiptMutationVariables>(VoidInvoiceReceiptDocument, options);
}
export type VoidInvoiceReceiptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<VoidInvoiceReceiptMutation, VoidInvoiceReceiptMutationVariables>;
export const ReturnInvoiceReceiptDocument = gql`
    mutation ReturnInvoiceReceipt($input: ReturnInvoiceReceiptInput!) {
  returnInvoiceReceipt(input: $input) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useReturnInvoiceReceiptMutation__
 *
 * To run a mutation, you first call `useReturnInvoiceReceiptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReturnInvoiceReceiptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReturnInvoiceReceiptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReturnInvoiceReceiptMutation(options: VueApolloComposable.UseMutationOptions<ReturnInvoiceReceiptMutation, ReturnInvoiceReceiptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReturnInvoiceReceiptMutation, ReturnInvoiceReceiptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReturnInvoiceReceiptMutation, ReturnInvoiceReceiptMutationVariables>(ReturnInvoiceReceiptDocument, options);
}
export type ReturnInvoiceReceiptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReturnInvoiceReceiptMutation, ReturnInvoiceReceiptMutationVariables>;
export const RecordOrderFiscalCommandLogsDocument = gql`
    mutation RecordOrderFiscalCommandLogs($input: RecordOrderFiscalCommandLogsInput!) {
  recordOrderFiscalCommandLogs(input: $input)
}
    `;

/**
 * __useRecordOrderFiscalCommandLogsMutation__
 *
 * To run a mutation, you first call `useRecordOrderFiscalCommandLogsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRecordOrderFiscalCommandLogsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRecordOrderFiscalCommandLogsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRecordOrderFiscalCommandLogsMutation(options: VueApolloComposable.UseMutationOptions<RecordOrderFiscalCommandLogsMutation, RecordOrderFiscalCommandLogsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RecordOrderFiscalCommandLogsMutation, RecordOrderFiscalCommandLogsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RecordOrderFiscalCommandLogsMutation, RecordOrderFiscalCommandLogsMutationVariables>(RecordOrderFiscalCommandLogsDocument, options);
}
export type RecordOrderFiscalCommandLogsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RecordOrderFiscalCommandLogsMutation, RecordOrderFiscalCommandLogsMutationVariables>;
export const CreateMarketingSourceDocument = gql`
    mutation CreateMarketingSource($input: CreateMarketingSourceInput!) {
  createMarketingSource(input: $input) {
    id
    title
    is_manual_selectable
    is_system
    created_at
  }
}
    `;

/**
 * __useCreateMarketingSourceMutation__
 *
 * To run a mutation, you first call `useCreateMarketingSourceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketingSourceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMarketingSourceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketingSourceMutation(options: VueApolloComposable.UseMutationOptions<CreateMarketingSourceMutation, CreateMarketingSourceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMarketingSourceMutation, CreateMarketingSourceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMarketingSourceMutation, CreateMarketingSourceMutationVariables>(CreateMarketingSourceDocument, options);
}
export type CreateMarketingSourceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMarketingSourceMutation, CreateMarketingSourceMutationVariables>;
export const UpdateMarketingSourceDocument = gql`
    mutation UpdateMarketingSource($id: ID!, $input: UpdateMarketingSourceInput!) {
  updateMarketingSource(id: $id, input: $input) {
    id
    title
    is_manual_selectable
    is_system
    created_at
  }
}
    `;

/**
 * __useUpdateMarketingSourceMutation__
 *
 * To run a mutation, you first call `useUpdateMarketingSourceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketingSourceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMarketingSourceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketingSourceMutation(options: VueApolloComposable.UseMutationOptions<UpdateMarketingSourceMutation, UpdateMarketingSourceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMarketingSourceMutation, UpdateMarketingSourceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMarketingSourceMutation, UpdateMarketingSourceMutationVariables>(UpdateMarketingSourceDocument, options);
}
export type UpdateMarketingSourceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMarketingSourceMutation, UpdateMarketingSourceMutationVariables>;
export const DeleteMarketingSourceDocument = gql`
    mutation DeleteMarketingSource($id: ID!) {
  deleteMarketingSource(id: $id)
}
    `;

/**
 * __useDeleteMarketingSourceMutation__
 *
 * To run a mutation, you first call `useDeleteMarketingSourceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketingSourceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMarketingSourceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMarketingSourceMutation(options: VueApolloComposable.UseMutationOptions<DeleteMarketingSourceMutation, DeleteMarketingSourceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMarketingSourceMutation, DeleteMarketingSourceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMarketingSourceMutation, DeleteMarketingSourceMutationVariables>(DeleteMarketingSourceDocument, options);
}
export type DeleteMarketingSourceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMarketingSourceMutation, DeleteMarketingSourceMutationVariables>;
export const OpenCashShiftDocument = gql`
    mutation OpenCashShift($input: OpenShiftInput!) {
  openShift(input: $input) {
    ...ShiftFields
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useOpenCashShiftMutation__
 *
 * To run a mutation, you first call `useOpenCashShiftMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOpenCashShiftMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOpenCashShiftMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useOpenCashShiftMutation(options: VueApolloComposable.UseMutationOptions<OpenCashShiftMutation, OpenCashShiftMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<OpenCashShiftMutation, OpenCashShiftMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<OpenCashShiftMutation, OpenCashShiftMutationVariables>(OpenCashShiftDocument, options);
}
export type OpenCashShiftMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<OpenCashShiftMutation, OpenCashShiftMutationVariables>;
export const ConfirmCashShiftKktDocument = gql`
    mutation ConfirmCashShiftKkt($input: ConfirmShiftKktInput!) {
  confirmShiftKkt(input: $input) {
    ...ShiftFields
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useConfirmCashShiftKktMutation__
 *
 * To run a mutation, you first call `useConfirmCashShiftKktMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCashShiftKktMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmCashShiftKktMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConfirmCashShiftKktMutation(options: VueApolloComposable.UseMutationOptions<ConfirmCashShiftKktMutation, ConfirmCashShiftKktMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmCashShiftKktMutation, ConfirmCashShiftKktMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConfirmCashShiftKktMutation, ConfirmCashShiftKktMutationVariables>(ConfirmCashShiftKktDocument, options);
}
export type ConfirmCashShiftKktMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmCashShiftKktMutation, ConfirmCashShiftKktMutationVariables>;
export const AbortCashShiftOpeningDocument = gql`
    mutation AbortCashShiftOpening($shiftId: ID!) {
  abortShiftOpening(shiftId: $shiftId) {
    ...ShiftFields
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useAbortCashShiftOpeningMutation__
 *
 * To run a mutation, you first call `useAbortCashShiftOpeningMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAbortCashShiftOpeningMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAbortCashShiftOpeningMutation({
 *   variables: {
 *     shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useAbortCashShiftOpeningMutation(options: VueApolloComposable.UseMutationOptions<AbortCashShiftOpeningMutation, AbortCashShiftOpeningMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AbortCashShiftOpeningMutation, AbortCashShiftOpeningMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AbortCashShiftOpeningMutation, AbortCashShiftOpeningMutationVariables>(AbortCashShiftOpeningDocument, options);
}
export type AbortCashShiftOpeningMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AbortCashShiftOpeningMutation, AbortCashShiftOpeningMutationVariables>;
export const CashShiftClosingContextDocument = gql`
    query CashShiftClosingContext($shiftId: ID!) {
  shiftClosingContext(shiftId: $shiftId) {
    shift {
      ...ShiftFields
    }
    revenue_mors_cash
    revenue_mors_card
    revenue_mors_other
    revenue_mors_total
    pending_operations {
      ...OrderFiscalOperationFields
    }
  }
}
    ${ShiftFieldsFragmentDoc}
${OrderFiscalOperationFieldsFragmentDoc}`;

/**
 * __useCashShiftClosingContextQuery__
 *
 * To run a query within a Vue component, call `useCashShiftClosingContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashShiftClosingContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCashShiftClosingContextQuery({
 *   shiftId: // value for 'shiftId'
 * });
 */
export function useCashShiftClosingContextQuery(variables: CashShiftClosingContextQueryVariables | VueCompositionApi.Ref<CashShiftClosingContextQueryVariables> | ReactiveFunction<CashShiftClosingContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables>(CashShiftClosingContextDocument, variables, options);
}
export function useCashShiftClosingContextLazyQuery(variables?: CashShiftClosingContextQueryVariables | VueCompositionApi.Ref<CashShiftClosingContextQueryVariables> | ReactiveFunction<CashShiftClosingContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables>(CashShiftClosingContextDocument, variables, options);
}
export type CashShiftClosingContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CashShiftClosingContextQuery, CashShiftClosingContextQueryVariables>;
export const StartCashShiftClosingDocument = gql`
    mutation StartCashShiftClosing($shiftId: ID!) {
  startShiftClosing(shiftId: $shiftId) {
    shift {
      ...ShiftFields
    }
    revenue_mors_cash
    revenue_mors_card
    revenue_mors_other
    revenue_mors_total
    pending_operations {
      ...OrderFiscalOperationFields
    }
  }
}
    ${ShiftFieldsFragmentDoc}
${OrderFiscalOperationFieldsFragmentDoc}`;

/**
 * __useStartCashShiftClosingMutation__
 *
 * To run a mutation, you first call `useStartCashShiftClosingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartCashShiftClosingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartCashShiftClosingMutation({
 *   variables: {
 *     shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useStartCashShiftClosingMutation(options: VueApolloComposable.UseMutationOptions<StartCashShiftClosingMutation, StartCashShiftClosingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartCashShiftClosingMutation, StartCashShiftClosingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StartCashShiftClosingMutation, StartCashShiftClosingMutationVariables>(StartCashShiftClosingDocument, options);
}
export type StartCashShiftClosingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartCashShiftClosingMutation, StartCashShiftClosingMutationVariables>;
export const CloseCashShiftDocument = gql`
    mutation CloseCashShift($input: CloseShiftInput!) {
  closeShift(input: $input) {
    ...ShiftFields
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useCloseCashShiftMutation__
 *
 * To run a mutation, you first call `useCloseCashShiftMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloseCashShiftMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloseCashShiftMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCloseCashShiftMutation(options: VueApolloComposable.UseMutationOptions<CloseCashShiftMutation, CloseCashShiftMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloseCashShiftMutation, CloseCashShiftMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CloseCashShiftMutation, CloseCashShiftMutationVariables>(CloseCashShiftDocument, options);
}
export type CloseCashShiftMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloseCashShiftMutation, CloseCashShiftMutationVariables>;
export const CancelCashShiftClosingDocument = gql`
    mutation CancelCashShiftClosing($shiftId: ID!) {
  cancelShiftClosing(shiftId: $shiftId) {
    ...ShiftFields
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useCancelCashShiftClosingMutation__
 *
 * To run a mutation, you first call `useCancelCashShiftClosingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelCashShiftClosingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelCashShiftClosingMutation({
 *   variables: {
 *     shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useCancelCashShiftClosingMutation(options: VueApolloComposable.UseMutationOptions<CancelCashShiftClosingMutation, CancelCashShiftClosingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelCashShiftClosingMutation, CancelCashShiftClosingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelCashShiftClosingMutation, CancelCashShiftClosingMutationVariables>(CancelCashShiftClosingDocument, options);
}
export type CancelCashShiftClosingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelCashShiftClosingMutation, CancelCashShiftClosingMutationVariables>;
export const RegisterCashShiftKktReopenDocument = gql`
    mutation RegisterCashShiftKktReopen($input: RegisterShiftKktReopenInput!) {
  registerShiftKktReopen(input: $input) {
    ...ShiftFields
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useRegisterCashShiftKktReopenMutation__
 *
 * To run a mutation, you first call `useRegisterCashShiftKktReopenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCashShiftKktReopenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterCashShiftKktReopenMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRegisterCashShiftKktReopenMutation(options: VueApolloComposable.UseMutationOptions<RegisterCashShiftKktReopenMutation, RegisterCashShiftKktReopenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegisterCashShiftKktReopenMutation, RegisterCashShiftKktReopenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RegisterCashShiftKktReopenMutation, RegisterCashShiftKktReopenMutationVariables>(RegisterCashShiftKktReopenDocument, options);
}
export type RegisterCashShiftKktReopenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegisterCashShiftKktReopenMutation, RegisterCashShiftKktReopenMutationVariables>;
export const ForceCloseCashShiftDocument = gql`
    mutation ForceCloseCashShift($input: ForceCloseShiftInput!) {
  forceCloseShift(input: $input) {
    ...ShiftFields
  }
}
    ${ShiftFieldsFragmentDoc}`;

/**
 * __useForceCloseCashShiftMutation__
 *
 * To run a mutation, you first call `useForceCloseCashShiftMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForceCloseCashShiftMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForceCloseCashShiftMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useForceCloseCashShiftMutation(options: VueApolloComposable.UseMutationOptions<ForceCloseCashShiftMutation, ForceCloseCashShiftMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ForceCloseCashShiftMutation, ForceCloseCashShiftMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ForceCloseCashShiftMutation, ForceCloseCashShiftMutationVariables>(ForceCloseCashShiftDocument, options);
}
export type ForceCloseCashShiftMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ForceCloseCashShiftMutation, ForceCloseCashShiftMutationVariables>;
export const GetOrderFiscalOperationDocument = gql`
    query GetOrderFiscalOperation($operationId: ID!) {
  orderFiscalOperation(operationId: $operationId) {
    ...OrderFiscalOperationFields
  }
}
    ${OrderFiscalOperationFieldsFragmentDoc}`;

/**
 * __useGetOrderFiscalOperationQuery__
 *
 * To run a query within a Vue component, call `useGetOrderFiscalOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderFiscalOperationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderFiscalOperationQuery({
 *   operationId: // value for 'operationId'
 * });
 */
export function useGetOrderFiscalOperationQuery(variables: GetOrderFiscalOperationQueryVariables | VueCompositionApi.Ref<GetOrderFiscalOperationQueryVariables> | ReactiveFunction<GetOrderFiscalOperationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables>(GetOrderFiscalOperationDocument, variables, options);
}
export function useGetOrderFiscalOperationLazyQuery(variables?: GetOrderFiscalOperationQueryVariables | VueCompositionApi.Ref<GetOrderFiscalOperationQueryVariables> | ReactiveFunction<GetOrderFiscalOperationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables>(GetOrderFiscalOperationDocument, variables, options);
}
export type GetOrderFiscalOperationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderFiscalOperationQuery, GetOrderFiscalOperationQueryVariables>;
export const ForceCloseOrderFiscalOperationDocument = gql`
    mutation ForceCloseOrderFiscalOperation($input: ForceCloseOrderFiscalOperationInput!) {
  forceCloseOrderFiscalOperation(input: $input) {
    ...OrderFiscalOperationFields
  }
}
    ${OrderFiscalOperationFieldsFragmentDoc}`;

/**
 * __useForceCloseOrderFiscalOperationMutation__
 *
 * To run a mutation, you first call `useForceCloseOrderFiscalOperationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForceCloseOrderFiscalOperationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForceCloseOrderFiscalOperationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useForceCloseOrderFiscalOperationMutation(options: VueApolloComposable.UseMutationOptions<ForceCloseOrderFiscalOperationMutation, ForceCloseOrderFiscalOperationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ForceCloseOrderFiscalOperationMutation, ForceCloseOrderFiscalOperationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ForceCloseOrderFiscalOperationMutation, ForceCloseOrderFiscalOperationMutationVariables>(ForceCloseOrderFiscalOperationDocument, options);
}
export type ForceCloseOrderFiscalOperationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ForceCloseOrderFiscalOperationMutation, ForceCloseOrderFiscalOperationMutationVariables>;
export const StartOrderFiscalPaymentReturnDocument = gql`
    mutation StartOrderFiscalPaymentReturn($operationId: ID!) {
  startOrderFiscalPaymentReturn(operationId: $operationId) {
    operation {
      ...OrderFiscalOperationFields
    }
    command
    id_command
    amount
    kkt_device_id
    terminal_device_id
  }
}
    ${OrderFiscalOperationFieldsFragmentDoc}`;

/**
 * __useStartOrderFiscalPaymentReturnMutation__
 *
 * To run a mutation, you first call `useStartOrderFiscalPaymentReturnMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartOrderFiscalPaymentReturnMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartOrderFiscalPaymentReturnMutation({
 *   variables: {
 *     operationId: // value for 'operationId'
 *   },
 * });
 */
export function useStartOrderFiscalPaymentReturnMutation(options: VueApolloComposable.UseMutationOptions<StartOrderFiscalPaymentReturnMutation, StartOrderFiscalPaymentReturnMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartOrderFiscalPaymentReturnMutation, StartOrderFiscalPaymentReturnMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StartOrderFiscalPaymentReturnMutation, StartOrderFiscalPaymentReturnMutationVariables>(StartOrderFiscalPaymentReturnDocument, options);
}
export type StartOrderFiscalPaymentReturnMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartOrderFiscalPaymentReturnMutation, StartOrderFiscalPaymentReturnMutationVariables>;
export const CompleteOrderFiscalPaymentReturnDocument = gql`
    mutation CompleteOrderFiscalPaymentReturn($input: CompleteOrderFiscalPaymentReturnInput!) {
  completeOrderFiscalPaymentReturn(input: $input) {
    ...OrderFiscalOperationFields
  }
}
    ${OrderFiscalOperationFieldsFragmentDoc}`;

/**
 * __useCompleteOrderFiscalPaymentReturnMutation__
 *
 * To run a mutation, you first call `useCompleteOrderFiscalPaymentReturnMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOrderFiscalPaymentReturnMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteOrderFiscalPaymentReturnMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCompleteOrderFiscalPaymentReturnMutation(options: VueApolloComposable.UseMutationOptions<CompleteOrderFiscalPaymentReturnMutation, CompleteOrderFiscalPaymentReturnMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteOrderFiscalPaymentReturnMutation, CompleteOrderFiscalPaymentReturnMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CompleteOrderFiscalPaymentReturnMutation, CompleteOrderFiscalPaymentReturnMutationVariables>(CompleteOrderFiscalPaymentReturnDocument, options);
}
export type CompleteOrderFiscalPaymentReturnMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteOrderFiscalPaymentReturnMutation, CompleteOrderFiscalPaymentReturnMutationVariables>;
export const GetOrderFiscalRefundOperationDocument = gql`
    query GetOrderFiscalRefundOperation($orderId: ID!) {
  orderFiscalRefundOperation(orderId: $orderId) {
    ...OrderFiscalRefundExecutionFields
  }
}
    ${OrderFiscalRefundExecutionFieldsFragmentDoc}`;

/**
 * __useGetOrderFiscalRefundOperationQuery__
 *
 * To run a query within a Vue component, call `useGetOrderFiscalRefundOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderFiscalRefundOperationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderFiscalRefundOperationQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetOrderFiscalRefundOperationQuery(variables: GetOrderFiscalRefundOperationQueryVariables | VueCompositionApi.Ref<GetOrderFiscalRefundOperationQueryVariables> | ReactiveFunction<GetOrderFiscalRefundOperationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables>(GetOrderFiscalRefundOperationDocument, variables, options);
}
export function useGetOrderFiscalRefundOperationLazyQuery(variables?: GetOrderFiscalRefundOperationQueryVariables | VueCompositionApi.Ref<GetOrderFiscalRefundOperationQueryVariables> | ReactiveFunction<GetOrderFiscalRefundOperationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables>(GetOrderFiscalRefundOperationDocument, variables, options);
}
export type GetOrderFiscalRefundOperationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderFiscalRefundOperationQuery, GetOrderFiscalRefundOperationQueryVariables>;
export const PrepareOrderFiscalRefundDocument = gql`
    mutation PrepareOrderFiscalRefund($input: PrepareOrderFiscalRefundInput!) {
  prepareOrderFiscalRefund(input: $input) {
    ...OrderFiscalRefundExecutionFields
  }
}
    ${OrderFiscalRefundExecutionFieldsFragmentDoc}`;

/**
 * __usePrepareOrderFiscalRefundMutation__
 *
 * To run a mutation, you first call `usePrepareOrderFiscalRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePrepareOrderFiscalRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePrepareOrderFiscalRefundMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePrepareOrderFiscalRefundMutation(options: VueApolloComposable.UseMutationOptions<PrepareOrderFiscalRefundMutation, PrepareOrderFiscalRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PrepareOrderFiscalRefundMutation, PrepareOrderFiscalRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PrepareOrderFiscalRefundMutation, PrepareOrderFiscalRefundMutationVariables>(PrepareOrderFiscalRefundDocument, options);
}
export type PrepareOrderFiscalRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PrepareOrderFiscalRefundMutation, PrepareOrderFiscalRefundMutationVariables>;
export const StartOrderFiscalRefundDocument = gql`
    mutation StartOrderFiscalRefund($input: OrderFiscalOperationIdentityInput!) {
  startOrderFiscalRefund(input: $input) {
    ...OrderFiscalRefundExecutionFields
  }
}
    ${OrderFiscalRefundExecutionFieldsFragmentDoc}`;

/**
 * __useStartOrderFiscalRefundMutation__
 *
 * To run a mutation, you first call `useStartOrderFiscalRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartOrderFiscalRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartOrderFiscalRefundMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useStartOrderFiscalRefundMutation(options: VueApolloComposable.UseMutationOptions<StartOrderFiscalRefundMutation, StartOrderFiscalRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartOrderFiscalRefundMutation, StartOrderFiscalRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StartOrderFiscalRefundMutation, StartOrderFiscalRefundMutationVariables>(StartOrderFiscalRefundDocument, options);
}
export type StartOrderFiscalRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartOrderFiscalRefundMutation, StartOrderFiscalRefundMutationVariables>;
export const CompleteOrderFiscalRefundDocument = gql`
    mutation CompleteOrderFiscalRefund($input: CompleteOrderFiscalRefundInput!) {
  completeOrderFiscalRefund(input: $input) {
    order {
      ...OrderFields
    }
    execution {
      ...OrderFiscalRefundExecutionFields
    }
  }
}
    ${OrderFieldsFragmentDoc}
${OrderFiscalRefundExecutionFieldsFragmentDoc}`;

/**
 * __useCompleteOrderFiscalRefundMutation__
 *
 * To run a mutation, you first call `useCompleteOrderFiscalRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOrderFiscalRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteOrderFiscalRefundMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCompleteOrderFiscalRefundMutation(options: VueApolloComposable.UseMutationOptions<CompleteOrderFiscalRefundMutation, CompleteOrderFiscalRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteOrderFiscalRefundMutation, CompleteOrderFiscalRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CompleteOrderFiscalRefundMutation, CompleteOrderFiscalRefundMutationVariables>(CompleteOrderFiscalRefundDocument, options);
}
export type CompleteOrderFiscalRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteOrderFiscalRefundMutation, CompleteOrderFiscalRefundMutationVariables>;
export const RetryOrderFiscalRefundReceiptDocument = gql`
    mutation RetryOrderFiscalRefundReceipt($input: RetryOrderFiscalReceiptInput!) {
  retryOrderFiscalReceipt(input: $input) {
    next_action
    operation {
      id
      status
    }
  }
}
    `;

/**
 * __useRetryOrderFiscalRefundReceiptMutation__
 *
 * To run a mutation, you first call `useRetryOrderFiscalRefundReceiptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryOrderFiscalRefundReceiptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryOrderFiscalRefundReceiptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRetryOrderFiscalRefundReceiptMutation(options: VueApolloComposable.UseMutationOptions<RetryOrderFiscalRefundReceiptMutation, RetryOrderFiscalRefundReceiptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RetryOrderFiscalRefundReceiptMutation, RetryOrderFiscalRefundReceiptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RetryOrderFiscalRefundReceiptMutation, RetryOrderFiscalRefundReceiptMutationVariables>(RetryOrderFiscalRefundReceiptDocument, options);
}
export type RetryOrderFiscalRefundReceiptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RetryOrderFiscalRefundReceiptMutation, RetryOrderFiscalRefundReceiptMutationVariables>;
export const ResolveOrderFiscalRefundReceiptDocument = gql`
    mutation ResolveOrderFiscalRefundReceipt($input: ResolveOrderFiscalReceiptInput!) {
  resolveOrderFiscalReceipt(input: $input) {
    execution {
      next_action
      operation {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useResolveOrderFiscalRefundReceiptMutation__
 *
 * To run a mutation, you first call `useResolveOrderFiscalRefundReceiptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResolveOrderFiscalRefundReceiptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResolveOrderFiscalRefundReceiptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResolveOrderFiscalRefundReceiptMutation(options: VueApolloComposable.UseMutationOptions<ResolveOrderFiscalRefundReceiptMutation, ResolveOrderFiscalRefundReceiptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResolveOrderFiscalRefundReceiptMutation, ResolveOrderFiscalRefundReceiptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResolveOrderFiscalRefundReceiptMutation, ResolveOrderFiscalRefundReceiptMutationVariables>(ResolveOrderFiscalRefundReceiptDocument, options);
}
export type ResolveOrderFiscalRefundReceiptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResolveOrderFiscalRefundReceiptMutation, ResolveOrderFiscalRefundReceiptMutationVariables>;
export const AnswerOrderFiscalRefundReceiptPrintedDocument = gql`
    mutation AnswerOrderFiscalRefundReceiptPrinted($input: AnswerOrderFiscalReceiptPrintedInput!) {
  answerOrderFiscalReceiptPrinted(input: $input) {
    execution {
      next_action
      operation {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useAnswerOrderFiscalRefundReceiptPrintedMutation__
 *
 * To run a mutation, you first call `useAnswerOrderFiscalRefundReceiptPrintedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAnswerOrderFiscalRefundReceiptPrintedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAnswerOrderFiscalRefundReceiptPrintedMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAnswerOrderFiscalRefundReceiptPrintedMutation(options: VueApolloComposable.UseMutationOptions<AnswerOrderFiscalRefundReceiptPrintedMutation, AnswerOrderFiscalRefundReceiptPrintedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AnswerOrderFiscalRefundReceiptPrintedMutation, AnswerOrderFiscalRefundReceiptPrintedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AnswerOrderFiscalRefundReceiptPrintedMutation, AnswerOrderFiscalRefundReceiptPrintedMutationVariables>(AnswerOrderFiscalRefundReceiptPrintedDocument, options);
}
export type AnswerOrderFiscalRefundReceiptPrintedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AnswerOrderFiscalRefundReceiptPrintedMutation, AnswerOrderFiscalRefundReceiptPrintedMutationVariables>;
export const FailOrderFiscalRefundDocument = gql`
    mutation FailOrderFiscalRefund($input: FailOrderFiscalRefundInput!) {
  failOrderFiscalRefund(input: $input) {
    order {
      ...OrderFields
    }
    execution {
      ...OrderFiscalRefundExecutionFields
    }
  }
}
    ${OrderFieldsFragmentDoc}
${OrderFiscalRefundExecutionFieldsFragmentDoc}`;

/**
 * __useFailOrderFiscalRefundMutation__
 *
 * To run a mutation, you first call `useFailOrderFiscalRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFailOrderFiscalRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFailOrderFiscalRefundMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useFailOrderFiscalRefundMutation(options: VueApolloComposable.UseMutationOptions<FailOrderFiscalRefundMutation, FailOrderFiscalRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FailOrderFiscalRefundMutation, FailOrderFiscalRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<FailOrderFiscalRefundMutation, FailOrderFiscalRefundMutationVariables>(FailOrderFiscalRefundDocument, options);
}
export type FailOrderFiscalRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FailOrderFiscalRefundMutation, FailOrderFiscalRefundMutationVariables>;
export const GetOrderFiscalSettlementOperationDocument = gql`
    query GetOrderFiscalSettlementOperation($orderId: ID!) {
  orderFiscalSettlementOperation(orderId: $orderId) {
    ...OrderFiscalExecutionFields
  }
}
    ${OrderFiscalExecutionFieldsFragmentDoc}`;

/**
 * __useGetOrderFiscalSettlementOperationQuery__
 *
 * To run a query within a Vue component, call `useGetOrderFiscalSettlementOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderFiscalSettlementOperationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderFiscalSettlementOperationQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetOrderFiscalSettlementOperationQuery(variables: GetOrderFiscalSettlementOperationQueryVariables | VueCompositionApi.Ref<GetOrderFiscalSettlementOperationQueryVariables> | ReactiveFunction<GetOrderFiscalSettlementOperationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables>(GetOrderFiscalSettlementOperationDocument, variables, options);
}
export function useGetOrderFiscalSettlementOperationLazyQuery(variables?: GetOrderFiscalSettlementOperationQueryVariables | VueCompositionApi.Ref<GetOrderFiscalSettlementOperationQueryVariables> | ReactiveFunction<GetOrderFiscalSettlementOperationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables>(GetOrderFiscalSettlementOperationDocument, variables, options);
}
export type GetOrderFiscalSettlementOperationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderFiscalSettlementOperationQuery, GetOrderFiscalSettlementOperationQueryVariables>;
export const PrepareOrderFiscalSettlementDocument = gql`
    mutation PrepareOrderFiscalSettlement($input: PrepareOrderFiscalSettlementInput!) {
  prepareOrderFiscalSettlement(input: $input) {
    ...OrderFiscalExecutionFields
  }
}
    ${OrderFiscalExecutionFieldsFragmentDoc}`;

/**
 * __usePrepareOrderFiscalSettlementMutation__
 *
 * To run a mutation, you first call `usePrepareOrderFiscalSettlementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePrepareOrderFiscalSettlementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePrepareOrderFiscalSettlementMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePrepareOrderFiscalSettlementMutation(options: VueApolloComposable.UseMutationOptions<PrepareOrderFiscalSettlementMutation, PrepareOrderFiscalSettlementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PrepareOrderFiscalSettlementMutation, PrepareOrderFiscalSettlementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PrepareOrderFiscalSettlementMutation, PrepareOrderFiscalSettlementMutationVariables>(PrepareOrderFiscalSettlementDocument, options);
}
export type PrepareOrderFiscalSettlementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PrepareOrderFiscalSettlementMutation, PrepareOrderFiscalSettlementMutationVariables>;
export const StartOrderFiscalSettlementDocument = gql`
    mutation StartOrderFiscalSettlement($input: OrderFiscalOperationIdentityInput!) {
  startOrderFiscalSettlement(input: $input) {
    ...OrderFiscalExecutionFields
  }
}
    ${OrderFiscalExecutionFieldsFragmentDoc}`;

/**
 * __useStartOrderFiscalSettlementMutation__
 *
 * To run a mutation, you first call `useStartOrderFiscalSettlementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartOrderFiscalSettlementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartOrderFiscalSettlementMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useStartOrderFiscalSettlementMutation(options: VueApolloComposable.UseMutationOptions<StartOrderFiscalSettlementMutation, StartOrderFiscalSettlementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartOrderFiscalSettlementMutation, StartOrderFiscalSettlementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StartOrderFiscalSettlementMutation, StartOrderFiscalSettlementMutationVariables>(StartOrderFiscalSettlementDocument, options);
}
export type StartOrderFiscalSettlementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartOrderFiscalSettlementMutation, StartOrderFiscalSettlementMutationVariables>;
export const CompleteOrderFiscalSettlementDocument = gql`
    mutation CompleteOrderFiscalSettlement($input: CompleteOrderFiscalSettlementInput!) {
  completeOrderFiscalSettlement(input: $input) {
    order {
      ...OrderFields
    }
    execution {
      ...OrderFiscalExecutionFields
    }
  }
}
    ${OrderFieldsFragmentDoc}
${OrderFiscalExecutionFieldsFragmentDoc}`;

/**
 * __useCompleteOrderFiscalSettlementMutation__
 *
 * To run a mutation, you first call `useCompleteOrderFiscalSettlementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOrderFiscalSettlementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteOrderFiscalSettlementMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCompleteOrderFiscalSettlementMutation(options: VueApolloComposable.UseMutationOptions<CompleteOrderFiscalSettlementMutation, CompleteOrderFiscalSettlementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteOrderFiscalSettlementMutation, CompleteOrderFiscalSettlementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CompleteOrderFiscalSettlementMutation, CompleteOrderFiscalSettlementMutationVariables>(CompleteOrderFiscalSettlementDocument, options);
}
export type CompleteOrderFiscalSettlementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteOrderFiscalSettlementMutation, CompleteOrderFiscalSettlementMutationVariables>;
export const FailOrderFiscalSettlementDocument = gql`
    mutation FailOrderFiscalSettlement($input: FailOrderFiscalSettlementInput!) {
  failOrderFiscalSettlement(input: $input) {
    order {
      ...OrderFields
    }
    execution {
      ...OrderFiscalExecutionFields
    }
  }
}
    ${OrderFieldsFragmentDoc}
${OrderFiscalExecutionFieldsFragmentDoc}`;

/**
 * __useFailOrderFiscalSettlementMutation__
 *
 * To run a mutation, you first call `useFailOrderFiscalSettlementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFailOrderFiscalSettlementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFailOrderFiscalSettlementMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useFailOrderFiscalSettlementMutation(options: VueApolloComposable.UseMutationOptions<FailOrderFiscalSettlementMutation, FailOrderFiscalSettlementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FailOrderFiscalSettlementMutation, FailOrderFiscalSettlementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<FailOrderFiscalSettlementMutation, FailOrderFiscalSettlementMutationVariables>(FailOrderFiscalSettlementDocument, options);
}
export type FailOrderFiscalSettlementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FailOrderFiscalSettlementMutation, FailOrderFiscalSettlementMutationVariables>;
export const RetryOrderFiscalReceiptDocument = gql`
    mutation RetryOrderFiscalReceipt($input: RetryOrderFiscalReceiptInput!) {
  retryOrderFiscalReceipt(input: $input) {
    ...OrderFiscalExecutionFields
  }
}
    ${OrderFiscalExecutionFieldsFragmentDoc}`;

/**
 * __useRetryOrderFiscalReceiptMutation__
 *
 * To run a mutation, you first call `useRetryOrderFiscalReceiptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryOrderFiscalReceiptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryOrderFiscalReceiptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRetryOrderFiscalReceiptMutation(options: VueApolloComposable.UseMutationOptions<RetryOrderFiscalReceiptMutation, RetryOrderFiscalReceiptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RetryOrderFiscalReceiptMutation, RetryOrderFiscalReceiptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RetryOrderFiscalReceiptMutation, RetryOrderFiscalReceiptMutationVariables>(RetryOrderFiscalReceiptDocument, options);
}
export type RetryOrderFiscalReceiptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RetryOrderFiscalReceiptMutation, RetryOrderFiscalReceiptMutationVariables>;
export const ResolveOrderFiscalReceiptDocument = gql`
    mutation ResolveOrderFiscalReceipt($input: ResolveOrderFiscalReceiptInput!) {
  resolveOrderFiscalReceipt(input: $input) {
    order {
      ...OrderFields
    }
    execution {
      ...OrderFiscalExecutionFields
    }
  }
}
    ${OrderFieldsFragmentDoc}
${OrderFiscalExecutionFieldsFragmentDoc}`;

/**
 * __useResolveOrderFiscalReceiptMutation__
 *
 * To run a mutation, you first call `useResolveOrderFiscalReceiptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResolveOrderFiscalReceiptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResolveOrderFiscalReceiptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResolveOrderFiscalReceiptMutation(options: VueApolloComposable.UseMutationOptions<ResolveOrderFiscalReceiptMutation, ResolveOrderFiscalReceiptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResolveOrderFiscalReceiptMutation, ResolveOrderFiscalReceiptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResolveOrderFiscalReceiptMutation, ResolveOrderFiscalReceiptMutationVariables>(ResolveOrderFiscalReceiptDocument, options);
}
export type ResolveOrderFiscalReceiptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResolveOrderFiscalReceiptMutation, ResolveOrderFiscalReceiptMutationVariables>;
export const AnswerOrderFiscalReceiptPrintedDocument = gql`
    mutation AnswerOrderFiscalReceiptPrinted($input: AnswerOrderFiscalReceiptPrintedInput!) {
  answerOrderFiscalReceiptPrinted(input: $input) {
    order {
      ...OrderFields
    }
    execution {
      ...OrderFiscalExecutionFields
    }
  }
}
    ${OrderFieldsFragmentDoc}
${OrderFiscalExecutionFieldsFragmentDoc}`;

/**
 * __useAnswerOrderFiscalReceiptPrintedMutation__
 *
 * To run a mutation, you first call `useAnswerOrderFiscalReceiptPrintedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAnswerOrderFiscalReceiptPrintedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAnswerOrderFiscalReceiptPrintedMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAnswerOrderFiscalReceiptPrintedMutation(options: VueApolloComposable.UseMutationOptions<AnswerOrderFiscalReceiptPrintedMutation, AnswerOrderFiscalReceiptPrintedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AnswerOrderFiscalReceiptPrintedMutation, AnswerOrderFiscalReceiptPrintedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AnswerOrderFiscalReceiptPrintedMutation, AnswerOrderFiscalReceiptPrintedMutationVariables>(AnswerOrderFiscalReceiptPrintedDocument, options);
}
export type AnswerOrderFiscalReceiptPrintedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AnswerOrderFiscalReceiptPrintedMutation, AnswerOrderFiscalReceiptPrintedMutationVariables>;
export const CancelOrderFiscalPaymentDocument = gql`
    mutation CancelOrderFiscalPayment($input: CancelOrderFiscalPaymentInput!) {
  cancelOrderFiscalPayment(input: $input) {
    id
    status
    failure_kind
    bank_payment_status
    failed_at
    cash_amount
  }
}
    `;

/**
 * __useCancelOrderFiscalPaymentMutation__
 *
 * To run a mutation, you first call `useCancelOrderFiscalPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderFiscalPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelOrderFiscalPaymentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCancelOrderFiscalPaymentMutation(options: VueApolloComposable.UseMutationOptions<CancelOrderFiscalPaymentMutation, CancelOrderFiscalPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelOrderFiscalPaymentMutation, CancelOrderFiscalPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelOrderFiscalPaymentMutation, CancelOrderFiscalPaymentMutationVariables>(CancelOrderFiscalPaymentDocument, options);
}
export type CancelOrderFiscalPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelOrderFiscalPaymentMutation, CancelOrderFiscalPaymentMutationVariables>;
export const SendPaymentLinkDocument = gql`
    mutation SendPaymentLink($input: SendPaymentLinkInput!) {
  sendPaymentLink(input: $input) {
    conversation_id
    provider
  }
}
    `;

/**
 * __useSendPaymentLinkMutation__
 *
 * To run a mutation, you first call `useSendPaymentLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendPaymentLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentLinkMutation(options: VueApolloComposable.UseMutationOptions<SendPaymentLinkMutation, SendPaymentLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>(SendPaymentLinkDocument, options);
}
export type SendPaymentLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>;
export const RefundAdvanceDocument = gql`
    mutation RefundAdvance($input: RefundAdvanceInput!) {
  refundAdvance(input: $input) {
    refund {
      id
      status
    }
  }
}
    `;

/**
 * __useRefundAdvanceMutation__
 *
 * To run a mutation, you first call `useRefundAdvanceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefundAdvanceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefundAdvanceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRefundAdvanceMutation(options: VueApolloComposable.UseMutationOptions<RefundAdvanceMutation, RefundAdvanceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RefundAdvanceMutation, RefundAdvanceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RefundAdvanceMutation, RefundAdvanceMutationVariables>(RefundAdvanceDocument, options);
}
export type RefundAdvanceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RefundAdvanceMutation, RefundAdvanceMutationVariables>;
export const RefundOrderDocument = gql`
    mutation RefundOrder($input: RefundOrderInput!) {
  refundOrder(input: $input) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useRefundOrderMutation__
 *
 * To run a mutation, you first call `useRefundOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefundOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefundOrderMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRefundOrderMutation(options: VueApolloComposable.UseMutationOptions<RefundOrderMutation, RefundOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RefundOrderMutation, RefundOrderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RefundOrderMutation, RefundOrderMutationVariables>(RefundOrderDocument, options);
}
export type RefundOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RefundOrderMutation, RefundOrderMutationVariables>;
export const RequestOrderRefundApprovalDocument = gql`
    mutation RequestOrderRefundApproval($input: RequestOrderRefundApprovalInput!) {
  requestOrderRefundApproval(input: $input) {
    ...OrderRefundApprovalFields
  }
}
    ${OrderRefundApprovalFieldsFragmentDoc}`;

/**
 * __useRequestOrderRefundApprovalMutation__
 *
 * To run a mutation, you first call `useRequestOrderRefundApprovalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrderRefundApprovalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestOrderRefundApprovalMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestOrderRefundApprovalMutation(options: VueApolloComposable.UseMutationOptions<RequestOrderRefundApprovalMutation, RequestOrderRefundApprovalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestOrderRefundApprovalMutation, RequestOrderRefundApprovalMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestOrderRefundApprovalMutation, RequestOrderRefundApprovalMutationVariables>(RequestOrderRefundApprovalDocument, options);
}
export type RequestOrderRefundApprovalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestOrderRefundApprovalMutation, RequestOrderRefundApprovalMutationVariables>;
export const ResolveOrderRefundApprovalDocument = gql`
    mutation ResolveOrderRefundApproval($input: ResolveOrderRefundApprovalInput!) {
  resolveOrderRefundApproval(input: $input) {
    ...OrderRefundApprovalFields
  }
}
    ${OrderRefundApprovalFieldsFragmentDoc}`;

/**
 * __useResolveOrderRefundApprovalMutation__
 *
 * To run a mutation, you first call `useResolveOrderRefundApprovalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResolveOrderRefundApprovalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResolveOrderRefundApprovalMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResolveOrderRefundApprovalMutation(options: VueApolloComposable.UseMutationOptions<ResolveOrderRefundApprovalMutation, ResolveOrderRefundApprovalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResolveOrderRefundApprovalMutation, ResolveOrderRefundApprovalMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResolveOrderRefundApprovalMutation, ResolveOrderRefundApprovalMutationVariables>(ResolveOrderRefundApprovalDocument, options);
}
export type ResolveOrderRefundApprovalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResolveOrderRefundApprovalMutation, ResolveOrderRefundApprovalMutationVariables>;
export const RecordOrderOutsideTerminalRefundDocument = gql`
    mutation RecordOrderOutsideTerminalRefund($input: RecordOrderOutsideTerminalRefundInput!) {
  recordOrderOutsideTerminalRefund(input: $input) {
    order {
      ...OrderFields
    }
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useRecordOrderOutsideTerminalRefundMutation__
 *
 * To run a mutation, you first call `useRecordOrderOutsideTerminalRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRecordOrderOutsideTerminalRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRecordOrderOutsideTerminalRefundMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRecordOrderOutsideTerminalRefundMutation(options: VueApolloComposable.UseMutationOptions<RecordOrderOutsideTerminalRefundMutation, RecordOrderOutsideTerminalRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RecordOrderOutsideTerminalRefundMutation, RecordOrderOutsideTerminalRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RecordOrderOutsideTerminalRefundMutation, RecordOrderOutsideTerminalRefundMutationVariables>(RecordOrderOutsideTerminalRefundDocument, options);
}
export type RecordOrderOutsideTerminalRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RecordOrderOutsideTerminalRefundMutation, RecordOrderOutsideTerminalRefundMutationVariables>;
export const CompleteOrderRefundTransferDocument = gql`
    mutation CompleteOrderRefundTransfer($input: CompleteOrderRefundTransferInput!) {
  completeOrderRefundTransfer(input: $input) {
    order {
      ...OrderFields
    }
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useCompleteOrderRefundTransferMutation__
 *
 * To run a mutation, you first call `useCompleteOrderRefundTransferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOrderRefundTransferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteOrderRefundTransferMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCompleteOrderRefundTransferMutation(options: VueApolloComposable.UseMutationOptions<CompleteOrderRefundTransferMutation, CompleteOrderRefundTransferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteOrderRefundTransferMutation, CompleteOrderRefundTransferMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CompleteOrderRefundTransferMutation, CompleteOrderRefundTransferMutationVariables>(CompleteOrderRefundTransferDocument, options);
}
export type CompleteOrderRefundTransferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteOrderRefundTransferMutation, CompleteOrderRefundTransferMutationVariables>;
export const CreatePlatformOrganizationDocument = gql`
    mutation CreatePlatformOrganization($input: PlatformCreateOrganizationInput!) {
  platformCreateOrganization(input: $input) {
    id
    title
    domain
    enabled_modules
  }
}
    `;

/**
 * __useCreatePlatformOrganizationMutation__
 *
 * To run a mutation, you first call `useCreatePlatformOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlatformOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePlatformOrganizationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlatformOrganizationMutation(options: VueApolloComposable.UseMutationOptions<CreatePlatformOrganizationMutation, CreatePlatformOrganizationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePlatformOrganizationMutation, CreatePlatformOrganizationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreatePlatformOrganizationMutation, CreatePlatformOrganizationMutationVariables>(CreatePlatformOrganizationDocument, options);
}
export type CreatePlatformOrganizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePlatformOrganizationMutation, CreatePlatformOrganizationMutationVariables>;
export const CreatePlatformEmployeeDocument = gql`
    mutation CreatePlatformEmployee($input: PlatformCreateEmployeeInput!) {
  platformCreateEmployee(input: $input) {
    id
    has_all_locations_access
    user {
      id
      phone
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useCreatePlatformEmployeeMutation__
 *
 * To run a mutation, you first call `useCreatePlatformEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlatformEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePlatformEmployeeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlatformEmployeeMutation(options: VueApolloComposable.UseMutationOptions<CreatePlatformEmployeeMutation, CreatePlatformEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePlatformEmployeeMutation, CreatePlatformEmployeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreatePlatformEmployeeMutation, CreatePlatformEmployeeMutationVariables>(CreatePlatformEmployeeDocument, options);
}
export type CreatePlatformEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePlatformEmployeeMutation, CreatePlatformEmployeeMutationVariables>;
export const GetPlatformOrganizationRolesDocument = gql`
    query GetPlatformOrganizationRoles($organizationId: ID!) {
  platformOrganizationRoles(organizationId: $organizationId) {
    id
    name
    title
  }
}
    `;

/**
 * __useGetPlatformOrganizationRolesQuery__
 *
 * To run a query within a Vue component, call `useGetPlatformOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformOrganizationRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPlatformOrganizationRolesQuery({
 *   organizationId: // value for 'organizationId'
 * });
 */
export function useGetPlatformOrganizationRolesQuery(variables: GetPlatformOrganizationRolesQueryVariables | VueCompositionApi.Ref<GetPlatformOrganizationRolesQueryVariables> | ReactiveFunction<GetPlatformOrganizationRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables>(GetPlatformOrganizationRolesDocument, variables, options);
}
export function useGetPlatformOrganizationRolesLazyQuery(variables?: GetPlatformOrganizationRolesQueryVariables | VueCompositionApi.Ref<GetPlatformOrganizationRolesQueryVariables> | ReactiveFunction<GetPlatformOrganizationRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables>(GetPlatformOrganizationRolesDocument, variables, options);
}
export type GetPlatformOrganizationRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPlatformOrganizationRolesQuery, GetPlatformOrganizationRolesQueryVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($input: ProductInput!) {
  createProduct(input: $input) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProductMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(options: VueApolloComposable.UseMutationOptions<CreateProductMutation, CreateProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateProductMutation, CreateProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
}
export type CreateProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: ID!, $input: ProductInput!) {
  updateProduct(id: $id, input: $input) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProductMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(options: VueApolloComposable.UseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
}
export type UpdateProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateProductMutation, UpdateProductMutationVariables>;
export const ReceiveProductDocument = gql`
    mutation ReceiveProduct($input: ProductMovementInput!) {
  receiveProduct(input: $input) {
    ...ProductMovementFields
  }
}
    ${ProductMovementFieldsFragmentDoc}`;

/**
 * __useReceiveProductMutation__
 *
 * To run a mutation, you first call `useReceiveProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReceiveProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReceiveProductMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReceiveProductMutation(options: VueApolloComposable.UseMutationOptions<ReceiveProductMutation, ReceiveProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReceiveProductMutation, ReceiveProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReceiveProductMutation, ReceiveProductMutationVariables>(ReceiveProductDocument, options);
}
export type ReceiveProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReceiveProductMutation, ReceiveProductMutationVariables>;
export const WriteOffProductDocument = gql`
    mutation WriteOffProduct($input: ProductMovementInput!) {
  writeOffProduct(input: $input) {
    ...ProductMovementFields
  }
}
    ${ProductMovementFieldsFragmentDoc}`;

/**
 * __useWriteOffProductMutation__
 *
 * To run a mutation, you first call `useWriteOffProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useWriteOffProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useWriteOffProductMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useWriteOffProductMutation(options: VueApolloComposable.UseMutationOptions<WriteOffProductMutation, WriteOffProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<WriteOffProductMutation, WriteOffProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<WriteOffProductMutation, WriteOffProductMutationVariables>(WriteOffProductDocument, options);
}
export type WriteOffProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<WriteOffProductMutation, WriteOffProductMutationVariables>;
export const TransferProductDocument = gql`
    mutation TransferProduct($input: ProductTransferInput!) {
  transferProduct(input: $input) {
    ...ProductMovementFields
  }
}
    ${ProductMovementFieldsFragmentDoc}`;

/**
 * __useTransferProductMutation__
 *
 * To run a mutation, you first call `useTransferProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTransferProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTransferProductMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTransferProductMutation(options: VueApolloComposable.UseMutationOptions<TransferProductMutation, TransferProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TransferProductMutation, TransferProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TransferProductMutation, TransferProductMutationVariables>(TransferProductDocument, options);
}
export type TransferProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TransferProductMutation, TransferProductMutationVariables>;
export const ReverseProductReceiptDocument = gql`
    mutation ReverseProductReceipt($id: ID!) {
  reverseProductReceipt(id: $id) {
    ...ProductMovementFields
  }
}
    ${ProductMovementFieldsFragmentDoc}`;

/**
 * __useReverseProductReceiptMutation__
 *
 * To run a mutation, you first call `useReverseProductReceiptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReverseProductReceiptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReverseProductReceiptMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useReverseProductReceiptMutation(options: VueApolloComposable.UseMutationOptions<ReverseProductReceiptMutation, ReverseProductReceiptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReverseProductReceiptMutation, ReverseProductReceiptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReverseProductReceiptMutation, ReverseProductReceiptMutationVariables>(ReverseProductReceiptDocument, options);
}
export type ReverseProductReceiptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReverseProductReceiptMutation, ReverseProductReceiptMutationVariables>;
export const UploadProductPhotoDocument = gql`
    mutation UploadProductPhoto($file: Upload!) {
  uploadProductPhoto(file: $file) {
    url
  }
}
    `;

/**
 * __useUploadProductPhotoMutation__
 *
 * To run a mutation, you first call `useUploadProductPhotoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadProductPhotoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadProductPhotoMutation({
 *   variables: {
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadProductPhotoMutation(options: VueApolloComposable.UseMutationOptions<UploadProductPhotoMutation, UploadProductPhotoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadProductPhotoMutation, UploadProductPhotoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadProductPhotoMutation, UploadProductPhotoMutationVariables>(UploadProductPhotoDocument, options);
}
export type UploadProductPhotoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadProductPhotoMutation, UploadProductPhotoMutationVariables>;
export const PushNotificationCapabilityDocument = gql`
    query PushNotificationCapability {
  webPushContext {
    capability {
      enabled
      public_key
    }
  }
}
    `;

/**
 * __usePushNotificationCapabilityQuery__
 *
 * To run a query within a Vue component, call `usePushNotificationCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePushNotificationCapabilityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePushNotificationCapabilityQuery();
 */
export function usePushNotificationCapabilityQuery(options: VueApolloComposable.UseQueryOptions<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables>(PushNotificationCapabilityDocument, {}, options);
}
export function usePushNotificationCapabilityLazyQuery(options: VueApolloComposable.UseQueryOptions<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables>(PushNotificationCapabilityDocument, {}, options);
}
export type PushNotificationCapabilityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PushNotificationCapabilityQuery, PushNotificationCapabilityQueryVariables>;
export const PushNotificationPreferencesDocument = gql`
    query PushNotificationPreferences {
  webPushContext {
    preferences {
      kind
      enabled
      available
    }
  }
}
    `;

/**
 * __usePushNotificationPreferencesQuery__
 *
 * To run a query within a Vue component, call `usePushNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePushNotificationPreferencesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePushNotificationPreferencesQuery();
 */
export function usePushNotificationPreferencesQuery(options: VueApolloComposable.UseQueryOptions<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables>(PushNotificationPreferencesDocument, {}, options);
}
export function usePushNotificationPreferencesLazyQuery(options: VueApolloComposable.UseQueryOptions<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables>(PushNotificationPreferencesDocument, {}, options);
}
export type PushNotificationPreferencesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PushNotificationPreferencesQuery, PushNotificationPreferencesQueryVariables>;
export const UpsertCurrentPushSubscriptionDocument = gql`
    mutation UpsertCurrentPushSubscription($input: UpsertWebPushSubscriptionInput!) {
  upsertWebPushSubscription(input: $input) {
    id
  }
}
    `;

/**
 * __useUpsertCurrentPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpsertCurrentPushSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCurrentPushSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertCurrentPushSubscriptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCurrentPushSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<UpsertCurrentPushSubscriptionMutation, UpsertCurrentPushSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertCurrentPushSubscriptionMutation, UpsertCurrentPushSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertCurrentPushSubscriptionMutation, UpsertCurrentPushSubscriptionMutationVariables>(UpsertCurrentPushSubscriptionDocument, options);
}
export type UpsertCurrentPushSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertCurrentPushSubscriptionMutation, UpsertCurrentPushSubscriptionMutationVariables>;
export const DeleteCurrentPushSubscriptionDocument = gql`
    mutation DeleteCurrentPushSubscription($input: WebPushEndpointInput!) {
  deleteWebPushSubscription(input: $input) {
    id
  }
}
    `;

/**
 * __useDeleteCurrentPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteCurrentPushSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurrentPushSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCurrentPushSubscriptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCurrentPushSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<DeleteCurrentPushSubscriptionMutation, DeleteCurrentPushSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCurrentPushSubscriptionMutation, DeleteCurrentPushSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCurrentPushSubscriptionMutation, DeleteCurrentPushSubscriptionMutationVariables>(DeleteCurrentPushSubscriptionDocument, options);
}
export type DeleteCurrentPushSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCurrentPushSubscriptionMutation, DeleteCurrentPushSubscriptionMutationVariables>;
export const TestCurrentPushSubscriptionDocument = gql`
    mutation TestCurrentPushSubscription($input: WebPushEndpointInput!) {
  testWebPushSubscription(input: $input) {
    id
  }
}
    `;

/**
 * __useTestCurrentPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useTestCurrentPushSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestCurrentPushSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestCurrentPushSubscriptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTestCurrentPushSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<TestCurrentPushSubscriptionMutation, TestCurrentPushSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TestCurrentPushSubscriptionMutation, TestCurrentPushSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TestCurrentPushSubscriptionMutation, TestCurrentPushSubscriptionMutationVariables>(TestCurrentPushSubscriptionDocument, options);
}
export type TestCurrentPushSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TestCurrentPushSubscriptionMutation, TestCurrentPushSubscriptionMutationVariables>;
export const UpdatePushNotificationPreferenceDocument = gql`
    mutation UpdatePushNotificationPreference($input: UpdateWebPushNotificationPreferenceInput!) {
  updateWebPushNotificationPreference(input: $input) {
    web_push_notification_preferences {
      kind
      enabled
      available
    }
  }
}
    `;

/**
 * __useUpdatePushNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdatePushNotificationPreferenceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePushNotificationPreferenceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePushNotificationPreferenceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePushNotificationPreferenceMutation(options: VueApolloComposable.UseMutationOptions<UpdatePushNotificationPreferenceMutation, UpdatePushNotificationPreferenceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePushNotificationPreferenceMutation, UpdatePushNotificationPreferenceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdatePushNotificationPreferenceMutation, UpdatePushNotificationPreferenceMutationVariables>(UpdatePushNotificationPreferenceDocument, options);
}
export type UpdatePushNotificationPreferenceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePushNotificationPreferenceMutation, UpdatePushNotificationPreferenceMutationVariables>;
export const CreateQrLinkDocument = gql`
    mutation CreateQrLink($input: CreateQrLinkInput!) {
  createQrLink(input: $input) {
    ...QrLinkFragment
  }
}
    ${QrLinkFragmentFragmentDoc}`;

/**
 * __useCreateQrLinkMutation__
 *
 * To run a mutation, you first call `useCreateQrLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQrLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQrLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateQrLinkMutation(options: VueApolloComposable.UseMutationOptions<CreateQrLinkMutation, CreateQrLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateQrLinkMutation, CreateQrLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateQrLinkMutation, CreateQrLinkMutationVariables>(CreateQrLinkDocument, options);
}
export type CreateQrLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateQrLinkMutation, CreateQrLinkMutationVariables>;
export const UpdateQrLinkDocument = gql`
    mutation UpdateQrLink($id: ID!, $input: UpdateQrLinkInput!) {
  updateQrLink(id: $id, input: $input) {
    ...QrLinkFragment
  }
}
    ${QrLinkFragmentFragmentDoc}`;

/**
 * __useUpdateQrLinkMutation__
 *
 * To run a mutation, you first call `useUpdateQrLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQrLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQrLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQrLinkMutation(options: VueApolloComposable.UseMutationOptions<UpdateQrLinkMutation, UpdateQrLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateQrLinkMutation, UpdateQrLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateQrLinkMutation, UpdateQrLinkMutationVariables>(UpdateQrLinkDocument, options);
}
export type UpdateQrLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateQrLinkMutation, UpdateQrLinkMutationVariables>;
export const DeleteQrLinkDocument = gql`
    mutation DeleteQrLink($id: ID!) {
  deleteQrLink(id: $id)
}
    `;

/**
 * __useDeleteQrLinkMutation__
 *
 * To run a mutation, you first call `useDeleteQrLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQrLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteQrLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQrLinkMutation(options: VueApolloComposable.UseMutationOptions<DeleteQrLinkMutation, DeleteQrLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteQrLinkMutation, DeleteQrLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteQrLinkMutation, DeleteQrLinkMutationVariables>(DeleteQrLinkDocument, options);
}
export type DeleteQrLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteQrLinkMutation, DeleteQrLinkMutationVariables>;
export const RestoreQrLinkDocument = gql`
    mutation RestoreQrLink($id: ID!) {
  restoreQrLink(id: $id) {
    ...QrLinkFragment
  }
}
    ${QrLinkFragmentFragmentDoc}`;

/**
 * __useRestoreQrLinkMutation__
 *
 * To run a mutation, you first call `useRestoreQrLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRestoreQrLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRestoreQrLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRestoreQrLinkMutation(options: VueApolloComposable.UseMutationOptions<RestoreQrLinkMutation, RestoreQrLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RestoreQrLinkMutation, RestoreQrLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RestoreQrLinkMutation, RestoreQrLinkMutationVariables>(RestoreQrLinkDocument, options);
}
export type RestoreQrLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RestoreQrLinkMutation, RestoreQrLinkMutationVariables>;
export const CreateScenarioDocument = gql`
    mutation CreateScenario($input: CreateScenarioInput!) {
  createScenario(input: $input) {
    ...ScenarioDetailFragment
  }
}
    ${ScenarioDetailFragmentFragmentDoc}`;

/**
 * __useCreateScenarioMutation__
 *
 * To run a mutation, you first call `useCreateScenarioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateScenarioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateScenarioMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateScenarioMutation(options: VueApolloComposable.UseMutationOptions<CreateScenarioMutation, CreateScenarioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateScenarioMutation, CreateScenarioMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateScenarioMutation, CreateScenarioMutationVariables>(CreateScenarioDocument, options);
}
export type CreateScenarioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateScenarioMutation, CreateScenarioMutationVariables>;
export const UpdateScenarioDocument = gql`
    mutation UpdateScenario($id: ID!, $input: UpdateScenarioInput!) {
  updateScenario(id: $id, input: $input) {
    ...ScenarioDetailFragment
  }
}
    ${ScenarioDetailFragmentFragmentDoc}`;

/**
 * __useUpdateScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateScenarioMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScenarioMutation(options: VueApolloComposable.UseMutationOptions<UpdateScenarioMutation, UpdateScenarioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateScenarioMutation, UpdateScenarioMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateScenarioMutation, UpdateScenarioMutationVariables>(UpdateScenarioDocument, options);
}
export type UpdateScenarioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateScenarioMutation, UpdateScenarioMutationVariables>;
export const DeleteScenarioDocument = gql`
    mutation DeleteScenario($id: ID!) {
  deleteScenario(id: $id)
}
    `;

/**
 * __useDeleteScenarioMutation__
 *
 * To run a mutation, you first call `useDeleteScenarioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScenarioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteScenarioMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScenarioMutation(options: VueApolloComposable.UseMutationOptions<DeleteScenarioMutation, DeleteScenarioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteScenarioMutation, DeleteScenarioMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteScenarioMutation, DeleteScenarioMutationVariables>(DeleteScenarioDocument, options);
}
export type DeleteScenarioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteScenarioMutation, DeleteScenarioMutationVariables>;
export const ActivateScenarioDocument = gql`
    mutation ActivateScenario($id: ID!) {
  activateScenario(id: $id) {
    ...ScenarioDetailFragment
  }
}
    ${ScenarioDetailFragmentFragmentDoc}`;

/**
 * __useActivateScenarioMutation__
 *
 * To run a mutation, you first call `useActivateScenarioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateScenarioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateScenarioMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateScenarioMutation(options: VueApolloComposable.UseMutationOptions<ActivateScenarioMutation, ActivateScenarioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActivateScenarioMutation, ActivateScenarioMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActivateScenarioMutation, ActivateScenarioMutationVariables>(ActivateScenarioDocument, options);
}
export type ActivateScenarioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActivateScenarioMutation, ActivateScenarioMutationVariables>;
export const DeactivateScenarioDocument = gql`
    mutation DeactivateScenario($id: ID!) {
  deactivateScenario(id: $id) {
    ...ScenarioDetailFragment
  }
}
    ${ScenarioDetailFragmentFragmentDoc}`;

/**
 * __useDeactivateScenarioMutation__
 *
 * To run a mutation, you first call `useDeactivateScenarioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateScenarioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateScenarioMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateScenarioMutation(options: VueApolloComposable.UseMutationOptions<DeactivateScenarioMutation, DeactivateScenarioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateScenarioMutation, DeactivateScenarioMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateScenarioMutation, DeactivateScenarioMutationVariables>(DeactivateScenarioDocument, options);
}
export type DeactivateScenarioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateScenarioMutation, DeactivateScenarioMutationVariables>;
export const CreateTireCarDocument = gql`
    mutation CreateTireCar($input: TireCarInput!) {
  createTireCar(input: $input) {
    ...TireCarFields
  }
}
    ${TireCarFieldsFragmentDoc}`;

/**
 * __useCreateTireCarMutation__
 *
 * To run a mutation, you first call `useCreateTireCarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTireCarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTireCarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTireCarMutation(options: VueApolloComposable.UseMutationOptions<CreateTireCarMutation, CreateTireCarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateTireCarMutation, CreateTireCarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateTireCarMutation, CreateTireCarMutationVariables>(CreateTireCarDocument, options);
}
export type CreateTireCarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateTireCarMutation, CreateTireCarMutationVariables>;
export const UpdateTireCarDocument = gql`
    mutation UpdateTireCar($id: ID!, $input: TireCarInput!) {
  updateTireCar(id: $id, input: $input) {
    ...TireCarFields
  }
}
    ${TireCarFieldsFragmentDoc}`;

/**
 * __useUpdateTireCarMutation__
 *
 * To run a mutation, you first call `useUpdateTireCarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTireCarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTireCarMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTireCarMutation(options: VueApolloComposable.UseMutationOptions<UpdateTireCarMutation, UpdateTireCarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTireCarMutation, UpdateTireCarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTireCarMutation, UpdateTireCarMutationVariables>(UpdateTireCarDocument, options);
}
export type UpdateTireCarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTireCarMutation, UpdateTireCarMutationVariables>;
export const DeleteTireCarDocument = gql`
    mutation DeleteTireCar($id: ID!) {
  deleteTireCar(id: $id)
}
    `;

/**
 * __useDeleteTireCarMutation__
 *
 * To run a mutation, you first call `useDeleteTireCarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTireCarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTireCarMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTireCarMutation(options: VueApolloComposable.UseMutationOptions<DeleteTireCarMutation, DeleteTireCarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTireCarMutation, DeleteTireCarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTireCarMutation, DeleteTireCarMutationVariables>(DeleteTireCarDocument, options);
}
export type DeleteTireCarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTireCarMutation, DeleteTireCarMutationVariables>;
export const ConnectOrganizationAddOnDocument = gql`
    mutation ConnectOrganizationAddOn($module: OrganizationModule!) {
  connectOrganizationAddOn(module: $module) {
    ...OrganizationAddOnFields
  }
}
    ${OrganizationAddOnFieldsFragmentDoc}`;

/**
 * __useConnectOrganizationAddOnMutation__
 *
 * To run a mutation, you first call `useConnectOrganizationAddOnMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConnectOrganizationAddOnMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConnectOrganizationAddOnMutation({
 *   variables: {
 *     module: // value for 'module'
 *   },
 * });
 */
export function useConnectOrganizationAddOnMutation(options: VueApolloComposable.UseMutationOptions<ConnectOrganizationAddOnMutation, ConnectOrganizationAddOnMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConnectOrganizationAddOnMutation, ConnectOrganizationAddOnMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConnectOrganizationAddOnMutation, ConnectOrganizationAddOnMutationVariables>(ConnectOrganizationAddOnDocument, options);
}
export type ConnectOrganizationAddOnMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConnectOrganizationAddOnMutation, ConnectOrganizationAddOnMutationVariables>;
export const DisconnectOrganizationAddOnDocument = gql`
    mutation DisconnectOrganizationAddOn($module: OrganizationModule!) {
  disconnectOrganizationAddOn(module: $module) {
    ...OrganizationAddOnFields
  }
}
    ${OrganizationAddOnFieldsFragmentDoc}`;

/**
 * __useDisconnectOrganizationAddOnMutation__
 *
 * To run a mutation, you first call `useDisconnectOrganizationAddOnMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectOrganizationAddOnMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisconnectOrganizationAddOnMutation({
 *   variables: {
 *     module: // value for 'module'
 *   },
 * });
 */
export function useDisconnectOrganizationAddOnMutation(options: VueApolloComposable.UseMutationOptions<DisconnectOrganizationAddOnMutation, DisconnectOrganizationAddOnMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DisconnectOrganizationAddOnMutation, DisconnectOrganizationAddOnMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DisconnectOrganizationAddOnMutation, DisconnectOrganizationAddOnMutationVariables>(DisconnectOrganizationAddOnDocument, options);
}
export type DisconnectOrganizationAddOnMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DisconnectOrganizationAddOnMutation, DisconnectOrganizationAddOnMutationVariables>;
export const AddTireServiceTemplateDocument = gql`
    mutation AddTireServiceTemplate($groups: [TireServiceTemplateGroup!]!) {
  addTireServiceTemplate(groups: $groups)
}
    `;

/**
 * __useAddTireServiceTemplateMutation__
 *
 * To run a mutation, you first call `useAddTireServiceTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTireServiceTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTireServiceTemplateMutation({
 *   variables: {
 *     groups: // value for 'groups'
 *   },
 * });
 */
export function useAddTireServiceTemplateMutation(options: VueApolloComposable.UseMutationOptions<AddTireServiceTemplateMutation, AddTireServiceTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddTireServiceTemplateMutation, AddTireServiceTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddTireServiceTemplateMutation, AddTireServiceTemplateMutationVariables>(AddTireServiceTemplateDocument, options);
}
export type AddTireServiceTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddTireServiceTemplateMutation, AddTireServiceTemplateMutationVariables>;
export const GetRobokassaConnectionDocument = gql`
    query GetRobokassaConnection {
  robokassaConnection {
    ...RobokassaConnectionFields
  }
}
    ${RobokassaConnectionFieldsFragmentDoc}`;

/**
 * __useGetRobokassaConnectionQuery__
 *
 * To run a query within a Vue component, call `useGetRobokassaConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRobokassaConnectionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRobokassaConnectionQuery();
 */
export function useGetRobokassaConnectionQuery(options: VueApolloComposable.UseQueryOptions<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables>(GetRobokassaConnectionDocument, {}, options);
}
export function useGetRobokassaConnectionLazyQuery(options: VueApolloComposable.UseQueryOptions<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables>(GetRobokassaConnectionDocument, {}, options);
}
export type GetRobokassaConnectionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRobokassaConnectionQuery, GetRobokassaConnectionQueryVariables>;
export const ConnectRobokassaDocument = gql`
    mutation ConnectRobokassa($input: RobokassaConnectionInput!) {
  connectRobokassa(input: $input) {
    ...RobokassaConnectionFields
  }
}
    ${RobokassaConnectionFieldsFragmentDoc}`;

/**
 * __useConnectRobokassaMutation__
 *
 * To run a mutation, you first call `useConnectRobokassaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConnectRobokassaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConnectRobokassaMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConnectRobokassaMutation(options: VueApolloComposable.UseMutationOptions<ConnectRobokassaMutation, ConnectRobokassaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConnectRobokassaMutation, ConnectRobokassaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConnectRobokassaMutation, ConnectRobokassaMutationVariables>(ConnectRobokassaDocument, options);
}
export type ConnectRobokassaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConnectRobokassaMutation, ConnectRobokassaMutationVariables>;
export const UpdateRobokassaConnectionDocument = gql`
    mutation UpdateRobokassaConnection($input: RobokassaConnectionInput!) {
  updateRobokassaConnection(input: $input) {
    ...RobokassaConnectionFields
  }
}
    ${RobokassaConnectionFieldsFragmentDoc}`;

/**
 * __useUpdateRobokassaConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateRobokassaConnectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRobokassaConnectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRobokassaConnectionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRobokassaConnectionMutation(options: VueApolloComposable.UseMutationOptions<UpdateRobokassaConnectionMutation, UpdateRobokassaConnectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateRobokassaConnectionMutation, UpdateRobokassaConnectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateRobokassaConnectionMutation, UpdateRobokassaConnectionMutationVariables>(UpdateRobokassaConnectionDocument, options);
}
export type UpdateRobokassaConnectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateRobokassaConnectionMutation, UpdateRobokassaConnectionMutationVariables>;
export const DisableRobokassaConnectionDocument = gql`
    mutation DisableRobokassaConnection {
  disableRobokassaConnection {
    ...RobokassaConnectionFields
  }
}
    ${RobokassaConnectionFieldsFragmentDoc}`;

/**
 * __useDisableRobokassaConnectionMutation__
 *
 * To run a mutation, you first call `useDisableRobokassaConnectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableRobokassaConnectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableRobokassaConnectionMutation();
 */
export function useDisableRobokassaConnectionMutation(options: VueApolloComposable.UseMutationOptions<DisableRobokassaConnectionMutation, DisableRobokassaConnectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DisableRobokassaConnectionMutation, DisableRobokassaConnectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DisableRobokassaConnectionMutation, DisableRobokassaConnectionMutationVariables>(DisableRobokassaConnectionDocument, options);
}
export type DisableRobokassaConnectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DisableRobokassaConnectionMutation, DisableRobokassaConnectionMutationVariables>;
export const UpdateMyProfileDocument = gql`
    mutation UpdateMyProfile($input: UpdateMyProfileInput!) {
  updateMyProfile(input: $input) {
    id
    phone
    first_name
    last_name
    patronymic_name
    telegram_id
    is_super_user
  }
}
    `;

/**
 * __useUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMyProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMyProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyProfileMutation(options: VueApolloComposable.UseMutationOptions<UpdateMyProfileMutation, UpdateMyProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>(UpdateMyProfileDocument, options);
}
export type UpdateMyProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>;
export const CreateBookingDocument = gql`
    mutation CreateBooking($input: CreateBookingInput!) {
  createBooking(input: $input)
}
    `;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBookingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingMutation(options: VueApolloComposable.UseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
}
export type CreateBookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateBookingMutation, CreateBookingMutationVariables>;
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($id: ID!, $input: UpdateBookingInput!) {
  updateBooking(id: $id, input: $input)
}
    `;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBookingMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingMutation(options: VueApolloComposable.UseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument, options);
}
export type UpdateBookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const ReplaceBookingClientDocument = gql`
    mutation ReplaceBookingClient($id: ID!, $input: ReplaceBookingClientInput!) {
  replaceBookingClient(id: $id, input: $input)
}
    `;

/**
 * __useReplaceBookingClientMutation__
 *
 * To run a mutation, you first call `useReplaceBookingClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplaceBookingClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplaceBookingClientMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReplaceBookingClientMutation(options: VueApolloComposable.UseMutationOptions<ReplaceBookingClientMutation, ReplaceBookingClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReplaceBookingClientMutation, ReplaceBookingClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReplaceBookingClientMutation, ReplaceBookingClientMutationVariables>(ReplaceBookingClientDocument, options);
}
export type ReplaceBookingClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReplaceBookingClientMutation, ReplaceBookingClientMutationVariables>;
export const UpdateBookingStatusDocument = gql`
    mutation UpdateBookingStatus($id: ID!, $input: UpdateBookingStatusInput!) {
  updateBookingStatus(id: $id, input: $input)
}
    `;

/**
 * __useUpdateBookingStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBookingStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBookingStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateBookingStatusMutation, UpdateBookingStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBookingStatusMutation, UpdateBookingStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBookingStatusMutation, UpdateBookingStatusMutationVariables>(UpdateBookingStatusDocument, options);
}
export type UpdateBookingStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBookingStatusMutation, UpdateBookingStatusMutationVariables>;
export const CreateOrderFromBookingGroupDocument = gql`
    mutation CreateOrderFromBookingGroup($bookingGroupId: ID!) {
  createOrderFromBookingGroup(bookingGroupId: $bookingGroupId) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useCreateOrderFromBookingGroupMutation__
 *
 * To run a mutation, you first call `useCreateOrderFromBookingGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderFromBookingGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOrderFromBookingGroupMutation({
 *   variables: {
 *     bookingGroupId: // value for 'bookingGroupId'
 *   },
 * });
 */
export function useCreateOrderFromBookingGroupMutation(options: VueApolloComposable.UseMutationOptions<CreateOrderFromBookingGroupMutation, CreateOrderFromBookingGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOrderFromBookingGroupMutation, CreateOrderFromBookingGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOrderFromBookingGroupMutation, CreateOrderFromBookingGroupMutationVariables>(CreateOrderFromBookingGroupDocument, options);
}
export type CreateOrderFromBookingGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOrderFromBookingGroupMutation, CreateOrderFromBookingGroupMutationVariables>;
export const RefreshOrderDraftDocument = gql`
    mutation RefreshOrderDraft($orderId: ID!) {
  refreshOrderDraft(orderId: $orderId) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useRefreshOrderDraftMutation__
 *
 * To run a mutation, you first call `useRefreshOrderDraftMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefreshOrderDraftMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefreshOrderDraftMutation({
 *   variables: {
 *     orderId: // value for 'orderId'
 *   },
 * });
 */
export function useRefreshOrderDraftMutation(options: VueApolloComposable.UseMutationOptions<RefreshOrderDraftMutation, RefreshOrderDraftMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RefreshOrderDraftMutation, RefreshOrderDraftMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RefreshOrderDraftMutation, RefreshOrderDraftMutationVariables>(RefreshOrderDraftDocument, options);
}
export type RefreshOrderDraftMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RefreshOrderDraftMutation, RefreshOrderDraftMutationVariables>;
export const SettleOrderDocument = gql`
    mutation SettleOrder($input: SettleOrderInput!) {
  settleOrder(input: $input) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useSettleOrderMutation__
 *
 * To run a mutation, you first call `useSettleOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSettleOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSettleOrderMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSettleOrderMutation(options: VueApolloComposable.UseMutationOptions<SettleOrderMutation, SettleOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SettleOrderMutation, SettleOrderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SettleOrderMutation, SettleOrderMutationVariables>(SettleOrderDocument, options);
}
export type SettleOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SettleOrderMutation, SettleOrderMutationVariables>;
export const CreateUnitUnavailabilityDocument = gql`
    mutation CreateUnitUnavailability($input: CreateUnitUnavailabilityInput!) {
  createUnitUnavailability(input: $input) {
    ...UnitUnavailabilityPayloadFields
  }
}
    ${UnitUnavailabilityPayloadFieldsFragmentDoc}`;

/**
 * __useCreateUnitUnavailabilityMutation__
 *
 * To run a mutation, you first call `useCreateUnitUnavailabilityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnitUnavailabilityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUnitUnavailabilityMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateUnitUnavailabilityMutation(options: VueApolloComposable.UseMutationOptions<CreateUnitUnavailabilityMutation, CreateUnitUnavailabilityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUnitUnavailabilityMutation, CreateUnitUnavailabilityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUnitUnavailabilityMutation, CreateUnitUnavailabilityMutationVariables>(CreateUnitUnavailabilityDocument, options);
}
export type CreateUnitUnavailabilityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUnitUnavailabilityMutation, CreateUnitUnavailabilityMutationVariables>;
export const UpdateUnitUnavailabilityDocument = gql`
    mutation UpdateUnitUnavailability($id: ID!, $input: UpdateUnitUnavailabilityInput!) {
  updateUnitUnavailability(id: $id, input: $input) {
    ...UnitUnavailabilityPayloadFields
  }
}
    ${UnitUnavailabilityPayloadFieldsFragmentDoc}`;

/**
 * __useUpdateUnitUnavailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateUnitUnavailabilityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnitUnavailabilityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUnitUnavailabilityMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUnitUnavailabilityMutation(options: VueApolloComposable.UseMutationOptions<UpdateUnitUnavailabilityMutation, UpdateUnitUnavailabilityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUnitUnavailabilityMutation, UpdateUnitUnavailabilityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUnitUnavailabilityMutation, UpdateUnitUnavailabilityMutationVariables>(UpdateUnitUnavailabilityDocument, options);
}
export type UpdateUnitUnavailabilityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUnitUnavailabilityMutation, UpdateUnitUnavailabilityMutationVariables>;
export const FinishUnitUnavailabilityDocument = gql`
    mutation FinishUnitUnavailability($id: ID!) {
  finishUnitUnavailability(id: $id) {
    id
    unit_id
    start
    end
    reason
  }
}
    `;

/**
 * __useFinishUnitUnavailabilityMutation__
 *
 * To run a mutation, you first call `useFinishUnitUnavailabilityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFinishUnitUnavailabilityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFinishUnitUnavailabilityMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useFinishUnitUnavailabilityMutation(options: VueApolloComposable.UseMutationOptions<FinishUnitUnavailabilityMutation, FinishUnitUnavailabilityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FinishUnitUnavailabilityMutation, FinishUnitUnavailabilityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<FinishUnitUnavailabilityMutation, FinishUnitUnavailabilityMutationVariables>(FinishUnitUnavailabilityDocument, options);
}
export type FinishUnitUnavailabilityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FinishUnitUnavailabilityMutation, FinishUnitUnavailabilityMutationVariables>;
export const DeleteUnitUnavailabilityDocument = gql`
    mutation DeleteUnitUnavailability($id: ID!) {
  deleteUnitUnavailability(id: $id)
}
    `;

/**
 * __useDeleteUnitUnavailabilityMutation__
 *
 * To run a mutation, you first call `useDeleteUnitUnavailabilityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnitUnavailabilityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUnitUnavailabilityMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUnitUnavailabilityMutation(options: VueApolloComposable.UseMutationOptions<DeleteUnitUnavailabilityMutation, DeleteUnitUnavailabilityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUnitUnavailabilityMutation, DeleteUnitUnavailabilityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteUnitUnavailabilityMutation, DeleteUnitUnavailabilityMutationVariables>(DeleteUnitUnavailabilityDocument, options);
}
export type DeleteUnitUnavailabilityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteUnitUnavailabilityMutation, DeleteUnitUnavailabilityMutationVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($input: CreateEmployeeInput!) {
  createEmployee(input: $input) {
    id
    user {
      id
      first_name
      last_name
      phone
    }
    status
    has_all_locations_access
    locations {
      id
      title
    }
    roles {
      id
      title
    }
    created_at
    last_activity_at
    is_owner
  }
}
    `;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateEmployeeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(options: VueApolloComposable.UseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
}
export type CreateEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($id: ID!, $input: UpdateEmployeeInput!) {
  updateEmployee(id: $id, input: $input) {
    id
    user {
      id
      first_name
      last_name
      phone
    }
    status
    has_all_locations_access
    locations {
      id
      title
    }
    roles {
      id
      title
    }
    created_at
    last_activity_at
    is_owner
  }
}
    `;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEmployeeMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(options: VueApolloComposable.UseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
}
export type UpdateEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const FireEmployeeDocument = gql`
    mutation FireEmployee($id: ID!, $input: FireEmployeeInput!) {
  fireEmployee(id: $id, input: $input) {
    id
    status
    fired_at
    firing_reason
  }
}
    `;

/**
 * __useFireEmployeeMutation__
 *
 * To run a mutation, you first call `useFireEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFireEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFireEmployeeMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useFireEmployeeMutation(options: VueApolloComposable.UseMutationOptions<FireEmployeeMutation, FireEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FireEmployeeMutation, FireEmployeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<FireEmployeeMutation, FireEmployeeMutationVariables>(FireEmployeeDocument, options);
}
export type FireEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FireEmployeeMutation, FireEmployeeMutationVariables>;
export const UnfireEmployeeDocument = gql`
    mutation UnfireEmployee($id: ID!) {
  unfireEmployee(id: $id) {
    id
    status
    fired_at
    firing_reason
  }
}
    `;

/**
 * __useUnfireEmployeeMutation__
 *
 * To run a mutation, you first call `useUnfireEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnfireEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnfireEmployeeMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUnfireEmployeeMutation(options: VueApolloComposable.UseMutationOptions<UnfireEmployeeMutation, UnfireEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnfireEmployeeMutation, UnfireEmployeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnfireEmployeeMutation, UnfireEmployeeMutationVariables>(UnfireEmployeeDocument, options);
}
export type UnfireEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnfireEmployeeMutation, UnfireEmployeeMutationVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees($status: EmployeeStatus, $location_id: ID, $first: Int!, $after: String) {
  employees(
    status: $status
    location_id: $location_id
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        user {
          id
          first_name
          last_name
          phone
        }
        status
        has_all_locations_access
        locations {
          id
          title
        }
        roles {
          id
          title
        }
        fired_at
        firing_reason
        created_at
        last_activity_at
        is_owner
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeesQuery({
 *   status: // value for 'status'
 *   location_id: // value for 'location_id'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetEmployeesQuery(variables: GetEmployeesQueryVariables | VueCompositionApi.Ref<GetEmployeesQueryVariables> | ReactiveFunction<GetEmployeesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeesQuery, GetEmployeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeesQuery, GetEmployeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeesQuery, GetEmployeesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, variables, options);
}
export function useGetEmployeesLazyQuery(variables?: GetEmployeesQueryVariables | VueCompositionApi.Ref<GetEmployeesQueryVariables> | ReactiveFunction<GetEmployeesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeesQuery, GetEmployeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeesQuery, GetEmployeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeesQuery, GetEmployeesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, variables, options);
}
export type GetEmployeesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles {
  roles {
    id
    name
    title
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a Vue component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRolesQuery();
 */
export function useGetRolesQuery(options: VueApolloComposable.UseQueryOptions<GetRolesQuery, GetRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRolesQuery, GetRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRolesQuery, GetRolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, {}, options);
}
export function useGetRolesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetRolesQuery, GetRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRolesQuery, GetRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRolesQuery, GetRolesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, {}, options);
}
export type GetRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRolesQuery, GetRolesQueryVariables>;
export const CheckPaymentStatusDocument = gql`
    mutation CheckPaymentStatus($paymentId: ID!) {
  checkPaymentStatus(paymentId: $paymentId) {
    id
    status
    available_actions
    attention_reasons
  }
}
    `;

/**
 * __useCheckPaymentStatusMutation__
 *
 * To run a mutation, you first call `useCheckPaymentStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCheckPaymentStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCheckPaymentStatusMutation({
 *   variables: {
 *     paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useCheckPaymentStatusMutation(options: VueApolloComposable.UseMutationOptions<CheckPaymentStatusMutation, CheckPaymentStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CheckPaymentStatusMutation, CheckPaymentStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CheckPaymentStatusMutation, CheckPaymentStatusMutationVariables>(CheckPaymentStatusDocument, options);
}
export type CheckPaymentStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CheckPaymentStatusMutation, CheckPaymentStatusMutationVariables>;
export const AttachRecoveredRefundRequestDocument = gql`
    mutation AttachRecoveredRefundRequest($refundId: ID!, $requestId: String!) {
  attachRecoveredRefundRequest(refundId: $refundId, requestId: $requestId) {
    id
    status
    provider_request_id
  }
}
    `;

/**
 * __useAttachRecoveredRefundRequestMutation__
 *
 * To run a mutation, you first call `useAttachRecoveredRefundRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachRecoveredRefundRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachRecoveredRefundRequestMutation({
 *   variables: {
 *     refundId: // value for 'refundId'
 *     requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAttachRecoveredRefundRequestMutation(options: VueApolloComposable.UseMutationOptions<AttachRecoveredRefundRequestMutation, AttachRecoveredRefundRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AttachRecoveredRefundRequestMutation, AttachRecoveredRefundRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AttachRecoveredRefundRequestMutation, AttachRecoveredRefundRequestMutationVariables>(AttachRecoveredRefundRequestDocument, options);
}
export type AttachRecoveredRefundRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AttachRecoveredRefundRequestMutation, AttachRecoveredRefundRequestMutationVariables>;
export const GetRadioTrackLoudnessDocument = gql`
    query GetRadioTrackLoudness($trackIds: [ID!]!) {
  radioTrackLoudness(trackIds: $trackIds) {
    ...RadioTrackLoudnessFragment
  }
}
    ${RadioTrackLoudnessFragmentFragmentDoc}`;

/**
 * __useGetRadioTrackLoudnessQuery__
 *
 * To run a query within a Vue component, call `useGetRadioTrackLoudnessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRadioTrackLoudnessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRadioTrackLoudnessQuery({
 *   trackIds: // value for 'trackIds'
 * });
 */
export function useGetRadioTrackLoudnessQuery(variables: GetRadioTrackLoudnessQueryVariables | VueCompositionApi.Ref<GetRadioTrackLoudnessQueryVariables> | ReactiveFunction<GetRadioTrackLoudnessQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables>(GetRadioTrackLoudnessDocument, variables, options);
}
export function useGetRadioTrackLoudnessLazyQuery(variables?: GetRadioTrackLoudnessQueryVariables | VueCompositionApi.Ref<GetRadioTrackLoudnessQueryVariables> | ReactiveFunction<GetRadioTrackLoudnessQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables>(GetRadioTrackLoudnessDocument, variables, options);
}
export type GetRadioTrackLoudnessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRadioTrackLoudnessQuery, GetRadioTrackLoudnessQueryVariables>;
export const RequestTrackUploadDocument = gql`
    mutation RequestTrackUpload($input: RequestTrackUploadInput!) {
  requestTrackUpload(input: $input) {
    uploadUrl
    trackId
    s3Path
    expiresAt
  }
}
    `;

/**
 * __useRequestTrackUploadMutation__
 *
 * To run a mutation, you first call `useRequestTrackUploadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestTrackUploadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestTrackUploadMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestTrackUploadMutation(options: VueApolloComposable.UseMutationOptions<RequestTrackUploadMutation, RequestTrackUploadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestTrackUploadMutation, RequestTrackUploadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestTrackUploadMutation, RequestTrackUploadMutationVariables>(RequestTrackUploadDocument, options);
}
export type RequestTrackUploadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestTrackUploadMutation, RequestTrackUploadMutationVariables>;
export const ConfirmTrackUploadDocument = gql`
    mutation ConfirmTrackUpload($trackId: ID!, $duration: Int!) {
  confirmTrackUpload(trackId: $trackId, duration: $duration) {
    ...RadioTrackFragment
  }
}
    ${RadioTrackFragmentFragmentDoc}`;

/**
 * __useConfirmTrackUploadMutation__
 *
 * To run a mutation, you first call `useConfirmTrackUploadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTrackUploadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmTrackUploadMutation({
 *   variables: {
 *     trackId: // value for 'trackId'
 *     duration: // value for 'duration'
 *   },
 * });
 */
export function useConfirmTrackUploadMutation(options: VueApolloComposable.UseMutationOptions<ConfirmTrackUploadMutation, ConfirmTrackUploadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmTrackUploadMutation, ConfirmTrackUploadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConfirmTrackUploadMutation, ConfirmTrackUploadMutationVariables>(ConfirmTrackUploadDocument, options);
}
export type ConfirmTrackUploadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmTrackUploadMutation, ConfirmTrackUploadMutationVariables>;
export const DeleteRadioTrackDocument = gql`
    mutation DeleteRadioTrack($id: ID!) {
  deleteRadioTrack(id: $id) {
    ...RadioTrackFragment
  }
}
    ${RadioTrackFragmentFragmentDoc}`;

/**
 * __useDeleteRadioTrackMutation__
 *
 * To run a mutation, you first call `useDeleteRadioTrackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRadioTrackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRadioTrackMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRadioTrackMutation(options: VueApolloComposable.UseMutationOptions<DeleteRadioTrackMutation, DeleteRadioTrackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteRadioTrackMutation, DeleteRadioTrackMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteRadioTrackMutation, DeleteRadioTrackMutationVariables>(DeleteRadioTrackDocument, options);
}
export type DeleteRadioTrackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteRadioTrackMutation, DeleteRadioTrackMutationVariables>;
export const UpdateRadioTrackDocument = gql`
    mutation UpdateRadioTrack($id: ID!, $input: UpdateRadioTrackInput!) {
  updateRadioTrack(id: $id, input: $input) {
    ...RadioTrackFragment
  }
}
    ${RadioTrackFragmentFragmentDoc}`;

/**
 * __useUpdateRadioTrackMutation__
 *
 * To run a mutation, you first call `useUpdateRadioTrackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRadioTrackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRadioTrackMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRadioTrackMutation(options: VueApolloComposable.UseMutationOptions<UpdateRadioTrackMutation, UpdateRadioTrackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateRadioTrackMutation, UpdateRadioTrackMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateRadioTrackMutation, UpdateRadioTrackMutationVariables>(UpdateRadioTrackDocument, options);
}
export type UpdateRadioTrackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateRadioTrackMutation, UpdateRadioTrackMutationVariables>;
export const CreateRadioPlaylistDocument = gql`
    mutation CreateRadioPlaylist($input: CreateRadioPlaylistInput!) {
  createRadioPlaylist(input: $input) {
    ...RadioPlaylistFragment
  }
}
    ${RadioPlaylistFragmentFragmentDoc}`;

/**
 * __useCreateRadioPlaylistMutation__
 *
 * To run a mutation, you first call `useCreateRadioPlaylistMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRadioPlaylistMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRadioPlaylistMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateRadioPlaylistMutation(options: VueApolloComposable.UseMutationOptions<CreateRadioPlaylistMutation, CreateRadioPlaylistMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateRadioPlaylistMutation, CreateRadioPlaylistMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateRadioPlaylistMutation, CreateRadioPlaylistMutationVariables>(CreateRadioPlaylistDocument, options);
}
export type CreateRadioPlaylistMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateRadioPlaylistMutation, CreateRadioPlaylistMutationVariables>;
export const UpdateRadioPlaylistDocument = gql`
    mutation UpdateRadioPlaylist($id: ID!, $input: UpdateRadioPlaylistInput!) {
  updateRadioPlaylist(id: $id, input: $input) {
    ...RadioPlaylistFragment
  }
}
    ${RadioPlaylistFragmentFragmentDoc}`;

/**
 * __useUpdateRadioPlaylistMutation__
 *
 * To run a mutation, you first call `useUpdateRadioPlaylistMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRadioPlaylistMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRadioPlaylistMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRadioPlaylistMutation(options: VueApolloComposable.UseMutationOptions<UpdateRadioPlaylistMutation, UpdateRadioPlaylistMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateRadioPlaylistMutation, UpdateRadioPlaylistMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateRadioPlaylistMutation, UpdateRadioPlaylistMutationVariables>(UpdateRadioPlaylistDocument, options);
}
export type UpdateRadioPlaylistMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateRadioPlaylistMutation, UpdateRadioPlaylistMutationVariables>;
export const DeleteRadioPlaylistDocument = gql`
    mutation DeleteRadioPlaylist($id: ID!) {
  deleteRadioPlaylist(id: $id) {
    ...RadioPlaylistFragment
  }
}
    ${RadioPlaylistFragmentFragmentDoc}`;

/**
 * __useDeleteRadioPlaylistMutation__
 *
 * To run a mutation, you first call `useDeleteRadioPlaylistMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRadioPlaylistMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRadioPlaylistMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRadioPlaylistMutation(options: VueApolloComposable.UseMutationOptions<DeleteRadioPlaylistMutation, DeleteRadioPlaylistMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteRadioPlaylistMutation, DeleteRadioPlaylistMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteRadioPlaylistMutation, DeleteRadioPlaylistMutationVariables>(DeleteRadioPlaylistDocument, options);
}
export type DeleteRadioPlaylistMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteRadioPlaylistMutation, DeleteRadioPlaylistMutationVariables>;
export const AddTracksToRadioPlaylistDocument = gql`
    mutation AddTracksToRadioPlaylist($playlistId: ID!, $trackIds: [ID!]!) {
  addTracksToRadioPlaylist(playlistId: $playlistId, trackIds: $trackIds) {
    ...RadioPlaylistFragment
  }
}
    ${RadioPlaylistFragmentFragmentDoc}`;

/**
 * __useAddTracksToRadioPlaylistMutation__
 *
 * To run a mutation, you first call `useAddTracksToRadioPlaylistMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTracksToRadioPlaylistMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTracksToRadioPlaylistMutation({
 *   variables: {
 *     playlistId: // value for 'playlistId'
 *     trackIds: // value for 'trackIds'
 *   },
 * });
 */
export function useAddTracksToRadioPlaylistMutation(options: VueApolloComposable.UseMutationOptions<AddTracksToRadioPlaylistMutation, AddTracksToRadioPlaylistMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddTracksToRadioPlaylistMutation, AddTracksToRadioPlaylistMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddTracksToRadioPlaylistMutation, AddTracksToRadioPlaylistMutationVariables>(AddTracksToRadioPlaylistDocument, options);
}
export type AddTracksToRadioPlaylistMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddTracksToRadioPlaylistMutation, AddTracksToRadioPlaylistMutationVariables>;
export const RemoveTrackFromRadioPlaylistDocument = gql`
    mutation RemoveTrackFromRadioPlaylist($playlistId: ID!, $trackId: ID!) {
  removeTrackFromRadioPlaylist(playlistId: $playlistId, trackId: $trackId) {
    ...RadioPlaylistFragment
  }
}
    ${RadioPlaylistFragmentFragmentDoc}`;

/**
 * __useRemoveTrackFromRadioPlaylistMutation__
 *
 * To run a mutation, you first call `useRemoveTrackFromRadioPlaylistMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTrackFromRadioPlaylistMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveTrackFromRadioPlaylistMutation({
 *   variables: {
 *     playlistId: // value for 'playlistId'
 *     trackId: // value for 'trackId'
 *   },
 * });
 */
export function useRemoveTrackFromRadioPlaylistMutation(options: VueApolloComposable.UseMutationOptions<RemoveTrackFromRadioPlaylistMutation, RemoveTrackFromRadioPlaylistMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveTrackFromRadioPlaylistMutation, RemoveTrackFromRadioPlaylistMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveTrackFromRadioPlaylistMutation, RemoveTrackFromRadioPlaylistMutationVariables>(RemoveTrackFromRadioPlaylistDocument, options);
}
export type RemoveTrackFromRadioPlaylistMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveTrackFromRadioPlaylistMutation, RemoveTrackFromRadioPlaylistMutationVariables>;
export const GetRadioTracksDocument = gql`
    query GetRadioTracks($searchQuery: String, $first: Int!, $after: String) {
  radioTracks(searchQuery: $searchQuery, first: $first, after: $after) {
    edges {
      node {
        ...RadioTrackFragment
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${RadioTrackFragmentFragmentDoc}`;

/**
 * __useGetRadioTracksQuery__
 *
 * To run a query within a Vue component, call `useGetRadioTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRadioTracksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRadioTracksQuery({
 *   searchQuery: // value for 'searchQuery'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetRadioTracksQuery(variables: GetRadioTracksQueryVariables | VueCompositionApi.Ref<GetRadioTracksQueryVariables> | ReactiveFunction<GetRadioTracksQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRadioTracksQuery, GetRadioTracksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRadioTracksQuery, GetRadioTracksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRadioTracksQuery, GetRadioTracksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRadioTracksQuery, GetRadioTracksQueryVariables>(GetRadioTracksDocument, variables, options);
}
export function useGetRadioTracksLazyQuery(variables?: GetRadioTracksQueryVariables | VueCompositionApi.Ref<GetRadioTracksQueryVariables> | ReactiveFunction<GetRadioTracksQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRadioTracksQuery, GetRadioTracksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRadioTracksQuery, GetRadioTracksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRadioTracksQuery, GetRadioTracksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRadioTracksQuery, GetRadioTracksQueryVariables>(GetRadioTracksDocument, variables, options);
}
export type GetRadioTracksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRadioTracksQuery, GetRadioTracksQueryVariables>;
export const GetRadioPlaylistsDocument = gql`
    query GetRadioPlaylists {
  radioPlaylists {
    ...RadioPlaylistFragment
  }
}
    ${RadioPlaylistFragmentFragmentDoc}`;

/**
 * __useGetRadioPlaylistsQuery__
 *
 * To run a query within a Vue component, call `useGetRadioPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRadioPlaylistsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRadioPlaylistsQuery();
 */
export function useGetRadioPlaylistsQuery(options: VueApolloComposable.UseQueryOptions<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables>(GetRadioPlaylistsDocument, {}, options);
}
export function useGetRadioPlaylistsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables>(GetRadioPlaylistsDocument, {}, options);
}
export type GetRadioPlaylistsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRadioPlaylistsQuery, GetRadioPlaylistsQueryVariables>;
export const GetShiftLoyaltyRegistrationsReportDocument = gql`
    query GetShiftLoyaltyRegistrationsReport($dateFrom: Date!, $dateTo: Date!) {
  shiftLoyaltyRegistrationsReport(dateFrom: $dateFrom, dateTo: $dateTo) {
    employee_id
    employee_name
    shifts_count
    potential_clients
    registered_clients
  }
}
    `;

/**
 * __useGetShiftLoyaltyRegistrationsReportQuery__
 *
 * To run a query within a Vue component, call `useGetShiftLoyaltyRegistrationsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftLoyaltyRegistrationsReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetShiftLoyaltyRegistrationsReportQuery({
 *   dateFrom: // value for 'dateFrom'
 *   dateTo: // value for 'dateTo'
 * });
 */
export function useGetShiftLoyaltyRegistrationsReportQuery(variables: GetShiftLoyaltyRegistrationsReportQueryVariables | VueCompositionApi.Ref<GetShiftLoyaltyRegistrationsReportQueryVariables> | ReactiveFunction<GetShiftLoyaltyRegistrationsReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables>(GetShiftLoyaltyRegistrationsReportDocument, variables, options);
}
export function useGetShiftLoyaltyRegistrationsReportLazyQuery(variables?: GetShiftLoyaltyRegistrationsReportQueryVariables | VueCompositionApi.Ref<GetShiftLoyaltyRegistrationsReportQueryVariables> | ReactiveFunction<GetShiftLoyaltyRegistrationsReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables>(GetShiftLoyaltyRegistrationsReportDocument, variables, options);
}
export type GetShiftLoyaltyRegistrationsReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetShiftLoyaltyRegistrationsReportQuery, GetShiftLoyaltyRegistrationsReportQueryVariables>;
export const GetNewClientRetentionReportDocument = gql`
    query GetNewClientRetentionReport($dateFrom: Date!, $dateTo: Date!, $dimension: NewClientRetentionDimension!) {
  newClientRetentionReport(
    dateFrom: $dateFrom
    dateTo: $dateTo
    dimension: $dimension
  ) {
    key
    title
    row_kind
    cohorts {
      month
      first_visit_date
      new_clients
      matured_30
      returned_30
      matured_90
      returned_90
      returned_any
    }
  }
}
    `;

/**
 * __useGetNewClientRetentionReportQuery__
 *
 * To run a query within a Vue component, call `useGetNewClientRetentionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewClientRetentionReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNewClientRetentionReportQuery({
 *   dateFrom: // value for 'dateFrom'
 *   dateTo: // value for 'dateTo'
 *   dimension: // value for 'dimension'
 * });
 */
export function useGetNewClientRetentionReportQuery(variables: GetNewClientRetentionReportQueryVariables | VueCompositionApi.Ref<GetNewClientRetentionReportQueryVariables> | ReactiveFunction<GetNewClientRetentionReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables>(GetNewClientRetentionReportDocument, variables, options);
}
export function useGetNewClientRetentionReportLazyQuery(variables?: GetNewClientRetentionReportQueryVariables | VueCompositionApi.Ref<GetNewClientRetentionReportQueryVariables> | ReactiveFunction<GetNewClientRetentionReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables>(GetNewClientRetentionReportDocument, variables, options);
}
export type GetNewClientRetentionReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetNewClientRetentionReportQuery, GetNewClientRetentionReportQueryVariables>;
export const GetRegularClientsReportDocument = gql`
    query GetRegularClientsReport($dateFrom: Date!, $dateTo: Date!) {
  regularClientsReport(dateFrom: $dateFrom, dateTo: $dateTo) {
    month
    point_date
    is_partial
    loyal
    entered
    left
    active
    visits
    revenue
  }
}
    `;

/**
 * __useGetRegularClientsReportQuery__
 *
 * To run a query within a Vue component, call `useGetRegularClientsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegularClientsReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRegularClientsReportQuery({
 *   dateFrom: // value for 'dateFrom'
 *   dateTo: // value for 'dateTo'
 * });
 */
export function useGetRegularClientsReportQuery(variables: GetRegularClientsReportQueryVariables | VueCompositionApi.Ref<GetRegularClientsReportQueryVariables> | ReactiveFunction<GetRegularClientsReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables>(GetRegularClientsReportDocument, variables, options);
}
export function useGetRegularClientsReportLazyQuery(variables?: GetRegularClientsReportQueryVariables | VueCompositionApi.Ref<GetRegularClientsReportQueryVariables> | ReactiveFunction<GetRegularClientsReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables>(GetRegularClientsReportDocument, variables, options);
}
export type GetRegularClientsReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRegularClientsReportQuery, GetRegularClientsReportQueryVariables>;
export const GetShiftLoyaltyReportItemsDocument = gql`
    query GetShiftLoyaltyReportItems {
  shiftLoyaltyReportItems
}
    `;

/**
 * __useGetShiftLoyaltyReportItemsQuery__
 *
 * To run a query within a Vue component, call `useGetShiftLoyaltyReportItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftLoyaltyReportItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetShiftLoyaltyReportItemsQuery();
 */
export function useGetShiftLoyaltyReportItemsQuery(options: VueApolloComposable.UseQueryOptions<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables>(GetShiftLoyaltyReportItemsDocument, {}, options);
}
export function useGetShiftLoyaltyReportItemsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables>(GetShiftLoyaltyReportItemsDocument, {}, options);
}
export type GetShiftLoyaltyReportItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetShiftLoyaltyReportItemsQuery, GetShiftLoyaltyReportItemsQueryVariables>;
export const SetShiftLoyaltyReportItemsDocument = gql`
    mutation SetShiftLoyaltyReportItems($catalogItemIds: [ID!]!) {
  setShiftLoyaltyReportItems(catalogItemIds: $catalogItemIds)
}
    `;

/**
 * __useSetShiftLoyaltyReportItemsMutation__
 *
 * To run a mutation, you first call `useSetShiftLoyaltyReportItemsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetShiftLoyaltyReportItemsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetShiftLoyaltyReportItemsMutation({
 *   variables: {
 *     catalogItemIds: // value for 'catalogItemIds'
 *   },
 * });
 */
export function useSetShiftLoyaltyReportItemsMutation(options: VueApolloComposable.UseMutationOptions<SetShiftLoyaltyReportItemsMutation, SetShiftLoyaltyReportItemsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetShiftLoyaltyReportItemsMutation, SetShiftLoyaltyReportItemsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetShiftLoyaltyReportItemsMutation, SetShiftLoyaltyReportItemsMutationVariables>(SetShiftLoyaltyReportItemsDocument, options);
}
export type SetShiftLoyaltyReportItemsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetShiftLoyaltyReportItemsMutation, SetShiftLoyaltyReportItemsMutationVariables>;
export const GetCitiesDocument = gql`
    query GetCities {
  cities {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a Vue component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCitiesQuery();
 */
export function useGetCitiesQuery(options: VueApolloComposable.UseQueryOptions<GetCitiesQuery, GetCitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCitiesQuery, GetCitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCitiesQuery, GetCitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, {}, options);
}
export function useGetCitiesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetCitiesQuery, GetCitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCitiesQuery, GetCitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCitiesQuery, GetCitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, {}, options);
}
export type GetCitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetBusinessLocationScheduleDocument = gql`
    query GetBusinessLocationSchedule($locationId: ID!) {
  locationSchedule(locationId: $locationId) {
    current {
      day_of_week
      is_day_off
      start
      end
      closes_next_day
      effective_from
    }
    upcoming {
      day_of_week
      is_day_off
      start
      end
      closes_next_day
      effective_from
    }
  }
}
    `;

/**
 * __useGetBusinessLocationScheduleQuery__
 *
 * To run a query within a Vue component, call `useGetBusinessLocationScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessLocationScheduleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBusinessLocationScheduleQuery({
 *   locationId: // value for 'locationId'
 * });
 */
export function useGetBusinessLocationScheduleQuery(variables: GetBusinessLocationScheduleQueryVariables | VueCompositionApi.Ref<GetBusinessLocationScheduleQueryVariables> | ReactiveFunction<GetBusinessLocationScheduleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables>(GetBusinessLocationScheduleDocument, variables, options);
}
export function useGetBusinessLocationScheduleLazyQuery(variables?: GetBusinessLocationScheduleQueryVariables | VueCompositionApi.Ref<GetBusinessLocationScheduleQueryVariables> | ReactiveFunction<GetBusinessLocationScheduleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables>(GetBusinessLocationScheduleDocument, variables, options);
}
export type GetBusinessLocationScheduleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBusinessLocationScheduleQuery, GetBusinessLocationScheduleQueryVariables>;
export const GetBusinessSettingsDocument = gql`
    query GetBusinessSettings {
  businessSettings {
    ...BusinessSettingsFields
  }
}
    ${BusinessSettingsFieldsFragmentDoc}`;

/**
 * __useGetBusinessSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetBusinessSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBusinessSettingsQuery();
 */
export function useGetBusinessSettingsQuery(options: VueApolloComposable.UseQueryOptions<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables>(GetBusinessSettingsDocument, {}, options);
}
export function useGetBusinessSettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables>(GetBusinessSettingsDocument, {}, options);
}
export type GetBusinessSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBusinessSettingsQuery, GetBusinessSettingsQueryVariables>;
export const GetBusinessSettingsCatalogDocument = gql`
    query GetBusinessSettingsCatalog {
  businessSettingsCatalog {
    countries {
      id
      title
    }
    timezones {
      id
      title
    }
  }
}
    `;

/**
 * __useGetBusinessSettingsCatalogQuery__
 *
 * To run a query within a Vue component, call `useGetBusinessSettingsCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessSettingsCatalogQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBusinessSettingsCatalogQuery();
 */
export function useGetBusinessSettingsCatalogQuery(options: VueApolloComposable.UseQueryOptions<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables>(GetBusinessSettingsCatalogDocument, {}, options);
}
export function useGetBusinessSettingsCatalogLazyQuery(options: VueApolloComposable.UseQueryOptions<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables>(GetBusinessSettingsCatalogDocument, {}, options);
}
export type GetBusinessSettingsCatalogQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBusinessSettingsCatalogQuery, GetBusinessSettingsCatalogQueryVariables>;
export const GetBusinessLocationsDocument = gql`
    query GetBusinessLocations($search: String, $status: BusinessLocationStatus, $first: Int! = 20, $after: String) {
  businessLocations(
    search: $search
    status: $status
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        ...BusinessLocationShell
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    ${BusinessLocationShellFragmentDoc}`;

/**
 * __useGetBusinessLocationsQuery__
 *
 * To run a query within a Vue component, call `useGetBusinessLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBusinessLocationsQuery({
 *   search: // value for 'search'
 *   status: // value for 'status'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetBusinessLocationsQuery(variables: GetBusinessLocationsQueryVariables | VueCompositionApi.Ref<GetBusinessLocationsQueryVariables> | ReactiveFunction<GetBusinessLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables>(GetBusinessLocationsDocument, variables, options);
}
export function useGetBusinessLocationsLazyQuery(variables?: GetBusinessLocationsQueryVariables | VueCompositionApi.Ref<GetBusinessLocationsQueryVariables> | ReactiveFunction<GetBusinessLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables>(GetBusinessLocationsDocument, variables, options);
}
export type GetBusinessLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBusinessLocationsQuery, GetBusinessLocationsQueryVariables>;
export const GetBusinessLocationDocument = gql`
    query GetBusinessLocation($locationId: ID!, $includePrivate: Boolean!) {
  businessLocation(locationId: $locationId) {
    ...BusinessLocationShell
    details @include(if: $includePrivate) {
      ...BusinessLocationDetailsFields
    }
    location_address @include(if: $includePrivate) {
      ...BusinessLocationAddressFields
    }
  }
}
    ${BusinessLocationShellFragmentDoc}
${BusinessLocationDetailsFieldsFragmentDoc}
${BusinessLocationAddressFieldsFragmentDoc}`;

/**
 * __useGetBusinessLocationQuery__
 *
 * To run a query within a Vue component, call `useGetBusinessLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessLocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBusinessLocationQuery({
 *   locationId: // value for 'locationId'
 *   includePrivate: // value for 'includePrivate'
 * });
 */
export function useGetBusinessLocationQuery(variables: GetBusinessLocationQueryVariables | VueCompositionApi.Ref<GetBusinessLocationQueryVariables> | ReactiveFunction<GetBusinessLocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBusinessLocationQuery, GetBusinessLocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessLocationQuery, GetBusinessLocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessLocationQuery, GetBusinessLocationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBusinessLocationQuery, GetBusinessLocationQueryVariables>(GetBusinessLocationDocument, variables, options);
}
export function useGetBusinessLocationLazyQuery(variables?: GetBusinessLocationQueryVariables | VueCompositionApi.Ref<GetBusinessLocationQueryVariables> | ReactiveFunction<GetBusinessLocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBusinessLocationQuery, GetBusinessLocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBusinessLocationQuery, GetBusinessLocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBusinessLocationQuery, GetBusinessLocationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBusinessLocationQuery, GetBusinessLocationQueryVariables>(GetBusinessLocationDocument, variables, options);
}
export type GetBusinessLocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBusinessLocationQuery, GetBusinessLocationQueryVariables>;
export const UpdateBusinessSettingsDocument = gql`
    mutation UpdateBusinessSettings($input: UpdateBusinessSettingsInput!) {
  updateBusinessSettings(input: $input) {
    ...BusinessSettingsFields
  }
}
    ${BusinessSettingsFieldsFragmentDoc}`;

/**
 * __useUpdateBusinessSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBusinessSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessSettingsMutation(options: VueApolloComposable.UseMutationOptions<UpdateBusinessSettingsMutation, UpdateBusinessSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBusinessSettingsMutation, UpdateBusinessSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBusinessSettingsMutation, UpdateBusinessSettingsMutationVariables>(UpdateBusinessSettingsDocument, options);
}
export type UpdateBusinessSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBusinessSettingsMutation, UpdateBusinessSettingsMutationVariables>;
export const ChangeBusinessTimezoneDocument = gql`
    mutation ChangeBusinessTimezone($timezone: String!) {
  changeBusinessTimezone(timezone: $timezone) {
    ...BusinessSettingsFields
  }
}
    ${BusinessSettingsFieldsFragmentDoc}`;

/**
 * __useChangeBusinessTimezoneMutation__
 *
 * To run a mutation, you first call `useChangeBusinessTimezoneMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeBusinessTimezoneMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeBusinessTimezoneMutation({
 *   variables: {
 *     timezone: // value for 'timezone'
 *   },
 * });
 */
export function useChangeBusinessTimezoneMutation(options: VueApolloComposable.UseMutationOptions<ChangeBusinessTimezoneMutation, ChangeBusinessTimezoneMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeBusinessTimezoneMutation, ChangeBusinessTimezoneMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangeBusinessTimezoneMutation, ChangeBusinessTimezoneMutationVariables>(ChangeBusinessTimezoneDocument, options);
}
export type ChangeBusinessTimezoneMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeBusinessTimezoneMutation, ChangeBusinessTimezoneMutationVariables>;
export const UpdateBusinessLocationDetailsDocument = gql`
    mutation UpdateBusinessLocationDetails($locationId: ID!, $input: UpdateBusinessLocationDetailsInput!) {
  updateBusinessLocationDetails(locationId: $locationId, input: $input) {
    ...BusinessLocationShell
    details {
      ...BusinessLocationDetailsFields
    }
  }
}
    ${BusinessLocationShellFragmentDoc}
${BusinessLocationDetailsFieldsFragmentDoc}`;

/**
 * __useUpdateBusinessLocationDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessLocationDetailsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessLocationDetailsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBusinessLocationDetailsMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessLocationDetailsMutation(options: VueApolloComposable.UseMutationOptions<UpdateBusinessLocationDetailsMutation, UpdateBusinessLocationDetailsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBusinessLocationDetailsMutation, UpdateBusinessLocationDetailsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBusinessLocationDetailsMutation, UpdateBusinessLocationDetailsMutationVariables>(UpdateBusinessLocationDetailsDocument, options);
}
export type UpdateBusinessLocationDetailsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBusinessLocationDetailsMutation, UpdateBusinessLocationDetailsMutationVariables>;
export const UpdateBusinessLocationAddressDocument = gql`
    mutation UpdateBusinessLocationAddress($locationId: ID!, $input: UpdateBusinessLocationAddressInput!) {
  updateBusinessLocationAddress(locationId: $locationId, input: $input) {
    ...BusinessLocationShell
    location_address {
      ...BusinessLocationAddressFields
    }
  }
}
    ${BusinessLocationShellFragmentDoc}
${BusinessLocationAddressFieldsFragmentDoc}`;

/**
 * __useUpdateBusinessLocationAddressMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessLocationAddressMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessLocationAddressMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBusinessLocationAddressMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessLocationAddressMutation(options: VueApolloComposable.UseMutationOptions<UpdateBusinessLocationAddressMutation, UpdateBusinessLocationAddressMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBusinessLocationAddressMutation, UpdateBusinessLocationAddressMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBusinessLocationAddressMutation, UpdateBusinessLocationAddressMutationVariables>(UpdateBusinessLocationAddressDocument, options);
}
export type UpdateBusinessLocationAddressMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBusinessLocationAddressMutation, UpdateBusinessLocationAddressMutationVariables>;
export const CreateBusinessLocationDocument = gql`
    mutation CreateBusinessLocation($input: CreateBusinessLocationInput!) {
  createBusinessLocation(input: $input) {
    ...BusinessLocationShell
  }
}
    ${BusinessLocationShellFragmentDoc}`;

/**
 * __useCreateBusinessLocationMutation__
 *
 * To run a mutation, you first call `useCreateBusinessLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBusinessLocationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBusinessLocationMutation(options: VueApolloComposable.UseMutationOptions<CreateBusinessLocationMutation, CreateBusinessLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateBusinessLocationMutation, CreateBusinessLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateBusinessLocationMutation, CreateBusinessLocationMutationVariables>(CreateBusinessLocationDocument, options);
}
export type CreateBusinessLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateBusinessLocationMutation, CreateBusinessLocationMutationVariables>;
export const ChangeBusinessLocationTimezoneDocument = gql`
    mutation ChangeBusinessLocationTimezone($locationId: ID!, $timezone: String!) {
  changeBusinessLocationTimezone(locationId: $locationId, timezone: $timezone) {
    saved
    timezone
    conflicts {
      booking_id
      group_id
      start
      end
      client_title
      service_title
    }
  }
}
    `;

/**
 * __useChangeBusinessLocationTimezoneMutation__
 *
 * To run a mutation, you first call `useChangeBusinessLocationTimezoneMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeBusinessLocationTimezoneMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeBusinessLocationTimezoneMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     timezone: // value for 'timezone'
 *   },
 * });
 */
export function useChangeBusinessLocationTimezoneMutation(options: VueApolloComposable.UseMutationOptions<ChangeBusinessLocationTimezoneMutation, ChangeBusinessLocationTimezoneMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeBusinessLocationTimezoneMutation, ChangeBusinessLocationTimezoneMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangeBusinessLocationTimezoneMutation, ChangeBusinessLocationTimezoneMutationVariables>(ChangeBusinessLocationTimezoneDocument, options);
}
export type ChangeBusinessLocationTimezoneMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeBusinessLocationTimezoneMutation, ChangeBusinessLocationTimezoneMutationVariables>;
export const GetLocationAddressSuggestionsDocument = gql`
    query GetLocationAddressSuggestions($query: String!, $countryCode: String!, $count: Int!) {
  locationAddressSuggestions(
    query: $query
    countryCode: $countryCode
    count: $count
  ) {
    label
    query
    country_code
    region
    city
    address
    street
    house
    postal_code
    latitude
    longitude
    coordinates_exact
  }
}
    `;

/**
 * __useGetLocationAddressSuggestionsQuery__
 *
 * To run a query within a Vue component, call `useGetLocationAddressSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationAddressSuggestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLocationAddressSuggestionsQuery({
 *   query: // value for 'query'
 *   countryCode: // value for 'countryCode'
 *   count: // value for 'count'
 * });
 */
export function useGetLocationAddressSuggestionsQuery(variables: GetLocationAddressSuggestionsQueryVariables | VueCompositionApi.Ref<GetLocationAddressSuggestionsQueryVariables> | ReactiveFunction<GetLocationAddressSuggestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables>(GetLocationAddressSuggestionsDocument, variables, options);
}
export function useGetLocationAddressSuggestionsLazyQuery(variables?: GetLocationAddressSuggestionsQueryVariables | VueCompositionApi.Ref<GetLocationAddressSuggestionsQueryVariables> | ReactiveFunction<GetLocationAddressSuggestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables>(GetLocationAddressSuggestionsDocument, variables, options);
}
export type GetLocationAddressSuggestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLocationAddressSuggestionsQuery, GetLocationAddressSuggestionsQueryVariables>;
export const GeocodeLocationAddressDocument = gql`
    query GeocodeLocationAddress($query: String!, $countryCode: String!) {
  locationAddressGeocode(query: $query, countryCode: $countryCode) {
    label
    country_code
    region
    city
    address
    postal_code
    latitude
    longitude
    coordinates_exact
    requires_review
  }
}
    `;

/**
 * __useGeocodeLocationAddressQuery__
 *
 * To run a query within a Vue component, call `useGeocodeLocationAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeocodeLocationAddressQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGeocodeLocationAddressQuery({
 *   query: // value for 'query'
 *   countryCode: // value for 'countryCode'
 * });
 */
export function useGeocodeLocationAddressQuery(variables: GeocodeLocationAddressQueryVariables | VueCompositionApi.Ref<GeocodeLocationAddressQueryVariables> | ReactiveFunction<GeocodeLocationAddressQueryVariables>, options: VueApolloComposable.UseQueryOptions<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables>(GeocodeLocationAddressDocument, variables, options);
}
export function useGeocodeLocationAddressLazyQuery(variables?: GeocodeLocationAddressQueryVariables | VueCompositionApi.Ref<GeocodeLocationAddressQueryVariables> | ReactiveFunction<GeocodeLocationAddressQueryVariables>, options: VueApolloComposable.UseQueryOptions<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables>(GeocodeLocationAddressDocument, variables, options);
}
export type GeocodeLocationAddressQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GeocodeLocationAddressQuery, GeocodeLocationAddressQueryVariables>;
export const UpsertBookingCatalogDocument = gql`
    mutation UpsertBookingCatalog($locationId: ID, $input: UpsertBookingCatalogInput!) {
  upsertBookingCatalog(locationId: $locationId, input: $input) {
    units {
      ...BookingSettingsUnitMutationFields
    }
    services {
      ...BookingSettingsServiceMutationFields
    }
    conflicts {
      ...BookingSettingsConflictFields
    }
  }
}
    ${BookingSettingsUnitMutationFieldsFragmentDoc}
${BookingSettingsServiceMutationFieldsFragmentDoc}
${BookingSettingsConflictFieldsFragmentDoc}`;

/**
 * __useUpsertBookingCatalogMutation__
 *
 * To run a mutation, you first call `useUpsertBookingCatalogMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBookingCatalogMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertBookingCatalogMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBookingCatalogMutation(options: VueApolloComposable.UseMutationOptions<UpsertBookingCatalogMutation, UpsertBookingCatalogMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertBookingCatalogMutation, UpsertBookingCatalogMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertBookingCatalogMutation, UpsertBookingCatalogMutationVariables>(UpsertBookingCatalogDocument, options);
}
export type UpsertBookingCatalogMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertBookingCatalogMutation, UpsertBookingCatalogMutationVariables>;
export const UpsertLocationScheduleDocument = gql`
    mutation UpsertLocationSchedule($locationId: ID, $input: UpsertLocationScheduleInput!) {
  upsertLocationSchedule(locationId: $locationId, input: $input) {
    schedule {
      current {
        day_of_week
        is_day_off
        start
        end
        closes_next_day
        effective_from
      }
      upcoming {
        day_of_week
        is_day_off
        start
        end
        closes_next_day
        effective_from
      }
    }
    conflicts {
      ...BookingSettingsConflictFields
    }
  }
}
    ${BookingSettingsConflictFieldsFragmentDoc}`;

/**
 * __useUpsertLocationScheduleMutation__
 *
 * To run a mutation, you first call `useUpsertLocationScheduleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLocationScheduleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertLocationScheduleMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLocationScheduleMutation(options: VueApolloComposable.UseMutationOptions<UpsertLocationScheduleMutation, UpsertLocationScheduleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertLocationScheduleMutation, UpsertLocationScheduleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertLocationScheduleMutation, UpsertLocationScheduleMutationVariables>(UpsertLocationScheduleDocument, options);
}
export type UpsertLocationScheduleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertLocationScheduleMutation, UpsertLocationScheduleMutationVariables>;
export const CloseLocationDocument = gql`
    mutation CloseLocation($locationId: ID, $input: CloseLocationInput!) {
  closeLocation(locationId: $locationId, input: $input) {
    location {
      ...LocationLifecycleFields
    }
    conflicts {
      ...BookingSettingsConflictFields
    }
    earliest_allowed_closed_from
  }
}
    ${LocationLifecycleFieldsFragmentDoc}
${BookingSettingsConflictFieldsFragmentDoc}`;

/**
 * __useCloseLocationMutation__
 *
 * To run a mutation, you first call `useCloseLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloseLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloseLocationMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCloseLocationMutation(options: VueApolloComposable.UseMutationOptions<CloseLocationMutation, CloseLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloseLocationMutation, CloseLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CloseLocationMutation, CloseLocationMutationVariables>(CloseLocationDocument, options);
}
export type CloseLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloseLocationMutation, CloseLocationMutationVariables>;
export const ReopenLocationDocument = gql`
    mutation ReopenLocation($locationId: ID) {
  reopenLocation(locationId: $locationId) {
    location {
      ...LocationLifecycleFields
    }
    conflicts {
      ...BookingSettingsConflictFields
    }
  }
}
    ${LocationLifecycleFieldsFragmentDoc}
${BookingSettingsConflictFieldsFragmentDoc}`;

/**
 * __useReopenLocationMutation__
 *
 * To run a mutation, you first call `useReopenLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReopenLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReopenLocationMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *   },
 * });
 */
export function useReopenLocationMutation(options: VueApolloComposable.UseMutationOptions<ReopenLocationMutation, ReopenLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReopenLocationMutation, ReopenLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReopenLocationMutation, ReopenLocationMutationVariables>(ReopenLocationDocument, options);
}
export type ReopenLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReopenLocationMutation, ReopenLocationMutationVariables>;
export const SaveCatalogCategoryDocument = gql`
    mutation SaveCatalogCategory($id: ID, $title: String!, $position: Int!) {
  saveCatalogCategory(id: $id, title: $title, position: $position) {
    id
    title
    position
  }
}
    `;

/**
 * __useSaveCatalogCategoryMutation__
 *
 * To run a mutation, you first call `useSaveCatalogCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveCatalogCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveCatalogCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *     title: // value for 'title'
 *     position: // value for 'position'
 *   },
 * });
 */
export function useSaveCatalogCategoryMutation(options: VueApolloComposable.UseMutationOptions<SaveCatalogCategoryMutation, SaveCatalogCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveCatalogCategoryMutation, SaveCatalogCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveCatalogCategoryMutation, SaveCatalogCategoryMutationVariables>(SaveCatalogCategoryDocument, options);
}
export type SaveCatalogCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveCatalogCategoryMutation, SaveCatalogCategoryMutationVariables>;
export const DeleteCatalogCategoryDocument = gql`
    mutation DeleteCatalogCategory($id: ID!) {
  deleteCatalogCategory(id: $id)
}
    `;

/**
 * __useDeleteCatalogCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCatalogCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCatalogCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCatalogCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCatalogCategoryMutation(options: VueApolloComposable.UseMutationOptions<DeleteCatalogCategoryMutation, DeleteCatalogCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCatalogCategoryMutation, DeleteCatalogCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCatalogCategoryMutation, DeleteCatalogCategoryMutationVariables>(DeleteCatalogCategoryDocument, options);
}
export type DeleteCatalogCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCatalogCategoryMutation, DeleteCatalogCategoryMutationVariables>;
export const ReorderCatalogServicesDocument = gql`
    mutation ReorderCatalogServices($groups: [CatalogServiceGroupInput!]!) {
  reorderCatalogServices(groups: $groups) {
    id
    title
    position
  }
}
    `;

/**
 * __useReorderCatalogServicesMutation__
 *
 * To run a mutation, you first call `useReorderCatalogServicesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReorderCatalogServicesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReorderCatalogServicesMutation({
 *   variables: {
 *     groups: // value for 'groups'
 *   },
 * });
 */
export function useReorderCatalogServicesMutation(options: VueApolloComposable.UseMutationOptions<ReorderCatalogServicesMutation, ReorderCatalogServicesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReorderCatalogServicesMutation, ReorderCatalogServicesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReorderCatalogServicesMutation, ReorderCatalogServicesMutationVariables>(ReorderCatalogServicesDocument, options);
}
export type ReorderCatalogServicesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReorderCatalogServicesMutation, ReorderCatalogServicesMutationVariables>;
export const SaveCatalogServiceDocument = gql`
    mutation SaveCatalogService($input: CatalogServiceInput!) {
  saveCatalogService(input: $input) {
    ...CatalogItemMutationPayloadFields
  }
}
    ${CatalogItemMutationPayloadFieldsFragmentDoc}`;

/**
 * __useSaveCatalogServiceMutation__
 *
 * To run a mutation, you first call `useSaveCatalogServiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveCatalogServiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveCatalogServiceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveCatalogServiceMutation(options: VueApolloComposable.UseMutationOptions<SaveCatalogServiceMutation, SaveCatalogServiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveCatalogServiceMutation, SaveCatalogServiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveCatalogServiceMutation, SaveCatalogServiceMutationVariables>(SaveCatalogServiceDocument, options);
}
export type SaveCatalogServiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveCatalogServiceMutation, SaveCatalogServiceMutationVariables>;
export const SetCatalogItemArchivedDocument = gql`
    mutation SetCatalogItemArchived($id: ID!, $archived: Boolean!) {
  setCatalogItemArchived(id: $id, archived: $archived) {
    ...CatalogItemMutationPayloadFields
  }
}
    ${CatalogItemMutationPayloadFieldsFragmentDoc}`;

/**
 * __useSetCatalogItemArchivedMutation__
 *
 * To run a mutation, you first call `useSetCatalogItemArchivedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCatalogItemArchivedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCatalogItemArchivedMutation({
 *   variables: {
 *     id: // value for 'id'
 *     archived: // value for 'archived'
 *   },
 * });
 */
export function useSetCatalogItemArchivedMutation(options: VueApolloComposable.UseMutationOptions<SetCatalogItemArchivedMutation, SetCatalogItemArchivedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetCatalogItemArchivedMutation, SetCatalogItemArchivedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetCatalogItemArchivedMutation, SetCatalogItemArchivedMutationVariables>(SetCatalogItemArchivedDocument, options);
}
export type SetCatalogItemArchivedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetCatalogItemArchivedMutation, SetCatalogItemArchivedMutationVariables>;
export const GetCatalogServicesDocument = gql`
    query GetCatalogServices($includeArchived: Boolean) {
  catalogItems(kind: SERVICE, includeArchived: $includeArchived) {
    ...CatalogItemFields
    tire_kind
  }
}
    ${CatalogItemFieldsFragmentDoc}`;

/**
 * __useGetCatalogServicesQuery__
 *
 * To run a query within a Vue component, call `useGetCatalogServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogServicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCatalogServicesQuery({
 *   includeArchived: // value for 'includeArchived'
 * });
 */
export function useGetCatalogServicesQuery(variables: GetCatalogServicesQueryVariables | VueCompositionApi.Ref<GetCatalogServicesQueryVariables> | ReactiveFunction<GetCatalogServicesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetCatalogServicesQuery, GetCatalogServicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCatalogServicesQuery, GetCatalogServicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCatalogServicesQuery, GetCatalogServicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCatalogServicesQuery, GetCatalogServicesQueryVariables>(GetCatalogServicesDocument, variables, options);
}
export function useGetCatalogServicesLazyQuery(variables: GetCatalogServicesQueryVariables | VueCompositionApi.Ref<GetCatalogServicesQueryVariables> | ReactiveFunction<GetCatalogServicesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetCatalogServicesQuery, GetCatalogServicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCatalogServicesQuery, GetCatalogServicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCatalogServicesQuery, GetCatalogServicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCatalogServicesQuery, GetCatalogServicesQueryVariables>(GetCatalogServicesDocument, variables, options);
}
export type GetCatalogServicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCatalogServicesQuery, GetCatalogServicesQueryVariables>;
export const SaveTireServiceSettingsDocument = gql`
    mutation SaveTireServiceSettings($input: SaveTireServiceSettingsInput!) {
  saveTireServiceSettings(input: $input) {
    ...TireServiceSettingsFields
  }
}
    ${TireServiceSettingsFieldsFragmentDoc}`;

/**
 * __useSaveTireServiceSettingsMutation__
 *
 * To run a mutation, you first call `useSaveTireServiceSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveTireServiceSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveTireServiceSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveTireServiceSettingsMutation(options: VueApolloComposable.UseMutationOptions<SaveTireServiceSettingsMutation, SaveTireServiceSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveTireServiceSettingsMutation, SaveTireServiceSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveTireServiceSettingsMutation, SaveTireServiceSettingsMutationVariables>(SaveTireServiceSettingsDocument, options);
}
export type SaveTireServiceSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveTireServiceSettingsMutation, SaveTireServiceSettingsMutationVariables>;
export const SetTireStorageEnabledDocument = gql`
    mutation SetTireStorageEnabled($enabled: Boolean!) {
  setTireStorageEnabled(enabled: $enabled) {
    module
    status
  }
}
    `;

/**
 * __useSetTireStorageEnabledMutation__
 *
 * To run a mutation, you first call `useSetTireStorageEnabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetTireStorageEnabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetTireStorageEnabledMutation({
 *   variables: {
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetTireStorageEnabledMutation(options: VueApolloComposable.UseMutationOptions<SetTireStorageEnabledMutation, SetTireStorageEnabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetTireStorageEnabledMutation, SetTireStorageEnabledMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetTireStorageEnabledMutation, SetTireStorageEnabledMutationVariables>(SetTireStorageEnabledDocument, options);
}
export type SetTireStorageEnabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetTireStorageEnabledMutation, SetTireStorageEnabledMutationVariables>;
export const SaveTireStorageWarehouseDocument = gql`
    mutation SaveTireStorageWarehouse($locationId: ID!, $id: ID, $title: String!, $rackCount: Int!, $cellCount: Int!) {
  saveTireStorageWarehouse(
    locationId: $locationId
    id: $id
    title: $title
    rackCount: $rackCount
    cellCount: $cellCount
  ) {
    ...TireStorageWarehouseFields
  }
}
    ${TireStorageWarehouseFieldsFragmentDoc}`;

/**
 * __useSaveTireStorageWarehouseMutation__
 *
 * To run a mutation, you first call `useSaveTireStorageWarehouseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveTireStorageWarehouseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveTireStorageWarehouseMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     id: // value for 'id'
 *     title: // value for 'title'
 *     rackCount: // value for 'rackCount'
 *     cellCount: // value for 'cellCount'
 *   },
 * });
 */
export function useSaveTireStorageWarehouseMutation(options: VueApolloComposable.UseMutationOptions<SaveTireStorageWarehouseMutation, SaveTireStorageWarehouseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveTireStorageWarehouseMutation, SaveTireStorageWarehouseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveTireStorageWarehouseMutation, SaveTireStorageWarehouseMutationVariables>(SaveTireStorageWarehouseDocument, options);
}
export type SaveTireStorageWarehouseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveTireStorageWarehouseMutation, SaveTireStorageWarehouseMutationVariables>;
export const DeleteTireStorageWarehouseDocument = gql`
    mutation DeleteTireStorageWarehouse($locationId: ID!, $id: ID!) {
  deleteTireStorageWarehouse(locationId: $locationId, id: $id)
}
    `;

/**
 * __useDeleteTireStorageWarehouseMutation__
 *
 * To run a mutation, you first call `useDeleteTireStorageWarehouseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTireStorageWarehouseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTireStorageWarehouseMutation({
 *   variables: {
 *     locationId: // value for 'locationId'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTireStorageWarehouseMutation(options: VueApolloComposable.UseMutationOptions<DeleteTireStorageWarehouseMutation, DeleteTireStorageWarehouseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTireStorageWarehouseMutation, DeleteTireStorageWarehouseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTireStorageWarehouseMutation, DeleteTireStorageWarehouseMutationVariables>(DeleteTireStorageWarehouseDocument, options);
}
export type DeleteTireStorageWarehouseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTireStorageWarehouseMutation, DeleteTireStorageWarehouseMutationVariables>;
export const CreateShopOrderDraftDocument = gql`
    mutation CreateShopOrderDraft($input: ShopOrderDraftInput!) {
  createShopOrderDraft(input: $input) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useCreateShopOrderDraftMutation__
 *
 * To run a mutation, you first call `useCreateShopOrderDraftMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopOrderDraftMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateShopOrderDraftMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateShopOrderDraftMutation(options: VueApolloComposable.UseMutationOptions<CreateShopOrderDraftMutation, CreateShopOrderDraftMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateShopOrderDraftMutation, CreateShopOrderDraftMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateShopOrderDraftMutation, CreateShopOrderDraftMutationVariables>(CreateShopOrderDraftDocument, options);
}
export type CreateShopOrderDraftMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateShopOrderDraftMutation, CreateShopOrderDraftMutationVariables>;
export const UploadSopImageDocument = gql`
    mutation UploadSopImage($file: Upload!) {
  uploadSopImage(file: $file) {
    url
  }
}
    `;

/**
 * __useUploadSopImageMutation__
 *
 * To run a mutation, you first call `useUploadSopImageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadSopImageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadSopImageMutation({
 *   variables: {
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadSopImageMutation(options: VueApolloComposable.UseMutationOptions<UploadSopImageMutation, UploadSopImageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadSopImageMutation, UploadSopImageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadSopImageMutation, UploadSopImageMutationVariables>(UploadSopImageDocument, options);
}
export type UploadSopImageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadSopImageMutation, UploadSopImageMutationVariables>;
export const SearchSopsDocument = gql`
    query SearchSops($search: String, $first: Int!, $after: String) {
  sops(search: $search, first: $first, after: $after) {
    edges {
      node {
        ...SopSearchFragment
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${SopSearchFragmentFragmentDoc}`;

/**
 * __useSearchSopsQuery__
 *
 * To run a query within a Vue component, call `useSearchSopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSopsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchSopsQuery({
 *   search: // value for 'search'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useSearchSopsQuery(variables: SearchSopsQueryVariables | VueCompositionApi.Ref<SearchSopsQueryVariables> | ReactiveFunction<SearchSopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchSopsQuery, SearchSopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchSopsQuery, SearchSopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchSopsQuery, SearchSopsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchSopsQuery, SearchSopsQueryVariables>(SearchSopsDocument, variables, options);
}
export function useSearchSopsLazyQuery(variables?: SearchSopsQueryVariables | VueCompositionApi.Ref<SearchSopsQueryVariables> | ReactiveFunction<SearchSopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchSopsQuery, SearchSopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchSopsQuery, SearchSopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchSopsQuery, SearchSopsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchSopsQuery, SearchSopsQueryVariables>(SearchSopsDocument, variables, options);
}
export type SearchSopsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchSopsQuery, SearchSopsQueryVariables>;
export const GetSopsDocument = gql`
    query GetSops($status: SopStatus, $sectionId: ID, $first: Int!, $after: String) {
  sops(status: $status, sectionId: $sectionId, first: $first, after: $after) {
    edges {
      node {
        ...SopListFragment
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      total
    }
  }
}
    ${SopListFragmentFragmentDoc}`;

/**
 * __useGetSopsQuery__
 *
 * To run a query within a Vue component, call `useGetSopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSopsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSopsQuery({
 *   status: // value for 'status'
 *   sectionId: // value for 'sectionId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useGetSopsQuery(variables: GetSopsQueryVariables | VueCompositionApi.Ref<GetSopsQueryVariables> | ReactiveFunction<GetSopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSopsQuery, GetSopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSopsQuery, GetSopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSopsQuery, GetSopsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSopsQuery, GetSopsQueryVariables>(GetSopsDocument, variables, options);
}
export function useGetSopsLazyQuery(variables?: GetSopsQueryVariables | VueCompositionApi.Ref<GetSopsQueryVariables> | ReactiveFunction<GetSopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSopsQuery, GetSopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSopsQuery, GetSopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSopsQuery, GetSopsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSopsQuery, GetSopsQueryVariables>(GetSopsDocument, variables, options);
}
export type GetSopsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSopsQuery, GetSopsQueryVariables>;
export const GetSopDocument = gql`
    query GetSop($id: ID!) {
  sop(id: $id) {
    ...SopDetailFragment
  }
}
    ${SopDetailFragmentFragmentDoc}`;

/**
 * __useGetSopQuery__
 *
 * To run a query within a Vue component, call `useGetSopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSopQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSopQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetSopQuery(variables: GetSopQueryVariables | VueCompositionApi.Ref<GetSopQueryVariables> | ReactiveFunction<GetSopQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSopQuery, GetSopQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSopQuery, GetSopQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSopQuery, GetSopQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSopQuery, GetSopQueryVariables>(GetSopDocument, variables, options);
}
export function useGetSopLazyQuery(variables?: GetSopQueryVariables | VueCompositionApi.Ref<GetSopQueryVariables> | ReactiveFunction<GetSopQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSopQuery, GetSopQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSopQuery, GetSopQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSopQuery, GetSopQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSopQuery, GetSopQueryVariables>(GetSopDocument, variables, options);
}
export type GetSopQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSopQuery, GetSopQueryVariables>;
export const GetSopSectionsDocument = gql`
    query GetSopSections {
  sopSections {
    ...SopSectionFragment
    parent {
      id
      name
    }
    children {
      id
      name
      sops_count
    }
  }
}
    ${SopSectionFragmentFragmentDoc}`;

/**
 * __useGetSopSectionsQuery__
 *
 * To run a query within a Vue component, call `useGetSopSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSopSectionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSopSectionsQuery();
 */
export function useGetSopSectionsQuery(options: VueApolloComposable.UseQueryOptions<GetSopSectionsQuery, GetSopSectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSopSectionsQuery, GetSopSectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSopSectionsQuery, GetSopSectionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSopSectionsQuery, GetSopSectionsQueryVariables>(GetSopSectionsDocument, {}, options);
}
export function useGetSopSectionsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetSopSectionsQuery, GetSopSectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSopSectionsQuery, GetSopSectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSopSectionsQuery, GetSopSectionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSopSectionsQuery, GetSopSectionsQueryVariables>(GetSopSectionsDocument, {}, options);
}
export type GetSopSectionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSopSectionsQuery, GetSopSectionsQueryVariables>;
export const CreateSopDocument = gql`
    mutation CreateSop($input: CreateSopInput!) {
  createSop(input: $input) {
    ...SopDetailFragment
  }
}
    ${SopDetailFragmentFragmentDoc}`;

/**
 * __useCreateSopMutation__
 *
 * To run a mutation, you first call `useCreateSopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSopMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSopMutation(options: VueApolloComposable.UseMutationOptions<CreateSopMutation, CreateSopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSopMutation, CreateSopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateSopMutation, CreateSopMutationVariables>(CreateSopDocument, options);
}
export type CreateSopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSopMutation, CreateSopMutationVariables>;
export const UpdateSopDocument = gql`
    mutation UpdateSop($id: ID!, $input: UpdateSopInput!) {
  updateSop(id: $id, input: $input) {
    ...SopDetailFragment
  }
}
    ${SopDetailFragmentFragmentDoc}`;

/**
 * __useUpdateSopMutation__
 *
 * To run a mutation, you first call `useUpdateSopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSopMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSopMutation(options: VueApolloComposable.UseMutationOptions<UpdateSopMutation, UpdateSopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSopMutation, UpdateSopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSopMutation, UpdateSopMutationVariables>(UpdateSopDocument, options);
}
export type UpdateSopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSopMutation, UpdateSopMutationVariables>;
export const DeleteSopDocument = gql`
    mutation DeleteSop($id: ID!) {
  deleteSop(id: $id)
}
    `;

/**
 * __useDeleteSopMutation__
 *
 * To run a mutation, you first call `useDeleteSopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSopMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSopMutation(options: VueApolloComposable.UseMutationOptions<DeleteSopMutation, DeleteSopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSopMutation, DeleteSopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteSopMutation, DeleteSopMutationVariables>(DeleteSopDocument, options);
}
export type DeleteSopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSopMutation, DeleteSopMutationVariables>;
export const PublishSopDocument = gql`
    mutation PublishSop($id: ID!) {
  publishSop(id: $id) {
    ...SopDetailFragment
  }
}
    ${SopDetailFragmentFragmentDoc}`;

/**
 * __usePublishSopMutation__
 *
 * To run a mutation, you first call `usePublishSopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishSopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishSopMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function usePublishSopMutation(options: VueApolloComposable.UseMutationOptions<PublishSopMutation, PublishSopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PublishSopMutation, PublishSopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PublishSopMutation, PublishSopMutationVariables>(PublishSopDocument, options);
}
export type PublishSopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PublishSopMutation, PublishSopMutationVariables>;
export const ArchiveSopDocument = gql`
    mutation ArchiveSop($id: ID!) {
  archiveSop(id: $id) {
    ...SopDetailFragment
  }
}
    ${SopDetailFragmentFragmentDoc}`;

/**
 * __useArchiveSopMutation__
 *
 * To run a mutation, you first call `useArchiveSopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchiveSopMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useArchiveSopMutation(options: VueApolloComposable.UseMutationOptions<ArchiveSopMutation, ArchiveSopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ArchiveSopMutation, ArchiveSopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ArchiveSopMutation, ArchiveSopMutationVariables>(ArchiveSopDocument, options);
}
export type ArchiveSopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ArchiveSopMutation, ArchiveSopMutationVariables>;
export const CreateSopSectionDocument = gql`
    mutation CreateSopSection($input: CreateSopSectionInput!) {
  createSopSection(input: $input) {
    ...SopSectionFragment
  }
}
    ${SopSectionFragmentFragmentDoc}`;

/**
 * __useCreateSopSectionMutation__
 *
 * To run a mutation, you first call `useCreateSopSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSopSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSopSectionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSopSectionMutation(options: VueApolloComposable.UseMutationOptions<CreateSopSectionMutation, CreateSopSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSopSectionMutation, CreateSopSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateSopSectionMutation, CreateSopSectionMutationVariables>(CreateSopSectionDocument, options);
}
export type CreateSopSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSopSectionMutation, CreateSopSectionMutationVariables>;
export const UpdateSopSectionDocument = gql`
    mutation UpdateSopSection($id: ID!, $input: UpdateSopSectionInput!) {
  updateSopSection(id: $id, input: $input) {
    ...SopSectionFragment
  }
}
    ${SopSectionFragmentFragmentDoc}`;

/**
 * __useUpdateSopSectionMutation__
 *
 * To run a mutation, you first call `useUpdateSopSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSopSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSopSectionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSopSectionMutation(options: VueApolloComposable.UseMutationOptions<UpdateSopSectionMutation, UpdateSopSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSopSectionMutation, UpdateSopSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSopSectionMutation, UpdateSopSectionMutationVariables>(UpdateSopSectionDocument, options);
}
export type UpdateSopSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSopSectionMutation, UpdateSopSectionMutationVariables>;
export const DeleteSopSectionDocument = gql`
    mutation DeleteSopSection($id: ID!) {
  deleteSopSection(id: $id)
}
    `;

/**
 * __useDeleteSopSectionMutation__
 *
 * To run a mutation, you first call `useDeleteSopSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSopSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSopSectionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSopSectionMutation(options: VueApolloComposable.UseMutationOptions<DeleteSopSectionMutation, DeleteSopSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSopSectionMutation, DeleteSopSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteSopSectionMutation, DeleteSopSectionMutationVariables>(DeleteSopSectionDocument, options);
}
export type DeleteSopSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSopSectionMutation, DeleteSopSectionMutationVariables>;
export const AssignTireStoragePlaceDocument = gql`
    mutation AssignTireStoragePlace($storageId: ID!, $warehouseId: ID, $rackNo: Int, $cellNo: Int) {
  assignTireStoragePlace(
    storageId: $storageId
    warehouseId: $warehouseId
    rackNo: $rackNo
    cellNo: $cellNo
  ) {
    ...TireStorageFields
  }
}
    ${TireStorageFieldsFragmentDoc}`;

/**
 * __useAssignTireStoragePlaceMutation__
 *
 * To run a mutation, you first call `useAssignTireStoragePlaceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignTireStoragePlaceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignTireStoragePlaceMutation({
 *   variables: {
 *     storageId: // value for 'storageId'
 *     warehouseId: // value for 'warehouseId'
 *     rackNo: // value for 'rackNo'
 *     cellNo: // value for 'cellNo'
 *   },
 * });
 */
export function useAssignTireStoragePlaceMutation(options: VueApolloComposable.UseMutationOptions<AssignTireStoragePlaceMutation, AssignTireStoragePlaceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignTireStoragePlaceMutation, AssignTireStoragePlaceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AssignTireStoragePlaceMutation, AssignTireStoragePlaceMutationVariables>(AssignTireStoragePlaceDocument, options);
}
export type AssignTireStoragePlaceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignTireStoragePlaceMutation, AssignTireStoragePlaceMutationVariables>;
export const ReleaseTireStorageDocument = gql`
    mutation ReleaseTireStorage($storageId: ID!, $items: [TireStorageReleaseItemInput!]!) {
  releaseTireStorage(storageId: $storageId, items: $items) {
    id
    storage {
      ...TireStorageFields
      releases {
        ...TireStorageReleaseFields
      }
    }
  }
}
    ${TireStorageFieldsFragmentDoc}
${TireStorageReleaseFieldsFragmentDoc}`;

/**
 * __useReleaseTireStorageMutation__
 *
 * To run a mutation, you first call `useReleaseTireStorageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReleaseTireStorageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReleaseTireStorageMutation({
 *   variables: {
 *     storageId: // value for 'storageId'
 *     items: // value for 'items'
 *   },
 * });
 */
export function useReleaseTireStorageMutation(options: VueApolloComposable.UseMutationOptions<ReleaseTireStorageMutation, ReleaseTireStorageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReleaseTireStorageMutation, ReleaseTireStorageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReleaseTireStorageMutation, ReleaseTireStorageMutationVariables>(ReleaseTireStorageDocument, options);
}
export type ReleaseTireStorageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReleaseTireStorageMutation, ReleaseTireStorageMutationVariables>;
export const CreateTireWorkOrderDocument = gql`
    mutation CreateTireWorkOrder($carId: ID, $bookingGroupId: ID) {
  createTireWorkOrder(carId: $carId, bookingGroupId: $bookingGroupId) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useCreateTireWorkOrderMutation__
 *
 * To run a mutation, you first call `useCreateTireWorkOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTireWorkOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTireWorkOrderMutation({
 *   variables: {
 *     carId: // value for 'carId'
 *     bookingGroupId: // value for 'bookingGroupId'
 *   },
 * });
 */
export function useCreateTireWorkOrderMutation(options: VueApolloComposable.UseMutationOptions<CreateTireWorkOrderMutation, CreateTireWorkOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateTireWorkOrderMutation, CreateTireWorkOrderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateTireWorkOrderMutation, CreateTireWorkOrderMutationVariables>(CreateTireWorkOrderDocument, options);
}
export type CreateTireWorkOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateTireWorkOrderMutation, CreateTireWorkOrderMutationVariables>;
export const SetTireWorkOrderCarDocument = gql`
    mutation SetTireWorkOrderCar($id: ID!, $carId: ID!) {
  setTireWorkOrderCar(id: $id, carId: $carId) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useSetTireWorkOrderCarMutation__
 *
 * To run a mutation, you first call `useSetTireWorkOrderCarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetTireWorkOrderCarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetTireWorkOrderCarMutation({
 *   variables: {
 *     id: // value for 'id'
 *     carId: // value for 'carId'
 *   },
 * });
 */
export function useSetTireWorkOrderCarMutation(options: VueApolloComposable.UseMutationOptions<SetTireWorkOrderCarMutation, SetTireWorkOrderCarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetTireWorkOrderCarMutation, SetTireWorkOrderCarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetTireWorkOrderCarMutation, SetTireWorkOrderCarMutationVariables>(SetTireWorkOrderCarDocument, options);
}
export type SetTireWorkOrderCarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetTireWorkOrderCarMutation, SetTireWorkOrderCarMutationVariables>;
export const UpdateTireWorkOrderParamsDocument = gql`
    mutation UpdateTireWorkOrderParams($id: ID!, $carClassId: ID, $wheelDiameter: Int, $runFlat: Boolean, $discountPercent: Int) {
  updateTireWorkOrderParams(
    id: $id
    carClassId: $carClassId
    wheelDiameter: $wheelDiameter
    runFlat: $runFlat
    discountPercent: $discountPercent
  ) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useUpdateTireWorkOrderParamsMutation__
 *
 * To run a mutation, you first call `useUpdateTireWorkOrderParamsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTireWorkOrderParamsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTireWorkOrderParamsMutation({
 *   variables: {
 *     id: // value for 'id'
 *     carClassId: // value for 'carClassId'
 *     wheelDiameter: // value for 'wheelDiameter'
 *     runFlat: // value for 'runFlat'
 *     discountPercent: // value for 'discountPercent'
 *   },
 * });
 */
export function useUpdateTireWorkOrderParamsMutation(options: VueApolloComposable.UseMutationOptions<UpdateTireWorkOrderParamsMutation, UpdateTireWorkOrderParamsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTireWorkOrderParamsMutation, UpdateTireWorkOrderParamsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTireWorkOrderParamsMutation, UpdateTireWorkOrderParamsMutationVariables>(UpdateTireWorkOrderParamsDocument, options);
}
export type UpdateTireWorkOrderParamsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTireWorkOrderParamsMutation, UpdateTireWorkOrderParamsMutationVariables>;
export const AddTireWorkOrderLineDocument = gql`
    mutation AddTireWorkOrderLine($id: ID!, $catalogItemId: ID!, $quantity: Int!, $enteredPrice: Int) {
  addTireWorkOrderLine(
    id: $id
    catalogItemId: $catalogItemId
    quantity: $quantity
    enteredPrice: $enteredPrice
  ) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useAddTireWorkOrderLineMutation__
 *
 * To run a mutation, you first call `useAddTireWorkOrderLineMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTireWorkOrderLineMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTireWorkOrderLineMutation({
 *   variables: {
 *     id: // value for 'id'
 *     catalogItemId: // value for 'catalogItemId'
 *     quantity: // value for 'quantity'
 *     enteredPrice: // value for 'enteredPrice'
 *   },
 * });
 */
export function useAddTireWorkOrderLineMutation(options: VueApolloComposable.UseMutationOptions<AddTireWorkOrderLineMutation, AddTireWorkOrderLineMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddTireWorkOrderLineMutation, AddTireWorkOrderLineMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddTireWorkOrderLineMutation, AddTireWorkOrderLineMutationVariables>(AddTireWorkOrderLineDocument, options);
}
export type AddTireWorkOrderLineMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddTireWorkOrderLineMutation, AddTireWorkOrderLineMutationVariables>;
export const ChangeTireWorkOrderLineQuantityDocument = gql`
    mutation ChangeTireWorkOrderLineQuantity($lineId: ID!, $quantity: Int!) {
  changeTireWorkOrderLineQuantity(lineId: $lineId, quantity: $quantity) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useChangeTireWorkOrderLineQuantityMutation__
 *
 * To run a mutation, you first call `useChangeTireWorkOrderLineQuantityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeTireWorkOrderLineQuantityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeTireWorkOrderLineQuantityMutation({
 *   variables: {
 *     lineId: // value for 'lineId'
 *     quantity: // value for 'quantity'
 *   },
 * });
 */
export function useChangeTireWorkOrderLineQuantityMutation(options: VueApolloComposable.UseMutationOptions<ChangeTireWorkOrderLineQuantityMutation, ChangeTireWorkOrderLineQuantityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeTireWorkOrderLineQuantityMutation, ChangeTireWorkOrderLineQuantityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangeTireWorkOrderLineQuantityMutation, ChangeTireWorkOrderLineQuantityMutationVariables>(ChangeTireWorkOrderLineQuantityDocument, options);
}
export type ChangeTireWorkOrderLineQuantityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeTireWorkOrderLineQuantityMutation, ChangeTireWorkOrderLineQuantityMutationVariables>;
export const RemoveTireWorkOrderLineDocument = gql`
    mutation RemoveTireWorkOrderLine($lineId: ID!) {
  removeTireWorkOrderLine(lineId: $lineId) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useRemoveTireWorkOrderLineMutation__
 *
 * To run a mutation, you first call `useRemoveTireWorkOrderLineMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTireWorkOrderLineMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveTireWorkOrderLineMutation({
 *   variables: {
 *     lineId: // value for 'lineId'
 *   },
 * });
 */
export function useRemoveTireWorkOrderLineMutation(options: VueApolloComposable.UseMutationOptions<RemoveTireWorkOrderLineMutation, RemoveTireWorkOrderLineMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveTireWorkOrderLineMutation, RemoveTireWorkOrderLineMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveTireWorkOrderLineMutation, RemoveTireWorkOrderLineMutationVariables>(RemoveTireWorkOrderLineDocument, options);
}
export type RemoveTireWorkOrderLineMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveTireWorkOrderLineMutation, RemoveTireWorkOrderLineMutationVariables>;
export const DeleteTireWorkOrderDocument = gql`
    mutation DeleteTireWorkOrder($id: ID!) {
  deleteTireWorkOrder(id: $id)
}
    `;

/**
 * __useDeleteTireWorkOrderMutation__
 *
 * To run a mutation, you first call `useDeleteTireWorkOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTireWorkOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTireWorkOrderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTireWorkOrderMutation(options: VueApolloComposable.UseMutationOptions<DeleteTireWorkOrderMutation, DeleteTireWorkOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTireWorkOrderMutation, DeleteTireWorkOrderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTireWorkOrderMutation, DeleteTireWorkOrderMutationVariables>(DeleteTireWorkOrderDocument, options);
}
export type DeleteTireWorkOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTireWorkOrderMutation, DeleteTireWorkOrderMutationVariables>;
export const OpenTireWorkOrderCheckoutDocument = gql`
    mutation OpenTireWorkOrderCheckout($id: ID!) {
  openTireWorkOrderCheckout(id: $id) {
    id
    version
  }
}
    `;

/**
 * __useOpenTireWorkOrderCheckoutMutation__
 *
 * To run a mutation, you first call `useOpenTireWorkOrderCheckoutMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOpenTireWorkOrderCheckoutMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOpenTireWorkOrderCheckoutMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useOpenTireWorkOrderCheckoutMutation(options: VueApolloComposable.UseMutationOptions<OpenTireWorkOrderCheckoutMutation, OpenTireWorkOrderCheckoutMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<OpenTireWorkOrderCheckoutMutation, OpenTireWorkOrderCheckoutMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<OpenTireWorkOrderCheckoutMutation, OpenTireWorkOrderCheckoutMutationVariables>(OpenTireWorkOrderCheckoutDocument, options);
}
export type OpenTireWorkOrderCheckoutMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<OpenTireWorkOrderCheckoutMutation, OpenTireWorkOrderCheckoutMutationVariables>;
export const AddTireStorageIntakeDocument = gql`
    mutation AddTireStorageIntake($workOrderId: ID!, $catalogItemId: ID!, $input: TireStorageInput!) {
  addTireStorageIntake(
    workOrderId: $workOrderId
    catalogItemId: $catalogItemId
    input: $input
  ) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useAddTireStorageIntakeMutation__
 *
 * To run a mutation, you first call `useAddTireStorageIntakeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTireStorageIntakeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTireStorageIntakeMutation({
 *   variables: {
 *     workOrderId: // value for 'workOrderId'
 *     catalogItemId: // value for 'catalogItemId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddTireStorageIntakeMutation(options: VueApolloComposable.UseMutationOptions<AddTireStorageIntakeMutation, AddTireStorageIntakeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddTireStorageIntakeMutation, AddTireStorageIntakeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddTireStorageIntakeMutation, AddTireStorageIntakeMutationVariables>(AddTireStorageIntakeDocument, options);
}
export type AddTireStorageIntakeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddTireStorageIntakeMutation, AddTireStorageIntakeMutationVariables>;
export const UpdateTireStorageIntakeDocument = gql`
    mutation UpdateTireStorageIntake($storageId: ID!, $input: TireStorageInput!) {
  updateTireStorageIntake(storageId: $storageId, input: $input) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useUpdateTireStorageIntakeMutation__
 *
 * To run a mutation, you first call `useUpdateTireStorageIntakeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTireStorageIntakeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTireStorageIntakeMutation({
 *   variables: {
 *     storageId: // value for 'storageId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTireStorageIntakeMutation(options: VueApolloComposable.UseMutationOptions<UpdateTireStorageIntakeMutation, UpdateTireStorageIntakeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTireStorageIntakeMutation, UpdateTireStorageIntakeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTireStorageIntakeMutation, UpdateTireStorageIntakeMutationVariables>(UpdateTireStorageIntakeDocument, options);
}
export type UpdateTireStorageIntakeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTireStorageIntakeMutation, UpdateTireStorageIntakeMutationVariables>;
export const AddTireStorageExtensionDocument = gql`
    mutation AddTireStorageExtension($workOrderId: ID!, $storageId: ID!, $enteredPrice: Int) {
  addTireStorageExtension(
    workOrderId: $workOrderId
    storageId: $storageId
    enteredPrice: $enteredPrice
  ) {
    ...TireWorkOrderFields
  }
}
    ${TireWorkOrderFieldsFragmentDoc}`;

/**
 * __useAddTireStorageExtensionMutation__
 *
 * To run a mutation, you first call `useAddTireStorageExtensionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTireStorageExtensionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTireStorageExtensionMutation({
 *   variables: {
 *     workOrderId: // value for 'workOrderId'
 *     storageId: // value for 'storageId'
 *     enteredPrice: // value for 'enteredPrice'
 *   },
 * });
 */
export function useAddTireStorageExtensionMutation(options: VueApolloComposable.UseMutationOptions<AddTireStorageExtensionMutation, AddTireStorageExtensionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddTireStorageExtensionMutation, AddTireStorageExtensionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddTireStorageExtensionMutation, AddTireStorageExtensionMutationVariables>(AddTireStorageExtensionDocument, options);
}
export type AddTireStorageExtensionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddTireStorageExtensionMutation, AddTireStorageExtensionMutationVariables>;